const fu = {};
function du() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : this || fu;
}
const vt = du(), mu = "@YZ/";
function Vi(n, t = mu) {
  return n.startsWith(t) ? n : `${t}${n}`;
}
function Pr(n) {
  return typeof n == "string" && n.startsWith("Symbol(") && n.endsWith(")");
}
function Tr(n) {
  return Pr(n) && (n = n.slice(7, -1)), n;
}
function Zn(n) {
  return n = Tr(n), n = Vi(n), typeof Symbol == "function" ? Symbol(n) : `Symbol(${n})`;
}
const Es = Zn("TIMESTAMP"), pu = Zn("META");
function gu(n, t) {
  const e = t.toString();
  if (!Pr(e))
    return !1;
  if (n && typeof n == "object") {
    if (Tr(e) == "")
      return t in n;
    for (const s of Reflect.ownKeys(n))
      if (s.toString() == e)
        return !0;
    return !1;
  }
  return !1;
}
function Do(n) {
  if (!Pr(n))
    return n;
  switch (n = Tr(n), n) {
    case Vi("TIMESTAMP"):
      return Es;
    case Vi("META"):
      return pu;
    default:
      return Zn(n);
  }
}
function $i(n) {
  if (Array.isArray(n))
    return n.map($i);
  if (n && typeof n == "object") {
    const t = {};
    for (const e of Reflect.ownKeys(n)) {
      const s = n[e];
      t[typeof e == "symbol" ? e.toString() : e] = typeof s == "symbol" ? s.toString() : $i(s);
    }
    return t;
  }
  return typeof n == "symbol" ? n.toString() : n;
}
function qi(n) {
  if (Array.isArray(n))
    return n.map(qi);
  if (n && typeof n == "object") {
    const t = {};
    for (const e of Object.keys(n))
      t[Do(e)] = qi(n[e]);
    return t;
  }
  return Do(n);
}
function Mr(n) {
  return JSON.stringify($i(n));
}
const Ar = Mr;
function Wa(n) {
  return qi(JSON.parse(n));
}
var Mt = /* @__PURE__ */ ((n) => (n.UNKNOWN = "", n.TEXT = "text/plain", n.MD = "text/plain", n.HTML = "text/html", n.XML_TEXT = "text/xml", n.CSS = "text/css", n.JPEG = "image/jpeg", n.PNG = "image/png", n.GIF = "image/gif", n.BMP = "image/bmp", n.WEBP = "image/webp", n.SVG = "image/svg+xml", n.ICON = "image/x-icon", n.MICROSOFT_ICON = "image/vnd.microsoft.icon", n.MPEG = "audio/mpeg", n.MP3 = "audio/mpeg", n.MP4 = "video/mp4", n.OGG = "audio/ogg", n.WAV = "audio/wav", n.MIDI = "audio/midi", n.WEBM = "video/webm", n.VIDEO_OGG = "video/ogg", n.OCTET_STREAM = "application/octet-stream", n.JAVASCRIPT = "application/javascript", n.ECMASCRIPT = "application/ecmascript", n.JSON = "application/json", n.XML = "application/xml", n.XHTML = "application/xhtml+xml", n.XWWW = "application/x-www-form-urlencoded", n.DOC = "application/msword", n.CSV = "application/x-csv", n.EXCEL = "application/vnb.ms-excel", n.PPT = "application/vnb.mspowerpoint", n.PDF = "application/pdf", n.ZIP = "application/zip", n.TGZ = "application/x-gtar", n.TAR_GZ = "application/x-gzip", n.EOT = "appliaction/vnd.ms-fontobject", n.TTF = "aplication/font-sfnt", n.PKCS12 = "aplication/pkcs12", n))(Mt || {}), Bn = /* @__PURE__ */ ((n) => (n.ascii = "ascii", n.utf8 = "utf8", n.utf16le = "utf16le", n.ucs2 = "ucs2", n.base64 = "base64", n.base64url = "base64url", n.latin1 = "latin1", n.binary = "binary", n.hex = "hex", n))(Bn || {}), Ut = /* @__PURE__ */ ((n) => (n.text = "text", n.dataURL = "dataURL", n.binaryString = "binaryString", n.arraybuffer = "arraybuffer", n))(Ut || {}), Hs = /* @__PURE__ */ ((n) => (n.md5 = "md5", n.sha1 = "sha1", n.sha256 = "sha256", n.SHA256 = "SHA-256", n.sha512 = "sha512", n.SHA512 = "SHA-512", n.AESGCM = "AES-GCM", n.ECDSA = "ECDSA", n))(Hs || {});
const Jn = (n) => {
  let t = null;
  switch (n) {
    case "any-character":
      t = /[^]/;
      break;
    case "bin":
      t = /^(0b)?[0-1]+$/i;
      break;
    case "oct":
      t = /^(0o)?[0-7]+$/i;
      break;
    case "hex":
      t = /^(0x)?[0-9a-fA-F]+$/i;
      break;
    case "ascii":
      t = /^[\x00-\xFF]+$/i;
      break;
    case "int":
      t = /^[-+]?[0-9]+$/;
      break;
    case "number":
      t = /[-+]?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
      break;
    case "number-single":
      t = /[-+]?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/i;
      break;
    case "split":
      t = /\s*,\s*/gi;
      break;
    case "trim":
      t = /^\s+|\s+$/g;
      break;
    case "regexp":
      t = /[\\^$.*+?()[\]{}|]/g;
      break;
    case "regexp-flags":
      t = /\w*$/;
      break;
    case "native-method":
      t = RegExp(
        "^" + Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(Jn("regexp"), "\\$&").replace(
          /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
          "$1.*?"
        ) + "$"
      );
      break;
    case "svg-segment":
      t = /([mlhvzaqtcs])([^mlhvzaqtcs]*)/gi;
      break;
    case "mobile-china":
      t = /^[1]{1}[0-9]{10}$/;
      break;
    case "email":
      t = /^[A-Za-z0-9_!#$%&'*+/=?`{|}~^.-]+\@[A-Za-z0-9._-]+\.[A-Za-z0-9]+$/gm;
      break;
    case "ip":
      t = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      break;
    case "url":
      t = /^http[s]?:\/\/([\w-]+\.)+[\w-]+([\w-./?%&=]*)?$/;
      break;
    case "element-url":
      t = /^url\(['"]?(.+?)['"]?\)$/i;
      break;
    case "date":
      t = /^\d{4}(\-|\/|\.)(\d{1,2})(\-|\/|\.)(\d{1,2})$/;
      break;
    case "time":
      t = /^(\d{1,2}):(\d{1,2}):(\d{1,2})$/;
      break;
    case "datetime":
      t = /^\d{4}(\-|\/|\.)(\d{1,2})(\-|\/|\.)(\d{1,2})\s+(\d{1,2}):(\d{1,2}):(\d{1,2})$/;
      break;
    case "base64-data":
      t = /^\s*data:(?:[a-z]+\/[a-z0-9-+.]+(?:;[a-z-]+=[a-z0-9-]+)?)?(?:;base64)?,([a-z0-9!$&',()*+;=\-._~:@/?%\s]*?)\s*$/i;
      break;
    case "hex-color":
      t = /^#([0-9A-F]{3}|[0-9A-F]{4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
      break;
    case "color":
      t = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?)%?\s*\))\s*$/i;
      break;
    case "whitespace":
      t = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]/g;
      break;
    case "commaSpaces":
      t = /[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*,[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028\u2029]*/;
      break;
    case "var-name":
      t = /^[a-zA-Z_$][a-zA-Z0-9_$]*$/;
      break;
    case "bezier":
      t = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/;
      break;
    case "chinese-name":
      t = /^(?:[\u4e00-\u9fa5·]{2,16})$/;
      break;
    case "chinese":
      t = new RegExp(
        String.raw`
          [\u{FA0E}\u{FA0F}\u{FA11}\u{FA13}\u{FA14}\u{FA1F}\u{FA21}\u{FA23}\u{FA24}\u{FA27}-\u{FA29}]
          |[\u{4E00}-\u{9FCC}]
          |[\u{3400}-\u{4DB5}]
          |[\u{20000}-\u{2A6D6}]
          |[\u{2A700}-\u{2B734}]
          |[\u{2B740}-\u{2B81D}]
          |[\u{2B820}-\u{2CEAF}]
          |[\u{2CEB0}-\u{2EBEF}]
        `.replace(/\s+/g, ""),
        "u"
      );
      break;
    case "mime-image":
      t = /^image\//;
      break;
    case "mime-video":
      t = /^video\//;
      break;
    case "mime-audio":
      t = /^audio\//;
      break;
    case "mime-document-word":
      t = /^application\/(?:vnd\.openxmlformats-officedocument\.wordprocessingml\.document|msword|vnd\.ms-word\.document\.macroenabled\.12|vnd\.openxmlformats-officedocument\.wordprocessingml\.template|vnd\.ms-word\.template\.macroenabled\.12)$/;
      break;
    case "mime-document-excel":
      t = /^application\/(?:vnd\.openxmlformats-officedocument\.spreadsheetml\.sheet|vnd\.ms-excel|vnd\.ms-excel\.sheet\.macroenabled\.12|vnd\.openxmlformats-officedocument\.spreadsheetml\.template|vnd\.ms-excel\.template\.macroenabled\.12)$/;
      break;
    case "mime-document-ppt":
      t = /^application\/(?:vnd\.ms-powerpoint|vnd\.openxmlformats-officedocument\.presentationml\.presentation|vnd\.ms-powerpoint\.presentation\.macroenabled\.12|vnd\.openxmlformats-officedocument\.presentationml\.template|vnd\.ms-powerpoint\.template\.macroenabled\.12)$/;
      break;
    case "mime-document-json":
      t = /^application\/json$/;
      break;
    case "mime-document-xml":
      t = /^(?:application|text)\/(?:xml|xhtml\+xml)$/;
      break;
  }
  return t;
}, fe = (n, t) => (typeof n == "string" && (n = Jn(n) || new RegExp(n)), n.test(t)), Za = (n, t) => {
  typeof n == "string" && (n = Jn(n) || new RegExp(n));
  const e = t.match(n);
  return e ? n.flags.toLowerCase().indexOf("g") >= 0 ? e.map(
    (s) => ({
      matchIndex: -1,
      fullMatch: s,
      groupMatchs: []
    })
  ) : {
    matchIndex: typeof e.index == "number" ? e.index : -1,
    fullMatch: e[0],
    groupMatchs: e.slice(1)
  } : null;
}, Ja = (n, t) => {
  typeof n == "string" && (n = Jn(n) || new RegExp(n));
  const e = [], s = t.matchAll(n);
  for (const i of s)
    e.push({
      matchIndex: typeof i.index == "number" ? i.index : -1,
      fullMatch: i[0],
      groupMatchs: i.slice(1)
    });
  return e;
};
function yu(n) {
  const t = n.match(/[\s\S]/gu);
  return t ? t.length : 0;
}
function Lo(n, t) {
  const e = n.codePointAt(t);
  return e ? String.fromCodePoint(e) : void 0;
}
function Xs(n = 12, t = "all") {
  let e = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghijklmnopqrstuvwxyz0123456789";
  t == "number" && (e = "0123456789");
  const s = e.length;
  let i = "";
  for (let r = 0; r < n; r++)
    i += e[Math.floor(Math.random() * s)];
  return i;
}
function xu(n) {
  return n.replace(/(^\w)/g, (t) => t.toLowerCase());
}
const pt = (n, t = "-") => {
  let e = n.replace(new RegExp("[_-]?([A-Z])", "g"), t + "$1").toLowerCase();
  const s = new RegExp(`^${t}`);
  return s.test(n) || (e = e.replace(s, "")), e;
};
function wu(n) {
  return n.replace(/(^\w|[_-]\w)/g, (t) => t.slice(-1).toUpperCase());
}
function Ka(n) {
  return xu(wu(n));
}
function Qa(n) {
  let t = "";
  for (let e = 0, s = n.length; e < s; e++) {
    const i = n.charCodeAt(e);
    i >= 1 && i <= 127 ? t += n.charAt(e) : i > 2047 ? (t += String.fromCharCode(224 | i >> 12 & 15), t += String.fromCharCode(128 | i >> 6 & 63), t += String.fromCharCode(128 | i >> 0 & 63)) : (t += String.fromCharCode(192 | i >> 6 & 31), t += String.fromCharCode(128 | i >> 0 & 63));
  }
  return t;
}
function bu(n) {
  return n.slice(0);
}
function vu(n, t = !0) {
  const e = t ? bu(n.buffer) : n.buffer;
  return new n.constructor(
    e,
    n.byteOffset,
    n.length
  );
}
const _u = "[object Undefined]", Su = "[object Null]", Cu = "[object Boolean]", Eu = "[object Number]", Pu = "[object BigInt]", th = "[object String]", Tu = "[object Symbol]", Mu = "[object Function]", Au = "[object Array]", Iu = "[object GeneratorFunction]";
function Kn(n) {
  return Object.prototype.toString.call(n);
}
function ku(n) {
  return n != null;
}
function Du(n) {
  return Kn(n) === th;
}
function eh(n) {
  const t = Kn(n);
  return t === _u || t === Su || t === Cu || t === Eu || t === th || t === Tu || t === Pu;
}
function Lu(n) {
  const t = Kn(n);
  return t == Mu || t == Iu;
}
function Xn(n) {
  return Kn(n) === Au;
}
function An(n) {
  return !!n && typeof n == "object";
}
function Ps(n) {
  return An(n) && !Xn(n);
}
const Ro = (n) => {
  for (const t in n)
    if (Object.prototype.hasOwnProperty.call(n, t))
      return !1;
  return !0;
};
function sh(n) {
  const t = [];
  for (const e in n)
    Object.prototype.hasOwnProperty.call(n, e) && t.push(e);
  return t;
}
function is(n, t, e = !0) {
  if (Ps(n) && Ps(t))
    for (const s of sh(t))
      (e || typeof n[s] > "u") && (Ps(n[s]) && Ps(t[s]) ? is(n[s], t[s], e) : n[s] = t[s]);
  return n;
}
function nh(n, ...t) {
  return new n.constructor(...t);
}
function Ve(n, t = `\r
`, e = 6, s = 1) {
  if (Du(n))
    return `"${n}"`;
  if (eh(n))
    return "" + n;
  if (Lu(n))
    return "[Fn]";
  if (s > e)
    return Xn(n) ? "[...]" : "{...}";
  let i = "", r = "";
  for (let o = 0; o < s; o++)
    i += "  ", o > 0 && (r += "  ");
  return Xn(n) ? `[${n.map(
    (o) => t + i + Ve(o, t, e, s + 1)
  ).join(", ")}${t}${r}]` : `{${sh(n).map(
    (o) => `${t}${i}${o}: ${Ve(
      n[o],
      t,
      e,
      s + 1
    )}`
  ).join(", ")}${t}${r}}`;
}
function Ru(n, t = "", e = ["", "sign", "key"]) {
  return Ps(n) ? Object.keys(n).filter((s) => {
    for (let i = 0, r = e.length; i < r; i++)
      if (n[s] == e[i])
        return !1;
    return !0;
  }).sort().map((s) => `${s}=${n[s]}`).join("&") + t : String(n);
}
function ih(n, t, e = "") {
  let s = [];
  return n === t ? s : typeof n != "object" || typeof t != "object" || !n || !t ? (s.push({
    path: e,
    newValue: t,
    oldValue: n
  }), s) : ((/* @__PURE__ */ new Set([...Object.keys(n), ...Object.keys(t)])).forEach((i) => {
    const r = e ? `${e}.${i}` : i;
    s = s.concat(ih(n[i], t[i], r));
  }), s);
}
function Ou(n) {
  return Number.isNaN(n);
}
function zu(n) {
  if (n <= 1)
    return !1;
  for (let t = 2; t <= Math.sqrt(n); t++)
    if (n % t === 0)
      return !1;
  return !0;
}
function Nu(n) {
  for (; !zu(n); )
    n++;
  return n;
}
function Qt(n, t) {
  const e = parseFloat(n);
  return Number.isNaN(e) ? typeof t == "number" ? t : NaN : e;
}
function ji(n = 1e-6) {
  return function(t, e) {
    return Math.abs(t - e) < n;
  };
}
function N(n, t, e) {
  const s = Math.min(t, e), i = Math.max(t, e);
  return n < s ? s : n > i ? i : n;
}
function Yu(n, t) {
  return (n % t + t) % t;
}
function In(n, t, e) {
  return typeof n == "number" && typeof t == "number" ? (1 - e) * n + e * t : typeof n == "number" ? n : typeof t == "number" ? t : 0;
}
function Bu(n, t, e) {
  const s = Math.max(n.length, t.length), i = new Array(s);
  for (let r = 0; r < s; r++)
    i[r] = In(n[r], t[r], e);
  return i;
}
function Xu(n, t, e) {
  return (s) => {
    const i = N(s, n, t);
    return e == 0 ? i : t - i < e ? t : Math.round(i / e) * e;
  };
}
function Fu(n, t = 12) {
  return Qt(n, 0).toFixed(t);
}
function Y(n, t = 12) {
  return +Fu(n, t);
}
function Hi(n, t) {
  const e = Za("number-single", String(n));
  return {
    hasNumber: !!e,
    number: e && !Array.isArray(e) && e.fullMatch ? parseFloat(e.fullMatch) : ku(t) ? t : NaN,
    prefix: e && !Array.isArray(e) && e.fullMatch ? n.substring(0, e.matchIndex) : "",
    suffix: e && !Array.isArray(e) && e.fullMatch ? n.substring(e.matchIndex + e.fullMatch.length) : ""
  };
}
function Ir(n) {
  const t = Za("number", n);
  return t ? Array.isArray(t) ? t.map((e) => Number(e.fullMatch)) : [Number(t.fullMatch)] : [];
}
function Uu(n = [], t = []) {
  const e = n.length, s = t.length;
  for (let r = 0; r < s; r++)
    n[r] = t[r];
  let i = Math.max(0, e - s);
  for (; i > 0; )
    n.pop(), i--;
  return n;
}
function rh(n, t) {
  const e = n.findIndex((s) => s === t);
  return e >= 0 && n.splice(e, 1), n;
}
function oh(n, t) {
  return n.findIndex((e) => e == t) >= 0;
}
function Gu(n, ...t) {
  return t.forEach((e) => {
    oh(n, e) || n.push(e);
  }), n;
}
function ct() {
  return (performance || Date).now();
}
function Gt(n = /* @__PURE__ */ new Date()) {
  return n.getTime();
}
function Vu(n = /* @__PURE__ */ new Date(), t = "yyyy-mm-dd hh:ii:ss.SSS") {
  return Zu(n, t);
}
function $u(n) {
  return !Ou(n.valueOf());
}
function qu(n, t = 3) {
  const e = Math.max(n.length, 6);
  let s = "";
  for (let r = 0; r < e - 4; r++)
    s += n[r] || "0";
  const i = [
    s,
    "" + (n[e - 4] || "0") + (n[e - 3] || "0"),
    "" + (n[e - 2] || "0") + (n[e - 1] || "0")
  ];
  switch (t) {
    case 1:
      return i[0];
    case 2:
      return i[0] + ":" + i[1];
    case 3:
      return i[0] + ":" + i[1] + ":" + i[2];
  }
}
function ju(n) {
  const t = Math.max(n.length, 6);
  let e = 0;
  e += (n[t - 2] || 0) * 10 + (n[t - 1] || 0), e += ((n[t - 4] || 0) * 10 + (n[t - 3] || 0)) * 60;
  let s = 0;
  for (let i = 0; i < t - 4; i++)
    s = s * 10 + (n[i] || 0);
  return e += s * 60 * 60, Math.floor(Math.max(0, e));
}
function Hu(n, t = !1) {
  let e = 0;
  typeof n == "number" ? e = n : e = ju(n);
  const s = [], i = e % 60;
  s.unshift(i % 10), s.unshift(Math.floor(i / 10)), e = Math.floor(e / 60);
  const r = e % 60;
  if (s.unshift(r % 10), s.unshift(Math.floor(r / 10)), e = Math.floor(e / 60), t) {
    const o = e % 100;
    for (s.unshift(o % 10), s.unshift(Math.floor(o / 10)), e = Math.floor(e / 100); e; )
      s.unshift(e % 10), e = Math.floor(e / 10);
  } else {
    const o = e % 24;
    s.unshift(o % 10), s.unshift(Math.floor(o / 10));
  }
  return s;
}
function Wu(n, t = 1, e = !1) {
  return n[n.length - 1] += t, Hu(n, e);
}
function Zu(n, t = "yyyy-mm-dd hh:ii:ss") {
  if (!$u(n))
    return "";
  const e = /(y+)/.exec(t);
  if (e && e[1]) {
    const i = e[1];
    t = t.replace(
      i,
      // (date.getFullYear() + "").substring(Math.max(4 - year.length, 0))
      (n.getFullYear() + "").substring(4 - i.length)
    );
  }
  const s = {
    "m+": n.getMonth() + 1,
    //月份
    "d+": n.getDate(),
    //日
    "h+": n.getHours(),
    //小时
    "i+": n.getMinutes(),
    //分
    "s+": n.getSeconds(),
    //秒
    "q+": Math.floor((n.getMonth() + 3) / 3),
    // 季度
    "S+": n.getMilliseconds()
    //毫秒
  };
  for (const i in s) {
    const r = new RegExp("(" + i + ")").exec(t);
    if (r && r[1]) {
      const o = r[1];
      t = t.replace(
        o,
        // d.length == 1 ? "" + o[k] : ("00" + o[k]).substring(("" + o[k]).length)
        // d.length == 1
        //   ? "" + o[k]
        //   : ("00" + o[k]).substring(("" + o[k]).length - d.length + 2)
        o.length === 1 ? "" + s[i] : ("00" + s[i]).slice(-o.length)
      );
    }
  }
  return t;
}
function Fn(n, t) {
  const e = typeof t?.aliveInSeconds == "number" ? Math.max(t.aliveInSeconds, 0) : -1, s = typeof t?.aliveUntilTimestamp == "number" ? Math.max(t.aliveUntilTimestamp, 0) : -1;
  function i(o, a = !1) {
    return eh(o) || Xn(o) ? { v: o, [Es]: Gt() } : a && gu(o, Es) ? o : {
      ...o,
      [Es]: Gt()
    };
  }
  let r = i(n, !0);
  return {
    get: () => {
      let o = !1;
      return (e >= 0 && Gt() > r[Es] + e * 1e3 || // 时间戳
      s >= 0 && Gt() > s) && (o = !0), o && (r.v = void 0), r;
    },
    set: (o) => r = i(o)
  };
}
const Ju = typeof window < "u";
!!(vt.Worker && vt.Blob && vt.Promise && vt.OffscreenCanvas && vt.OffscreenCanvasRenderingContext2D && vt.HTMLCanvasElement && vt.HTMLCanvasElement.prototype.transferControlToOffscreen && vt.URL && vt.URL.createObjectURL);
const Ku = (() => {
  if (!vt.OffscreenCanvas)
    return !1;
  const n = new OffscreenCanvas(1, 1), t = n.getContext("2d");
  if (!t)
    return !1;
  t.fillRect(0, 0, 1, 1);
  const e = n.transferToImageBitmap();
  try {
    t.createPattern(e, "no-repeat");
  } catch {
    return !1;
  }
  return !0;
})();
let Oo;
try {
  Oo = Map;
} catch {
  Oo = function() {
  };
}
let zo;
try {
  zo = Set;
} catch {
  zo = function() {
  };
}
const es = (n, t = 16) => {
  let e = n.toLowerCase();
  const s = e.indexOf("0b") == 0, i = e.indexOf("0o") == 0, r = e.indexOf("0x") == 0;
  (s || i || r) && (e = e.slice(2)), s && (t = 2), i && (t = 8), r && (t = 16);
  const o = parseInt(e, t);
  if (isNaN(o))
    throw new Error(`radixStringToNumber(${n}, ${t}) 无法解析！`);
  return o;
};
function kr(n) {
  return new TextEncoder().encode(n);
}
function ah(n) {
  return String.fromCharCode.apply(
    null,
    new Uint16Array(n)
  );
}
function Dr(n, t) {
  const e = t?.mime, s = t?.encode, i = t?.type;
  return i ? new Blob([n], {
    type: i
  }) : e ? s === Bn.base64 ? new Blob([n], { type: `${e};${s}` }) : s === Bn.utf8 ? new Blob([n], {
    type: `${e};charset=${s}`
  }) : new Blob([n], {
    type: `${e}`
  }) : new Blob([n]);
}
const Qu = (n) => {
  let t = Mt.UNKNOWN;
  switch (new DataView(n).getUint32(0, tf()).toString(16).toUpperCase()) {
    case "FFD8FFDB":
      t = Mt.JPEG;
      break;
    case "FFD8FFE0":
    case "FFD8FFE1":
    case "FFD8FFE2":
    case "FFD8FFE3":
      t = Mt.JPEG;
      break;
    case "89504E47":
      t = Mt.PNG;
      break;
    case "47494638":
      t = Mt.GIF;
      break;
    case "52494646":
      t = Mt.WEBP;
      break;
    case "25504446":
      t = Mt.PDF;
      break;
    case "504B0304":
      t = Mt.ZIP;
      break;
  }
  return t;
};
function tf() {
  const n = Uint32Array.of(305419896), t = new Uint8Array(n.buffer);
  switch (t[0] * 16777216 + t[1] * 65536 + t[2] * 256 + t[3]) {
    case 305419896:
      return !1;
    case 2018915346:
      return !0;
  }
}
const Ts = {
  THROW: 1,
  DROP: 2,
  SLIDE: 3,
  EXPAND: 4
};
class ef {
  queue;
  limit;
  overflow;
  constructor(t = 10, e = Ts.EXPAND) {
    this.queue = [], this.limit = t, this.overflow = e;
  }
  length() {
    return this.queue.length;
  }
  isEmpty() {
    return this.length() === 0;
  }
  findIndex(t) {
    return this.queue.findIndex(t);
  }
  deleteIndex(t) {
    return !!this.queue.splice(t, 1).length;
  }
  delete(t) {
    const e = this.findIndex(t);
    return e > -1 ? this.deleteIndex(e) : !1;
  }
  // 入队
  enqueue(t) {
    if (this.length() < this.limit) {
      this.queue.push(t);
      return;
    }
    switch (this.overflow) {
      case Ts.EXPAND:
        this.limit *= 2, this.queue.push(t);
        break;
      case Ts.SLIDE:
        this.deleteIndex(0), this.queue.push(t);
        break;
      case Ts.THROW:
        throw new Error(`Queue limit(${this.limit}) overflow!`);
    }
  }
  push(t) {
    this.enqueue(t);
  }
  put(t) {
    this.enqueue(t);
  }
  // 出队
  dequeue() {
    return this.queue.shift();
  }
  pop() {
    return this.dequeue();
  }
  take() {
    return this.dequeue();
  }
  // 获取队顶对象
  peek() {
    return this.queue[0];
  }
  // 获取对象
  index(t) {
    return this.queue[t];
  }
  // 全部出队
  clear() {
    this.queue = [];
  }
  // 全部出队
  flush() {
    const t = [];
    let e;
    for (; e = this.dequeue(); )
      t.push(e);
    return t;
  }
}
const sf = (n) => new ef(n, Ts.EXPAND), No = {
  SLIDE: 1,
  EXPAND: 2
};
class nf {
  size;
  table;
  objectSignature;
  overflow;
  ttl;
  constructor(t) {
    this.table = new Array(t?.size || 137), this.size = this.table.length, this.objectSignature = t?.objectSignature || ((e) => String(e)), this.overflow = t?.overflow || No.EXPAND, this.ttl = t?.ttl || 6e4;
  }
  // 散列函数，纯函数
  hash(t) {
    if (t == null || t == null)
      throw new Error("HashTable can't put undefined or null");
    const e = this.objectSignature(t), s = 31;
    let i = 0;
    for (let r = 0, o = e.length; r < o; r++)
      i += s * i + e.charCodeAt(r);
    return i % this.size;
  }
  // 扩展散列表大小至一个更大的质数
  resize() {
    const t = this.size, e = Nu(this.size * 2), s = new Array(e), i = this.table;
    this.table = s, this.size = e;
    for (let r = 0, o = t; r < o; r++)
      if (i[r] !== void 0 && !this.isOutdated(i[r])) {
        let a = this.hash(i[r].value);
        for (; s[a] !== void 0; )
          a = (a + 1) % e;
        s[a] = i[r];
      }
    i.length = 0;
  }
  put(t) {
    this.size > 200 && Math.random() < 0.1 && this.clean();
    let e = this.hash(t);
    const s = e;
    for (; this.table[e] !== void 0 && !this.isOutdated(this.table[e]); )
      if (e = (e + 1) % this.size, s == e) {
        if (this.overflow == No.EXPAND)
          return this.resize(), this.put(t);
        break;
      }
    return this.table[e] = { value: t, timestamp: Date.now() }, e;
  }
  // 性能瓶颈
  // visitFn : return false to break loop
  traverse(t) {
    for (let e = 0, s = this.size; e < s; e++)
      if (this.table[e] !== void 0 && !t(this.table[e].value, e))
        return e;
    return -1;
  }
  // filter : return false 删除
  update(t) {
    this.traverse((e, s) => (t(e) === !1 && this.deleteIndex(s), !0));
  }
  getIndex(t) {
    let e = this.hash(t);
    const s = e;
    for (; this.table[e]?.value !== t; )
      if (this.table[e] === void 0 || (this.isOutdated(this.table[e]) && (this.table[e] = void 0), e = (e + 1) % this.size, s == e))
        return -1;
    return this.isOutdated(this.table[e]) ? (this.table[e] = void 0, -1) : e;
  }
  has(t) {
    return this.getIndex(t) >= 0;
  }
  // 性能瓶颈
  find(t) {
    const e = this.traverse((s) => !t(s));
    return e >= 0 ? this.table[e]?.value : void 0;
  }
  deleteIndex(t) {
    return t >= 0 && t < this.size && this.table[t] !== void 0 ? (this.table[t] = void 0, !0) : !1;
  }
  delete(t) {
    return this.deleteIndex(this.getIndex(t));
  }
  clear() {
    this.table = [];
  }
  // 数据是否过期
  isOutdated(t) {
    return Date.now() - t.timestamp > this.ttl;
  }
  // 性能瓶颈
  // 供外部使用：主动清理过期数据
  clean() {
    for (let t = 0, e = this.size; t < e; t++)
      this.table[t] !== void 0 && this.isOutdated(this.table[t]) && (this.table[t] = void 0);
  }
}
class Ws {
  maps = /* @__PURE__ */ new Map();
  constructor() {
  }
  // Object.entries(...);
  // Object.fromEntries(...);
  entries() {
    return [...this.maps.entries()];
  }
  // Object.keys(...);
  keys() {
    return [...this.maps.keys()];
  }
  // Object.values(...);
  values() {
    return [...this.maps.values()];
  }
  json() {
    const t = {};
    for (const e of this.maps)
      t[e[0]] = e[1];
    return t;
  }
  get length() {
    return this.maps.size;
  }
  set(t, e) {
    this.maps.set(t, e);
  }
  get(t) {
    return this.maps.get(t);
  }
  has(t) {
    return this.maps.has(t);
  }
  // Map 对象是按插入的顺序返回键值
  getEntryFromIndex(t) {
    let e = -1;
    for (const s of this.maps)
      if (++e == t)
        return s;
  }
  // 性能瓶颈
  getEntry(t) {
    for (const e of this.maps)
      if (t(e[0], e[1]))
        return e;
  }
  firstEntry() {
    return this.getEntryFromIndex(0);
  }
  // 从头部删除
  shift() {
    const t = this.firstEntry();
    if (t) {
      const [e] = t;
      this.delete(e);
    }
    return t;
  }
  delete(t) {
    return this.maps.delete(t);
  }
  clear() {
    this.maps.clear();
  }
  // filter : return false 删除
  update(t) {
    const e = this.entries();
    for (let s = 0, i = e.length; s < i; s++) {
      const [r, o] = e[s];
      t(r, o) === !1 && this.delete(r);
    }
  }
}
function jg() {
  vt.OPEN_LOG = !0;
}
function Hg() {
  vt.OPEN_LOG = !1;
}
function Wg(n) {
  vt.LOG_UPLOAD_FN = n;
}
function hh() {
  return !!vt.OPEN_LOG;
}
function ch(n) {
  vt.LOG_UPLOAD_FN && vt.LOG_UPLOAD_FN(n);
}
function ae(n) {
  ch({ level: "info", msg: n }), hh() && (!console || typeof console != "object" || typeof console.log != "function" || console.log(n));
}
function kn(n) {
  ch({ level: "warn", msg: n }), hh() && (!console || typeof console != "object" || typeof console.warn != "function" || console.warn(n));
}
const Yo = () => {
};
function lh(n = 0, t) {
  const e = t?.min || 300, s = t?.max || 6e4, i = t?.exponent || 2, r = t?.factor || 0.5;
  let o = e * Math.pow(i, n);
  if (r) {
    const a = Math.random(), h = Math.floor(a * r * o);
    o = Math.floor(a * 10) & 1 ? o + h : o - h;
  }
  return Math.min(o, s) | 0;
}
function Lr(n, t = 3, e, s) {
  return async function(...i) {
    const r = `retry(${n.name})(${i.map((a) => Ve(a))})`;
    let o;
    for (let a = 0; a < t; a++)
      try {
        return await n.call(s || this, ...i);
      } catch (h) {
        ae(`(${r}) 第 ${a + 1} 次尝试失败, retrying...`), o = h, await new Promise(
          (c) => setTimeout(
            c,
            typeof e == "number" ? e : lh(a)
            // : 300 * Math.pow(2, attempt)
          )
        );
      }
    throw ae(
      `(${r}) 已 ${t} 次失败，不再重试。 Last error: ${Ve(
        o
      )}`
    ), o;
  };
}
function Rr(n, t = 60, e = new Ws(), s) {
  return async function(...i) {
    const r = `cache(${n.name})(${i.map((c) => Ve(c))})`, o = Date.now();
    t && e.update((c, l) => o - l.timestamp < t * 1e3);
    const a = Ar(i), h = e.get(a);
    if (h) {
      if (!t || o - h.timestamp < t * 1e3)
        return ae(`${r} 击中缓存`), h.value;
      e.delete(a);
    }
    try {
      ae(`${r} 没有缓存, 尝试立即执行...`);
      const c = await n.call(s || this, ...i);
      return ae(`${r} 缓存设置成功`), e.set(a, {
        value: c,
        timestamp: Date.now()
      }), c;
    } catch (c) {
      throw ae(`${r} 执行失败 : ${Ve(c)}`), c;
    }
  };
}
var Wi = function(n, t) {
  return Wi = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, s) {
    e.__proto__ = s;
  } || function(e, s) {
    for (var i in s)
      Object.prototype.hasOwnProperty.call(s, i) && (e[i] = s[i]);
  }, Wi(n, t);
};
function Or(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Wi(n, t);
  function e() {
    this.constructor = n;
  }
  n.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
function Bo(n) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && n[t], s = 0;
  if (e)
    return e.call(n);
  if (n && typeof n.length == "number")
    return {
      next: function() {
        return n && s >= n.length && (n = void 0), { value: n && n[s++], done: !n };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Zi(n, t) {
  var e = typeof Symbol == "function" && n[Symbol.iterator];
  if (!e)
    return n;
  var s = e.call(n), i, r = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = s.next()).done; )
      r.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (e = s.return) && e.call(s);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return r;
}
function Ji(n, t, e) {
  if (e || arguments.length === 2)
    for (var s = 0, i = t.length, r; s < i; s++)
      (r || !(s in t)) && (r || (r = Array.prototype.slice.call(t, 0, s)), r[s] = t[s]);
  return n.concat(r || Array.prototype.slice.call(t));
}
function ye(n) {
  return typeof n == "function";
}
function rf(n) {
  var t = function(s) {
    Error.call(s), s.stack = new Error().stack;
  }, e = n(t);
  return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e, e;
}
var Ci = rf(function(n) {
  return function(t) {
    n(this), this.message = t ? t.length + ` errors occurred during unsubscription:
` + t.map(function(e, s) {
      return s + 1 + ") " + e.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = t;
  };
});
function Xo(n, t) {
  if (n) {
    var e = n.indexOf(t);
    0 <= e && n.splice(e, 1);
  }
}
var zr = function() {
  function n(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return n.prototype.unsubscribe = function() {
    var t, e, s, i, r;
    if (!this.closed) {
      this.closed = !0;
      var o = this._parentage;
      if (o)
        if (this._parentage = null, Array.isArray(o))
          try {
            for (var a = Bo(o), h = a.next(); !h.done; h = a.next()) {
              var c = h.value;
              c.remove(this);
            }
          } catch (p) {
            t = { error: p };
          } finally {
            try {
              h && !h.done && (e = a.return) && e.call(a);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          o.remove(this);
      var l = this.initialTeardown;
      if (ye(l))
        try {
          l();
        } catch (p) {
          r = p instanceof Ci ? p.errors : [p];
        }
      var u = this._finalizers;
      if (u) {
        this._finalizers = null;
        try {
          for (var d = Bo(u), f = d.next(); !f.done; f = d.next()) {
            var m = f.value;
            try {
              Fo(m);
            } catch (p) {
              r = r ?? [], p instanceof Ci ? r = Ji(Ji([], Zi(r)), Zi(p.errors)) : r.push(p);
            }
          }
        } catch (p) {
          s = { error: p };
        } finally {
          try {
            f && !f.done && (i = d.return) && i.call(d);
          } finally {
            if (s)
              throw s.error;
          }
        }
      }
      if (r)
        throw new Ci(r);
    }
  }, n.prototype.add = function(t) {
    var e;
    if (t && t !== this)
      if (this.closed)
        Fo(t);
      else {
        if (t instanceof n) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (e = this._finalizers) !== null && e !== void 0 ? e : []).push(t);
      }
  }, n.prototype._hasParent = function(t) {
    var e = this._parentage;
    return e === t || Array.isArray(e) && e.includes(t);
  }, n.prototype._addParent = function(t) {
    var e = this._parentage;
    this._parentage = Array.isArray(e) ? (e.push(t), e) : e ? [e, t] : t;
  }, n.prototype._removeParent = function(t) {
    var e = this._parentage;
    e === t ? this._parentage = null : Array.isArray(e) && Xo(e, t);
  }, n.prototype.remove = function(t) {
    var e = this._finalizers;
    e && Xo(e, t), t instanceof n && t._removeParent(this);
  }, n.EMPTY = function() {
    var t = new n();
    return t.closed = !0, t;
  }(), n;
}();
zr.EMPTY;
function uh(n) {
  return n instanceof zr || n && "closed" in n && ye(n.remove) && ye(n.add) && ye(n.unsubscribe);
}
function Fo(n) {
  ye(n) ? n() : n.unsubscribe();
}
var fh = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, of = {
  setTimeout: function(n, t) {
    for (var e = [], s = 2; s < arguments.length; s++)
      e[s - 2] = arguments[s];
    return setTimeout.apply(void 0, Ji([n, t], Zi(e)));
  },
  clearTimeout: function(n) {
    return clearTimeout(n);
  },
  delegate: void 0
};
function af(n) {
  of.setTimeout(function() {
    throw n;
  });
}
function Uo() {
}
function hf(n) {
  n();
}
var Nr = function(n) {
  Or(t, n);
  function t(e) {
    var s = n.call(this) || this;
    return s.isStopped = !1, e ? (s.destination = e, uh(e) && e.add(s)) : s.destination = ff, s;
  }
  return t.create = function(e, s, i) {
    return new Ki(e, s, i);
  }, t.prototype.next = function(e) {
    this.isStopped || this._next(e);
  }, t.prototype.error = function(e) {
    this.isStopped || (this.isStopped = !0, this._error(e));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, n.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(e) {
    this.destination.next(e);
  }, t.prototype._error = function(e) {
    try {
      this.destination.error(e);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(zr), cf = Function.prototype.bind;
function Ei(n, t) {
  return cf.call(n, t);
}
var lf = function() {
  function n(t) {
    this.partialObserver = t;
  }
  return n.prototype.next = function(t) {
    var e = this.partialObserver;
    if (e.next)
      try {
        e.next(t);
      } catch (s) {
        gn(s);
      }
  }, n.prototype.error = function(t) {
    var e = this.partialObserver;
    if (e.error)
      try {
        e.error(t);
      } catch (s) {
        gn(s);
      }
    else
      gn(t);
  }, n.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (e) {
        gn(e);
      }
  }, n;
}(), Ki = function(n) {
  Or(t, n);
  function t(e, s, i) {
    var r = n.call(this) || this, o;
    if (ye(e) || !e)
      o = {
        next: e ?? void 0,
        error: s ?? void 0,
        complete: i ?? void 0
      };
    else {
      var a;
      r && fh.useDeprecatedNextContext ? (a = Object.create(e), a.unsubscribe = function() {
        return r.unsubscribe();
      }, o = {
        next: e.next && Ei(e.next, a),
        error: e.error && Ei(e.error, a),
        complete: e.complete && Ei(e.complete, a)
      }) : o = e;
    }
    return r.destination = new lf(o), r;
  }
  return t;
}(Nr);
function gn(n) {
  af(n);
}
function uf(n) {
  throw n;
}
var ff = {
  closed: !0,
  next: Uo,
  error: uf,
  complete: Uo
}, df = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function mf(n) {
  return n;
}
function pf(n) {
  return n.length === 0 ? mf : n.length === 1 ? n[0] : function(t) {
    return n.reduce(function(e, s) {
      return s(e);
    }, t);
  };
}
(function() {
  function n(t) {
    t && (this._subscribe = t);
  }
  return n.prototype.lift = function(t) {
    var e = new n();
    return e.source = this, e.operator = t, e;
  }, n.prototype.subscribe = function(t, e, s) {
    var i = this, r = yf(t) ? t : new Ki(t, e, s);
    return hf(function() {
      var o = i, a = o.operator, h = o.source;
      r.add(a ? a.call(r, h) : h ? i._subscribe(r) : i._trySubscribe(r));
    }), r;
  }, n.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (e) {
      t.error(e);
    }
  }, n.prototype.forEach = function(t, e) {
    var s = this;
    return e = Go(e), new e(function(i, r) {
      var o = new Ki({
        next: function(a) {
          try {
            t(a);
          } catch (h) {
            r(h), o.unsubscribe();
          }
        },
        error: r,
        complete: i
      });
      s.subscribe(o);
    });
  }, n.prototype._subscribe = function(t) {
    var e;
    return (e = this.source) === null || e === void 0 ? void 0 : e.subscribe(t);
  }, n.prototype[df] = function() {
    return this;
  }, n.prototype.pipe = function() {
    for (var t = [], e = 0; e < arguments.length; e++)
      t[e] = arguments[e];
    return pf(t)(this);
  }, n.prototype.toPromise = function(t) {
    var e = this;
    return t = Go(t), new t(function(s, i) {
      var r;
      e.subscribe(function(o) {
        return r = o;
      }, function(o) {
        return i(o);
      }, function() {
        return s(r);
      });
    });
  }, n.create = function(t) {
    return new n(t);
  }, n;
})();
function Go(n) {
  var t;
  return (t = n ?? fh.Promise) !== null && t !== void 0 ? t : Promise;
}
function gf(n) {
  return n && ye(n.next) && ye(n.error) && ye(n.complete);
}
function yf(n) {
  return n && n instanceof Nr || gf(n) && uh(n);
}
(function(n) {
  Or(t, n);
  function t(e, s, i, r, o, a) {
    var h = n.call(this, e) || this;
    return h.onFinalize = o, h.shouldUnsubscribe = a, h._next = s ? function(c) {
      try {
        s(c);
      } catch (l) {
        e.error(l);
      }
    } : n.prototype._next, h._error = r ? function(c) {
      try {
        r(c);
      } catch (l) {
        e.error(l);
      } finally {
        this.unsubscribe();
      }
    } : n.prototype._error, h._complete = i ? function() {
      try {
        i();
      } catch (c) {
        e.error(c);
      } finally {
        this.unsubscribe();
      }
    } : n.prototype._complete, h;
  }
  return t.prototype.unsubscribe = function() {
    var e;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var s = this.closed;
      n.prototype.unsubscribe.call(this), !s && ((e = this.onFinalize) === null || e === void 0 || e.call(this));
    }
  }, t;
})(Nr);
class xf extends Error {
  name;
  response;
  statusCode;
  constructor(t, e) {
    super(t), this.name = "HttpError", this.response = e, this.statusCode = e.status;
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      stack: this.stack,
      response: this.response,
      statusCode: this.statusCode
    };
  }
}
let Os;
function Te(n) {
  Os = n, n(), Os = null;
}
class wf {
  subscribers = /* @__PURE__ */ new Set();
  add() {
    Os && !this.subscribers.has(Os) && this.subscribers.add(Os);
  }
  notify(t) {
    this.subscribers.forEach((e) => e(t));
  }
}
const Vo = /* @__PURE__ */ new WeakMap();
function Pi(n, t) {
  let e = Vo.get(n);
  e || (e = /* @__PURE__ */ new Map(), Vo.set(n, e));
  let s = e.get(t);
  return s || (s = new wf(), e.set(t, s)), s;
}
const Yr = dh;
function dh(n, t) {
  if (!An(n))
    return n;
  const e = typeof t?.deep == "boolean" ? t?.deep : !0, s = t?.path || "", i = t?.callback, r = {
    // 拦截对象属性的读取
    // target 目标对象、key 键值、receiver 当前proxy实例
    get(o, a, h) {
      const c = s ? `${s}.${String(a)}` : String(a);
      let l = Reflect.get(o, a, h);
      const u = Pi(o, a);
      if (e && An(l) && !("isYZProxy" in l)) {
        const d = dh(l, {
          deep: !0,
          path: c,
          callback: i
        });
        Array.isArray(l) && (d.YZProxyArrayDep = u), l = d;
      }
      return u.add(), l;
    },
    // 拦截对象属性的设置
    // target 目标对象、key 键值、value 值、receiver 当前proxy实例
    set(o, a, h, c) {
      const l = Reflect.get(o, a, c), u = Reflect.set(o, a, h, c);
      if (a == "YZProxyArrayDep")
        return u;
      if (l !== h) {
        let d;
        Array.isArray(o) ? d = o.YZProxyArrayDep : d = Pi(o, a);
        const f = { path: s ? `${s}.${String(a)}` : String(a), newValue: h, oldValue: l };
        d.notify(f), i && i(f);
      }
      return u;
    },
    // 拦截 `delete proxy[key]` 的操作，返回一个布尔值
    deleteProperty(o, a) {
      if (!(a in o))
        return !1;
      let h = typeof a == "symbol" ? void 0 : o[a];
      An(h) && (h = Array.isArray(h) ? [...h] : { ...h });
      const c = Reflect.deleteProperty(o, a);
      if (c) {
        let l;
        Array.isArray(o) ? l = o.YZProxyArrayDep : l = Pi(o, a);
        const u = { path: s ? `${s}.${String(a)}` : String(a), newValue: void 0, oldValue: h };
        l.notify(u), i && i(u);
      }
      return c;
    },
    // 拦截 `key in proxy` 的操作，返回一个布尔值
    has(o, a) {
      return a === "isYZProxy" || a in o;
    }
    // 拦截 `Object.keys(proxy)`、`for...in` 等循环，返回一个数组
    // ownKeys(target) {
    //   return [];
    // },
    // 拦截 `Object.getOwnPropertyDescriptor(proxy, key)`，返回属性的描述对象
    // getOwnPropertyDescriptor(target, key) {
    //   return {};
    // },
    // 拦截 `Object.defineProperty(proxy, key, desc`，返回一个布尔值
    // defineProperty(target, key, desc) {
    //   return true;
    // },
    // 拦截 `Object.preventExtensions(proxy)`，返回一个布尔值
    // preventExtensions(target) {
    //   return true;
    // },
    // 拦截 `Object.getPrototypeOf(proxy)`，返回一个对象
    // getPrototypeOf(target) {
    //   return {};
    // },
    // 拦截 `Object.isExtensible(proxy)`，返回一个布尔值
    // isExtensible(target) {
    //   return true;
    // },
    // 拦截 `Object.setPrototypeOf(proxy, proto)`，返回一个布尔值
    // setPrototypeOf(target, proto) {
    //   return true;
    // },
    // 拦截 Proxy 实例作为函数调用的操作
    // apply(target, thisArg, args) {
    //   return target.apply(thisArg, args);
    // },
    // 拦截 Proxy 实例作为构造函数调用的操作
    // construct(target, args) {
    //   return {};
    // }
  };
  return new Proxy(n, r);
}
class Qn {
  events;
  constructor() {
    this.events = {};
  }
  isEmpty(t) {
    return this.events[t] == null || this.events[t].length == 0;
  }
  has(t, e) {
    return this.events[t] !== void 0 && this.events[t].indexOf(e) !== -1;
  }
  prependListener(t, e, s) {
    return this.events[t] || (this.events[t] = []), this.events[t].unshift(
      s ? e.bind(s) : e
    ), this;
  }
  addListener(t, e, s) {
    return this.events[t] || (this.events[t] = []), this.events[t].push(
      s ? e.bind(s) : e
    ), this;
  }
  on(t, e, s) {
    return this.addListener(t, e, s), this;
  }
  removeListener(t, e) {
    return this.events[t] && (this.events[t] = this.events[t].filter((s) => s !== e)), this;
  }
  off(t, e) {
    return this.removeListener(t, e), this;
  }
  removeAllListeners(t) {
    return t ? this.events[t] = [] : this.events = {}, this;
  }
  // 注意：handler 自己绑定 this
  emit(t, ...e) {
    return this.events[t] && this.events[t].slice(0).forEach((s) => {
      s(...e);
    }), this;
  }
  once(t, e, s) {
    const i = (...r) => {
      s ? e.apply(s, r) : e(...r), this.off(t, i);
    };
    return this.on(t, i), this;
  }
}
function bf(n, t = (e, s) => e <= s) {
  const e = n.length;
  let s = Math.floor(e / 2);
  for (; s > 0; ) {
    for (let i = s; i < e; i++) {
      const r = n[i];
      let o = i;
      for (; o >= s && !t(n[o - s], r); )
        n[o] = n[o - s], o -= s;
      n[o] = r;
    }
    s = Math.floor(s / 2);
  }
}
function vf() {
  const n = {};
  return n.promise = new Promise((t, e) => {
    n.resolve = t, n.reject = e;
  }), n;
}
let _f = 0;
function mh(n) {
  const t = vf();
  let e = !1;
  return {
    name: n.name || String(++_f),
    deadline: typeof n.deadline == "number" ? Math.max(n.deadline, 0) : -1,
    run: async () => {
      if (!e) {
        e = !0;
        try {
          let s;
          const i = n.args || [];
          n.thisArg ? s = await n.fn.call(n.thisArg, ...i) : s = await n.fn(...i), t.resolve(s);
        } catch (s) {
          t.reject(s);
        }
      }
    },
    result: () => t.promise
  };
}
class Sf {
  // 任务队列
  queue;
  // 是否暂停执行任务队列
  suspend = !1;
  // 执行信号
  // Incrementing adds a lock
  // Decrementing releases a lock
  semaphore = 0;
  // 并发执行数量 或 并发等待结果数量
  concurrency = 1;
  // 剩余可执行时间，毫秒
  // -1 不考虑剩余可执行时间
  // =0 自动暂停执行任务队列
  timeRemaining = -1;
  // 超时任务检查id
  timeoutId;
  // queue = createNoneRingQueue() : 不缓存数据
  // queue = createFixedRingQueue(10) : 超出缓存空间时，抛错
  // queue = createDroppingRingQueue(10) : 超出缓存空间时，忽略新数据
  // queue = createSlidingRingQueue(10) : 超出缓存空间时，删除旧数据
  // queue = createExpandingRingQueue(10) : 超出缓存空间时，扩大缓存空间
  constructor(t) {
    this.queue = t?.queue || sf(10), typeof t?.concurrency == "number" && (this.concurrency = Math.max(t?.concurrency, 1)), typeof t?.timeRemaining == "number" && this.setTimeRemaining(t.timeRemaining);
  }
  setTimeRemaining(t) {
    this.timeRemaining = Math.max(0, t);
  }
  increaseTimeRemaining(t, e = !1) {
    this.timeRemaining !== -1 ? this.setTimeRemaining(this.timeRemaining + t) : e && this.setTimeRemaining(t);
  }
  decreaseTimeRemaining(t) {
    this.timeRemaining !== -1 && this.setTimeRemaining(this.timeRemaining - t);
  }
  // 执行任务，不管执行结果
  _exec(t, e = !0) {
    const s = Gt();
    try {
      this.semaphore++, t.run();
    } finally {
      this.semaphore--, e && (this.decreaseTimeRemaining(Gt() - s), this._flush());
    }
  }
  // 执行队列
  _flush() {
    for (; !this.suspend && this.semaphore < this.concurrency && (this.timeRemaining == -1 || this.timeRemaining > 0); ) {
      const t = this.queue.dequeue();
      if (!t)
        break;
      this._exec(t);
    }
    this._timeout();
  }
  // 超时任务检查
  _timeout(t = 0, e = 0) {
    clearTimeout(this.timeoutId), this.timeoutId = setTimeout(() => {
      if (!(this.suspend || this.semaphore > 0 || !this.queue.length)) {
        for (let s = 0; s < this.queue.length(); ) {
          const i = this.queue.index(s);
          if (!i)
            break;
          i.deadline != -1 && i.deadline <= Gt() ? (this._exec(i, !1), this.queue.deleteIndex(s)) : s++;
        }
        this.queue.length() && (this.timeoutId = setTimeout(
          () => {
            this._timeout(t, ++e);
          },
          300 * Math.pow(2, e)
          // wait a bit longer between each retry
        ));
      }
    }, t);
  }
  // 暂停
  pause() {
    this.suspend = !0;
  }
  // 恢复
  resume() {
    this.suspend = !1, this._flush();
  }
  addTask(t) {
    this.queue.delete((e) => e.name == t.name), this.queue.enqueue(t);
  }
  // 立即触发执行
  immediately(t) {
    this._exec(t), this._flush();
  }
  // 立即顺序触发执行队列
  asap(t) {
    this.addTask(t), this._flush();
  }
  // 有空余时间再执行队列
  idleCallback(t) {
    this.setTimeRemaining(t.timeRemaining()), this._flush();
  }
  clear() {
    this.queue.clear();
  }
}
class ph extends Sf {
  // 上个任务的执行结果
  lastResult;
  constructor(t) {
    super(t);
  }
  // 执行任务
  _exec(t, e = !0) {
    const s = Gt();
    try {
      this.semaphore++, t.run();
    } finally {
      t.result().then((i) => {
        this.lastResult = i;
      }).finally(() => {
        this.semaphore--, e && (this.decreaseTimeRemaining(Gt() - s), this._flush());
      });
    }
  }
}
class Cf {
  schedule;
  closeLastDialog;
  constructor(t) {
    this.schedule = new ph(t);
  }
  // dialog 自己绑定this
  // 将 Dialog 放入队列，依次关闭后显示
  asap(t, e) {
    const s = mh({
      fn: (i) => new Promise((r) => {
        this.closeLastDialog = t({
          ...i,
          onClose: () => {
            this.closeLastDialog = void 0, i?.onClose?.(), r();
          }
        });
      }),
      args: [e]
    });
    return this.schedule.asap(s), s;
  }
  // 强制显示 Dialog
  immediately(t, e) {
    return this.clear(), this.asap(t, e);
  }
  // 强制关闭上一个 Dialog
  closeLast() {
    this.closeLastDialog && this.closeLastDialog();
  }
  // 丢弃所有未处理的 Dialog
  clear() {
    this.schedule.clear(), this.closeLast();
  }
}
function gh(n) {
  const t = typeof n.immutable == "boolean" ? n.immutable : !0, e = n.initState || {};
  let s = n.reducer;
  if (n.enhancer)
    return n.enhancer(gh)({ reducer: s, initState: e, immutable: t });
  const i = [], r = (c) => (i.push(c), () => {
    const l = i.indexOf(c);
    l > -1 && i.splice(l, 1);
  });
  let o = e;
  t || (o = Yr(o, {
    callback: (c) => {
      i.forEach((l) => l(c));
    }
  }));
  const a = (c) => {
    if (t) {
      const l = o;
      o = s(o, c);
      const u = ih(l, o);
      for (const d of u)
        i.forEach((f) => f(d));
    } else
      s(o, c);
  }, h = (c) => {
    s = c, a({ type: "INIT" });
  };
  return a({ type: "INIT" }), {
    getState: () => o,
    dispatch: a,
    subscribe: r,
    replaceReducer: h
  };
}
function Ef(n = window.location.href) {
  try {
    return new URL(n);
  } catch {
    const t = "(?<protocol>https?:)", e = "(?<host>(?<hostname>[^/#?:]+)(?::(?<port>\\d+))?)", s = "(?<pathname>(?:\\/[^/#?]+)*\\/?)", i = "(?<search>(?:\\?[^#]*)?)", r = "(?<hash>(?:#.*)?)", o = new RegExp(`^${t}//${e}${s}${i}${r}$`).exec(n);
    return {
      href: n,
      protocol: o?.groups?.protocol || "",
      host: o?.groups?.host || "",
      hostname: o?.groups?.hostname || "",
      port: o?.groups?.port || "",
      pathname: o?.groups?.pathname || "",
      search: o?.groups?.search || "",
      hash: o?.groups?.hash || ""
    };
  }
}
function Pf(n = window.location.href) {
  const t = Ef(n), e = t.href.indexOf(t.hash);
  return t.hash && e >= 0 ? t.href.substring(0, e) : t.href;
}
function Tf(n, t) {
  return n + t.replace(/^[&?]/, n.indexOf("?") >= 0 ? "&" : "?");
}
function Mf(n) {
  return "?" + Object.entries(n).map(([t, e]) => `${encodeURIComponent(t)}=${encodeURIComponent(e)}`).join("&");
}
function Af(n) {
  return "?" + [...n.entries()].map(
    (t) => encodeURIComponent(t[0]) + "=" + encodeURIComponent(t[1] instanceof File ? t[1].name : t[1])
  ).join("&");
}
function yh(n, t) {
  return function() {
    return n.apply(t, arguments);
  };
}
const { toString: If } = Object.prototype, { getPrototypeOf: Br } = Object, ti = ((n) => (t) => {
  const e = If.call(t);
  return n[e] || (n[e] = e.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ee = (n) => (n = n.toLowerCase(), (t) => ti(t) === n), ei = (n) => (t) => typeof t === n, { isArray: ms } = Array, Fs = ei("undefined");
function kf(n) {
  return n !== null && !Fs(n) && n.constructor !== null && !Fs(n.constructor) && zt(n.constructor.isBuffer) && n.constructor.isBuffer(n);
}
const xh = ee("ArrayBuffer");
function Df(n) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(n) : t = n && n.buffer && xh(n.buffer), t;
}
const Lf = ei("string"), zt = ei("function"), wh = ei("number"), si = (n) => n !== null && typeof n == "object", Rf = (n) => n === !0 || n === !1, Dn = (n) => {
  if (ti(n) !== "object")
    return !1;
  const t = Br(n);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in n) && !(Symbol.iterator in n);
}, Of = ee("Date"), zf = ee("File"), Nf = ee("Blob"), Yf = ee("FileList"), Bf = (n) => si(n) && zt(n.pipe), Xf = (n) => {
  let t;
  return n && (typeof FormData == "function" && n instanceof FormData || zt(n.append) && ((t = ti(n)) === "formdata" || // detect form-data instance
  t === "object" && zt(n.toString) && n.toString() === "[object FormData]"));
}, Ff = ee("URLSearchParams"), [Uf, Gf, Vf, $f] = ["ReadableStream", "Request", "Response", "Headers"].map(ee), qf = (n) => n.trim ? n.trim() : n.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Zs(n, t, { allOwnKeys: e = !1 } = {}) {
  if (n === null || typeof n > "u")
    return;
  let s, i;
  if (typeof n != "object" && (n = [n]), ms(n))
    for (s = 0, i = n.length; s < i; s++)
      t.call(null, n[s], s, n);
  else {
    const r = e ? Object.getOwnPropertyNames(n) : Object.keys(n), o = r.length;
    let a;
    for (s = 0; s < o; s++)
      a = r[s], t.call(null, n[a], a, n);
  }
}
function bh(n, t) {
  t = t.toLowerCase();
  const e = Object.keys(n);
  let s = e.length, i;
  for (; s-- > 0; )
    if (i = e[s], t === i.toLowerCase())
      return i;
  return null;
}
const Xe = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), vh = (n) => !Fs(n) && n !== Xe;
function Qi() {
  const { caseless: n } = vh(this) && this || {}, t = {}, e = (s, i) => {
    const r = n && bh(t, i) || i;
    Dn(t[r]) && Dn(s) ? t[r] = Qi(t[r], s) : Dn(s) ? t[r] = Qi({}, s) : ms(s) ? t[r] = s.slice() : t[r] = s;
  };
  for (let s = 0, i = arguments.length; s < i; s++)
    arguments[s] && Zs(arguments[s], e);
  return t;
}
const jf = (n, t, e, { allOwnKeys: s } = {}) => (Zs(t, (i, r) => {
  e && zt(i) ? n[r] = yh(i, e) : n[r] = i;
}, { allOwnKeys: s }), n), Hf = (n) => (n.charCodeAt(0) === 65279 && (n = n.slice(1)), n), Wf = (n, t, e, s) => {
  n.prototype = Object.create(t.prototype, s), n.prototype.constructor = n, Object.defineProperty(n, "super", {
    value: t.prototype
  }), e && Object.assign(n.prototype, e);
}, Zf = (n, t, e, s) => {
  let i, r, o;
  const a = {};
  if (t = t || {}, n == null)
    return t;
  do {
    for (i = Object.getOwnPropertyNames(n), r = i.length; r-- > 0; )
      o = i[r], (!s || s(o, n, t)) && !a[o] && (t[o] = n[o], a[o] = !0);
    n = e !== !1 && Br(n);
  } while (n && (!e || e(n, t)) && n !== Object.prototype);
  return t;
}, Jf = (n, t, e) => {
  n = String(n), (e === void 0 || e > n.length) && (e = n.length), e -= t.length;
  const s = n.indexOf(t, e);
  return s !== -1 && s === e;
}, Kf = (n) => {
  if (!n)
    return null;
  if (ms(n))
    return n;
  let t = n.length;
  if (!wh(t))
    return null;
  const e = new Array(t);
  for (; t-- > 0; )
    e[t] = n[t];
  return e;
}, Qf = ((n) => (t) => n && t instanceof n)(typeof Uint8Array < "u" && Br(Uint8Array)), td = (n, t) => {
  const e = (n && n[Symbol.iterator]).call(n);
  let s;
  for (; (s = e.next()) && !s.done; ) {
    const i = s.value;
    t.call(n, i[0], i[1]);
  }
}, ed = (n, t) => {
  let e;
  const s = [];
  for (; (e = n.exec(t)) !== null; )
    s.push(e);
  return s;
}, sd = ee("HTMLFormElement"), nd = (n) => n.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, e, s) {
    return e.toUpperCase() + s;
  }
), $o = (({ hasOwnProperty: n }) => (t, e) => n.call(t, e))(Object.prototype), id = ee("RegExp"), _h = (n, t) => {
  const e = Object.getOwnPropertyDescriptors(n), s = {};
  Zs(e, (i, r) => {
    let o;
    (o = t(i, r, n)) !== !1 && (s[r] = o || i);
  }), Object.defineProperties(n, s);
}, rd = (n) => {
  _h(n, (t, e) => {
    if (zt(n) && ["arguments", "caller", "callee"].indexOf(e) !== -1)
      return !1;
    const s = n[e];
    if (zt(s)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + e + "'");
      });
    }
  });
}, od = (n, t) => {
  const e = {}, s = (i) => {
    i.forEach((r) => {
      e[r] = !0;
    });
  };
  return ms(n) ? s(n) : s(String(n).split(t)), e;
}, ad = () => {
}, hd = (n, t) => n != null && Number.isFinite(n = +n) ? n : t;
function cd(n) {
  return !!(n && zt(n.append) && n[Symbol.toStringTag] === "FormData" && n[Symbol.iterator]);
}
const ld = (n) => {
  const t = new Array(10), e = (s, i) => {
    if (si(s)) {
      if (t.indexOf(s) >= 0)
        return;
      if (!("toJSON" in s)) {
        t[i] = s;
        const r = ms(s) ? [] : {};
        return Zs(s, (o, a) => {
          const h = e(o, i + 1);
          !Fs(h) && (r[a] = h);
        }), t[i] = void 0, r;
      }
    }
    return s;
  };
  return e(n, 0);
}, ud = ee("AsyncFunction"), fd = (n) => n && (si(n) || zt(n)) && zt(n.then) && zt(n.catch), Sh = ((n, t) => n ? setImmediate : t ? ((e, s) => (Xe.addEventListener("message", ({ source: i, data: r }) => {
  i === Xe && r === e && s.length && s.shift()();
}, !1), (i) => {
  s.push(i), Xe.postMessage(e, "*");
}))(`axios@${Math.random()}`, []) : (e) => setTimeout(e))(
  typeof setImmediate == "function",
  zt(Xe.postMessage)
), dd = typeof queueMicrotask < "u" ? queueMicrotask.bind(Xe) : typeof process < "u" && process.nextTick || Sh, M = {
  isArray: ms,
  isArrayBuffer: xh,
  isBuffer: kf,
  isFormData: Xf,
  isArrayBufferView: Df,
  isString: Lf,
  isNumber: wh,
  isBoolean: Rf,
  isObject: si,
  isPlainObject: Dn,
  isReadableStream: Uf,
  isRequest: Gf,
  isResponse: Vf,
  isHeaders: $f,
  isUndefined: Fs,
  isDate: Of,
  isFile: zf,
  isBlob: Nf,
  isRegExp: id,
  isFunction: zt,
  isStream: Bf,
  isURLSearchParams: Ff,
  isTypedArray: Qf,
  isFileList: Yf,
  forEach: Zs,
  merge: Qi,
  extend: jf,
  trim: qf,
  stripBOM: Hf,
  inherits: Wf,
  toFlatObject: Zf,
  kindOf: ti,
  kindOfTest: ee,
  endsWith: Jf,
  toArray: Kf,
  forEachEntry: td,
  matchAll: ed,
  isHTMLForm: sd,
  hasOwnProperty: $o,
  hasOwnProp: $o,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: _h,
  freezeMethods: rd,
  toObjectSet: od,
  toCamelCase: nd,
  noop: ad,
  toFiniteNumber: hd,
  findKey: bh,
  global: Xe,
  isContextDefined: vh,
  isSpecCompliantForm: cd,
  toJSONObject: ld,
  isAsyncFn: ud,
  isThenable: fd,
  setImmediate: Sh,
  asap: dd
};
function U(n, t, e, s, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = n, this.name = "AxiosError", t && (this.code = t), e && (this.config = e), s && (this.request = s), i && (this.response = i, this.status = i.status ? i.status : null);
}
M.inherits(U, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: M.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Ch = U.prototype, Eh = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((n) => {
  Eh[n] = { value: n };
});
Object.defineProperties(U, Eh);
Object.defineProperty(Ch, "isAxiosError", { value: !0 });
U.from = (n, t, e, s, i, r) => {
  const o = Object.create(Ch);
  return M.toFlatObject(n, o, function(a) {
    return a !== Error.prototype;
  }, (a) => a !== "isAxiosError"), U.call(o, n.message, t, e, s, i), o.cause = n, o.name = n.name, r && Object.assign(o, r), o;
};
const md = null;
function tr(n) {
  return M.isPlainObject(n) || M.isArray(n);
}
function Ph(n) {
  return M.endsWith(n, "[]") ? n.slice(0, -2) : n;
}
function qo(n, t, e) {
  return n ? n.concat(t).map(function(s, i) {
    return s = Ph(s), !e && i ? "[" + s + "]" : s;
  }).join(e ? "." : "") : t;
}
function pd(n) {
  return M.isArray(n) && !n.some(tr);
}
const gd = M.toFlatObject(M, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function ni(n, t, e) {
  if (!M.isObject(n))
    throw new TypeError("target must be an object");
  t = t || new FormData(), e = M.toFlatObject(e, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(f, m) {
    return !M.isUndefined(m[f]);
  });
  const s = e.metaTokens, i = e.visitor || c, r = e.dots, o = e.indexes, a = (e.Blob || typeof Blob < "u" && Blob) && M.isSpecCompliantForm(t);
  if (!M.isFunction(i))
    throw new TypeError("visitor must be a function");
  function h(f) {
    if (f === null)
      return "";
    if (M.isDate(f))
      return f.toISOString();
    if (!a && M.isBlob(f))
      throw new U("Blob is not supported. Use a Buffer instead.");
    return M.isArrayBuffer(f) || M.isTypedArray(f) ? a && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function c(f, m, p) {
    let S = f;
    if (f && !p && typeof f == "object") {
      if (M.endsWith(m, "{}"))
        m = s ? m : m.slice(0, -2), f = JSON.stringify(f);
      else if (M.isArray(f) && pd(f) || (M.isFileList(f) || M.endsWith(m, "[]")) && (S = M.toArray(f)))
        return m = Ph(m), S.forEach(function(g, b) {
          !(M.isUndefined(g) || g === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? qo([m], b, r) : o === null ? m : m + "[]",
            h(g)
          );
        }), !1;
    }
    return tr(f) ? !0 : (t.append(qo(p, m, r), h(f)), !1);
  }
  const l = [], u = Object.assign(gd, {
    defaultVisitor: c,
    convertValue: h,
    isVisitable: tr
  });
  function d(f, m) {
    if (!M.isUndefined(f)) {
      if (l.indexOf(f) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      l.push(f), M.forEach(f, function(p, S) {
        (!(M.isUndefined(p) || p === null) && i.call(
          t,
          p,
          M.isString(S) ? S.trim() : S,
          m,
          u
        )) === !0 && d(p, m ? m.concat(S) : [S]);
      }), l.pop();
    }
  }
  if (!M.isObject(n))
    throw new TypeError("data must be an object");
  return d(n), t;
}
function jo(n) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(n).replace(/[!'()~]|%20|%00/g, function(e) {
    return t[e];
  });
}
function Xr(n, t) {
  this._pairs = [], n && ni(n, this, t);
}
const Th = Xr.prototype;
Th.append = function(n, t) {
  this._pairs.push([n, t]);
};
Th.toString = function(n) {
  const t = n ? function(e) {
    return n.call(this, e, jo);
  } : jo;
  return this._pairs.map(function(e) {
    return t(e[0]) + "=" + t(e[1]);
  }, "").join("&");
};
function yd(n) {
  return encodeURIComponent(n).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Mh(n, t, e) {
  if (!t)
    return n;
  const s = e && e.encode || yd;
  M.isFunction(e) && (e = {
    serialize: e
  });
  const i = e && e.serialize;
  let r;
  if (i ? r = i(t, e) : r = M.isURLSearchParams(t) ? t.toString() : new Xr(t, e).toString(s), r) {
    const o = n.indexOf("#");
    o !== -1 && (n = n.slice(0, o)), n += (n.indexOf("?") === -1 ? "?" : "&") + r;
  }
  return n;
}
class xd {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, e, s) {
    return this.handlers.push({
      fulfilled: t,
      rejected: e,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    M.forEach(this.handlers, function(e) {
      e !== null && t(e);
    });
  }
}
const Ho = xd, Ah = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, wd = typeof URLSearchParams < "u" ? URLSearchParams : Xr, bd = typeof FormData < "u" ? FormData : null, vd = typeof Blob < "u" ? Blob : null, _d = {
  isBrowser: !0,
  classes: {
    URLSearchParams: wd,
    FormData: bd,
    Blob: vd
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Fr = typeof window < "u" && typeof document < "u", er = typeof navigator == "object" && navigator || void 0, Sd = Fr && (!er || ["ReactNative", "NativeScript", "NS"].indexOf(er.product) < 0), Cd = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), Ed = Fr && window.location.href || "http://localhost", Pd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Fr,
  hasStandardBrowserEnv: Sd,
  hasStandardBrowserWebWorkerEnv: Cd,
  navigator: er,
  origin: Ed
}, Symbol.toStringTag, { value: "Module" })), St = {
  ...Pd,
  ..._d
};
function Td(n, t) {
  return ni(n, new St.classes.URLSearchParams(), Object.assign({
    visitor: function(e, s, i, r) {
      return St.isNode && M.isBuffer(e) ? (this.append(s, e.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Md(n) {
  return M.matchAll(/\w+|\[(\w*)]/g, n).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Ad(n) {
  const t = {}, e = Object.keys(n);
  let s;
  const i = e.length;
  let r;
  for (s = 0; s < i; s++)
    r = e[s], t[r] = n[r];
  return t;
}
function Ih(n) {
  function t(e, s, i, r) {
    let o = e[r++];
    if (o === "__proto__")
      return !0;
    const a = Number.isFinite(+o), h = r >= e.length;
    return o = !o && M.isArray(i) ? i.length : o, h ? (M.hasOwnProp(i, o) ? i[o] = [i[o], s] : i[o] = s, !a) : ((!i[o] || !M.isObject(i[o])) && (i[o] = []), t(e, s, i[o], r) && M.isArray(i[o]) && (i[o] = Ad(i[o])), !a);
  }
  if (M.isFormData(n) && M.isFunction(n.entries)) {
    const e = {};
    return M.forEachEntry(n, (s, i) => {
      t(Md(s), i, e, 0);
    }), e;
  }
  return null;
}
function Id(n, t, e) {
  if (M.isString(n))
    try {
      return (t || JSON.parse)(n), M.trim(n);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (e || JSON.stringify)(n);
}
const Ur = {
  transitional: Ah,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(n, t) {
    const e = t.getContentType() || "", s = e.indexOf("application/json") > -1, i = M.isObject(n);
    if (i && M.isHTMLForm(n) && (n = new FormData(n)), M.isFormData(n))
      return s ? JSON.stringify(Ih(n)) : n;
    if (M.isArrayBuffer(n) || M.isBuffer(n) || M.isStream(n) || M.isFile(n) || M.isBlob(n) || M.isReadableStream(n))
      return n;
    if (M.isArrayBufferView(n))
      return n.buffer;
    if (M.isURLSearchParams(n))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let r;
    if (i) {
      if (e.indexOf("application/x-www-form-urlencoded") > -1)
        return Td(n, this.formSerializer).toString();
      if ((r = M.isFileList(n)) || e.indexOf("multipart/form-data") > -1) {
        const o = this.env && this.env.FormData;
        return ni(
          r ? { "files[]": n } : n,
          o && new o(),
          this.formSerializer
        );
      }
    }
    return i || s ? (t.setContentType("application/json", !1), Id(n)) : n;
  }],
  transformResponse: [function(n) {
    const t = this.transitional || Ur.transitional, e = t && t.forcedJSONParsing, s = this.responseType === "json";
    if (M.isResponse(n) || M.isReadableStream(n))
      return n;
    if (n && M.isString(n) && (e && !this.responseType || s)) {
      const i = !(t && t.silentJSONParsing) && s;
      try {
        return JSON.parse(n);
      } catch (r) {
        if (i)
          throw r.name === "SyntaxError" ? U.from(r, U.ERR_BAD_RESPONSE, this, null, this.response) : r;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: St.classes.FormData,
    Blob: St.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
M.forEach(["delete", "get", "head", "post", "put", "patch"], (n) => {
  Ur.headers[n] = {};
});
const Gr = Ur, kd = M.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Dd = (n) => {
  const t = {};
  let e, s, i;
  return n && n.split(`
`).forEach(function(r) {
    i = r.indexOf(":"), e = r.substring(0, i).trim().toLowerCase(), s = r.substring(i + 1).trim(), !(!e || t[e] && kd[e]) && (e === "set-cookie" ? t[e] ? t[e].push(s) : t[e] = [s] : t[e] = t[e] ? t[e] + ", " + s : s);
  }), t;
}, Wo = Symbol("internals");
function vs(n) {
  return n && String(n).trim().toLowerCase();
}
function Ln(n) {
  return n === !1 || n == null ? n : M.isArray(n) ? n.map(Ln) : String(n);
}
function Ld(n) {
  const t = /* @__PURE__ */ Object.create(null), e = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = e.exec(n); )
    t[s[1]] = s[2];
  return t;
}
const Rd = (n) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(n.trim());
function Ti(n, t, e, s, i) {
  if (M.isFunction(s))
    return s.call(this, t, e);
  if (i && (t = e), !!M.isString(t)) {
    if (M.isString(s))
      return t.indexOf(s) !== -1;
    if (M.isRegExp(s))
      return s.test(t);
  }
}
function Od(n) {
  return n.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, e, s) => e.toUpperCase() + s);
}
function zd(n, t) {
  const e = M.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(n, s + e, {
      value: function(i, r, o) {
        return this[s].call(this, t, i, r, o);
      },
      configurable: !0
    });
  });
}
class ii {
  constructor(t) {
    t && this.set(t);
  }
  set(t, e, s) {
    const i = this;
    function r(a, h, c) {
      const l = vs(h);
      if (!l)
        throw new Error("header name must be a non-empty string");
      const u = M.findKey(i, l);
      (!u || i[u] === void 0 || c === !0 || c === void 0 && i[u] !== !1) && (i[u || h] = Ln(a));
    }
    const o = (a, h) => M.forEach(a, (c, l) => r(c, l, h));
    if (M.isPlainObject(t) || t instanceof this.constructor)
      o(t, e);
    else if (M.isString(t) && (t = t.trim()) && !Rd(t))
      o(Dd(t), e);
    else if (M.isHeaders(t))
      for (const [a, h] of t.entries())
        r(h, a, s);
    else
      t != null && r(e, t, s);
    return this;
  }
  get(t, e) {
    if (t = vs(t), t) {
      const s = M.findKey(this, t);
      if (s) {
        const i = this[s];
        if (!e)
          return i;
        if (e === !0)
          return Ld(i);
        if (M.isFunction(e))
          return e.call(this, i, s);
        if (M.isRegExp(e))
          return e.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, e) {
    if (t = vs(t), t) {
      const s = M.findKey(this, t);
      return !!(s && this[s] !== void 0 && (!e || Ti(this, this[s], s, e)));
    }
    return !1;
  }
  delete(t, e) {
    const s = this;
    let i = !1;
    function r(o) {
      if (o = vs(o), o) {
        const a = M.findKey(s, o);
        a && (!e || Ti(s, s[a], a, e)) && (delete s[a], i = !0);
      }
    }
    return M.isArray(t) ? t.forEach(r) : r(t), i;
  }
  clear(t) {
    const e = Object.keys(this);
    let s = e.length, i = !1;
    for (; s--; ) {
      const r = e[s];
      (!t || Ti(this, this[r], r, t, !0)) && (delete this[r], i = !0);
    }
    return i;
  }
  normalize(t) {
    const e = this, s = {};
    return M.forEach(this, (i, r) => {
      const o = M.findKey(s, r);
      if (o) {
        e[o] = Ln(i), delete e[r];
        return;
      }
      const a = t ? Od(r) : String(r).trim();
      a !== r && delete e[r], e[a] = Ln(i), s[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const e = /* @__PURE__ */ Object.create(null);
    return M.forEach(this, (s, i) => {
      s != null && s !== !1 && (e[i] = t && M.isArray(s) ? s.join(", ") : s);
    }), e;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, e]) => t + ": " + e).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...e) {
    const s = new this(t);
    return e.forEach((i) => s.set(i)), s;
  }
  static accessor(t) {
    const e = (this[Wo] = this[Wo] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(r) {
      const o = vs(r);
      e[o] || (zd(s, r), e[o] = !0);
    }
    return M.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
ii.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
M.reduceDescriptors(ii.prototype, ({ value: n }, t) => {
  let e = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => n,
    set(s) {
      this[e] = s;
    }
  };
});
M.freezeMethods(ii);
const te = ii;
function Mi(n, t) {
  const e = this || Gr, s = t || e, i = te.from(s.headers);
  let r = s.data;
  return M.forEach(n, function(o) {
    r = o.call(e, r, i.normalize(), t ? t.status : void 0);
  }), i.normalize(), r;
}
function kh(n) {
  return !!(n && n.__CANCEL__);
}
function ps(n, t, e) {
  U.call(this, n ?? "canceled", U.ERR_CANCELED, t, e), this.name = "CanceledError";
}
M.inherits(ps, U, {
  __CANCEL__: !0
});
function Dh(n, t, e) {
  const s = e.config.validateStatus;
  !e.status || !s || s(e.status) ? n(e) : t(new U(
    "Request failed with status code " + e.status,
    [U.ERR_BAD_REQUEST, U.ERR_BAD_RESPONSE][Math.floor(e.status / 100) - 4],
    e.config,
    e.request,
    e
  ));
}
function Nd(n) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(n);
  return t && t[1] || "";
}
function Yd(n, t) {
  n = n || 10;
  const e = new Array(n), s = new Array(n);
  let i = 0, r = 0, o;
  return t = t !== void 0 ? t : 1e3, function(a) {
    const h = Date.now(), c = s[r];
    o || (o = h), e[i] = a, s[i] = h;
    let l = r, u = 0;
    for (; l !== i; )
      u += e[l++], l = l % n;
    if (i = (i + 1) % n, i === r && (r = (r + 1) % n), h - o < t)
      return;
    const d = c && h - c;
    return d ? Math.round(u * 1e3 / d) : void 0;
  };
}
function Bd(n, t) {
  let e = 0, s = 1e3 / t, i, r;
  const o = (a, h = Date.now()) => {
    e = h, i = null, r && (clearTimeout(r), r = null), n.apply(null, a);
  };
  return [(...a) => {
    const h = Date.now(), c = h - e;
    c >= s ? o(a, h) : (i = a, r || (r = setTimeout(() => {
      r = null, o(i);
    }, s - c)));
  }, () => i && o(i)];
}
const Un = (n, t, e = 3) => {
  let s = 0;
  const i = Yd(50, 250);
  return Bd((r) => {
    const o = r.loaded, a = r.lengthComputable ? r.total : void 0, h = o - s, c = i(h), l = o <= a;
    s = o;
    const u = {
      loaded: o,
      total: a,
      progress: a ? o / a : void 0,
      bytes: h,
      rate: c || void 0,
      estimated: c && a && l ? (a - o) / c : void 0,
      event: r,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    n(u);
  }, e);
}, Zo = (n, t) => {
  const e = n != null;
  return [(s) => t[0]({
    lengthComputable: e,
    total: n,
    loaded: s
  }), t[1]];
}, Jo = (n) => (...t) => M.asap(() => n(...t)), Xd = St.hasStandardBrowserEnv ? ((n, t) => (e) => (e = new URL(e, St.origin), n.protocol === e.protocol && n.host === e.host && (t || n.port === e.port)))(
  new URL(St.origin),
  St.navigator && /(msie|trident)/i.test(St.navigator.userAgent)
) : () => !0, Fd = St.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(n, t, e, s, i, r) {
      const o = [n + "=" + encodeURIComponent(t)];
      M.isNumber(e) && o.push("expires=" + new Date(e).toGMTString()), M.isString(s) && o.push("path=" + s), M.isString(i) && o.push("domain=" + i), r === !0 && o.push("secure"), document.cookie = o.join("; ");
    },
    read(n) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(n) {
      this.write(n, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Ud(n) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(n);
}
function Gd(n, t) {
  return t ? n.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : n;
}
function Lh(n, t, e) {
  let s = !Ud(t);
  return n && (s || e == !1) ? Gd(n, t) : t;
}
const Ko = (n) => n instanceof te ? { ...n } : n;
function $e(n, t) {
  t = t || {};
  const e = {};
  function s(c, l, u, d) {
    return M.isPlainObject(c) && M.isPlainObject(l) ? M.merge.call({ caseless: d }, c, l) : M.isPlainObject(l) ? M.merge({}, l) : M.isArray(l) ? l.slice() : l;
  }
  function i(c, l, u, d) {
    if (M.isUndefined(l)) {
      if (!M.isUndefined(c))
        return s(void 0, c, u, d);
    } else
      return s(c, l, u, d);
  }
  function r(c, l) {
    if (!M.isUndefined(l))
      return s(void 0, l);
  }
  function o(c, l) {
    if (M.isUndefined(l)) {
      if (!M.isUndefined(c))
        return s(void 0, c);
    } else
      return s(void 0, l);
  }
  function a(c, l, u) {
    if (u in t)
      return s(c, l);
    if (u in n)
      return s(void 0, c);
  }
  const h = {
    url: r,
    method: r,
    data: r,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: a,
    headers: (c, l, u) => i(Ko(c), Ko(l), u, !0)
  };
  return M.forEach(Object.keys(Object.assign({}, n, t)), function(c) {
    const l = h[c] || i, u = l(n[c], t[c], c);
    M.isUndefined(u) && l !== a || (e[c] = u);
  }), e;
}
const Rh = (n) => {
  const t = $e({}, n);
  let { data: e, withXSRFToken: s, xsrfHeaderName: i, xsrfCookieName: r, headers: o, auth: a } = t;
  t.headers = o = te.from(o), t.url = Mh(Lh(t.baseURL, t.url, t.allowAbsoluteUrls), n.params, n.paramsSerializer), a && o.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let h;
  if (M.isFormData(e)) {
    if (St.hasStandardBrowserEnv || St.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if ((h = o.getContentType()) !== !1) {
      const [c, ...l] = h ? h.split(";").map((u) => u.trim()).filter(Boolean) : [];
      o.setContentType([c || "multipart/form-data", ...l].join("; "));
    }
  }
  if (St.hasStandardBrowserEnv && (s && M.isFunction(s) && (s = s(t)), s || s !== !1 && Xd(t.url))) {
    const c = i && r && Fd.read(r);
    c && o.set(i, c);
  }
  return t;
}, Vd = typeof XMLHttpRequest < "u", $d = Vd && function(n) {
  return new Promise(function(t, e) {
    const s = Rh(n);
    let i = s.data;
    const r = te.from(s.headers).normalize();
    let { responseType: o, onUploadProgress: a, onDownloadProgress: h } = s, c, l, u, d, f;
    function m() {
      d && d(), f && f(), s.cancelToken && s.cancelToken.unsubscribe(c), s.signal && s.signal.removeEventListener("abort", c);
    }
    let p = new XMLHttpRequest();
    p.open(s.method.toUpperCase(), s.url, !0), p.timeout = s.timeout;
    function S() {
      if (!p)
        return;
      const b = te.from(
        "getAllResponseHeaders" in p && p.getAllResponseHeaders()
      ), x = {
        data: !o || o === "text" || o === "json" ? p.responseText : p.response,
        status: p.status,
        statusText: p.statusText,
        headers: b,
        config: n,
        request: p
      };
      Dh(function(w) {
        t(w), m();
      }, function(w) {
        e(w), m();
      }, x), p = null;
    }
    "onloadend" in p ? p.onloadend = S : p.onreadystatechange = function() {
      !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(S);
    }, p.onabort = function() {
      p && (e(new U("Request aborted", U.ECONNABORTED, n, p)), p = null);
    }, p.onerror = function() {
      e(new U("Network Error", U.ERR_NETWORK, n, p)), p = null;
    }, p.ontimeout = function() {
      let b = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const x = s.transitional || Ah;
      s.timeoutErrorMessage && (b = s.timeoutErrorMessage), e(new U(
        b,
        x.clarifyTimeoutError ? U.ETIMEDOUT : U.ECONNABORTED,
        n,
        p
      )), p = null;
    }, i === void 0 && r.setContentType(null), "setRequestHeader" in p && M.forEach(r.toJSON(), function(b, x) {
      p.setRequestHeader(x, b);
    }), M.isUndefined(s.withCredentials) || (p.withCredentials = !!s.withCredentials), o && o !== "json" && (p.responseType = s.responseType), h && ([u, f] = Un(h, !0), p.addEventListener("progress", u)), a && p.upload && ([l, d] = Un(a), p.upload.addEventListener("progress", l), p.upload.addEventListener("loadend", d)), (s.cancelToken || s.signal) && (c = (b) => {
      p && (e(!b || b.type ? new ps(null, n, p) : b), p.abort(), p = null);
    }, s.cancelToken && s.cancelToken.subscribe(c), s.signal && (s.signal.aborted ? c() : s.signal.addEventListener("abort", c)));
    const g = Nd(s.url);
    if (g && St.protocols.indexOf(g) === -1) {
      e(new U("Unsupported protocol " + g + ":", U.ERR_BAD_REQUEST, n));
      return;
    }
    p.send(i || null);
  });
}, qd = (n, t) => {
  const { length: e } = n = n ? n.filter(Boolean) : [];
  if (t || e) {
    let s = new AbortController(), i;
    const r = function(c) {
      if (!i) {
        i = !0, a();
        const l = c instanceof Error ? c : this.reason;
        s.abort(l instanceof U ? l : new ps(l instanceof Error ? l.message : l));
      }
    };
    let o = t && setTimeout(() => {
      o = null, r(new U(`timeout ${t} of ms exceeded`, U.ETIMEDOUT));
    }, t);
    const a = () => {
      n && (o && clearTimeout(o), o = null, n.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(r) : c.removeEventListener("abort", r);
      }), n = null);
    };
    n.forEach((c) => c.addEventListener("abort", r));
    const { signal: h } = s;
    return h.unsubscribe = () => M.asap(a), h;
  }
}, jd = qd, Hd = function* (n, t) {
  let e = n.byteLength;
  if (!t || e < t) {
    yield n;
    return;
  }
  let s = 0, i;
  for (; s < e; )
    i = s + t, yield n.slice(s, i), s = i;
}, Wd = async function* (n, t) {
  for await (const e of Zd(n))
    yield* Hd(e, t);
}, Zd = async function* (n) {
  if (n[Symbol.asyncIterator]) {
    yield* n;
    return;
  }
  const t = n.getReader();
  try {
    for (; ; ) {
      const { done: e, value: s } = await t.read();
      if (e)
        break;
      yield s;
    }
  } finally {
    await t.cancel();
  }
}, Qo = (n, t, e, s) => {
  const i = Wd(n, t);
  let r = 0, o, a = (h) => {
    o || (o = !0, s && s(h));
  };
  return new ReadableStream({
    async pull(h) {
      try {
        const { done: c, value: l } = await i.next();
        if (c) {
          a(), h.close();
          return;
        }
        let u = l.byteLength;
        if (e) {
          let d = r += u;
          e(d);
        }
        h.enqueue(new Uint8Array(l));
      } catch (c) {
        throw a(c), c;
      }
    },
    cancel(h) {
      return a(h), i.return();
    }
  }, {
    highWaterMark: 2
  });
}, ri = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Oh = ri && typeof ReadableStream == "function", Jd = ri && (typeof TextEncoder == "function" ? ((n) => (t) => n.encode(t))(new TextEncoder()) : async (n) => new Uint8Array(await new Response(n).arrayBuffer())), zh = (n, ...t) => {
  try {
    return !!n(...t);
  } catch {
    return !1;
  }
}, Kd = Oh && zh(() => {
  let n = !1;
  const t = new Request(St.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return n = !0, "half";
    }
  }).headers.has("Content-Type");
  return n && !t;
}), ta = 64 * 1024, sr = Oh && zh(() => M.isReadableStream(new Response("").body)), Gn = {
  stream: sr && ((n) => n.body)
};
ri && ((n) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Gn[t] && (Gn[t] = M.isFunction(n[t]) ? (e) => e[t]() : (e, s) => {
      throw new U(`Response type '${t}' is not supported`, U.ERR_NOT_SUPPORT, s);
    });
  });
})(new Response());
const Qd = async (n) => {
  if (n == null)
    return 0;
  if (M.isBlob(n))
    return n.size;
  if (M.isSpecCompliantForm(n))
    return (await new Request(St.origin, {
      method: "POST",
      body: n
    }).arrayBuffer()).byteLength;
  if (M.isArrayBufferView(n) || M.isArrayBuffer(n))
    return n.byteLength;
  if (M.isURLSearchParams(n) && (n = n + ""), M.isString(n))
    return (await Jd(n)).byteLength;
}, tm = async (n, t) => M.toFiniteNumber(n.getContentLength()) ?? Qd(t), em = ri && (async (n) => {
  let {
    url: t,
    method: e,
    data: s,
    signal: i,
    cancelToken: r,
    timeout: o,
    onDownloadProgress: a,
    onUploadProgress: h,
    responseType: c,
    headers: l,
    withCredentials: u = "same-origin",
    fetchOptions: d
  } = Rh(n);
  c = c ? (c + "").toLowerCase() : "text";
  let f = jd([i, r && r.toAbortSignal()], o), m;
  const p = f && f.unsubscribe && (() => {
    f.unsubscribe();
  });
  let S;
  try {
    if (h && Kd && e !== "get" && e !== "head" && (S = await tm(l, s)) !== 0) {
      let C = new Request(t, {
        method: "POST",
        body: s,
        duplex: "half"
      }), _;
      if (M.isFormData(s) && (_ = C.headers.get("content-type")) && l.setContentType(_), C.body) {
        const [D, z] = Zo(
          S,
          Un(Jo(h))
        );
        s = Qo(C.body, ta, D, z);
      }
    }
    M.isString(u) || (u = u ? "include" : "omit");
    const g = "credentials" in Request.prototype;
    m = new Request(t, {
      ...d,
      signal: f,
      method: e.toUpperCase(),
      headers: l.normalize().toJSON(),
      body: s,
      duplex: "half",
      credentials: g ? u : void 0
    });
    let b = await fetch(m);
    const x = sr && (c === "stream" || c === "response");
    if (sr && (a || x && p)) {
      const C = {};
      ["status", "statusText", "headers"].forEach((B) => {
        C[B] = b[B];
      });
      const _ = M.toFiniteNumber(b.headers.get("content-length")), [D, z] = a && Zo(
        _,
        Un(Jo(a), !0)
      ) || [];
      b = new Response(
        Qo(b.body, ta, D, () => {
          z && z(), p && p();
        }),
        C
      );
    }
    c = c || "text";
    let w = await Gn[M.findKey(Gn, c) || "text"](b, n);
    return !x && p && p(), await new Promise((C, _) => {
      Dh(C, _, {
        data: w,
        headers: te.from(b.headers),
        status: b.status,
        statusText: b.statusText,
        config: n,
        request: m
      });
    });
  } catch (g) {
    throw p && p(), g && g.name === "TypeError" && /fetch/i.test(g.message) ? Object.assign(
      new U("Network Error", U.ERR_NETWORK, n, m),
      {
        cause: g.cause || g
      }
    ) : U.from(g, g && g.code, n, m);
  }
}), nr = {
  http: md,
  xhr: $d,
  fetch: em
};
M.forEach(nr, (n, t) => {
  if (n) {
    try {
      Object.defineProperty(n, "name", { value: t });
    } catch {
    }
    Object.defineProperty(n, "adapterName", { value: t });
  }
});
const ea = (n) => `- ${n}`, sm = (n) => M.isFunction(n) || n === null || n === !1, Nh = {
  getAdapter: (n) => {
    n = M.isArray(n) ? n : [n];
    const { length: t } = n;
    let e, s;
    const i = {};
    for (let r = 0; r < t; r++) {
      e = n[r];
      let o;
      if (s = e, !sm(e) && (s = nr[(o = String(e)).toLowerCase()], s === void 0))
        throw new U(`Unknown adapter '${o}'`);
      if (s)
        break;
      i[o || "#" + r] = s;
    }
    if (!s) {
      const r = Object.entries(i).map(
        ([a, h]) => `adapter ${a} ` + (h === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let o = t ? r.length > 1 ? `since :
` + r.map(ea).join(`
`) : " " + ea(r[0]) : "as no adapter specified";
      throw new U(
        "There is no suitable adapter to dispatch the request " + o,
        "ERR_NOT_SUPPORT"
      );
    }
    return s;
  },
  adapters: nr
};
function Ai(n) {
  if (n.cancelToken && n.cancelToken.throwIfRequested(), n.signal && n.signal.aborted)
    throw new ps(null, n);
}
function sa(n) {
  return Ai(n), n.headers = te.from(n.headers), n.data = Mi.call(
    n,
    n.transformRequest
  ), ["post", "put", "patch"].indexOf(n.method) !== -1 && n.headers.setContentType("application/x-www-form-urlencoded", !1), Nh.getAdapter(n.adapter || Gr.adapter)(n).then(function(t) {
    return Ai(n), t.data = Mi.call(
      n,
      n.transformResponse,
      t
    ), t.headers = te.from(t.headers), t;
  }, function(t) {
    return kh(t) || (Ai(n), t && t.response && (t.response.data = Mi.call(
      n,
      n.transformResponse,
      t.response
    ), t.response.headers = te.from(t.response.headers))), Promise.reject(t);
  });
}
const Yh = "1.8.4", oi = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((n, t) => {
  oi[n] = function(e) {
    return typeof e === n || "a" + (t < 1 ? "n " : " ") + n;
  };
});
const na = {};
oi.transitional = function(n, t, e) {
  function s(i, r) {
    return "[Axios v" + Yh + "] Transitional option '" + i + "'" + r + (e ? ". " + e : "");
  }
  return (i, r, o) => {
    if (n === !1)
      throw new U(
        s(r, " has been removed" + (t ? " in " + t : "")),
        U.ERR_DEPRECATED
      );
    return t && !na[r] && (na[r] = !0, console.warn(
      s(
        r,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), n ? n(i, r, o) : !0;
  };
};
oi.spelling = function(n) {
  return (t, e) => (console.warn(`${e} is likely a misspelling of ${n}`), !0);
};
function nm(n, t, e) {
  if (typeof n != "object")
    throw new U("options must be an object", U.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(n);
  let i = s.length;
  for (; i-- > 0; ) {
    const r = s[i], o = t[r];
    if (o) {
      const a = n[r], h = a === void 0 || o(a, r, n);
      if (h !== !0)
        throw new U("option " + r + " must be " + h, U.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (e !== !0)
      throw new U("Unknown option " + r, U.ERR_BAD_OPTION);
  }
}
const Rn = {
  assertOptions: nm,
  validators: oi
}, re = Rn.validators;
class Vn {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Ho(),
      response: new Ho()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, e) {
    try {
      return await this._request(t, e);
    } catch (s) {
      if (s instanceof Error) {
        let i = {};
        Error.captureStackTrace ? Error.captureStackTrace(i) : i = new Error();
        const r = i.stack ? i.stack.replace(/^.+\n/, "") : "";
        try {
          s.stack ? r && !String(s.stack).endsWith(r.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + r) : s.stack = r;
        } catch {
        }
      }
      throw s;
    }
  }
  _request(t, e) {
    typeof t == "string" ? (e = e || {}, e.url = t) : e = t || {}, e = $e(this.defaults, e);
    const { transitional: s, paramsSerializer: i, headers: r } = e;
    s !== void 0 && Rn.assertOptions(s, {
      silentJSONParsing: re.transitional(re.boolean),
      forcedJSONParsing: re.transitional(re.boolean),
      clarifyTimeoutError: re.transitional(re.boolean)
    }, !1), i != null && (M.isFunction(i) ? e.paramsSerializer = {
      serialize: i
    } : Rn.assertOptions(i, {
      encode: re.function,
      serialize: re.function
    }, !0)), e.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? e.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : e.allowAbsoluteUrls = !0), Rn.assertOptions(e, {
      baseUrl: re.spelling("baseURL"),
      withXsrfToken: re.spelling("withXSRFToken")
    }, !0), e.method = (e.method || this.defaults.method || "get").toLowerCase();
    let o = r && M.merge(
      r.common,
      r[e.method]
    );
    r && M.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete r[m];
      }
    ), e.headers = te.concat(o, r);
    const a = [];
    let h = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(e) === !1 || (h = h && m.synchronous, a.unshift(m.fulfilled, m.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(m) {
      c.push(m.fulfilled, m.rejected);
    });
    let l, u = 0, d;
    if (!h) {
      const m = [sa.bind(this), void 0];
      for (m.unshift.apply(m, a), m.push.apply(m, c), d = m.length, l = Promise.resolve(e); u < d; )
        l = l.then(m[u++], m[u++]);
      return l;
    }
    d = a.length;
    let f = e;
    for (u = 0; u < d; ) {
      const m = a[u++], p = a[u++];
      try {
        f = m(f);
      } catch (S) {
        p.call(this, S);
        break;
      }
    }
    try {
      l = sa.call(this, f);
    } catch (m) {
      return Promise.reject(m);
    }
    for (u = 0, d = c.length; u < d; )
      l = l.then(c[u++], c[u++]);
    return l;
  }
  getUri(t) {
    t = $e(this.defaults, t);
    const e = Lh(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Mh(e, t.params, t.paramsSerializer);
  }
}
M.forEach(["delete", "get", "head", "options"], function(n) {
  Vn.prototype[n] = function(t, e) {
    return this.request($e(e || {}, {
      method: n,
      url: t,
      data: (e || {}).data
    }));
  };
});
M.forEach(["post", "put", "patch"], function(n) {
  function t(e) {
    return function(s, i, r) {
      return this.request($e(r || {}, {
        method: n,
        headers: e ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: i
      }));
    };
  }
  Vn.prototype[n] = t(), Vn.prototype[n + "Form"] = t(!0);
});
const On = Vn;
class Vr {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let e;
    this.promise = new Promise(function(i) {
      e = i;
    });
    const s = this;
    this.promise.then((i) => {
      if (!s._listeners)
        return;
      let r = s._listeners.length;
      for (; r-- > 0; )
        s._listeners[r](i);
      s._listeners = null;
    }), this.promise.then = (i) => {
      let r;
      const o = new Promise((a) => {
        s.subscribe(a), r = a;
      }).then(i);
      return o.cancel = function() {
        s.unsubscribe(r);
      }, o;
    }, t(function(i, r, o) {
      s.reason || (s.reason = new ps(i, r, o), e(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const e = this._listeners.indexOf(t);
    e !== -1 && this._listeners.splice(e, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), e = (s) => {
      t.abort(s);
    };
    return this.subscribe(e), t.signal.unsubscribe = () => this.unsubscribe(e), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Vr(function(e) {
        t = e;
      }),
      cancel: t
    };
  }
}
const im = Vr;
function rm(n) {
  return function(t) {
    return n.apply(null, t);
  };
}
function om(n) {
  return M.isObject(n) && n.isAxiosError === !0;
}
const ir = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(ir).forEach(([n, t]) => {
  ir[t] = n;
});
const am = ir;
function Bh(n) {
  const t = new On(n), e = yh(On.prototype.request, t);
  return M.extend(e, On.prototype, t, { allOwnKeys: !0 }), M.extend(e, t, null, { allOwnKeys: !0 }), e.create = function(s) {
    return Bh($e(n, s));
  }, e;
}
const ht = Bh(Gr);
ht.Axios = On;
ht.CanceledError = ps;
ht.CancelToken = im;
ht.isCancel = kh;
ht.VERSION = Yh;
ht.toFormData = ni;
ht.AxiosError = U;
ht.Cancel = ht.CanceledError;
ht.all = function(n) {
  return Promise.all(n);
};
ht.spread = rm;
ht.isAxiosError = om;
ht.mergeConfig = $e;
ht.AxiosHeaders = te;
ht.formToJSON = (n) => Ih(M.isHTMLForm(n) ? new FormData(n) : n);
ht.getAdapter = Nh.getAdapter;
ht.HttpStatusCode = am;
ht.default = ht;
const hm = ht;
class Xh {
  instance;
  canceler;
  retryCount = 0;
  cacheTime = 0;
  caches = new Ws();
  constructor(t) {
    this.instance = hm.create(t), this.canceler = new cm(), this.retryCount = t?.retry || 0, this.cacheTime = t?.cache || 0, this.instance.interceptors.request.use(
      (e) => (t?.interceptor?.start?.(), this.canceler.pendingRequest(e), t?.interceptor?.request?.(e), e),
      (e) => (t?.interceptor?.end?.(), this.canceler.cancelRequest(e.config), t?.interceptor?.requestError?.(e), Promise.reject(e))
    ), this.instance.interceptors.response.use(
      (e) => (t?.interceptor?.end?.(), this.canceler.confirmRequest(e.config), t?.interceptor?.response?.(e), e.status == 200 ? Promise.resolve(e) : Promise.reject(e)),
      (e) => (t?.interceptor?.end?.(), this.canceler.cancelRequest(e.config), t?.interceptor?.responseError?.(e), Promise.reject(e.response))
    );
  }
  // @CacheDecorator(60)
  // @RetryDecorator(3)
  request(t) {
    let e = this.instance.request;
    const s = t.retry || this.retryCount;
    s && (e = Lr(e, s));
    const i = t.cache || this.cacheTime;
    return i && (e = Rr(e, i, this.caches)), e(t);
  }
  // this.request() 请求后未返回前，可取消请求
  cancel(t) {
    this.canceler.cancelRequest(t);
  }
  get(t, e) {
    return this.request({ ...e, method: "get", url: t });
  }
  delete(t, e) {
    return this.request({ ...e, method: "delete", url: t });
  }
  head(t, e) {
    return this.request({ ...e, method: "head", url: t });
  }
  options(t, e) {
    return this.request({ ...e, method: "options", url: t });
  }
  post(t, e, s) {
    return this.request({ ...s, method: "post", url: t, data: e });
  }
  postBlob(t, e, s) {
    return s = {
      ...s,
      headers: {
        ...s?.headers,
        "Content-Type": "multipart/form-data"
      }
    }, this.request({ ...s, method: "post", url: t, data: e });
  }
  // UNDO : application/octet-stream
  postForm(t, e, s) {
    return this.instance.postForm(t, e, { ...s });
  }
  put(t, e, s) {
    return this.request({ ...s, method: "put", url: t, data: e });
  }
  patch(t, e, s) {
    return this.request({ ...s, method: "patch", url: t, data: e });
  }
  getUri(t) {
    return this.instance.getUri(t);
  }
}
class cm {
  pendingRequestMap;
  constructor() {
    this.pendingRequestMap = /* @__PURE__ */ new Map();
  }
  getRequestId(t) {
    const { method: e, url: s, params: i, data: r } = t;
    return Ar({ method: e, url: s, params: i, data: r });
  }
  pendingRequest(t) {
    const e = this.getRequestId(t);
    if (this.pendingRequestMap.has(e))
      t.signal = this.pendingRequestMap.get(e)?.signal;
    else {
      const s = new AbortController();
      t.signal = s.signal, this.pendingRequestMap.set(e, s);
    }
  }
  confirmRequest(t) {
    if (this.pendingRequestMap.size === 0)
      return;
    const e = this.getRequestId(t);
    this.pendingRequestMap.has(e) && this.pendingRequestMap.delete(e);
  }
  cancelRequest(t) {
    if (this.pendingRequestMap.size === 0)
      return;
    const e = this.getRequestId(t);
    this.pendingRequestMap.has(e) && (this.pendingRequestMap.get(e)?.abort(), this.pendingRequestMap.delete(e));
  }
  cancelAllRequest() {
    const t = this.pendingRequestMap.values();
    for (const e of t)
      e.abort();
    this.pendingRequestMap.clear();
  }
}
function Fh(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Uh = { exports: {} };
(function(n, t) {
  (function(e) {
    n.exports = e();
  })(function(e) {
    var s = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
    function i(g, b) {
      var x = g[0], w = g[1], C = g[2], _ = g[3];
      x += (w & C | ~w & _) + b[0] - 680876936 | 0, x = (x << 7 | x >>> 25) + w | 0, _ += (x & w | ~x & C) + b[1] - 389564586 | 0, _ = (_ << 12 | _ >>> 20) + x | 0, C += (_ & x | ~_ & w) + b[2] + 606105819 | 0, C = (C << 17 | C >>> 15) + _ | 0, w += (C & _ | ~C & x) + b[3] - 1044525330 | 0, w = (w << 22 | w >>> 10) + C | 0, x += (w & C | ~w & _) + b[4] - 176418897 | 0, x = (x << 7 | x >>> 25) + w | 0, _ += (x & w | ~x & C) + b[5] + 1200080426 | 0, _ = (_ << 12 | _ >>> 20) + x | 0, C += (_ & x | ~_ & w) + b[6] - 1473231341 | 0, C = (C << 17 | C >>> 15) + _ | 0, w += (C & _ | ~C & x) + b[7] - 45705983 | 0, w = (w << 22 | w >>> 10) + C | 0, x += (w & C | ~w & _) + b[8] + 1770035416 | 0, x = (x << 7 | x >>> 25) + w | 0, _ += (x & w | ~x & C) + b[9] - 1958414417 | 0, _ = (_ << 12 | _ >>> 20) + x | 0, C += (_ & x | ~_ & w) + b[10] - 42063 | 0, C = (C << 17 | C >>> 15) + _ | 0, w += (C & _ | ~C & x) + b[11] - 1990404162 | 0, w = (w << 22 | w >>> 10) + C | 0, x += (w & C | ~w & _) + b[12] + 1804603682 | 0, x = (x << 7 | x >>> 25) + w | 0, _ += (x & w | ~x & C) + b[13] - 40341101 | 0, _ = (_ << 12 | _ >>> 20) + x | 0, C += (_ & x | ~_ & w) + b[14] - 1502002290 | 0, C = (C << 17 | C >>> 15) + _ | 0, w += (C & _ | ~C & x) + b[15] + 1236535329 | 0, w = (w << 22 | w >>> 10) + C | 0, x += (w & _ | C & ~_) + b[1] - 165796510 | 0, x = (x << 5 | x >>> 27) + w | 0, _ += (x & C | w & ~C) + b[6] - 1069501632 | 0, _ = (_ << 9 | _ >>> 23) + x | 0, C += (_ & w | x & ~w) + b[11] + 643717713 | 0, C = (C << 14 | C >>> 18) + _ | 0, w += (C & x | _ & ~x) + b[0] - 373897302 | 0, w = (w << 20 | w >>> 12) + C | 0, x += (w & _ | C & ~_) + b[5] - 701558691 | 0, x = (x << 5 | x >>> 27) + w | 0, _ += (x & C | w & ~C) + b[10] + 38016083 | 0, _ = (_ << 9 | _ >>> 23) + x | 0, C += (_ & w | x & ~w) + b[15] - 660478335 | 0, C = (C << 14 | C >>> 18) + _ | 0, w += (C & x | _ & ~x) + b[4] - 405537848 | 0, w = (w << 20 | w >>> 12) + C | 0, x += (w & _ | C & ~_) + b[9] + 568446438 | 0, x = (x << 5 | x >>> 27) + w | 0, _ += (x & C | w & ~C) + b[14] - 1019803690 | 0, _ = (_ << 9 | _ >>> 23) + x | 0, C += (_ & w | x & ~w) + b[3] - 187363961 | 0, C = (C << 14 | C >>> 18) + _ | 0, w += (C & x | _ & ~x) + b[8] + 1163531501 | 0, w = (w << 20 | w >>> 12) + C | 0, x += (w & _ | C & ~_) + b[13] - 1444681467 | 0, x = (x << 5 | x >>> 27) + w | 0, _ += (x & C | w & ~C) + b[2] - 51403784 | 0, _ = (_ << 9 | _ >>> 23) + x | 0, C += (_ & w | x & ~w) + b[7] + 1735328473 | 0, C = (C << 14 | C >>> 18) + _ | 0, w += (C & x | _ & ~x) + b[12] - 1926607734 | 0, w = (w << 20 | w >>> 12) + C | 0, x += (w ^ C ^ _) + b[5] - 378558 | 0, x = (x << 4 | x >>> 28) + w | 0, _ += (x ^ w ^ C) + b[8] - 2022574463 | 0, _ = (_ << 11 | _ >>> 21) + x | 0, C += (_ ^ x ^ w) + b[11] + 1839030562 | 0, C = (C << 16 | C >>> 16) + _ | 0, w += (C ^ _ ^ x) + b[14] - 35309556 | 0, w = (w << 23 | w >>> 9) + C | 0, x += (w ^ C ^ _) + b[1] - 1530992060 | 0, x = (x << 4 | x >>> 28) + w | 0, _ += (x ^ w ^ C) + b[4] + 1272893353 | 0, _ = (_ << 11 | _ >>> 21) + x | 0, C += (_ ^ x ^ w) + b[7] - 155497632 | 0, C = (C << 16 | C >>> 16) + _ | 0, w += (C ^ _ ^ x) + b[10] - 1094730640 | 0, w = (w << 23 | w >>> 9) + C | 0, x += (w ^ C ^ _) + b[13] + 681279174 | 0, x = (x << 4 | x >>> 28) + w | 0, _ += (x ^ w ^ C) + b[0] - 358537222 | 0, _ = (_ << 11 | _ >>> 21) + x | 0, C += (_ ^ x ^ w) + b[3] - 722521979 | 0, C = (C << 16 | C >>> 16) + _ | 0, w += (C ^ _ ^ x) + b[6] + 76029189 | 0, w = (w << 23 | w >>> 9) + C | 0, x += (w ^ C ^ _) + b[9] - 640364487 | 0, x = (x << 4 | x >>> 28) + w | 0, _ += (x ^ w ^ C) + b[12] - 421815835 | 0, _ = (_ << 11 | _ >>> 21) + x | 0, C += (_ ^ x ^ w) + b[15] + 530742520 | 0, C = (C << 16 | C >>> 16) + _ | 0, w += (C ^ _ ^ x) + b[2] - 995338651 | 0, w = (w << 23 | w >>> 9) + C | 0, x += (C ^ (w | ~_)) + b[0] - 198630844 | 0, x = (x << 6 | x >>> 26) + w | 0, _ += (w ^ (x | ~C)) + b[7] + 1126891415 | 0, _ = (_ << 10 | _ >>> 22) + x | 0, C += (x ^ (_ | ~w)) + b[14] - 1416354905 | 0, C = (C << 15 | C >>> 17) + _ | 0, w += (_ ^ (C | ~x)) + b[5] - 57434055 | 0, w = (w << 21 | w >>> 11) + C | 0, x += (C ^ (w | ~_)) + b[12] + 1700485571 | 0, x = (x << 6 | x >>> 26) + w | 0, _ += (w ^ (x | ~C)) + b[3] - 1894986606 | 0, _ = (_ << 10 | _ >>> 22) + x | 0, C += (x ^ (_ | ~w)) + b[10] - 1051523 | 0, C = (C << 15 | C >>> 17) + _ | 0, w += (_ ^ (C | ~x)) + b[1] - 2054922799 | 0, w = (w << 21 | w >>> 11) + C | 0, x += (C ^ (w | ~_)) + b[8] + 1873313359 | 0, x = (x << 6 | x >>> 26) + w | 0, _ += (w ^ (x | ~C)) + b[15] - 30611744 | 0, _ = (_ << 10 | _ >>> 22) + x | 0, C += (x ^ (_ | ~w)) + b[6] - 1560198380 | 0, C = (C << 15 | C >>> 17) + _ | 0, w += (_ ^ (C | ~x)) + b[13] + 1309151649 | 0, w = (w << 21 | w >>> 11) + C | 0, x += (C ^ (w | ~_)) + b[4] - 145523070 | 0, x = (x << 6 | x >>> 26) + w | 0, _ += (w ^ (x | ~C)) + b[11] - 1120210379 | 0, _ = (_ << 10 | _ >>> 22) + x | 0, C += (x ^ (_ | ~w)) + b[2] + 718787259 | 0, C = (C << 15 | C >>> 17) + _ | 0, w += (_ ^ (C | ~x)) + b[9] - 343485551 | 0, w = (w << 21 | w >>> 11) + C | 0, g[0] = x + g[0] | 0, g[1] = w + g[1] | 0, g[2] = C + g[2] | 0, g[3] = _ + g[3] | 0;
    }
    function r(g) {
      var b = [], x;
      for (x = 0; x < 64; x += 4)
        b[x >> 2] = g.charCodeAt(x) + (g.charCodeAt(x + 1) << 8) + (g.charCodeAt(x + 2) << 16) + (g.charCodeAt(x + 3) << 24);
      return b;
    }
    function o(g) {
      var b = [], x;
      for (x = 0; x < 64; x += 4)
        b[x >> 2] = g[x] + (g[x + 1] << 8) + (g[x + 2] << 16) + (g[x + 3] << 24);
      return b;
    }
    function a(g) {
      var b = g.length, x = [1732584193, -271733879, -1732584194, 271733878], w, C, _, D, z, B;
      for (w = 64; w <= b; w += 64)
        i(x, r(g.substring(w - 64, w)));
      for (g = g.substring(w - 64), C = g.length, _ = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], w = 0; w < C; w += 1)
        _[w >> 2] |= g.charCodeAt(w) << (w % 4 << 3);
      if (_[w >> 2] |= 128 << (w % 4 << 3), w > 55)
        for (i(x, _), w = 0; w < 16; w += 1)
          _[w] = 0;
      return D = b * 8, D = D.toString(16).match(/(.*?)(.{0,8})$/), z = parseInt(D[2], 16), B = parseInt(D[1], 16) || 0, _[14] = z, _[15] = B, i(x, _), x;
    }
    function h(g) {
      var b = g.length, x = [1732584193, -271733879, -1732584194, 271733878], w, C, _, D, z, B;
      for (w = 64; w <= b; w += 64)
        i(x, o(g.subarray(w - 64, w)));
      for (g = w - 64 < b ? g.subarray(w - 64) : new Uint8Array(0), C = g.length, _ = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], w = 0; w < C; w += 1)
        _[w >> 2] |= g[w] << (w % 4 << 3);
      if (_[w >> 2] |= 128 << (w % 4 << 3), w > 55)
        for (i(x, _), w = 0; w < 16; w += 1)
          _[w] = 0;
      return D = b * 8, D = D.toString(16).match(/(.*?)(.{0,8})$/), z = parseInt(D[2], 16), B = parseInt(D[1], 16) || 0, _[14] = z, _[15] = B, i(x, _), x;
    }
    function c(g) {
      var b = "", x;
      for (x = 0; x < 4; x += 1)
        b += s[g >> x * 8 + 4 & 15] + s[g >> x * 8 & 15];
      return b;
    }
    function l(g) {
      var b;
      for (b = 0; b < g.length; b += 1)
        g[b] = c(g[b]);
      return g.join("");
    }
    l(a("hello")), typeof ArrayBuffer < "u" && !ArrayBuffer.prototype.slice && function() {
      function g(b, x) {
        return b = b | 0 || 0, b < 0 ? Math.max(b + x, 0) : Math.min(b, x);
      }
      ArrayBuffer.prototype.slice = function(b, x) {
        var w = this.byteLength, C = g(b, w), _ = w, D, z, B, G;
        return x !== e && (_ = g(x, w)), C > _ ? new ArrayBuffer(0) : (D = _ - C, z = new ArrayBuffer(D), B = new Uint8Array(z), G = new Uint8Array(this, C, D), B.set(G), z);
      };
    }();
    function u(g) {
      return /[\u0080-\uFFFF]/.test(g) && (g = unescape(encodeURIComponent(g))), g;
    }
    function d(g, b) {
      var x = g.length, w = new ArrayBuffer(x), C = new Uint8Array(w), _;
      for (_ = 0; _ < x; _ += 1)
        C[_] = g.charCodeAt(_);
      return b ? C : w;
    }
    function f(g) {
      return String.fromCharCode.apply(null, new Uint8Array(g));
    }
    function m(g, b, x) {
      var w = new Uint8Array(g.byteLength + b.byteLength);
      return w.set(new Uint8Array(g)), w.set(new Uint8Array(b), g.byteLength), x ? w : w.buffer;
    }
    function p(g) {
      var b = [], x = g.length, w;
      for (w = 0; w < x - 1; w += 2)
        b.push(parseInt(g.substr(w, 2), 16));
      return String.fromCharCode.apply(String, b);
    }
    function S() {
      this.reset();
    }
    return S.prototype.append = function(g) {
      return this.appendBinary(u(g)), this;
    }, S.prototype.appendBinary = function(g) {
      this._buff += g, this._length += g.length;
      var b = this._buff.length, x;
      for (x = 64; x <= b; x += 64)
        i(this._hash, r(this._buff.substring(x - 64, x)));
      return this._buff = this._buff.substring(x - 64), this;
    }, S.prototype.end = function(g) {
      var b = this._buff, x = b.length, w, C = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], _;
      for (w = 0; w < x; w += 1)
        C[w >> 2] |= b.charCodeAt(w) << (w % 4 << 3);
      return this._finish(C, x), _ = l(this._hash), g && (_ = p(_)), this.reset(), _;
    }, S.prototype.reset = function() {
      return this._buff = "", this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
    }, S.prototype.getState = function() {
      return {
        buff: this._buff,
        length: this._length,
        hash: this._hash.slice()
      };
    }, S.prototype.setState = function(g) {
      return this._buff = g.buff, this._length = g.length, this._hash = g.hash, this;
    }, S.prototype.destroy = function() {
      delete this._hash, delete this._buff, delete this._length;
    }, S.prototype._finish = function(g, b) {
      var x = b, w, C, _;
      if (g[x >> 2] |= 128 << (x % 4 << 3), x > 55)
        for (i(this._hash, g), x = 0; x < 16; x += 1)
          g[x] = 0;
      w = this._length * 8, w = w.toString(16).match(/(.*?)(.{0,8})$/), C = parseInt(w[2], 16), _ = parseInt(w[1], 16) || 0, g[14] = C, g[15] = _, i(this._hash, g);
    }, S.hash = function(g, b) {
      return S.hashBinary(u(g), b);
    }, S.hashBinary = function(g, b) {
      var x = a(g), w = l(x);
      return b ? p(w) : w;
    }, S.ArrayBuffer = function() {
      this.reset();
    }, S.ArrayBuffer.prototype.append = function(g) {
      var b = m(this._buff.buffer, g, !0), x = b.length, w;
      for (this._length += g.byteLength, w = 64; w <= x; w += 64)
        i(this._hash, o(b.subarray(w - 64, w)));
      return this._buff = w - 64 < x ? new Uint8Array(b.buffer.slice(w - 64)) : new Uint8Array(0), this;
    }, S.ArrayBuffer.prototype.end = function(g) {
      var b = this._buff, x = b.length, w = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], C, _;
      for (C = 0; C < x; C += 1)
        w[C >> 2] |= b[C] << (C % 4 << 3);
      return this._finish(w, x), _ = l(this._hash), g && (_ = p(_)), this.reset(), _;
    }, S.ArrayBuffer.prototype.reset = function() {
      return this._buff = new Uint8Array(0), this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
    }, S.ArrayBuffer.prototype.getState = function() {
      var g = S.prototype.getState.call(this);
      return g.buff = f(g.buff), g;
    }, S.ArrayBuffer.prototype.setState = function(g) {
      return g.buff = d(g.buff, !0), S.prototype.setState.call(this, g);
    }, S.ArrayBuffer.prototype.destroy = S.prototype.destroy, S.ArrayBuffer.prototype._finish = S.prototype._finish, S.ArrayBuffer.hash = function(g, b) {
      var x = h(new Uint8Array(g)), w = l(x);
      return b ? p(w) : w;
    }, S;
  });
})(Uh);
var lm = Uh.exports;
const um = /* @__PURE__ */ Fh(lm), Zg = Ju && window.File && window.FileReader && window.FileList && window.Blob;
function Jg(n = 'script[type="text/js-worker"]') {
  return Array.prototype.map.call(
    document.querySelectorAll(n),
    (t) => t.textContent
  );
}
const Gh = (n) => new XMLSerializer().serializeToString(n), Kg = (n, t = "text/html") => new DOMParser().parseFromString(n, t), Vh = (n, t = {
  mime: Mt.SVG,
  encode: Bn.utf8
  // utf-8 base64
}) => Dr(Gh(n), t);
async function $h(n = ["*"], t) {
  let e = [];
  const s = document.createElement("input");
  return s.setAttribute("type", "file"), s.setAttribute("visibility", "hidden"), s.setAttribute("accept", n.join(",")), t && s.setAttribute("multiple", "true"), s.addEventListener(
    "click",
    (i) => {
      s.value = "";
    },
    !1
  ), new Promise((i, r) => {
    s.addEventListener(
      "change",
      (o) => {
        e = Array.from(o.target.files || []), e.length === 0 ? r(new Error("Cancel")) : i(e);
      },
      !1
    ), window.addEventListener(
      "focus",
      () => {
        setTimeout(() => {
          e.length === 0 && r(new Error("Cancel"));
        }, 1e3);
      },
      { once: !0 }
    ), s.click();
  }).then((i) => (s.remove(), i)).catch((i) => {
    throw s.remove(), i;
  });
}
function ai(n, t = Ut.text, e) {
  return new Promise((s, i) => {
    const r = new FileReader();
    switch (r.addEventListener("progress", (o) => {
      e?.(o.loaded, o.total);
    }), r.addEventListener("load", (o) => {
      s(o.target?.result);
    }), r.addEventListener("error", (o) => {
      i(o);
    }), t) {
      case Ut.dataURL:
        r.readAsDataURL(n);
        break;
      case Ut.binaryString:
        r.readAsBinaryString(n);
        break;
      case Ut.arraybuffer:
        r.readAsArrayBuffer(n);
        break;
      case Ut.text:
      default:
        r.readAsText(n);
    }
  });
}
async function Qg(n) {
  const t = await ai(
    n,
    Ut.arraybuffer
  );
  return Qu(t);
}
const ty = (n) => {
  let t;
  return n instanceof File ? t = n.name : t = n, t.match(/\.([0-9a-z]+)(?:[\\?#]|$)/i)?.[1] || "";
};
function ey(n) {
  switch (n.toLowerCase()) {
    case "jpg":
    case "jpeg":
      return Mt.JPEG;
    case "gif":
      return Mt.GIF;
    case "svg":
      return Mt.SVG;
    case "pdf":
      return Mt.PDF;
    case "png":
    default:
      return Mt.PNG;
  }
}
function qh(n, t, e, s, i, r, o) {
  const a = new FileReader();
  a.addEventListener("load", (h) => {
    if (!h.target || !h.target.result)
      return t(h);
    if (e.append(h.target.result), o < s.size)
      qh(
        n,
        t,
        e,
        s,
        i,
        o,
        Math.min(o + i, s.size)
      );
    else
      return n(e.end());
  }), a.addEventListener("error", (h) => t(h)), a.readAsArrayBuffer(s.slice(r, o));
}
async function fm(n, t = 1 * 1024 * 1024) {
  return await new Promise(
    (e, s) => qh(
      e,
      s,
      new um.ArrayBuffer(),
      n,
      t,
      0,
      Math.min(t, n.size)
    )
  );
}
class sy {
  axios;
  // 获取服务器端 文件 MD5 hash 地址
  checkURL;
  // 文件上传地址
  uploadURL;
  // 要上传的文件
  file;
  // 本地文件 MD5 hash
  fileHash;
  // 文件切割块大小
  chunkSize;
  // 文件总切割数量
  chunks;
  // 当前块数
  currentChunk = 0;
  // 是否正在上传
  isUploading = !1;
  begin = 0;
  end = 0;
  timer;
  time = [0, 0, 0, 0, 0, 0];
  onExist;
  onStart;
  onProgress;
  onComplete;
  onTime;
  constructor(t) {
    this.axios = new Xh({
      baseURL: t.baseURL,
      interceptor: {
        response: (e) => {
          e.config.url == this.uploadURL && e.status == 200 && (this.onProgress?.(this.currentChunk++, this.chunks), this.end == this.file.size ? (this.isUploading = !1, this.stopTimeCount(), this.onComplete?.()) : this.isUploading && this.uploadChunk());
        }
      }
    }), this.checkURL = t.checkURL, this.uploadURL = t.uploadURL, this.file = t.file, this.chunkSize = t.chunkSize || 1 * 1024 * 1024, this.chunks = Math.ceil(this.file.size / this.chunkSize), this.onExist = t.onExist, this.onStart = t.onStart, this.onProgress = t.onProgress, this.onComplete = t.onComplete, this.onTime = t.onTime;
  }
  async start() {
    this.fileHash || (this.fileHash = await fm(this.file, this.chunkSize)), (await this.axios.post(this.checkURL, {
      fileName: this.file.name,
      fileHash: this.fileHash
    })).data.isExist ? (this.isUploading = !1, this.onExist?.()) : this.isUploading || (this.onStart?.(), this.startTimeCount(), await this.uploadChunk());
  }
  pause() {
    this.isUploading && (this.isUploading = !1, this.stopTimeCount());
  }
  async uploadChunk() {
    this.isUploading = !0, this.begin = this.currentChunk * this.chunkSize, this.end = Math.min(this.begin + this.chunkSize, this.file.size);
    const t = this.file.slice(this.begin, this.end), e = new FormData();
    e.append("fileData", t), e.append("fileName", this.file.name), e.append("fileHash", this.fileHash), e.append("chunkIndex", String(this.currentChunk)), e.append("chunks", String(this.chunks)), await this.axios.postBlob(this.uploadURL, e);
  }
  startTimeCount() {
    this.stopTimeCount(), this.timer = setInterval(() => {
      Wu(this.time, 1), this.onTime?.(qu(this.time));
    }, 1e3);
  }
  stopTimeCount() {
    this.timer && (clearInterval(this.timer), this.timer = void 0);
  }
}
var jh = { exports: {} };
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(n) {
  (function(t, e, s, i) {
    var r = ["", "webkit", "Moz", "MS", "ms", "o"], o = e.createElement("div"), a = "function", h = Math.round, c = Math.abs, l = Date.now;
    function u(y, v, E) {
      return setTimeout(x(y, E), v);
    }
    function d(y, v, E) {
      return Array.isArray(y) ? (f(y, E[v], E), !0) : !1;
    }
    function f(y, v, E) {
      var P;
      if (y)
        if (y.forEach)
          y.forEach(v, E);
        else if (y.length !== i)
          for (P = 0; P < y.length; )
            v.call(E, y[P], P, y), P++;
        else
          for (P in y)
            y.hasOwnProperty(P) && v.call(E, y[P], P, y);
    }
    function m(y, v, E) {
      var P = "DEPRECATED METHOD: " + v + `
` + E + ` AT 
`;
      return function() {
        var I = new Error("get-stack-trace"), R = I && I.stack ? I.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace", $ = t.console && (t.console.warn || t.console.log);
        return $ && $.call(t.console, P, R), y.apply(this, arguments);
      };
    }
    var p;
    typeof Object.assign != "function" ? p = function(v) {
      if (v === i || v === null)
        throw new TypeError("Cannot convert undefined or null to object");
      for (var E = Object(v), P = 1; P < arguments.length; P++) {
        var I = arguments[P];
        if (I !== i && I !== null)
          for (var R in I)
            I.hasOwnProperty(R) && (E[R] = I[R]);
      }
      return E;
    } : p = Object.assign;
    var S = m(function(v, E, P) {
      for (var I = Object.keys(E), R = 0; R < I.length; )
        (!P || P && v[I[R]] === i) && (v[I[R]] = E[I[R]]), R++;
      return v;
    }, "extend", "Use `assign`."), g = m(function(v, E) {
      return S(v, E, !0);
    }, "merge", "Use `assign`.");
    function b(y, v, E) {
      var P = v.prototype, I;
      I = y.prototype = Object.create(P), I.constructor = y, I._super = P, E && p(I, E);
    }
    function x(y, v) {
      return function() {
        return y.apply(v, arguments);
      };
    }
    function w(y, v) {
      return typeof y == a ? y.apply(v && v[0] || i, v) : y;
    }
    function C(y, v) {
      return y === i ? v : y;
    }
    function _(y, v, E) {
      f(G(v), function(P) {
        y.addEventListener(P, E, !1);
      });
    }
    function D(y, v, E) {
      f(G(v), function(P) {
        y.removeEventListener(P, E, !1);
      });
    }
    function z(y, v) {
      for (; y; ) {
        if (y == v)
          return !0;
        y = y.parentNode;
      }
      return !1;
    }
    function B(y, v) {
      return y.indexOf(v) > -1;
    }
    function G(y) {
      return y.trim().split(/\s+/g);
    }
    function V(y, v, E) {
      if (y.indexOf && !E)
        return y.indexOf(v);
      for (var P = 0; P < y.length; ) {
        if (E && y[P][E] == v || !E && y[P] === v)
          return P;
        P++;
      }
      return -1;
    }
    function j(y) {
      return Array.prototype.slice.call(y, 0);
    }
    function et(y, v, E) {
      for (var P = [], I = [], R = 0; R < y.length; ) {
        var $ = v ? y[R][v] : y[R];
        V(I, $) < 0 && P.push(y[R]), I[R] = $, R++;
      }
      return E && (v ? P = P.sort(function(yt, Et) {
        return yt[v] > Et[v];
      }) : P = P.sort()), P;
    }
    function J(y, v) {
      for (var E, P, I = v[0].toUpperCase() + v.slice(1), R = 0; R < r.length; ) {
        if (E = r[R], P = E ? E + I : v, P in y)
          return P;
        R++;
      }
      return i;
    }
    var Ht = 1;
    function Dt() {
      return Ht++;
    }
    function Yt(y) {
      var v = y.ownerDocument || y;
      return v.defaultView || v.parentWindow || t;
    }
    var Wt = /mobile|tablet|ip(ad|hone|od)|android/i, L = "ontouchstart" in t, k = J(t, "PointerEvent") !== i, F = L && Wt.test(navigator.userAgent), H = "touch", Ct = "pen", Zt = "mouse", rn = "kinect", on = 25, ut = 1, se = 2, st = 4, bt = 8, Qe = 1, Re = 2, Oe = 4, be = 8, A = 16, ot = Re | Oe, ze = be | A, fo = ot | ze, mo = ["x", "y"], an = ["clientX", "clientY"];
    function Bt(y, v) {
      var E = this;
      this.manager = y, this.callback = v, this.element = y.element, this.target = y.options.inputTarget, this.domHandler = function(P) {
        w(y.options.enable, [y]) && E.handler(P);
      }, this.init();
    }
    Bt.prototype = {
      /**
       * should handle the inputEvent data and trigger the callback
       * @virtual
       */
      handler: function() {
      },
      /**
       * bind the events
       */
      init: function() {
        this.evEl && _(this.element, this.evEl, this.domHandler), this.evTarget && _(this.target, this.evTarget, this.domHandler), this.evWin && _(Yt(this.element), this.evWin, this.domHandler);
      },
      /**
       * unbind the events
       */
      destroy: function() {
        this.evEl && D(this.element, this.evEl, this.domHandler), this.evTarget && D(this.target, this.evTarget, this.domHandler), this.evWin && D(Yt(this.element), this.evWin, this.domHandler);
      }
    };
    function Bl(y) {
      var v, E = y.options.inputClass;
      return E ? v = E : k ? v = pi : F ? v = ln : L ? v = gi : v = cn, new v(y, Xl);
    }
    function Xl(y, v, E) {
      var P = E.pointers.length, I = E.changedPointers.length, R = v & ut && P - I === 0, $ = v & (st | bt) && P - I === 0;
      E.isFirst = !!R, E.isFinal = !!$, R && (y.session = {}), E.eventType = v, Fl(y, E), y.emit("hammer.input", E), y.recognize(E), y.session.prevInput = E;
    }
    function Fl(y, v) {
      var E = y.session, P = v.pointers, I = P.length;
      E.firstInput || (E.firstInput = po(v)), I > 1 && !E.firstMultiple ? E.firstMultiple = po(v) : I === 1 && (E.firstMultiple = !1);
      var R = E.firstInput, $ = E.firstMultiple, ft = $ ? $.center : R.center, yt = v.center = go(P);
      v.timeStamp = l(), v.deltaTime = v.timeStamp - R.timeStamp, v.angle = mi(ft, yt), v.distance = hn(ft, yt), Ul(E, v), v.offsetDirection = xo(v.deltaX, v.deltaY);
      var Et = yo(v.deltaTime, v.deltaX, v.deltaY);
      v.overallVelocityX = Et.x, v.overallVelocityY = Et.y, v.overallVelocity = c(Et.x) > c(Et.y) ? Et.x : Et.y, v.scale = $ ? $l($.pointers, P) : 1, v.rotation = $ ? Vl($.pointers, P) : 0, v.maxPointers = E.prevInput ? v.pointers.length > E.prevInput.maxPointers ? v.pointers.length : E.prevInput.maxPointers : v.pointers.length, Gl(E, v);
      var ie = y.element;
      z(v.srcEvent.target, ie) && (ie = v.srcEvent.target), v.target = ie;
    }
    function Ul(y, v) {
      var E = v.center, P = y.offsetDelta || {}, I = y.prevDelta || {}, R = y.prevInput || {};
      (v.eventType === ut || R.eventType === st) && (I = y.prevDelta = {
        x: R.deltaX || 0,
        y: R.deltaY || 0
      }, P = y.offsetDelta = {
        x: E.x,
        y: E.y
      }), v.deltaX = I.x + (E.x - P.x), v.deltaY = I.y + (E.y - P.y);
    }
    function Gl(y, v) {
      var E = y.lastInterval || v, P = v.timeStamp - E.timeStamp, I, R, $, ft;
      if (v.eventType != bt && (P > on || E.velocity === i)) {
        var yt = v.deltaX - E.deltaX, Et = v.deltaY - E.deltaY, ie = yo(P, yt, Et);
        R = ie.x, $ = ie.y, I = c(ie.x) > c(ie.y) ? ie.x : ie.y, ft = xo(yt, Et), y.lastInterval = v;
      } else
        I = E.velocity, R = E.velocityX, $ = E.velocityY, ft = E.direction;
      v.velocity = I, v.velocityX = R, v.velocityY = $, v.direction = ft;
    }
    function po(y) {
      for (var v = [], E = 0; E < y.pointers.length; )
        v[E] = {
          clientX: h(y.pointers[E].clientX),
          clientY: h(y.pointers[E].clientY)
        }, E++;
      return {
        timeStamp: l(),
        pointers: v,
        center: go(v),
        deltaX: y.deltaX,
        deltaY: y.deltaY
      };
    }
    function go(y) {
      var v = y.length;
      if (v === 1)
        return {
          x: h(y[0].clientX),
          y: h(y[0].clientY)
        };
      for (var E = 0, P = 0, I = 0; I < v; )
        E += y[I].clientX, P += y[I].clientY, I++;
      return {
        x: h(E / v),
        y: h(P / v)
      };
    }
    function yo(y, v, E) {
      return {
        x: v / y || 0,
        y: E / y || 0
      };
    }
    function xo(y, v) {
      return y === v ? Qe : c(y) >= c(v) ? y < 0 ? Re : Oe : v < 0 ? be : A;
    }
    function hn(y, v, E) {
      E || (E = mo);
      var P = v[E[0]] - y[E[0]], I = v[E[1]] - y[E[1]];
      return Math.sqrt(P * P + I * I);
    }
    function mi(y, v, E) {
      E || (E = mo);
      var P = v[E[0]] - y[E[0]], I = v[E[1]] - y[E[1]];
      return Math.atan2(I, P) * 180 / Math.PI;
    }
    function Vl(y, v) {
      return mi(v[1], v[0], an) + mi(y[1], y[0], an);
    }
    function $l(y, v) {
      return hn(v[0], v[1], an) / hn(y[0], y[1], an);
    }
    var ql = {
      mousedown: ut,
      mousemove: se,
      mouseup: st
    }, jl = "mousedown", Hl = "mousemove mouseup";
    function cn() {
      this.evEl = jl, this.evWin = Hl, this.pressed = !1, Bt.apply(this, arguments);
    }
    b(cn, Bt, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(v) {
        var E = ql[v.type];
        E & ut && v.button === 0 && (this.pressed = !0), E & se && v.which !== 1 && (E = st), this.pressed && (E & st && (this.pressed = !1), this.callback(this.manager, E, {
          pointers: [v],
          changedPointers: [v],
          pointerType: Zt,
          srcEvent: v
        }));
      }
    });
    var Wl = {
      pointerdown: ut,
      pointermove: se,
      pointerup: st,
      pointercancel: bt,
      pointerout: bt
    }, Zl = {
      2: H,
      3: Ct,
      4: Zt,
      5: rn
      // see https://twitter.com/jacobrossi/status/480596438489890816
    }, wo = "pointerdown", bo = "pointermove pointerup pointercancel";
    t.MSPointerEvent && !t.PointerEvent && (wo = "MSPointerDown", bo = "MSPointerMove MSPointerUp MSPointerCancel");
    function pi() {
      this.evEl = wo, this.evWin = bo, Bt.apply(this, arguments), this.store = this.manager.session.pointerEvents = [];
    }
    b(pi, Bt, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(v) {
        var E = this.store, P = !1, I = v.type.toLowerCase().replace("ms", ""), R = Wl[I], $ = Zl[v.pointerType] || v.pointerType, ft = $ == H, yt = V(E, v.pointerId, "pointerId");
        R & ut && (v.button === 0 || ft) ? yt < 0 && (E.push(v), yt = E.length - 1) : R & (st | bt) && (P = !0), !(yt < 0) && (E[yt] = v, this.callback(this.manager, R, {
          pointers: E,
          changedPointers: [v],
          pointerType: $,
          srcEvent: v
        }), P && E.splice(yt, 1));
      }
    });
    var Jl = {
      touchstart: ut,
      touchmove: se,
      touchend: st,
      touchcancel: bt
    }, Kl = "touchstart", Ql = "touchstart touchmove touchend touchcancel";
    function vo() {
      this.evTarget = Kl, this.evWin = Ql, this.started = !1, Bt.apply(this, arguments);
    }
    b(vo, Bt, {
      handler: function(v) {
        var E = Jl[v.type];
        if (E === ut && (this.started = !0), !!this.started) {
          var P = tu.call(this, v, E);
          E & (st | bt) && P[0].length - P[1].length === 0 && (this.started = !1), this.callback(this.manager, E, {
            pointers: P[0],
            changedPointers: P[1],
            pointerType: H,
            srcEvent: v
          });
        }
      }
    });
    function tu(y, v) {
      var E = j(y.touches), P = j(y.changedTouches);
      return v & (st | bt) && (E = et(E.concat(P), "identifier", !0)), [E, P];
    }
    var eu = {
      touchstart: ut,
      touchmove: se,
      touchend: st,
      touchcancel: bt
    }, su = "touchstart touchmove touchend touchcancel";
    function ln() {
      this.evTarget = su, this.targetIds = {}, Bt.apply(this, arguments);
    }
    b(ln, Bt, {
      handler: function(v) {
        var E = eu[v.type], P = nu.call(this, v, E);
        P && this.callback(this.manager, E, {
          pointers: P[0],
          changedPointers: P[1],
          pointerType: H,
          srcEvent: v
        });
      }
    });
    function nu(y, v) {
      var E = j(y.touches), P = this.targetIds;
      if (v & (ut | se) && E.length === 1)
        return P[E[0].identifier] = !0, [E, E];
      var I, R, $ = j(y.changedTouches), ft = [], yt = this.target;
      if (R = E.filter(function(Et) {
        return z(Et.target, yt);
      }), v === ut)
        for (I = 0; I < R.length; )
          P[R[I].identifier] = !0, I++;
      for (I = 0; I < $.length; )
        P[$[I].identifier] && ft.push($[I]), v & (st | bt) && delete P[$[I].identifier], I++;
      if (ft.length)
        return [
          // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
          et(R.concat(ft), "identifier", !0),
          ft
        ];
    }
    var iu = 2500, _o = 25;
    function gi() {
      Bt.apply(this, arguments);
      var y = x(this.handler, this);
      this.touch = new ln(this.manager, y), this.mouse = new cn(this.manager, y), this.primaryTouch = null, this.lastTouches = [];
    }
    b(gi, Bt, {
      /**
       * handle mouse and touch events
       * @param {Hammer} manager
       * @param {String} inputEvent
       * @param {Object} inputData
       */
      handler: function(v, E, P) {
        var I = P.pointerType == H, R = P.pointerType == Zt;
        if (!(R && P.sourceCapabilities && P.sourceCapabilities.firesTouchEvents)) {
          if (I)
            ru.call(this, E, P);
          else if (R && ou.call(this, P))
            return;
          this.callback(v, E, P);
        }
      },
      /**
       * remove the event listeners
       */
      destroy: function() {
        this.touch.destroy(), this.mouse.destroy();
      }
    });
    function ru(y, v) {
      y & ut ? (this.primaryTouch = v.changedPointers[0].identifier, So.call(this, v)) : y & (st | bt) && So.call(this, v);
    }
    function So(y) {
      var v = y.changedPointers[0];
      if (v.identifier === this.primaryTouch) {
        var E = { x: v.clientX, y: v.clientY };
        this.lastTouches.push(E);
        var P = this.lastTouches, I = function() {
          var R = P.indexOf(E);
          R > -1 && P.splice(R, 1);
        };
        setTimeout(I, iu);
      }
    }
    function ou(y) {
      for (var v = y.srcEvent.clientX, E = y.srcEvent.clientY, P = 0; P < this.lastTouches.length; P++) {
        var I = this.lastTouches[P], R = Math.abs(v - I.x), $ = Math.abs(E - I.y);
        if (R <= _o && $ <= _o)
          return !0;
      }
      return !1;
    }
    var Co = J(o.style, "touchAction"), Eo = Co !== i, Po = "compute", To = "auto", yi = "manipulation", Ne = "none", xs = "pan-x", ws = "pan-y", un = hu();
    function xi(y, v) {
      this.manager = y, this.set(v);
    }
    xi.prototype = {
      /**
       * set the touchAction value on the element or enable the polyfill
       * @param {String} value
       */
      set: function(y) {
        y == Po && (y = this.compute()), Eo && this.manager.element.style && un[y] && (this.manager.element.style[Co] = y), this.actions = y.toLowerCase().trim();
      },
      /**
       * just re-set the touchAction value
       */
      update: function() {
        this.set(this.manager.options.touchAction);
      },
      /**
       * compute the value for the touchAction property based on the recognizer's settings
       * @returns {String} value
       */
      compute: function() {
        var y = [];
        return f(this.manager.recognizers, function(v) {
          w(v.options.enable, [v]) && (y = y.concat(v.getTouchAction()));
        }), au(y.join(" "));
      },
      /**
       * this method is called on each input cycle and provides the preventing of the browser behavior
       * @param {Object} input
       */
      preventDefaults: function(y) {
        var v = y.srcEvent, E = y.offsetDirection;
        if (this.manager.session.prevented) {
          v.preventDefault();
          return;
        }
        var P = this.actions, I = B(P, Ne) && !un[Ne], R = B(P, ws) && !un[ws], $ = B(P, xs) && !un[xs];
        if (I) {
          var ft = y.pointers.length === 1, yt = y.distance < 2, Et = y.deltaTime < 250;
          if (ft && yt && Et)
            return;
        }
        if (!($ && R) && (I || R && E & ot || $ && E & ze))
          return this.preventSrc(v);
      },
      /**
       * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
       * @param {Object} srcEvent
       */
      preventSrc: function(y) {
        this.manager.session.prevented = !0, y.preventDefault();
      }
    };
    function au(y) {
      if (B(y, Ne))
        return Ne;
      var v = B(y, xs), E = B(y, ws);
      return v && E ? Ne : v || E ? v ? xs : ws : B(y, yi) ? yi : To;
    }
    function hu() {
      if (!Eo)
        return !1;
      var y = {}, v = t.CSS && t.CSS.supports;
      return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(E) {
        y[E] = v ? t.CSS.supports("touch-action", E) : !0;
      }), y;
    }
    var fn = 1, Xt = 2, ts = 4, ve = 8, ce = ve, bs = 16, ne = 32;
    function le(y) {
      this.options = p({}, this.defaults, y || {}), this.id = Dt(), this.manager = null, this.options.enable = C(this.options.enable, !0), this.state = fn, this.simultaneous = {}, this.requireFail = [];
    }
    le.prototype = {
      /**
       * @virtual
       * @type {Object}
       */
      defaults: {},
      /**
       * set options
       * @param {Object} options
       * @return {Recognizer}
       */
      set: function(y) {
        return p(this.options, y), this.manager && this.manager.touchAction.update(), this;
      },
      /**
       * recognize simultaneous with an other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      recognizeWith: function(y) {
        if (d(y, "recognizeWith", this))
          return this;
        var v = this.simultaneous;
        return y = dn(y, this), v[y.id] || (v[y.id] = y, y.recognizeWith(this)), this;
      },
      /**
       * drop the simultaneous link. it doesnt remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRecognizeWith: function(y) {
        return d(y, "dropRecognizeWith", this) ? this : (y = dn(y, this), delete this.simultaneous[y.id], this);
      },
      /**
       * recognizer can only run when an other is failing
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      requireFailure: function(y) {
        if (d(y, "requireFailure", this))
          return this;
        var v = this.requireFail;
        return y = dn(y, this), V(v, y) === -1 && (v.push(y), y.requireFailure(this)), this;
      },
      /**
       * drop the requireFailure link. it does not remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRequireFailure: function(y) {
        if (d(y, "dropRequireFailure", this))
          return this;
        y = dn(y, this);
        var v = V(this.requireFail, y);
        return v > -1 && this.requireFail.splice(v, 1), this;
      },
      /**
       * has require failures boolean
       * @returns {boolean}
       */
      hasRequireFailures: function() {
        return this.requireFail.length > 0;
      },
      /**
       * if the recognizer can recognize simultaneous with an other recognizer
       * @param {Recognizer} otherRecognizer
       * @returns {Boolean}
       */
      canRecognizeWith: function(y) {
        return !!this.simultaneous[y.id];
      },
      /**
       * You should use `tryEmit` instead of `emit` directly to check
       * that all the needed recognizers has failed before emitting.
       * @param {Object} input
       */
      emit: function(y) {
        var v = this, E = this.state;
        function P(I) {
          v.manager.emit(I, y);
        }
        E < ve && P(v.options.event + Mo(E)), P(v.options.event), y.additionalEvent && P(y.additionalEvent), E >= ve && P(v.options.event + Mo(E));
      },
      /**
       * Check that all the require failure recognizers has failed,
       * if true, it emits a gesture event,
       * otherwise, setup the state to FAILED.
       * @param {Object} input
       */
      tryEmit: function(y) {
        if (this.canEmit())
          return this.emit(y);
        this.state = ne;
      },
      /**
       * can we emit?
       * @returns {boolean}
       */
      canEmit: function() {
        for (var y = 0; y < this.requireFail.length; ) {
          if (!(this.requireFail[y].state & (ne | fn)))
            return !1;
          y++;
        }
        return !0;
      },
      /**
       * update the recognizer
       * @param {Object} inputData
       */
      recognize: function(y) {
        var v = p({}, y);
        if (!w(this.options.enable, [this, v])) {
          this.reset(), this.state = ne;
          return;
        }
        this.state & (ce | bs | ne) && (this.state = fn), this.state = this.process(v), this.state & (Xt | ts | ve | bs) && this.tryEmit(v);
      },
      /**
       * return the state of the recognizer
       * the actual recognizing happens in this method
       * @virtual
       * @param {Object} inputData
       * @returns {Const} STATE
       */
      process: function(y) {
      },
      // jshint ignore:line
      /**
       * return the preferred touch-action
       * @virtual
       * @returns {Array}
       */
      getTouchAction: function() {
      },
      /**
       * called when the gesture isn't allowed to recognize
       * like when another is being recognized or it is disabled
       * @virtual
       */
      reset: function() {
      }
    };
    function Mo(y) {
      return y & bs ? "cancel" : y & ve ? "end" : y & ts ? "move" : y & Xt ? "start" : "";
    }
    function Ao(y) {
      return y == A ? "down" : y == be ? "up" : y == Re ? "left" : y == Oe ? "right" : "";
    }
    function dn(y, v) {
      var E = v.manager;
      return E ? E.get(y) : y;
    }
    function Jt() {
      le.apply(this, arguments);
    }
    b(Jt, le, {
      /**
       * @namespace
       * @memberof AttrRecognizer
       */
      defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
      },
      /**
       * Used to check if it the recognizer receives valid input, like input.distance > 10.
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {Boolean} recognized
       */
      attrTest: function(y) {
        var v = this.options.pointers;
        return v === 0 || y.pointers.length === v;
      },
      /**
       * Process the input and return the state for the recognizer
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {*} State
       */
      process: function(y) {
        var v = this.state, E = y.eventType, P = v & (Xt | ts), I = this.attrTest(y);
        return P && (E & bt || !I) ? v | bs : P || I ? E & st ? v | ve : v & Xt ? v | ts : Xt : ne;
      }
    });
    function mn() {
      Jt.apply(this, arguments), this.pX = null, this.pY = null;
    }
    b(mn, Jt, {
      /**
       * @namespace
       * @memberof PanRecognizer
       */
      defaults: {
        event: "pan",
        threshold: 10,
        pointers: 1,
        direction: fo
      },
      getTouchAction: function() {
        var y = this.options.direction, v = [];
        return y & ot && v.push(ws), y & ze && v.push(xs), v;
      },
      directionTest: function(y) {
        var v = this.options, E = !0, P = y.distance, I = y.direction, R = y.deltaX, $ = y.deltaY;
        return I & v.direction || (v.direction & ot ? (I = R === 0 ? Qe : R < 0 ? Re : Oe, E = R != this.pX, P = Math.abs(y.deltaX)) : (I = $ === 0 ? Qe : $ < 0 ? be : A, E = $ != this.pY, P = Math.abs(y.deltaY))), y.direction = I, E && P > v.threshold && I & v.direction;
      },
      attrTest: function(y) {
        return Jt.prototype.attrTest.call(this, y) && (this.state & Xt || !(this.state & Xt) && this.directionTest(y));
      },
      emit: function(y) {
        this.pX = y.deltaX, this.pY = y.deltaY;
        var v = Ao(y.direction);
        v && (y.additionalEvent = this.options.event + v), this._super.emit.call(this, y);
      }
    });
    function wi() {
      Jt.apply(this, arguments);
    }
    b(wi, Jt, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "pinch",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [Ne];
      },
      attrTest: function(y) {
        return this._super.attrTest.call(this, y) && (Math.abs(y.scale - 1) > this.options.threshold || this.state & Xt);
      },
      emit: function(y) {
        if (y.scale !== 1) {
          var v = y.scale < 1 ? "in" : "out";
          y.additionalEvent = this.options.event + v;
        }
        this._super.emit.call(this, y);
      }
    });
    function bi() {
      le.apply(this, arguments), this._timer = null, this._input = null;
    }
    b(bi, le, {
      /**
       * @namespace
       * @memberof PressRecognizer
       */
      defaults: {
        event: "press",
        pointers: 1,
        time: 251,
        // minimal time of the pointer to be pressed
        threshold: 9
        // a minimal movement is ok, but keep it low
      },
      getTouchAction: function() {
        return [To];
      },
      process: function(y) {
        var v = this.options, E = y.pointers.length === v.pointers, P = y.distance < v.threshold, I = y.deltaTime > v.time;
        if (this._input = y, !P || !E || y.eventType & (st | bt) && !I)
          this.reset();
        else if (y.eventType & ut)
          this.reset(), this._timer = u(function() {
            this.state = ce, this.tryEmit();
          }, v.time, this);
        else if (y.eventType & st)
          return ce;
        return ne;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function(y) {
        this.state === ce && (y && y.eventType & st ? this.manager.emit(this.options.event + "up", y) : (this._input.timeStamp = l(), this.manager.emit(this.options.event, this._input)));
      }
    });
    function vi() {
      Jt.apply(this, arguments);
    }
    b(vi, Jt, {
      /**
       * @namespace
       * @memberof RotateRecognizer
       */
      defaults: {
        event: "rotate",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [Ne];
      },
      attrTest: function(y) {
        return this._super.attrTest.call(this, y) && (Math.abs(y.rotation) > this.options.threshold || this.state & Xt);
      }
    });
    function _i() {
      Jt.apply(this, arguments);
    }
    b(_i, Jt, {
      /**
       * @namespace
       * @memberof SwipeRecognizer
       */
      defaults: {
        event: "swipe",
        threshold: 10,
        velocity: 0.3,
        direction: ot | ze,
        pointers: 1
      },
      getTouchAction: function() {
        return mn.prototype.getTouchAction.call(this);
      },
      attrTest: function(y) {
        var v = this.options.direction, E;
        return v & (ot | ze) ? E = y.overallVelocity : v & ot ? E = y.overallVelocityX : v & ze && (E = y.overallVelocityY), this._super.attrTest.call(this, y) && v & y.offsetDirection && y.distance > this.options.threshold && y.maxPointers == this.options.pointers && c(E) > this.options.velocity && y.eventType & st;
      },
      emit: function(y) {
        var v = Ao(y.offsetDirection);
        v && this.manager.emit(this.options.event + v, y), this.manager.emit(this.options.event, y);
      }
    });
    function pn() {
      le.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0;
    }
    b(pn, le, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "tap",
        pointers: 1,
        taps: 1,
        interval: 300,
        // max time between the multi-tap taps
        time: 250,
        // max time of the pointer to be down (like finger on the screen)
        threshold: 9,
        // a minimal movement is ok, but keep it low
        posThreshold: 10
        // a multi-tap can be a bit off the initial position
      },
      getTouchAction: function() {
        return [yi];
      },
      process: function(y) {
        var v = this.options, E = y.pointers.length === v.pointers, P = y.distance < v.threshold, I = y.deltaTime < v.time;
        if (this.reset(), y.eventType & ut && this.count === 0)
          return this.failTimeout();
        if (P && I && E) {
          if (y.eventType != st)
            return this.failTimeout();
          var R = this.pTime ? y.timeStamp - this.pTime < v.interval : !0, $ = !this.pCenter || hn(this.pCenter, y.center) < v.posThreshold;
          this.pTime = y.timeStamp, this.pCenter = y.center, !$ || !R ? this.count = 1 : this.count += 1, this._input = y;
          var ft = this.count % v.taps;
          if (ft === 0)
            return this.hasRequireFailures() ? (this._timer = u(function() {
              this.state = ce, this.tryEmit();
            }, v.interval, this), Xt) : ce;
        }
        return ne;
      },
      failTimeout: function() {
        return this._timer = u(function() {
          this.state = ne;
        }, this.options.interval, this), ne;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function() {
        this.state == ce && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
      }
    });
    function ue(y, v) {
      return v = v || {}, v.recognizers = C(v.recognizers, ue.defaults.preset), new Si(y, v);
    }
    ue.VERSION = "2.0.7", ue.defaults = {
      /**
       * set if DOM events are being triggered.
       * But this is slower and unused by simple implementations, so disabled by default.
       * @type {Boolean}
       * @default false
       */
      domEvents: !1,
      /**
       * The value for the touchAction property/fallback.
       * When set to `compute` it will magically set the correct value based on the added recognizers.
       * @type {String}
       * @default compute
       */
      touchAction: Po,
      /**
       * @type {Boolean}
       * @default true
       */
      enable: !0,
      /**
       * EXPERIMENTAL FEATURE -- can be removed/changed
       * Change the parent input target element.
       * If Null, then it is being set the to main element.
       * @type {Null|EventTarget}
       * @default null
       */
      inputTarget: null,
      /**
       * force an input class
       * @type {Null|Function}
       * @default null
       */
      inputClass: null,
      /**
       * Default recognizer setup when calling `Hammer()`
       * When creating a new Manager these will be skipped.
       * @type {Array}
       */
      preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [vi, { enable: !1 }],
        [wi, { enable: !1 }, ["rotate"]],
        [_i, { direction: ot }],
        [mn, { direction: ot }, ["swipe"]],
        [pn],
        [pn, { event: "doubletap", taps: 2 }, ["tap"]],
        [bi]
      ],
      /**
       * Some CSS properties can be used to improve the working of Hammer.
       * Add them to this method and they will be set when creating a new Manager.
       * @namespace
       */
      cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: "none",
        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: "none",
        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: "none",
        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: "none",
        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: "none",
        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: "rgba(0,0,0,0)"
      }
    };
    var cu = 1, Io = 2;
    function Si(y, v) {
      this.options = p({}, ue.defaults, v || {}), this.options.inputTarget = this.options.inputTarget || y, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = y, this.input = Bl(this), this.touchAction = new xi(this, this.options.touchAction), ko(this, !0), f(this.options.recognizers, function(E) {
        var P = this.add(new E[0](E[1]));
        E[2] && P.recognizeWith(E[2]), E[3] && P.requireFailure(E[3]);
      }, this);
    }
    Si.prototype = {
      /**
       * set options
       * @param {Object} options
       * @returns {Manager}
       */
      set: function(y) {
        return p(this.options, y), y.touchAction && this.touchAction.update(), y.inputTarget && (this.input.destroy(), this.input.target = y.inputTarget, this.input.init()), this;
      },
      /**
       * stop recognizing for this session.
       * This session will be discarded, when a new [input]start event is fired.
       * When forced, the recognizer cycle is stopped immediately.
       * @param {Boolean} [force]
       */
      stop: function(y) {
        this.session.stopped = y ? Io : cu;
      },
      /**
       * run the recognizers!
       * called by the inputHandler function on every movement of the pointers (touches)
       * it walks through all the recognizers and tries to detect the gesture that is being made
       * @param {Object} inputData
       */
      recognize: function(y) {
        var v = this.session;
        if (!v.stopped) {
          this.touchAction.preventDefaults(y);
          var E, P = this.recognizers, I = v.curRecognizer;
          (!I || I && I.state & ce) && (I = v.curRecognizer = null);
          for (var R = 0; R < P.length; )
            E = P[R], v.stopped !== Io && // 1
            (!I || E == I || // 2
            E.canRecognizeWith(I)) ? E.recognize(y) : E.reset(), !I && E.state & (Xt | ts | ve) && (I = v.curRecognizer = E), R++;
        }
      },
      /**
       * get a recognizer by its event name.
       * @param {Recognizer|String} recognizer
       * @returns {Recognizer|Null}
       */
      get: function(y) {
        if (y instanceof le)
          return y;
        for (var v = this.recognizers, E = 0; E < v.length; E++)
          if (v[E].options.event == y)
            return v[E];
        return null;
      },
      /**
       * add a recognizer to the manager
       * existing recognizers with the same event name will be removed
       * @param {Recognizer} recognizer
       * @returns {Recognizer|Manager}
       */
      add: function(y) {
        if (d(y, "add", this))
          return this;
        var v = this.get(y.options.event);
        return v && this.remove(v), this.recognizers.push(y), y.manager = this, this.touchAction.update(), y;
      },
      /**
       * remove a recognizer by name or instance
       * @param {Recognizer|String} recognizer
       * @returns {Manager}
       */
      remove: function(y) {
        if (d(y, "remove", this))
          return this;
        if (y = this.get(y), y) {
          var v = this.recognizers, E = V(v, y);
          E !== -1 && (v.splice(E, 1), this.touchAction.update());
        }
        return this;
      },
      /**
       * bind event
       * @param {String} events
       * @param {Function} handler
       * @returns {EventEmitter} this
       */
      on: function(y, v) {
        if (y !== i && v !== i) {
          var E = this.handlers;
          return f(G(y), function(P) {
            E[P] = E[P] || [], E[P].push(v);
          }), this;
        }
      },
      /**
       * unbind event, leave emit blank to remove all handlers
       * @param {String} events
       * @param {Function} [handler]
       * @returns {EventEmitter} this
       */
      off: function(y, v) {
        if (y !== i) {
          var E = this.handlers;
          return f(G(y), function(P) {
            v ? E[P] && E[P].splice(V(E[P], v), 1) : delete E[P];
          }), this;
        }
      },
      /**
       * emit event to the listeners
       * @param {String} event
       * @param {Object} data
       */
      emit: function(y, v) {
        this.options.domEvents && lu(y, v);
        var E = this.handlers[y] && this.handlers[y].slice();
        if (!(!E || !E.length)) {
          v.type = y, v.preventDefault = function() {
            v.srcEvent.preventDefault();
          };
          for (var P = 0; P < E.length; )
            E[P](v), P++;
        }
      },
      /**
       * destroy the manager and unbinds all events
       * it doesn't unbind dom events, that is the user own responsibility
       */
      destroy: function() {
        this.element && ko(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
      }
    };
    function ko(y, v) {
      var E = y.element;
      if (E.style) {
        var P;
        f(y.options.cssProps, function(I, R) {
          P = J(E.style, R), v ? (y.oldCssProps[P] = E.style[P], E.style[P] = I) : E.style[P] = y.oldCssProps[P] || "";
        }), v || (y.oldCssProps = {});
      }
    }
    function lu(y, v) {
      var E = e.createEvent("Event");
      E.initEvent(y, !0, !0), E.gesture = v, v.target.dispatchEvent(E);
    }
    p(ue, {
      INPUT_START: ut,
      INPUT_MOVE: se,
      INPUT_END: st,
      INPUT_CANCEL: bt,
      STATE_POSSIBLE: fn,
      STATE_BEGAN: Xt,
      STATE_CHANGED: ts,
      STATE_ENDED: ve,
      STATE_RECOGNIZED: ce,
      STATE_CANCELLED: bs,
      STATE_FAILED: ne,
      DIRECTION_NONE: Qe,
      DIRECTION_LEFT: Re,
      DIRECTION_RIGHT: Oe,
      DIRECTION_UP: be,
      DIRECTION_DOWN: A,
      DIRECTION_HORIZONTAL: ot,
      DIRECTION_VERTICAL: ze,
      DIRECTION_ALL: fo,
      Manager: Si,
      Input: Bt,
      TouchAction: xi,
      TouchInput: ln,
      MouseInput: cn,
      PointerEventInput: pi,
      TouchMouseInput: gi,
      SingleTouchInput: vo,
      Recognizer: le,
      AttrRecognizer: Jt,
      Tap: pn,
      Pan: mn,
      Swipe: _i,
      Pinch: wi,
      Rotate: vi,
      Press: bi,
      on: _,
      off: D,
      each: f,
      merge: g,
      extend: S,
      assign: p,
      inherit: b,
      bindFn: x,
      prefixed: J
    });
    var uu = typeof t < "u" ? t : typeof self < "u" ? self : {};
    uu.Hammer = ue, typeof i == "function" && i.amd ? i(function() {
      return ue;
    }) : n.exports ? n.exports = ue : t[s] = ue;
  })(window, document, "Hammer");
})(jh);
var dm = jh.exports;
const rt = /* @__PURE__ */ Fh(dm);
var rr = function(n, t) {
  return rr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, s) {
    e.__proto__ = s;
  } || function(e, s) {
    for (var i in s)
      Object.prototype.hasOwnProperty.call(s, i) && (e[i] = s[i]);
  }, rr(n, t);
};
function he(n, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  rr(n, t);
  function e() {
    this.constructor = n;
  }
  n.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
function mm(n, t, e, s) {
  function i(r) {
    return r instanceof e ? r : new e(function(o) {
      o(r);
    });
  }
  return new (e || (e = Promise))(function(r, o) {
    function a(l) {
      try {
        c(s.next(l));
      } catch (u) {
        o(u);
      }
    }
    function h(l) {
      try {
        c(s.throw(l));
      } catch (u) {
        o(u);
      }
    }
    function c(l) {
      l.done ? r(l.value) : i(l.value).then(a, h);
    }
    c((s = s.apply(n, t || [])).next());
  });
}
function Hh(n, t) {
  var e = { label: 0, sent: function() {
    if (r[0] & 1)
      throw r[1];
    return r[1];
  }, trys: [], ops: [] }, s, i, r, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(c) {
    return function(l) {
      return h([c, l]);
    };
  }
  function h(c) {
    if (s)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, c[0] && (e = 0)), e; )
      try {
        if (s = 1, i && (r = c[0] & 2 ? i.return : c[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, c[1])).done)
          return r;
        switch (i = 0, r && (c = [c[0] & 2, r.value]), c[0]) {
          case 0:
          case 1:
            r = c;
            break;
          case 4:
            return e.label++, { value: c[1], done: !1 };
          case 5:
            e.label++, i = c[1], c = [0];
            continue;
          case 7:
            c = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (r = e.trys, !(r = r.length > 0 && r[r.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              e = 0;
              continue;
            }
            if (c[0] === 3 && (!r || c[1] > r[0] && c[1] < r[3])) {
              e.label = c[1];
              break;
            }
            if (c[0] === 6 && e.label < r[1]) {
              e.label = r[1], r = c;
              break;
            }
            if (r && e.label < r[2]) {
              e.label = r[2], e.ops.push(c);
              break;
            }
            r[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        c = t.call(n, e);
      } catch (l) {
        c = [6, l], i = 0;
      } finally {
        s = r = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function qe(n) {
  var t = typeof Symbol == "function" && Symbol.iterator, e = t && n[t], s = 0;
  if (e)
    return e.call(n);
  if (n && typeof n.length == "number")
    return {
      next: function() {
        return n && s >= n.length && (n = void 0), { value: n && n[s++], done: !n };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function we(n, t) {
  var e = typeof Symbol == "function" && n[Symbol.iterator];
  if (!e)
    return n;
  var s = e.call(n), i, r = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = s.next()).done; )
      r.push(i.value);
  } catch (a) {
    o = { error: a };
  } finally {
    try {
      i && !i.done && (e = s.return) && e.call(s);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return r;
}
function Ie(n, t, e) {
  if (e || arguments.length === 2)
    for (var s = 0, i = t.length, r; s < i; s++)
      (r || !(s in t)) && (r || (r = Array.prototype.slice.call(t, 0, s)), r[s] = t[s]);
  return n.concat(r || Array.prototype.slice.call(t));
}
function as(n) {
  return this instanceof as ? (this.v = n, this) : new as(n);
}
function pm(n, t, e) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var s = e.apply(n, t || []), i, r = [];
  return i = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), a("next"), a("throw"), a("return", o), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function o(f) {
    return function(m) {
      return Promise.resolve(m).then(f, u);
    };
  }
  function a(f, m) {
    s[f] && (i[f] = function(p) {
      return new Promise(function(S, g) {
        r.push([f, p, S, g]) > 1 || h(f, p);
      });
    }, m && (i[f] = m(i[f])));
  }
  function h(f, m) {
    try {
      c(s[f](m));
    } catch (p) {
      d(r[0][3], p);
    }
  }
  function c(f) {
    f.value instanceof as ? Promise.resolve(f.value.v).then(l, u) : d(r[0][2], f);
  }
  function l(f) {
    h("next", f);
  }
  function u(f) {
    h("throw", f);
  }
  function d(f, m) {
    f(m), r.shift(), r.length && h(r[0][0], r[0][1]);
  }
}
function gm(n) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = n[Symbol.asyncIterator], e;
  return t ? t.call(n) : (n = typeof qe == "function" ? qe(n) : n[Symbol.iterator](), e = {}, s("next"), s("throw"), s("return"), e[Symbol.asyncIterator] = function() {
    return this;
  }, e);
  function s(r) {
    e[r] = n[r] && function(o) {
      return new Promise(function(a, h) {
        o = n[r](o), i(a, h, o.done, o.value);
      });
    };
  }
  function i(r, o, a, h) {
    Promise.resolve(h).then(function(c) {
      r({ value: c, done: a });
    }, o);
  }
}
function W(n) {
  return typeof n == "function";
}
function $r(n) {
  var t = function(s) {
    Error.call(s), s.stack = new Error().stack;
  }, e = n(t);
  return e.prototype = Object.create(Error.prototype), e.prototype.constructor = e, e;
}
var Ii = $r(function(n) {
  return function(e) {
    n(this), this.message = e ? e.length + ` errors occurred during unsubscription:
` + e.map(function(s, i) {
      return i + 1 + ") " + s.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = e;
  };
});
function Us(n, t) {
  if (n) {
    var e = n.indexOf(t);
    0 <= e && n.splice(e, 1);
  }
}
var gs = function() {
  function n(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return n.prototype.unsubscribe = function() {
    var t, e, s, i, r;
    if (!this.closed) {
      this.closed = !0;
      var o = this._parentage;
      if (o)
        if (this._parentage = null, Array.isArray(o))
          try {
            for (var a = qe(o), h = a.next(); !h.done; h = a.next()) {
              var c = h.value;
              c.remove(this);
            }
          } catch (p) {
            t = { error: p };
          } finally {
            try {
              h && !h.done && (e = a.return) && e.call(a);
            } finally {
              if (t)
                throw t.error;
            }
          }
        else
          o.remove(this);
      var l = this.initialTeardown;
      if (W(l))
        try {
          l();
        } catch (p) {
          r = p instanceof Ii ? p.errors : [p];
        }
      var u = this._finalizers;
      if (u) {
        this._finalizers = null;
        try {
          for (var d = qe(u), f = d.next(); !f.done; f = d.next()) {
            var m = f.value;
            try {
              ia(m);
            } catch (p) {
              r = r ?? [], p instanceof Ii ? r = Ie(Ie([], we(r)), we(p.errors)) : r.push(p);
            }
          }
        } catch (p) {
          s = { error: p };
        } finally {
          try {
            f && !f.done && (i = d.return) && i.call(d);
          } finally {
            if (s)
              throw s.error;
          }
        }
      }
      if (r)
        throw new Ii(r);
    }
  }, n.prototype.add = function(t) {
    var e;
    if (t && t !== this)
      if (this.closed)
        ia(t);
      else {
        if (t instanceof n) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (e = this._finalizers) !== null && e !== void 0 ? e : []).push(t);
      }
  }, n.prototype._hasParent = function(t) {
    var e = this._parentage;
    return e === t || Array.isArray(e) && e.includes(t);
  }, n.prototype._addParent = function(t) {
    var e = this._parentage;
    this._parentage = Array.isArray(e) ? (e.push(t), e) : e ? [e, t] : t;
  }, n.prototype._removeParent = function(t) {
    var e = this._parentage;
    e === t ? this._parentage = null : Array.isArray(e) && Us(e, t);
  }, n.prototype.remove = function(t) {
    var e = this._finalizers;
    e && Us(e, t), t instanceof n && t._removeParent(this);
  }, n.EMPTY = function() {
    var t = new n();
    return t.closed = !0, t;
  }(), n;
}(), Wh = gs.EMPTY;
function Zh(n) {
  return n instanceof gs || n && "closed" in n && W(n.remove) && W(n.add) && W(n.unsubscribe);
}
function ia(n) {
  W(n) ? n() : n.unsubscribe();
}
var Jh = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, or = {
  setTimeout: function(n, t) {
    for (var e = [], s = 2; s < arguments.length; s++)
      e[s - 2] = arguments[s];
    var i = or.delegate;
    return i?.setTimeout ? i.setTimeout.apply(i, Ie([n, t], we(e))) : setTimeout.apply(void 0, Ie([n, t], we(e)));
  },
  clearTimeout: function(n) {
    var t = or.delegate;
    return (t?.clearTimeout || clearTimeout)(n);
  },
  delegate: void 0
};
function Kh(n) {
  or.setTimeout(function() {
    throw n;
  });
}
function Gs() {
}
function zn(n) {
  n();
}
var qr = function(n) {
  he(t, n);
  function t(e) {
    var s = n.call(this) || this;
    return s.isStopped = !1, e ? (s.destination = e, Zh(e) && e.add(s)) : s.destination = bm, s;
  }
  return t.create = function(e, s, i) {
    return new us(e, s, i);
  }, t.prototype.next = function(e) {
    this.isStopped || this._next(e);
  }, t.prototype.error = function(e) {
    this.isStopped || (this.isStopped = !0, this._error(e));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, n.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(e) {
    this.destination.next(e);
  }, t.prototype._error = function(e) {
    try {
      this.destination.error(e);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(gs), ym = Function.prototype.bind;
function ki(n, t) {
  return ym.call(n, t);
}
var xm = function() {
  function n(t) {
    this.partialObserver = t;
  }
  return n.prototype.next = function(t) {
    var e = this.partialObserver;
    if (e.next)
      try {
        e.next(t);
      } catch (s) {
        yn(s);
      }
  }, n.prototype.error = function(t) {
    var e = this.partialObserver;
    if (e.error)
      try {
        e.error(t);
      } catch (s) {
        yn(s);
      }
    else
      yn(t);
  }, n.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (e) {
        yn(e);
      }
  }, n;
}(), us = function(n) {
  he(t, n);
  function t(e, s, i) {
    var r = n.call(this) || this, o;
    if (W(e) || !e)
      o = {
        next: e ?? void 0,
        error: s ?? void 0,
        complete: i ?? void 0
      };
    else {
      var a;
      r && Jh.useDeprecatedNextContext ? (a = Object.create(e), a.unsubscribe = function() {
        return r.unsubscribe();
      }, o = {
        next: e.next && ki(e.next, a),
        error: e.error && ki(e.error, a),
        complete: e.complete && ki(e.complete, a)
      }) : o = e;
    }
    return r.destination = new xm(o), r;
  }
  return t;
}(qr);
function yn(n) {
  Kh(n);
}
function wm(n) {
  throw n;
}
var bm = {
  closed: !0,
  next: Gs,
  error: wm,
  complete: Gs
}, jr = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function Je(n) {
  return n;
}
function vm(n) {
  return n.length === 0 ? Je : n.length === 1 ? n[0] : function(e) {
    return n.reduce(function(s, i) {
      return i(s);
    }, e);
  };
}
var nt = function() {
  function n(t) {
    t && (this._subscribe = t);
  }
  return n.prototype.lift = function(t) {
    var e = new n();
    return e.source = this, e.operator = t, e;
  }, n.prototype.subscribe = function(t, e, s) {
    var i = this, r = Sm(t) ? t : new us(t, e, s);
    return zn(function() {
      var o = i, a = o.operator, h = o.source;
      r.add(a ? a.call(r, h) : h ? i._subscribe(r) : i._trySubscribe(r));
    }), r;
  }, n.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (e) {
      t.error(e);
    }
  }, n.prototype.forEach = function(t, e) {
    var s = this;
    return e = ra(e), new e(function(i, r) {
      var o = new us({
        next: function(a) {
          try {
            t(a);
          } catch (h) {
            r(h), o.unsubscribe();
          }
        },
        error: r,
        complete: i
      });
      s.subscribe(o);
    });
  }, n.prototype._subscribe = function(t) {
    var e;
    return (e = this.source) === null || e === void 0 ? void 0 : e.subscribe(t);
  }, n.prototype[jr] = function() {
    return this;
  }, n.prototype.pipe = function() {
    for (var t = [], e = 0; e < arguments.length; e++)
      t[e] = arguments[e];
    return vm(t)(this);
  }, n.prototype.toPromise = function(t) {
    var e = this;
    return t = ra(t), new t(function(s, i) {
      var r;
      e.subscribe(function(o) {
        return r = o;
      }, function(o) {
        return i(o);
      }, function() {
        return s(r);
      });
    });
  }, n.create = function(t) {
    return new n(t);
  }, n;
}();
function ra(n) {
  var t;
  return (t = n ?? Jh.Promise) !== null && t !== void 0 ? t : Promise;
}
function _m(n) {
  return n && W(n.next) && W(n.error) && W(n.complete);
}
function Sm(n) {
  return n && n instanceof qr || _m(n) && Zh(n);
}
function Cm(n) {
  return W(n?.lift);
}
function kt(n) {
  return function(t) {
    if (Cm(t))
      return t.lift(function(e) {
        try {
          return n(e, this);
        } catch (s) {
          this.error(s);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function lt(n, t, e, s, i) {
  return new Em(n, t, e, s, i);
}
var Em = function(n) {
  he(t, n);
  function t(e, s, i, r, o, a) {
    var h = n.call(this, e) || this;
    return h.onFinalize = o, h.shouldUnsubscribe = a, h._next = s ? function(c) {
      try {
        s(c);
      } catch (l) {
        e.error(l);
      }
    } : n.prototype._next, h._error = r ? function(c) {
      try {
        r(c);
      } catch (l) {
        e.error(l);
      } finally {
        this.unsubscribe();
      }
    } : n.prototype._error, h._complete = i ? function() {
      try {
        i();
      } catch (c) {
        e.error(c);
      } finally {
        this.unsubscribe();
      }
    } : n.prototype._complete, h;
  }
  return t.prototype.unsubscribe = function() {
    var e;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var s = this.closed;
      n.prototype.unsubscribe.call(this), !s && ((e = this.onFinalize) === null || e === void 0 || e.call(this));
    }
  }, t;
}(qr), Pm = $r(function(n) {
  return function() {
    n(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), ke = function(n) {
  he(t, n);
  function t() {
    var e = n.call(this) || this;
    return e.closed = !1, e.currentObservers = null, e.observers = [], e.isStopped = !1, e.hasError = !1, e.thrownError = null, e;
  }
  return t.prototype.lift = function(e) {
    var s = new oa(this, this);
    return s.operator = e, s;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new Pm();
  }, t.prototype.next = function(e) {
    var s = this;
    zn(function() {
      var i, r;
      if (s._throwIfClosed(), !s.isStopped) {
        s.currentObservers || (s.currentObservers = Array.from(s.observers));
        try {
          for (var o = qe(s.currentObservers), a = o.next(); !a.done; a = o.next()) {
            var h = a.value;
            h.next(e);
          }
        } catch (c) {
          i = { error: c };
        } finally {
          try {
            a && !a.done && (r = o.return) && r.call(o);
          } finally {
            if (i)
              throw i.error;
          }
        }
      }
    });
  }, t.prototype.error = function(e) {
    var s = this;
    zn(function() {
      if (s._throwIfClosed(), !s.isStopped) {
        s.hasError = s.isStopped = !0, s.thrownError = e;
        for (var i = s.observers; i.length; )
          i.shift().error(e);
      }
    });
  }, t.prototype.complete = function() {
    var e = this;
    zn(function() {
      if (e._throwIfClosed(), !e.isStopped) {
        e.isStopped = !0;
        for (var s = e.observers; s.length; )
          s.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var e;
      return ((e = this.observers) === null || e === void 0 ? void 0 : e.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(e) {
    return this._throwIfClosed(), n.prototype._trySubscribe.call(this, e);
  }, t.prototype._subscribe = function(e) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(e), this._innerSubscribe(e);
  }, t.prototype._innerSubscribe = function(e) {
    var s = this, i = this, r = i.hasError, o = i.isStopped, a = i.observers;
    return r || o ? Wh : (this.currentObservers = null, a.push(e), new gs(function() {
      s.currentObservers = null, Us(a, e);
    }));
  }, t.prototype._checkFinalizedStatuses = function(e) {
    var s = this, i = s.hasError, r = s.thrownError, o = s.isStopped;
    i ? e.error(r) : o && e.complete();
  }, t.prototype.asObservable = function() {
    var e = new nt();
    return e.source = this, e;
  }, t.create = function(e, s) {
    return new oa(e, s);
  }, t;
}(nt), oa = function(n) {
  he(t, n);
  function t(e, s) {
    var i = n.call(this) || this;
    return i.destination = e, i.source = s, i;
  }
  return t.prototype.next = function(e) {
    var s, i;
    (i = (s = this.destination) === null || s === void 0 ? void 0 : s.next) === null || i === void 0 || i.call(s, e);
  }, t.prototype.error = function(e) {
    var s, i;
    (i = (s = this.destination) === null || s === void 0 ? void 0 : s.error) === null || i === void 0 || i.call(s, e);
  }, t.prototype.complete = function() {
    var e, s;
    (s = (e = this.destination) === null || e === void 0 ? void 0 : e.complete) === null || s === void 0 || s.call(e);
  }, t.prototype._subscribe = function(e) {
    var s, i;
    return (i = (s = this.source) === null || s === void 0 ? void 0 : s.subscribe(e)) !== null && i !== void 0 ? i : Wh;
  }, t;
}(ke), aa = function(n) {
  he(t, n);
  function t(e) {
    var s = n.call(this) || this;
    return s._value = e, s;
  }
  return Object.defineProperty(t.prototype, "value", {
    get: function() {
      return this.getValue();
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._subscribe = function(e) {
    var s = n.prototype._subscribe.call(this, e);
    return !s.closed && e.next(this._value), s;
  }, t.prototype.getValue = function() {
    var e = this, s = e.hasError, i = e.thrownError, r = e._value;
    if (s)
      throw i;
    return this._throwIfClosed(), r;
  }, t.prototype.next = function(e) {
    n.prototype.next.call(this, this._value = e);
  }, t;
}(ke), Hr = {
  now: function() {
    return (Hr.delegate || Date).now();
  },
  delegate: void 0
}, Tm = function(n) {
  he(t, n);
  function t(e, s, i) {
    e === void 0 && (e = 1 / 0), s === void 0 && (s = 1 / 0), i === void 0 && (i = Hr);
    var r = n.call(this) || this;
    return r._bufferSize = e, r._windowTime = s, r._timestampProvider = i, r._buffer = [], r._infiniteTimeWindow = !0, r._infiniteTimeWindow = s === 1 / 0, r._bufferSize = Math.max(1, e), r._windowTime = Math.max(1, s), r;
  }
  return t.prototype.next = function(e) {
    var s = this, i = s.isStopped, r = s._buffer, o = s._infiniteTimeWindow, a = s._timestampProvider, h = s._windowTime;
    i || (r.push(e), !o && r.push(a.now() + h)), this._trimBuffer(), n.prototype.next.call(this, e);
  }, t.prototype._subscribe = function(e) {
    this._throwIfClosed(), this._trimBuffer();
    for (var s = this._innerSubscribe(e), i = this, r = i._infiniteTimeWindow, o = i._buffer, a = o.slice(), h = 0; h < a.length && !e.closed; h += r ? 1 : 2)
      e.next(a[h]);
    return this._checkFinalizedStatuses(e), s;
  }, t.prototype._trimBuffer = function() {
    var e = this, s = e._bufferSize, i = e._timestampProvider, r = e._buffer, o = e._infiniteTimeWindow, a = (o ? 1 : 2) * s;
    if (s < 1 / 0 && a < r.length && r.splice(0, r.length - a), !o) {
      for (var h = i.now(), c = 0, l = 1; l < r.length && r[l] <= h; l += 2)
        c = l;
      c && r.splice(0, c + 1);
    }
  }, t;
}(ke), Mm = function(n) {
  he(t, n);
  function t(e, s) {
    return n.call(this) || this;
  }
  return t.prototype.schedule = function(e, s) {
    return this;
  }, t;
}(gs), $n = {
  setInterval: function(n, t) {
    for (var e = [], s = 2; s < arguments.length; s++)
      e[s - 2] = arguments[s];
    var i = $n.delegate;
    return i?.setInterval ? i.setInterval.apply(i, Ie([n, t], we(e))) : setInterval.apply(void 0, Ie([n, t], we(e)));
  },
  clearInterval: function(n) {
    var t = $n.delegate;
    return (t?.clearInterval || clearInterval)(n);
  },
  delegate: void 0
}, Am = function(n) {
  he(t, n);
  function t(e, s) {
    var i = n.call(this, e, s) || this;
    return i.scheduler = e, i.work = s, i.pending = !1, i;
  }
  return t.prototype.schedule = function(e, s) {
    var i;
    if (s === void 0 && (s = 0), this.closed)
      return this;
    this.state = e;
    var r = this.id, o = this.scheduler;
    return r != null && (this.id = this.recycleAsyncId(o, r, s)), this.pending = !0, this.delay = s, this.id = (i = this.id) !== null && i !== void 0 ? i : this.requestAsyncId(o, this.id, s), this;
  }, t.prototype.requestAsyncId = function(e, s, i) {
    return i === void 0 && (i = 0), $n.setInterval(e.flush.bind(e, this), i);
  }, t.prototype.recycleAsyncId = function(e, s, i) {
    if (i === void 0 && (i = 0), i != null && this.delay === i && this.pending === !1)
      return s;
    s != null && $n.clearInterval(s);
  }, t.prototype.execute = function(e, s) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var i = this._execute(e, s);
    if (i)
      return i;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, t.prototype._execute = function(e, s) {
    var i = !1, r;
    try {
      this.work(e);
    } catch (o) {
      i = !0, r = o || new Error("Scheduled action threw falsy error");
    }
    if (i)
      return this.unsubscribe(), r;
  }, t.prototype.unsubscribe = function() {
    if (!this.closed) {
      var e = this, s = e.id, i = e.scheduler, r = i.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, Us(r, this), s != null && (this.id = this.recycleAsyncId(i, s, null)), this.delay = null, n.prototype.unsubscribe.call(this);
    }
  }, t;
}(Mm), ha = function() {
  function n(t, e) {
    e === void 0 && (e = n.now), this.schedulerActionCtor = t, this.now = e;
  }
  return n.prototype.schedule = function(t, e, s) {
    return e === void 0 && (e = 0), new this.schedulerActionCtor(this, t).schedule(s, e);
  }, n.now = Hr.now, n;
}(), Im = function(n) {
  he(t, n);
  function t(e, s) {
    s === void 0 && (s = ha.now);
    var i = n.call(this, e, s) || this;
    return i.actions = [], i._active = !1, i;
  }
  return t.prototype.flush = function(e) {
    var s = this.actions;
    if (this._active) {
      s.push(e);
      return;
    }
    var i;
    this._active = !0;
    do
      if (i = e.execute(e.state, e.delay))
        break;
    while (e = s.shift());
    if (this._active = !1, i) {
      for (; e = s.shift(); )
        e.unsubscribe();
      throw i;
    }
  }, t;
}(ha), Wr = new Im(Am), km = Wr, Qh = new nt(function(n) {
  return n.complete();
});
function tc(n) {
  return n && W(n.schedule);
}
function Zr(n) {
  return n[n.length - 1];
}
function Dm(n) {
  return W(Zr(n)) ? n.pop() : void 0;
}
function Js(n) {
  return tc(Zr(n)) ? n.pop() : void 0;
}
function Lm(n, t) {
  return typeof Zr(n) == "number" ? n.pop() : t;
}
var Jr = function(n) {
  return n && typeof n.length == "number" && typeof n != "function";
};
function ec(n) {
  return W(n?.then);
}
function sc(n) {
  return W(n[jr]);
}
function nc(n) {
  return Symbol.asyncIterator && W(n?.[Symbol.asyncIterator]);
}
function ic(n) {
  return new TypeError("You provided " + (n !== null && typeof n == "object" ? "an invalid object" : "'" + n + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function Rm() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var rc = Rm();
function oc(n) {
  return W(n?.[rc]);
}
function ac(n) {
  return pm(this, arguments, function() {
    var e, s, i, r;
    return Hh(this, function(o) {
      switch (o.label) {
        case 0:
          e = n.getReader(), o.label = 1;
        case 1:
          o.trys.push([1, , 9, 10]), o.label = 2;
        case 2:
          return [4, as(e.read())];
        case 3:
          return s = o.sent(), i = s.value, r = s.done, r ? [4, as(void 0)] : [3, 5];
        case 4:
          return [2, o.sent()];
        case 5:
          return [4, as(i)];
        case 6:
          return [4, o.sent()];
        case 7:
          return o.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return e.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function hc(n) {
  return W(n?.getReader);
}
function gt(n) {
  if (n instanceof nt)
    return n;
  if (n != null) {
    if (sc(n))
      return Om(n);
    if (Jr(n))
      return zm(n);
    if (ec(n))
      return Nm(n);
    if (nc(n))
      return cc(n);
    if (oc(n))
      return Ym(n);
    if (hc(n))
      return Bm(n);
  }
  throw ic(n);
}
function Om(n) {
  return new nt(function(t) {
    var e = n[jr]();
    if (W(e.subscribe))
      return e.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function zm(n) {
  return new nt(function(t) {
    for (var e = 0; e < n.length && !t.closed; e++)
      t.next(n[e]);
    t.complete();
  });
}
function Nm(n) {
  return new nt(function(t) {
    n.then(function(e) {
      t.closed || (t.next(e), t.complete());
    }, function(e) {
      return t.error(e);
    }).then(null, Kh);
  });
}
function Ym(n) {
  return new nt(function(t) {
    var e, s;
    try {
      for (var i = qe(n), r = i.next(); !r.done; r = i.next()) {
        var o = r.value;
        if (t.next(o), t.closed)
          return;
      }
    } catch (a) {
      e = { error: a };
    } finally {
      try {
        r && !r.done && (s = i.return) && s.call(i);
      } finally {
        if (e)
          throw e.error;
      }
    }
    t.complete();
  });
}
function cc(n) {
  return new nt(function(t) {
    Xm(n, t).catch(function(e) {
      return t.error(e);
    });
  });
}
function Bm(n) {
  return cc(ac(n));
}
function Xm(n, t) {
  var e, s, i, r;
  return mm(this, void 0, void 0, function() {
    var o, a;
    return Hh(this, function(h) {
      switch (h.label) {
        case 0:
          h.trys.push([0, 5, 6, 11]), e = gm(n), h.label = 1;
        case 1:
          return [4, e.next()];
        case 2:
          if (s = h.sent(), !!s.done)
            return [3, 4];
          if (o = s.value, t.next(o), t.closed)
            return [2];
          h.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return a = h.sent(), i = { error: a }, [3, 11];
        case 6:
          return h.trys.push([6, , 9, 10]), s && !s.done && (r = e.return) ? [4, r.call(e)] : [3, 8];
        case 7:
          h.sent(), h.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (i)
            throw i.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function xe(n, t, e, s, i) {
  s === void 0 && (s = 0), i === void 0 && (i = !1);
  var r = t.schedule(function() {
    e(), i ? n.add(this.schedule(null, s)) : this.unsubscribe();
  }, s);
  if (n.add(r), !i)
    return r;
}
function lc(n, t) {
  return t === void 0 && (t = 0), kt(function(e, s) {
    e.subscribe(lt(s, function(i) {
      return xe(s, n, function() {
        return s.next(i);
      }, t);
    }, function() {
      return xe(s, n, function() {
        return s.complete();
      }, t);
    }, function(i) {
      return xe(s, n, function() {
        return s.error(i);
      }, t);
    }));
  });
}
function Kr(n, t) {
  return t === void 0 && (t = 0), kt(function(e, s) {
    s.add(n.schedule(function() {
      return e.subscribe(s);
    }, t));
  });
}
function Fm(n, t) {
  return gt(n).pipe(Kr(t), lc(t));
}
function Um(n, t) {
  return gt(n).pipe(Kr(t), lc(t));
}
function Gm(n, t) {
  return new nt(function(e) {
    var s = 0;
    return t.schedule(function() {
      s === n.length ? e.complete() : (e.next(n[s++]), e.closed || this.schedule());
    });
  });
}
function Vm(n, t) {
  return new nt(function(e) {
    var s;
    return xe(e, t, function() {
      s = n[rc](), xe(e, t, function() {
        var i, r, o;
        try {
          i = s.next(), r = i.value, o = i.done;
        } catch (a) {
          e.error(a);
          return;
        }
        o ? e.complete() : e.next(r);
      }, 0, !0);
    }), function() {
      return W(s?.return) && s.return();
    };
  });
}
function uc(n, t) {
  if (!n)
    throw new Error("Iterable cannot be null");
  return new nt(function(e) {
    xe(e, t, function() {
      var s = n[Symbol.asyncIterator]();
      xe(e, t, function() {
        s.next().then(function(i) {
          i.done ? e.complete() : e.next(i.value);
        });
      }, 0, !0);
    });
  });
}
function $m(n, t) {
  return uc(ac(n), t);
}
function qm(n, t) {
  if (n != null) {
    if (sc(n))
      return Fm(n, t);
    if (Jr(n))
      return Gm(n, t);
    if (ec(n))
      return Um(n, t);
    if (nc(n))
      return uc(n, t);
    if (oc(n))
      return Vm(n, t);
    if (hc(n))
      return $m(n, t);
  }
  throw ic(n);
}
function Ks(n, t) {
  return t ? qm(n, t) : gt(n);
}
function jm() {
  for (var n = [], t = 0; t < arguments.length; t++)
    n[t] = arguments[t];
  var e = Js(n);
  return Ks(n, e);
}
var Hm = $r(function(n) {
  return function() {
    n(this), this.name = "EmptyError", this.message = "no elements in sequence";
  };
});
function Wm(n, t) {
  var e = typeof t == "object";
  return new Promise(function(s, i) {
    var r = new us({
      next: function(o) {
        s(o), r.unsubscribe();
      },
      error: i,
      complete: function() {
        e ? s(t.defaultValue) : i(new Hm());
      }
    });
    n.subscribe(r);
  });
}
function Zm(n) {
  return n instanceof Date && !isNaN(n);
}
function it(n, t) {
  return kt(function(e, s) {
    var i = 0;
    e.subscribe(lt(s, function(r) {
      s.next(n.call(t, r, i++));
    }));
  });
}
var Jm = Array.isArray;
function Km(n, t) {
  return Jm(t) ? n.apply(void 0, Ie([], we(t))) : n(t);
}
function Qr(n) {
  return it(function(t) {
    return Km(n, t);
  });
}
var Qm = Array.isArray, tp = Object.getPrototypeOf, ep = Object.prototype, sp = Object.keys;
function np(n) {
  if (n.length === 1) {
    var t = n[0];
    if (Qm(t))
      return { args: t, keys: null };
    if (ip(t)) {
      var e = sp(t);
      return {
        args: e.map(function(s) {
          return t[s];
        }),
        keys: e
      };
    }
  }
  return { args: n, keys: null };
}
function ip(n) {
  return n && typeof n == "object" && tp(n) === ep;
}
function rp(n, t) {
  return n.reduce(function(e, s, i) {
    return e[s] = t[i], e;
  }, {});
}
function op() {
  for (var n = [], t = 0; t < arguments.length; t++)
    n[t] = arguments[t];
  var e = Js(n), s = Dm(n), i = np(n), r = i.args, o = i.keys;
  if (r.length === 0)
    return Ks([], e);
  var a = new nt(hp(r, e, o ? function(h) {
    return rp(o, h);
  } : Je));
  return s ? a.pipe(Qr(s)) : a;
}
function hp(n, t, e) {
  return e === void 0 && (e = Je), function(s) {
    ca(t, function() {
      for (var i = n.length, r = new Array(i), o = i, a = i, h = function(l) {
        ca(t, function() {
          var u = Ks(n[l], t), d = !1;
          u.subscribe(lt(s, function(f) {
            r[l] = f, d || (d = !0, a--), a || s.next(e(r.slice()));
          }, function() {
            --o || s.complete();
          }));
        }, s);
      }, c = 0; c < i; c++)
        h(c);
    }, s);
  };
}
function ca(n, t, e) {
  n ? xe(e, n, t) : t();
}
function cp(n, t, e, s, i, r, o, a) {
  var h = [], c = 0, l = 0, u = !1, d = function() {
    u && !h.length && !c && t.complete();
  }, f = function(p) {
    return c < s ? m(p) : h.push(p);
  }, m = function(p) {
    r && t.next(p), c++;
    var S = !1;
    gt(e(p, l++)).subscribe(lt(t, function(g) {
      i?.(g), r ? f(g) : t.next(g);
    }, function() {
      S = !0;
    }, void 0, function() {
      if (S)
        try {
          c--;
          for (var g = function() {
            var b = h.shift();
            o ? xe(t, o, function() {
              return m(b);
            }) : m(b);
          }; h.length && c < s; )
            g();
          d();
        } catch (b) {
          t.error(b);
        }
    }));
  };
  return n.subscribe(lt(t, f, function() {
    u = !0, d();
  })), function() {
    a?.();
  };
}
function to(n, t, e) {
  return e === void 0 && (e = 1 / 0), W(t) ? to(function(s, i) {
    return it(function(r, o) {
      return t(s, r, i, o);
    })(gt(n(s, i)));
  }, e) : (typeof t == "number" && (e = t), kt(function(s, i) {
    return cp(s, i, n, e);
  }));
}
function fc(n) {
  return n === void 0 && (n = 1 / 0), to(Je, n);
}
function lp() {
  return fc(1);
}
function la() {
  for (var n = [], t = 0; t < arguments.length; t++)
    n[t] = arguments[t];
  return lp()(Ks(n, Js(n)));
}
var up = ["addListener", "removeListener"], fp = ["addEventListener", "removeEventListener"], dp = ["on", "off"];
function ar(n, t, e, s) {
  if (W(e) && (s = e, e = void 0), s)
    return ar(n, t, e).pipe(Qr(s));
  var i = we(gp(n) ? fp.map(function(a) {
    return function(h) {
      return n[a](t, h, e);
    };
  }) : mp(n) ? up.map(ua(n, t)) : pp(n) ? dp.map(ua(n, t)) : [], 2), r = i[0], o = i[1];
  if (!r && Jr(n))
    return to(function(a) {
      return ar(a, t, e);
    })(gt(n));
  if (!r)
    throw new TypeError("Invalid event target");
  return new nt(function(a) {
    var h = function() {
      for (var c = [], l = 0; l < arguments.length; l++)
        c[l] = arguments[l];
      return a.next(1 < c.length ? c : c[0]);
    };
    return r(h), function() {
      return o(h);
    };
  });
}
function ua(n, t) {
  return function(e) {
    return function(s) {
      return n[e](t, s);
    };
  };
}
function mp(n) {
  return W(n.addListener) && W(n.removeListener);
}
function pp(n) {
  return W(n.on) && W(n.off);
}
function gp(n) {
  return W(n.addEventListener) && W(n.removeEventListener);
}
function tt(n, t, e) {
  return e ? tt(n, t).pipe(Qr(e)) : new nt(function(s) {
    var i = function() {
      for (var o = [], a = 0; a < arguments.length; a++)
        o[a] = arguments[a];
      return s.next(o.length === 1 ? o[0] : o);
    }, r = n(i);
    return W(t) ? function() {
      return t(i, r);
    } : void 0;
  });
}
function yp(n, t, e) {
  n === void 0 && (n = 0), e === void 0 && (e = km);
  var s = -1;
  return t != null && (tc(t) ? e = t : s = t), new nt(function(i) {
    var r = Zm(n) ? +n - e.now() : n;
    r < 0 && (r = 0);
    var o = 0;
    return e.schedule(function() {
      i.closed || (i.next(o++), 0 <= s ? this.schedule(void 0, s) : i.complete());
    }, r);
  });
}
function dc() {
  for (var n = [], t = 0; t < arguments.length; t++)
    n[t] = arguments[t];
  var e = Js(n), s = Lm(n, 1 / 0), i = n;
  return i.length ? i.length === 1 ? gt(i[0]) : fc(s)(Ks(i, e)) : Qh;
}
var xp = Array.isArray;
function wp(n) {
  return n.length === 1 && xp(n[0]) ? n[0] : n;
}
function mc(n, t) {
  return kt(function(e, s) {
    var i = 0;
    e.subscribe(lt(s, function(r) {
      return n.call(t, r, i++) && s.next(r);
    }));
  });
}
function hi() {
  for (var n = [], t = 0; t < arguments.length; t++)
    n[t] = arguments[t];
  return n = wp(n), n.length === 1 ? gt(n[0]) : new nt(bp(n));
}
function bp(n) {
  return function(t) {
    for (var e = [], s = function(r) {
      e.push(gt(n[r]).subscribe(lt(t, function(o) {
        if (e) {
          for (var a = 0; a < e.length; a++)
            a !== r && e[a].unsubscribe();
          e = null;
        }
        t.next(o);
      })));
    }, i = 0; e && !t.closed && i < n.length; i++)
      s(i);
  };
}
function De(n, t) {
  return t === void 0 && (t = Je), n = n ?? vp, kt(function(e, s) {
    var i, r = !0;
    e.subscribe(lt(s, function(o) {
      var a = t(o);
      (r || !n(i, a)) && (r = !1, i = a, s.next(o));
    }));
  });
}
function vp(n, t) {
  return n === t;
}
function pc(n, t) {
  return t ? function(e) {
    return e.pipe(pc(function(s, i) {
      return gt(n(s, i)).pipe(it(function(r, o) {
        return t(s, r, i, o);
      }));
    }));
  } : kt(function(e, s) {
    var i = 0, r = null, o = !1;
    e.subscribe(lt(s, function(a) {
      r || (r = lt(s, void 0, function() {
        r = null, o && s.complete();
      }), gt(n(a, i++)).subscribe(r));
    }, function() {
      o = !0, !r && s.complete();
    }));
  });
}
function _p(n) {
  n === void 0 && (n = {});
  var t = n.connector, e = t === void 0 ? function() {
    return new ke();
  } : t, s = n.resetOnError, i = s === void 0 ? !0 : s, r = n.resetOnComplete, o = r === void 0 ? !0 : r, a = n.resetOnRefCountZero, h = a === void 0 ? !0 : a;
  return function(c) {
    var l, u, d, f = 0, m = !1, p = !1, S = function() {
      u?.unsubscribe(), u = void 0;
    }, g = function() {
      S(), l = d = void 0, m = p = !1;
    }, b = function() {
      var x = l;
      g(), x?.unsubscribe();
    };
    return kt(function(x, w) {
      f++, !p && !m && S();
      var C = d = d ?? e();
      w.add(function() {
        f--, f === 0 && !p && !m && (u = Di(b, h));
      }), C.subscribe(w), !l && f > 0 && (l = new us({
        next: function(_) {
          return C.next(_);
        },
        error: function(_) {
          p = !0, S(), u = Di(g, i, _), C.error(_);
        },
        complete: function() {
          m = !0, S(), u = Di(g, o), C.complete();
        }
      }), gt(x).subscribe(l));
    })(c);
  };
}
function Di(n, t) {
  for (var e = [], s = 2; s < arguments.length; s++)
    e[s - 2] = arguments[s];
  if (t === !0) {
    n();
    return;
  }
  if (t !== !1) {
    var i = new us({
      next: function() {
        i.unsubscribe(), n();
      }
    });
    return gt(t.apply(void 0, Ie([], we(e)))).subscribe(i);
  }
}
function Sp(n, t, e) {
  var s, i, r, o, a = !1;
  return n && typeof n == "object" ? (s = n.bufferSize, o = s === void 0 ? 1 / 0 : s, i = n.windowTime, t = i === void 0 ? 1 / 0 : i, r = n.refCount, a = r === void 0 ? !1 : r, e = n.scheduler) : o = n ?? 1 / 0, _p({
    connector: function() {
      return new Tm(o, t, e);
    },
    resetOnError: !0,
    resetOnComplete: !1,
    resetOnRefCountZero: a
  });
}
function Ke() {
  for (var n = [], t = 0; t < arguments.length; t++)
    n[t] = arguments[t];
  var e = Js(n);
  return kt(function(s, i) {
    (e ? la(n, s, e) : la(n, s)).subscribe(i);
  });
}
function ci(n, t) {
  return kt(function(e, s) {
    var i = null, r = 0, o = !1, a = function() {
      return o && !i && s.complete();
    };
    e.subscribe(lt(s, function(h) {
      i?.unsubscribe();
      var c = 0, l = r++;
      gt(n(h, l)).subscribe(i = lt(s, function(u) {
        return s.next(t ? t(h, u, l, c++) : u);
      }, function() {
        i = null, a();
      }));
    }, function() {
      o = !0, a();
    }));
  });
}
function Cp() {
  return ci(Je);
}
function eo(n) {
  return kt(function(t, e) {
    gt(n).subscribe(lt(e, function() {
      return e.complete();
    }, Gs)), !e.closed && t.subscribe(e);
  });
}
function je(n, t, e) {
  var s = W(n) || t || e ? { next: n, error: t, complete: e } : n;
  return s ? kt(function(i, r) {
    var o;
    (o = s.subscribe) === null || o === void 0 || o.call(s);
    var a = !0;
    i.subscribe(lt(r, function(h) {
      var c;
      (c = s.next) === null || c === void 0 || c.call(s, h), r.next(h);
    }, function() {
      var h;
      a = !1, (h = s.complete) === null || h === void 0 || h.call(s), r.complete();
    }, function(h) {
      var c;
      a = !1, (c = s.error) === null || c === void 0 || c.call(s, h), r.error(h);
    }, function() {
      var h, c;
      a && ((h = s.unsubscribe) === null || h === void 0 || h.call(s)), (c = s.finalize) === null || c === void 0 || c.call(s);
    }));
  }) : Je;
}
function Ep(n, t) {
  return kt(function(e, s) {
    var i = t ?? {}, r = i.leading, o = r === void 0 ? !0 : r, a = i.trailing, h = a === void 0 ? !1 : a, c = !1, l = null, u = null, d = !1, f = function() {
      u?.unsubscribe(), u = null, h && (S(), d && s.complete());
    }, m = function() {
      u = null, d && s.complete();
    }, p = function(g) {
      return u = gt(n(g)).subscribe(lt(s, f, m));
    }, S = function() {
      if (c) {
        c = !1;
        var g = l;
        l = null, s.next(g), !d && p(g);
      }
    };
    e.subscribe(lt(s, function(g) {
      c = !0, l = g, !(u && !u.closed) && (o ? S() : p(g));
    }, function() {
      d = !0, !(h && c && u && !u.closed) && s.complete();
    }));
  });
}
function Pp(n, t, e) {
  t === void 0 && (t = Wr);
  var s = yp(n, t);
  return Ep(function() {
    return s;
  }, e);
}
function Tp(n, t) {
  return kt(function(e, s) {
    var i = [], r = function(o) {
      for (; 0 < i.length; )
        i.shift().error(o);
      s.error(o);
    };
    gt(n).subscribe(lt(s, function(o) {
      var a = new ke();
      i.push(a);
      var h = new gs(), c = function() {
        Us(i, a), a.complete(), h.unsubscribe();
      }, l;
      try {
        l = gt(t(o));
      } catch (u) {
        r(u);
        return;
      }
      s.next(a.asObservable()), h.add(l.subscribe(lt(s, c, Gs, r)));
    }, Gs)), e.subscribe(lt(s, function(o) {
      var a, h, c = i.slice();
      try {
        for (var l = qe(c), u = l.next(); !u.done; u = l.next()) {
          var d = u.value;
          d.next(o);
        }
      } catch (f) {
        a = { error: f };
      } finally {
        try {
          u && !u.done && (h = l.return) && h.call(l);
        } finally {
          if (a)
            throw a.error;
        }
      }
    }, function() {
      for (; 0 < i.length; )
        i.shift().complete();
      s.complete();
    }, r, function() {
      for (; 0 < i.length; )
        i.shift().unsubscribe();
    }));
  });
}
function ny(n) {
  return n.toElement ? n.toElement : n.currentTarget ? n.currentTarget : n.srcElement ? n.srcElement : null;
}
function Z(n, t, e, s = !1) {
  const i = async (r) => {
    await e(r);
  };
  try {
    n.addEventListener(t, i, s);
  } catch {
    n.attachEvent("on" + t, i);
  }
  return () => {
    try {
      n.removeEventListener(t, i, s);
    } catch {
      n.detachEvent("on" + t, i);
    }
  };
}
function iy(n, t, e, s, i = !1) {
  return Z(
    n || document.body,
    e,
    (r) => {
      r.target === t && s(r);
    },
    i
  );
}
function ry(n) {
  n.replaceWith(n.cloneNode(!0));
}
function X(n, t, e = !1) {
  return ar(n, t, { capture: e });
}
function oy(n) {
  const t = tt(
    (e) => n.register(e),
    (e, s) => {
      n.unregister?.(e, ...s || []);
    },
    // 参数转换函数
    (...e) => [...e]
  );
  return n.share ? t.pipe(
    Sp({
      bufferSize: n.bufferSize || 1,
      // 每个新订阅会收到最近一次事件
      refCount: !0
      // 最后一个订阅取消时会自动解绑事件
    })
  ) : t;
}
function Fe(n) {
  if (n.preventDefault) {
    n.preventDefault();
    return;
  }
  try {
    n.returnValue = !1;
  } catch {
  }
}
function gc(n) {
  if (n.stopPropagation) {
    n.stopPropagation();
    return;
  }
  try {
    n.cancelBubble = !0;
  } catch {
  }
}
const Mp = [
  "click",
  "dblclick",
  "wheel",
  "contextmenu",
  "mousedown",
  "mouseup",
  "mousemove",
  "mouseover",
  "mouseout",
  "mouseenter",
  "mouseleave"
], Ap = ["keydown", "keyup", "keypress"], Ip = ["touchstart", "touchend", "touchcancel", "touchmove"], kp = [
  "pointerdown",
  "pointerup",
  "pointercancel",
  "pointermove"
], Dp = [
  "dragstart",
  "drag",
  "dragend",
  "dragenter",
  "dragover",
  "dragleave",
  "drop"
], Lp = ["change"];
function so(n, t = {
  bubbles: !0,
  detail: {}
}) {
  let e;
  try {
    const s = Object.assign(
      {
        bubbles: !0,
        cancelable: !0,
        view: window,
        detail: 1,
        // screenX: e.screenX,
        // screenY: e.screenY,
        // clientX: e.clientX,
        // clientY: e.clientY,
        ctrlKey: !1,
        altKey: !1,
        shiftKey: !1,
        metaKey: !1,
        button: 0,
        relatedTarget: null
      },
      t
    );
    Mp.includes(n) ? e = new MouseEvent(n, s) : Ap.includes(n) ? e = new KeyboardEvent(n, s) : Ip.includes(n) ? e = new TouchEvent(n, s) : kp.includes(n) ? e = new PointerEvent(n, s) : Dp.includes(n) ? e = new DragEvent(n, s) : Lp.includes(n) ? e = new Event(n, s) : e = new CustomEvent(n, s);
  } catch {
    document.createEvent ? e = document.createEvent("Event").initEvent(n, !0, !0) : document.createEventObject && (e = document.createEventObject());
  }
  return e;
}
function yc(n, t, e) {
  if (n)
    if (n.dispatchEvent)
      n.dispatchEvent(e);
    else if (n.fireEvent && document.createEventObject)
      n.fireEvent("on" + t, e);
    else
      throw new Error(`Can't dispatch event : ${t}`);
}
function ay(n, t) {
  const e = n.target, s = so(t);
  yc(e, t, s);
}
function hy(n) {
  const t = n.target, e = "click";
  if (!/(SELECT|INPUT|TEXTAREA)/i.test(t.tagName)) {
    const s = so(e);
    s.view = n.view || window, s.detail = 1, s.screenX = t.screenX || 0, s.screenY = t.screenY || 0, s.clientX = t.clientX || 0, s.clientY = t.clientY || 0, s.pageX = n.pageX, s.pageY = n.pageY, s.ctrlKey = !!n.ctrlKey, s.altKey = !!n.altKey, s.shiftKey = !!n.shiftKey, s.metaKey = !!n.metaKey, s.button = 0, s.relatedTarget = null, s._constructed = !0, yc(t, e, s);
  }
}
function cy(n, t) {
  const e = n.changedTouches[0];
  return so(t, {
    bubbles: !0,
    cancelable: !0,
    view: window,
    detail: 1,
    screenX: e.screenX,
    screenY: e.screenY,
    clientX: e.clientX,
    clientY: e.clientY,
    ctrlKey: !1,
    altKey: !1,
    shiftKey: !1,
    metaKey: !1,
    button: 0,
    relatedTarget: null
  });
}
let Vs = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame, hr = window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.oCancelAnimationFrame || window.msCancelAnimationFrame;
if (!Vs) {
  let n = ct();
  Vs = (t) => {
    const e = ct(), s = Math.max(0, 16 - (e - n)), i = window.setTimeout(() => {
      t(e + s);
    }, s);
    return n = e + s, i;
  };
}
hr || (hr = (n) => {
  window.clearTimeout(n);
});
function xc(n) {
  let t = !1, e = Vs(function s(i) {
    !t && n(i) && (e = Vs(s));
  });
  return () => {
    hr(e), t = !0;
  };
}
function fa(n, t = 0) {
  if (t == 0)
    return n(ct()), () => {
    };
  {
    const e = ct();
    return xc((s) => s - e >= t ? (n(s), !1) : !0);
  }
}
function ly(n, t = 0) {
  let e = !1, s = 0;
  const i = ct();
  let r = fa(function o(a) {
    if (e)
      return;
    s++;
    const h = a - i - s * t;
    n(a, s, t <= h), r = fa(o, Math.max(0, t - h));
  }, t);
  return () => {
    r(), e = !0;
  };
}
function uy(n, t = 20) {
  const e = 1e3 / t;
  let s = 0, i;
  return () => (ct() - s >= e && (s = ct(), i = n()), i);
}
window.requestIdleCallback = window.requestIdleCallback || function(n, t) {
  const e = ct();
  return setTimeout(() => {
    const s = ct() - e;
    n({
      didTimeout: !0,
      // 是否已到设置的超时时间
      timeRemaining: () => Math.max(0, 50 - s)
      // 本帧剩余可执行时间，毫秒
    });
  }, t?.timeout);
};
window.cancelIdleCallback = window.cancelIdleCallback || function(n) {
  clearTimeout(n);
};
function Rp(n, t) {
  window.requestIdleCallback(
    (e) => {
      e.timeRemaining() > 0 || e.didTimeout ? n() : Rp(n, t);
    },
    { timeout: t?.timeout }
  );
}
let Nn = 0, cr = 0, Ye = 33, _e = 33, lr, ur = -1;
const wc = new MessageChannel(), Op = wc.port2;
wc.port1.onmessage = (n) => {
  lr && lr({
    didTimeout: ur == -1 ? !1 : ct() - Nn > ur,
    // currentCallback 执行时，是否已到设置的超时时间
    timeRemaining: () => Math.max(0, cr - ct())
    // 本帧剩余可执行时间，毫秒
  });
};
function zp(n, t) {
  return lr = n, ur = typeof t?.timeout == "number" ? t?.timeout : -1, requestAnimationFrame((e) => {
    Nn = e;
    let s = _e + Nn - cr;
    s < _e && Ye < _e ? (s < 8 && (s = 8), _e = s < Ye ? Ye : s) : s > _e && Ye > _e ? _e = s < Ye ? Ye : s : Ye = s, cr = Nn + _e, Op.postMessage(null);
  });
}
const da = new ph({
  concurrency: 1,
  timeRemaining: 0
});
let Li = !1;
function Np(n, t) {
  const e = mh({
    fn: n,
    name: t?.name,
    deadline: typeof t?.timeout == "number" ? Gt() + t.timeout : void 0
  });
  da.addTask(e), !Li && (Li = !0, zp((s) => {
    Li = !1, da.idleCallback(s);
  }));
}
class Qs {
  static _nextId = 0;
  static nextId() {
    return Qs._nextId++;
  }
}
const O = {
  // 线性
  Linear: {
    None: function(n) {
      return n;
    }
  },
  Ease: {
    In: function(n) {
      return Math.pow(n, 1.7);
    }
  },
  // 二次
  Quadratic: {
    In: function(n) {
      return n * n;
    },
    Out: function(n) {
      return n * (2 - n);
    },
    InOut: function(n) {
      return (n *= 2) < 1 ? 0.5 * n * n : -0.5 * (--n * (n - 2) - 1);
    },
    style: "cubic-bezier(0.25, 0.46, 0.45, 0.94)"
  },
  // 三次
  Cubic: {
    In: function(n) {
      return n * n * n;
    },
    Out: function(n) {
      return --n * n * n + 1;
    },
    InOut: function(n) {
      return (n *= 2) < 1 ? 0.5 * n * n * n : 0.5 * ((n -= 2) * n * n + 2);
    }
  },
  // 四次
  Quartic: {
    In: function(n) {
      return n * n * n * n;
    },
    Out: function(n) {
      return 1 - --n * n * n * n;
    },
    InOut: function(n) {
      return (n *= 2) < 1 ? 0.5 * n * n * n * n : -0.5 * ((n -= 2) * n * n * n - 2);
    }
  },
  // 五次
  Quintic: {
    In: function(n) {
      return n * n * n * n * n;
    },
    Out: function(n) {
      return --n * n * n * n * n + 1;
    },
    InOut: function(n) {
      return (n *= 2) < 1 ? 0.5 * n * n * n * n * n : 0.5 * ((n -= 2) * n * n * n * n + 2);
    }
  },
  // 正弦曲线
  Sinusoidal: {
    In: function(n) {
      return 1 - Math.sin((1 - n) * Math.PI / 2);
    },
    Out: function(n) {
      return Math.sin(n * Math.PI / 2);
    },
    InOut: function(n) {
      return 0.5 * (1 - Math.sin(Math.PI * (0.5 - n)));
    }
  },
  // 指数
  Exponential: {
    In: function(n) {
      return n === 0 ? 0 : Math.pow(1024, n - 1);
    },
    Out: function(n) {
      return n === 1 ? 1 : 1 - Math.pow(2, -10 * n);
    },
    InOut: function(n) {
      return n === 0 ? 0 : n === 1 ? 1 : (n *= 2) < 1 ? 0.5 * Math.pow(1024, n - 1) : 0.5 * (-Math.pow(2, -10 * (n - 1)) + 2);
    }
  },
  // 圆
  Circular: {
    In: function(n) {
      return 1 - Math.sqrt(1 - n * n);
    },
    Out: function(n) {
      return Math.sqrt(1 - --n * n);
    },
    InOut: function(n) {
      return (n *= 2) < 1 ? -0.5 * (Math.sqrt(1 - n * n) - 1) : 0.5 * (Math.sqrt(1 - (n -= 2) * n) + 1);
    },
    style: "cubic-bezier(0.1, 0.57, 0.1, 1)"
    // Not properly "circular" but this looks better, it should be (0.075, 0.82, 0.165, 1)
  },
  // 松紧带
  Elastic: {
    In: function(n) {
      return n === 0 ? 0 : n === 1 ? 1 : -Math.pow(2, 10 * (n - 1)) * Math.sin((n - 1.1) * 5 * Math.PI);
    },
    Out: function(n) {
      return n === 0 ? 0 : n === 1 ? 1 : Math.pow(2, -10 * n) * Math.sin((n - 0.1) * 5 * Math.PI) + 1;
    },
    InOut: function(n) {
      return n === 0 ? 0 : n === 1 ? 1 : (n *= 2, n < 1 ? -0.5 * Math.pow(2, 10 * (n - 1)) * Math.sin((n - 1.1) * 5 * Math.PI) : 0.5 * Math.pow(2, -10 * (n - 1)) * Math.sin((n - 1.1) * 5 * Math.PI) + 1);
    }
  },
  // 后退
  Back: {
    In: function(n) {
      return n === 1 ? 1 : n * n * ((1.70158 + 1) * n - 1.70158);
    },
    Out: function(n) {
      return n === 0 ? 0 : --n * n * ((1.70158 + 1) * n + 1.70158) + 1;
    },
    InOut: function(n) {
      const t = 2.5949095;
      return (n *= 2) < 1 ? 0.5 * (n * n * ((t + 1) * n - t)) : 0.5 * ((n -= 2) * n * ((t + 1) * n + t) + 2);
    },
    style: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
  },
  // 弹跳
  Bounce: {
    In: function(n) {
      return 1 - O.Bounce.Out(1 - n);
    },
    Out: function(n) {
      return n < 1 / 2.75 ? 7.5625 * n * n : n < 2 / 2.75 ? 7.5625 * (n -= 1.5 / 2.75) * n + 0.75 : n < 2.5 / 2.75 ? 7.5625 * (n -= 2.25 / 2.75) * n + 0.9375 : 7.5625 * (n -= 2.625 / 2.75) * n + 0.984375;
    },
    InOut: function(n) {
      return n < 0.5 ? O.Bounce.In(n * 2) * 0.5 : O.Bounce.Out(n * 2 - 1) * 0.5 + 0.5;
    }
  },
  // 生成指数
  generatePow: function(n = 4) {
    return n = n < Number.EPSILON ? Number.EPSILON : n, n = n > 1e4 ? 1e4 : n, {
      In: function(t) {
        return t ** n;
      },
      Out: function(t) {
        return 1 - (1 - t) ** n;
      },
      InOut: function(t) {
        return t < 0.5 ? (t * 2) ** n / 2 : (1 - (2 - t * 2) ** n) / 2 + 0.5;
      }
    };
  },
  // 随机
  random: function(n) {
    return Math.random();
  },
  // 步数
  createStep: function(n) {
    return function(t) {
      return Math.floor(t * n) / n;
    };
  },
  // 增加噪音
  createNoisyEasing: function(n, t = 0.1) {
    const e = 1 - t;
    return function(s) {
      return t * Math.random() + e * n(s);
    };
  },
  swing: function(n) {
    return n + Math.sin(n * Math.PI * 2) / 2;
  },
  causeSeizures: function(n) {
    return n + 0.2 * Math.random() - 0.1;
  }
};
function Yp(n) {
  switch (n) {
    case O.Quadratic.In:
      return O.Quadratic.Out;
    case O.Quadratic.Out:
      return O.Quadratic.In;
    case O.Quadratic.InOut:
      return O.Quadratic.InOut;
    case O.Cubic.In:
      return O.Cubic.Out;
    case O.Cubic.Out:
      return O.Cubic.In;
    case O.Cubic.InOut:
      return O.Cubic.InOut;
    case O.Quartic.In:
      return O.Quartic.Out;
    case O.Quartic.Out:
      return O.Quartic.In;
    case O.Quartic.InOut:
      return O.Quartic.InOut;
    case O.Quintic.In:
      return O.Quintic.Out;
    case O.Quintic.Out:
      return O.Quintic.In;
    case O.Quintic.InOut:
      return O.Quintic.InOut;
    case O.Sinusoidal.In:
      return O.Sinusoidal.Out;
    case O.Sinusoidal.Out:
      return O.Sinusoidal.In;
    case O.Sinusoidal.InOut:
      return O.Sinusoidal.InOut;
    case O.Exponential.In:
      return O.Exponential.Out;
    case O.Exponential.Out:
      return O.Exponential.In;
    case O.Exponential.InOut:
      return O.Exponential.InOut;
    case O.Circular.In:
      return O.Circular.Out;
    case O.Circular.Out:
      return O.Circular.In;
    case O.Circular.InOut:
      return O.Circular.InOut;
    case O.Elastic.In:
      return O.Elastic.Out;
    case O.Elastic.Out:
      return O.Elastic.In;
    case O.Elastic.InOut:
      return O.Elastic.InOut;
    case O.Back.In:
      return O.Back.Out;
    case O.Back.Out:
      return O.Back.In;
    case O.Back.InOut:
      return O.Back.InOut;
    case O.Bounce.In:
      return O.Bounce.Out;
    case O.Bounce.Out:
      return O.Bounce.In;
    case O.Bounce.InOut:
      return O.Bounce.InOut;
    default:
      return n;
  }
}
const Bp = 4, Xp = 1e-3, Fp = 1e-7, Up = 10, Ms = 11, xn = 1 / (Ms - 1), Gp = typeof Float32Array == "function";
function bc(n, t) {
  return 1 - 3 * t + 3 * n;
}
function vc(n, t) {
  return 3 * t - 6 * n;
}
function _c(n) {
  return 3 * n;
}
function qn(n, t, e) {
  return ((bc(t, e) * n + vc(t, e)) * n + _c(t)) * n;
}
function Sc(n, t, e) {
  return 3 * bc(t, e) * n * n + 2 * vc(t, e) * n + _c(t);
}
function Vp(n, t, e, s, i) {
  let r, o, a = 0;
  do
    o = t + (e - t) / 2, r = qn(o, s, i) - n, r > 0 ? e = o : t = o;
  while (Math.abs(r) > Fp && ++a < Up);
  return o;
}
function $p(n, t, e, s) {
  for (let i = 0; i < Bp; ++i) {
    const r = Sc(t, e, s);
    if (r === 0)
      return t;
    const o = qn(t, e, s) - n;
    t -= o / r;
  }
  return t;
}
function qp(n) {
  return n;
}
function Cc(n, t, e, s) {
  if (!(0 <= n && n <= 1 && 0 <= e && e <= 1))
    throw new Error("bezier x values must be in [0, 1] range");
  if (n === t && e === s)
    return qp;
  const i = Gp ? new Float32Array(Ms) : new Array(Ms);
  for (let o = 0; o < Ms; ++o)
    i[o] = qn(o * xn, n, e);
  function r(o) {
    let a = 0, h = 1;
    const c = Ms - 1;
    for (; h !== c && i[h] <= o; ++h)
      a += xn;
    --h;
    const l = (o - i[h]) / (i[h + 1] - i[h]), u = a + l * xn, d = Sc(u, n, e);
    return d >= Xp ? $p(o, u, n, e) : d === 0 ? u : Vp(
      o,
      a,
      a + xn,
      n,
      e
    );
  }
  return (o) => o === 0 || o === 1 ? o : qn(r(o), t, s);
}
function Ec(n) {
  switch (n) {
    case "linear":
      return [0, 0, 1, 1];
    case "ease":
      return [0.25, 0.1, 0.25, 1];
    case "ease-in":
      return [0.42, 0, 1, 1];
    case "ease-in-out":
      return [0.42, 0, 0.58, 1];
    case "ease-out":
      return [0, 0, 0.58, 1];
  }
}
function jp(n) {
  const [t, e, s, i] = Ec(n);
  return [1 - s, 1 - i, 1 - t, 1 - e];
}
function fy(n) {
  return Cc(...Ec(n));
}
function dy(n) {
  return Cc(...jp(n));
}
const Ae = {
  Utils: {
    Linear: function(n, t, e) {
      return (t - n) * e + n;
    },
    Factorial: function() {
      const n = [1];
      return function(t) {
        let e = 1;
        if (n[t])
          return n[t];
        for (let s = t; s > 1; s--)
          e *= s;
        return n[t] = e, e;
      };
    }(),
    Bernstein: function(n, t) {
      const e = Ae.Utils.Factorial;
      return e(n) / e(t) / e(n - t);
    },
    // 卡特穆尔·罗姆
    CatmullRom: function(n, t, e, s, i) {
      const r = (e - n) * 0.5, o = (s - t) * 0.5, a = i * i, h = i * a;
      return (2 * t - 2 * e + r + o) * h + (-3 * t + 3 * e - 2 * r - o) * a + r * i + t;
    },
    QuadraticBezier: (n, t, e, s) => {
      const i = 1 - s;
      return i * i * n + 2 * i * s * t + s * s * e;
    },
    CubicBezier: (n, t, e, s, i) => {
      const r = 1 - i;
      return r * r * r * n + 3 * r * r * i * t + 3 * r * i * i * e + i * i * i * s;
    }
  },
  // 线性
  Linear: function(n, t) {
    const e = n.length - 1, s = e * t, i = Math.floor(s), r = Ae.Utils.Linear;
    return t < 0 ? r(n[0], n[1], s) : t > 1 ? r(n[e], n[e - 1], e - s) : r(n[i], n[i + 1 > e ? e : i + 1], s - i);
  },
  // 贝塞尔
  Bezier: function(n, t) {
    let e = 0;
    const s = n.length - 1, i = Math.pow, r = Ae.Utils.Bernstein;
    for (let o = 0; o <= s; o++)
      e += i(1 - t, s - o) * i(t, o) * n[o] * r(s, o);
    return e;
  },
  // 卡特穆尔·罗姆
  CatmullRom: function(n, t) {
    const e = n.length - 1;
    let s = e * t, i = Math.floor(s);
    const r = Ae.Utils.CatmullRom;
    return n[0] === n[e] ? (t < 0 && (i = Math.floor(s = e * (1 + t))), r(
      n[(i - 1 + e) % e],
      n[i],
      n[(i + 1) % e],
      n[(i + 2) % e],
      s - i
    )) : t < 0 ? n[0] - (r(n[0], n[0], n[1], n[1], -s) - n[0]) : t > 1 ? n[e] - (r(n[e], n[e], n[e - 1], n[e - 1], s - e) - n[e]) : r(
      n[i ? i - 1 : 0],
      n[i],
      n[e < i + 1 ? e : i + 1],
      n[e < i + 2 ? e : i + 2],
      s - i
    );
  }
};
class Pc {
  _tweens = {};
  _tweensAddedDuringUpdate = {};
  getAll() {
    return Object.keys(this._tweens).map((t) => this._tweens[t]);
  }
  removeAll() {
    this._tweens = {};
  }
  add(t) {
    this._tweens[t.getId()] = t, this._tweensAddedDuringUpdate[t.getId()] = t;
  }
  remove(t) {
    delete this._tweens[t.getId()], delete this._tweensAddedDuringUpdate[t.getId()];
  }
  update(t = ct(), e = !1) {
    const s = Object.keys(this._tweens);
    for (let i = 0; i < s.length; i++) {
      const r = this._tweens[s[i]], o = !e;
      r && r.update(t, o) === !1 && !e && delete this._tweens[s[i]];
    }
    return !!Object.keys(this._tweens).length;
  }
}
const $t = new Pc();
class Tc {
  constructor(t, e = $t) {
    this._object = t, this._group = e;
  }
  _id = Qs.nextId();
  // 是否正在执行
  _isPlaying = !1;
  // 动画开始时间
  _startTime = 0;
  // 动画延迟时间
  _delayTime = 0;
  // 动画持续时间
  _durationTime = 1e3;
  // 是否暂停
  _isPaused = !1;
  // 暂停开始时间
  _pauseStartTime = 0;
  // 动画重复次数初始值
  _initialRepeat = 0;
  // 动画重复次数剩余值
  _repeat = 0;
  // 动画重复间隔
  _repeatDelayTime;
  // 动画重复时是否倒置
  _yoyo = !1;
  // 是否倒置运行
  _reversed = !1;
  // 初始值
  _valuesStart = {};
  // 结束值
  _valuesEnd = {};
  // reverse时的初始值
  _valuesStartRepeat = {};
  // 缓动函数
  _easingFunction = O.Linear.None;
  // 插值函数
  _interpolationFunction = Ae.Linear;
  // 链式动画数组
  _chainedTweens = [];
  // 链式动画是否已停止
  _isChainStopped = !1;
  // 动画开始hook
  _onStartCallback;
  // 动画开始hook是否已被执行
  _onStartCallbackFired = !1;
  // 动画每轮repeat开始hook
  _onEveryStartCallback;
  // 动画每轮repeat开始hook是否已被执行
  _onEveryStartCallbackFired = !1;
  // 动画更新hook
  _onUpdateCallback;
  // 动画repeat hook
  _onRepeatCallback;
  // 动画完成hook
  _onCompleteCallback;
  // 动画结束hook
  _onStopCallback;
  // 是否强制结束动画
  _goToEnd = !1;
  getId() {
    return this._id;
  }
  isPlaying() {
    return this._isPlaying;
  }
  isPaused() {
    return this._isPaused;
  }
  to(t, e) {
    return this._valuesEnd = Object.create(t), e !== void 0 && (this._durationTime = e), this;
  }
  duration(t = 1e3) {
    return this._durationTime = t, this;
  }
  start(t = ct()) {
    if (this._isPlaying)
      return this;
    if (this._group && this._group.add(this), this._repeat = this._initialRepeat, this._reversed) {
      this._reversed = !1;
      for (const e in this._valuesStartRepeat)
        this._swapEndStartRepeatValues(e), this._valuesStart[e] = this._valuesStartRepeat[e];
    }
    return this._isPlaying = !0, this._isPaused = !1, this._onStartCallbackFired = !1, this._onEveryStartCallbackFired = !1, this._isChainStopped = !1, this._startTime = t, this._startTime += this._delayTime, this._setupProperties(
      this._object,
      this._valuesStart,
      this._valuesEnd,
      this._valuesStartRepeat
    ), this;
  }
  _setupProperties(t, e, s, i) {
    for (const r in s) {
      const o = t[r], a = Array.isArray(o), h = a ? "array" : typeof o, c = !a && Array.isArray(s[r]);
      if (!(h === "undefined" || h === "function")) {
        if (c) {
          let l = s[r];
          if (l.length === 0)
            continue;
          l = l.map(
            this._handleRelativeValue.bind(this, o)
          ), s[r] = [o].concat(l);
        }
        if ((h === "object" || a) && o && !c) {
          e[r] = a ? [] : {};
          for (const l in o)
            e[r][l] = o[l];
          i[r] = a ? [] : {}, this._setupProperties(
            o,
            e[r],
            s[r],
            i[r]
          );
        } else
          typeof e[r] > "u" && (e[r] = o), a || (e[r] *= 1), c ? i[r] = s[r].slice().reverse() : i[r] = e[r] || 0;
      }
    }
  }
  stop() {
    return this._isChainStopped || (this._isChainStopped = !0, this.stopChainedTweens()), this._isPlaying ? (this._group && this._group.remove(this), this._isPlaying = !1, this._isPaused = !1, this._onStopCallback && this._onStopCallback(this._object), this) : this;
  }
  end() {
    return this._goToEnd = !0, this.update(1 / 0), this;
  }
  pause(t = ct()) {
    return this._isPaused || !this._isPlaying ? this : (this._isPaused = !0, this._pauseStartTime = t, this._group && this._group.remove(this), this);
  }
  resume(t = ct()) {
    return !this._isPaused || !this._isPlaying ? this : (this._isPaused = !1, this._startTime += t - this._pauseStartTime, this._pauseStartTime = 0, this._group && this._group.add(this), this);
  }
  stopChainedTweens() {
    for (let t = 0, e = this._chainedTweens.length; t < e; t++)
      this._chainedTweens[t].stop();
    return this;
  }
  group(t = $t) {
    return this._group = t, this;
  }
  delay(t = 0) {
    return this._delayTime = t, this;
  }
  repeat(t = 0) {
    return this._initialRepeat = t, this._repeat = t, this;
  }
  repeatDelay(t) {
    return this._repeatDelayTime = t, this;
  }
  yoyo(t = !1) {
    return this._yoyo = t, this;
  }
  easing(t = O.Linear.None) {
    return this._easingFunction = t, this;
  }
  interpolation(t = Ae.Linear) {
    return this._interpolationFunction = t, this;
  }
  chain(...t) {
    return this._chainedTweens = t, this;
  }
  onStart(t) {
    return this._onStartCallback = t, this;
  }
  onEveryStart(t) {
    return this._onEveryStartCallback = t, this;
  }
  onUpdate(t) {
    return this._onUpdateCallback = t, this;
  }
  onRepeat(t) {
    return this._onRepeatCallback = t, this;
  }
  onComplete(t) {
    return this._onCompleteCallback = t, this;
  }
  onStop(t) {
    return this._onStopCallback = t, this;
  }
  /**
   * @returns true if the tween is still playing after the update, false otherwise
   */
  update(t = ct(), e = !0) {
    if (this._isPaused)
      return !0;
    let s, i;
    const r = this._startTime + this._durationTime;
    if (!this._goToEnd && !this._isPlaying) {
      if (t > r)
        return !1;
      e && this.start(t);
    }
    if (this._goToEnd = !1, t < this._startTime)
      return !0;
    this._onStartCallbackFired === !1 && (this._onStartCallback && this._onStartCallback(this._object), this._onStartCallbackFired = !0), this._onEveryStartCallbackFired === !1 && (this._onEveryStartCallback && this._onEveryStartCallback(this._object), this._onEveryStartCallbackFired = !0), i = (t - this._startTime) / this._durationTime, i = this._durationTime === 0 || i > 1 ? 1 : i;
    const o = this._easingFunction(i);
    if (this._updateProperties(
      this._object,
      this._valuesStart,
      this._valuesEnd,
      o
    ), this._onUpdateCallback && this._onUpdateCallback(this._object, i), i === 1)
      if (this._repeat > 0) {
        isFinite(this._repeat) && this._repeat--;
        for (s in this._valuesStartRepeat)
          !this._yoyo && typeof this._valuesEnd[s] == "string" && (this._valuesStartRepeat[s] = this._valuesStartRepeat[s] + parseFloat(this._valuesEnd[s])), this._yoyo && this._swapEndStartRepeatValues(s), this._valuesStart[s] = this._valuesStartRepeat[s];
        return this._yoyo && (this._reversed = !this._reversed), this._repeatDelayTime !== void 0 ? this._startTime = t + this._repeatDelayTime : this._startTime = t + this._delayTime, this._onRepeatCallback && this._onRepeatCallback(this._object), this._onEveryStartCallbackFired = !1, !0;
      } else {
        this._onCompleteCallback && this._onCompleteCallback(this._object);
        for (let a = 0, h = this._chainedTweens.length; a < h; a++)
          this._chainedTweens[a].start(this._startTime + this._durationTime);
        return this._isPlaying = !1, !1;
      }
    return !0;
  }
  _updateProperties(t, e, s, i) {
    for (const r in s) {
      if (e[r] === void 0)
        continue;
      const o = e[r] || 0;
      let a = s[r];
      const h = Array.isArray(t[r]), c = Array.isArray(a);
      !h && c ? t[r] = this._interpolationFunction(
        a,
        i
      ) : typeof a == "object" && a ? this._updateProperties(t[r], o, a, i) : (a = this._handleRelativeValue(
        o,
        a
      ), typeof a == "number" && (t[r] = o + (a - o) * i));
    }
  }
  // Parses relative end values with start as base (e.g.: +10, -3)
  _handleRelativeValue(t, e) {
    return typeof e != "string" ? e : e.charAt(0) === "+" || e.charAt(0) === "-" ? t + parseFloat(e) : parseFloat(e);
  }
  _swapEndStartRepeatValues(t) {
    const e = this._valuesStartRepeat[t], s = this._valuesEnd[t];
    typeof s == "string" ? this._valuesStartRepeat[t] = this._valuesStartRepeat[t] + parseFloat(s) : this._valuesStartRepeat[t] = s, this._valuesEnd[t] = e;
  }
}
const Hp = Qs.nextId, Wp = $t.getAll.bind($t), Zp = $t.removeAll.bind($t), Jp = $t.add.bind($t), Kp = $t.remove.bind($t), Qp = $t.update.bind($t), my = {
  now: ct,
  Sequence: Qs,
  Easing: O,
  Interpolation: Ae,
  Group: Pc,
  Tween: Tc,
  nextId: Hp,
  getAll: Wp,
  removeAll: Zp,
  add: Jp,
  remove: Kp,
  update: Qp
};
class ma {
  autoStart;
  startTime;
  oldTime;
  elapsedTime;
  running;
  constructor(t = !0) {
    this.autoStart = t, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
  }
  start() {
    this.startTime = ct(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
  }
  stop() {
    this.getElapsedTime(), this.running = !1, this.autoStart = !1;
  }
  // 毫秒
  getElapsedTime() {
    return this.getDelta(), this.elapsedTime;
  }
  // 毫秒
  getDelta() {
    let t = 0;
    if (this.autoStart && !this.running)
      return this.start(), 0;
    if (this.running) {
      const e = ct();
      t = e - this.oldTime, this.oldTime = e, this.elapsedTime += t;
    }
    return t;
  }
}
class li {
  tweens = [];
  /// 每帧时间
  frameDuration;
  onGroupStart;
  onGroupComplete;
  constructor(t) {
    this.frameDuration = t?.frameDuration || 1e3, this.onGroupStart = t?.onGroupStart, this.onGroupComplete = t?.onGroupComplete;
  }
  get count() {
    return this.tweens.length;
  }
  clear() {
    this.tweens = [];
  }
  sort(t = !1) {
    bf(
      this.tweens,
      (e, s) => t ? e.delay > s.delay : e.delay <= s.delay
    );
  }
  cloneTweens(t = this.tweens) {
    const e = [];
    return t.forEach((s) => {
      const i = { ...s };
      delete i.tween, i.fromValues = { ...i.fromValues }, i.toValues = { ...i.toValues }, e.push(i);
    }), e;
  }
  addTween(t, e, s) {
    const i = {
      fromValues: t,
      toValues: e,
      frames: typeof s?.frames == "number" ? s.frames : 1,
      /// 默认顺序执行
      delay: typeof s?.delay == "number" ? s.delay : this.tweens.length,
      easeFunction: s?.easeFunction || O.Linear.None,
      interpolationFunction: s?.interpolationFunction || Ae.Linear,
      repeat: typeof s?.repeat == "number" ? s.repeat : 0,
      yoyo: s?.yoyo || !1,
      onStart: s?.onStart || (() => {
      }),
      onUpdate: s?.onUpdate || (() => {
      }),
      onComplete: s?.onComplete || (() => {
      })
    };
    return this.tweens.push(i), this;
  }
  cancelRequestAnimationCycle = () => {
  };
  runTweens(t) {
    this.cancelRequestAnimationCycle();
    const e = new ma(), s = this.frameDuration;
    return new Promise((i) => {
      this.onGroupStart?.(), this.cancelRequestAnimationCycle = xc(
        (r) => {
          if (!this.isPaused) {
            const a = Math.max(0, r - this.pausedDuration), h = Math.max(
              0,
              e.getElapsedTime() - this.pausedDuration
            );
            t.filter((c) => c.delay * s <= h).forEach((c) => {
              c.tween || (c.tween = new Tc({ ...c.fromValues }).to({ ...c.toValues }, c.frames * s).easing(c.easeFunction).interpolation(c.interpolationFunction).repeat(c.repeat).yoyo(c.yoyo).onStart(c.onStart).onUpdate(c.onUpdate).onComplete(c.onComplete), c.tween.start(a)), /// 进行中的tween
              (c.delay + c.frames * (c.repeat + 1)) * s > h ? c.tween.update(a) : (c.tween.isPlaying() && c.tween.end(), rh(t, c));
            });
          }
          const o = !!t.length;
          return o || (this.onGroupComplete?.(), i()), o;
        }
      );
    });
  }
  isPaused = !1;
  pausedClock = new ma();
  pausedDuration = 0;
  /// 注意传入的 tweens 为深拷贝新数据
  play(t = this.cloneTweens(this.tweens)) {
    this.isPaused = !1, this.pausedDuration = 0, this.runTweens(t);
  }
  reverse() {
    const t = this.cloneTweens(this.tweens);
    let e = 0;
    t.forEach((s) => {
      e = Math.max(e, s.delay + s.frames), s.easeFunction = Yp(s.easeFunction);
      const i = { ...s.toValues };
      s.toValues = { ...s.fromValues }, s.fromValues = { ...i };
    }), t.forEach((s) => {
      s.delay = e - s.frames;
    }), this.play(t);
  }
  pause() {
    this.pausedClock.start(), this.isPaused = !0;
  }
  resume() {
    this.pausedDuration += this.pausedClock.getElapsedTime(), this.pausedClock.stop(), this.isPaused = !1;
  }
}
const tn = new nf({
  objectSignature: (n) => n.name
  // size: getNextPrime(500),
  // overflow: HashTableOverflow.SLIDE
});
function Mc(n, t = tn) {
  let e = t?.find((s) => s.el == n);
  return e || (e = ho(n), t.put(e), e);
}
function fr(n, t, e = tn) {
  const s = Mc(n, e);
  s.alternate || (s.alternate = ho(n), is(s.alternate.props, s.props, !0)), t(s.alternate);
}
function Ac(n = tn) {
  n.update((t) => {
    const e = t.alternate;
    return e && (co(t, e), t.props = e.props, t.alternate = void 0), !0;
  });
}
function py(n = tn) {
  Ac(n);
}
function Ic(n = tn) {
  Np(() => Ac(n), {
    name: "PATCH_VNODES",
    timeout: 50
  });
}
function gy(n, t, e, s, i) {
  const r = t / e;
  let o = 0, a = 0;
  switch (n) {
    case "aspectFit":
      r >= 1 ? (o = s, a = o / r, a > i && (a = i, o = a * r)) : (a = i, o = a * r, o > s && (o = s, a = o / r));
      break;
    case "aspectFill":
      r >= 1 ? (a = i, o = a * r) : (o = s, a = o / r);
      break;
    case "widthFix":
      o = s, a = o / r;
      break;
    case "heightFix":
      a = i, o = a * r;
      break;
    case "scaleToFill":
    default:
      o = s, a = i;
      break;
  }
  return { width: o, height: a };
}
function t0(n) {
  try {
    const t = document.createElement("canvas"), e = t.getContext("2d");
    return t.width = n.width, t.height = n.height, e.drawImage(n, 0, 0, t.width, t.height), e.getImageData(0, 0, t.width, t.height);
  } catch {
    return new ImageData(n.width, n.height);
  }
}
const yy = (n) => {
  const t = n.width, e = n.height, s = t * e * 3, i = s + 54, r = [
    // WORD bfType -- The file type signature; must be "BM"
    66,
    77,
    // DWORD bfSize -- The size, in bytes, of the bitmap file
    i & 255,
    i >> 8 & 255,
    i >> 16 & 255,
    i >> 24 & 255,
    // WORD bfReserved1 -- Reserved; must be zero
    0,
    0,
    // WORD bfReserved2 -- Reserved; must be zero
    0,
    0,
    // DWORD bfOffBits -- The offset, in bytes, from the beginning of the BITMAPFILEHEADER structure to the bitmap bits.
    54,
    0,
    0,
    0
  ], o = [
    // DWORD biSize -- The number of bytes required by the structure
    40,
    0,
    0,
    0,
    // LONG biWidth -- The width of the bitmap, in pixels
    t & 255,
    t >> 8 & 255,
    t >> 16 & 255,
    t >> 24 & 255,
    // LONG biHeight -- The height of the bitmap, in pixels
    e & 255,
    e >> 8 & 255,
    e >> 16 & 255,
    e >> 24 & 255,
    // WORD biPlanes -- The number of planes for the target device. This value must be set to 1
    1,
    0,
    // WORD biBitCount -- The number of bits-per-pixel, 24 bits-per-pixel -- the bitmap
    // has a maximum of 2^24 colors (16777216, Truecolor)
    24,
    0,
    // DWORD biCompression -- The type of compression, BI_RGB (code 0) -- uncompressed
    0,
    0,
    0,
    0,
    // DWORD biSizeImage -- The size, in bytes, of the image. This may be set to zero for BI_RGB bitmaps
    s & 255,
    s >> 8 & 255,
    s >> 16 & 255,
    s >> 24 & 255,
    // LONG biXPelsPerMeter, unused
    0,
    0,
    0,
    0,
    // LONG biYPelsPerMeter, unused
    0,
    0,
    0,
    0,
    // DWORD biClrUsed, the number of color indexes of palette, unused
    0,
    0,
    0,
    0,
    // DWORD biClrImportant, unused
    0,
    0,
    0,
    0
  ], a = (4 - t * 3 % 4) % 4, h = n.data;
  let c = "";
  const l = t << 2;
  let u = e;
  const d = String.fromCharCode;
  do {
    const m = l * (u - 1);
    let p = "";
    for (let S = 0; S < t; S++) {
      const g = S << 2;
      p += d(h[m + g + 2]) + d(h[m + g + 1]) + d(h[m + g]);
    }
    for (let S = 0; S < a; S++)
      p += String.fromCharCode(0);
    c += p;
  } while (--u);
  function f(m) {
    if (!window.btoa)
      throw "btoa undefined";
    let p = "";
    if (typeof m == "string")
      p = m;
    else
      for (let S = 0; S < m.length; S++)
        p += String.fromCharCode(m[S]);
    return btoa(p);
  }
  return f(r.concat(o)) + f(c);
};
function xy(n) {
  const { width: t, height: e } = n, s = document.createElement("canvas"), i = s.getContext("2d");
  return s.width = t, s.height = e, i.putImageData(n, 0, 0, 0, 0, t, e), s.toDataURL("image/png");
}
const wy = (n, t, e) => {
  const { width: s, height: i } = n, r = document.createElement("canvas"), o = r.getContext("2d");
  r.width = s, r.height = i, o.putImageData(n, 0, 0, 0, 0, s, i);
  const a = `image/${t ? t.toLowerCase() : "png"}`;
  r.toBlob(
    (h) => {
      e?.(null, h);
    },
    a,
    1
  );
};
function by(n, t) {
  return createImageBitmap(n, t);
}
function vy(n) {
  const t = [], e = [], s = [];
  let i = 0;
  for (let h = 0, c = n.data.length; h < c; h += 4)
    t[i] = n.data[h], e[i] = n.data[h + 1], s[i] = n.data[h + 2], i += 1;
  const r = Ri(t), o = Ri(e), a = Ri(s);
  return "rgb(" + r + "," + o + "," + a + ")";
}
function Ri(n) {
  const t = {}, e = [], s = [];
  for (let a = 0; a < n.length; a++)
    t[n[a]] ? e.push(n[a]) : t[n[a]] = 1;
  let i = 0;
  for (let a = 0; a < e.length; a++) {
    i = 0;
    for (let h = 0; h < e.length; h++)
      e[a] === e[h] && (i += 1), s[a] = i;
  }
  const r = Math.max.apply(null, s);
  let o = 0;
  for (; o < s.length; o++)
    if (s[o] === r)
      return;
  return e[o];
}
const _y = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4;
      i[h] = t[(o * e + e - a - 1) * 4], i[h + 1] = t[(o * e + e - a - 1) * 4 + 1], i[h + 2] = t[(o * e + e - a - 1) * 4 + 2], i[h + 3] = t[(o * e + e - a - 1) * 4 + 3];
    }
  return new ImageData(i, e, s);
}, Sy = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4;
      i[h] = t[((s - o - 1) * e + a) * 4], i[h + 1] = t[((s - o - 1) * e + a) * 4 + 1], i[h + 2] = t[((s - o - 1) * e + a) * 4 + 2], i[h + 3] = t[((s - o - 1) * e + a) * 4 + 3];
    }
  return new ImageData(i, e, s);
}, Cy = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < e; o++)
    for (let a = 0; a < s; a++) {
      const h = (o * s + a) * 4;
      i[h] = t[(a * e + e - o - 1) * 4], i[h + 1] = t[(a * e + e - o - 1) * 4 + 1], i[h + 2] = t[(a * e + e - o - 1) * 4 + 2], i[h + 3] = t[(a * e + e - o - 1) * 4 + 3];
    }
  return new ImageData(i, s, e);
}, Ey = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < e; o++)
    for (let a = 0; a < s; a++) {
      const h = (o * s + a) * 4;
      i[h] = t[((s - a - 1) * e + o) * 4], i[h + 1] = t[((s - a - 1) * e + o) * 4 + 1], i[h + 2] = t[((s - a - 1) * e + o) * 4 + 2], i[h + 3] = t[((s - a - 1) * e + o) * 4 + 3];
    }
  return new ImageData(i, s, e);
}, Py = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4, c = (t[h] + t[h + 1] + t[h + 2]) / 3;
      i[h] = c, i[h + 1] = c, i[h + 2] = c, i[h + 3] = t[h + 3];
    }
  return new ImageData(i, e, s);
}, Ty = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4, c = 0.2126 * t[h] + 0.7152 * t[h + 1] + 0.0722 * t[h + 2];
      i[h] = c, i[h + 1] = c, i[h + 2] = c, i[h + 3] = t[h + 3];
    }
  return new ImageData(i, e, s);
}, My = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4, l = (t[h] + t[h + 1] + t[h + 2]) / 3 > 127 ? 255 : 0;
      i[h] = l, i[h + 1] = l, i[h + 2] = l, i[h + 3] = t[h + 3];
    }
  return new ImageData(i, e, s);
}, Ay = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4;
      i[h] = 255 - t[h], i[h + 1] = 255 - t[h + 1], i[h + 2] = 255 - t[h + 2], i[h + 3] = t[h + 3];
    }
  return new ImageData(i, e, s);
}, Iy = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4;
      i[h] = t[h], i[h + 1] = 0, i[h + 2] = 0, i[h + 3] = t[h + 3];
    }
  return new ImageData(i, e, s);
}, ky = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4;
      i[h] = 0, i[h + 1] = t[h + 1], i[h + 2] = 0, i[h + 3] = t[h + 3];
    }
  return new ImageData(i, e, s);
}, Dy = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4;
      i[h] = 0, i[h + 1] = 0, i[h + 2] = t[h + 2], i[h + 3] = t[h + 3];
    }
  return new ImageData(i, e, s);
}, Ly = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4;
      i[h] = t[h], i[h + 1] = t[h + 1], i[h + 2] = 0, i[h + 3] = t[h + 3];
    }
  return new ImageData(i, e, s);
}, Ry = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4;
      i[h] = t[h], i[h + 1] = 0, i[h + 2] = t[h + 1], i[h + 3] = t[h + 3];
    }
  return new ImageData(i, e, s);
}, Oy = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4;
      i[h] = 0, i[h + 1] = t[h + 1], i[h + 2] = t[h + 1], i[h + 3] = t[h + 3];
    }
  return new ImageData(i, e, s);
}, zy = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4, c = (t[h + 1] + t[h + 2]) / 2;
      i[h] = t[h], i[h + 1] = c, i[h + 2] = c, i[h + 3] = t[h + 3];
    }
  return new ImageData(i, e, s);
}, Ny = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4, c = (t[h] + t[h + 2]) / 2;
      i[h] = c, i[h + 1] = t[h + 1], i[h + 2] = c, i[h + 3] = t[h + 3];
    }
  return new ImageData(i, e, s);
}, Yy = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4, c = (t[h] + t[h + 1]) / 2;
      i[h] = c, i[h + 1] = c, i[h + 2] = t[h + 2], i[h + 3] = t[h + 3];
    }
  return new ImageData(i, e, s);
}, By = (n) => kc(n, [-1, -1, -1, -1, 9, -1, -1, -1, -1]), Xy = (n) => kc(n, [-1, -1, -1, -1, 8, -1, -1, -1, -1]), Fy = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4;
      i[h] = t[h], i[h + 1] = t[h + 1], i[h + 2] = t[h + 2], i[h + 3] = 255;
    }
  return new ImageData(i, e, s);
}, Uy = (n) => {
  const { data: t, width: e, height: s } = n, i = new Uint8ClampedArray(t.length);
  for (let o = 0; o < s; o++)
    for (let a = 0; a < e; a++) {
      const h = (o * e + a) * 4;
      if (t[h + 3] === 0)
        i[h] = 255, i[h + 1] = 255, i[h + 2] = 255, i[h + 3] = 255;
      else {
        const c = Dc(
          [
            t[h],
            t[h + 1],
            t[h + 2],
            t[h + 3]
          ],
          [255, 255, 255, 255]
        );
        i[h] = c[0], i[h + 1] = c[1], i[h + 2] = c[2], i[h + 3] = c[3];
      }
    }
  return new ImageData(i, e, s);
};
function Gy(n, t, e, s, i, r = !1, o) {
  const { data: a, width: h, height: c } = n;
  let l = i, u = s, d = t, f = e;
  if (l < 0 ? l = 0 : l > h && (l = h), u < 0 ? u = 0 : u > c && (u = c), d < 1 ? d = 1 : d > h && (d = h), f < 1 ? f = 1 : f > c && (f = c), l + d > h && (d = h - l), u + f > c && (f = c - u), r) {
    const m = new Uint8ClampedArray(a.length);
    for (let S = 0; S < c; S++)
      for (let g = 0; g < h; g++) {
        const b = (S * h + g) * 4;
        g >= l && g <= l + d && S >= u && S <= u + f ? (m[b] = a[b], m[b + 1] = a[b + 1], m[b + 2] = a[b + 2], m[b + 3] = a[b + 3]) : (m[b] = 255, m[b + 1] = 255, m[b + 2] = 255, m[b + 3] = o && ["JPG", "JPEG"].includes(o.toUpperCase()) ? 255 : 0);
      }
    return new ImageData(m, h, c);
  } else {
    const m = new Uint8ClampedArray(d * f * 4);
    for (let S = u; S <= u + f; S++)
      for (let g = l; g <= l + d; g++) {
        const b = ((S - u) * d + g - l) * 4, x = (S * h + g) * 4;
        m[b] = a[x], m[b + 1] = a[x + 1], m[b + 2] = a[x + 2], m[b + 3] = a[x + 3];
      }
    return new ImageData(m, d, f);
  }
}
function Vy(n, t, e, s) {
  const { data: i, width: r, height: o } = n;
  let a = t;
  a > Math.floor(r / 2) && (a = Math.floor(r / 2)), a > Math.floor(o / 2) && (a = Math.floor(o / 2)), a < 0 && (a = 0);
  const h = new Uint8ClampedArray(i.length);
  for (let l = 0; l < o; l++)
    for (let u = 0; u < r; u++) {
      const d = (l * r + u) * 4;
      let f = -1;
      u < a ? l < a ? f = Math.sqrt(
        Math.pow(a - u - 1, 2) + Math.pow(a - l - 1, 2)
      ) : l > o - a - 1 && (f = Math.sqrt(
        Math.pow(a - u - 1, 2) + Math.pow(l - (o - a), 2)
      )) : u > r - a - 1 && (l < a ? f = Math.sqrt(
        Math.pow(u - (r - a), 2) + Math.pow(a - l - 1, 2)
      ) : l > o - a - 1 && (f = Math.sqrt(
        Math.pow(u - (r - a), 2) + Math.pow(l - (o - a), 2)
      ))), Math.round(f) > a ? (h[d] = 255, h[d + 1] = 255, h[d + 2] = 255, h[d + 3] = s || e.toUpperCase() === "PNG" ? 0 : 255) : (h[d] = i[d], h[d + 1] = i[d + 1], h[d + 2] = i[d + 2], h[d + 3] = s || e.toUpperCase() === "PNG" ? i[d + 3] : 255);
    }
  return new ImageData(h, r, o);
}
function $y(n, t, e, s, i, r = 1e4) {
  const o = new Image();
  o.src = n;
  const a = document.createElement("canvas"), h = a.getContext("2d");
  return a.width = r, a.height = r, h.drawImage(o, 0, 0, t, e, 0, 0, s, i), h.getImageData(0, 0, s, i);
}
function qy(n, t) {
  const { data: e, width: s, height: i } = n, r = new Uint8ClampedArray(e.length);
  for (let a = 0; a < i; a++)
    for (let h = 0; h < s; h++) {
      const c = (a * s + h) * 4;
      r[c] = Math.max(
        Math.min(e[c] + t, 255),
        0
      ), r[c + 1] = Math.max(
        Math.min(e[c + 1] + t, 255),
        0
      ), r[c + 2] = Math.max(
        Math.min(e[c + 2] + t, 255),
        0
      ), r[c + 3] = e[c + 3];
    }
  return new ImageData(r, s, i);
}
function jy(n, t, e = !1) {
  const { data: s, width: i, height: r } = n, o = new Uint8ClampedArray(s.length);
  for (let h = 0; h < r; h++)
    for (let c = 0; c < i; c++) {
      const l = (h * i + c) * 4;
      s[l + 3] === 0 ? (o[l] = 255, o[l + 1] = 255, o[l + 2] = 255) : (o[l] = s[l], o[l + 1] = s[l + 1], o[l + 2] = s[l + 2]);
      let u = s[l + 3];
      e ? u = Math.max(Math.min(Math.floor(255 * t), 255), 0) : u = Math.max(Math.min(Math.floor(u + 255 * t), 255), 0), o[l + 3] = u;
    }
  return new ImageData(o, i, r);
}
function Hy(n, t, e, s) {
  const { data: i, width: r, height: o } = n, {
    data: a,
    width: h,
    height: c
  } = t;
  let l = e, u = s;
  e + c > o && (l = o - c), s + h > r && (u = r - h);
  const d = new Uint8ClampedArray(i.length);
  for (let m = 0; m < o; m++)
    for (let p = 0; p < r; p++) {
      const S = (m * r + p) * 4;
      if (p < u || p > u + h || m <= l || m >= l + c)
        d[S] = i[S], d[S + 1] = i[S + 1], d[S + 2] = i[S + 2], d[S + 3] = i[S + 3];
      else {
        const g = (m * r + p - ((l + 1) * r + (m - (l + 1)) * (r - h)) + h - u - 1) * 4, b = [
          a[g],
          a[g + 1],
          a[g + 2],
          a[g + 3]
        ], x = [
          i[S],
          i[S + 1],
          i[S + 2],
          i[S + 3]
        ], w = Dc(b, x);
        d[S] = w[0], d[S + 1] = w[1], d[S + 2] = w[2], d[S + 3] = w[3];
      }
    }
  return new ImageData(d, r, o);
}
function Wy(n, t, e, s, i, r = 10) {
  const { data: o, width: a, height: h } = n;
  let c = i, l = s, u = t, d = e;
  c < 0 ? c = 0 : c > a && (c = a), l < 0 ? l = 0 : l > h && (l = h), u < 1 ? u = 1 : u > a && (u = a), d < 1 ? d = 1 : d > h && (d = h), c + u > a && (u = a - c), l + d > h && (d = h - l);
  const f = new Uint8ClampedArray(o.length);
  for (let p = 0; p < h; p++)
    for (let S = 0; S < a; S++) {
      const g = (p * a + S) * 4;
      if (S >= c && S <= c + u && p >= l && p <= l + d) {
        const b = Math.floor((S - c) / r), x = Math.floor((p - l) / r);
        let w = Math.floor(
          r * (b + 1) - r / 2 + c
        ), C = Math.floor(
          r * (x + 1) - r / 2 + l
        );
        w > a - 1 && (w = a - 1), C > h - 1 && (C = h - 1);
        const _ = (C * a + w) * 4;
        f[g] = o[_], f[g + 1] = o[_ + 1], f[g + 2] = o[_ + 2], f[g + 3] = o[_ + 3];
      } else
        f[g] = o[g], f[g + 1] = o[g + 1], f[g + 2] = o[g + 2], f[g + 3] = o[g + 3];
    }
  return new ImageData(f, a, h);
}
function Zy(n, t, e = {
  backgroundColor: { r: 0, g: 0, b: 0, a: 255 },
  changeIntoColor: { r: 0, g: 0, b: 0, a: 0 }
}) {
  if (t && e) {
    const { data: s, width: i, height: r } = n, { data: o } = t, a = new Uint8ClampedArray(s.length), { backgroundColor: h, changeIntoColor: c } = e;
    for (let u = 0; u < r; u++)
      for (let d = 0; d < i; d++) {
        const f = (u * i + d) * 4, m = o[f], p = o[f + 1], S = o[f + 2], g = o[f + 3];
        m === h.r && p === h.g && S === h.b && g === h.a && c.a !== 0 ? (a[f] = c.r, a[f + 1] = c.g, a[f + 2] = c.b, a[f + 3] = c.a) : (a[f] = s[f], a[f + 1] = s[f + 1], a[f + 2] = s[f + 2], a[f + 3] = s[f + 3]);
      }
    return new ImageData(a, i, r);
  }
  return n;
}
function kc(n, t) {
  const { data: e, width: s, height: i } = n, r = new Uint8ClampedArray(e.length);
  for (let a = 0; a < i; a++)
    for (let h = 0; h < s; h++) {
      const c = (a * s + h) * 4;
      for (let l = 0; l < 3; l++) {
        const u = c + l;
        h === 0 || h === s - 1 || a === 0 || a === i - 1 ? r[u] = e[u] : r[u] = t[0] * e[u - s * 4 - 4] + t[1] * e[u - s * 4] + t[2] * e[u - s * 4 + 4] + t[3] * e[u - 4] + t[4] * e[u] + t[5] * e[u + 4] + t[6] * e[u + s * 4 - 4] + t[7] * e[u + s * 4] + t[8] * e[u + s * 4 + 4];
      }
      r[c + 3] = e[c + 3];
    }
  return new ImageData(r, s, i);
}
function Dc(n, t) {
  if (n && n.length === 4 && t && t.length === 4) {
    const e = n[3], s = t[3];
    if (e === 255 || s === 0)
      return n;
    if (e === 0)
      return t;
    {
      const i = e / 255, r = s / 255, o = Math.max(
        Math.min(
          Math.floor(
            n[0] * i + t[0] * r * (1 - i)
          ),
          255
        ),
        0
      ), a = Math.max(
        Math.min(
          Math.floor(
            n[1] * i + t[1] * r * (1 - i)
          ),
          255
        ),
        0
      ), h = Math.max(
        Math.min(
          Math.floor(
            n[2] * i + t[2] * r * (1 - i)
          ),
          255
        ),
        0
      ), c = Math.max(
        Math.min(
          Math.floor(
            (i + r * (1 - i)) * 255
          ),
          255
        ),
        0
      );
      return [o, a, h, c];
    }
  }
  return [255, 255, 255, 255];
}
const Lc = function() {
  const n = [];
  return {
    writeByte(t) {
      n.push(t & 255);
    },
    writeShort(t) {
      this.writeByte(t), this.writeByte(t >>> 8);
    },
    writeBytes(t, e = 0, s = t.length) {
      for (let i = 0; i < s; i++)
        this.writeByte(t[i + e]);
    },
    writeString(t) {
      for (let e = 0, s = t.length; e < s; e++)
        this.writeByte(t.charCodeAt(e));
    },
    toByteArray() {
      return n;
    },
    toString() {
      let t = "[";
      for (let e = 0, s = n.length; e < s; e++)
        e > 0 && (t += ","), t += n[e];
      return t += "]", t;
    }
  };
}, e0 = function() {
  let n = 0, t = 0, e = 0, s = "";
  const i = function(o) {
    if (!(o < 0)) {
      if (o < 26)
        return 65 + o;
      if (o < 52)
        return 97 + (o - 26);
      if (o < 62)
        return 48 + (o - 52);
      if (o == 62)
        return 43;
      if (o == 63)
        return 47;
    }
    throw new Error("n:" + o);
  }, r = function(o) {
    s += String.fromCharCode(i(o & 63));
  };
  return {
    writeByte(o) {
      for (n = n << 8 | o & 255, t += 8, e += 1; t >= 6; )
        r(n >>> t - 6), t -= 6;
    },
    flush() {
      if (t > 0 && (r(n << 6 - t), n = 0, t = 0), e % 3 != 0) {
        const o = 3 - e % 3;
        for (let a = 0; a < o; a++)
          s += "=";
      }
    },
    toString() {
      return s;
    }
  };
}, s0 = function(n, t, e) {
  const s = new Array(n * n), i = function(a) {
    const h = a;
    let c = 0, l = 0;
    return {
      write(u, d) {
        if (u >>> d)
          throw new Error("length over");
        for (; c + d >= 8; )
          h.writeByte(255 & (u << c | l)), d -= 8 - c, u >>>= 8 - c, l = 0, c = 0;
        l = u << c | l, c = c + d;
      },
      flush() {
        c > 0 && h.writeByte(l);
      }
    };
  }, r = function(a) {
    const h = 1 << a, c = (1 << a) + 1;
    let l = a + 1;
    const u = o();
    for (let S = 0; S < h; S++)
      u.add(String.fromCharCode(S));
    u.add(String.fromCharCode(h)), u.add(String.fromCharCode(c));
    const d = Lc(), f = i(d);
    f.write(h, l);
    let m = 0, p = String.fromCharCode(s[m]);
    for (m += 1; m < s.length; ) {
      const S = String.fromCharCode(s[m]);
      m += 1, u.contains(p + S) ? p = p + S : (f.write(u.indexOf(p), l), u.size() < 4095 && (u.size() == 1 << l && (l += 1), u.add(p + S)), p = S);
    }
    return f.write(u.indexOf(p), l), f.write(c, l), f.flush(), d.toByteArray();
  }, o = function() {
    const a = {};
    let h = 0;
    return {
      add(c) {
        if (this.contains(c))
          throw new Error("dup key:" + c);
        a[c] = h, h += 1;
      },
      size() {
        return h;
      },
      indexOf(c) {
        return a[c];
      },
      contains(c) {
        return typeof a[c] < "u";
      }
    };
  };
  return {
    setPixel(a, h, c) {
      s[h * n + a] = c;
    },
    write(a) {
      a.writeString("GIF87a"), a.writeShort(n), a.writeShort(n), a.writeByte(128), a.writeByte(0), a.writeByte(0), a.writeByte(es("0x" + t[1] + t[2])), a.writeByte(es("0x" + t[3] + t[4])), a.writeByte(es("0x" + t[5] + t[6])), a.writeByte(es("0x" + e[1] + e[2])), a.writeByte(es("0x" + e[3] + e[4])), a.writeByte(es("0x" + e[5] + e[6])), a.writeString(","), a.writeShort(0), a.writeShort(0), a.writeShort(n), a.writeShort(n), a.writeByte(0);
      const h = 2, c = r(h);
      a.writeByte(h);
      let l = 0;
      for (; c.length - l > 255; )
        a.writeByte(255), a.writeBytes(c, l, 255), l += 255;
      a.writeByte(c.length - l), a.writeBytes(c, l, c.length - l), a.writeByte(0), a.writeString(";");
    }
  };
}, n0 = function(n, t, e, s) {
  const i = s0(n, t, e);
  for (let c = 0; c < n; c++)
    for (let l = 0; l < n; l++)
      i.setPixel(l, c, s(l, c));
  const r = Lc();
  i.write(r);
  const o = e0(), a = r.toByteArray();
  for (let c = 0, l = a.length; c < l; c++)
    o.writeByte(a[c]);
  o.flush();
  let h = "";
  return h += "data:image/gif;base64,", h += o, h;
}, Rt = {
  MODE_NUMBER: 1,
  MODE_ALPHA_NUM: 2,
  MODE_8BIT_BYTE: 4,
  MODE_KANJI: 8
}, As = {
  M: 0,
  L: 1,
  H: 2,
  Q: 3
}, Se = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}, dt = {
  glog: function(n) {
    if (n < 1)
      throw new Error("glog(" + n + ")");
    return dt.LOG_TABLE[n];
  },
  gexp: function(n) {
    for (; n < 0; )
      n += 255;
    for (; n >= 256; )
      n -= 255;
    return dt.EXP_TABLE[n];
  },
  EXP_TABLE: new Array(256),
  LOG_TABLE: new Array(256)
};
for (let n = 0; n < 8; n++)
  dt.EXP_TABLE[n] = 1 << n;
for (let n = 8; n < 256; n++)
  dt.EXP_TABLE[n] = dt.EXP_TABLE[n - 4] ^ dt.EXP_TABLE[n - 5] ^ dt.EXP_TABLE[n - 6] ^ dt.EXP_TABLE[n - 8];
for (let n = 0; n < 255; n++)
  dt.LOG_TABLE[dt.EXP_TABLE[n]] = n;
const K = {
  PATTERN_POSITION_TABLE: [
    [],
    [6, 18],
    [6, 22],
    [6, 26],
    [6, 30],
    [6, 34],
    [6, 22, 38],
    [6, 24, 42],
    [6, 26, 46],
    [6, 28, 50],
    [6, 30, 54],
    [6, 32, 58],
    [6, 34, 62],
    [6, 26, 46, 66],
    [6, 26, 48, 70],
    [6, 26, 50, 74],
    [6, 30, 54, 78],
    [6, 30, 56, 82],
    [6, 30, 58, 86],
    [6, 34, 62, 90],
    [6, 28, 50, 72, 94],
    [6, 26, 50, 74, 98],
    [6, 30, 54, 78, 102],
    [6, 28, 54, 80, 106],
    [6, 32, 58, 84, 110],
    [6, 30, 58, 86, 114],
    [6, 34, 62, 90, 118],
    [6, 26, 50, 74, 98, 122],
    [6, 30, 54, 78, 102, 126],
    [6, 26, 52, 78, 104, 130],
    [6, 30, 56, 82, 108, 134],
    [6, 34, 60, 86, 112, 138],
    [6, 30, 58, 86, 114, 142],
    [6, 34, 62, 90, 118, 146],
    [6, 30, 54, 78, 102, 126, 150],
    [6, 24, 50, 76, 102, 128, 154],
    [6, 28, 54, 80, 106, 132, 158],
    [6, 32, 58, 84, 110, 136, 162],
    [6, 26, 54, 82, 110, 138, 166],
    [6, 30, 58, 86, 114, 142, 170]
  ],
  G15: 1335,
  G18: 7973,
  G15_MASK: 21522,
  getBCHTypeInfo: function(n) {
    let t = n << 10;
    for (; K.getBCHDigit(t) - K.getBCHDigit(K.G15) >= 0; )
      t ^= K.G15 << K.getBCHDigit(t) - K.getBCHDigit(K.G15);
    return (n << 10 | t) ^ K.G15_MASK;
  },
  getBCHTypeNumber: function(n) {
    let t = n << 12;
    for (; K.getBCHDigit(t) - K.getBCHDigit(K.G18) >= 0; )
      t ^= K.G18 << K.getBCHDigit(t) - K.getBCHDigit(K.G18);
    return n << 12 | t;
  },
  getBCHDigit: function(n) {
    let t = 0;
    for (; n != 0; )
      t++, n >>>= 1;
    return t;
  },
  getPatternPosition: function(n) {
    return K.PATTERN_POSITION_TABLE[n - 1];
  },
  getMask: function(n, t, e) {
    switch (n) {
      case Se.PATTERN000:
        return (t + e) % 2 == 0;
      case Se.PATTERN001:
        return t % 2 == 0;
      case Se.PATTERN010:
        return e % 3 == 0;
      case Se.PATTERN011:
        return (t + e) % 3 == 0;
      case Se.PATTERN100:
        return (Math.floor(t / 2) + Math.floor(e / 3)) % 2 == 0;
      case Se.PATTERN101:
        return t * e % 2 + t * e % 3 == 0;
      case Se.PATTERN110:
        return (t * e % 2 + t * e % 3) % 2 == 0;
      case Se.PATTERN111:
        return (t * e % 3 + (t + e) % 2) % 2 == 0;
      default:
        throw new Error("bad maskPattern:" + n);
    }
  },
  getErrorCorrectPolynomial: function(n) {
    let t = new fs([1], 0);
    for (let e = 0; e < n; e++)
      t = t.multiply(new fs([1, dt.gexp(e)], 0));
    return t;
  },
  getLengthInBits: function(n, t) {
    if (1 <= t && t < 10)
      switch (n) {
        case Rt.MODE_NUMBER:
          return 10;
        case Rt.MODE_ALPHA_NUM:
          return 9;
        case Rt.MODE_8BIT_BYTE:
          return 8;
        case Rt.MODE_KANJI:
          return 8;
        default:
          throw new Error("mode:" + n);
      }
    else if (t < 27)
      switch (n) {
        case Rt.MODE_NUMBER:
          return 12;
        case Rt.MODE_ALPHA_NUM:
          return 11;
        case Rt.MODE_8BIT_BYTE:
          return 16;
        case Rt.MODE_KANJI:
          return 10;
        default:
          throw new Error("mode:" + n);
      }
    else if (t < 41)
      switch (n) {
        case Rt.MODE_NUMBER:
          return 14;
        case Rt.MODE_ALPHA_NUM:
          return 13;
        case Rt.MODE_8BIT_BYTE:
          return 16;
        case Rt.MODE_KANJI:
          return 12;
        default:
          throw new Error("mode:" + n);
      }
    else
      throw new Error("type:" + t);
  },
  getLostPoint: function(n) {
    const t = n.getModuleCount();
    let e = 0;
    for (let r = 0; r < t; r++)
      for (let o = 0; o < t; o++) {
        let a = 0;
        const h = n.isDark(r, o);
        for (let c = -1; c <= 1; c++)
          if (!(r + c < 0 || t <= r + c))
            for (let l = -1; l <= 1; l++)
              o + l < 0 || t <= o + l || c == 0 && l == 0 || h == n.isDark(r + c, o + l) && a++;
        a > 5 && (e += 3 + a - 5);
      }
    for (let r = 0; r < t - 1; r++)
      for (let o = 0; o < t - 1; o++) {
        let a = 0;
        n.isDark(r, o) && a++, n.isDark(r + 1, o) && a++, n.isDark(r, o + 1) && a++, n.isDark(r + 1, o + 1) && a++, (a == 0 || a == 4) && (e += 3);
      }
    for (let r = 0; r < t; r++)
      for (let o = 0; o < t - 6; o++)
        n.isDark(r, o) && !n.isDark(r, o + 1) && n.isDark(r, o + 2) && n.isDark(r, o + 3) && n.isDark(r, o + 4) && !n.isDark(r, o + 5) && n.isDark(r, o + 6) && (e += 40);
    for (let r = 0; r < t; r++)
      for (let o = 0; o < t - 6; o++)
        n.isDark(o, r) && !n.isDark(o + 1, r) && n.isDark(o + 2, r) && n.isDark(o + 3, r) && n.isDark(o + 4, r) && !n.isDark(o + 5, r) && n.isDark(o + 6, r) && (e += 40);
    let s = 0;
    for (let r = 0; r < t; r++)
      for (let o = 0; o < t; o++)
        n.isDark(o, r) && s++;
    const i = Math.abs(100 * s / t / t - 50) / 5;
    return e += i * 10, e;
  }
};
class fs {
  num;
  constructor(t, e) {
    if (t.length == null)
      throw new Error(t.length + "/" + e);
    let s = 0;
    for (; s < t.length && t[s] == 0; )
      s++;
    this.num = new Array(t.length - s + e);
    for (let i = 0; i < t.length - s; i++)
      this.num[i] = t[i + s];
  }
  get(t) {
    return this.num[t];
  }
  getLength() {
    return this.num.length;
  }
  multiply(t) {
    const e = new Array(this.getLength() + t.getLength() - 1);
    for (let s = 0; s < this.getLength(); s++)
      for (let i = 0; i < t.getLength(); i++)
        e[s + i] ^= dt.gexp(
          dt.glog(this.get(s)) + dt.glog(t.get(i))
        );
    return new fs(e, 0);
  }
  mod(t) {
    if (this.getLength() - t.getLength() < 0)
      return this;
    const e = dt.glog(this.get(0)) - dt.glog(t.get(0)), s = new Array(this.getLength());
    for (let i = 0; i < this.getLength(); i++)
      s[i] = this.get(i);
    for (let i = 0; i < t.getLength(); i++)
      s[i] ^= dt.gexp(dt.glog(t.get(i)) + e);
    return new fs(s, 0).mod(t);
  }
}
class ge {
  totalCount;
  dataCount;
  constructor(t, e) {
    this.totalCount = t, this.dataCount = e;
  }
  static RS_BLOCK_TABLE = [
    // L
    // M
    // Q
    // H
    // 1
    [1, 26, 19],
    [1, 26, 16],
    [1, 26, 13],
    [1, 26, 9],
    // 2
    [1, 44, 34],
    [1, 44, 28],
    [1, 44, 22],
    [1, 44, 16],
    // 3
    [1, 70, 55],
    [1, 70, 44],
    [2, 35, 17],
    [2, 35, 13],
    // 4
    [1, 100, 80],
    [2, 50, 32],
    [2, 50, 24],
    [4, 25, 9],
    // 5
    [1, 134, 108],
    [2, 67, 43],
    [2, 33, 15, 2, 34, 16],
    [2, 33, 11, 2, 34, 12],
    // 6
    [2, 86, 68],
    [4, 43, 27],
    [4, 43, 19],
    [4, 43, 15],
    // 7
    [2, 98, 78],
    [4, 49, 31],
    [2, 32, 14, 4, 33, 15],
    [4, 39, 13, 1, 40, 14],
    // 8
    [2, 121, 97],
    [2, 60, 38, 2, 61, 39],
    [4, 40, 18, 2, 41, 19],
    [4, 40, 14, 2, 41, 15],
    // 9
    [2, 146, 116],
    [3, 58, 36, 2, 59, 37],
    [4, 36, 16, 4, 37, 17],
    [4, 36, 12, 4, 37, 13],
    // 10
    [2, 86, 68, 2, 87, 69],
    [4, 69, 43, 1, 70, 44],
    [6, 43, 19, 2, 44, 20],
    [6, 43, 15, 2, 44, 16],
    // 11
    [4, 101, 81],
    [1, 80, 50, 4, 81, 51],
    [4, 50, 22, 4, 51, 23],
    [3, 36, 12, 8, 37, 13],
    // 12
    [2, 116, 92, 2, 117, 93],
    [6, 58, 36, 2, 59, 37],
    [4, 46, 20, 6, 47, 21],
    [7, 42, 14, 4, 43, 15],
    // 13
    [4, 133, 107],
    [8, 59, 37, 1, 60, 38],
    [8, 44, 20, 4, 45, 21],
    [12, 33, 11, 4, 34, 12],
    // 14
    [3, 145, 115, 1, 146, 116],
    [4, 64, 40, 5, 65, 41],
    [11, 36, 16, 5, 37, 17],
    [11, 36, 12, 5, 37, 13],
    // 15
    [5, 109, 87, 1, 110, 88],
    [5, 65, 41, 5, 66, 42],
    [5, 54, 24, 7, 55, 25],
    [11, 36, 12],
    // 16
    [5, 122, 98, 1, 123, 99],
    [7, 73, 45, 3, 74, 46],
    [15, 43, 19, 2, 44, 20],
    [3, 45, 15, 13, 46, 16],
    // 17
    [1, 135, 107, 5, 136, 108],
    [10, 74, 46, 1, 75, 47],
    [1, 50, 22, 15, 51, 23],
    [2, 42, 14, 17, 43, 15],
    // 18
    [5, 150, 120, 1, 151, 121],
    [9, 69, 43, 4, 70, 44],
    [17, 50, 22, 1, 51, 23],
    [2, 42, 14, 19, 43, 15],
    // 19
    [3, 141, 113, 4, 142, 114],
    [3, 70, 44, 11, 71, 45],
    [17, 47, 21, 4, 48, 22],
    [9, 39, 13, 16, 40, 14],
    // 20
    [3, 135, 107, 5, 136, 108],
    [3, 67, 41, 13, 68, 42],
    [15, 54, 24, 5, 55, 25],
    [15, 43, 15, 10, 44, 16],
    // 21
    [4, 144, 116, 4, 145, 117],
    [17, 68, 42],
    [17, 50, 22, 6, 51, 23],
    [19, 46, 16, 6, 47, 17],
    // 22
    [2, 139, 111, 7, 140, 112],
    [17, 74, 46],
    [7, 54, 24, 16, 55, 25],
    [34, 37, 13],
    // 23
    [4, 151, 121, 5, 152, 122],
    [4, 75, 47, 14, 76, 48],
    [11, 54, 24, 14, 55, 25],
    [16, 45, 15, 14, 46, 16],
    // 24
    [6, 147, 117, 4, 148, 118],
    [6, 73, 45, 14, 74, 46],
    [11, 54, 24, 16, 55, 25],
    [30, 46, 16, 2, 47, 17],
    // 25
    [8, 132, 106, 4, 133, 107],
    [8, 75, 47, 13, 76, 48],
    [7, 54, 24, 22, 55, 25],
    [22, 45, 15, 13, 46, 16],
    // 26
    [10, 142, 114, 2, 143, 115],
    [19, 74, 46, 4, 75, 47],
    [28, 50, 22, 6, 51, 23],
    [33, 46, 16, 4, 47, 17],
    // 27
    [8, 152, 122, 4, 153, 123],
    [22, 73, 45, 3, 74, 46],
    [8, 53, 23, 26, 54, 24],
    [12, 45, 15, 28, 46, 16],
    // 28
    [3, 147, 117, 10, 148, 118],
    [3, 73, 45, 23, 74, 46],
    [4, 54, 24, 31, 55, 25],
    [11, 45, 15, 31, 46, 16],
    // 29
    [7, 146, 116, 7, 147, 117],
    [21, 73, 45, 7, 74, 46],
    [1, 53, 23, 37, 54, 24],
    [19, 45, 15, 26, 46, 16],
    // 30
    [5, 145, 115, 10, 146, 116],
    [19, 75, 47, 10, 76, 48],
    [15, 54, 24, 25, 55, 25],
    [23, 45, 15, 25, 46, 16],
    // 31
    [13, 145, 115, 3, 146, 116],
    [2, 74, 46, 29, 75, 47],
    [42, 54, 24, 1, 55, 25],
    [23, 45, 15, 28, 46, 16],
    // 32
    [17, 145, 115],
    [10, 74, 46, 23, 75, 47],
    [10, 54, 24, 35, 55, 25],
    [19, 45, 15, 35, 46, 16],
    // 33
    [17, 145, 115, 1, 146, 116],
    [14, 74, 46, 21, 75, 47],
    [29, 54, 24, 19, 55, 25],
    [11, 45, 15, 46, 46, 16],
    // 34
    [13, 145, 115, 6, 146, 116],
    [14, 74, 46, 23, 75, 47],
    [44, 54, 24, 7, 55, 25],
    [59, 46, 16, 1, 47, 17],
    // 35
    [12, 151, 121, 7, 152, 122],
    [12, 75, 47, 26, 76, 48],
    [39, 54, 24, 14, 55, 25],
    [22, 45, 15, 41, 46, 16],
    // 36
    [6, 151, 121, 14, 152, 122],
    [6, 75, 47, 34, 76, 48],
    [46, 54, 24, 10, 55, 25],
    [2, 45, 15, 64, 46, 16],
    // 37
    [17, 152, 122, 4, 153, 123],
    [29, 74, 46, 14, 75, 47],
    [49, 54, 24, 10, 55, 25],
    [24, 45, 15, 46, 46, 16],
    // 38
    [4, 152, 122, 18, 153, 123],
    [13, 74, 46, 32, 75, 47],
    [48, 54, 24, 14, 55, 25],
    [42, 45, 15, 32, 46, 16],
    // 39
    [20, 147, 117, 4, 148, 118],
    [40, 75, 47, 7, 76, 48],
    [43, 54, 24, 22, 55, 25],
    [10, 45, 15, 67, 46, 16],
    // 40
    [19, 148, 118, 6, 149, 119],
    [18, 75, 47, 31, 76, 48],
    [34, 54, 24, 34, 55, 25],
    [20, 45, 15, 61, 46, 16]
  ];
  static getRSBlocks(t, e) {
    const s = ge.getRsBlockTable(t, e);
    if (s == null)
      throw new Error(
        "bad rs block @ typeNumber:" + t + "/errorCorrectLevel:" + e
      );
    const i = s.length / 3, r = [];
    for (let o = 0; o < i; o++) {
      const a = s[o * 3 + 0], h = s[o * 3 + 1], c = s[o * 3 + 2];
      for (let l = 0; l < a; l++)
        r.push(new ge(h, c));
    }
    return r;
  }
  static getRsBlockTable(t, e) {
    switch (e) {
      case As.L:
        return ge.RS_BLOCK_TABLE[(t - 1) * 4 + 0];
      case As.M:
        return ge.RS_BLOCK_TABLE[(t - 1) * 4 + 1];
      case As.Q:
        return ge.RS_BLOCK_TABLE[(t - 1) * 4 + 2];
      case As.H:
        return ge.RS_BLOCK_TABLE[(t - 1) * 4 + 3];
      default:
        return;
    }
  }
}
class pa {
  buffer;
  length;
  constructor() {
    this.buffer = [], this.length = 0;
  }
  get(t) {
    const e = Math.floor(t / 8);
    return (this.buffer[e] >>> 7 - t % 8 & 1) == 1;
  }
  put(t, e) {
    for (let s = 0; s < e; s++)
      this.putBit((t >>> e - s - 1 & 1) == 1);
  }
  getLengthInBits() {
    return this.length;
  }
  putBit(t) {
    const e = Math.floor(this.length / 8);
    this.buffer.length <= e && this.buffer.push(0), t && (this.buffer[e] |= 128 >>> this.length % 8), this.length++;
  }
}
class i0 {
  mode;
  data;
  constructor(t) {
    this.mode = Rt.MODE_8BIT_BYTE, this.data = t;
  }
  getLength() {
    return this.data.length;
  }
  write(t) {
    for (let e = 0, s = this.data.length; e < s; e++)
      t.put(this.data.charCodeAt(e), 8);
  }
}
class Ue {
  static PAD0 = 236;
  static PAD1 = 17;
  typeNumber;
  errorCorrectLevel;
  modules;
  moduleCount;
  dataCache;
  dataList;
  constructor(t, e) {
    this.typeNumber = t, this.errorCorrectLevel = As[e], this.modules = [], this.moduleCount = 0, this.dataCache = null, this.dataList = [];
  }
  addData(t) {
    const e = new i0(t);
    this.dataList.push(e), this.dataCache = null;
  }
  isDark(t, e) {
    if (t < 0 || this.moduleCount <= t || e < 0 || this.moduleCount <= e)
      throw new Error(t + "," + e);
    return this.modules[t][e];
  }
  getModuleCount() {
    return this.moduleCount;
  }
  make() {
    if (this.typeNumber < 1) {
      let t = 1;
      for (t = 1; t < 40; t++) {
        const e = ge.getRSBlocks(
          t,
          this.errorCorrectLevel
        ), s = new pa();
        let i = 0;
        for (let r = 0; r < e.length; r++)
          i += e[r].dataCount;
        for (let r = 0; r < this.dataList.length; r++) {
          const o = this.dataList[r];
          s.put(o.mode, 4), s.put(
            o.getLength(),
            K.getLengthInBits(o.mode, t)
          ), o.write(s);
        }
        if (s.getLengthInBits() <= i * 8)
          break;
      }
      this.typeNumber = t;
    }
    this.makeImpl(!1, this.getBestMaskPattern());
  }
  makeImpl(t, e) {
    this.moduleCount = this.typeNumber * 4 + 17, this.modules = new Array(this.moduleCount);
    for (let s = 0; s < this.moduleCount; s++) {
      this.modules[s] = new Array(this.moduleCount);
      for (let i = 0; i < this.moduleCount; i++)
        this.modules[s][i] = null;
    }
    this.setupPositionProbePattern(0, 0), this.setupPositionProbePattern(this.moduleCount - 7, 0), this.setupPositionProbePattern(0, this.moduleCount - 7), this.setupPositionAdjustPattern(), this.setupTimingPattern(), this.setupTypeInfo(t, e), this.typeNumber >= 7 && this.setupTypeNumber(t), this.dataCache == null && (this.dataCache = Ue.createData(
      this.typeNumber,
      this.errorCorrectLevel,
      this.dataList
    )), this.mapData(this.dataCache, e);
  }
  setupPositionProbePattern(t, e) {
    for (let s = -1; s <= 7; s++)
      if (!(t + s <= -1 || this.moduleCount <= t + s))
        for (let i = -1; i <= 7; i++)
          e + i <= -1 || this.moduleCount <= e + i || (0 <= s && s <= 6 && (i == 0 || i == 6) || 0 <= i && i <= 6 && (s == 0 || s == 6) || 2 <= s && s <= 4 && 2 <= i && i <= 4 ? this.modules[t + s][e + i] = !0 : this.modules[t + s][e + i] = !1);
  }
  getBestMaskPattern() {
    let t = 0, e = 0;
    for (let s = 0; s < 8; s++) {
      this.makeImpl(!0, s);
      const i = K.getLostPoint(this);
      (s == 0 || t > i) && (t = i, e = s);
    }
    return e;
  }
  createMovieClip(t, e, s) {
    const i = t.createEmptyMovieClip(e, s), r = 1;
    this.make();
    for (let o = 0; o < this.modules.length; o++) {
      const a = o * r;
      for (let h = 0; h < this.modules[o].length; h++) {
        const c = h * r;
        this.modules[o][h] && (i.beginFill(0, 100), i.moveTo(c, a), i.lineTo(c + r, a), i.lineTo(c + r, a + r), i.lineTo(c, a + r), i.endFill());
      }
    }
    return i;
  }
  setupTimingPattern() {
    for (let t = 8; t < this.moduleCount - 8; t++)
      this.modules[t][6] == null && (this.modules[t][6] = t % 2 == 0);
    for (let t = 8; t < this.moduleCount - 8; t++)
      this.modules[6][t] == null && (this.modules[6][t] = t % 2 == 0);
  }
  setupPositionAdjustPattern() {
    const t = K.getPatternPosition(this.typeNumber);
    for (let e = 0; e < t.length; e++)
      for (let s = 0; s < t.length; s++) {
        const i = t[e], r = t[s];
        if (this.modules[i][r] == null)
          for (let o = -2; o <= 2; o++)
            for (let a = -2; a <= 2; a++)
              o == -2 || o == 2 || a == -2 || a == 2 || o == 0 && a == 0 ? this.modules[i + o][r + a] = !0 : this.modules[i + o][r + a] = !1;
      }
  }
  setupTypeNumber(t) {
    const e = K.getBCHTypeNumber(this.typeNumber);
    for (let s = 0; s < 18; s++) {
      const i = !t && (e >> s & 1) == 1;
      this.modules[Math.floor(s / 3)][s % 3 + this.moduleCount - 8 - 3] = i;
    }
    for (let s = 0; s < 18; s++) {
      const i = !t && (e >> s & 1) == 1;
      this.modules[s % 3 + this.moduleCount - 8 - 3][Math.floor(s / 3)] = i;
    }
  }
  setupTypeInfo(t, e) {
    const s = this.errorCorrectLevel << 3 | e, i = K.getBCHTypeInfo(s);
    for (let r = 0; r < 15; r++) {
      const o = !t && (i >> r & 1) == 1;
      r < 6 ? this.modules[r][8] = o : r < 8 ? this.modules[r + 1][8] = o : this.modules[this.moduleCount - 15 + r][8] = o;
    }
    for (let r = 0; r < 15; r++) {
      const o = !t && (i >> r & 1) == 1;
      r < 8 ? this.modules[8][this.moduleCount - r - 1] = o : r < 9 ? this.modules[8][15 - r - 1 + 1] = o : this.modules[8][15 - r - 1] = o;
    }
    this.modules[this.moduleCount - 8][8] = !t;
  }
  mapData(t, e) {
    let s = -1, i = this.moduleCount - 1, r = 7, o = 0;
    for (let a = this.moduleCount - 1; a > 0; a -= 2)
      for (a == 6 && a--; ; ) {
        for (let h = 0; h < 2; h++)
          if (this.modules[i][a - h] == null) {
            let c = !1;
            o < t.length && (c = (t[o] >>> r & 1) == 1), K.getMask(e, i, a - h) && (c = !c), this.modules[i][a - h] = c, r--, r == -1 && (o++, r = 7);
          }
        if (i += s, i < 0 || this.moduleCount <= i) {
          i -= s, s = -s;
          break;
        }
      }
  }
  static createData(t, e, s) {
    const i = ge.getRSBlocks(t, e), r = new pa();
    for (let a = 0; a < s.length; a++) {
      const h = s[a];
      r.put(h.mode, 4), r.put(
        h.getLength(),
        K.getLengthInBits(h.mode, t)
      ), h.write(r);
    }
    let o = 0;
    for (let a = 0; a < i.length; a++)
      o += i[a].dataCount;
    if (r.getLengthInBits() > o * 8)
      throw new Error(
        "code length overflow. (" + r.getLengthInBits() + ">" + o * 8 + ")"
      );
    for (r.getLengthInBits() + 4 <= o * 8 && r.put(0, 4); r.getLengthInBits() % 8 != 0; )
      r.putBit(!1);
    for (; !(r.getLengthInBits() >= o * 8 || (r.put(Ue.PAD0, 8), r.getLengthInBits() >= o * 8)); )
      r.put(Ue.PAD1, 8);
    return Ue.createBytes(r, i);
  }
  static createBytes(t, e) {
    let s = 0, i = 0, r = 0;
    const o = new Array(e.length), a = new Array(e.length);
    for (let u = 0; u < e.length; u++) {
      const d = e[u].dataCount, f = e[u].totalCount - d;
      i = Math.max(i, d), r = Math.max(r, f), o[u] = new Array(d);
      for (let g = 0; g < o[u].length; g++)
        o[u][g] = 255 & t.buffer[g + s];
      s += d;
      const m = K.getErrorCorrectPolynomial(f), S = new fs(o[u], m.getLength() - 1).mod(m);
      a[u] = new Array(m.getLength() - 1);
      for (let g = 0; g < a[u].length; g++) {
        const b = g + S.getLength() - a[u].length;
        a[u][g] = b >= 0 ? S.get(b) : 0;
      }
    }
    let h = 0;
    for (let u = 0; u < e.length; u++)
      h += e[u].totalCount;
    const c = new Array(h);
    let l = 0;
    for (let u = 0; u < i; u++)
      for (let d = 0; d < e.length; d++)
        u < o[d].length && (c[l++] = o[d][u]);
    for (let u = 0; u < r; u++)
      for (let d = 0; d < e.length; d++)
        u < a[d].length && (c[l++] = a[d][u]);
    return c;
  }
}
const ga = Math.ceil, zs = Math.floor, ya = Math.round;
function Jy(n, t) {
  const e = Qa(n), s = t?.ecc || "H", i = t?.size || 256, r = -1, o = t?.padding || 0, a = t?.color || "#000000", h = t?.background || "#ffffff", c = new Ue(r, s);
  c.addData(e), c.make();
  const l = c.getModuleCount(), u = (i - o * 2) / l, d = o, f = i - o;
  return n0(i, a, h, function(m, p) {
    if (d <= m && m < f && d <= p && p < f) {
      const S = zs((m - d) / u), g = zs((p - d) / u);
      return c.isDark(g, S) ? 0 : 1;
    } else
      return 1;
  });
}
function Ky(n, t) {
  const e = t.x || 0, s = t.y || 0, i = Qa(n), r = t.ctx, o = t.ecc || "H", a = typeof t.size == "number" ? zs(t.size) : 256, h = t.padding || 0, c = -1, l = t.color || "#000000", u = t.background || "#ffffff", d = new Ue(c, o);
  d.addData(i), d.make();
  const f = d.getModuleCount(), m = (a - h * 2) / f;
  r.fillStyle = u, r.fillRect(e, s, a, a);
  for (let p = 0; p < f; p++)
    for (let S = 0; S < f; S++) {
      const g = ga((S + 1) * m) - zs(S * m), b = ga((p + 1) * m) - zs(p * m);
      r.fillStyle = d.isDark(p, S) ? l : u, r.fillRect(
        e + ya(S * m) + h,
        s + ya(p * m) + h,
        g,
        b
      );
    }
}
function q(n) {
  return n * Math.PI / 180;
}
function wt(n) {
  return n * 180 / Math.PI;
}
function $s(n, t, e = 0) {
  return Math.sqrt(n * n + t * t + e * e);
}
function Ge(n, t, e, s) {
  return $s(e - n, s - t);
}
function qt(n, t, e, s) {
  let i = Math.atan2(s - t, e - n);
  return i < 0 && (i += Math.PI * 2), i;
}
function He(n, t) {
  return {
    dx: Math.cos(n) * t,
    dy: Math.sin(n) * t
  };
}
function Qy(n, t, e) {
  if (typeof e == "number") {
    const s = $s(n, t, e);
    return {
      x: n /= s,
      y: t /= s,
      z: e /= s
    };
  } else {
    const s = $s(n, t);
    return {
      x: n /= s,
      y: t /= s
    };
  }
}
function t1(n, t, e, s, i = 10) {
  if (Math.abs(e - n) < i && Math.abs(s - t) < i)
    return "no";
  const r = wt(qt(n, t, e, s));
  return r >= -135 && r <= -45 ? "up" : r > 45 && r < 135 ? "down" : r >= 135 && r <= 180 || r >= -180 && r < -135 ? "left" : "right";
}
class no {
  // x, y, z 表示旋转轴的方向
  _x;
  _y;
  _z;
  // w 表示旋转角度的余弦值（实际上是 cos(θ/2)）
  _w;
  constructor(t = 0, e = 0, s = 0, i = 1) {
    this._x = t, this._y = e, this._z = s, this._w = i;
  }
  static slerpFlat(t, e, s, i, r, o, a) {
    let h = s[i + 0], c = s[i + 1], l = s[i + 2], u = s[i + 3];
    const d = r[o + 0], f = r[o + 1], m = r[o + 2], p = r[o + 3];
    if (a === 0) {
      t[e + 0] = h, t[e + 1] = c, t[e + 2] = l, t[e + 3] = u;
      return;
    }
    if (a === 1) {
      t[e + 0] = d, t[e + 1] = f, t[e + 2] = m, t[e + 3] = p;
      return;
    }
    if (u !== p || h !== d || c !== f || l !== m) {
      let S = 1 - a;
      const g = h * d + c * f + l * m + u * p, b = g >= 0 ? 1 : -1, x = 1 - g * g;
      if (x > Number.EPSILON) {
        const C = Math.sqrt(x), _ = Math.atan2(C, g * b);
        S = Math.sin(S * _) / C, a = Math.sin(a * _) / C;
      }
      const w = a * b;
      if (h = h * S + d * w, c = c * S + f * w, l = l * S + m * w, u = u * S + p * w, S === 1 - a) {
        const C = 1 / Math.sqrt(h * h + c * c + l * l + u * u);
        h *= C, c *= C, l *= C, u *= C;
      }
    }
    t[e] = h, t[e + 1] = c, t[e + 2] = l, t[e + 3] = u;
  }
  static multiplyQuaternionsFlat(t, e, s, i, r, o) {
    const a = s[i], h = s[i + 1], c = s[i + 2], l = s[i + 3], u = r[o], d = r[o + 1], f = r[o + 2], m = r[o + 3];
    return t[e] = a * m + l * u + h * f - c * d, t[e + 1] = h * m + l * d + c * u - a * f, t[e + 2] = c * m + l * f + a * d - h * u, t[e + 3] = l * m - a * u - h * d - c * f, t;
  }
  get x() {
    return this._x;
  }
  set x(t) {
    this._x = t, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(t) {
    this._y = t, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(t) {
    this._z = t, this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(t) {
    this._w = t, this._onChangeCallback();
  }
  set(t = this._x, e = this._y, s = this._z, i = this._w) {
    return this._x = t, this._y = e, this._z = s, this._w = i, this._onChangeCallback(), this;
  }
  clone() {
    return new no(this._x, this._y, this._z, this._w);
  }
  copy(t) {
    return this._x = t.x, this._y = t.y, this._z = t.z, this._w = t.w, this._onChangeCallback(), this;
  }
  setFromEuler(t, e = !0) {
    const s = t.x, i = t.y, r = t.z, o = t.order, a = Math.cos, h = Math.sin, c = a(s / 2), l = a(i / 2), u = a(r / 2), d = h(s / 2), f = h(i / 2), m = h(r / 2);
    switch (o) {
      case "XYZ":
        this._x = d * l * u + c * f * m, this._y = c * f * u - d * l * m, this._z = c * l * m + d * f * u, this._w = c * l * u - d * f * m;
        break;
      case "YXZ":
        this._x = d * l * u + c * f * m, this._y = c * f * u - d * l * m, this._z = c * l * m - d * f * u, this._w = c * l * u + d * f * m;
        break;
      case "ZXY":
        this._x = d * l * u - c * f * m, this._y = c * f * u + d * l * m, this._z = c * l * m + d * f * u, this._w = c * l * u - d * f * m;
        break;
      case "ZYX":
        this._x = d * l * u - c * f * m, this._y = c * f * u + d * l * m, this._z = c * l * m - d * f * u, this._w = c * l * u + d * f * m;
        break;
      case "YZX":
        this._x = d * l * u + c * f * m, this._y = c * f * u + d * l * m, this._z = c * l * m - d * f * u, this._w = c * l * u - d * f * m;
        break;
      case "XZY":
        this._x = d * l * u - c * f * m, this._y = c * f * u - d * l * m, this._z = c * l * m + d * f * u, this._w = c * l * u + d * f * m;
        break;
      default:
        console.warn(
          "Quaternion: .setFromEuler() encountered an unknown order: " + o
        );
    }
    return e === !0 && this._onChangeCallback(), this;
  }
  setFromAxisAngle(t, e) {
    const s = e / 2, i = Math.sin(s);
    return this._x = t.x * i, this._y = t.y * i, this._z = t.z * i, this._w = Math.cos(s), this._onChangeCallback(), this;
  }
  setFromRotationMatrix4(t) {
    const e = t.value, s = e[0], i = e[4], r = e[8], o = e[1], a = e[5], h = e[9], c = e[2], l = e[6], u = e[10], d = s + a + u;
    if (d > 0) {
      const f = 0.5 / Math.sqrt(d + 1);
      this._w = 0.25 / f, this._x = (l - h) * f, this._y = (r - c) * f, this._z = (o - i) * f;
    } else if (s > a && s > u) {
      const f = 2 * Math.sqrt(1 + s - a - u);
      this._w = (l - h) / f, this._x = 0.25 * f, this._y = (i + o) / f, this._z = (r + c) / f;
    } else if (a > u) {
      const f = 2 * Math.sqrt(1 + a - s - u);
      this._w = (r - c) / f, this._x = (i + o) / f, this._y = 0.25 * f, this._z = (h + l) / f;
    } else {
      const f = 2 * Math.sqrt(1 + u - s - a);
      this._w = (o - i) / f, this._x = (r + c) / f, this._y = (h + l) / f, this._z = 0.25 * f;
    }
    return this._onChangeCallback(), this;
  }
  setFromUnitVectors(t, e) {
    let s = t.dot(e) + 1;
    return s < Number.EPSILON ? (s = 0, Math.abs(t.x) > Math.abs(t.z) ? (this._x = -t.y, this._y = t.x, this._z = 0, this._w = s) : (this._x = 0, this._y = -t.z, this._z = t.y, this._w = s)) : (this._x = t.y * e.z - t.z * e.y, this._y = t.z * e.x - t.x * e.z, this._z = t.x * e.y - t.y * e.x, this._w = s), this.normalize();
  }
  angleTo(t) {
    return 2 * Math.acos(Math.abs(N(this.dot(t), -1, 1)));
  }
  rotateTowards(t, e) {
    const s = this.angleTo(t);
    if (s === 0)
      return this;
    const i = Math.min(1, e / s);
    return this.slerp(t, i), this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  dot(t) {
    return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(
      this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w
    );
  }
  normalize() {
    let t = this.length();
    return t === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t = 1 / t, this._x = this._x * t, this._y = this._y * t, this._z = this._z * t, this._w = this._w * t), this._onChangeCallback(), this;
  }
  multiply(t) {
    return this.multiplyQuaternions(this, t);
  }
  premultiply(t) {
    return this.multiplyQuaternions(t, this);
  }
  multiplyQuaternions(t, e) {
    const s = t._x, i = t._y, r = t._z, o = t._w, a = e._x, h = e._y, c = e._z, l = e._w;
    return this._x = s * l + o * a + i * c - r * h, this._y = i * l + o * h + r * a - s * c, this._z = r * l + o * c + s * h - i * a, this._w = o * l - s * a - i * h - r * c, this._onChangeCallback(), this;
  }
  // 插值 t: 0 ~ 1
  slerp(t, e) {
    if (e === 0)
      return this;
    if (e === 1)
      return this.copy(t);
    const s = this._x, i = this._y, r = this._z, o = this._w;
    let a = o * t._w + s * t._x + i * t._y + r * t._z;
    if (a < 0 ? (this._w = -t._w, this._x = -t._x, this._y = -t._y, this._z = -t._z, a = -a) : this.copy(t), a >= 1)
      return this._w = o, this._x = s, this._y = i, this._z = r, this;
    const h = 1 - a * a;
    if (h <= Number.EPSILON) {
      const f = 1 - e;
      return this._w = f * o + e * this._w, this._x = f * s + e * this._x, this._y = f * i + e * this._y, this._z = f * r + e * this._z, this.normalize(), this;
    }
    const c = Math.sqrt(h), l = Math.atan2(c, a), u = Math.sin((1 - e) * l) / c, d = Math.sin(e * l) / c;
    return this._w = o * u + this._w * d, this._x = s * u + this._x * d, this._y = i * u + this._y * d, this._z = r * u + this._z * d, this._onChangeCallback(), this;
  }
  slerpQuaternions(t, e, s) {
    return this.copy(t).slerp(e, s);
  }
  random() {
    const t = 2 * Math.PI * Math.random(), e = 2 * Math.PI * Math.random(), s = Math.random(), i = Math.sqrt(1 - s), r = Math.sqrt(s);
    return this.set(
      i * Math.sin(t),
      i * Math.cos(t),
      r * Math.sin(e),
      r * Math.cos(e)
    );
  }
  equals(t) {
    return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
  }
  fromArray(t, e = 0) {
    return this._x = t[e], this._y = t[e + 1], this._z = t[e + 2], this._w = t[e + 3], this._onChangeCallback(), this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._w, t;
  }
  fromBufferAttribute(t, e) {
    return this._x = t.getX(e), this._y = t.getY(e), this._z = t.getZ(e), this._w = t.getW(e), this._onChangeCallback(), this;
  }
  toJSON() {
    return this.toArray();
  }
  onChange(t) {
    return this._onChangeCallback = t, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
}
class ui {
  x = 0;
  y = 0;
  constructor(t = 0, e = 0) {
    this.x = t, this.y = e;
  }
  get width() {
    return this.x;
  }
  set width(t) {
    this.x = t;
  }
  get height() {
    return this.y;
  }
  set height(t) {
    this.y = t;
  }
  set(t = 0, e = 0) {
    return this.x = t, this.y = e, this;
  }
  setScalar(t) {
    return this.x = t, this.y = t, this;
  }
  setX(t) {
    return this.x = t, this;
  }
  setY(t) {
    return this.y = t, this;
  }
  setComponent(t, e) {
    switch (t) {
      case 0:
        this.x = e;
        break;
      case 1:
        this.y = e;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  copy(t) {
    return this.x = t.x, this.y = t.y, this;
  }
  clone() {
    return new ui(this.x, this.y);
  }
  /// 交换律：  P + Q = Q + P
  /// 结合律：  (P + Q) + R =  P + (Q + R)
  /// 分配率：  a(P + Q) = aP + aQ
  add(t) {
    return this.x += t.x, this.y += t.y, this;
  }
  addScalar(t) {
    return this.x += t, this.y += t, this;
  }
  addVectors(t, e) {
    return this.x = t.x + e.x, this.y = t.y + e.y, this;
  }
  addScaledVector(t, e) {
    return this.x += t.x * e, this.y += t.y * e, this;
  }
  /// P.sub(Q) = 从 Q的终点 到 P的终点
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this;
  }
  subScalar(t) {
    return this.x -= t, this.y -= t, this;
  }
  subVectors(t, e) {
    return this.x = t.x - e.x, this.y = t.y - e.y, this;
  }
  /// 乘积
  /// 交换律：  P * Q = Q * P
  /// 结合律：  (ab)P = a(bP)
  /// 分配率：  (a + b)P = aP + bP
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this;
  }
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this;
  }
  divide(t) {
    return this.x /= t.x, this.y /= t.y, this;
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  applyMatrix3(t) {
    const e = this.x, s = this.y;
    return this.x = t.m11 * e + t.m21 * s + t.m31, this.y = t.m12 * e + t.m22 * s + t.m32, this;
  }
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this;
  }
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this;
  }
  clamp(t, e) {
    return this.x = N(this.x, t.x, e.x), this.y = N(this.y, t.y, e.y), this;
  }
  clampScalar(t, e) {
    return this.x = N(this.x, t, e), this.y = N(this.y, t, e), this;
  }
  clampLength(t, e) {
    const s = this.length();
    return this.divideScalar(s || 1).multiplyScalar(
      N(s, t, e)
    );
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
  }
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this;
  }
  /// 点积、数量积、内积
  /// 点积的正负号说明2个向量指向同一方向的接近程度
  /// P.Q = 0  =>  向量P 和 向量Q 互相垂直  =>  向量P 和 向量Q 线性无关
  /// P.Q = |P| * |Q| * cos(从Q到P的角度差)
  /// P.Q = Q.P
  /// (aP).Q = a(Q.P)
  /// P.(Q + R) = P.Q + P.R
  /// P.P = |P| * |P|
  /// |P.Q| <= |P| * |Q|
  dot(t) {
    return this.x * t.x + this.y * t.y;
  }
  /// 叉积、向量积  =>  新向量垂直于原来两个向量
  /// 三维向量独有
  /// 叉积遵循右手法则：右手4指指向 向量P 的方向，手掌掌内指向 向量Q 的方向，则大拇指所指方向就是 叉积 P x Q 的方向
  /// (P x Q).P = (P x Q).Q = 0
  /// |P x Q| = |P| * |Q| * sin(从Q到P的角度差) = 向量P 和 向量Q 组成的平行四边形的面积
  /// 假设 单位向量i<1,0,0> 指向 x轴正方向，单位向量j<0,1,0> 指向 y轴正方向，单位向量k<0,0,1> 指向 z轴正方向
  /// 且 i 在 j 之前，j 在 k 之前，k 在 i 之前
  /// 则
  /// i x j = k
  /// j x k = i
  /// k x i = j
  /// j x i = -k
  /// k x j = -i
  /// i x k = -j
  /// Q x P = -(P x Q)
  // (aP) x Q = a(P x Q)
  /// P x (Q + R) = P x Q + P x R
  /// P x P - O = <0,0,0>
  /// (P x Q).R = (R x P).Q = (Q x R).P
  /// P x (Q x R) = P x Q x R = |P| * |P| * Q - (P.Q)P
  cross(t) {
    return this.x * t.y - this.y * t.x;
  }
  /// 投影到 v 的向量
  projectOnVector(t) {
    const e = t.lengthSq();
    if (e === 0)
      return this.set(0, 0);
    const s = t.dot(this) / e;
    return this.copy(t).multiplyScalar(s);
  }
  /// 相对于 v 的垂直分量
  perpendOnVector(t) {
    return xa.copy(this).projectOnVector(t), this.sub(xa);
  }
  /// 模、范数、长度
  /// |P| >= 0
  /// |aP| = |a| * |P|
  /// |P + Q| <= |P| + |Q|
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  /// 规格化
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  // computes the angle in radians with respect to the positive x-axis
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  angleTo(t) {
    const e = Math.sqrt(this.lengthSq() * t.lengthSq());
    if (e === 0)
      return Math.PI / 2;
    const s = this.dot(t) / e;
    return Math.acos(N(s, -1, 1));
  }
  distanceTo(t) {
    return Math.sqrt(this.distanceToSquared(t));
  }
  distanceToSquared(t) {
    const e = this.x - t.x, s = this.y - t.y;
    return e * e + s * s;
  }
  manhattanDistanceTo(t) {
    return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  lerp(t, e) {
    return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this;
  }
  lerpVectors(t, e, s) {
    return this.x = t.x + (e.x - t.x) * s, this.y = t.y + (e.y - t.y) * s, this;
  }
  equals(t) {
    return t.x === this.x && t.y === this.y;
  }
  fromArray(t, e = 0) {
    return this.x = t[e], this.y = t[e + 1], this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this.x, t[e + 1] = this.y, t;
  }
  fromBufferAttribute(t, e) {
    return this.x = t.getX(e), this.y = t.getY(e), this;
  }
  rotateAround(t, e) {
    const s = Math.cos(e), i = Math.sin(e), r = this.x - t.x, o = this.y - t.y;
    return this.x = r * s - o * i + t.x, this.y = r * i + o * s + t.y, this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y;
  }
}
class jt {
  x = 0;
  y = 0;
  z = 0;
  constructor(t = 0, e = 0, s = 0) {
    this.x = t, this.y = e, this.z = s;
  }
  set(t = 0, e = 0, s = 0) {
    return this.x = t, this.y = e, this.z = s, this;
  }
  setScalar(t) {
    return this.x = t, this.y = t, this.z = t, this;
  }
  setX(t) {
    return this.x = t, this;
  }
  setY(t) {
    return this.y = t, this;
  }
  setZ(t) {
    return this.z = t, this;
  }
  setComponent(t, e) {
    switch (t) {
      case 0:
        this.x = e;
        break;
      case 1:
        this.y = e;
        break;
      case 2:
        this.z = e;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  clone() {
    return new jt(this.x, this.y, this.z);
  }
  copy(t) {
    return this.x = t.x, this.y = t.y, this.z = t.z, this;
  }
  add(t) {
    return this.x += t.x, this.y += t.y, this.z += t.z, this;
  }
  addScalar(t) {
    return this.x += t, this.y += t, this.z += t, this;
  }
  addVectors(t, e) {
    return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this;
  }
  addScaledVector(t, e) {
    return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this;
  }
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this.z -= t.z, this;
  }
  subScalar(t) {
    return this.x -= t, this.y -= t, this.z -= t, this;
  }
  subVectors(t, e) {
    return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this;
  }
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this.z *= t.z, this;
  }
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this.z *= t, this;
  }
  multiplyVectors(t, e) {
    return this.x = t.x * e.x, this.y = t.y * e.y, this.z = t.z * e.z, this;
  }
  applyEuler(t) {
    return this.applyQuaternion(wa.setFromEuler(t));
  }
  applyAxisAngle(t, e) {
    return this.applyQuaternion(wa.setFromAxisAngle(t, e));
  }
  applyMatrix3(t) {
    const e = this.x, s = this.y, i = this.z, r = t.value;
    return this.x = r[0] * e + r[3] * s + r[6] * i, this.y = r[1] * e + r[4] * s + r[7] * i, this.z = r[2] * e + r[5] * s + r[8] * i, this;
  }
  applyNormalMatrix(t) {
    return this.applyMatrix3(t).normalize();
  }
  applyMatrix4(t) {
    const e = this.x, s = this.y, i = this.z, r = t.value, o = 1 / (r[3] * e + r[7] * s + r[11] * i + r[15]);
    return this.x = (r[0] * e + r[4] * s + r[8] * i + r[12]) * o, this.y = (r[1] * e + r[5] * s + r[9] * i + r[13]) * o, this.z = (r[2] * e + r[6] * s + r[10] * i + r[14]) * o, this;
  }
  applyQuaternion(t) {
    const e = this.x, s = this.y, i = this.z, r = t.x, o = t.y, a = t.z, h = t.w, c = 2 * (o * i - a * s), l = 2 * (a * e - r * i), u = 2 * (r * s - o * e);
    return this.x = e + h * c + o * u - a * l, this.y = s + h * l + a * c - r * u, this.z = i + h * u + r * l - o * c, this;
  }
  // project(camera) {
  //   return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(
  //     camera.projectionMatrix
  //   );
  // }
  // unproject(camera) {
  //   return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(
  //     camera.matrixWorld
  //   );
  // }
  transformDirection(t) {
    const e = this.x, s = this.y, i = this.z, r = t.value;
    return this.x = r[0] * e + r[4] * s + r[8] * i, this.y = r[1] * e + r[5] * s + r[9] * i, this.z = r[2] * e + r[6] * s + r[10] * i, this.normalize();
  }
  divide(t) {
    return this.x /= t.x, this.y /= t.y, this.z /= t.z, this;
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
  }
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
  }
  clamp(t, e) {
    return this.x = N(this.x, t.x, e.x), this.y = N(this.y, t.y, e.y), this.z = N(this.z, t.z, e.z), this;
  }
  clampScalar(t, e) {
    return this.x = N(this.x, t, e), this.y = N(this.y, t, e), this.z = N(this.z, t, e), this;
  }
  clampLength(t, e) {
    const s = this.length();
    return this.divideScalar(s || 1).multiplyScalar(
      N(s, t, e)
    );
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  dot(t) {
    return this.x * t.x + this.y * t.y + this.z * t.z;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  lerp(t, e) {
    return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this;
  }
  lerpVectors(t, e, s) {
    return this.x = t.x + (e.x - t.x) * s, this.y = t.y + (e.y - t.y) * s, this.z = t.z + (e.z - t.z) * s, this;
  }
  cross(t) {
    return this.crossVectors(this, t);
  }
  crossVectors(t, e) {
    const s = t.x, i = t.y, r = t.z, o = e.x, a = e.y, h = e.z;
    return this.x = i * h - r * a, this.y = r * o - s * h, this.z = s * a - i * o, this;
  }
  /// 投影到 v 的向量
  projectOnVector(t) {
    const e = t.lengthSq();
    if (e === 0)
      return this.set(0, 0, 0);
    const s = t.dot(this) / e;
    return this.copy(t).multiplyScalar(s);
  }
  /// 相对于 v 的垂直分量
  perpendOnVector(t) {
    return Oi.copy(this).projectOnVector(t), this.sub(Oi);
  }
  projectOnPlane(t) {
    return this.perpendOnVector(t);
  }
  reflect(t) {
    return this.sub(Oi.copy(t).multiplyScalar(2 * this.dot(t)));
  }
  angleTo(t) {
    const e = Math.sqrt(this.lengthSq() * t.lengthSq());
    if (e === 0)
      return Math.PI / 2;
    const s = this.dot(t) / e;
    return Math.acos(N(s, -1, 1));
  }
  distanceTo(t) {
    return Math.sqrt(this.distanceToSquared(t));
  }
  distanceToSquared(t) {
    const e = this.x - t.x, s = this.y - t.y, i = this.z - t.z;
    return e * e + s * s + i * i;
  }
  manhattanDistanceTo(t) {
    return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
  }
  // setFromSpherical(s) {
  //   return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
  // }
  // setFromSphericalCoords(radius, phi, theta) {
  //   const sinPhiRadius = Math.sin(phi) * radius;
  //   this.x = sinPhiRadius * Math.sin(theta);
  //   this.y = Math.cos(phi) * radius;
  //   this.z = sinPhiRadius * Math.cos(theta);
  //   return this;
  // }
  // setFromCylindrical(c) {
  //   return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
  // }
  // setFromCylindricalCoords(radius, theta, y) {
  //   this.x = radius * Math.sin(theta);
  //   this.y = y;
  //   this.z = radius * Math.cos(theta);
  //   return this;
  // }
  setFromMatrix4Position(t) {
    const e = t.value;
    return this.x = e[12], this.y = e[13], this.z = e[14], this;
  }
  setFromMatrix4Scale(t) {
    const e = this.setFromMatrix4Column(t, 0).length(), s = this.setFromMatrix4Column(t, 1).length(), i = this.setFromMatrix4Column(t, 2).length();
    return this.x = e, this.y = s, this.z = i, this;
  }
  setFromMatrix4Column(t, e) {
    return this.fromArray(t.value, e * 4);
  }
  setFromMatrix3Column(t, e) {
    return this.fromArray(t.value, e * 3);
  }
  setFromEuler(t) {
    return this.x = t.x, this.y = t.y, this.z = t.z, this;
  }
  // setFromColor(c) {
  //   this.x = c.r;
  //   this.y = c.g;
  //   this.z = c.b;
  //   return this;
  // }
  equals(t) {
    return t.x === this.x && t.y === this.y && t.z === this.z;
  }
  fromArray(t, e = 0) {
    return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t;
  }
  fromBufferAttribute(t, e) {
    return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  randomDirection() {
    const t = Math.random() * Math.PI * 2, e = Math.random() * 2 - 1, s = Math.sqrt(1 - e * e);
    return this.x = s * Math.cos(t), this.y = e, this.z = s * Math.sin(t), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
}
class Rc {
  x = 0;
  y = 0;
  z = 0;
  w = 1;
  constructor(t = 0, e = 0, s = 0, i = 1) {
    this.x = t, this.y = e, this.z = s, this.w = i;
  }
  get width() {
    return this.z;
  }
  set width(t) {
    this.z = t;
  }
  get height() {
    return this.w;
  }
  set height(t) {
    this.w = t;
  }
  set(t = 0, e = 0, s = 0, i = 1) {
    return this.x = t, this.y = e, this.z = s, this.w = i, this;
  }
  setScalar(t) {
    return this.x = t, this.y = t, this.z = t, this.w = t, this;
  }
  setX(t) {
    return this.x = t, this;
  }
  setY(t) {
    return this.y = t, this;
  }
  setZ(t) {
    return this.z = t, this;
  }
  setW(t) {
    return this.w = t, this;
  }
  setComponent(t, e) {
    switch (t) {
      case 0:
        this.x = e;
        break;
      case 1:
        this.y = e;
        break;
      case 2:
        this.z = e;
        break;
      case 3:
        this.w = e;
        break;
      default:
        throw new Error("index is out of range: " + t);
    }
    return this;
  }
  getComponent(t) {
    switch (t) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + t);
    }
  }
  clone() {
    return new Rc(this.x, this.y, this.z, this.w);
  }
  copy(t) {
    return this.x = t.x, this.y = t.y, this.z = t.z, this.w = t.w, this;
  }
  add(t) {
    return this.x += t.x, this.y += t.y, this.z += t.z, this.w += t.w, this;
  }
  addScalar(t) {
    return this.x += t, this.y += t, this.z += t, this.w += t, this;
  }
  addVectors(t, e) {
    return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this.w = t.w + e.w, this;
  }
  addScaledVector(t, e) {
    return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this.w += t.w * e, this;
  }
  sub(t) {
    return this.x -= t.x, this.y -= t.y, this.z -= t.z, this.w -= t.w, this;
  }
  subScalar(t) {
    return this.x -= t, this.y -= t, this.z -= t, this.w -= t, this;
  }
  subVectors(t, e) {
    return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this.w = t.w - e.w, this;
  }
  multiply(t) {
    return this.x *= t.x, this.y *= t.y, this.z *= t.z, this.w *= t.w, this;
  }
  multiplyScalar(t) {
    return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
  }
  applyMatrix4(t) {
    const e = this.x, s = this.y, i = this.z, r = this.w, o = t.value;
    return this.x = o[0] * e + o[4] * s + o[8] * i + o[12] * r, this.y = o[1] * e + o[5] * s + o[9] * i + o[13] * r, this.z = o[2] * e + o[6] * s + o[10] * i + o[14] * r, this.w = o[3] * e + o[7] * s + o[11] * i + o[15] * r, this;
  }
  divide(t) {
    return this.x /= t.x, this.y /= t.y, this.z /= t.z, this.w /= t.w, this;
  }
  divideScalar(t) {
    return this.multiplyScalar(1 / t);
  }
  setAxisAngleFromQuaternion(t) {
    this.w = 2 * Math.acos(t.w);
    const e = Math.sqrt(1 - t.w * t.w);
    return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t.x / e, this.y = t.y / e, this.z = t.z / e), this;
  }
  setAxisAngleFromRotationMatrix4(t) {
    let e, s, i, r;
    const h = t.value, c = h[0], l = h[4], u = h[8], d = h[1], f = h[5], m = h[9], p = h[2], S = h[6], g = h[10];
    if (Math.abs(l - d) < 0.01 && Math.abs(u - p) < 0.01 && Math.abs(m - S) < 0.01) {
      if (Math.abs(l + d) < 0.1 && Math.abs(u + p) < 0.1 && Math.abs(m + S) < 0.1 && Math.abs(c + f + g - 3) < 0.1)
        return this.set(1, 0, 0, 0), this;
      e = Math.PI;
      const x = (c + 1) / 2, w = (f + 1) / 2, C = (g + 1) / 2, _ = (l + d) / 4, D = (u + p) / 4, z = (m + S) / 4;
      return x > w && x > C ? x < 0.01 ? (s = 0, i = 0.707106781, r = 0.707106781) : (s = Math.sqrt(x), i = _ / s, r = D / s) : w > C ? w < 0.01 ? (s = 0.707106781, i = 0, r = 0.707106781) : (i = Math.sqrt(w), s = _ / i, r = z / i) : C < 0.01 ? (s = 0.707106781, i = 0.707106781, r = 0) : (r = Math.sqrt(C), s = D / r, i = z / r), this.set(s, i, r, e), this;
    }
    let b = Math.sqrt(
      (S - m) * (S - m) + (u - p) * (u - p) + (d - l) * (d - l)
    );
    return Math.abs(b) < 1e-3 && (b = 1), this.x = (S - m) / b, this.y = (u - p) / b, this.z = (d - l) / b, this.w = Math.acos((c + f + g - 1) / 2), this;
  }
  setFromMatrix4Position(t) {
    const e = t.value;
    return this.x = e[12], this.y = e[13], this.z = e[14], this.w = e[15], this;
  }
  min(t) {
    return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this.w = Math.min(this.w, t.w), this;
  }
  max(t) {
    return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this.w = Math.max(this.w, t.w), this;
  }
  clamp(t, e) {
    return this.x = N(this.x, t.x, e.x), this.y = N(this.y, t.y, e.y), this.z = N(this.z, t.z, e.z), this.w = N(this.w, t.w, e.w), this;
  }
  clampScalar(t, e) {
    return this.x = N(this.x, t, e), this.y = N(this.y, t, e), this.z = N(this.z, t, e), this.w = N(this.w, t, e), this;
  }
  clampLength(t, e) {
    const s = this.length();
    return this.divideScalar(s || 1).multiplyScalar(
      N(s, t, e)
    );
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
  }
  roundToZero() {
    return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
  }
  dot(t) {
    return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(
      this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w
    );
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(t) {
    return this.normalize().multiplyScalar(t);
  }
  /// 投影到 v 的向量
  projectOnVector(t) {
    const e = t.lengthSq();
    if (e === 0)
      return this.set(0, 0, 0, 1);
    const s = t.dot(this) / e;
    return this.copy(t).multiplyScalar(s);
  }
  // /// 相对于 v 的垂直分量
  // perpendOnVector(v: Vector4) {
  //   _v4.copy(this).projectOnVector(v);
  //   return this.sub(_v4);
  // }
  lerp(t, e) {
    return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this.w += (t.w - this.w) * e, this;
  }
  lerpVectors(t, e, s) {
    return this.x = t.x + (e.x - t.x) * s, this.y = t.y + (e.y - t.y) * s, this.z = t.z + (e.z - t.z) * s, this.w = t.w + (e.w - t.w) * s, this;
  }
  equals(t) {
    return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
  }
  fromArray(t, e = 0) {
    return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this.w = t[e + 3], this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t[e + 3] = this.w, t;
  }
  fromBufferAttribute(t, e) {
    return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this.w = t.getW(e), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
const xa = new ui(), Oi = new jt(), wa = new no(), ba = r0(
  "50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,t9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro",
  32
);
function r0(n, t = 10) {
  const e = {}, s = n.split(",");
  for (let i = 0; i < s.length; i += 2) {
    const r = "&" + s[i + 1] + ";", o = parseInt(s[i], t);
    e[r] = "&#" + o + ";";
  }
  return e["\\xa0"] = "&#160;", e;
}
function Pt(n, t) {
  const e = Object.keys(t);
  for (let s = 0; s < e.length; s++)
    n = n.replace(
      new RegExp("{" + e[s] + "}", "gi"),
      "" + t[e[s]]
    );
  return n;
}
function wn(n) {
  let t, e;
  if (!n)
    throw new Error(
      "cannot create a random attribute name for an undefined object"
    );
  const s = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
  t = "";
  do
    for (t = "", e = 0; e < 12; e++)
      t += s[Math.floor(Math.random() * s.length)];
  while (n[t]);
  return t;
}
function o0(n) {
  const t = {
    left: "start",
    right: "end",
    center: "middle",
    start: "start",
    end: "end"
  };
  return t[n] || t.start;
}
function a0(n) {
  const t = {
    alphabetic: "alphabetic",
    hanging: "hanging",
    top: "text-before-edge",
    bottom: "text-after-edge",
    middle: "central"
  };
  return t[n] || t.alphabetic;
}
const _s = {
  strokeStyle: {
    svgAttr: "stroke",
    canvas: "#000000",
    svg: "none",
    apply: "stroke"
  },
  fillStyle: {
    svgAttr: "fill",
    canvas: "#000000",
    svg: null,
    // svg default is black, but we need to special case this to handle canvas stroke without fill
    apply: "fill"
  },
  lineCap: {
    svgAttr: "stroke-linecap",
    canvas: "butt",
    svg: "butt",
    apply: "stroke"
  },
  lineJoin: {
    svgAttr: "stroke-linejoin",
    canvas: "miter",
    svg: "miter",
    apply: "stroke"
  },
  miterLimit: {
    svgAttr: "stroke-miterlimit",
    canvas: 10,
    svg: 4,
    apply: "stroke"
  },
  lineWidth: {
    svgAttr: "stroke-width",
    canvas: 1,
    svg: 1,
    apply: "stroke"
  },
  globalAlpha: {
    svgAttr: "opacity",
    canvas: 1,
    svg: 1,
    apply: "fill stroke"
  },
  font: {
    // font converts to multiple svg attributes, there is custom logic for this
    canvas: "10px sans-serif"
  },
  shadowColor: {
    canvas: "#000000"
  },
  shadowOffsetX: {
    canvas: 0
  },
  shadowOffsetY: {
    canvas: 0
  },
  shadowBlur: {
    canvas: 0
  },
  textAlign: {
    canvas: "start"
  },
  textBaseline: {
    canvas: "alphabetic"
  },
  lineDash: {
    svgAttr: "stroke-dasharray",
    canvas: [],
    svg: null,
    apply: "stroke"
  },
  lineDashOffset: {
    svgAttr: "stroke-dashoffset",
    canvas: 0,
    svg: 0,
    apply: "stroke"
  }
};
let zi = class {
  __root;
  __ctx;
  constructor(t, e) {
    this.__root = t, this.__ctx = e;
  }
  /**
   * Adds a color stop to the gradient root
   */
  addColorStop(t, e) {
    const s = this.__ctx.__createElement("stop");
    if (s.setAttribute("offset", "" + t), e.indexOf("rgba") !== -1) {
      const r = /rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d?\.?\d*)\s*\)/gi.exec(e);
      r && (s.setAttribute(
        "stop-color",
        Pt("rgb({r},{g},{b})", {
          r: r[1],
          g: r[2],
          b: r[3]
        })
      ), s.setAttribute("stop-opacity", r[4]));
    } else
      s.setAttribute("stop-color", e);
    this.__root.appendChild(s);
  }
}, va = class {
  __root;
  __ctx;
  constructor(t, e) {
    this.__root = t, this.__ctx = e;
  }
}, h0 = class dr {
  __document = document;
  __canvas;
  __ctx;
  width;
  height;
  __styleStack;
  __groupStack;
  __rootSVG;
  __ids;
  __SVGdefs;
  __currentElement;
  __currentElementsToStyle = null;
  constructor({
    canvas: t,
    width: e = 500,
    height: s = 500
  }) {
    t ? (this.__canvas = t, this.__ctx = t.getContext("2d"), this.width = t.width, this.height = t.height) : (this.__canvas = this.__document.createElement("canvas"), this.__ctx = this.__canvas.getContext("2d"), this.width = e, this.height = s), this.__setDefaultStyles(), this.__styleStack = [this.__getStyleState()], this.__groupStack = [], this.__rootSVG = this.__document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    ), this.__rootSVG.setAttribute("version", "1.1"), this.__rootSVG.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.__rootSVG.setAttributeNS(
      "http://www.w3.org/2000/xmlns/",
      "xmlns:xlink",
      "http://www.w3.org/1999/xlink"
    ), this.__rootSVG.setAttribute("width", "" + this.width), this.__rootSVG.setAttribute("height", "" + this.height), this.__ids = {}, this.__SVGdefs = this.__document.createElementNS(
      "http://www.w3.org/2000/svg",
      "defs"
    ), this.__rootSVG.appendChild(this.__SVGdefs), this.__currentElement = this.__document.createElementNS(
      "http://www.w3.org/2000/svg",
      "g"
    ), this.__rootSVG.appendChild(this.__currentElement);
  }
  /**
   * Applies default canvas styles to the context
   */
  __setDefaultStyles() {
    const t = Object.keys(_s);
    for (let e = 0, s = t.length; e < s; e++) {
      const i = t[e];
      this[i] = _s[i].canvas;
    }
  }
  /**
   * Gets the current style state
   */
  __getStyleState() {
    const t = {}, e = Object.keys(_s);
    for (let s = 0, i = e.length; s < i; s++) {
      const r = e[s];
      t[r] = this[r];
    }
    return t;
  }
  /**
   * Applies styles on restore
   */
  __applyStyleState(t) {
    const e = Object.keys(t);
    for (let s = 0, i = e.length; s < i; s++) {
      const r = e[s];
      this[r] = t[r];
    }
  }
  /**
   * Creates the specified svg element
   */
  __createElement(t, e = {}, s = !1) {
    const i = this.__document.createElementNS(
      "http://www.w3.org/2000/svg",
      t
    ), r = Object.keys(e);
    s && (i.setAttribute("fill", "none"), i.setAttribute("stroke", "none"));
    for (let o = 0; o < r.length; o++) {
      const a = r[o];
      i.setAttribute(a, e[a]);
    }
    return i;
  }
  /**
   * Apples the current styles to the current SVG element. On "CustomCanvasContext.fill" or "CustomCanvasContext.stroke"
   */
  __applyStyleToCurrentElement(t) {
    let e = this.__currentElement;
    const s = this.__currentElementsToStyle;
    s && (e.setAttribute(t, ""), e = s.element, s.children.forEach((r) => {
      r.setAttribute(t, "");
    }));
    const i = Object.keys(_s);
    for (let r = 0; r < i.length; r++) {
      const o = _s[i[r]], a = this[i[r]];
      if (o.apply) {
        if (a instanceof va) {
          if (a.__ctx)
            for (; a.__ctx.__SVGdefs.childNodes.length; ) {
              const h = a.__ctx.__SVGdefs.childNodes[0].getAttribute("id");
              this.__ids[h] = h, this.__SVGdefs.appendChild(a.__ctx.__SVGdefs.childNodes[0]);
            }
          e.setAttribute(
            o.apply,
            Pt("url(#{id})", {
              id: a.__root.getAttribute("id")
            })
          );
        } else if (a instanceof zi)
          e.setAttribute(
            o.apply,
            Pt("url(#{id})", {
              id: a.__root.getAttribute("id")
            })
          );
        else if (o.apply.indexOf(t) !== -1 && o.svg !== a)
          if ((o.svgAttr === "stroke" || o.svgAttr === "fill") && a.indexOf("rgba") !== -1) {
            const c = /rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d?\.?\d*)\s*\)/gi.exec(a);
            if (c) {
              e.setAttribute(
                o.svgAttr,
                Pt("rgb({r},{g},{b})", {
                  r: c[1],
                  g: c[2],
                  b: c[3]
                })
              );
              let l = parseFloat(c[4]);
              const u = this.globalAlpha;
              u != null && (l *= u), e.setAttribute(
                o.svgAttr + "-opacity",
                "" + l
              );
            }
          } else {
            let h = o.svgAttr;
            if (i[r] === "globalAlpha" && (h = t + "-" + o.svgAttr, e.getAttribute(h)))
              continue;
            h && e.setAttribute(h, a);
          }
      }
    }
  }
  /**
   * Will return the closest group or svg node. May return the current element.
   */
  __closestGroupOrSvg(t) {
    return t = t || this.__currentElement, t.nodeName === "g" || t.nodeName === "svg" ? t : this.__closestGroupOrSvg(t.parentNode);
  }
  /**
   * Returns the serialized value of the svg so far
   * @param fixNamedEntities - Standalone SVG doesn't support named entities, which document.createTextNode encodes.
   *                           If true, we attempt to find all named entities and encode it as a numeric entity.
   * @return serialized svg
   */
  getSerializedSvg(t) {
    let e = new XMLSerializer().serializeToString(this.__rootSVG);
    if (/xmlns="http:\/\/www\.w3\.org\/2000\/svg".+xmlns="http:\/\/www\.w3\.org\/2000\/svg/gi.test(e) && (e = e.replace(
      'xmlns="http://www.w3.org/2000/svg',
      'xmlns:xlink="http://www.w3.org/1999/xlink'
    )), t) {
      const i = Object.keys(ba);
      for (let r = 0, o = i.length; r < o; r++) {
        const a = i[r], h = ba[a], c = new RegExp(a, "gi");
        c.test(e) && (e = e.replace(c, h));
      }
    }
    return e;
  }
  /**
   * Returns the root svg
   */
  getSvg() {
    return this.__rootSVG;
  }
  /**
   * Will generate a group tag
   */
  save() {
    const t = this.__createElement("g"), e = this.__closestGroupOrSvg();
    this.__groupStack.push(e), e.appendChild(t), this.__currentElement = t, this.__styleStack.push(this.__getStyleState());
  }
  /**
   * Sets current element to parent, or just root if already root
   */
  restore() {
    this.__currentElementsToStyle = null;
    const t = this.__groupStack.pop();
    t ? this.__currentElement = t : this.__currentElement = this.__rootSVG.childNodes[1];
    const e = this.__styleStack.pop();
    e && this.__applyStyleState(e);
  }
  /**
   * Helper method to add transform
   */
  __addTransform(t) {
    const e = this.__closestGroupOrSvg();
    if (e.childNodes.length > 0) {
      this.__currentElement.nodeName === "path" && (this.__currentElementsToStyle || (this.__currentElementsToStyle = { element: e, children: [] }), this.__currentElementsToStyle.children.push(this.__currentElement), this.__applyCurrentDefaultPath());
      const i = this.__createElement("g");
      e.appendChild(i), this.__currentElement = i;
    }
    let s = this.__currentElement.getAttribute("transform");
    s ? s += " " : s = "", s += t, this.__currentElement.setAttribute("transform", s);
  }
  /**
   *  scales the current element
   */
  scale(t, e) {
    e === void 0 && (e = t), this.__addTransform(Pt("scale({x},{y})", { x: t, y: e }));
  }
  /**
   * rotates the current element
   */
  rotate(t) {
    const e = t * 180 / Math.PI;
    this.__addTransform(
      Pt("rotate({angle},{cx},{cy})", {
        angle: e,
        cx: 0,
        cy: 0
      })
    );
  }
  /**
   * translates the current element
   */
  translate(t, e) {
    this.__addTransform(Pt("translate({x},{y})", { x: t, y: e }));
  }
  /**
   * applies a transform to the current element
   */
  transform(t, e, s, i, r, o) {
    this.__addTransform(
      Pt("matrix({a},{b},{c},{d},{e},{f})", {
        a: t,
        b: e,
        c: s,
        d: i,
        e: r,
        f: o
      })
    );
  }
  /**
   * Create a new Path Element
   */
  beginPath() {
    this.__currentDefaultPath = "", this.__currentPosition = {};
    const t = this.__createElement("path", {}, !0);
    this.__closestGroupOrSvg().appendChild(t), this.__currentElement = t;
  }
  /**
   * Helper function to apply currentDefaultPath to current path element
   */
  __applyCurrentDefaultPath() {
    const t = this.__currentElement;
    t.nodeName === "path" && t.setAttribute("d", this.__currentDefaultPath);
  }
  /**
   * Helper function to add path command
   */
  __addPathCommand(t) {
    this.__currentDefaultPath += " ", this.__currentDefaultPath += t;
  }
  /**
   * Adds the move command to the current path element,
   * if the currentPathElement is not empty create a new path element
   */
  moveTo(t, e) {
    this.__currentElement.nodeName !== "path" && this.beginPath(), this.__currentPosition = { x: t, y: e }, this.__addPathCommand(Pt("M {x} {y}", this.__currentPosition));
  }
  /**
   * Closes the current path
   */
  closePath() {
    this.__currentDefaultPath && this.__addPathCommand("Z");
  }
  /**
   * Adds a line to command
   */
  lineTo(t, e) {
    this.__currentPosition = { x: t, y: e }, this.__currentDefaultPath.indexOf("M") > -1 ? this.__addPathCommand(Pt("L {x} {y}", this.__currentPosition)) : this.__addPathCommand(Pt("M {x} {y}", this.__currentPosition));
  }
  /**
   * Add a bezier command
   */
  bezierCurveTo(t, e, s, i, r, o) {
    this.__currentPosition = { x: r, y: o }, this.__addPathCommand(
      Pt("C {cp1x} {cp1y} {cp2x} {cp2y} {x} {y}", {
        cp1x: t,
        cp1y: e,
        cp2x: s,
        cp2y: i,
        x: r,
        y: o
      })
    );
  }
  /**
   * Adds a quadratic curve to command
   */
  quadraticCurveTo(t, e, s, i) {
    this.__currentPosition = { x: s, y: i }, this.__addPathCommand(
      Pt("Q {cpx} {cpy} {x} {y}", { cpx: t, cpy: e, x: s, y: i })
    );
  }
  /**
   * Return a new normalized vector of given vector
   */
  normalize(t) {
    const e = Math.sqrt(t[0] * t[0] + t[1] * t[1]);
    return [t[0] / e, t[1] / e];
  }
  /**
   * Adds the arcTo to the current path
   *
   * @see http://www.w3.org/TR/2015/WD-2dcontext-20150514/#dom-context-2d-arcto
   */
  arcTo(t, e, s, i, r) {
    const o = this.__currentPosition && this.__currentPosition.x, a = this.__currentPosition && this.__currentPosition.y;
    if (typeof o > "u" || typeof a > "u")
      return;
    if (r < 0)
      throw new Error(
        "IndexSizeError: The radius provided (" + r + ") is negative."
      );
    if (o === t && a === e || t === s && e === i || r === 0) {
      this.lineTo(t, e);
      return;
    }
    const h = this.normalize([o - t, a - e]), c = this.normalize([s - t, i - e]);
    if (h[0] * c[1] === h[1] * c[0]) {
      this.lineTo(t, e);
      return;
    }
    const l = h[0] * c[0] + h[1] * c[1], u = Math.acos(Math.abs(l)), d = this.normalize([
      h[0] + c[0],
      h[1] + c[1]
    ]), f = r / Math.sin(u / 2), m = t + f * d[0], p = e + f * d[1], S = [
      -h[1],
      h[0]
    ], g = [c[1], -c[0]], b = function(C) {
      const _ = C[0];
      return C[1] >= 0 ? Math.acos(_) : -Math.acos(_);
    }, x = b(S), w = b(g);
    this.lineTo(
      m + S[0] * r,
      p + S[1] * r
    ), this.arc(m, p, r, x, w);
  }
  /**
   * Sets the stroke property on the current element
   */
  stroke() {
    this.__currentElement.nodeName === "path" && this.__currentElement.setAttribute("paint-order", "fill stroke markers"), this.__applyCurrentDefaultPath(), this.__applyStyleToCurrentElement("stroke");
  }
  /**
   * Sets fill properties on the current element
   */
  fill() {
    this.__currentElement.nodeName === "path" && this.__currentElement.setAttribute("paint-order", "stroke fill markers"), this.__applyCurrentDefaultPath(), this.__applyStyleToCurrentElement("fill");
  }
  /**
   *  Adds a rectangle to the path.
   */
  rect(t, e, s, i) {
    this.__currentElement.nodeName !== "path" && this.beginPath(), this.moveTo(t, e), this.lineTo(t + s, e), this.lineTo(t + s, e + i), this.lineTo(t, e + i), this.lineTo(t, e), this.closePath();
  }
  /**
   * adds a rectangle element
   */
  fillRect(t, e, s, i) {
    const r = this.__createElement(
      "rect",
      {
        x: t,
        y: e,
        width: s,
        height: i
      },
      !0
    );
    this.__closestGroupOrSvg().appendChild(r), this.__currentElement = r, this.__applyStyleToCurrentElement("fill");
  }
  /**
   * Draws a rectangle with no fill
   */
  strokeRect(t, e, s, i) {
    const r = this.__createElement(
      "rect",
      {
        x: t,
        y: e,
        width: s,
        height: i
      },
      !0
    );
    this.__closestGroupOrSvg().appendChild(r), this.__currentElement = r, this.__applyStyleToCurrentElement("stroke");
  }
  /**
   * Clear entire canvas:
   * 1. save current transforms
   * 2. remove all the childNodes of the root g element
   */
  __clearCanvas() {
    const e = this.__closestGroupOrSvg().getAttribute("transform"), s = this.__rootSVG.childNodes[1], i = s.childNodes;
    for (let r = i.length - 1; r >= 0; r--)
      i[r] && s.removeChild(i[r]);
    this.__currentElement = s, this.__groupStack = [], e && this.__addTransform(e);
  }
  /**
   * "Clears" a canvas by just drawing a white rectangle in the current group.
   */
  clearRect(t, e, s, i) {
    if (t === 0 && e === 0 && s === this.width && i === this.height) {
      this.__clearCanvas();
      return;
    }
    const r = this.__closestGroupOrSvg(), o = this.__createElement(
      "rect",
      {
        x: t,
        y: e,
        width: s,
        height: i,
        fill: "#FFFFFF"
      },
      !0
    );
    r.appendChild(o);
  }
  /**
   * Adds a linear gradient to a defs tag.
   * Returns a canvas gradient object that has a reference to it's parent def
   */
  createLinearGradient(t, e, s, i) {
    const r = this.__createElement(
      "linearGradient",
      {
        id: wn(this.__ids),
        x1: t + "px",
        x2: s + "px",
        y1: e + "px",
        y2: i + "px",
        gradientUnits: "userSpaceOnUse"
      },
      !1
    );
    return this.__SVGdefs.appendChild(r), new zi(r, this);
  }
  /**
   * Adds a radial gradient to a defs tag.
   * Returns a canvas gradient object that has a reference to it's parent def
   */
  createRadialGradient(t, e, s, i, r, o) {
    const a = this.__createElement(
      "radialGradient",
      {
        id: wn(this.__ids),
        cx: i + "px",
        cy: r + "px",
        r: o + "px",
        fx: t + "px",
        fy: e + "px",
        gradientUnits: "userSpaceOnUse"
      },
      !1
    );
    return this.__SVGdefs.appendChild(a), new zi(a, this);
  }
  /**
   * Parses the font string and returns svg mapping
   */
  __parseFont() {
    const e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:%|in|[cem]m|ex|p[CustomCanvasContext]))(?:\s*\/\s*(normal|[.\d]+(?:%|in|[cem]m|ex|p[CustomCanvasContext])))?\s*([-,'"\sa-z0-9]+?)\s*$/i.exec(this.font), s = {
      style: e[1] || "normal",
      size: e[4] || "10px",
      family: e[6] || "sans-serif",
      weight: e[3] || "normal",
      decoration: e[2] || "normal",
      href: null
    };
    return this.__fontUnderline === "underline" && (s.decoration = "underline"), this.__fontHref && (s.href = this.__fontHref), s;
  }
  /**
   * Helper to link text fragments
   */
  __wrapTextLink(t, e) {
    if (t.href) {
      const s = this.__createElement("a");
      return s.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", t.href), s.appendChild(e), s;
    }
    return e;
  }
  /**
   * Fills or strokes text
   * @param text
   * @param x
   * @param y
   * @param action - stroke or fill
   */
  __applyText(t, e, s, i) {
    const r = this.__parseFont(), o = this.__closestGroupOrSvg(), a = this.__createElement(
      "text",
      {
        "font-family": r.family,
        "font-size": r.size,
        "font-style": r.style,
        "font-weight": r.weight,
        "text-decoration": r.decoration,
        x: e,
        y: s,
        "text-anchor": o0(this.textAlign),
        "dominant-baseline": a0(this.textBaseline)
      },
      !0
    );
    a.appendChild(this.__document.createTextNode(t)), this.__currentElement = a, this.__applyStyleToCurrentElement(i), o.appendChild(
      this.__wrapTextLink(r, a)
    );
  }
  /**
   * Creates a text element
   * @param text
   * @param x
   * @param y
   */
  fillText(t, e, s) {
    this.__applyText(t, e, s, "fill");
  }
  /**
   * Strokes text
   * @param text
   * @param x
   * @param y
   */
  strokeText(t, e, s) {
    this.__applyText(t, e, s, "stroke");
  }
  /**
   * No need to implement this for svg.
   * @param text
   * @return {TextMetrics}
   */
  measureText(t) {
    return this.__ctx.font = this.font, this.__ctx.measureText(t);
  }
  /**
   *  Arc command!
   */
  arc(t, e, s, i, r, o) {
    if (i === r)
      return;
    i = i % (2 * Math.PI), r = r % (2 * Math.PI), i === r && (r = (r + 2 * Math.PI - 1e-3 * (o ? -1 : 1)) % (2 * Math.PI));
    const a = t + s * Math.cos(r), h = e + s * Math.sin(r), c = t + s * Math.cos(i), l = e + s * Math.sin(i), u = o ? 0 : 1;
    let d = 0, f = r - i;
    f < 0 && (f += 2 * Math.PI), o ? d = f > Math.PI ? 0 : 1 : d = f > Math.PI ? 1 : 0, this.lineTo(c, l), this.__addPathCommand(
      Pt(
        "A {rx} {ry} {xAxisRotation} {largeArcFlag} {sweepFlag} {endX} {endY}",
        {
          rx: s,
          ry: s,
          xAxisRotation: 0,
          largeArcFlag: d,
          sweepFlag: u,
          endX: a,
          endY: h
        }
      )
    ), this.__currentPosition = { x: a, y: h };
  }
  /**
   * Generates a ClipPath from the clip command.
   */
  clip() {
    const t = this.__closestGroupOrSvg(), e = this.__createElement("clipPath"), s = wn(this.__ids), i = this.__createElement("g");
    this.__applyCurrentDefaultPath(), t.removeChild(this.__currentElement), e.setAttribute("id", s), e.appendChild(this.__currentElement), this.__SVGdefs.appendChild(e), t.setAttribute("clip-path", Pt("url(#{id})", { id: s })), t.appendChild(i), this.__currentElement = i;
  }
  /**
   * Draws a canvas, image or mock context to this canvas.
   * Note that all svg dom manipulation uses node.childNodes rather than node.children for IE support.
   * http://www.whatwg.org/specs/web-apps/current-work/multipage/the-canvas-element.html#dom-context-2d-drawimage
   */
  drawImage(...t) {
    let e = t[0], s, i, r, o, a = 0, h = 0, c, l, u, d, f, m, p, S;
    if (t.length === 3)
      s = t[1], i = t[2], c = e.width, l = e.height, r = c, o = l;
    else if (t.length === 5)
      s = t[1], i = t[2], r = t[3], o = t[4], c = e.width, l = e.height;
    else if (t.length === 9)
      a = t[1], h = t[2], c = t[3], l = t[4], s = t[5], i = t[6], r = t[7], o = t[8];
    else
      throw new Error(
        "Invalid number of arguments passed to drawImage: " + arguments.length
      );
    const g = this.__closestGroupOrSvg();
    this.__currentElement;
    const b = "translate(" + s + ", " + i + ")";
    if (e instanceof dr) {
      if (u = e.getSvg().cloneNode(!0), u.childNodes && u.childNodes.length > 1) {
        for (d = u.childNodes[0]; d.childNodes.length; )
          S = d.childNodes[0].getAttribute("id"), this.__ids[S] = S, this.__SVGdefs.appendChild(d.childNodes[0]);
        if (f = u.childNodes[1], f) {
          const x = f.getAttribute("transform");
          let w;
          x ? w = x + " " + b : w = b, f.setAttribute("transform", w), g.appendChild(f);
        }
      }
    } else
      (e.nodeName === "CANVAS" || e.nodeName === "IMG") && (m = this.__createElement("image"), m.setAttribute("width", r), m.setAttribute("height", o), m.setAttribute("preserveAspectRatio", "none"), (a || h || c !== e.width || l !== e.height) && (p = this.__document.createElement("canvas"), p.width = r, p.height = o, p.getContext("2d")?.drawImage(e, a, h, c, l, 0, 0, r, o), e = p), m.setAttribute("transform", b), m.setAttributeNS(
        "http://www.w3.org/1999/xlink",
        "xlink:href",
        e.nodeName === "CANVAS" ? e.toDataURL() : e.getAttribute("src")
      ), g.appendChild(m));
  }
  /**
   * Generates a pattern tag
   */
  createPattern(t, e) {
    const s = this.__document.createElementNS(
      "http://www.w3.org/2000/svg",
      "pattern"
    ), i = wn(this.__ids);
    let r;
    return s.setAttribute("id", i), t.nodeName === "CANVAS" || t.nodeName === "IMG" ? (r = this.__document.createElementNS(
      "http://www.w3.org/2000/svg",
      "image"
    ), r.setAttribute(
      "width",
      "" + t.width
    ), r.setAttribute(
      "height",
      "" + t.height
    ), r.setAttributeNS(
      "http://www.w3.org/1999/xlink",
      "xlink:href",
      t.nodeName === "CANVAS" ? t.toDataURL() : t.getAttribute("src")
    ), s.appendChild(r), this.__SVGdefs.appendChild(s)) : t instanceof dr && (s.setAttribute("width", "" + t.width), s.setAttribute(
      "height",
      "" + t.height
    ), s.appendChild(t.__rootSVG.childNodes[1]), this.__SVGdefs.appendChild(s)), new va(s, this);
  }
  setLineDash(t) {
    t && t.length > 0 ? this.lineDash = t.join(",") : this.lineDash = null;
  }
  drawFocusRing() {
  }
  createImageData() {
  }
  getImageData() {
  }
  putImageData() {
  }
  globalCompositeOperation() {
  }
  setTransform() {
  }
}, _a = class {
  canvas;
  context;
  // context: CanvasRenderingContext2D
  // | WebGLRenderingContext
  // | WebGL2RenderingContext
  // | GPUCanvasContext
  // | ImageBitmapRenderingContext
  customContext;
  // https://developer.mozilla.org/en-US/docs/Web/API/Path2D
  currentPath2D = new Path2D();
  path2Ds = [];
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix
  currentMatrix = new DOMMatrix();
  // currentMatrix = document
  //   .createElementNS("http://www.w3.org/2000/svg", "svg")
  //   .createSVGMatrix();
  hasSetCustomStrokeStyle = !1;
  hasSetCustomFillStyle = !1;
  constructor(t, e, s, i = !1) {
    this.canvas = t, this.context = t.getContext("2d", {
      willReadFrequently: !0
    }), i && (this.customContext = new h0({
      canvas: this.canvas,
      width: e || this.canvas.width,
      height: s || this.canvas.height
    }));
  }
  set lineWidth(t) {
    this.hasSetCustomStrokeStyle = !0, this.context.lineWidth = t, this.customContext && (this.customContext.lineWidth = t);
  }
  get lineWidth() {
    return this.context.lineWidth;
  }
  set lineCap(t) {
    this.hasSetCustomStrokeStyle = !0, this.context.lineCap = t, this.customContext && (this.customContext.lineCap = t);
  }
  get lineCap() {
    return this.context.lineCap;
  }
  set lineJoin(t) {
    this.hasSetCustomStrokeStyle = !0, this.context.lineJoin = t, this.customContext && (this.customContext.lineCap = t);
  }
  get lineJoin() {
    return this.context.lineJoin;
  }
  set lineDashOffset(t) {
    this.hasSetCustomStrokeStyle = !0, this.context.lineDashOffset = t, this.customContext && (this.customContext.lineDashOffset = t);
  }
  get lineDashOffset() {
    return this.context.lineDashOffset;
  }
  set miterLimit(t) {
    this.hasSetCustomStrokeStyle = !0, this.context.miterLimit = t, this.customContext && (this.customContext.miterLimit = t);
  }
  get miterLimit() {
    return this.context.miterLimit;
  }
  set globalAlpha(t) {
    this.context.globalAlpha = t, this.customContext && (this.customContext.globalAlpha = t);
  }
  get globalAlpha() {
    return this.context.globalAlpha;
  }
  // rgb(255,221,0)
  // rgba(255,221,0,1)
  // #000000
  set fillStyle(t) {
    this.hasSetCustomFillStyle = !0, typeof t == "string" || t instanceof CanvasGradient || t instanceof CanvasPattern ? (this.context.fillStyle = t, this.customContext && (this.customContext.fillStyle = t)) : (this.context.fillStyle = t.gradient, this.customContext && (this.customContext.fillStyle = t.gradientCustom));
  }
  get fillStyle() {
    return this.context.fillStyle;
  }
  set strokeStyle(t) {
    this.hasSetCustomStrokeStyle = !0, typeof t == "string" || t instanceof CanvasGradient || t instanceof CanvasPattern ? (this.context.strokeStyle = t, this.customContext && (this.customContext.strokeStyle = t)) : (this.context.strokeStyle = t.gradient, this.customContext && (this.customContext.strokeStyle = t.gradientCustom));
  }
  get strokeStyle() {
    return this.context.strokeStyle;
  }
  // font:"10px sans-serif"
  set font(t) {
    this.context.font = t, this.customContext && (this.customContext.font = t);
  }
  get font() {
    return this.context.font;
  }
  set textBaseline(t) {
    this.context.textBaseline = t, this.customContext && (this.customContext.textBaseline = t);
  }
  get textBaseline() {
    return this.context.textBaseline;
  }
  set textAlign(t) {
    this.context.textAlign = t, this.customContext && (this.customContext.textAlign = t);
  }
  get textAlign() {
    return this.context.textAlign;
  }
  fill(t) {
    return t ? this.context.fill(t) : (this.context.fill(), this.customContext && this.customContext.fill()), this;
  }
  fillRect(t, e, s, i) {
    return this.context.fillRect(t, e, s, i), this.customContext && this.customContext.fillRect(t, e, s, i), this;
  }
  fillText(t, e, s, i) {
    return this.hasSetCustomFillStyle = !1, this.context.fillText(t, e, s, i), this.customContext && this.customContext.fillText(t, e, s), this;
  }
  setLineDash(t) {
    return this.context.setLineDash(t), this.customContext && this.customContext.setLineDash(t), this;
  }
  stroke(t) {
    return t ? this.context.stroke(t) : (this.context.stroke(), this.customContext && this.customContext.stroke()), this;
  }
  strokeText(t, e, s, i) {
    return this.context.strokeText(t, e, s, i), this.customContext && this.customContext.strokeText(t, e, s), this;
  }
  strokeRect(t, e, s, i) {
    return this.context.strokeRect(t, e, s, i), this.customContext && this.customContext.strokeRect(t, e, s, i), this;
  }
  measureText(t) {
    return this.context.measureText(t);
  }
  clearRect(t = 0, e = 0, s = this.canvas.width, i = this.canvas.height) {
    return this.context.clearRect(t, e, s, i), this.customContext && this.customContext.clearRect(t, e, s, i), this;
  }
  save() {
    return this.context.save(), this.customContext && this.customContext.save(), this.currentMatrix = new DOMMatrix(), this.path2Ds.push(this.currentPath2D), this.currentPath2D = new Path2D(), this;
  }
  restore() {
    return this.context.restore(), this.customContext && this.customContext.restore(), this.hasSetCustomStrokeStyle = !1, this.hasSetCustomFillStyle = !1, this.currentMatrix = new DOMMatrix(), this.currentPath2D = this.path2Ds.pop() || new Path2D(), this;
  }
  beginPath() {
    return this.context.beginPath(), this.customContext && this.customContext.beginPath(), this;
  }
  closePath() {
    return this.context.closePath(), this.customContext && this.customContext.closePath(), this.currentPath2D.closePath(), this;
  }
  changePath2D(t = this.currentPath2D, e = this.currentMatrix) {
    const s = new Path2D();
    s.addPath(t, e), this.currentPath2D = s;
  }
  isPointInStroke(...t) {
    return t[0] instanceof Path2D ? this.context.isPointInStroke(t[0], t[1], t[2]) : this.context.isPointInStroke(t[0], t[1]);
  }
  isPointInPath(...t) {
    return t[0] instanceof Path2D ? this.context.isPointInPath(t[0], t[1], t[2]) : this.context.isPointInPath(t[0], t[1]);
  }
  // transform(a: number, b: number, c: number, d: number, e: number, f: number) {
  //   this.context.transform(a, b, c, d, e, f);
  //   if (this.customContext) this.customContext.transform(a, b, c, d, e, f);
  //   return this;
  // }
  translate(t, e) {
    return this.context.translate(t, e), this.customContext && this.customContext.translate(t, e), this.currentMatrix.translate(t, e), this.changePath2D(), this;
  }
  rotate(t, e = 0, s = 0) {
    return this.translate(e, s), this.context.rotate(t), this.customContext && this.customContext.rotate(t), this.currentMatrix.rotate(t), this.translate(-e, -s), this.changePath2D(), this;
  }
  scale(t, e = t, s = 0, i = 0) {
    return this.translate(s, i), this.context.scale(t, e), this.customContext && this.customContext.scale(t, e), this.currentMatrix.scale(t, e), this.translate(-s, -i), this.changePath2D(), this;
  }
  moveTo(t, e) {
    return this.context.moveTo(t, e), this.customContext && this.customContext.moveTo(t, e), this.currentPath2D.moveTo(t, e), this;
  }
  lineTo(t, e) {
    return this.context.lineTo(t, e), this.customContext && this.customContext.lineTo(t, e), this.currentPath2D.lineTo(t, e), this;
  }
  arc(t, e, s, i, r, o) {
    return this.context.arc(t, e, s, i, r, o), this.customContext && this.customContext.arc(
      t,
      e,
      s,
      i,
      r,
      o ? -1 : 1
    ), this.currentPath2D.arc(
      t,
      e,
      s,
      i,
      r,
      o
    ), this;
  }
  arcTo(t, e, s, i, r) {
    return this.context.arcTo(t, e, s, i, r), this.customContext && this.customContext.arcTo(t, e, s, i, r), this.currentPath2D.arcTo(t, e, s, i, r), this;
  }
  ellipse(t, e, s, i, r, o, a, h) {
    return this.context.ellipse(
      t,
      e,
      s,
      i,
      r,
      o,
      a,
      h
    ), this.currentPath2D.ellipse(
      t,
      e,
      s,
      i,
      r,
      o,
      a,
      h
    ), this;
  }
  quadraticCurveTo(t, e, s, i) {
    return this.context.quadraticCurveTo(t, e, s, i), this.customContext && this.customContext.quadraticCurveTo(t, e, s, i), this.currentPath2D.quadraticCurveTo(t, e, s, i), this;
  }
  bezierCurveTo(t, e, s, i, r, o) {
    return this.context.bezierCurveTo(t, e, s, i, r, o), this.customContext && this.customContext.bezierCurveTo(t, e, s, i, r, o), this.currentPath2D.bezierCurveTo(t, e, s, i, r, o), this;
  }
  rect(t, e, s, i) {
    return this.context.rect(t, e, s, i), this.customContext && this.customContext.rect(t, e, s, i), this.currentPath2D.rect(t, e, s, i), this;
  }
  // { 0: "#ffffff", 1: "#ff0000" }
  createLinearGradient(t, e, s, i, r) {
    const o = this.context.createLinearGradient(
      t,
      e,
      s,
      i
    );
    return r && Object.entries(r).forEach(([a, h]) => {
      o.addColorStop(parseFloat(a), h);
    }), o;
  }
  createRadialGradient(t, e, s, i, r, o, a) {
    const h = this.context.createRadialGradient(
      t,
      e,
      s,
      i,
      r,
      o
    );
    return a && Object.entries(a).forEach(([c, l]) => {
      h.addColorStop(parseFloat(c), l);
    }), h;
  }
  //  const image = new Image();
  //  image.src = "../assets/images/picture.jpg";
  //  image.onload = function () {
  //    co.drawImage(image);
  //  };
  drawImage(t, ...e) {
    if (e.length === 0)
      this.context.drawImage(t, 0, 0);
    else if (e.length === 2) {
      const s = e[0], i = e[1];
      this.context.drawImage(t, s, i);
    } else if (e.length === 4) {
      const s = e[0], i = e[1], r = e[2], o = e[3];
      this.context.drawImage(t, s, i, r, o);
    } else if (e.length === 8) {
      const s = e[0], i = e[1], r = e[2], o = e[3], a = e[4], h = e[5], c = e[6], l = e[7];
      this.context.drawImage(t, s, i, r, o, a, h, c, l);
    } else
      throw new Error(
        "Invalid number of arguments passed to drawImage: " + e.length
      );
    return this.customContext && this.customContext.drawImage(t, ...e), this;
  }
  getImageData(t = 0, e = 0, s = this.canvas.width, i = this.canvas.height, r) {
    return this.context.getImageData(t, e, s, i, r);
  }
  putImageData(t, e = 0, s = 0) {
    return this.context.putImageData(t, e, s);
  }
  createPattern(t, e) {
    return this.context.createPattern(t, e);
  }
  toRawSVG() {
    if (this.customContext) {
      const t = this.customContext.getSerializedSvg(!0), e = this.customContext.getSvg();
      return { raw: t, element: e };
    } else
      return { raw: "", element: null };
  }
}, io = class {
  x;
  y;
  toX;
  toY;
  constructor(t) {
    this.x = t?.x || 0, this.y = t?.y || 0, this.toX = t?.toX || 0, this.toY = t?.toY || 0;
  }
  toSVGPathData() {
    return [["L", this.toX, this.toY]];
  }
  toCanvasContext(t) {
    t.lineTo(this.toX, this.toY);
  }
  getBoundingClientRect() {
    const t = qt(this.x, this.y, this.toX, this.toY);
    if (t === 0) {
      const e = Math.min(this.x, this.toX), s = Math.min(this.y, this.toY), i = Math.max(this.x, this.toX), r = Math.max(this.y, this.toY);
      return {
        x: e,
        y: s,
        width: i - e,
        height: r - s
      };
    } else {
      const e = Math.sin(t), s = Math.cos(t), i = s * this.x - e * this.y, r = s * this.toX - e * this.toY, o = s * this.y + e * this.x, a = s * this.toY + e * this.toX;
      return {
        x: Math.min(i, r),
        y: Math.min(o, a),
        width: Math.max(i, r) - Math.min(i, r),
        height: Math.max(o, a) - Math.min(o, a)
      };
    }
  }
  // t : The fraction of the overall duration of the path. (A value from 0.0 to 1.0)
  interpolate(t) {
    return {
      x: this.x + t * (this.toX - this.x),
      y: this.y + t * (this.toY - this.y)
    };
  }
  intersection(t) {
    const e = this.x, s = this.y, i = t.toX, r = t.toY, o = this.toX - e, a = t.x - i;
    if (!o && !a)
      return null;
    const h = (this.toY - s) / o, c = (t.y - r) / a;
    if (o) {
      if (!a)
        return { x: i, y: h * (i - e) + s };
    } else
      return { x: e, y: c * (e - i) + r };
    const l = (-c * i + r + h * e - s) / (h - c), u = h * (l - e) + s;
    return isNaN(l) || isNaN(u) ? null : { x: l, y: u };
  }
}, c0 = class extends io {
  // x方向的半径
  rx;
  // y方向的半径
  ry;
  // 绕着x轴旋转的角度
  xAxisRotate;
  // 0小弧 1大弧
  largeArcFlag;
  // 0逆时针方向 1顺时针方向
  sweepFlag;
  constructor(t) {
    super(t), this.rx = t.rx, this.ry = t.ry, this.xAxisRotate = t?.xAxisRotate ?? 0, this.largeArcFlag = t?.largeArcFlag ?? 1, this.sweepFlag = t?.sweepFlag ?? 1, this.toX = t.toX, this.toY = t.toY;
  }
  /// A rx,ry xAxisRotate LargeArcFlag,SweepFlag x,y
  toSVGPathData() {
    return [
      [
        "A",
        this.rx,
        this.ry,
        this.xAxisRotate,
        this.largeArcFlag,
        this.sweepFlag,
        this.toX,
        this.toY
      ]
    ];
  }
  toCanvasContext(t) {
    const [e, s, i, r, o, a, h] = this.convert(
      this.x,
      this.y,
      this.toX,
      this.toY,
      this.rx,
      this.ry,
      this.xAxisRotate,
      this.largeArcFlag,
      this.sweepFlag
    );
    t.ellipse(
      e,
      s,
      i,
      r,
      o,
      a,
      h,
      !this.sweepFlag
    );
  }
  convert(t, e, s, i, r, o, a, h, c) {
    const l = a / 180 * Math.PI, u = (t - s) / 2, d = (e - i) / 2, f = Math.cos(l) * u + Math.sin(l) * d, m = -Math.sin(l) * u + Math.cos(l) * d, p = f * f / (r * r) + m * m / (o * o);
    if (p > 1) {
      const V = Math.sqrt(p);
      throw r = V * r, o = V * o, new Error(
        `Radii are too small to build an arc. Correcting them to ${r}/${o}.`
      );
    }
    const S = Math.sqrt(
      (r * r * o * o - r * r * m * m - o * o * f * f) / (r * r * m * m + o * o * f * f)
    ), g = h != c ? 1 : -1, b = g * S * r * m / o, x = g * S * -o * f / r, w = (t + s) / 2, C = (e + i) / 2, _ = Math.cos(l) * b - Math.sin(l) * x + w, D = Math.sin(l) * b + Math.cos(l) * x + C, z = (V, j, et, J) => (V * J >= j * et ? 1 : -1) * Math.acos(
      (V * et + j * J) / (Math.sqrt(V * V + j * j) * Math.sqrt(et * et + J * J))
    ), B = z(1, 0, t - _, e - D) - l, G = z(t - _, e - D, s - _, i - D);
    return [_, D, r, o, l, B, B + G];
  }
};
const l0 = c0;
let u0 = class extends io {
  cx;
  cy;
  isLineThrough;
  constructor(t) {
    super(t), this.cx = t.cx, this.cy = t.cy, this.isLineThrough = typeof t.isLineThrough == "boolean" ? t.isLineThrough : !1;
  }
  /// Q cx,cy x,y
  /// T x,y
  toSVGPathData() {
    if (this.isLineThrough) {
      const t = this.cx * 2 - (this.x + this.toX) / 2, e = this.cy * 2 - (this.y + this.toY) / 2;
      return [["Q", t, e, this.toX, this.toY]];
    } else
      return [["Q", this.cx, this.cy, this.toX, this.toY]];
  }
  toCanvasContext(t) {
    if (this.isLineThrough) {
      const e = this.cx * 2 - (this.x + this.toX) / 2, s = this.cy * 2 - (this.y + this.toY) / 2;
      t.quadraticCurveTo(e, s, this.toX, this.toY);
    } else
      t.quadraticCurveTo(this.cx, this.cy, this.toX, this.toY);
  }
  getBoundingClientRect() {
    const t = [this.x, this.toX], e = [this.y, this.toY];
    let s, i, r, o;
    for (let c = 0; c < 2; ++c)
      s = c == 0 ? this.x - 2 * this.cx + this.toX : this.y - 2 * this.cy + this.toY, i = c == 0 ? -2 * this.x + 2 * this.cx : -2 * this.y + 2 * this.cy, r = c == 0 ? this.x : this.y, Math.abs(s) > 1e-12 && (o = -i / (2 * s), 0 < o && o < 1 && [t, e][c].push(s * o * o + i * o + r));
    const a = { x: Math.min.apply(0, t), y: Math.min.apply(0, e) }, h = { x: Math.max.apply(0, t), y: Math.max.apply(0, e) };
    return {
      x: a.x,
      y: a.y,
      width: h.x - a.x,
      height: h.y - a.y
    };
  }
  // t : The fraction of the overall duration of the path. (A value from 0.0 to 1.0)
  interpolate(t) {
    return {
      x: (1 - t) * (1 - t) * this.x + 2 * (1 - t) * t * this.cx + t * t * this.toX,
      y: (1 - t) * (1 - t) * this.y + 2 * (1 - t) * t * this.cy + t * t * this.toY
    };
  }
};
const f0 = u0;
let d0 = class Is extends io {
  c1x;
  c1y;
  c2x;
  c2y;
  constructor(t) {
    super(t), this.c1x = t.c1x, this.c1y = t.c1y, this.c2x = t.c2x, this.c2y = t.c2y;
  }
  /// C c1x,c1y c2x,c2y x,y
  /// S c2x,c2y x,y
  toSVGPathData() {
    return [["C", this.c1x, this.c1y, this.c2x, this.c2y, this.toX, this.toY]];
  }
  toCanvasContext(t) {
    t.bezierCurveTo(
      this.c1x,
      this.c1y,
      this.c2x,
      this.c2y,
      this.toX,
      this.toY
    );
  }
  getBoundingClientRect() {
    let t = this.c2x - 2 * this.c1x + this.x - (this.toX - 2 * this.c2x + this.c1x), e = 2 * (this.c1x - this.x) - 2 * (this.c2x - this.c1x), s = this.x - this.c1x, i = (-e + Math.sqrt(e * e - 4 * t * s)) / 2 / t, r = (-e - Math.sqrt(e * e - 4 * t * s)) / 2 / t;
    const o = [this.y, this.toY], a = [this.x, this.toX];
    let h;
    const c = [];
    Math.abs(i) > 1e12 && (i = 0.5), Math.abs(r) > 1e12 && (r = 0.5), i >= 0 && i <= 1 && (h = this.interpolate(i), a.push(h.x), o.push(h.y), c.push({ X: h.x, Y: h.y })), r >= 0 && r <= 1 && (h = this.interpolate(r), a.push(h.x), o.push(h.y), c.push({ X: h.x, Y: h.y })), t = this.c2y - 2 * this.c1y + this.y - (this.toY - 2 * this.c2y + this.c1y), e = 2 * (this.c1y - this.y) - 2 * (this.c2y - this.c1y), s = this.y - this.c1y, i = (-e + Math.sqrt(e * e - 4 * t * s)) / 2 / t, r = (-e - Math.sqrt(e * e - 4 * t * s)) / 2 / t, Math.abs(i) > 1e12 && (i = 0.5), Math.abs(r) > 1e12 && (r = 0.5), i >= 0 && i <= 1 && (h = this.interpolate(i), a.push(h.x), o.push(h.y), c.push({ X: h.x, Y: h.y })), r >= 0 && r <= 1 && (h = this.interpolate(r), a.push(h.x), o.push(h.y), c.push({ X: h.x, Y: h.y }));
    const l = [], u = c.length;
    for (let m = 0; m < u; m++) {
      for (let p = m + 1; p < u; p++)
        c[m].X === c[p].X && c[m].Y === c[p].Y && (p = ++m);
      l.push({ X: c[m].X, Y: c[m].Y });
    }
    const d = { x: Math.min.apply(Math, a), y: Math.min.apply(Math, o) }, f = { x: Math.max.apply(Math, a), y: Math.max.apply(Math, o) };
    return {
      x: d.x,
      y: d.y,
      width: f.x - d.x,
      height: f.y - d.y,
      dots: l
      // these are the extrema points
    };
  }
  /// t (0.0 to 1.0) : The fraction of the overall duration of the path
  interpolate(t) {
    return {
      x: Math.pow(1 - t, 3) * this.x + 3 * Math.pow(1 - t, 2) * t * this.c1x + 3 * Math.pow(1 - t, 1) * Math.pow(t, 2) * this.c2x + Math.pow(t, 3) * this.toX,
      y: Math.pow(1 - t, 3) * this.y + 3 * Math.pow(1 - t, 2) * t * this.c1y + 3 * Math.pow(1 - t, 1) * Math.pow(t, 2) * this.c2y + Math.pow(t, 3) * this.toY
    };
  }
  static base3(t, e, s, i, r) {
    const o = -3 * e + 9 * s - 9 * i + 3 * r, a = t * o + 6 * e - 12 * s + 6 * i;
    return t * a - 3 * e + 3 * s;
  }
  /**
   * Based on snap.svg bezlen() function
   * like getTotalLength(), approximate a cubic bézier length
   * https://github.com/adobe-webplatform/Snap.svg/blob/master/dist/snap.svg.js#L5786
   */
  static bezlen(t, e, s, i, r, o, a, h, c = 1) {
    c = Math.max(0, Math.min(c, 1));
    const l = c / 2, u = [
      -0.1252,
      0.1252,
      -0.3678,
      0.3678,
      -0.5873,
      0.5873,
      -0.7699,
      0.7699,
      -0.9041,
      0.9041,
      -0.9816,
      0.9816
    ], d = [
      0.2491,
      0.2491,
      0.2335,
      0.2335,
      0.2032,
      0.2032,
      0.1601,
      0.1601,
      0.1069,
      0.1069,
      0.0472,
      0.0472
    ];
    let f = 0;
    for (let m = 0; m < 12; m++) {
      const p = l * u[m] + l, S = this.base3(p, t, s, r, a), g = this.base3(p, e, i, o, h);
      f += d[m] * Math.sqrt(S * S + g * g);
    }
    return l * f;
  }
  length(t = 1) {
    return Is.bezlen(
      this.x,
      this.y,
      this.c1x,
      this.c1y,
      this.c2x,
      this.c2y,
      this.toX,
      this.toY,
      t
    );
  }
  /// get position on the curve (0..1)
  getTatLen(t) {
    const e = this.x, s = this.y, i = this.c1x, r = this.c1y, o = this.c2x, a = this.c2y, h = this.toX, c = this.toY;
    if (t < 0 || Is.bezlen(e, s, i, r, o, a, h, c) < t)
      return 0;
    const l = 1;
    let u = l / 2, d = l - u, f = Is.bezlen(e, s, i, r, o, a, h, c, d);
    for (; Math.abs(f - t) > 0.01; )
      u /= 2, d += (f < t ? 1 : -1) * u, f = Is.bezlen(e, s, i, r, o, a, h, c, d);
    return d;
  }
  /// Find dot coordinates on the given cubic bezier curve at the given t
  getPointAtSegmentLength(t) {
    const e = this.getTatLen(t), s = 1 - e, i = Math.pow(s, 3), r = Math.pow(s, 2), o = e * e, a = o * e, h = i * this.x + r * 3 * e * this.c1x + s * 3 * e * e * this.c2x + a * this.toX, c = i * this.y + r * 3 * e * this.c1y + s * 3 * e * e * this.c2y + a * this.toY, l = this.x + 2 * e * (this.c1x - this.x) + o * (this.c2x - 2 * this.c1x + this.x), u = this.y + 2 * e * (this.c1y - this.y) + o * (this.c2y - 2 * this.c1y + this.y), d = this.c1x + 2 * e * (this.c2x - this.c1x) + o * (this.toX - 2 * this.c2x + this.c1x), f = this.c1y + 2 * e * (this.c2y - this.c1y) + o * (this.toY - 2 * this.c2y + this.c1y), m = s * this.x + e * this.c1x, p = s * this.y + e * this.c1y, S = s * this.c2x + e * this.toX, g = s * this.c2y + e * this.toY, b = 90 - Math.atan2(l - d, u - f) * 180 / Math.PI;
    return {
      x: h,
      // x coordinate of the point
      y: c,
      // y coordinate of the point
      m: {
        x: l,
        // x coordinate of the left anchor
        y: u
        // y coordinate of the left anchor
      },
      n: {
        x: d,
        // x coordinate of the right anchor
        y: f
        // y coordinate of the right anchor
      },
      start: {
        x: m,
        // x coordinate of the start of the curve
        y: p
        // y coordinate of the start of the curve
      },
      end: {
        x: S,
        //  x coordinate of the end of the curve
        y: g
        // y coordinate of the end of the curve
      },
      alpha: b
      // degree: angle of the curve derivative at the point
    };
  }
};
const Ce = d0, Ns = Math.PI * 2;
function Sa(n, t, e, s) {
  const i = n * s - t * e < 0 ? -1 : 1;
  let r = n * e + t * s;
  return r > 1 && (r = 1), r < -1 && (r = -1), i * Math.acos(r);
}
function m0(n, t, e, s, i, r, o, a, h, c) {
  const l = c * (n - e) / 2 + h * (t - s) / 2, u = -h * (n - e) / 2 + c * (t - s) / 2, d = o * o, f = a * a, m = l * l, p = u * u;
  let S = d * f - d * p - f * m;
  S < 0 && (S = 0), S /= d * p + f * m, S = Math.sqrt(S) * (i === r ? -1 : 1);
  const g = S * o / a * u, b = S * -a / o * l, x = c * g - h * b + (n + e) / 2, w = h * g + c * b + (t + s) / 2, C = (l - g) / o, _ = (u - b) / a, D = (-l - g) / o, z = (-u - b) / a, B = Sa(1, 0, C, _);
  let G = Sa(C, _, D, z);
  return r === 0 && G > 0 && (G -= Ns), r === 1 && G < 0 && (G += Ns), [x, w, B, G];
}
function p0(n, t) {
  const e = 1.3333333333333333 * Math.tan(t / 4), s = Math.cos(n), i = Math.sin(n), r = Math.cos(n + t), o = Math.sin(n + t);
  return [
    s,
    i,
    s - i * e,
    i + s * e,
    r + o * e,
    o - r * e,
    r,
    o
  ];
}
function Oc(n, t, e, s, i, r, o, a, h) {
  const c = Math.sin(h * Ns / 360), l = Math.cos(h * Ns / 360), u = l * (n - e) / 2 + c * (t - s) / 2, d = -c * (n - e) / 2 + l * (t - s) / 2;
  if (u === 0 && d === 0)
    return [];
  if (o === 0 || a === 0)
    return [];
  o = Math.abs(o), a = Math.abs(a);
  const f = u * u / (o * o) + d * d / (a * a);
  f > 1 && (o *= Math.sqrt(f), a *= Math.sqrt(f));
  const m = m0(n, t, e, s, i, r, o, a, c, l), p = [];
  let S = m[2], g = m[3];
  const b = Math.max(Math.ceil(Math.abs(g) / (Ns / 4)), 1);
  g /= b;
  for (let x = 0; x < b; x++)
    p.push(p0(S, g)), S += g;
  return p.map((x) => {
    for (let w = 0; w < x.length; w += 2) {
      let C = x[w + 0], _ = x[w + 1];
      C *= o, _ *= a;
      const D = l * C - c * _, z = c * C + l * _;
      x[w + 0] = D + m[0], x[w + 1] = z + m[1];
    }
    return x;
  });
}
function mr(n, t, e, s, i, r) {
  return [
    n / 3 + 2 / 3 * e,
    t / 3 + 2 / 3 * s,
    i / 3 + 2 / 3 * e,
    r / 3 + 2 / 3 * s,
    i,
    r
  ];
}
function ks(n, t, e, s) {
  return [n, t, e, s, e, s];
}
const bn = {
  a: 7,
  // A rx,ry xAxisRotate LargeArcFlag,SweepFlag x,y
  c: 6,
  // C c1x,c1y c2x,c2y x,y
  s: 4,
  // S c2x,c2y x,y
  q: 4,
  // Q cx,cy x,y
  t: 2,
  // T x,y
  m: 2,
  // M x,y
  l: 2,
  // L x,y
  h: 1,
  // H x
  v: 1,
  // V y
  z: 0
  // Z
  // r: 4
};
class rs {
  static createSVGElement(t = "path", e) {
    const s = document.createElementNS.call(
      document,
      "http://www.w3.org/2000/svg",
      t
    );
    return e && Me(s, e), s;
  }
  static createSvgPath(t, e) {
    return this.createSVGElement("path", { d: t, id: e || Xs() });
  }
  static downloadFromSVGElement(t, e = "shape") {
    return pr(
      Vh(t),
      `${e}.svg`
    );
  }
  static downloadFromSVGString(t, e = "shape") {
    return pr(Dr(t), `${e}.svg`);
  }
  static getSVGRawStringFromElement(t) {
    return Gh(t);
  }
  // https://github.com/dy/is-svg-path
  // isSVGPath('M0 0L10 20 20 0Z') //true
  // isSVGPath('M00Z') //false
  // isSVGPath('xyz') //false
  static isSVGPath(t) {
    return typeof t != "string" ? !1 : (t = t.trim(), /^[mlhvzaqtcs]\s*[-+.0-9][^mlhvzaqtcs]+/i.test(t) && /[\dz]$/i.test(t));
  }
  static SVGPathDataToD(t) {
    return t.map((e) => {
      if (!e[0])
        return "";
      switch (e[0].toLowerCase()) {
        case "a":
          return `${e[0]} ${e[1]},${e[2]} ${e[3]} ${e[4]},${e[5]} ${e[6]},${e[7]}`;
        case "c":
          return `${e[0]} ${e[1]},${e[2]} ${e[3]},${e[4]} ${e[5]},${e[6]}`;
        case "s":
        case "q":
          return `${e[0]} ${e[1]},${e[2]} ${e[3]},${e[4]}`;
        default:
          return e[0] + " " + e.slice(1).join(",");
      }
    }).join(" ");
  }
  /// parse an svg path data string to `[[command, arg1, arg2, ...], ...]`
  static parseSVGPath(t) {
    const e = [];
    return rs.isSVGPath(t) && t.replace(
      /([mlhvzaqtcs])([^mlhvzaqtcs]*)/gi,
      (s, i, r) => {
        let o = i.toLowerCase();
        const a = Ir(r);
        for (o == "m" && a.length > bn[o] && (e.push([
          i,
          ...a.splice(0, bn[o])
        ]), o = "l", i = i == "m" ? "l" : "L"); a.length; ) {
          if (a.length < bn[o])
            throw new Error(
              `parseSVGPath substring:{ ${s} } command:{ ${i} } args:{ ${a} }`
            );
          e.push([
            i,
            ...a.splice(0, bn[o])
          ]);
        }
        return o == "z" && e.push([i]), "";
      }
    ), e;
  }
  /// https://github.com/jkroso/abs-svg-path
  static absolutizeSVGPath(t) {
    let e = 0, s = 0, i = 0, r = 0;
    return t.map(function(o) {
      const a = o[0], h = a.toUpperCase();
      if (a != h)
        switch (o[0] = h, a) {
          case "a":
            o[6] += i, o[7] += r;
            break;
          case "v":
            o[1] += r;
            break;
          case "h":
            o[1] += i;
            break;
          default:
            for (let c = 1; c < o.length; )
              o[c++] += i, o[c++] += r;
        }
      switch (h) {
        case "Z":
          i = e, r = s;
          break;
        case "H":
          i = o[1];
          break;
        case "V":
          r = o[1];
          break;
        case "M":
          i = e = o[1], r = s = o[2];
          break;
        default:
          i = o[o.length - 2], r = o[o.length - 1];
      }
      return o;
    });
  }
  static relativeSVGPath(t) {
    let e = 0, s = 0, i = 0, r = 0;
    return t.map(function(o) {
      const a = o[0], h = a.toLowerCase();
      if (a != h)
        switch (o[0] = h, a) {
          case "A":
            o[6] -= i, o[7] -= r;
            break;
          case "V":
            o[1] -= r;
            break;
          case "H":
            o[1] -= i;
            break;
          default:
            for (let c = 1; c < o.length; )
              o[c++] -= i, o[c++] -= r;
        }
      switch (h) {
        case "z":
          i = e, r = s;
          break;
        case "h":
          i += o[1];
          break;
        case "v":
          r += o[1];
          break;
        case "m":
          i += o[1], r += o[2], e += o[1], s += o[2];
          break;
        default:
          i += o[o.length - 2], r += o[o.length - 1];
      }
      return o;
    });
  }
  /// 统统变为 CubicBezier
  /// https://github.com/jkroso/normalize-svg-path
  static normalizeSVGPath(t) {
    const e = [];
    let s = 0, i = 0, r = 0, o = 0, a = 0, h = 0, c = 0, l = 0, u;
    for (let d = 0, f = t.length; d < f; d++) {
      let m = t[d];
      const p = m[0];
      switch (p) {
        case "M":
          s = m[1], i = m[2];
          break;
        case "A":
          const S = Oc(
            r,
            o,
            m[6],
            m[7],
            m[4],
            m[5],
            m[1],
            m[2],
            m[3]
          );
          if (!S.length)
            continue;
          S.forEach((x, w) => {
            const [C, _, D, z, B, G, V, j] = x;
            m = ["C", D, z, B, G, V, j], w < S.length - 1 && e.push(m);
          });
          break;
        case "S":
          let g = r, b = o;
          (u == "C" || u == "S") && (g += g - c, b += b - l), m = ["C", g, b, m[1], m[2], m[3], m[4]];
          break;
        case "T":
          u == "Q" || u == "T" ? (a = r * 2 - a, h = o * 2 - h) : (a = r, h = o), m = ["C", ...mr(r, o, a, h, m[1], m[2])];
          break;
        case "Q":
          a = m[1], h = m[2], m = ["C", ...mr(r, o, m[1], m[2], m[3], m[4])];
          break;
        case "L":
          m = ["C", ...ks(r, o, m[1], m[2])];
          break;
        case "H":
          m = ["C", ...ks(r, o, m[1], o)];
          break;
        case "V":
          m = ["C", ...ks(r, o, r, m[1])];
          break;
        case "Z":
          m = ["C", ...ks(r, o, s, i)];
          break;
      }
      u = p, r = m[m.length - 2], o = m[m.length - 1], m.length > 4 ? (c = m[m.length - 4], l = m[m.length - 3]) : (c = r, l = o), e.push(m);
    }
    return e;
  }
  /// http://schepers.cc/getting-to-the-point
  /// Catmull-Rom curves : `R x1,y1 x2,y2 x3,y3`
  static catmullRom2bezier(t) {
    const e = [];
    for (let s = 0, i = t.length; i - 2 > s; s += 2) {
      let r;
      s == 0 ? r = [
        { x: t[s], y: t[s + 1] },
        { x: t[s], y: t[s + 1] },
        { x: t[s + 2], y: t[s + 3] },
        { x: t[s + 4], y: t[s + 5] }
      ] : i - 4 == s ? r = [
        { x: t[s - 2], y: t[s - 1] },
        { x: t[s], y: t[s + 1] },
        { x: t[s + 2], y: t[s + 3] },
        { x: t[s + 2], y: t[s + 3] }
      ] : r = [
        { x: t[s - 2], y: t[s - 1] },
        { x: t[s], y: t[s + 1] },
        { x: t[s + 2], y: t[s + 3] },
        { x: t[s + 4], y: t[s + 5] }
      ];
      const o = [
        { x: r[1].x, y: r[1].y },
        {
          x: (-r[0].x + 6 * r[1].x + r[2].x) / 6,
          y: (-r[0].y + 6 * r[1].y + r[2].y) / 6
        },
        {
          x: (r[1].x + 6 * r[2].x - r[3].x) / 6,
          y: (r[1].y + 6 * r[2].y - r[3].y) / 6
        },
        { x: r[2].x, y: r[2].y }
      ];
      e.push(["C", o[1].x, o[1].y, o[2].x, o[2].y, o[3].x, o[3].y]);
    }
    return e;
  }
  // Convert 'Z', 'V' and 'H' segments to 'L' segments
  static zvhToLSVGPath(t) {
    const e = [];
    let s = ["L", 0, 0], i;
    for (let r = 0, o = t.length; r < o; r++) {
      const a = t[r];
      switch (a[0]) {
        case "M":
          s = ["L", a[1], a[2]], e.push(a);
          break;
        case "Z":
          e.push(s);
          break;
        case "H":
          i = e[e.length - 1] || ["L", 0, 0], e.push([
            "L",
            a[1],
            i[i.length - 1]
          ]);
          break;
        case "V":
          i = e[e.length - 1] || ["L", 0, 0], e.push([
            "L",
            i[i.length - 2],
            a[1]
          ]);
          break;
        default:
          e.push(a);
      }
    }
    return e;
  }
  // Expand shorthand curve commands to full versions; mutates the path in place for efficiency
  // Requires commands have already been converted to absolute versions
  static longhandSVGPath(t) {
    const e = {
      S: { to: "C", x: 3 },
      T: { to: "Q", x: 1 }
    };
    let s, i = 0, r = 0;
    for (let o = 0, a = t.length; o < a; o++) {
      const h = t[o], c = e[h[0]];
      c && (h[0] = c.to, s && (s[0] === c.to ? (i = 2 * Number(s[c.x + 2]) - Number(s[c.x]), r = 2 * Number(s[c.x + 3]) - Number(s[c.x + 1])) : (i = Number(s[s.length - 2]), r = Number(s[s.length - 1]))), h.splice(1, 0, i, r)), s = h;
    }
    return t;
  }
}
let g0 = class me {
  /// cX cY 为相对于自身 (0,0) 点的相对值
  cX;
  cY;
  x;
  y;
  degree;
  scalarX;
  scalarY;
  /// 绝对值
  startPathX = 0;
  startPathY = 0;
  prevPathX = 0;
  prevPathY = 0;
  normalizedLines = [];
  // d = "M0,0"
  // d = [['C',1,2,3,4,5,6]]
  constructor(t) {
    this.cX = 0, this.cY = 0, this.x = t?.x || 0, this.y = t?.y || 0, typeof t?.centerX == "number" && typeof t?.centerY == "number" && (this.cX = t.centerX - this.x, this.cY = t.centerY - this.y), this.degree = t?.degree || 0, this.scalarX = 1, this.scalarY = 1, t?.scalar !== void 0 && (this.scalarX = t.scalar, this.scalarY = t.scalar), t?.scalarX !== void 0 && (this.scalarX = t.scalarX), t?.scalarY !== void 0 && (this.scalarY = t.scalarY), this.reset(t?.d, t?.originMatrix);
  }
  reset(t, e) {
    typeof t == "string" ? this.resetFromSVGPathData(rs.parseSVGPath(t), e) : t instanceof me ? this.resetFromSVGPathData(t.toSVGPathData(), e) : this.resetFromSVGPathData(t || [], e);
  }
  resetFromSVGPathData(t, e) {
    this.normalizedLines = [];
    const s = rs.normalizeSVGPath(
      rs.absolutizeSVGPath(t)
    );
    this.prevPathX = this.startPathX = 0, this.prevPathY = this.startPathY = 0;
    let i = !1;
    for (let r = 0, o = s.length; r < o; r++) {
      const a = s[r];
      if (a[0] == "M") {
        i || (i = !0, this.startPathX = a[1], this.startPathY = a[2]), this.prevPathX = a[1], this.prevPathY = a[2];
        continue;
      }
      this.appendLine(
        new Ce({
          c1x: a[1],
          c1y: a[2],
          c2x: a[3],
          c2y: a[4],
          toX: a[5],
          toY: a[6]
        })
      );
    }
    e && ({ x: this.startPathX, y: this.startPathY } = e.transformPoint(
      {
        x: this.startPathX,
        y: this.startPathY
      }
    ), { x: this.prevPathX, y: this.prevPathY } = e.transformPoint({
      x: this.prevPathX,
      y: this.prevPathY
    }), this.normalizedLines.forEach((r) => {
      ({ x: r.x, y: r.y } = e.transformPoint({ x: r.x, y: r.y })), { x: r.c1x, y: r.c1y } = e.transformPoint({
        x: r.c1x,
        y: r.c1y
      }), { x: r.c2x, y: r.c2y } = e.transformPoint({
        x: r.c2x,
        y: r.c2y
      }), { x: r.toX, y: r.toY } = e.transformPoint({
        x: r.toX,
        y: r.toY
      });
    }));
  }
  static fromPolymorphPoints(t) {
    const e = new me();
    e.prevPathX = e.startPathX = t[0] || 0, e.prevPathY = e.startPathY = t[1] || 0;
    for (let s = 2, i = t.length; s + 5 < i; s += 6)
      e.appendLine(
        new Ce({
          c1x: t[s],
          c1y: t[s + 1],
          c2x: t[s + 2],
          c2y: t[s + 3],
          toX: t[s + 4],
          toY: t[s + 5]
        })
      );
    return e;
  }
  static fromLines(t) {
    const e = new me();
    e.prevPathX = e.startPathX = t[0].x || 0, e.prevPathY = e.startPathY = t[0].y || 0;
    for (let s = 0, i = t.length; s < i; s++)
      e.appendLine(t[s]);
    return e;
  }
  /// 涉及 this.prevPathX + this.prevPathY
  appendLine(t) {
    if (t instanceof l0) {
      Oc(
        this.prevPathX,
        this.prevPathY,
        t.toX,
        t.toY,
        t.largeArcFlag,
        t.sweepFlag,
        t.rx,
        t.ry,
        t.xAxisRotate
      ).forEach((c) => {
        const [l, u, d, f, m, p, S, g] = c;
        this.normalizedLines.push(
          new Ce({
            x: this.prevPathX,
            y: this.prevPathY,
            c1x: d,
            c1y: f,
            c2x: m,
            c2y: p,
            toX: S,
            toY: g
          })
        ), this.prevPathX = S, this.prevPathY = g;
      });
      return;
    }
    let e, s, i, r, o, a;
    t instanceof Ce ? (e = t.c1x, s = t.c1y, i = t.c2x, r = t.c2y, o = t.toX, a = t.toY) : t instanceof f0 ? [e, s, i, r, o, a] = mr(
      this.prevPathX,
      this.prevPathY,
      t.cx,
      t.cy,
      t.toX,
      t.toY
    ) : [e, s, i, r, o, a] = ks(
      this.prevPathX,
      this.prevPathY,
      t.toX,
      t.toY
    ), this.normalizedLines.push(
      new Ce({
        x: this.prevPathX,
        y: this.prevPathY,
        c1x: e,
        c1y: s,
        c2x: i,
        c2y: r,
        toX: o,
        toY: a
      })
    ), this.prevPathX = o, this.prevPathY = a;
  }
  /// 绝对值
  toSVGPathData() {
    const { startPathX: t, startPathY: e, normalizedLines: s } = this.updateTransform(), i = [];
    i.push(["M", t, e]);
    for (let r = 0, o = s.length; r < o; r++)
      i.push(...s[r].toSVGPathData());
    return i;
  }
  toSVGPathD() {
    return rs.SVGPathDataToD(this.toSVGPathData());
  }
  /// PathD 自己管理 canvas transform
  toCanvasContext(t) {
    const { startPathX: e, startPathY: s, normalizedLines: i } = this.updateTransform();
    t.beginPath(), t.moveTo(e, s), i.forEach((r) => {
      r.toCanvasContext(t);
    });
  }
  /// 绝对值
  getBoundingClientRect() {
    const { normalizedLines: t } = this.updateTransform(), e = [], s = [];
    if (t.forEach((h) => {
      const c = h.getBoundingClientRect();
      e.push(c.x, c.x + c.width), s.push(c.y, c.y + c.height);
    }), e.length == 0 || s.length == 0)
      return { x: 0, y: 0, width: 0, height: 0 };
    const i = Math.min.apply(0, e), r = Math.min.apply(0, s), o = Math.max.apply(0, e), a = Math.max.apply(0, s);
    return {
      x: i,
      y: r,
      width: o - i,
      height: a - r
    };
  }
  update(t) {
    this.cX = typeof t.cX == "number" ? t.cX : this.cX, this.cY = typeof t.cY == "number" ? t.cY : this.cY, this.x = t.x, this.y = t.y, this.degree = t.degree, this.scalarX = t.scalarX, this.scalarY = t.scalarY;
  }
  updateTransform() {
    const t = new _t();
    if (t.translate(this.x + this.cX, this.y + this.cY), t.rotate(this.degree), t.scale(this.scalarX, this.scalarY), t.translate(-this.cX, -this.cY), t.isIdentity)
      return {
        startPathX: this.startPathX,
        startPathY: this.startPathY,
        normalizedLines: this.normalizedLines
      };
    {
      let e = this.startPathX, s = this.startPathY;
      ({ x: e, y: s } = t.transformPoint({
        x: e,
        y: s
      }));
      const i = [];
      return this.normalizedLines.forEach((r) => {
        let o = r.x, a = r.y, h = r.c1x, c = r.c1y, l = r.c2x, u = r.c2y, d = r.toX, f = r.toY;
        ({ x: o, y: a } = t.transformPoint({ x: o, y: a })), { x: h, y: c } = t.transformPoint({ x: h, y: c }), { x: l, y: u } = t.transformPoint({ x: l, y: u }), { x: d, y: f } = t.transformPoint({ x: d, y: f }), i.push(
          new Ce({ x: o, y: a, c1x: h, c1y: c, c2x: l, c2y: u, toX: d, toY: f })
        );
      }), {
        startPathX: e,
        startPathY: s,
        normalizedLines: i
      };
    }
  }
  /// returns length in pixels
  getTotalLength() {
    const { normalizedLines: t } = this.updateTransform();
    return t.reduce((e, s) => e += s.length(), 0);
  }
  getPointAtLength(t) {
    const { normalizedLines: e } = this.updateTransform();
    let s = 0;
    const i = e.length;
    for (let r = 0; r < i; r++) {
      const o = e[r], a = o.length();
      if (s + a >= t)
        return o.getPointAtSegmentLength(t - s);
      s += a;
    }
    return e[i - 1].getPointAtSegmentLength(1);
  }
  /// 与 getPointAtLength 类似
  /// t (0.0 to 1.0) : The fraction of the overall duration of the path
  interpolate(t) {
    const { startPathX: e, startPathY: s, normalizedLines: i } = this.updateTransform(), r = i.length;
    if (r === 0)
      return { x: e, y: s };
    if (r === 1)
      return i[0].interpolate(t);
    {
      let o = t * r, a = i[0];
      if (o--, o > 1)
        for (let h = 1; h < r && (a = i[h], o > 1); h++)
          o -= 1;
      return a.interpolate(o);
    }
  }
  /// from | to  : 0 ~ 1
  getSubpath(t, e) {
    if (this.getTotalLength() - e < 1e-6)
      return this.getSubpathsAtLength(this, t);
    {
      const s = this.getSubpathsAtLength(this, e, 1);
      return t ? this.getSubpathsAtLength(s, t) : s;
    }
  }
  getSubpathsAtLength(t, e, s) {
    const { startPathX: i, startPathY: r, normalizedLines: o } = t.updateTransform();
    let a = null, h = 0;
    const c = new me();
    c.prevPathX = c.startPathX = i, c.prevPathY = c.startPathY = r;
    for (let l = 0, u = o.length; l < u; l++) {
      const d = o[l], f = d.length();
      if (h + f > e && !a) {
        const m = d.getPointAtSegmentLength(e - h);
        if (c.appendLine(
          new Ce({
            c1x: m.start.x,
            c1y: m.start.y,
            c2x: m.m.x,
            c2y: m.m.y,
            toX: m.x,
            toY: m.y
          })
        ), s)
          return c;
        a = c, c.appendLine(
          new Ce({
            c1x: m.n.x,
            c1y: m.n.y,
            c2x: m.end.x,
            c2y: m.end.y,
            toX: d.x,
            toY: d.y
          })
        ), h += f;
        continue;
      }
      h += f, c.appendLine(d);
    }
    return c;
  }
  /// drag along path
  closestPoint(t, e) {
    const s = this.getTotalLength();
    let i = { x: t, y: e }, r = 0, o = 1 / 0, a = 8;
    for (let c = 0; c <= s; c += a) {
      const l = this.getPointAtLength(c), u = Math.pow(
        Ge(l.x, l.y, t, e),
        2
      );
      u < o && (i = l, r = c, o = u);
    }
    for (a /= 2; a > 0.5; ) {
      const c = r - a, l = this.getPointAtLength(c), u = Math.pow(
        Ge(l.x, l.y, t, e),
        2
      ), d = r + a, f = this.getPointAtLength(d), m = Math.pow(
        Ge(f.x, f.y, t, e),
        2
      );
      c >= 0 && u < o ? (i = l, r = c, o = u) : d <= s && m < o ? (i = f, r = d, o = m) : a /= 2;
    }
    const h = this.getPointAtLength(
      r + (r === s ? -0.1 : 0.1)
    );
    return {
      point: i,
      rotation: r >= s ? qt(h.x, h.y, i.x, i.y) : qt(i.x, i.y, h.x, h.y),
      distance: Math.sqrt(o)
    };
  }
  get polymorphPoints() {
    const { startPathX: t, startPathY: e, normalizedLines: s } = this.updateTransform();
    return [t, e].concat(
      s.reduce(
        (i, r) => i.concat([r.c1x, r.c1y, r.c2x, r.c2y, r.toX, r.toY]),
        []
      )
    );
  }
  perimeterPoints() {
    const t = this.polymorphPoints, e = t.length;
    let s = t[e - 2], i = t[e - 1], r = 0;
    for (let o = 0; o < e; o += 6)
      r += Ge(t[o], t[o + 1], s, i), s = t[o], i = t[o + 1];
    return Math.floor(r);
  }
  expendFill(t) {
    const e = this.polymorphPoints, s = e.length;
    let i = t - s;
    const r = Math.ceil(t / s), o = [];
    o.push(["M", e[0], e[1]]);
    let a = 2;
    for (; a + 5 <= s - 1; ) {
      const h = e[a++], c = e[a++], l = e[a++], u = e[a++], d = e[a++], f = e[a++];
      o.push(["C", h, c, l, u, d, f]);
      let m = 0;
      for (; m < r && i > 0; )
        o.push(["C", d, f, d, f, d, f]), i -= 6, m++;
    }
    return o;
  }
  static mixPoints(t, e, s) {
    const i = t.length, r = new Array(i);
    for (let o = 0; o < i; o++)
      r[o] = Y(t[o] + (e[o] - t[o]) * s, 6);
    return r;
  }
  /// offset : 0 ~ 1
  static getPathInterpolator(t, e) {
    return (s) => Math.abs(s - 0) < Number.EPSILON ? t : Math.abs(s - 1) < Number.EPSILON ? e : me.fromPolymorphPoints(
      me.mixPoints(
        new me({ d: t }).polymorphPoints,
        new me({ d: e }).polymorphPoints,
        s
      )
    ).toSVGPathData();
  }
}, y0 = class extends Qn {
  // [index: string | number | symbol]: any;
  id;
  originD;
  originMatrix;
  independentTransformInGroup;
  forceCXY = !1;
  /// 相对于自身 (0,0) 点的相对值
  cX;
  cY;
  x;
  y;
  degree;
  scalarX;
  scalarY;
  diffXInGroup;
  diffYInGroup;
  diffDegreeInGroup;
  diffScalarXInGroup;
  diffScalarYInGroup;
  vx;
  vy;
  ax;
  ay;
  mass;
  attrs;
  enableDrag;
  alongPath;
  isDragging = !1;
  isMouseIn = !1;
  targetToAfterDragFree;
  followMouse;
  strokeArmyAnts;
  strokeArmyAntsOffset = 0;
  strokeDashTotalLength = 0;
  isShow = !0;
  el;
  pathd;
  usePathDtoCanvasContext = !1;
  parent;
  shapes = [];
  constructor(t) {
    if (super(), this.id = Xs(), t?.d && (this.originD = t?.d), t?.originMatrix && (this.originMatrix = t.originMatrix), this.independentTransformInGroup = typeof t?.independentTransformInGroup == "boolean" ? t.independentTransformInGroup : !1, this.x = t?.x || 0, this.y = t?.y || 0, this.cX = 0, this.cY = 0, typeof t?.centerX == "number" && typeof t?.centerY == "number" && this.forceSetCXY(t.centerX - this.x, t.centerY - this.y), this.degree = t?.degree || 0, this.scalarX = 1, this.scalarY = 1, t?.scalar !== void 0 && (this.scalarX = t.scalar, this.scalarY = t.scalar), t?.scalarX !== void 0 && (this.scalarX = t.scalarX), t?.scalarY !== void 0 && (this.scalarY = t.scalarY), this.diffXInGroup = t?.diffXInGroup || 0, this.diffYInGroup = t?.diffYInGroup || 0, this.diffDegreeInGroup = t?.diffDegreeInGroup || 0, this.diffScalarXInGroup = t?.diffScalarXInGroup || 1, this.diffScalarYInGroup = t?.diffScalarYInGroup || 1, this.vx = t?.vx || 0, this.vy = t?.vy || 0, this.ax = t?.ax || 0, this.ay = t?.ay || 0, this.mass = t?.mass || 1, this.attrs = {
      // "paint-order": "markers stroke fill", // 先 stroke 再 fill
      // "paint-order": "fill stroke markers", // default
      stroke: "none",
      fill: "none"
      // "pointerEvents": "none",
    }, t?.attrs && this.setAttr(t?.attrs), this.enableDrag = t?.enableDrag || !1, this.alongPath = t?.alongPath, this.targetToAfterDragFree = t?.targetToAfterDragFree, this.followMouse = t?.followMouse || !1, this.isShow = typeof t?.isShow == "boolean" ? t?.isShow : !0, this.strokeArmyAnts = t?.strokeArmyAnts || !1, this.strokeArmyAnts) {
      const s = this.getAttr("stroke-dasharray", "4 4");
      this.setAttr("stroke-dasharray", s), this.strokeDashTotalLength = Ir(
        s
      ).reduce((i, r) => i + r, 0);
    }
    return Yr(this);
  }
  /// 强制设置 坐标系原点
  forceSetCXY(t, e) {
    this.cX = t, this.cY = e, this.forceCXY = !0;
  }
  /// 子类可覆盖
  shapeInit() {
  }
  /// 统一初始化 pathd
  initPathD() {
    if (!this.pathd) {
      if (this.pathd = new g0(), Te(() => {
        this.pathd?.reset(
          this.originD || this.toSVGPathData(),
          this.originMatrix
        );
      }), this.pathd && !this.forceCXY) {
        const t = this.shapes.length == 0 ? this.pathd.getBoundingClientRect() : this.getBoundingClientRect();
        t && (this.pathd.cX = this.cX = t.x + t.width / 2 - this.pathd.x, this.pathd.cY = this.cY = t.y + t.height / 2 - this.pathd.y);
      }
      this.shapeInit();
    }
    return this.pathd;
  }
  frameStart(t) {
  }
  frameUpdate(t, e) {
    this.pathd = this.initPathD(), this.pathd.update(this), this.strokeArmyAnts && (this.isMouseIn || (this.setAttr("stroke-dashoffset", String(this.strokeArmyAntsOffset++)), this.strokeArmyAntsOffset > this.strokeDashTotalLength && (this.strokeArmyAntsOffset = 0)));
  }
  frameEnd(t) {
  }
  /// Shape SVG 使用 PathD transform 系统，使用相对值
  /// 子类一定要覆盖 toSVGPathData ！
  /// 唯一例外是 group ，可以不覆盖！
  /// translate() rotate() scale() 等 transfrom 交给 PathD 处理， YZSVG 不处理
  /// 属性值自己保存
  toSVGPathData() {
    return [];
  }
  /// 子类不要覆盖 toSVGPathD ！
  /// 供 YZSVG 调用
  toSVGPathD() {
    return this.pathd?.toSVGPathD() || "";
  }
  /// Shape Canvas 使用 PathD transform 系统 或 原生canvas系统
  /// 如果子类没有覆盖 toCanvasContext , 则默认使用 PathD 的 toCanvasContext
  ///   - translate() rotate() scale() 等 transfrom 交给 PathD 处理，YZCanvas 不处理
  ///   - canvas.ctx.createLinearGradient 使用绝对值
  /// 如果子类覆盖 toCanvasContext , 则使用 原生canvas系统
  ///   - translate() rotate() scale() 等 transfrom 交给 YZCanvas 处理
  ///   - canvas.ctx.createLinearGradient 使用相对值
  /// 不包含 fill() 及 stroke()
  /// 属性值自己保存
  toCanvasContext(t) {
    this.usePathDtoCanvasContext = !0, this.pathd?.toCanvasContext(t);
  }
  /// 目前 仅 Text 无法转换为 PathD, 也就无 getBoundingClientRect
  /// 子类可覆盖
  /// 绝对值
  getBoundingClientRect() {
    return this.pathd?.getBoundingClientRect() || null;
  }
  /// 绝对值
  get center() {
    const t = this.getBoundingClientRect(), e = { x: this.x, y: this.y };
    return t && (e.x = t.x + t.width / 2, e.y = t.y + t.height / 2), e;
  }
  trim() {
    if (this.parent)
      return;
    const t = this.getBoundingClientRect();
    if (!t)
      return;
    this.shapes.forEach((s) => {
      const i = s.originMatrix ? s.originMatrix.clone() : new _t();
      i.translate(-t.x + s.x, -t.y + s.y), s.originMatrix = i;
    });
    const e = this.originMatrix ? this.originMatrix.clone() : new _t();
    e.translate(-t.x + this.x, -t.y + this.y), this.originMatrix = e;
  }
  isPointInPath(t, e, s) {
    if (s instanceof _a)
      return s.isPointInPath(new Path2D(this.toSVGPathD()), t, e);
    let i;
    try {
      i = new SVGPoint(t, e);
    } catch {
      i = s.createSVGPoint(), i.x = t, i.y = e;
    }
    if (this.el instanceof SVGGeometryElement)
      return this.el.isPointInFill(i);
    {
      const r = this.getBoundingClientRect();
      if (r)
        return t >= r.x && t <= r.x + r.width && e >= r.y && e <= r.y + r.height;
    }
    return !1;
  }
  isPointInStroke(t, e, s) {
    if (s instanceof _a)
      return s.isPointInStroke(new Path2D(this.toSVGPathD()), t, e);
    let i;
    try {
      i = new SVGPoint(t, e);
    } catch {
      i = s.createSVGPoint(), i.x = t, i.y = e;
    }
    return this.el instanceof SVGGeometryElement ? this.el.isPointInStroke(i) : !1;
  }
  clone() {
    return nh(this).copy(this);
  }
  copy(t) {
    return this.id = t.id, this.originD = t.originD, this.originMatrix = t.originMatrix, this.independentTransformInGroup = t.independentTransformInGroup, this.x = t.x, this.y = t.y, this.cX = t.cX, this.cY = t.cY, this.degree = t.degree, this.scalarX = t.scalarX, this.scalarY = t.scalarY, this.diffXInGroup = t.diffXInGroup, this.diffYInGroup = t.diffYInGroup, this.diffDegreeInGroup = t.diffDegreeInGroup, this.diffScalarXInGroup = t.diffScalarXInGroup, this.diffScalarYInGroup = t.diffScalarYInGroup, this.vx = t.vx, this.vy = t.vy, this.ax = t.ax, this.ay = t.ay, this.mass = t.mass, this.attrs = {
      ...t.attrs
    }, this.enableDrag = t.enableDrag, this.alongPath = t.alongPath, this.targetToAfterDragFree = t.targetToAfterDragFree, this.followMouse = t.followMouse, this.isShow = t.isShow, this.strokeArmyAnts = t.strokeArmyAnts, this.strokeDashTotalLength = t.strokeDashTotalLength, this;
  }
  save() {
  }
  restore() {
  }
  setAttr(t, e) {
    typeof t != "string" ? Object.assign(
      this.attrs,
      Object.fromEntries(
        Object.entries(t).map(([s, i]) => [pt(s), i])
      )
    ) : e && (this.attrs[pt(t)] = e);
  }
  getAttr(t, e) {
    return this.attrs[t] || this.attrs[pt(t)] || e;
  }
  getAttrs() {
    return this.attrs;
  }
  hasAttr(t) {
    return !!this.attrs[t] || !!this.attrs[pt(t)];
  }
  distance(t) {
    return Ge(this.x, this.y, t.x, t.y);
  }
  rotateTo(t) {
    this.degree = wt(qt(this.x, this.y, t.x, t.y));
  }
  followTo(t, e = 3) {
    this.rotateTo(t);
    const { dx: s, dy: i } = He(q(this.degree), e);
    this.vx = s, this.vy = i, this.run();
  }
  followAccelerationTo(t, e = 0.05) {
    this.rotateTo(t);
    const { dx: s, dy: i } = He(q(this.degree), e);
    this.ax = s, this.ay = i, this.run();
  }
  /// 碰撞检测
  checkCollision(t) {
  }
  /// 回弹
  checkWall(t) {
  }
  /// 物体之间引力
  gravitateTo(t) {
    const e = t.x - this.x, s = t.y - this.y, i = e * e + s * s, r = Math.sqrt(i), o = this.mass * t.mass / i, a = o * e / r, h = o * s / r;
    this.vx += a / this.mass, this.vy += h / this.mass, t.vx -= a / t.mass, t.vy -= h / t.mass;
  }
  run(t) {
    this.vx += this.ax, this.vy += this.ay;
    const e = Qt(t?.gravity, 0);
    this.vy += e;
    const s = Qt(t?.friction, 1);
    this.vx *= s, this.vy *= s, this.x += this.vx, this.y += this.vy;
  }
  runEaseTo(t, e) {
    const s = Qt(e?.easing, 0.05), i = t.x - this.cX - this.x, r = t.y - this.cY - this.y;
    this.vx = i * s, this.vy = r * s, this.run(e);
  }
  runSpringTo(t, e) {
    const s = Qt(e?.spring, 0.03);
    (Array.isArray(t) ? t : [t]).forEach((i) => {
      const r = i.x - this.cX - this.x, o = i.y - this.cY - this.y, a = r * s, h = o * s;
      this.vx += a, this.vy += h;
    }), this.run({ friction: 0.9, ...e });
  }
  springMassTo(t, e) {
    const s = Qt(e?.springLength, 100), i = Qt(e?.spring, 1e-4), r = t.x - this.x, o = t.y - this.y, a = Math.sqrt(r * r + o * o);
    if (a < s) {
      const h = r * i, c = o * i;
      return this.vx += h / this.mass, this.vy += c / this.mass, t.vx -= h / t.mass, t.vy -= c / t.mass, 1 - a / s;
    }
    return 0;
  }
  getTotalLength() {
    return this.initPathD().getTotalLength();
  }
  interpolate(t) {
    return this.initPathD().interpolate(t);
  }
  getPointAtLength(t) {
    return this.initPathD().getPointAtLength(t);
  }
  trailPath(t, e = 0) {
    const s = this.getTotalLength();
    return t.originD = this.initPathD().getSubpath(0, e * s), this.getPointAtLength(e * s);
  }
  strokeDashTween(t = 1e3, e) {
    const s = this.initPathD(), i = Y(s.getTotalLength(), 0);
    this.setAttr({
      strokeDasharray: `${i} ${i}`,
      strokeDashoffset: `${i}`
    });
    const r = e?.onUpdate, o = new li({ frameDuration: t });
    o.addTween(
      { offset: i },
      { offset: 0 },
      Object.assign(e || {}, {
        onUpdate: (a, h) => {
          this.setAttr("strokeDashoffset", "" + Y(a.offset, 2)), r?.(a, h);
        }
      })
    ), o.play();
  }
};
class x0 extends y0 {
  x;
  y;
  z;
  // public w: number; // perspective
  fl;
  vpX;
  vpY;
  cX;
  cY;
  cZ;
  radius;
  constructor(t) {
    super(t), this.x = t?.x || 0, this.y = t?.y || 0, this.z = t?.z || 0, this.fl = t?.fl || 250, this.vpX = t?.vpX || 0, this.vpY = t?.vpY || 0, this.cX = t?.cX || 0, this.cY = t?.cY || 0, this.cZ = t?.cZ || 0, this.radius = t?.radius || 0;
  }
  toSVGPathData() {
    return this.radius ? [
      ["M", this.getScreenX(), this.getScreenY() - this.radius],
      ["a", this.radius, this.radius, 0, 1, 1, 0, 2 * this.radius],
      ["a", this.radius, this.radius, 0, 1, 1, 0, -2 * this.radius],
      ["z"]
    ] : [["M", this.getScreenX(), this.getScreenY()]];
  }
  toCanvasContext(t) {
    t.beginPath(), t.arc(0, 0, this.radius, 0, Math.PI * 2, !0), t.closePath();
  }
  setVanishingPoint(t, e) {
    this.vpX = t, this.vpY = e;
  }
  setCenter(t, e, s) {
    this.cX = t, this.cY = e, this.cZ = s;
  }
  rotateX(t) {
    ({ x: this.y, y: this.z } = oe(q(t), this.y, this.z));
  }
  rotateY(t) {
    ({ x: this.x, y: this.z } = oe(q(t), this.x, this.z));
  }
  rotateZ(t) {
    ({ x: this.x, y: this.y } = oe(q(t), this.x, this.y));
  }
  getScreenX() {
    const t = this.fl / (this.fl + this.z + this.cZ);
    return this.vpX + (this.cX + this.x) * t;
  }
  getScreenY() {
    const t = this.fl / (this.fl + this.z + this.cZ);
    return this.vpY + (this.cY + this.y) * t;
  }
  eq(t) {
    return this.x === t.x && this.y === t.y && this.z === t.z && this.radius === t.radius && this.mass === t.mass;
  }
  length() {
    return $s(this.x, this.y, this.z);
  }
  distance(t) {
    const e = t.x - this.x, s = t.y - this.y, i = t.z - this.z;
    return Math.sqrt(e * e + s * s + i * i);
  }
  scalar(t) {
    return this.x *= t, this.y *= t, this.z *= t, this;
  }
  normalize(t = 1) {
    const e = this.length();
    if (e) {
      const s = t / e;
      this.scalar(s);
    }
    return this;
  }
  clamp(t) {
    const e = this.length();
    return e && e > t && this.scalar(t / e), this;
  }
  cross(t) {
    const e = this.x, s = this.y, i = this.z;
    return {
      x: s * t.z - i * t.y,
      y: i * t.x - e * t.z,
      z: e * t.y - s * t.x
    };
  }
  multiply(t) {
    return {
      x: this.x * t.x,
      y: this.y * t.y,
      z: this.z * t.z
    };
  }
  div(t) {
    return {
      x: this.x / t.x,
      y: this.y / t.y,
      z: this.z / t.z
    };
  }
  add(t) {
    return {
      x: this.x + t.x,
      y: this.y + t.y,
      z: this.z + t.z
    };
  }
  sub(t) {
    return {
      x: this.x - t.x,
      y: this.y - t.y,
      z: this.z - t.z
    };
  }
  dot(t) {
    return this.x * t.x + this.y * t.y + this.z * t.z;
  }
  reflect(t) {
    const e = this.dot(t);
    return {
      x: this.x - 2 * e * t.x,
      y: this.y - 2 * e * t.y,
      z: this.z - 2 * e * t.z
    };
  }
}
const vn = x0, _n = 2e3, Ca = 2001, Ea = [1, 0, 0, 1], Pa = [1, 0, 0, 1, 0, 0], Ta = [1, 0, 0, 0, 1, 0, 0, 0, 1], Ma = [
  1,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  1,
  0,
  0,
  0,
  0,
  1
];
class zc {
  /// 按列顺序
  value;
  constructor(t = Ea) {
    this.value = Array.from(t);
  }
  get m11() {
    return this.value[0];
  }
  get m12() {
    return this.value[1];
  }
  get m21() {
    return this.value[2];
  }
  get m22() {
    return this.value[3];
  }
  set m11(t) {
    this.value[0] = t;
  }
  set m12(t) {
    this.value[1] = t;
  }
  set m21(t) {
    this.value[2] = t;
  }
  set m22(t) {
    this.value[3] = t;
  }
  /// 按行顺序
  set(t = 1, e = 0, s = 0, i = 1) {
    return this.m11 = t, this.m21 = e, this.m12 = s, this.m22 = i, this;
  }
  identity() {
    return this.value = Array.from(Ea), this;
  }
  get isIdentity() {
    return this.m11 == 1 && this.m12 == 0 && this.m21 == 0 && this.m22 == 1;
  }
  copy(t) {
    return this.m11 = t.m11, this.m12 = t.m12, this.m21 = t.m21, this.m22 = t.m22, this;
  }
  clone() {
    return new zc(this.value);
  }
  fromArray(t, e = 0) {
    for (let s = 0; s < 4; s++)
      this.value[s] = t[s + e];
    return this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this.m11, t[e + 1] = this.m12, t[e + 2] = this.m21, t[e + 3] = this.m22, t;
  }
  multiplyMatrices(t, e) {
    const s = t.value, i = e.value, r = this.value, o = s[0], a = s[2], h = s[1], c = s[3], l = i[0], u = i[2], d = i[1], f = i[3];
    return r[0] = o * l + a * d, r[2] = o * u + a * f, r[1] = h * l + c * d, r[3] = h * u + c * f, this;
  }
  multiply(t) {
    return this.multiplyMatrices(this, t);
  }
  premultiply(t) {
    return this.multiplyMatrices(t, this);
  }
  multiplyScalar(t) {
    return this.m11 *= t, this.m12 *= t, this.m21 *= t, this.m22 *= t, this;
  }
  /// 行列式
  determinant() {
    return this.m11 * this.m22 - this.m21 * this.m12;
  }
}
class en {
  /// 按列顺序
  value;
  constructor(t = Ta) {
    this.value = Array.from(t);
  }
  get m11() {
    return this.value[0];
  }
  get m12() {
    return this.value[1];
  }
  get m13() {
    return this.value[2];
  }
  get m21() {
    return this.value[3];
  }
  get m22() {
    return this.value[4];
  }
  get m23() {
    return this.value[5];
  }
  get m31() {
    return this.value[6];
  }
  get m32() {
    return this.value[7];
  }
  get m33() {
    return this.value[8];
  }
  set m11(t) {
    this.value[0] = t;
  }
  set m12(t) {
    this.value[1] = t;
  }
  set m13(t) {
    this.value[2] = t;
  }
  set m21(t) {
    this.value[3] = t;
  }
  set m22(t) {
    this.value[4] = t;
  }
  set m23(t) {
    this.value[5] = t;
  }
  set m31(t) {
    this.value[6] = t;
  }
  set m32(t) {
    this.value[7] = t;
  }
  set m33(t) {
    this.value[8] = t;
  }
  /// 按行顺序
  set(t = 1, e = 0, s = 0, i = 0, r = 1, o = 0, a = 0, h = 0, c = 1) {
    const l = this.value;
    return l[0] = t, l[1] = i, l[2] = a, l[3] = e, l[4] = r, l[5] = h, l[6] = s, l[7] = o, l[8] = c, this;
  }
  identity() {
    return this.value = Array.from(Ta), this;
  }
  get isIdentity() {
    return this.m11 == 1 && this.m12 == 0 && this.m13 == 0 && this.m21 == 0 && this.m22 == 1 && this.m23 == 0 && this.m31 == 0 && this.m32 == 0 && this.m33 == 1;
  }
  copy(t) {
    return this.m11 = t.m11, this.m12 = t.m12, this.m13 = t.m13, this.m21 = t.m21, this.m22 = t.m22, this.m23 = t.m23, this.m31 = t.m31, this.m32 = t.m32, this.m33 = t.m33, this;
  }
  clone() {
    return new en(this.value);
  }
  fromArray(t, e = 0) {
    for (let s = 0; s < 9; s++)
      this.value[s] = t[s + e];
    return this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this.m11, t[e + 1] = this.m12, t[e + 2] = this.m13, t[e + 3] = this.m21, t[e + 4] = this.m22, t[e + 5] = this.m23, t[e + 6] = this.m31, t[e + 7] = this.m32, t[e + 8] = this.m33, t;
  }
  extractBasis(t, e, s) {
    return t.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), s.setFromMatrix3Column(this, 2), this;
  }
  setFromMatrix4(t) {
    return this.set(t.m11, t.m21, t.m31, t.m12, t.m22, t.m32, t.m13, t.m23, t.m33), this;
  }
  multiplyMatrices(t, e) {
    const s = t.value, i = e.value, r = this.value, o = s[0], a = s[3], h = s[6], c = s[1], l = s[4], u = s[7], d = s[2], f = s[5], m = s[8], p = i[0], S = i[3], g = i[6], b = i[1], x = i[4], w = i[7], C = i[2], _ = i[5], D = i[8];
    return r[0] = o * p + a * b + h * C, r[3] = o * S + a * x + h * _, r[6] = o * g + a * w + h * D, r[1] = c * p + l * b + u * C, r[4] = c * S + l * x + u * _, r[7] = c * g + l * w + u * D, r[2] = d * p + f * b + m * C, r[5] = d * S + f * x + m * _, r[8] = d * g + f * w + m * D, this;
  }
  multiply(t) {
    return this.multiplyMatrices(this, t);
  }
  premultiply(t) {
    return this.multiplyMatrices(t, this);
  }
  multiplyScalar(t) {
    return this.m11 *= t, this.m12 *= t, this.m13 *= t, this.m21 *= t, this.m22 *= t, this.m23 *= t, this.m31 *= t, this.m32 *= t, this.m33 *= t, this;
  }
  /// 行列式
  determinant() {
    const t = this.value, e = t[0], s = t[1], i = t[2], r = t[3], o = t[4], a = t[5], h = t[6], c = t[7], l = t[8];
    return e * o * l - e * a * c - s * r * l + s * a * h + i * r * c - i * o * h;
  }
  inverse() {
    const t = this.value, e = t[0], s = t[1], i = t[2], r = t[3], o = t[4], a = t[5], h = t[6], c = t[7], l = t[8], u = l * o - a * c, d = a * h - l * r, f = c * r - o * h, m = e * u + s * d + i * f;
    if (m === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const p = 1 / m;
    return t[0] = u * p, t[1] = (i * c - l * s) * p, t[2] = (a * s - i * o) * p, t[3] = d * p, t[4] = (l * e - i * h) * p, t[5] = (i * r - a * e) * p, t[6] = f * p, t[7] = (s * h - c * e) * p, t[8] = (o * e - s * r) * p, this;
  }
  transpose() {
    let t;
    const e = this.value;
    return t = e[1], e[1] = e[3], e[3] = t, t = e[2], e[2] = e[6], e[6] = t, t = e[5], e[5] = e[7], e[7] = t, this;
  }
  getNormalMatrix(t) {
    return this.setFromMatrix4(t).inverse().transpose();
  }
  transposeIntoArray(t) {
    const e = this.value;
    return t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8], this;
  }
  setUvTransform(t, e, s, i, r, o, a) {
    const h = Math.cos(r), c = Math.sin(r);
    return this.set(
      s * h,
      s * c,
      -s * (h * o + c * a) + o + t,
      -i * c,
      i * h,
      -i * (-c * o + h * a) + a + e,
      0,
      0,
      1
    ), this;
  }
  scale(t, e) {
    return this.premultiply(Ni.makeScale(t, e)), this;
  }
  rotate(t) {
    return this.premultiply(Ni.makeRotation(-t)), this;
  }
  translate(t, e) {
    return this.premultiply(Ni.makeTranslation(t, e)), this;
  }
  makeTranslation(t, e) {
    return typeof t == "number" ? this.set(1, 0, t, 0, 1, e, 0, 0, 1) : this.set(1, 0, t.x, 0, 1, t.y, 0, 0, 1), this;
  }
  // counterclockwise
  makeRotation(t) {
    const e = Math.cos(t), s = Math.sin(t);
    return this.set(e, -s, 0, s, e, 0, 0, 0, 1), this;
  }
  makeScale(t, e) {
    return this.set(t, 0, 0, 0, e, 0, 0, 0, 1), this;
  }
  equals(t) {
    for (let e = 0; e < 9; e++)
      if (this.value[e] !== t.value[e])
        return !1;
    return !0;
  }
}
class Ot {
  /// 按列顺序
  value;
  is3dSpecial = !1;
  constructor(t = Ma) {
    this.value = Array.from(t);
  }
  get m11() {
    return this.value[0];
  }
  get m12() {
    return this.value[1];
  }
  get m13() {
    return this.value[2];
  }
  get m14() {
    return this.value[3];
  }
  get m21() {
    return this.value[4];
  }
  get m22() {
    return this.value[5];
  }
  get m23() {
    return this.value[6];
  }
  get m24() {
    return this.value[7];
  }
  get m31() {
    return this.value[8];
  }
  get m32() {
    return this.value[9];
  }
  get m33() {
    return this.value[10];
  }
  get m34() {
    return this.value[11];
  }
  get m41() {
    return this.value[12];
  }
  get m42() {
    return this.value[13];
  }
  get m43() {
    return this.value[14];
  }
  get m44() {
    return this.value[15];
  }
  set m11(t) {
    this.value[0] = t;
  }
  set m12(t) {
    this.value[1] = t;
  }
  set m13(t) {
    this.value[2] = t;
  }
  set m14(t) {
    this.value[3] = t;
  }
  set m21(t) {
    this.value[4] = t;
  }
  set m22(t) {
    this.value[5] = t;
  }
  set m23(t) {
    this.value[6] = t;
  }
  set m24(t) {
    this.value[7] = t;
  }
  set m31(t) {
    this.value[8] = t;
  }
  set m32(t) {
    this.value[9] = t;
  }
  set m33(t) {
    this.value[10] = t;
  }
  set m34(t) {
    this.value[11] = t;
  }
  set m41(t) {
    this.value[12] = t;
  }
  set m42(t) {
    this.value[13] = t;
  }
  set m43(t) {
    this.value[14] = t;
  }
  set m44(t) {
    this.value[15] = t;
  }
  /// 按行顺序
  set(t = 1, e = 0, s = 0, i = 0, r = 0, o = 1, a = 0, h = 0, c = 0, l = 0, u = 1, d = 0, f = 0, m = 0, p = 0, S = 1) {
    const g = this.value;
    return g[0] = t, g[4] = e, g[8] = s, g[12] = i, g[1] = r, g[5] = o, g[9] = a, g[13] = h, g[2] = c, g[6] = l, g[10] = u, g[14] = d, g[3] = f, g[7] = m, g[11] = p, g[15] = S, this;
  }
  is2D() {
    return !this.is3dSpecial && this.m31 == 0 && this.m32 == 0 && this.m33 == 1 && this.m34 == 0 && this.m43 == 0 && this.m44 == 1;
  }
  is3D() {
    return !this.is2D();
  }
  identity() {
    return this.value = Array.from(Ma), this;
  }
  get isIdentity() {
    return this.m11 == 1 && this.m12 == 0 && this.m13 == 0 && this.m14 == 0 && this.m21 == 0 && this.m22 == 1 && this.m23 == 0 && this.m24 == 0 && this.m31 == 0 && this.m32 == 0 && this.m33 == 1 && this.m34 == 0 && this.m41 == 0 && this.m42 == 0 && this.m43 == 0 && this.m44 == 1;
  }
  copy(t) {
    return this.m11 = t.m11, this.m12 = t.m12, this.m13 = t.m13, this.m14 = t.m14, this.m21 = t.m21, this.m22 = t.m22, this.m23 = t.m23, this.m24 = t.m24, this.m31 = t.m31, this.m32 = t.m32, this.m33 = t.m33, this.m34 = t.m34, this.m41 = t.m41, this.m42 = t.m42, this.m43 = t.m43, this.m44 = t.m44, this;
  }
  clone() {
    return new Ot(this.value);
  }
  // matrix4(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1)
  static fromString(t) {
    const e = new Ot(), s = Ja("number", t);
    return s.length === 16 && s.forEach((i, r) => {
      i.fullMatch && (e.value[r] = parseFloat(i.fullMatch));
    }), e;
  }
  fromArray(t, e = 0) {
    for (let s = 0; s < 16; s++)
      this.value[s] = t[s + e];
    return this;
  }
  toArray(t = [], e = 0) {
    const s = this.value;
    return t[e] = s[0], t[e + 1] = s[1], t[e + 2] = s[2], t[e + 3] = s[3], t[e + 4] = s[4], t[e + 5] = s[5], t[e + 6] = s[6], t[e + 7] = s[7], t[e + 8] = s[8], t[e + 9] = s[9], t[e + 10] = s[10], t[e + 11] = s[11], t[e + 12] = s[12], t[e + 13] = s[13], t[e + 14] = s[14], t[e + 15] = s[15], t;
  }
  copyPosition(t) {
    const e = this.value, s = t.value;
    return e[12] = s[12], e[13] = s[13], e[14] = s[14], this;
  }
  setFromMatrix3(t) {
    const e = t.value;
    return this.set(
      e[0],
      e[3],
      e[6],
      0,
      e[1],
      e[4],
      e[7],
      0,
      e[2],
      e[5],
      e[8],
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  extractBasis(t, e, s) {
    return t.setFromMatrix4Column(this, 0), e.setFromMatrix4Column(this, 1), s.setFromMatrix4Column(this, 2), this;
  }
  makeBasis(t, e, s) {
    return this.set(
      t.x,
      e.x,
      s.x,
      0,
      t.y,
      e.y,
      s.y,
      0,
      t.z,
      e.z,
      s.z,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  normalize() {
    return this.multiplyScalar(1 / (this.m44 || 1e-4));
  }
  // w: perspective
  transformPoint(t) {
    const e = t.z || 1, s = t.w || 1;
    return {
      x: t.x * this.m11 + t.y * this.m21 + e * this.m31 + s * this.m41,
      y: t.x * this.m12 + t.y * this.m22 + e * this.m32 + s * this.m42,
      z: t.x * this.m13 + t.y * this.m23 + e * this.m33 + s * this.m43,
      w: t.x * this.m14 + t.y * this.m24 + e * this.m34 + s * this.m44
    };
  }
  toMatrix(t) {
    const { scalarX: e, scalarY: s, skewX: i, skewY: r, x: o, y: a } = this.split(), h = [e, r, i, s, o, a];
    return t ? (t.value = h, t) : new _t(h);
  }
  flatten() {
    return this.m31 = 0, this.m32 = 0, this.m33 = 1, this.m34 = 0, this.m14 = 0, this.m24 = 0, this.m43 = 0, this.m44 = 1, this;
  }
  toString(t = 6) {
    return `matrix3d(${this.value.map((e) => Y(e, t)).join(",")})`;
  }
  split() {
    const t = Math.sqrt(
      this.m11 * this.m11 + this.m12 * this.m12 + this.m13 * this.m13
    ), e = Math.sqrt(
      this.m21 * this.m21 + this.m22 * this.m22 + this.m23 * this.m23
    ), s = Math.sqrt(
      this.m31 * this.m31 + this.m32 * this.m32 + this.m33 * this.m33
    ), i = wt(N(Math.asin(-this.m13), -1, 1));
    let r = wt(Math.atan2(this.m23, this.m33));
    Math.cos(q(i)) === 0 && (r = wt(Math.atan2(-this.m31, this.m22)));
    let o = wt(Math.atan2(this.m12, this.m11));
    return this.m11 < 0 && this.m22 >= 0 && (o += 180), {
      x: this.m41,
      y: this.m42,
      z: this.m43,
      scalarX: t,
      scalarY: e,
      scalarZ: s,
      degreeX: r,
      degreeY: i,
      degreeZ: o,
      skewX: wt(this.m14),
      skewY: wt(this.m24),
      skewZ: wt(this.m34),
      skewW: this.m44,
      perspective: this.m34 ? -(1 / this.m34) : 0
    };
  }
  extractRotation(t) {
    const e = this.value, s = t.value, i = 1 / ss.setFromMatrix4Column(t, 0).length(), r = 1 / ss.setFromMatrix4Column(t, 1).length(), o = 1 / ss.setFromMatrix4Column(t, 2).length();
    return e[0] = s[0] * i, e[1] = s[1] * i, e[2] = s[2] * i, e[3] = 0, e[4] = s[4] * r, e[5] = s[5] * r, e[6] = s[6] * r, e[7] = 0, e[8] = s[8] * o, e[9] = s[9] * o, e[10] = s[10] * o, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
  }
  makeRotationFromEuler(t) {
    const e = this.value, s = t.x, i = t.y, r = t.z, o = Math.cos(s), a = Math.sin(s), h = Math.cos(i), c = Math.sin(i), l = Math.cos(r), u = Math.sin(r);
    if (t.order === "XYZ") {
      const d = o * l, f = o * u, m = a * l, p = a * u;
      e[0] = h * l, e[4] = -h * u, e[8] = c, e[1] = f + m * c, e[5] = d - p * c, e[9] = -a * h, e[2] = p - d * c, e[6] = m + f * c, e[10] = o * h;
    } else if (t.order === "YXZ") {
      const d = h * l, f = h * u, m = c * l, p = c * u;
      e[0] = d + p * a, e[4] = m * a - f, e[8] = o * c, e[1] = o * u, e[5] = o * l, e[9] = -a, e[2] = f * a - m, e[6] = p + d * a, e[10] = o * h;
    } else if (t.order === "ZXY") {
      const d = h * l, f = h * u, m = c * l, p = c * u;
      e[0] = d - p * a, e[4] = -o * u, e[8] = m + f * a, e[1] = f + m * a, e[5] = o * l, e[9] = p - d * a, e[2] = -o * c, e[6] = a, e[10] = o * h;
    } else if (t.order === "ZYX") {
      const d = o * l, f = o * u, m = a * l, p = a * u;
      e[0] = h * l, e[4] = m * c - f, e[8] = d * c + p, e[1] = h * u, e[5] = p * c + d, e[9] = f * c - m, e[2] = -c, e[6] = a * h, e[10] = o * h;
    } else if (t.order === "YZX") {
      const d = o * h, f = o * c, m = a * h, p = a * c;
      e[0] = h * l, e[4] = p - d * u, e[8] = m * u + f, e[1] = u, e[5] = o * l, e[9] = -a * l, e[2] = -c * l, e[6] = f * u + m, e[10] = d - p * u;
    } else if (t.order === "XZY") {
      const d = o * h, f = o * c, m = a * h, p = a * c;
      e[0] = h * l, e[4] = -u, e[8] = c * l, e[1] = d * u + p, e[5] = o * l, e[9] = f * u - m, e[2] = m * u - f, e[6] = a * l, e[10] = p * u + d;
    }
    return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
  }
  makeRotationFromQuaternion(t) {
    return this.compose(w0, t, b0);
  }
  lookAt(t, e, s) {
    const i = this.value;
    return Lt.subVectors(t, e), Lt.lengthSq() === 0 && (Lt.z = 1), Lt.normalize(), Ee.crossVectors(s, Lt), Ee.lengthSq() === 0 && (Math.abs(s.z) === 1 ? Lt.x += 1e-4 : Lt.z += 1e-4, Lt.normalize(), Ee.crossVectors(s, Lt)), Ee.normalize(), Sn.crossVectors(Lt, Ee), i[0] = Ee.x, i[4] = Sn.x, i[8] = Lt.x, i[1] = Ee.y, i[5] = Sn.y, i[9] = Lt.y, i[2] = Ee.z, i[6] = Sn.z, i[10] = Lt.z, this;
  }
  multiplyMatrices(t, e) {
    const s = t.value, i = e.value, r = this.value, o = s[0], a = s[4], h = s[8], c = s[12], l = s[1], u = s[5], d = s[9], f = s[13], m = s[2], p = s[6], S = s[10], g = s[14], b = s[3], x = s[7], w = s[11], C = s[15], _ = i[0], D = i[4], z = i[8], B = i[12], G = i[1], V = i[5], j = i[9], et = i[13], J = i[2], Ht = i[6], Dt = i[10], Yt = i[14], Wt = i[3], L = i[7], k = i[11], F = i[15];
    return r[0] = o * _ + a * G + h * J + c * Wt, r[4] = o * D + a * V + h * Ht + c * L, r[8] = o * z + a * j + h * Dt + c * k, r[12] = o * B + a * et + h * Yt + c * F, r[1] = l * _ + u * G + d * J + f * Wt, r[5] = l * D + u * V + d * Ht + f * L, r[9] = l * z + u * j + d * Dt + f * k, r[13] = l * B + u * et + d * Yt + f * F, r[2] = m * _ + p * G + S * J + g * Wt, r[6] = m * D + p * V + S * Ht + g * L, r[10] = m * z + p * j + S * Dt + g * k, r[14] = m * B + p * et + S * Yt + g * F, r[3] = b * _ + x * G + w * J + C * Wt, r[7] = b * D + x * V + w * Ht + C * L, r[11] = b * z + x * j + w * Dt + C * k, r[15] = b * B + x * et + w * Yt + C * F, this;
  }
  multiply(t) {
    return this.multiplyMatrices(this, t);
  }
  premultiply(t) {
    return this.multiplyMatrices(t, this);
  }
  multiplyScalar(t) {
    return this.m11 *= t, this.m12 *= t, this.m13 *= t, this.m14 *= t, this.m21 *= t, this.m22 *= t, this.m23 *= t, this.m24 *= t, this.m31 *= t, this.m32 *= t, this.m33 *= t, this.m34 *= t, this;
  }
  /// 行列式
  determinant() {
    const t = this.value, e = t[0], s = t[4], i = t[8], r = t[12], o = t[1], a = t[5], h = t[9], c = t[13], l = t[2], u = t[6], d = t[10], f = t[14], m = t[3], p = t[7], S = t[11], g = t[15];
    return m * (+r * h * u - i * c * u - r * a * d + s * c * d + i * a * f - s * h * f) + p * (+e * h * f - e * c * d + r * o * d - i * o * f + i * c * l - r * h * l) + S * (+e * c * u - e * a * f - r * o * u + s * o * f + r * a * l - s * c * l) + g * (-i * a * l - e * h * u + e * a * d + i * o * u - s * o * d + s * h * l);
  }
  transpose() {
    const t = this.value;
    let e;
    return e = t[1], t[1] = t[4], t[4] = e, e = t[2], t[2] = t[8], t[8] = e, e = t[6], t[6] = t[9], t[9] = e, e = t[3], t[3] = t[12], t[12] = e, e = t[7], t[7] = t[13], t[13] = e, e = t[11], t[11] = t[14], t[14] = e, this;
  }
  setPosition(t, e, s) {
    const i = this.value;
    return t instanceof jt ? (i[12] = t.x, i[13] = t.y, i[14] = t.z) : typeof t == "number" && typeof e == "number" && typeof s == "number" && (i[12] = t, i[13] = e, i[14] = s), this;
  }
  inverse() {
    const t = this.value, e = t[0], s = t[1], i = t[2], r = t[3], o = t[4], a = t[5], h = t[6], c = t[7], l = t[8], u = t[9], d = t[10], f = t[11], m = t[12], p = t[13], S = t[14], g = t[15], b = u * S * c - p * d * c + p * h * f - a * S * f - u * h * g + a * d * g, x = m * d * c - l * S * c - m * h * f + o * S * f + l * h * g - o * d * g, w = l * p * c - m * u * c + m * a * f - o * p * f - l * a * g + o * u * g, C = m * u * h - l * p * h - m * a * d + o * p * d + l * a * S - o * u * S, _ = e * b + s * x + i * w + r * C;
    if (_ === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const D = 1 / _;
    return t[0] = b * D, t[1] = (p * d * r - u * S * r - p * i * f + s * S * f + u * i * g - s * d * g) * D, t[2] = (a * S * r - p * h * r + p * i * c - s * S * c - a * i * g + s * h * g) * D, t[3] = (u * h * r - a * d * r - u * i * c + s * d * c + a * i * f - s * h * f) * D, t[4] = x * D, t[5] = (l * S * r - m * d * r + m * i * f - e * S * f - l * i * g + e * d * g) * D, t[6] = (m * h * r - o * S * r - m * i * c + e * S * c + o * i * g - e * h * g) * D, t[7] = (o * d * r - l * h * r + l * i * c - e * d * c - o * i * f + e * h * f) * D, t[8] = w * D, t[9] = (m * u * r - l * p * r - m * s * f + e * p * f + l * s * g - e * u * g) * D, t[10] = (o * p * r - m * a * r + m * s * c - e * p * c - o * s * g + e * a * g) * D, t[11] = (l * a * r - o * u * r - l * s * c + e * u * c + o * s * f - e * a * f) * D, t[12] = C * D, t[13] = (l * p * i - m * u * i + m * s * d - e * p * d - l * s * S + e * u * S) * D, t[14] = (m * a * i - o * p * i - m * s * h + e * p * h + o * s * S - e * a * S) * D, t[15] = (o * u * i - l * a * i + l * s * h - e * u * h - o * s * d + e * a * d) * D, this;
  }
  getMaxScaleOnAxis() {
    const t = this.value, e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2], s = t[4] * t[4] + t[5] * t[5] + t[6] * t[6], i = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
    return Math.sqrt(Math.max(e, s, i));
  }
  makeTranslation(t, e, s) {
    return t instanceof jt ? this.set(1, 0, 0, t.x, 0, 1, 0, t.y, 0, 0, 1, t.z, 0, 0, 0, 1) : this.set(1, 0, 0, t, 0, 1, 0, e, 0, 0, 1, s, 0, 0, 0, 1), this;
  }
  makeRotationX(t) {
    const e = Math.cos(t), s = Math.sin(t);
    return this.set(1, 0, 0, 0, 0, e, -s, 0, 0, s, e, 0, 0, 0, 0, 1), this;
  }
  makeRotationY(t) {
    const e = Math.cos(t), s = Math.sin(t);
    return this.set(e, 0, s, 0, 0, 1, 0, 0, -s, 0, e, 0, 0, 0, 0, 1), this;
  }
  makeRotationZ(t) {
    const e = Math.cos(t), s = Math.sin(t);
    return this.set(e, -s, 0, 0, s, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
  }
  makeRotationAxis(t, e) {
    const s = Math.cos(e), i = Math.sin(e), r = 1 - s, o = t.x, a = t.y, h = t.z, c = r * o, l = r * a;
    return this.set(
      c * o + s,
      c * a - i * h,
      c * h + i * a,
      0,
      c * a + i * h,
      l * a + s,
      l * h - i * o,
      0,
      c * h - i * a,
      l * h + i * o,
      r * h * h + s,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeScale(t, e, s) {
    return this.set(t, 0, 0, 0, 0, e, 0, 0, 0, 0, s, 0, 0, 0, 0, 1), this;
  }
  makeShear(t, e, s, i, r, o) {
    return this.set(1, s, r, 0, t, 1, o, 0, e, i, 1, 0, 0, 0, 0, 1), this;
  }
  makePerspective(t, e, s, i, r, o, a = _n) {
    const h = this.value, c = 2 * r / (e - t), l = 2 * r / (s - i), u = (e + t) / (e - t), d = (s + i) / (s - i);
    let f, m;
    if (a === _n)
      f = -(o + r) / (o - r), m = -2 * o * r / (o - r);
    else if (a === Ca)
      f = -o / (o - r), m = -o * r / (o - r);
    else
      throw new Error(
        "Matrix4.makePerspective(): Invalid coordinate system: " + a
      );
    return h[0] = c, h[4] = 0, h[8] = u, h[12] = 0, h[1] = 0, h[5] = l, h[9] = d, h[13] = 0, h[2] = 0, h[6] = 0, h[10] = f, h[14] = m, h[3] = 0, h[7] = 0, h[11] = -1, h[15] = 0, this;
  }
  makeOrthographic(t, e, s, i, r, o, a = _n) {
    const h = this.value, c = 1 / (e - t), l = 1 / (s - i), u = 1 / (o - r), d = (e + t) * c, f = (s + i) * l;
    let m, p;
    if (a === _n)
      m = (o + r) * u, p = -2 * u;
    else if (a === Ca)
      m = r * u, p = -1 * u;
    else
      throw new Error(
        "Matrix4.makeOrthographic(): Invalid coordinate system: " + a
      );
    return h[0] = 2 * c, h[4] = 0, h[8] = 0, h[12] = -d, h[1] = 0, h[5] = 2 * l, h[9] = 0, h[13] = -f, h[2] = 0, h[6] = 0, h[10] = p, h[14] = -m, h[3] = 0, h[7] = 0, h[11] = 0, h[15] = 1, this;
  }
  compose(t, e, s) {
    const i = this.value, r = e.x, o = e.y, a = e.z, h = e.w, c = r + r, l = o + o, u = a + a, d = r * c, f = r * l, m = r * u, p = o * l, S = o * u, g = a * u, b = h * c, x = h * l, w = h * u, C = s.x, _ = s.y, D = s.z;
    return i[0] = (1 - (p + g)) * C, i[1] = (f + w) * C, i[2] = (m - x) * C, i[3] = 0, i[4] = (f - w) * _, i[5] = (1 - (d + g)) * _, i[6] = (S + b) * _, i[7] = 0, i[8] = (m + x) * D, i[9] = (S - b) * D, i[10] = (1 - (d + p)) * D, i[11] = 0, i[12] = t.x, i[13] = t.y, i[14] = t.z, i[15] = 1, this;
  }
  decompose(t, e, s) {
    const i = this.value;
    let r = ss.set(i[0], i[1], i[2]).length();
    const o = ss.set(i[4], i[5], i[6]).length(), a = ss.set(i[8], i[9], i[10]).length();
    this.determinant() < 0 && (r = -r), t.x = i[12], t.y = i[13], t.z = i[14], Kt.copy(this);
    const c = 1 / r, l = 1 / o, u = 1 / a;
    return Kt.value[0] *= c, Kt.value[1] *= c, Kt.value[2] *= c, Kt.value[4] *= l, Kt.value[5] *= l, Kt.value[6] *= l, Kt.value[8] *= u, Kt.value[9] *= u, Kt.value[10] *= u, e.setFromRotationMatrix4(Kt), s.x = r, s.y = o, s.z = a, this;
  }
  equals(t) {
    for (let e = 0; e < 16; e++)
      if (this.value[e] !== t.value[e])
        return !1;
    return !0;
  }
  translate(t = 0, e = 0, s = 0) {
    return this.multiply(
      new Ot([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, s, 1])
    );
  }
  scale(t = 1, e = 1, s = 1) {
    return this.multiply(
      new Ot([t, 0, 0, 0, 0, e, 0, 0, 0, 0, s, 0, 0, 0, 0, 1])
    );
  }
  scaleVector3(t) {
    const e = this.value, s = t.x, i = t.y, r = t.z;
    return e[0] *= s, e[4] *= i, e[8] *= r, e[1] *= s, e[5] *= i, e[9] *= r, e[2] *= s, e[6] *= i, e[10] *= r, e[3] *= s, e[7] *= i, e[11] *= r, this;
  }
  // rotate(degX = 0, degY = 0, degZ = 0) {
  //   if (degZ) {
  //     this.is3dSpecial = true;
  //   }
  //   const x = toRadian(degX);
  //   const y = toRadian(degY);
  //   const z = toRadian(degZ);
  //   const a = Math.cos(x);
  //   const b = Math.sin(x);
  //   const c = Math.cos(y);
  //   const d = Math.sin(y);
  //   const e = Math.cos(z);
  //   const f = Math.sin(z);
  //   const ae = a * e;
  //   const af = a * f;
  //   const be = b * e;
  //   const bf = b * f;
  //   this.m11 = c * e;
  //   this.m21 = -c * f;
  //   this.m31 = d;
  //   this.m12 = af + be * d;
  //   this.m22 = ae - bf * d;
  //   this.m32 = -b * c;
  //   this.m13 = bf - ae * d;
  //   this.m23 = be + af * d;
  //   this.m33 = a * c;
  //   return this;
  // }
  rotateX(t) {
    const e = q(t), s = Math.cos(e), i = Math.sin(e);
    return this.multiply(
      // new Matrix4([1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1])
      new Ot([1, 0, 0, 0, 0, s, i, 0, 0, -i, s, 0, 0, 0, 0, 1])
    );
  }
  rotateY(t) {
    const e = q(t), s = Math.cos(e), i = Math.sin(e);
    return this.multiply(
      // new Matrix4([c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1])
      new Ot([s, 0, -i, 0, 0, 1, 0, 0, i, 0, s, 0, 0, 0, 0, 1])
    );
  }
  /// this.multiply([c, s, -s, c, 0, 0]);
  rotateZ(t) {
    this.is3dSpecial = !0;
    const e = q(t), s = Math.cos(e), i = Math.sin(e);
    return this.multiply(
      // new Matrix4([c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1])
      new Ot([s, i, 0, 0, -i, s, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1])
    );
  }
  skew(t = 0, e = 0, s = 0) {
    return this.multiply(
      new Ot([
        1,
        0,
        0,
        q(t),
        0,
        1,
        0,
        q(e),
        0,
        0,
        1,
        q(s),
        0,
        0,
        0,
        1
      ])
    );
  }
  perspective(t) {
    return this.multiply(
      new Ot([
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        t ? -(1 / t) : 0,
        0,
        0,
        0,
        1
      ])
    );
  }
  // based on http://code.metager.de/source/xref/mozilla/B2G/gecko/gfx/thebes/gfx3DMatrix.cpp#651
  unproject(t) {
    let e = t.x * this.m11 + t.y * this.m21 + this.m41, s = t.x * this.m12 + t.y * this.m22 + this.m42, i = t.x * this.m13 + t.y * this.m23 + this.m43, r = t.x * this.m14 + t.y * this.m24 + this.m44, o = e + this.m31, a = s + this.m32, h = i + this.m33, c = r + this.m34;
    r == 0 && (r = 1e-4), e /= r, s /= r, i /= r, c == 0 && (c = 1e-4), o /= c, a /= c, h /= c;
    const l = h - i;
    if (l == 0)
      return { x: e, y: s, z: i, mass: r };
    const u = -i / l;
    return e += u * (o - e), s += u * (a - s), { x: e, y: s, z: i, mass: r };
  }
  // from homegeneous (euclid) to cartesian FLATTENED!!!! like a projection
  project(t) {
    const e = t.z;
    let s = t.x * this.m11 + t.y * this.m21 + e * this.m31 + this.m41, i = t.x * this.m12 + t.y * this.m22 + e * this.m32 + this.m42, r = t.x * this.m14 + t.y * this.m24 + e * this.m34 + this.m44;
    return r == 0 && (r = 1e-4), s /= r, i /= r, r < 0 && (s -= this.m41, i -= this.m42, s *= 1 / r, i *= 1 / r, s += this.m41, i += this.m42), { x: s, y: i, z: e, mass: r };
  }
  bounds(t, e, s, i) {
    const r = new vn({ x: t, y: e }), o = new vn({ x: t + s, y: e }), a = new vn({ x: t + s, y: e + i }), h = new vn({ x: t, y: e + i });
    ({ x: r.x, y: r.y, z: r.z, mass: r.mass } = this.project(r)), { x: o.x, y: o.y, z: o.z, mass: o.mass } = this.project(o), { x: a.x, y: a.y, z: a.z, mass: a.mass } = this.project(a), { x: h.x, y: h.y, z: h.z, mass: h.mass } = this.project(h);
    const c = Math.min(r.x, o.x, a.x, h.x), l = Math.min(r.y, o.y, a.y, h.y), u = Math.max(r.x, o.x, a.x, h.x) - c, d = Math.max(r.y, o.y, a.y, h.y) - l;
    return { x: c, y: l, width: u, height: d };
  }
}
class _t {
  /// 按列顺序
  value;
  _m13 = 0;
  _m23 = 0;
  _m33 = 1;
  matrix4;
  constructor(t = Pa) {
    this.value = Array.from(t), this.matrix4 = this.toMatrix4();
  }
  get m11() {
    return this.value[0];
  }
  get m12() {
    return this.value[1];
  }
  get m13() {
    return this._m13;
  }
  get m21() {
    return this.value[2];
  }
  get m22() {
    return this.value[3];
  }
  get m23() {
    return this._m23;
  }
  get m31() {
    return this.value[4];
  }
  get m32() {
    return this.value[5];
  }
  get m33() {
    return this._m33;
  }
  set m11(t) {
    this.value[0] = t;
  }
  set m12(t) {
    this.value[1] = t;
  }
  set m13(t) {
    this._m13 = t;
  }
  set m21(t) {
    this.value[2] = t;
  }
  set m22(t) {
    this.value[3] = t;
  }
  set m23(t) {
    this._m23 = t;
  }
  set m31(t) {
    this.value[4] = t;
  }
  set m32(t) {
    this.value[5] = t;
  }
  set m33(t) {
    this._m33 = t;
  }
  // matrix(1, 0, 0, 1, -50, -50)
  static fromString(t) {
    const e = new _t(), s = Ja("number", t);
    return s.length === 6 && s.forEach((i, r) => {
      i.fullMatch && (e.value[r] = parseFloat(i.fullMatch));
    }), e;
  }
  toMatrix4(t = this.matrix4) {
    const e = [
      this.m11,
      this.m12,
      0,
      this.m13,
      this.m21,
      this.m22,
      0,
      this.m23,
      0,
      0,
      1,
      0,
      this.m31,
      this.m32,
      0,
      this.m33
    ];
    return t ? (t.value = e, t) : new Ot(e);
  }
  identity() {
    return this.value = Array.from(Pa), this.m13 = 0, this.m23 = 0, this.m33 = 1, this.matrix4 = this.toMatrix4(), this;
  }
  get isIdentity() {
    return this.m11 == 1 && this.m12 == 0 && this.m13 == 0 && this.m21 == 0 && this.m22 == 1 && this.m23 == 0 && this.m31 == 0 && this.m32 == 0 && this.m33 == 1;
  }
  multiplyScalar(t) {
    return this.m11 *= t, this.m12 *= t, this.m13 *= t, this.m21 *= t, this.m22 *= t, this.m23 *= t, this.m31 *= t, this.m32 *= t, this.m33 *= t, this;
  }
  normalize() {
    const t = this.m33 || 1e-4;
    return this.multiplyScalar(1 / t);
  }
  transformPoint(t) {
    const e = t.z || 1;
    return {
      x: t.x * this.m11 + t.y * this.m21 + e * this.m31,
      y: t.x * this.m12 + t.y * this.m22 + e * this.m32,
      z: t.x * this.m13 + t.y * this.m23 + e * this.m33
    };
  }
  clone() {
    return new _t(this.value);
  }
  multiply(t) {
    const e = this.clone(), s = t instanceof _t ? t : new _t(t);
    return this.m11 = s.m11 * e.m11 + s.m12 * e.m21 + s.m13 * e.m31, this.m12 = s.m11 * e.m12 + s.m12 * e.m22 + s.m13 * e.m32, this.m13 = s.m11 * e.m13 + s.m12 * e.m23 + s.m13 * e.m33, this.m21 = s.m21 * e.m11 + s.m22 * e.m21 + s.m23 * e.m31, this.m22 = s.m21 * e.m12 + s.m22 * e.m22 + s.m23 * e.m32, this.m23 = s.m21 * e.m13 + s.m22 * e.m23 + s.m23 * e.m33, this.m31 = s.m31 * e.m11 + s.m32 * e.m21 + s.m33 * e.m31, this.m32 = s.m31 * e.m12 + s.m32 * e.m22 + s.m33 * e.m32, this.m33 = s.m31 * e.m13 + s.m32 * e.m23 + s.m33 * e.m33, this;
  }
  append(t) {
    return this.multiply(t);
  }
  prepend(t) {
    return t.multiply(this), this;
  }
  inverse() {
    const t = this.m11, e = this.m12, s = this.m13, i = this.m21, r = this.m22, o = this.m23, a = this.m31, h = this.m32, c = this.m33, l = c * r - o * h, u = -c * i + o * a, d = h * i - r * a;
    let f = t * l + e * u + s * d;
    return f ? (f = 1 / f, this.m11 = l * f, this.m12 = (-c * e + s * h) * f, this.m13 = (o * e - s * r) * f, this.m21 = u * f, this.m22 = (c * t - s * a) * f, this.m23 = (-o * t + s * i) * f, this.m31 = d * f, this.m32 = (-h * t + e * a) * f, this.m33 = (r * t - e * i) * f, this) : null;
  }
  adjugate() {
    const t = new _t();
    return t.m11 = this.m22 * this.m33 - this.m32 * this.m23, t.m12 = this.m32 * this.m13 - this.m12 * this.m33, t.m13 = this.m12 * this.m23 - this.m22 * this.m13, t.m21 = this.m31 * this.m23 - this.m21 * this.m33, t.m22 = this.m11 * this.m33 - this.m31 * this.m13, t.m23 = this.m21 * this.m13 - this.m11 * this.m23, t.m31 = this.m21 * this.m32 - this.m31 * this.m22, t.m32 = this.m31 * this.m12 - this.m11 * this.m32, t.m33 = this.m11 * this.m22 - this.m21 * this.m12, t;
  }
  split() {
    let t = wt(Math.atan2(this.m12, this.m11));
    return this.m11 < 0 && this.m22 >= 0 && (t += 180), {
      x: this.m31,
      y: this.m32,
      degree: t,
      scaleX: Math.sqrt(this.m11 * this.m11 + this.m12 * this.m12),
      scaleY: Math.sqrt(this.m21 * this.m21 + this.m22 * this.m22),
      skewX: wt(Math.atan2(-this.m21, this.m22)),
      skewY: wt(Math.atan2(this.m12, this.m11))
    };
  }
  getGroupCoords(t) {
    const e = this.value[0], s = this.value[1], i = this.value[2], r = this.value[3], o = this.value[4], a = this.value[5], h = t.value[0], c = t.value[1], l = t.value[2], u = t.value[3], d = t.value[4], f = t.value[5], m = h * u, p = c * l, S = (l * s - e * u) / (p - m), g = (h * s - e * c) / (m - p), b = (l * r - i * u) / (p - m), x = (h * r - i * c) / (m - p), w = (l * (a - f) + u * (d - o)) / (p - m), C = (h * (a - f) + c * (d - o)) / (m - p), _ = [S, g, b, x, w, C];
    return new _t(_);
  }
  toString(t = 6) {
    return this.matrix4.is2D() ? `matrix(${this.value.map((e) => Y(e, t)).join(",")})` : this.matrix4.toString();
  }
  // toFilter() {
  //   return (
  //     "progid:DXImageTransform.Microsoft.Matrix(M11=" +
  //     this.value[0] +
  //     ", M12=" +
  //     this.value[2] +
  //     ", M21=" +
  //     this.value[1] +
  //     ", M22=" +
  //     this.value[3] +
  //     ", Dx=" +
  //     this.value[4] +
  //     ", Dy=" +
  //     this.value[5] +
  //     ", sizingmethod='auto expand')"
  //   );
  // }
  // 相对值
  translate(t, e) {
    return this.multiply([1, 0, 0, 1, t, e]), this.toMatrix4(), this;
  }
  // 绝对值
  translateTo(t, e) {
    return this.translate(t - this.m31, e - this.m32);
  }
  translateX(t) {
    return this.translate(t, 0);
  }
  translateXTo(t) {
    return this.translateTo(t, this.m32);
  }
  translateY(t) {
    return this.translate(0, t);
  }
  translateYTo(t) {
    return this.translateTo(this.m31, t);
  }
  translateZ(t) {
    return this.matrix4.translate(0, 0, t), this.matrix4.toMatrix(this), this;
  }
  translateZTo(t) {
    return this.translateZ(t - this.matrix4.m43), this;
  }
  translate3d(t, e, s) {
    return this.matrix4.translate(t, e, s), this.matrix4.toMatrix(this), this;
  }
  translate3dTo(t, e, s) {
    return this.translate3d(
      t - this.matrix4.m41,
      e - this.matrix4.m42,
      s - this.matrix4.m43
    ), this;
  }
  rotate(t, e = 0, s = 0) {
    const i = q(t), r = Math.cos(i), o = Math.sin(i);
    return this.translate(e, s), this.multiply([r, o, -o, r, 0, 0]), this.translate(-e, -s), this.toMatrix4(), this;
  }
  rotateTo(t, e = 0, s = 0) {
    const { degree: i } = this.split();
    return this.rotate(t - i, e, s), this;
  }
  rotateX(t) {
    return this.matrix4.rotateX(t), this.matrix4.toMatrix(this), this;
  }
  rotateXTo(t) {
    const { degreeX: e } = this.matrix4.split();
    return this.rotateX(t - e), this;
  }
  rotateY(t) {
    return this.matrix4.rotateY(t), this.matrix4.toMatrix(this), this;
  }
  rotateYTo(t) {
    const { degreeY: e } = this.matrix4.split();
    return this.rotateY(t - e), this;
  }
  rotateZ(t) {
    return this.matrix4.rotateZ(t), this.matrix4.toMatrix(this), this;
  }
  rotateZTo(t) {
    const { degreeZ: e } = this.matrix4.split();
    return this.rotateZ(t - e), this;
  }
  rotate3d(t, e, s) {
    return this.matrix4.rotateX(t).rotateY(e).rotateZ(s), this.matrix4.toMatrix(this), this;
  }
  rotate3dTo(t, e, s) {
    const { degreeX: i, degreeY: r, degreeZ: o } = this.matrix4.split();
    return this.rotate3d(t - i, e - r, s - o), this;
  }
  scale(t, e = t, s = 0, i = 0) {
    return this.translate(s, i), this.multiply([t, 0, 0, e, 0, 0]), this.translate(-s, -i), this.toMatrix4(), this;
  }
  scaleTo(t, e = t, s = 0, i = 0) {
    return this.scale(
      t / this.m11,
      e / this.m22,
      s,
      i
    );
  }
  scaleX(t) {
    return this.scale(t, 1);
  }
  scaleXTo(t) {
    return this.scale(t / this.m11, 1);
  }
  scaleY(t) {
    return this.scale(1, t);
  }
  scaleYTo(t) {
    return this.scale(1, t / this.m22);
  }
  scaleZ(t) {
    return this.matrix4.scale(1, 1, t), this.matrix4.toMatrix(this), this;
  }
  scaleZTo(t) {
    const { scalarZ: e } = this.matrix4.split();
    return this.scaleZ(t / e), this;
  }
  scale3d(t, e = t, s = t) {
    return this.matrix4.scale(t, e, s), this.matrix4.toMatrix(this), this;
  }
  scale3dTo(t, e = t, s = t) {
    const { scalarX: i, scalarY: r, scalarZ: o } = this.matrix4.split();
    return this.scale3d(t / i, e / r, s / o), this;
  }
  skew(t, e = t) {
    return this.multiply([
      Math.cos(q(e)),
      Math.sin(q(e)),
      -Math.sin(q(t)),
      Math.cos(q(t)),
      0,
      0
    ]), this.toMatrix4(), this;
  }
  skewTo(t, e = t) {
    const { skewX: s, skewY: i } = this.split();
    return this.skew(t - s, e - i);
  }
  skewX(t) {
    const { skewY: e } = this.split();
    return this.skew(t, e);
  }
  skewXTo(t) {
    const { skewY: e } = this.split();
    return this.skewTo(t, e);
  }
  skewY(t) {
    const { skewX: e } = this.split();
    return this.skew(e, t);
  }
  skewYTo(t) {
    const { skewX: e } = this.split();
    return this.skewTo(e, t);
  }
  skewZ(t) {
    return this;
  }
  skewZTo(t) {
    return this;
  }
  skew3d(t, e, s) {
    return this;
  }
  skew3dTo(t, e, s) {
    return this;
  }
  perspective(t) {
    return this.matrix4.perspective(t), this.matrix4.toMatrix(this), this;
  }
}
const w0 = new jt(0, 0, 0), b0 = new jt(1, 1, 1), Ee = new jt(), Sn = new jt(), Lt = new jt(), ss = new jt(), Ni = new en(), Kt = new Ot();
function v0(n) {
  const t = new _t();
  return n.replace(
    // /([a-z]+)\(?([^)a-z]+)\)?/gi,
    /([a-z0-9]+)\s*\(?\s*((-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)*[a-z%]*\s*,?\s*)+)\)?/gi,
    function(e, s, i) {
      i.indexOf(",") >= 0 ? i = i.split(/\s*,\s*/) : i = i.split(/\s+/);
      const r = [];
      for (let o = 0, a = i.length; o < a; o++)
        i[o].trim() && r.push(parseFloat("" + i[o]));
      switch (s.toLowerCase()) {
        case "t":
        case "translate":
          t.translate(r[0], r[1]);
          break;
        case "translatex":
          t.translateX(r[0]);
          break;
        case "translatey":
          t.translateY(r[0]);
          break;
        case "translatez":
          t.translateZ(r[0]);
          break;
        case "translate3d":
          t.translate3d(r[0], r[1], r[2]);
          break;
        case "r":
        case "rotate":
          t.rotate(r[0], r[1] ?? 0, r[2] ?? 0);
          break;
        case "rotatex":
          t.rotateX(r[0]);
          break;
        case "rotatey":
          t.rotateY(r[0]);
          break;
        case "rotatez":
          t.rotateZ(r[0]);
          break;
        case "rotate3d":
          t.rotate3d(r[0], r[1], r[2]);
          break;
        case "s":
        case "scale":
          t.scale(r[0], r[1] ?? r[0]);
          break;
        case "scalex":
          t.scaleX(r[0]);
          break;
        case "scaley":
          t.scaleY(r[0]);
          break;
        case "scalez":
          t.scaleZ(r[0]);
          break;
        case "scale3d":
          t.scale3d(r[0], r[1], r[2]);
          break;
        case "skew":
          t.skew(r[0], r[1] ?? 0);
          break;
        case "skewx":
          t.skewX(r[0]);
          break;
        case "skewy":
          t.skewY(r[0]);
          break;
        case "skewz":
          t.skewZ(r[0]);
          break;
        case "skew3d":
          t.skew3d(r[0], r[1], r[2]);
          break;
        case "m":
        case "matrix":
          t.multiply([
            r[0],
            r[1],
            r[2],
            r[3],
            r[4],
            r[5]
          ]), t.toMatrix4();
          break;
        case "matrix3d":
          t.matrix4.multiply(new Ot(r)), t.matrix4.toMatrix(t);
          break;
      }
      return "";
    }
  ), t;
}
function oe(n, t, e) {
  const s = new _t();
  return s.rotate(wt(n)), s.transformPoint({ x: t, y: e });
}
function Nc(n) {
  const t = typeof n?.x == "number" ? n?.x : 0, e = typeof n?.y == "number" ? n?.y : 0, s = typeof n?.degree == "number" ? n?.degree : 0, i = typeof n?.scalarX == "number" ? n?.scalarX : 1, r = typeof n?.scalarY == "number" ? n?.scalarY : 1, o = q(s), a = Math.cos(o), h = Math.sin(o), c = new DOMMatrix([
    a * i,
    h * i,
    -h * r,
    a * r,
    t,
    e
  ]);
  return c.multiplySelf(new DOMMatrix(n?.originMatrix || "")), c;
}
function h1(n, t) {
  const e = new Path2D(n), s = new Path2D();
  return s.addPath(e, Nc(t)), s;
}
const Cn = new ui(), at = new jt();
function Ss(n, t) {
  switch (t.constructor) {
    case Float32Array:
      return n;
    case Uint32Array:
      return n / 4294967295;
    case Uint16Array:
      return n / 65535;
    case Uint8Array:
      return n / 255;
    case Int32Array:
      return Math.max(n / 2147483647, -1);
    case Int16Array:
      return Math.max(n / 32767, -1);
    case Int8Array:
      return Math.max(n / 127, -1);
    default:
      throw new Error("Invalid component type.");
  }
}
function It(n, t) {
  switch (t.constructor) {
    case Float32Array:
      return n;
    case Uint32Array:
      return Math.round(n * 4294967295);
    case Uint16Array:
      return Math.round(n * 65535);
    case Uint8Array:
      return Math.round(n * 255);
    case Int32Array:
      return Math.round(n * 2147483647);
    case Int16Array:
      return Math.round(n * 32767);
    case Int8Array:
      return Math.round(n * 127);
    default:
      throw new Error("Invalid component type.");
  }
}
class Le {
  array;
  itemSize;
  count;
  normalized;
  updateRanges;
  version;
  constructor(t, e, s = !1) {
    if (Array.isArray(t))
      throw new TypeError("BufferAttribute: array should be a Typed Array.");
    this.array = t, this.itemSize = e, this.count = t.length / e, this.normalized = s, this.updateRanges = [], this.version = 0;
  }
  _onChangeCallback() {
  }
  set needsUpdate(t) {
    t === !0 && this.version++;
  }
  addUpdateRange(t, e) {
    this.updateRanges.push({ start: t, count: e });
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0;
  }
  copy(t) {
    return this.array = vu(t.array), this.itemSize = t.itemSize, this.count = t.count, this.normalized = t.normalized, this;
  }
  copyAt(t, e, s) {
    t *= this.itemSize, s *= e.itemSize;
    for (let i = 0, r = this.itemSize; i < r; i++)
      this.array[t + i] = e.array[s + i];
    return this;
  }
  copyArray(t) {
    return this.array.set(t), this;
  }
  applyMatrix3(t) {
    if (this.itemSize === 2)
      for (let e = 0, s = this.count; e < s; e++)
        Cn.fromBufferAttribute(this, e), Cn.applyMatrix3(t), this.setXY(e, Cn.x, Cn.y);
    else if (this.itemSize === 3)
      for (let e = 0, s = this.count; e < s; e++)
        at.fromBufferAttribute(this, e), at.applyMatrix3(t), this.setXYZ(e, at.x, at.y, at.z);
    return this;
  }
  applyMatrix4(t) {
    for (let e = 0, s = this.count; e < s; e++)
      at.fromBufferAttribute(this, e), at.applyMatrix4(t), this.setXYZ(e, at.x, at.y, at.z);
    return this;
  }
  applyNormalMatrix(t) {
    for (let e = 0, s = this.count; e < s; e++)
      at.fromBufferAttribute(this, e), at.applyNormalMatrix(t), this.setXYZ(e, at.x, at.y, at.z);
    return this;
  }
  transformDirection(t) {
    for (let e = 0, s = this.count; e < s; e++)
      at.fromBufferAttribute(this, e), at.transformDirection(t), this.setXYZ(e, at.x, at.y, at.z);
    return this;
  }
  set(t, e = 0) {
    return this.array.set(t, e), this;
  }
  getComponent(t, e) {
    let s = this.array[t * this.itemSize + e];
    return this.normalized && (s = Ss(s, this.array)), s;
  }
  setComponent(t, e, s) {
    return this.normalized && (s = It(s, this.array)), this.array[t * this.itemSize + e] = s, this;
  }
  getX(t) {
    let e = this.array[t * this.itemSize];
    return this.normalized && (e = Ss(e, this.array)), e;
  }
  setX(t, e) {
    return this.normalized && (e = It(e, this.array)), this.array[t * this.itemSize] = e, this;
  }
  getY(t) {
    let e = this.array[t * this.itemSize + 1];
    return this.normalized && (e = Ss(e, this.array)), e;
  }
  setY(t, e) {
    return this.normalized && (e = It(e, this.array)), this.array[t * this.itemSize + 1] = e, this;
  }
  getZ(t) {
    let e = this.array[t * this.itemSize + 2];
    return this.normalized && (e = Ss(e, this.array)), e;
  }
  setZ(t, e) {
    return this.normalized && (e = It(e, this.array)), this.array[t * this.itemSize + 2] = e, this;
  }
  getW(t) {
    let e = this.array[t * this.itemSize + 3];
    return this.normalized && (e = Ss(e, this.array)), e;
  }
  setW(t, e) {
    return this.normalized && (e = It(e, this.array)), this.array[t * this.itemSize + 3] = e, this;
  }
  setXY(t, e, s) {
    return t *= this.itemSize, this.normalized && (e = It(e, this.array), s = It(s, this.array)), this.array[t + 0] = e, this.array[t + 1] = s, this;
  }
  setXYZ(t, e, s, i) {
    return t *= this.itemSize, this.normalized && (e = It(e, this.array), s = It(s, this.array), i = It(i, this.array)), this.array[t + 0] = e, this.array[t + 1] = s, this.array[t + 2] = i, this;
  }
  setXYZW(t, e, s, i, r) {
    return t *= this.itemSize, this.normalized && (e = It(e, this.array), s = It(s, this.array), i = It(i, this.array), r = It(r, this.array)), this.array[t + 0] = e, this.array[t + 1] = s, this.array[t + 2] = i, this.array[t + 3] = r, this;
  }
  onChange(t) {
    return this._onChangeCallback = t, this;
  }
  clone() {
    return nh(
      this,
      this.array,
      this.itemSize,
      this.normalized
    ).copy(this);
  }
  toJSON() {
    return {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized
    };
  }
}
class c1 extends Le {
  constructor(t, e, s = !1) {
    super(new Int8Array(t), e, s);
  }
}
class l1 extends Le {
  constructor(t, e, s = !1) {
    super(new Uint8Array(t), e, s);
  }
}
class u1 extends Le {
  constructor(t, e, s = !1) {
    super(new Uint8ClampedArray(t), e, s);
  }
}
class f1 extends Le {
  constructor(t, e, s = !1) {
    super(new Int16Array(t), e, s);
  }
}
class d1 extends Le {
  constructor(t, e, s = !1) {
    super(new Uint16Array(t), e, s);
  }
}
class m1 extends Le {
  constructor(t, e, s = !1) {
    super(new Int32Array(t), e, s);
  }
}
class p1 extends Le {
  constructor(t, e, s = !1) {
    super(new Uint32Array(t), e, s);
  }
}
class g1 extends Le {
  constructor(t, e, s = !1) {
    super(new Float32Array(t), e, s);
  }
}
const _0 = {
  map: /* @__PURE__ */ new Map(),
  // see https://github.com/catdad/canvas-confetti/issues/209
  // creating canvases is actually pretty expensive, so we should create a
  // 1:1 map for bitmap:canvas, so that we can animate in
  // a performant manner, but also not store them forever so that we don't
  // have a memory leak
  transform: function(n) {
    if (Ku)
      return n;
    if (this.map.has(n))
      return this.map.get(n);
    const t = new OffscreenCanvas(n.width, n.height);
    return t.getContext("2d")?.drawImage(n, 0, 0), this.map.set(n, t), t;
  },
  clear: function() {
    this.map.clear();
  }
};
function y1(n, t, e) {
  const s = new OffscreenCanvas(n, t), i = s.getContext("2d");
  if (i)
    return e(i), s.transferToImageBitmap();
}
function x1(n, t, e) {
  const s = n.createPattern(
    _0.transform(t),
    "no-repeat"
  );
  if (s) {
    const i = Nc(e);
    s.setTransform(i), n.fillStyle = s;
  }
}
const Aa = ["", "-webkit-", "-moz-", "-o-", "-ms-"];
function Ia(n, t) {
  const e = t.x || 0, s = t.y || 0, i = t.z || 0;
  di(
    n,
    "transform",
    `translate(${e}px, ${s}px) translateZ(${i}px)`
  );
}
function w1(n, t) {
  const e = t?.easingFn || O.Linear.None, s = t?.duration || 0, i = t?.delay || 0, r = Gt(), o = r + s;
  let a = 0, h = 0;
  const c = t.deltaX, l = t.deltaY;
  function u() {
    const d = Gt();
    if (d >= o) {
      Ia(n, { x: c - a, y: l - h });
      return;
    }
    const f = (d - r) / s, m = e(f), p = c * m, S = l * m;
    Ia(n, { x: p - a, y: S - h }), a = p, h = S, Vs(u);
  }
  setTimeout(() => {
    u();
  }, i);
}
const b1 = typeof HTMLElement == "object" ? function(t) {
  return t instanceof HTMLElement;
} : function(t) {
  return t && typeof t == "object" && t.nodeType === 1 && typeof t.nodeName == "string";
};
function S0(n) {
  return window.URL.createObjectURL(n);
}
function v1(n) {
  return window.URL.revokeObjectURL(n);
}
function Yc(n) {
  let t = !1;
  function e() {
    /loaded|complete/.test(document.readyState) && !t && (o(), n(), t = !0);
  }
  const s = Z(document, "DOMContentLoaded", e), i = Z(window, "load", e), r = setInterval(e, 100), o = () => {
    clearInterval(r), s?.(), i?.();
  };
  return o;
}
function C0(n) {
  return Z(window, "beforeunload", (t) => {
    n(t);
  });
}
async function _1(n, t = 6e4) {
  return new Promise((e, s) => {
    const i = document.createElement("script");
    i.type = "text/javascript", i.async = !1, i.onload = (o) => {
      clearTimeout(r), e(o), i.onerror = i.onload = null;
    }, i.onerror = (o) => {
      clearTimeout(r), s(o);
    }, i.src = n;
    const r = setTimeout(() => {
      s("Timeout!");
    }, t);
    document.body.appendChild(i);
  });
}
function pr(n, t) {
  const e = document.createElement("a");
  e.style.visibility = "hidden", e.download = t, typeof n == "string" ? e.href = n : e.href = window.URL.createObjectURL(n), e.click();
}
async function S1(n, t = document.getElementsByTagName("head")[0], e = 6e4) {
  return new Promise((s, i) => {
    const r = document.createElement("link");
    r.setAttribute("type", "text/css"), r.setAttribute("rel", "stylesheet"), r.onload = (a) => {
      clearTimeout(o), s(a), r.onerror = r.onload = null;
    }, r.onerror = (a) => {
      clearTimeout(o), i(a);
    }, r.setAttribute("href", n);
    const o = setTimeout(() => {
      i("Timeout!");
    }, e);
    t.appendChild(r);
  });
}
function C1() {
  return new Promise((n) => {
    const t = Array.from(
      document.querySelectorAll("link[rel=stylesheet]")
    );
    let e = document.styleSheets.length || 0;
    const s = () => e >= t.length ? (n(), !0) : !1;
    s() || t.forEach((i) => {
      i.onload = () => {
        e += 1, s();
      };
    });
  });
}
const ka = new Ws();
async function E0(n, t = 6e4) {
  return new Promise((e, s) => {
    const i = typeof n == "string" ? n : S0(n), r = ka.get(i);
    if (r)
      return e(r);
    const o = setTimeout(() => {
      s("Timeout!");
    }, t), a = document.createElement("img");
    a.onload = () => {
      clearTimeout(o), a.onerror = a.onload = null;
      const h = a.naturalWidth || a.width, c = a.naturalHeight || a.height, l = {
        width: h,
        height: c,
        aspectRatio: h / c,
        element: a,
        imageData: t0(a)
      };
      ka.set(i, l), e(l);
    }, a.onerror = (h) => {
      clearTimeout(o), s(h);
    }, a.src = i;
  });
}
async function P0(n = Ut.text, t = ["*"]) {
  const s = (await $h(t))[0], i = await ai(s, n);
  return {
    type: s.type,
    name: s.name,
    size: s.size,
    data: i
  };
}
async function E1(n = ["image/*"]) {
  const e = (await $h(n))[0];
  if (!e.type.match(/image\/*/))
    return new Error("Not Image Type!");
  const s = await ai(
    e,
    Ut.arraybuffer
  ), i = Dr(s), r = await E0(i);
  return {
    type: e.type,
    name: e.name,
    size: e.size,
    data: s,
    width: r.width,
    height: r.height,
    aspectRatio: r.aspectRatio,
    imageData: r.imageData
  };
}
function P1() {
  return window.getSelection()?.toString() || "";
}
function T1(n) {
  document.getElementsByTagName("title")[0].innerText = n, document.title = n;
}
function M1(n = 200) {
  "vibrate" in navigator ? window.navigator.vibrate(n) : console.error("Your device is not support vibrate on this browser.");
}
async function A1(n) {
  if (navigator.clipboard)
    return await navigator.clipboard.writeText(n);
  {
    const t = document.createElement("textarea");
    return t.value = n, t.style.opacity = "0", t.style.position = "fixed", t.style.top = "0", t.style.left = "0", t.focus(), t.select(), document.execCommand("copy");
  }
}
function I1(n = 0, t = 0) {
  window.scrollTo(n, t);
}
function k1() {
  let n = Yo, t = Yo;
  return "scrollRestoration" in window.history && (window.history.scrollRestoration = "manual", n = C0(() => {
    window.history.scrollRestoration = "auto";
  }), t = Yc(() => {
    window.history.scrollRestoration = "manual";
  })), () => {
    n(), t();
  };
}
function D1(n) {
  return /(html|body)/i.test(n.tagName) || n === document.documentElement;
}
const L1 = (n) => n === document.activeElement && (n.type || n.href);
function Bc() {
  return parseFloat(getComputedStyle(document.documentElement).fontSize);
}
function R1(n) {
  return n * Bc();
}
function O1(n) {
  return n.parentElement ? parseFloat(getComputedStyle(n.parentElement).fontSize) : Bc();
}
const z1 = (n) => {
  let t = n;
  for (; t && t.nodeType !== 1; ) {
    const e = t.parentElement || n.parentNode;
    if (!e)
      break;
    t = e;
  }
  return t;
}, N1 = (n) => n.parentElement, Xc = (n, t = []) => !n || n.parentElement === null && n.parentNode === null ? t : Xc(n.parentElement, t.concat([n]));
function Y1(n) {
  const t = Xc(n);
  for (let e = 0, s = t.length; e < s; e++)
    if (/(auto|scroll)/.test(
      Yn(t[e], "overflow") + Yn(t[e], "overflow-y") + Yn(t[e], "overflow-x")
    ))
      return t[e];
  return document.scrollingElement || document.documentElement;
}
const B1 = (n, t) => n.contains ? n != t && n.contains(t) : !!(n.compareDocumentPosition(t) & 16), X1 = (n) => Array.prototype.slice.call(n.parentElement?.children).filter((t) => t !== n), F1 = (n) => n.nextElementSibling, U1 = (n) => n.previousElementSibling, G1 = (n, t) => n.closest(t), V1 = (n) => n.shadowRoot, fi = (n) => n.tagName === "INPUT" || n instanceof HTMLInputElement, Fc = (n) => n.tagName === "SELECT" || n instanceof HTMLSelectElement, $1 = (n) => n.tagName === "TEXTAREA" || n instanceof HTMLTextAreaElement, Uc = (n) => fi(n) && n.getAttribute("type") === "checkbox", Gc = (n) => fi(n) && n.getAttribute("type") === "radio", q1 = (n) => fi(n) && n.getAttribute("type") === "text", j1 = (n) => fi(n) && n.getAttribute("type") === "number";
function H1(n, t) {
  if (Fc(n)) {
    const e = n.options;
    for (let s = 0, i = e.length; s < i; s++)
      e[s].selected = e[s].value == t;
  }
}
function W1(n, t) {
  if (Gc(n)) {
    const e = document.getElementsByName(n.name);
    for (let s = 0, i = e.length; s < i; s++) {
      const r = e[s];
      r.checked = r.value == t;
    }
  }
}
function Z1(n, t) {
  Uc(n) && (n.checked = t);
}
function Ds(n, t, e = "append") {
  typeof t == "string" ? n[e](k0(t)) : n[e](t);
}
function T0(n, t) {
  if (typeof t == "string") {
    n.innerHTML = t;
    const e = $c(n);
    e != n && (n = e);
  } else
    Ds(t, "replaceWith");
}
const M0 = function(n) {
  T0(n, "");
}, J1 = (n, t) => {
  n.textContent = t;
}, K1 = (n) => {
  if (n instanceof SVGElement)
    return "";
  let t = n.innerText;
  if (!t) {
    const e = n.querySelector("slot")?.assignedNodes() || [];
    let s = 0;
    for (; !t && s <= e.length - 1; )
      "innerText" in e[s] && (t = e[s].innerText), s++;
  }
  return t;
}, Q1 = (n) => n.remove();
function tx(n, t) {
  Yn(n, "display") == "none" && t === void 0 || t === !0 ? A0(n) : I0(n);
}
function A0(n) {
  qs(
    n,
    "display",
    n instanceof HTMLTableRowElement ? "table-row" : n instanceof HTMLTableCellElement ? "table-cell" : "block"
  );
}
function I0(n) {
  qs(n, "display", "none");
}
function Vc(n, t, e = "toggle") {
  const s = t.split(/[,\s]+/);
  if (n.classList)
    s.forEach((i) => {
      const r = i.trim();
      r !== "" && n.classList[e](r);
    });
  else {
    const i = n.className.split(/ +/);
    let r = !1;
    s.forEach((o) => {
      const a = o.trim();
      if (a !== "") {
        const h = i.indexOf(a);
        switch (e) {
          case "add":
            h === -1 && (i.push(a), r = !0);
            break;
          case "remove":
            h !== -1 && (i.splice(h, 1), r = !0);
            break;
          case "toggle":
            h === -1 ? i.push(a) : i.splice(h, 1), r = !0;
            break;
        }
      }
    }), r && ds(
      n,
      "class",
      i.join(" ").replace(/^\s+/, "").replace(/\s+$/, "")
    );
  }
}
function ex(n, t) {
  Vc(n, t, "add");
}
function sx(n, t) {
  Vc(n, t, "remove");
}
function nx(n, t) {
  return new RegExp("(?:^|\\s+)" + t + "(?:\\s+|$)").test(n.className);
}
function k0(n, t = !1) {
  const e = document.createElement("template");
  return e.innerHTML = n, t && e.content.childNodes.forEach((s) => {
    const i = $c(s);
    i != s && e.content.replaceChild(i, s);
  }), e.content;
}
function D0(n) {
  return document.createElement.call(document, n);
}
function ix(n) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", n);
}
function rx(n) {
  return document.createTextNode.call(document, n);
}
function $c(n) {
  return n.tagName == "SCRIPT" && (n = Da(n)), n.querySelectorAll && n.querySelectorAll("script").forEach((t) => {
    t.parentNode?.replaceChild(Da(t), t);
  }), n;
}
function Da(n) {
  const t = n.ownerDocument.createElement("script");
  t.text = n.text;
  const e = n.attributes;
  for (let s = 0, i = e.length; s < i; s++)
    t.setAttribute(e[s].name, e[s].value);
  return t;
}
function ox(n, t = "http://test.com/localstorage.html") {
  const e = document.createElement("iframe");
  e.src = t, document.body.append(e), setTimeout(function() {
    e.contentWindow?.postMessage(n, t);
  }, 4e3), setTimeout(function() {
    e.remove();
  }, 6e3);
}
function ax(n) {
  const t = new Proxy(window, {
    get(e, s, i) {
      if (typeof s == "string" && ["open", "location", "document"].includes(s))
        throw new Error(`禁止访问 key: ${s}`);
      return s === "window" ? t : Reflect.get(e, s, i);
    },
    set(e, s, i, r) {
      return Reflect.set(e, s, i, r);
    }
  });
  new Function("window", `with(window) { ${n} }`)(t, null);
}
function L0() {
  let n = null;
  if (window.ActiveXObject) {
    const t = [
      "Microsoft.XMLHTTP",
      "MSXML6.XMLHTTP",
      "MSXML5.XMLHTTP",
      "MSXML4.XMLHTTP",
      "MSXML3.XMLHTTP",
      "MSXML2.XMLHTTP",
      "MSXML.XMLHTTP"
    ];
    for (let e = 0, s = t.length; e < s; e++)
      try {
        n = new window.ActiveXObject(t[e]);
        break;
      } catch {
        continue;
      }
  } else
    n = new XMLHttpRequest();
  return n;
}
function R0(n, t) {
  return new Promise((e, s) => {
    const {
      method: i = "GET",
      data: r = {},
      multipartFormDataString: o = "",
      boundary: a = "",
      headers: h = {},
      withCredentials: c = !1,
      responseType: l = "json",
      timeout: u = 3e4
    } = t || {}, d = L0();
    d.timeout = u, d.responseType = l, d.onreadystatechange = function(b) {
      d.readyState === 4 && (d.status === 200 ? e(d.response) : s(d.statusText));
    }, d.ontimeout = () => {
      s(`${n} is timed out for ${u}ms.`);
    }, d.addEventListener("load", (b) => t?.load?.(b, d), !1), d.addEventListener(
      "loadstart",
      (b) => t?.loadstart?.(b, d),
      !1
    ), d.addEventListener(
      "loadend",
      (b) => t?.loadend?.(b, d),
      !1
    ), d.addEventListener(
      "progress",
      (b) => {
        if (b.lengthComputable) {
          const x = Math.round(b.loaded * 100 / b.total);
          t?.progress?.(b, d, x);
        }
      },
      !1
    ), d.addEventListener("error", (b) => t?.error?.(b, d), !1), d.addEventListener("abort", (b) => t?.abort?.(b, d), !1);
    const f = i.toUpperCase();
    Object.assign(h, {
      Accept: "*/*"
      // "Access-Control-Request-Headers": "authorization",
      // "Access-Control-Request-Method": "POST",
      // "Content-Type": "application/json;charset=utf-8",
    });
    let m = !1, p = !1, S = !1;
    function g() {
      d.setRequestHeader("If-Modified-Since", "Sat, 1 Jan 2000 00:00:00 GMT"), c && (d.withCredentials = !0);
      for (const b in h)
        pt(b).toLowerCase() == "content-type" && h[b].toLowerCase() == "multipart/form-data" ? (m = !0, d.setRequestHeader(
          "Content-Type",
          "multipart/form-data; boundary=" + a
        )) : (pt(b).toLowerCase() == "content-type" && (h[b].toLowerCase().indexOf("text/plain") >= 0 ? p = !0 : h[b].toLowerCase().indexOf("application/json") >= 0 && (S = !0)), d.setRequestHeader(b, h[b]));
    }
    switch (f) {
      case "GET":
        let b = "";
        r instanceof FormData ? b = Af(r) : b = Mf(r), d.open("GET", Tf(n, b), !0), g(), d.send(null);
        break;
      default:
        d.open(f, n, !0), g(), m ? d.sendAsBinary(o) : S ? d.send(JSON.stringify(r)) : p ? d.send(
          Object.entries(r).map(([x, w]) => `${x}=${w}`).join(`\r
`)
        ) : d.send(
          Object.entries(r).map(
            ([x, w]) => `${encodeURIComponent(x)}=${encodeURIComponent(w)}`
          ).join("&")
        );
        break;
    }
  });
}
async function hx(n) {
  const t = {
    url: n.action || "",
    data: {},
    contentType: n.method.toLowerCase() === "post" && n.enctype ? n.enctype : "application/x-www-form-urlencoded",
    multipartFormDataString: "",
    boundary: "---------------------------" + Date.now().toString(16)
  }, e = [], s = t.contentType == "multipart/form-data";
  for (let i = 0; i < n.elements.length; i++) {
    const r = n.elements[i];
    if (!r.hasAttribute("name"))
      continue;
    const o = r.getAttribute("type");
    switch (r.nodeName.toUpperCase() === "INPUT" && o ? o.toUpperCase() : "") {
      case "FILE":
        const h = r;
        if (s)
          for (let u = 0, d = h.files?.length || 0; u < d; u++) {
            const f = h.files?.[u];
            if (f) {
              const m = await ai(
                f,
                Ut.binaryString
              );
              e.push(
                'Content-Disposition: form-data; name="' + h.name + '"; filename="' + f.name + `"\r
Content-Type: ` + f.type + `\r
\r
` + m + `\r
`
              );
            }
          }
        break;
      case "RADIO":
      case "CHECKBOX":
        if (!r.checked)
          break;
      default:
        const l = r;
        s ? e.push(
          'Content-Disposition: form-data; name="' + l.name + `"\r
\r
` + l.value + `\r
`
        ) : t.data[l.name] = l.value;
        break;
    }
  }
  return t.multipartFormDataString = "--" + t.boundary + `\r
` + e.join("--" + t.boundary + `\r
`) + "--" + t.boundary + `--\r
`, t;
}
function qc(n) {
  const t = [];
  for (let e = 0, s = Aa.length; e < s; e++) {
    const i = pt(Aa[e] + n);
    t.push(i);
  }
  return t;
}
function Yn(n, t, e) {
  const s = Mc(n);
  return s.props.style = s.props.style || {}, t ? s.props.style[t] || s.props.style[Ka(t)] || s.props.style[pt(t)] || "" : s.props.style;
}
function qs(n, t, e) {
  fr(n, (s) => {
    s.props.style = s.props.style || {}, typeof t == "string" && e ? s.props.style[t] = e : t instanceof Object && Object.keys(t).forEach((i) => {
      s.props.style[i] = t[i];
    });
  }), Ic();
}
function jc(n, t = !1) {
  const e = {};
  if (!t)
    if (getComputedStyle) {
      const s = getComputedStyle(n);
      for (let i = 0, r = s.length; i < r; i++) {
        const o = s[i];
        e[o] = s.getPropertyValue(o);
      }
    } else {
      const s = n.style || n.currentStyle;
      for (const i in s)
        Object.prototype.hasOwnProperty.call(s, i) && (e[i] = s[i]);
    }
  return n.style.cssText && n.style.cssText.split(";").filter((s) => !!s).forEach((s) => {
    const [i, r] = s.split(":").map((o) => o.trim());
    i && r && (e[i] = r);
  }), e;
}
function cx(n, t) {
  const e = qc(t), s = e.length;
  let i = "";
  for (let r = 0; r < s; r++) {
    const o = e[r];
    if (i = n[o] || "", i)
      return i;
  }
  return i;
}
function lx(n, t, e) {
  const s = qc(t), i = s.length;
  let r = "";
  for (let o = 0; o < i; o++) {
    const a = s[o];
    if (r = "style" in n && n.style[a] || "currentStyle" in n && n.currentStyle[a] || "", r)
      return r;
  }
  if (getComputedStyle) {
    const o = getComputedStyle(n, e);
    for (let a = 0; a < i; a++) {
      const h = s[a];
      if (r = o.getPropertyValue(h).trim(), r)
        return r;
    }
  }
  return r;
}
function di(n, t, e) {
  if (t)
    if (typeof t == "string" && e)
      try {
        n.style.setProperty(
          t,
          e.replace(/!important/i, ""),
          e.toLowerCase().includes("!important") ? "important" : ""
        );
      } catch {
        n.style[t] = e;
      }
    else
      t instanceof Object && Object.keys(t).forEach((s) => {
        di(n, s, t[s]);
      });
}
function Hc(n, t) {
  typeof t == "string" ? n.style.removeProperty(pt(t)) : Object.keys(t).forEach((e) => {
    Hc(n, e);
  });
}
function O0(n, t) {
  let e;
  if (typeof t == "string") {
    const s = document.querySelector(t)?.shadowRoot;
    s ? e = s : e = document.querySelector(t);
  } else
    e = t || document.getElementsByTagName("head")[0];
  if (e) {
    const s = document.createElement("style");
    return s.innerHTML = n, e.appendChild(s), () => {
      (e instanceof HTMLElement || e instanceof ShadowRoot) && e.removeChild(s);
    };
  } else {
    const s = document.styleSheets[0].insertRule(n);
    return () => {
      document.styleSheets[0].deleteRule(s);
    };
  }
}
class z0 {
  selector;
  name;
  value;
  constructor(t, e, s) {
    this.selector = t, this.name = e, this.value = s;
  }
  toString() {
    return `${this.selector} { ${this.name}: ${this.value} }`;
  }
}
class N0 {
  propertyName;
  values = [];
  constructor(t) {
    this.propertyName = t;
  }
  add(t, e) {
    this.values.push(new z0(t, this.propertyName, e));
  }
}
async function Y0() {
  const n = [], t = document.querySelectorAll("style, link");
  for (let e = 0, s = t.length; e < s; e++) {
    const i = t[e];
    let r = i.innerHTML;
    switch (i.nodeName.toLowerCase()) {
      case "style":
        break;
      case "link":
        r = await R0(i.href, {
          method: "GET",
          responseType: "text"
        });
        break;
    }
    r = r.replace(/\/\/.+?(?=\n|\r|$)|\/\*[\s\S]+?\*\//g, "").replace(/@[^{};]*;|@[^{};]*\{[^}]*\}/g, "").replace(/[\\n\n]+(?<=[\\n\n]+)\s+/g, ""), n.push(r);
  }
  return n;
}
async function ux() {
  const n = {}, t = await Y0();
  for (let e = 0, s = t.length; e < s; e++) {
    const r = t[e].match(/[^{]*{[^}]*}/g);
    if (r)
      for (let o = 0, a = r.length; o < a; o++) {
        const h = r[o].split(/[{}]/g), c = h[0].trim(), u = h[1].split(";");
        for (let d = 0; d < u.length; d++)
          if (u[d].trim() != "") {
            const f = u[d].split(":"), m = f[0].trim().toLowerCase(), p = f[1];
            n[m] || (n[m] = new N0(m)), p && n[m].add(c, p.trim());
          }
      }
  }
  return n;
}
function Me(n, t, e) {
  if (t === void 0 && e === void 0)
    return Wc(n);
  if (typeof t == "string" && e === void 0)
    return B0(n, t);
  typeof t == "object" ? fr(n, (s) => {
    for (const i in t)
      i == "style" ? qs(n, i, t[i]) : Object.prototype.hasOwnProperty.call(t, i) && (s.props[i] = "" + t[i]);
  }) : typeof t == "string" && typeof e == "string" && (t == "style" ? qs(n, t, e) : fr(n, (s) => {
    s.props[t] = "" + e;
  })), Ic();
}
function Wc(n) {
  const t = {};
  for (let e = 0, s = n.attributes, i = s.length; e < i; e++) {
    const r = s[e];
    r.nodeName && r.nodeValue && (r.nodeName === "style" ? t[r.nodeName] = jc(n, !0) : t[r.nodeName] = r.nodeValue);
  }
  return t;
}
function B0(n, t) {
  return t === "style" ? jc(n, !0) : n.getAttribute(pt(t));
}
function ds(n, t, e) {
  return n.setAttribute(pt(t), "" + e);
}
function fx(n, t) {
  t.split(/[,\s]+/i).forEach((e) => {
    const s = pt(e.trim());
    s != "" && n.removeAttribute(s);
  });
}
function X0(n, t) {
  for (const e in t) {
    const s = t[e];
    switch (e) {
      case "fill":
        s !== "none" && (n.fillStyle = s);
        break;
      case "stroke":
        s !== "none" && (n.strokeStyle = s);
        break;
      case "stroke-width":
      case "strokeWidth":
        n.lineWidth = Number(s);
        break;
      case "stroke-linecap":
      case "strokeLinecap":
        n.lineCap = s;
        break;
      case "stroke-linejoin":
      case "strokeLinejoin":
        switch (s) {
          case "round":
          case "bevel":
          case "miter":
            n.lineJoin = s;
            break;
          default:
            n.lineJoin = "miter";
            break;
        }
        break;
      case "stroke-miterlimit":
      case "strokeMiterlimit":
        n.miterLimit = Number(s);
        break;
      case "stroke-opacity":
      case "strokeOpacity":
        break;
      case "stroke-dashoffset":
      case "strokeDashoffset":
        n.lineDashOffset = Number(s);
        break;
      case "stroke-dasharray":
      case "strokeDasharray":
        typeof s == "string" && n.setLineDash(s.split(/\s+/).map((i) => Number(i)));
        break;
      case "cursor":
        break;
      case "font":
        typeof s == "string" && (n.font = s);
        break;
      case "font-size":
      case "fontSize":
        n.font += ` ${s}`;
        break;
      case "font-family":
      case "fontFamily":
        n.font += ` ${s}`;
        break;
      case "font-weight":
      case "fontWeight":
        break;
      case "font-style":
      case "fontStyle":
        break;
      case "text-anchor":
      case "textAnchor":
        switch (s) {
          case "middle":
            n.textAlign = "center";
            break;
          case "end":
            n.textAlign = "end";
            break;
          case "start":
            n.textAlign = "start";
            break;
        }
        break;
      case "alignment-baseline":
      case "alignmentBaseline":
        switch (s) {
          case "middle":
          case "bottom":
          case "top":
          case "alphabetic":
          case "hanging":
          case "ideographic":
            n.textBaseline = s;
            break;
          default:
            n.textBaseline = "alphabetic";
            break;
        }
        break;
    }
  }
}
function dx() {
  return "ontouchstart" in window || "ontouchend" in document || navigator.maxTouchPoints > 0;
}
function mx() {
  return !!window.PointerEvent;
}
function px(n, t) {
  let e = document.createElement(n);
  t = "on" + t;
  let s = t in e;
  return s || (e.setAttribute(t, "return;"), s = typeof e[t] == "function"), e = null, s;
}
function La() {
  return {
    x: 0,
    y: 0,
    isDown: !1
  };
}
function ys() {
  const n = La(), t = La();
  return {
    start: n,
    current: t,
    setStart: function(e, s) {
      n.x = e.x, n.y = e.y, n.isDown = typeof s == "boolean" ? s : typeof e.isDown == "boolean" ? e.isDown : !1, this.setCurrent(e, s);
    },
    setCurrent: (e, s) => {
      t.x = e.x, t.y = e.y, t.isDown = typeof s == "boolean" ? s : typeof e.isDown == "boolean" ? e.isDown : !1;
    }
  };
}
function ro(n = document.documentElement, t = !1) {
  return X(n, "mousemove", t);
}
function F0(n = document.documentElement, t = !1) {
  return X(n, "mousedown", t);
}
function U0(n = document.documentElement, t = !1) {
  return X(n, "mouseup", t);
}
function gx(n = document.documentElement, t = !1) {
  return X(n, "mouseover", t);
}
function yx(n = document.documentElement, t = !1) {
  return X(n, "mouseout", t);
}
function xx(n = document.documentElement, t = !1) {
  return X(n, "mouseenter", t);
}
function bx(n = document.documentElement, t = !1) {
  return X(n, "mouseleave", t);
}
function vx(n = document.documentElement, t = !1) {
  return X(n, "click", t);
}
function _x(n = document.documentElement, t = !1) {
  return X(n, "dblclick", t);
}
function Sx(n = document.documentElement, t = !1) {
  return X(
    n,
    "onwheel" in document.createElement("div") ? "wheel" : document.onmousewheel !== void 0 ? "mousewheel" : "DOMMouseScroll",
    // older Firefox
    t
  );
}
function Cx(n = document.documentElement, t = !1) {
  return X(n, "contextmenu", t);
}
function G0(n = document.documentElement, t = !1) {
  return X(n, "touchmove", t);
}
function V0(n = document.documentElement, t = !1) {
  return X(n, "touchstart", t);
}
function $0(n = document.documentElement, t = !1) {
  return X(n, "touchend", t);
}
function q0(n = document.documentElement, t = !1) {
  return X(n, "touchcancel", t);
}
function Zc(n = document.documentElement, t = !1) {
  return X(n, "pointermove", t);
}
function Jc(n = document.documentElement, t = !1) {
  return X(n, "pointerdown", t);
}
function Kc(n = document.documentElement, t = !1) {
  return X(n, "pointerup", t);
}
function Qc(n = document.documentElement, t = !1) {
  return X(n, "pointercancel", t);
}
function Ex(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("pan", e);
    },
    (e) => {
      t.off("pan", e);
    }
  );
}
function Px(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("panmove", e);
    },
    (e) => {
      t.off("panmove", e);
    }
  );
}
function Tx(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("panstart", e);
    },
    (e) => {
      t.off("panstart", e);
    }
  );
}
function Mx(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("panend", e);
    },
    (e) => {
      t.off("panend", e);
    }
  );
}
function Ax(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("pancancel", e);
    },
    (e) => {
      t.off("pancancel", e);
    }
  );
}
function Ix(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("panleft", e);
    },
    (e) => {
      t.off("panleft", e);
    }
  );
}
function kx(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("panright", e);
    },
    (e) => {
      t.off("panright", e);
    }
  );
}
function Dx(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("panup", e);
    },
    (e) => {
      t.off("panup", e);
    }
  );
}
function Lx(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("pandown", e);
    },
    (e) => {
      t.off("pandown", e);
    }
  );
}
function Rx(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("pinch", e);
    },
    (e) => {
      t.off("pinch", e);
    }
  );
}
function Ox(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("pinchin", e);
    },
    (e) => {
      t.off("pinchin", e);
    }
  );
}
function zx(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("pinchout", e);
    },
    (e) => {
      t.off("pinchout", e);
    }
  );
}
function Nx(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("press", e);
    },
    (e) => {
      t.off("press", e);
    }
  );
}
function Yx(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("rotate", e);
    },
    (e) => {
      t.off("rotate", e);
    }
  );
}
function Bx(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("swipe", e);
    },
    (e) => {
      t.off("swipe", e);
    }
  );
}
function Xx(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("swipeleft", e);
    },
    (e) => {
      t.off("swipeleft", e);
    }
  );
}
function Fx(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("swiperight", e);
    },
    (e) => {
      t.off("swiperight", e);
    }
  );
}
function Ux(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("swipeup", e);
    },
    (e) => {
      t.off("swipeup", e);
    }
  );
}
function Gx(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("swipedown", e);
    },
    (e) => {
      t.off("swipedown", e);
    }
  );
}
function j0(n = document.documentElement) {
  const t = new rt(n);
  return tt(
    (e) => {
      t.on("tap", e);
    },
    (e) => {
      t.off("tap", e);
    }
  );
}
function Vx(n = document.documentElement) {
  const t = new rt(document.documentElement);
  return tt(
    (e) => {
      const s = (i) => {
        !i.target || n == i.target || n.contains(i.target) || e(i);
      };
      return t.on("tap", s), s;
    },
    (e, s) => {
      t.off("tap", s);
    }
  );
}
function $x(n = document.documentElement, t = !1) {
  return X(n, "transitionstart", t);
}
function qx(n = document.documentElement, t = !1) {
  return dc(
    X(n, "transitionend", t),
    X(
      n,
      "webkitTransitionEnd",
      t
    ),
    X(n, "oTransitionEnd", t),
    X(n, "MSTransitionEnd", t)
  );
}
function jx(n = document.documentElement, t = !1) {
  return X(n, "animationstart", t);
}
function Hx(n = document.documentElement, t = !1) {
  return X(n, "animationend", t);
}
function H0(n = document.documentElement, t = !1) {
  return X(n, "drag", t);
}
function W0(n = document.documentElement, t = !1) {
  return X(n, "dragstart", t);
}
function Z0(n = document.documentElement, t = !1) {
  return X(n, "dragend", t);
}
function J0(n = document.documentElement, t = !1) {
  return X(n, "drop", t);
}
function K0(n = document.documentElement, t = !1) {
  return X(n, "dragenter", t);
}
function Q0(n = document.documentElement, t = !1) {
  return X(n, "dragleave", t);
}
function tg(n = document.documentElement, t = !1) {
  return X(n, "dragover", t);
}
function eg(n = document.documentElement, t = !1) {
  return X(n, "keydown", t);
}
function sg(n = document.documentElement, t = !1) {
  return X(n, "keyup", t);
}
function Wx(n = document.documentElement, t = !1) {
  return X(n, "keypress", t);
}
function Zx(n = document.documentElement, t) {
  const e = t?.useMousePoint || ys();
  return ro(n).pipe(
    it((s) => (e.setCurrent(mt(s, n)), e))
  );
}
function ng(n = document.documentElement, t) {
  const e = t?.useMousePoint || ys();
  return ro(n).pipe(
    Tp(
      F0(n).pipe(
        je((s) => {
          e.setStart(mt(s, n), !0), t?.start?.(s, e);
        })
      ),
      () => U0(n).pipe(
        je((s) => {
          e.setCurrent(mt(s, n), !1), t?.end?.(s, e);
        })
      )
    ),
    Cp(),
    it((s) => (e.setCurrent(mt(s, n), !0), e))
  );
}
function ig(n = document.documentElement, t) {
  const e = t?.useMousePoint || ys();
  return V0(n).pipe(
    je((s) => {
      const i = s.changedTouches[0];
      e.setStart(mt(i, n), !0), t?.start?.(i, e);
    }),
    ci(
      () => G0(n).pipe(
        eo(
          hi($0(n), q0(n)).pipe(
            je((s) => {
              const i = s.changedTouches[0];
              e.setCurrent(mt(i, n), !1), t?.end?.(i, e);
            })
          )
        )
      )
    ),
    it((s) => {
      const i = s.changedTouches[0];
      return e.setCurrent(mt(i, n), !0), e;
    })
  );
}
function gr(n = document.documentElement, t) {
  const e = t?.useMousePoint || ys();
  return Jc(n).pipe(
    je((s) => {
      e.setStart(mt(s, n), !0), t?.start?.(s, e);
    }),
    ci(
      () => Zc(n).pipe(
        eo(
          hi(Kc(n), Qc(n)).pipe(
            je((s) => {
              e.setCurrent(mt(s, n), !1), t?.end?.(s, e);
            })
          )
        )
      )
    ),
    it((s) => (e.setCurrent(mt(s, n), !0), e))
  );
}
function Jx(n = document.documentElement, t) {
  return hi(
    ng(n, t),
    ig(n, t)
    // usePointerDownMovePoint$(el, options),
  );
}
function rg(n = document.documentElement, t) {
  const e = t?.useMousePoint || ys();
  return dc(ro(n), Jc(n)).pipe(
    pc((s) => s instanceof PointerEvent ? (e.setStart(mt(s, n), !0), t?.start?.(s, e), Zc(n).pipe(
      eo(
        hi(Kc(n), Qc(n)).pipe(
          je((i) => {
            e.setCurrent(mt(i, n), !1), t?.end?.(i, e);
          })
        )
      )
    )) : s instanceof MouseEvent ? jm(s) : Qh),
    it((s) => (e.setCurrent(
      mt(s, n),
      s instanceof PointerEvent
    ), e))
  );
}
function Kx(n) {
  return new nt((t) => gr(n, {
    start: () => {
      t.next(0);
    }
  }).subscribe((s) => {
    t.next(s.current.y - s.start.y);
  }).unsubscribe).pipe(De());
}
function Qx(n, t) {
  ds(n, "draggable", "true");
  const e = W0(n, !0).subscribe(
    (r) => {
      Fe(r), gc(r);
      const o = r.dataTransfer;
      o && (o.effectAllowed = "move", o.setData("text/plain", "some-data")), t?.onStart?.(r);
    }
  ), s = H0(n).subscribe((r) => {
    Fe(r), t?.onDrag?.(r);
  }), i = Z0(n).subscribe((r) => {
    Fe(r), t?.onEnd?.(r);
  });
  return () => {
    e.unsubscribe(), s.unsubscribe(), i.unsubscribe();
  };
}
function tw(n, t) {
  const e = K0(n).subscribe((o) => {
    Fe(o), t?.onEnter?.(o);
  }), s = tg(n).subscribe((o) => {
    Fe(o);
    const a = o.dataTransfer;
    a && (a.dropEffect = "move"), t?.onOver?.(o);
  }), i = Q0(n).subscribe((o) => {
    Fe(o), t?.onLeave?.(o);
  }), r = J0(n).subscribe((o) => {
    Fe(o);
    const a = o.dataTransfer;
    if (!a) {
      t?.onDrop?.(o, []);
      return;
    }
    t?.onDrop?.(o, [...a.files]);
  });
  return () => {
    e.unsubscribe(), s.unsubscribe(), i.unsubscribe(), r.unsubscribe();
  };
}
function og(n = 10) {
  return X(window, "scroll", !0).pipe(Pp(n));
}
function ew() {
  return X(document, "visibilitychange", !0).pipe(
    it(() => document.visibilityState === "visible"),
    De()
  );
}
function sw() {
  return X(window, "storage", !1);
}
function nw() {
  return {
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    innerWidth: window.innerWidth,
    // 浏览器窗口的宽度（不包括滚动条）
    innerHeight: window.innerHeight,
    // 浏览器窗口的高度（不包括滚动条）
    screenX: window.screenX,
    screenY: window.screenY,
    // window.screenY + (window.outerHeight - window.innerHeight)
    pageXOffset: window.pageXOffset,
    // 当前页面水平滚动的像素数
    pageYOffset: window.pageYOffset
    // 当前页面垂直滚动的像素数
  };
}
function sn() {
  const n = document.documentElement || document.body;
  return {
    el: n,
    // 不包括边框大小，只包含内容和内边距
    clientWidth: n.clientWidth,
    clientHeight: n.clientHeight,
    clientTop: n.clientTop,
    clientLeft: n.clientLeft,
    // const contentWidth =
    //   [...el.children].reduce(
    //     (a, e) => Math.max(a, e.getBoundingClientRect().right),
    //     0
    //   ) - el.getBoundingClientRect().x;
    // 元素的内容区域加上它的内边距再加上任何溢出内容的尺寸
    // 当内容没有溢出时，scrollWidth == clientWidth , scrollHeight == clientHeight
    // 当内容溢出时，   scrollWidth >  clientWidth , scrollHeight >  clientHeight
    scrollWidth: n.scrollWidth,
    scrollHeight: n.scrollHeight,
    scrollTop: n.scrollTop,
    scrollLeft: n.scrollLeft,
    // 返回元素的实际大小，包括边框、内边距和滚动条
    offsetWidth: n.offsetWidth,
    offsetHeight: n.offsetHeight,
    offsetTop: n.offsetTop,
    offsetLeft: n.offsetLeft,
    offsetParent: n.offsetParent
  };
}
function tl() {
  const { clientWidth: n, clientHeight: t, scrollLeft: e, scrollTop: s } = sn();
  return {
    width: window.innerWidth || n,
    height: window.innerHeight || t,
    x: window.pageXOffset || e,
    y: window.pageYOffset || s
  };
}
function iw() {
  const { scrollWidth: n, scrollHeight: t, scrollLeft: e, scrollTop: s } = sn();
  return {
    width: n,
    height: t,
    scrollX: window.pageXOffset || e,
    scrollY: window.pageYOffset || s
  };
}
function el(n) {
  return n.getBoundingClientRect();
}
function rw(n) {
  return {
    x: n.offsetLeft,
    y: n.offsetTop,
    width: n.offsetWidth,
    height: n.offsetHeight
  };
}
function Ra(n) {
  const { top: t, left: e, width: s, height: i } = n.getBoundingClientRect(), { scrollLeft: r, scrollTop: o } = sn();
  return {
    x: e + r,
    y: t + o,
    width: s,
    height: i
  };
}
function ow(n) {
  let t = n, e = 0, s = 0;
  for (; t !== null; )
    e += t.offsetLeft, s += t.offsetTop, t.offsetParent instanceof HTMLElement ? t = t.offsetParent : t = null;
  return {
    x: e,
    y: s,
    width: n.offsetWidth,
    height: n.offsetHeight
  };
}
function aw() {
  const { clientHeight: n, scrollTop: t, scrollHeight: e } = sn(), s = e - n;
  return s <= 0 ? 0 : t / s * 100;
}
function hw(n) {
  const t = tl(), e = el(n);
  return e.bottom >= 0 && e.top <= t.height && e.right >= 0 && e.left <= t.width;
}
function cw(n) {
  if ("center" in n) {
    const t = n.center, e = el(n.target);
    return {
      x: t.x - e.x,
      y: t.y - e.y
    };
  }
  return {
    x: n.clientX,
    y: n.clientY
  };
}
function Oa(n) {
  if ("center" in n)
    return n.center;
  if (typeof n.pageX == "number" && typeof n.pageY == "number")
    return {
      x: n.pageX,
      y: n.pageY
    };
  const { scrollLeft: t, scrollTop: e } = sn();
  return {
    x: n.clientX + t,
    y: n.clientY + e
  };
}
function mt(n, t) {
  const e = {
    x: 0,
    y: 0
  };
  if (t) {
    const s = Oa(n), i = Ra(t);
    e.x = N(s.x - i.x, 0, i.width), e.y = N(s.y - i.y, 0, i.height);
  } else {
    let s = 0, i = 0;
    if ("currentTarget" in n && n.currentTarget && n.target && n.currentTarget != n.target) {
      const r = n.currentTarget.getBoundingClientRect(), o = n.target.getBoundingClientRect();
      s = o.left - r.left, i = o.top - r.top;
    }
    if ("offsetX" in n)
      e.x = n.offsetX + s, e.y = n.offsetY + i;
    else {
      const r = Oa(n), o = Ra(n.target);
      e.x = N(r.x - o.x + s, 0, o.width), e.y = N(r.y - o.y + i, 0, o.height);
    }
  }
  return e;
}
function lw(n) {
  let t = 0;
  return n || (n = window.event), n.wheelDelta ? (t = n.wheelDelta / 120, window.opera && (t = -t)) : n.detail && (t = -n.detail / 3), t;
}
function uw(n) {
  if (document.implementation.hasFeature("MouseEvents", "2.0"))
    return n.button;
  switch (n.button) {
    case 0:
    case 1:
    case 3:
    case 5:
    case 7:
      return 0;
    case 2:
    case 6:
      return 2;
    case 4:
      return 1;
  }
}
const fw = {
  BACKSPACE: 8,
  TAB: 9,
  COMMA: 188,
  DELETE: 46,
  END: 35,
  ENTER: 13,
  ESCAPE: 27,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  DOWN: 40,
  PAGE_DOWN: 34,
  PAGE_UP: 33,
  PERIOD: 190,
  RIGHT: 39,
  SPACE: 32
}, dw = {
  NULL: "",
  CANCEL: "",
  // ^break
  HELP: "",
  BACK_SPACE: "",
  TAB: "",
  CLEAR: "",
  RETURN: "",
  ENTER: "",
  SHIFT: "",
  CONTROL: "",
  ALT: "",
  PAUSE: "",
  ESCAPE: "",
  SPACE: "",
  PAGE_UP: "",
  PAGE_DOWN: "",
  END: "",
  HOME: "",
  ARROW_LEFT: "",
  LEFT: "",
  ARROW_UP: "",
  UP: "",
  ARROW_RIGHT: "",
  RIGHT: "",
  ARROW_DOWN: "",
  DOWN: "",
  INSERT: "",
  DELETE: "",
  SEMICOLON: "",
  EQUALS: "",
  NUMPAD0: "",
  // number pad keys
  NUMPAD1: "",
  NUMPAD2: "",
  NUMPAD3: "",
  NUMPAD4: "",
  NUMPAD5: "",
  NUMPAD6: "",
  NUMPAD7: "",
  NUMPAD8: "",
  NUMPAD9: "",
  MULTIPLY: "",
  ADD: "",
  SEPARATOR: "",
  SUBTRACT: "",
  DECIMAL: "",
  DIVIDE: "",
  F1: "",
  // function keys
  F2: "",
  F3: "",
  F4: "",
  F5: "",
  F6: "",
  F7: "",
  F8: "",
  F9: "",
  F10: "",
  F11: "",
  F12: "",
  COMMAND: "",
  // Apple command key
  META: "",
  // alias for Windows key
  /**
   * Japanese modifier key for switching between full- and half-width
   * characters.
   * @see <https://en.wikipedia.org/wiki/Language_input_keys>
   */
  ZENKAKU_HANKAKU: ""
};
function mw(n) {
  if (n.key)
    return n.key;
  if (n.keyCode)
    return n.keyCode;
  if (n.which)
    return n.which;
}
function sl(n, t) {
  const e = t.ctrl || !1, s = t.shift || !1, i = t.alt || !1;
  return (e === n.metaKey || e === n.ctrlKey) && s === n.shiftKey && i === n.altKey && t.keys.map((r) => r.toLowerCase()).includes(n.key.toLowerCase());
}
function ag(n) {
  return eg(n.target || document || window).pipe(
    mc((t) => sl(t, n)),
    it((t) => {
      t.stopPropagation(), t.preventDefault();
    })
  );
}
function pw(n) {
  return sg(n.target || document || window).pipe(
    mc((t) => sl(t, n)),
    it((t) => {
      t.stopPropagation(), t.preventDefault();
    })
  );
}
function hg(n = { keys: ["o"] }, t = Ut.text) {
  return ag(n).pipe(
    // 方法1：使用 switchMap 调用异步函数
    ci(async () => await P0(t))
    // 方法2：将 Promise 转为 Observable
    // switchMap(() => {
    //   return from(useSelectFile(type));
    // })
  );
}
async function gw(n = { keys: ["o"] }, t = Ut.text) {
  return Wm(hg(n, t));
}
async function cg(n, t) {
  return new Promise((e) => {
    const s = new ResizeObserver((i) => {
      const r = n.getBoundingClientRect();
      t(r), e(() => {
        s.unobserve(n);
      });
    });
    s.observe(n);
  });
}
function nl(n = document.documentElement, t) {
  return new nt((e) => {
    const s = n.getBoundingClientRect();
    let i = s.x, r = s.y, o = s.width, a = s.height;
    e.next(s);
    const h = new ResizeObserver((c) => {
      const l = n.getBoundingClientRect();
      (i != l.x || r != l.y || o != l.width || a != l.height) && (i = l.x, r = l.y, o = l.width, a = l.height, e.next(l));
    });
    return h.observe(n, t), () => {
      h.unobserve(n), h.disconnect();
    };
  });
}
function yw() {
  return X(
    window,
    "orientationchange" in window ? "orientationchange" : "resize"
  ).pipe(
    it((n) => ({
      width: n.target.innerWidth,
      height: n.target.innerHeight
    })),
    Ke({
      width: window.innerWidth,
      height: window.innerHeight
    })
  );
}
function lg() {
  const n = {
    x: 0,
    y: 0,
    dx: 0,
    dy: 0,
    dStartX: 0,
    dStartY: 0,
    isDown: !1
  }, t = {
    x: 0,
    y: 0,
    dx: 0,
    dy: 0,
    dStartX: 0,
    dStartY: 0,
    isDown: !1
  };
  return {
    mousePoint: t,
    setStartMousePoint: function(e, s) {
      n.x = e.x, n.y = e.y, n.isDown = typeof s == "boolean" ? s : !1, this.setCurrentMousePoint(e, s);
    },
    setCurrentMousePoint: (e, s) => {
      const i = t.x, r = t.y;
      t.x = e.x, t.y = e.y, t.dx = t.x - i, t.dy = t.y - r, t.dStartX = t.x - n.x, t.dStartY = t.y - n.y, t.isDown = typeof s == "boolean" ? s : !1;
    }
  };
}
function xw(n = document.documentElement) {
  const t = new Qn(), e = new rt(n);
  let s = [];
  const i = lg(), r = i.mousePoint, o = (A) => {
    t.emit("mouseDown", A);
  }, a = (A) => {
    t.emit("mouseUp", A);
  }, h = (A) => {
    r.isDown || i.setCurrentMousePoint(mt(A, n)), t.emit("mouseMove", A);
  }, c = (A) => {
    t.emit("mouseOver", A);
  }, l = (A) => {
    t.emit("mouseOut", A);
  }, u = (A) => {
    t.emit("mouseEnter", A);
  }, d = (A) => {
    t.emit("mouseLeave", A);
  }, f = (A) => {
    t.emit("mouseClick", A);
  }, m = (A) => {
    t.emit("mouseDoubleClick", A);
  }, p = (A) => {
    t.emit("mouseWheel", A);
  }, S = (A) => {
    t.emit("mouseContextMenu", A);
  }, g = (A) => {
    t.emit("touchStart", A);
  }, b = (A) => {
    t.emit("touchEnd", A);
  }, x = (A) => {
    t.emit("touchCancel", A);
  }, w = (A) => {
    const ot = A.changedTouches[0];
    r.isDown || i.setCurrentMousePoint(mt(ot, n)), t.emit("touchMove", A);
  }, C = (A) => {
    t.emit("pointerDown", A);
  }, _ = (A) => {
    t.emit("pointerUp", A);
  }, D = (A) => {
    t.emit("pointerCancel", A);
  }, z = (A) => {
    t.emit("pointerMove", A);
  }, B = (A) => {
    t.emit("pan", A);
  }, G = (A) => {
    t.emit("panStart", A);
  }, V = (A) => {
    t.emit("panMove", A);
  }, j = (A) => {
    t.emit("panEnd", A);
  }, et = (A) => {
    t.emit("panCancel", A);
  }, J = (A) => {
    t.emit("panLeft", A);
  }, Ht = (A) => {
    t.emit("panRight", A);
  }, Dt = (A) => {
    t.emit("panUp", A);
  }, Yt = (A) => {
    t.emit("panDown", A);
  }, Wt = (A) => {
    t.emit("pinch", A);
  }, L = (A) => {
    t.emit("pinchin", A);
  }, k = (A) => {
    t.emit("pinchout", A);
  }, F = (A) => {
    t.emit("press", A);
  }, H = (A) => {
    t.emit("rotate", A);
  }, Ct = (A) => {
    t.emit("swipe", A);
  }, Zt = (A) => {
    t.emit("swipeLeft", A);
  }, rn = (A) => {
    t.emit("swipeRight", A);
  }, on = (A) => {
    t.emit("swipeUp", A);
  }, ut = (A) => {
    t.emit("swipeDown", A);
  }, se = (A) => {
    t.emit("tap", A);
  }, st = (A) => {
    !A.target || n == A.target || n.contains(A.target) || t.emit("tapOutSide", A);
  }, bt = (A) => {
    t.emit("transitionstart", A);
  }, Qe = (A) => {
    t.emit("transitionend", A);
  }, Re = (A) => {
    t.emit("animationstart", A);
  }, Oe = (A) => {
    t.emit("animationend", A);
  };
  let be = {
    ...n.getBoundingClientRect(),
    width: n.offsetWidth,
    height: n.offsetHeight
  };
  return {
    el: n,
    get rect() {
      return be;
    },
    mousePoint: r,
    eb: t,
    start: async function() {
      s.push(Z(n, "mousedown", o)), s.push(Z(n, "mouseup", a)), s.push(Z(n, "mousemove", h)), s.push(Z(n, "mouseover", c)), s.push(Z(n, "mouseout", l)), s.push(Z(n, "mouseenter", u)), s.push(Z(n, "mouseleave", d)), s.push(Z(n, "click", f)), s.push(Z(n, "dblclick", m)), s.push(
        Z(
          n,
          "onwheel" in document.createElement("div") ? "wheel" : document.onmousewheel !== void 0 ? "mousewheel" : "DOMMouseScroll",
          // older Firefox
          p
        )
      ), s.push(Z(n, "contextmenu", S)), s.push(Z(n, "touchstart", g)), s.push(Z(n, "touchend", b)), s.push(Z(n, "touchcancel", x)), s.push(Z(n, "touchmove", w)), s.push(Z(n, "pointerdown", C)), s.push(Z(n, "pointerup", _)), s.push(Z(n, "pointercancel", D)), s.push(Z(n, "pointermove", z)), e.on("pan", B), e.on("panstart", G), e.on("panmove", V), e.on("panend", j), e.on("pancancel", et), e.on("panleft", J), e.on("panright", Ht), e.on("panup", Dt), e.on("pandown", Yt), e.on("pinch", Wt), e.on("pinchin", L), e.on("pinchout", k), e.on("press", F), e.on("rotate", H), e.on("swipe", Ct), e.on("swipeleft", Zt), e.on("swiperight", rn), e.on("swipeup", on), e.on("swipedown", ut), e.on("tap", se), s.push(Z(document, "pointerdown", st)), s.push(Z(n, "transitionstart", bt)), s.push(Z(n, "transitionend", Qe)), s.push(Z(n, "animationstart", Re)), s.push(Z(n, "animationend", Oe));
      const A = await cg(n, (ot) => {
        be = ot, t.emit("resize", ot);
      });
      s.push(A), s.push(
        ug(this, {
          start: (ot) => {
            i.setStartMousePoint(mt(ot, n), !0);
          },
          move: (ot) => {
            i.setCurrentMousePoint(mt(ot, n));
          },
          end: (ot) => {
            i.setCurrentMousePoint(mt(ot, n), !1);
          }
        })
      );
    },
    end: () => {
      t.removeAllListeners(), s.forEach((A) => A()), s = [], e.off("pan", B), e.off("panstart", G), e.off("panmove", V), e.off("panend", j), e.off("pancancel", et), e.off("panleft", J), e.off("panright", Ht), e.off("panup", Dt), e.off("pandown", Yt), e.off("pinch", Wt), e.off("pinchin", L), e.off("pinchout", k), e.off("press", F), e.off("rotate", H), e.off("swipe", Ct), e.off("swipeleft", Zt), e.off("swiperight", rn), e.off("swipeup", on), e.off("swipedown", ut), e.off("tap", se);
    }
  };
}
function ug(n, t) {
  return fg(n, t);
}
function fg(n, t) {
  const e = n.eb, s = (o) => {
    e.on("pointerMove", r), e.on("pointerUp", i), e.on("pointerCancel", i), t?.start?.(o);
  }, i = (o) => {
    e.off("pointerMove", r), e.off("pointerUp", i), e.off("pointerCancel", i), t?.end?.(o);
  }, r = (o) => {
    t?.move?.(o);
  };
  return e.on("pointerDown", s), () => e.off("pointerDown", s);
}
function ww(n, t) {
  const e = n.eb, s = (o) => {
    document.addEventListener("mousemove", r, !1), document.addEventListener("mouseup", i, !1), t?.start?.(o);
  }, i = (o) => {
    document.removeEventListener("mousemove", r, !1), document.removeEventListener("mouseup", i, !1), t?.end?.(o);
  }, r = (o) => {
    t?.move?.(o);
  };
  return e.on("mouseDown", s), () => e.off("mouseDown", s);
}
function bw(n, t) {
  const e = n.eb, s = (o) => {
    e.on("touchMove", r), e.on("touchEnd", i), e.on("touchCancel", i);
    const a = o.changedTouches[0];
    t?.start?.(a);
  }, i = (o) => {
    e.off("touchMove", r), e.off("touchEnd", i), e.off("touchCancel", i);
    const a = o.changedTouches[0];
    t?.end?.(a);
  }, r = (o) => {
    const a = o.changedTouches[0];
    t?.move?.(a);
  };
  return e.on("touchStart", s), () => e.off("touchStart", s);
}
let oo = class {
  x;
  y;
  toX;
  toY;
  constructor(t) {
    this.x = Y(t?.x || 0, 2), this.y = Y(t?.y || 0, 2), this.toX = Y(t?.toX || 0, 2), this.toY = Y(t?.toY || 0, 2);
  }
  // 使用绝对值!
  toSVGPathData() {
    return [["L", this.toX, this.toY]];
  }
  // 使用绝对值!
  toCanvasContext(t) {
    t.lineTo(this.toX, this.toY);
  }
  getBoundingClientRect(t = 2) {
    const e = qt(this.x, this.y, this.toX, this.toY);
    if (e === 0) {
      const s = Math.min(this.x, this.toX), i = Math.min(this.y, this.toY), r = Math.max(this.x, this.toX), o = Math.max(this.y, this.toY);
      return {
        x: s,
        y: i,
        width: r - s,
        height: o - i
      };
    } else {
      const s = Math.sin(e), i = Math.cos(e), r = i * this.x - s * this.y, o = i * this.toX - s * this.toY, a = i * this.y + s * this.x, h = i * this.toY + s * this.toX;
      return {
        x: Y(Math.min(r, o), t),
        y: Y(Math.min(a, h), t),
        width: Y(Math.max(r, o) - Math.min(r, o), t),
        height: Y(Math.max(a, h) - Math.min(a, h), t)
      };
    }
  }
  // t (0.0 to 1.0) : The fraction of the overall duration of the path
  interpolate(t) {
    return {
      x: this.x + t * (this.toX - this.x),
      y: this.y + t * (this.toY - this.y)
    };
  }
  intersection(t) {
    const e = this.x, s = this.y, i = t.toX, r = t.toY, o = this.toX - e, a = t.x - i;
    if (!o && !a)
      return null;
    const h = (this.toY - s) / o, c = (t.y - r) / a;
    if (o) {
      if (!a)
        return { x: i, y: h * (i - e) + s };
    } else
      return { x: e, y: c * (e - i) + r };
    const l = (-c * i + r + h * e - s) / (h - c), u = h * (l - e) + s;
    return isNaN(l) || isNaN(u) ? null : { x: l, y: u };
  }
};
class yr extends oo {
  rx;
  ry;
  xAxisRotate;
  largeArcFlag;
  sweepFlag;
  constructor(t) {
    super(t), this.rx = Y(t.rx, 2), this.ry = Y(t.ry, 2), this.xAxisRotate = typeof t?.xAxisRotate == "number" ? t?.xAxisRotate : 0, this.largeArcFlag = typeof t?.largeArcFlag == "number" ? t?.largeArcFlag : 1, this.sweepFlag = typeof t?.sweepFlag == "number" ? t?.sweepFlag : 1;
  }
  /// A rx,ry xAxisRotate LargeArcFlag,SweepFlag x,y
  toSVGPathData() {
    return [
      [
        "A",
        this.rx,
        this.ry,
        this.xAxisRotate,
        this.largeArcFlag,
        this.sweepFlag,
        this.toX,
        this.toY
      ]
    ];
  }
  toCanvasContext(t) {
    const [e, s, i, r, o, a, h] = this.convert(
      this.x,
      this.y,
      this.toX,
      this.toY,
      this.rx,
      this.ry,
      this.xAxisRotate,
      this.largeArcFlag,
      this.sweepFlag
    );
    t.ellipse(
      e,
      s,
      i,
      r,
      o,
      a,
      h,
      !this.sweepFlag
    );
  }
  convert(t, e, s, i, r, o, a, h, c) {
    const l = a / 180 * Math.PI, u = (t - s) / 2, d = (e - i) / 2, f = Math.cos(l) * u + Math.sin(l) * d, m = -Math.sin(l) * u + Math.cos(l) * d, p = f * f / (r * r) + m * m / (o * o);
    if (p > 1) {
      const V = Math.sqrt(p);
      throw r = V * r, o = V * o, new Error(
        `Radii are too small to build an arc. Correcting them to ${r}/${o}.`
      );
    }
    const S = Math.sqrt(
      (r * r * o * o - r * r * m * m - o * o * f * f) / (r * r * m * m + o * o * f * f)
    ), g = h != c ? 1 : -1, b = g * S * r * m / o, x = g * S * -o * f / r, w = (t + s) / 2, C = (e + i) / 2, _ = Math.cos(l) * b - Math.sin(l) * x + w, D = Math.sin(l) * b + Math.cos(l) * x + C, z = (V, j, et, J) => (V * J >= j * et ? 1 : -1) * Math.acos(
      (V * et + j * J) / (Math.sqrt(V * V + j * j) * Math.sqrt(et * et + J * J))
    ), B = z(1, 0, t - _, e - D) - l, G = z(t - _, e - D, s - _, i - D);
    return [_, D, r, o, l, B, B + G];
  }
}
class dg extends oo {
  cx;
  cy;
  isLineThrough;
  constructor(t) {
    super(t), this.cx = Y(t.cx, 2), this.cy = Y(t.cy, 2), this.isLineThrough = typeof t.isLineThrough == "boolean" ? t.isLineThrough : !1;
  }
  /// Q cx,cy x,y
  /// T x,y
  toSVGPathData() {
    if (this.isLineThrough) {
      const t = this.cx * 2 - (this.x + this.toX) / 2, e = this.cy * 2 - (this.y + this.toY) / 2;
      return [["Q", t, e, this.toX, this.toY]];
    } else
      return [["Q", this.cx, this.cy, this.toX, this.toY]];
  }
  toCanvasContext(t) {
    if (this.isLineThrough) {
      const e = this.cx * 2 - (this.x + this.toX) / 2, s = this.cy * 2 - (this.y + this.toY) / 2;
      t.quadraticCurveTo(e, s, this.toX, this.toY);
    } else
      t.quadraticCurveTo(this.cx, this.cy, this.toX, this.toY);
  }
  getBoundingClientRect(t = 2) {
    const e = [this.x, this.toX], s = [this.y, this.toY];
    let i, r, o, a;
    for (let l = 0; l < 2; ++l)
      i = l == 0 ? this.x - 2 * this.cx + this.toX : this.y - 2 * this.cy + this.toY, r = l == 0 ? -2 * this.x + 2 * this.cx : -2 * this.y + 2 * this.cy, o = l == 0 ? this.x : this.y, Math.abs(i) > 1e-12 && (a = -r / (2 * i), 0 < a && a < 1 && [e, s][l].push(i * a * a + r * a + o));
    const h = { x: Math.min(0, ...e), y: Math.min(0, ...s) }, c = { x: Math.max(0, ...e), y: Math.max(0, ...s) };
    return {
      x: Y(h.x, t),
      y: Y(h.y, t),
      width: Y(c.x - h.x, t),
      height: Y(c.y - h.y, t)
    };
  }
  // t (0.0 to 1.0) : The fraction of the overall duration of the path
  interpolate(t) {
    return {
      x: (1 - t) * (1 - t) * this.x + 2 * (1 - t) * t * this.cx + t * t * this.toX,
      y: (1 - t) * (1 - t) * this.y + 2 * (1 - t) * t * this.cy + t * t * this.toY
    };
  }
}
const mg = dg;
class xt extends oo {
  c1x;
  c1y;
  c2x;
  c2y;
  constructor(t) {
    super(t), this.c1x = Y(t.c1x, 2), this.c1y = Y(t.c1y, 2), this.c2x = Y(t.c2x, 2), this.c2y = Y(t.c2y, 2);
  }
  clone() {
    return new xt({
      x: this.x,
      y: this.y,
      c1x: this.c1x,
      c1y: this.c1y,
      c2x: this.c2x,
      c2y: this.c2y,
      toX: this.toX,
      toY: this.toY
    });
  }
  /// C c1x,c1y c2x,c2y x,y
  /// S c2x,c2y x,y
  toSVGPathData() {
    return [["C", this.c1x, this.c1y, this.c2x, this.c2y, this.toX, this.toY]];
  }
  toCanvasContext(t) {
    t.bezierCurveTo(
      this.c1x,
      this.c1y,
      this.c2x,
      this.c2y,
      this.toX,
      this.toY
    );
  }
  getBoundingClientRect(t = 2) {
    let e = this.c2x - 2 * this.c1x + this.x - (this.toX - 2 * this.c2x + this.c1x), s = 2 * (this.c1x - this.x) - 2 * (this.c2x - this.c1x), i = this.x - this.c1x, r = (-s + Math.sqrt(s * s - 4 * e * i)) / 2 / e, o = (-s - Math.sqrt(s * s - 4 * e * i)) / 2 / e;
    const a = [this.y, this.toY], h = [this.x, this.toX];
    let c;
    const l = [];
    Math.abs(r) > 1e12 && (r = 0.5), Math.abs(o) > 1e12 && (o = 0.5), r >= 0 && r <= 1 && (c = this.interpolate(r), h.push(c.x), a.push(c.y), l.push({ X: c.x, Y: c.y })), o >= 0 && o <= 1 && (c = this.interpolate(o), h.push(c.x), a.push(c.y), l.push({ X: c.x, Y: c.y })), e = this.c2y - 2 * this.c1y + this.y - (this.toY - 2 * this.c2y + this.c1y), s = 2 * (this.c1y - this.y) - 2 * (this.c2y - this.c1y), i = this.y - this.c1y, r = (-s + Math.sqrt(s * s - 4 * e * i)) / 2 / e, o = (-s - Math.sqrt(s * s - 4 * e * i)) / 2 / e, Math.abs(r) > 1e12 && (r = 0.5), Math.abs(o) > 1e12 && (o = 0.5), r >= 0 && r <= 1 && (c = this.interpolate(r), h.push(c.x), a.push(c.y), l.push({ X: c.x, Y: c.y })), o >= 0 && o <= 1 && (c = this.interpolate(o), h.push(c.x), a.push(c.y), l.push({ X: c.x, Y: c.y }));
    const u = [], d = l.length;
    for (let p = 0; p < d; p++) {
      for (let S = p + 1; S < d; S++)
        l[p].X === l[S].X && l[p].Y === l[S].Y && (S = ++p);
      u.push({ X: l[p].X, Y: l[p].Y });
    }
    const f = { x: Math.min(...h), y: Math.min(...a) }, m = { x: Math.max(...h), y: Math.max(...a) };
    return {
      x: Y(f.x, t),
      y: Y(f.y, t),
      width: Y(m.x - f.x, t),
      height: Y(m.y - f.y, t),
      dots: u
      // these are the extrema points
    };
  }
  static base3(t, e, s, i, r) {
    const o = -3 * e + 9 * s - 9 * i + 3 * r, a = t * o + 6 * e - 12 * s + 6 * i;
    return t * a - 3 * e + 3 * s;
  }
  /**
   * Based on snap.svg bezlen() function
   * like getTotalLength(), approximate a cubic bézier length
   * https://github.com/adobe-webplatform/Snap.svg/blob/master/dist/snap.svg.js#L5786
   */
  static bezlen(t, e, s, i, r, o, a, h, c = 1) {
    c = Math.max(0, Math.min(c, 1));
    const l = c / 2, u = [
      -0.1252,
      0.1252,
      -0.3678,
      0.3678,
      -0.5873,
      0.5873,
      -0.7699,
      0.7699,
      -0.9041,
      0.9041,
      -0.9816,
      0.9816
    ], d = [
      0.2491,
      0.2491,
      0.2335,
      0.2335,
      0.2032,
      0.2032,
      0.1601,
      0.1601,
      0.1069,
      0.1069,
      0.0472,
      0.0472
    ];
    let f = 0;
    for (let m = 0; m < 12; m++) {
      const p = l * u[m] + l, S = xt.base3(p, t, s, r, a), g = xt.base3(p, e, i, o, h);
      f += d[m] * Math.sqrt(S * S + g * g);
    }
    return l * f;
  }
  // returns length in pixels
  length(t = 1) {
    return xt.bezlen(
      this.x,
      this.y,
      this.c1x,
      this.c1y,
      this.c2x,
      this.c2y,
      this.toX,
      this.toY,
      t
    );
  }
  // Find dot coordinates on the given cubic bezier curve at the given length
  getPointAtSegmentLength(t) {
    const e = this.getTatLen(t), s = 1 - e, i = Math.pow(s, 3), r = Math.pow(s, 2), o = e * e, a = o * e, h = i * this.x + r * 3 * e * this.c1x + s * 3 * e * e * this.c2x + a * this.toX, c = i * this.y + r * 3 * e * this.c1y + s * 3 * e * e * this.c2y + a * this.toY, l = this.x + 2 * e * (this.c1x - this.x) + o * (this.c2x - 2 * this.c1x + this.x), u = this.y + 2 * e * (this.c1y - this.y) + o * (this.c2y - 2 * this.c1y + this.y), d = this.c1x + 2 * e * (this.c2x - this.c1x) + o * (this.toX - 2 * this.c2x + this.c1x), f = this.c1y + 2 * e * (this.c2y - this.c1y) + o * (this.toY - 2 * this.c2y + this.c1y), m = s * this.x + e * this.c1x, p = s * this.y + e * this.c1y, S = s * this.c2x + e * this.toX, g = s * this.c2y + e * this.toY, b = 90 - Math.atan2(l - d, u - f) * 180 / Math.PI;
    return {
      x: h,
      // x coordinate of the point
      y: c,
      // y coordinate of the point
      m: {
        x: l,
        // x coordinate of the left anchor
        y: u
        // y coordinate of the left anchor
      },
      n: {
        x: d,
        // x coordinate of the right anchor
        y: f
        // y coordinate of the right anchor
      },
      start: {
        x: m,
        // x coordinate of the start of the curve
        y: p
        // y coordinate of the start of the curve
      },
      end: {
        x: S,
        //  x coordinate of the end of the curve
        y: g
        // y coordinate of the end of the curve
      },
      alpha: b
      // degree: angle of the curve derivative at the point
    };
  }
  // 将 length 转为 t (0.0 to 1.0)
  getTatLen(t) {
    const e = this.x, s = this.y, i = this.c1x, r = this.c1y, o = this.c2x, a = this.c2y, h = this.toX, c = this.toY;
    if (t < 0 || xt.bezlen(e, s, i, r, o, a, h, c) < t)
      return 0;
    const l = 1;
    let u = l / 2, d = l - u, f = xt.bezlen(e, s, i, r, o, a, h, c, d);
    for (; Math.abs(f - t) > 0.01; )
      u /= 2, d += (f < t ? 1 : -1) * u, f = xt.bezlen(e, s, i, r, o, a, h, c, d);
    return d;
  }
  // t (0.0 to 1.0) : The fraction of the overall duration of the path
  interpolate(t) {
    return {
      x: Math.pow(1 - t, 3) * this.x + 3 * Math.pow(1 - t, 2) * t * this.c1x + 3 * Math.pow(1 - t, 1) * Math.pow(t, 2) * this.c2x + Math.pow(t, 3) * this.toX,
      y: Math.pow(1 - t, 3) * this.y + 3 * Math.pow(1 - t, 2) * t * this.c1y + 3 * Math.pow(1 - t, 1) * Math.pow(t, 2) * this.c2y + Math.pow(t, 3) * this.toY
    };
  }
}
const Ys = Math.PI * 2;
function za(n, t, e, s) {
  const i = n * s - t * e < 0 ? -1 : 1;
  let r = n * e + t * s;
  return r > 1 && (r = 1), r < -1 && (r = -1), i * Math.acos(r);
}
function pg(n, t, e, s, i, r, o, a, h, c) {
  const l = c * (n - e) / 2 + h * (t - s) / 2, u = -h * (n - e) / 2 + c * (t - s) / 2, d = o * o, f = a * a, m = l * l, p = u * u;
  let S = d * f - d * p - f * m;
  S < 0 && (S = 0), S /= d * p + f * m, S = Math.sqrt(S) * (i === r ? -1 : 1);
  const g = S * o / a * u, b = S * -a / o * l, x = c * g - h * b + (n + e) / 2, w = h * g + c * b + (t + s) / 2, C = (l - g) / o, _ = (u - b) / a, D = (-l - g) / o, z = (-u - b) / a, B = za(1, 0, C, _);
  let G = za(C, _, D, z);
  return r === 0 && G > 0 && (G -= Ys), r === 1 && G < 0 && (G += Ys), [x, w, B, G];
}
function gg(n, t) {
  const e = 1.3333333333333333 * Math.tan(t / 4), s = Math.cos(n), i = Math.sin(n), r = Math.cos(n + t), o = Math.sin(n + t);
  return [
    s,
    i,
    s - i * e,
    i + s * e,
    r + o * e,
    o - r * e,
    r,
    o
  ];
}
function il(n, t, e, s, i, r, o, a, h) {
  const c = Math.sin(h * Ys / 360), l = Math.cos(h * Ys / 360), u = l * (n - e) / 2 + c * (t - s) / 2, d = -c * (n - e) / 2 + l * (t - s) / 2;
  if (u === 0 && d === 0)
    return [];
  if (o === 0 || a === 0)
    return [];
  o = Math.abs(o), a = Math.abs(a);
  const f = u * u / (o * o) + d * d / (a * a);
  f > 1 && (o *= Math.sqrt(f), a *= Math.sqrt(f));
  const m = pg(n, t, e, s, i, r, o, a, c, l), p = [];
  let S = m[2], g = m[3];
  const b = Math.max(Math.ceil(Math.abs(g) / (Ys / 4)), 1);
  g /= b;
  for (let x = 0; x < b; x++)
    p.push(gg(S, g)), S += g;
  return p.map((x) => {
    for (let w = 0; w < x.length; w += 2) {
      let C = x[w + 0], _ = x[w + 1];
      C *= o, _ *= a;
      const D = l * C - c * _, z = c * C + l * _;
      x[w + 0] = D + m[0], x[w + 1] = z + m[1];
    }
    return x;
  });
}
function xr(n, t, e, s, i, r) {
  return [
    n / 3 + 2 / 3 * e,
    t / 3 + 2 / 3 * s,
    i / 3 + 2 / 3 * e,
    r / 3 + 2 / 3 * s,
    i,
    r
  ];
}
function Ls(n, t, e, s) {
  return [n, t, e, s, e, s];
}
const En = {
  a: 7,
  // A rx,ry xAxisRotate LargeArcFlag,SweepFlag x,y
  c: 6,
  // C c1x,c1y c2x,c2y x,y
  s: 4,
  // S c2x,c2y x,y
  q: 4,
  // Q cx,cy x,y
  t: 2,
  // T x,y
  m: 2,
  // M x,y
  l: 2,
  // L x,y
  h: 1,
  // H x
  v: 1,
  // V y
  z: 0
  // Z
  // r: 4
};
function We(n = "path") {
  return document.createElementNS.call(
    document,
    "http://www.w3.org/2000/svg",
    n
  );
}
function rl() {
  return We("path");
}
const yg = (n) => n instanceof SVGElement && n.tagName === "path";
function xg(n, t = "shape") {
  return pr(
    Vh(n),
    `${t}.svg`
  );
}
function ol(n) {
  return typeof n != "string" ? !1 : (n = n.trim(), /^[mlhvzaqtcs]\s*[-+.0-9][^mlhvzaqtcs]+/i.test(n) && /[\dz]$/i.test(n));
}
function wg(n) {
  return n.map((t) => {
    if (!t[0])
      return "";
    switch (t[0].toLowerCase()) {
      case "a":
        return `${t[0]} ${t[1]},${t[2]} ${t[3]} ${t[4]},${t[5]} ${t[6]},${t[7]}`;
      case "c":
        return `${t[0]} ${t[1]},${t[2]} ${t[3]},${t[4]} ${t[5]},${t[6]}`;
      case "s":
      case "q":
        return `${t[0]} ${t[1]},${t[2]} ${t[3]},${t[4]}`;
      default:
        return t[0] + " " + t.slice(1).join(",");
    }
  }).join(" ");
}
function al(n) {
  const t = [];
  return ol(n) && n.replace(
    /([mlhvzaqtcs])([^mlhvzaqtcs]*)/gi,
    (e, s, i) => {
      let r = s.toLowerCase();
      const o = Ir(i);
      for (r == "m" && o.length > En[r] && (t.push([s, ...o.splice(0, En[r])]), r = "l", s = s == "m" ? "l" : "L"); o.length; ) {
        if (o.length < En[r])
          throw new Error(
            `parseSVGPath substring:{ ${e} } command:{ ${s} } args:{ ${o} }`
          );
        t.push([
          s,
          ...o.splice(0, En[r])
        ]);
      }
      return r == "z" && t.push([s]), "";
    }
  ), t;
}
function hl(n) {
  let t = 0, e = 0, s = 0, i = 0;
  return n.map(function(r) {
    const o = r[0], a = o.toUpperCase();
    if (o != a)
      switch (r[0] = a, o) {
        case "a":
          r[6] += s, r[7] += i;
          break;
        case "v":
          r[1] += i;
          break;
        case "h":
          r[1] += s;
          break;
        default:
          for (let h = 1; h < r.length; )
            r[h++] += s, r[h++] += i;
      }
    switch (a) {
      case "Z":
        s = t, i = e;
        break;
      case "H":
        s = r[1];
        break;
      case "V":
        i = r[1];
        break;
      case "M":
        s = t = r[1], i = e = r[2];
        break;
      default:
        s = r[r.length - 2], i = r[r.length - 1];
    }
    return r;
  });
}
function bg(n) {
  const t = [];
  let e = 0, s = 0, i = 0, r = 0, o = 0, a = 0, h = 0, c = 0, l;
  for (let u = 0, d = n.length; u < d; u++) {
    let f = n[u];
    const m = f[0];
    switch (m) {
      case "M":
        e = f[1], s = f[2];
        break;
      case "A":
        const p = il(
          i,
          r,
          f[6],
          f[7],
          f[4],
          f[5],
          f[1],
          f[2],
          f[3]
        );
        if (!p.length)
          continue;
        p.forEach((b, x) => {
          const [w, C, _, D, z, B, G, V] = b;
          f = ["C", _, D, z, B, G, V], x < p.length - 1 && t.push(f);
        });
        break;
      case "S":
        let S = i, g = r;
        (l == "C" || l == "S") && (S += S - h, g += g - c), f = ["C", S, g, f[1], f[2], f[3], f[4]];
        break;
      case "T":
        l == "Q" || l == "T" ? (o = i * 2 - o, a = r * 2 - a) : (o = i, a = r), f = ["C", ...xr(i, r, o, a, f[1], f[2])];
        break;
      case "Q":
        o = f[1], a = f[2], f = ["C", ...xr(i, r, f[1], f[2], f[3], f[4])];
        break;
      case "L":
        f = ["C", ...Ls(i, r, f[1], f[2])];
        break;
      case "H":
        f = ["C", ...Ls(i, r, f[1], r)];
        break;
      case "V":
        f = ["C", ...Ls(i, r, i, f[1])];
        break;
      case "Z":
        f = ["C", ...Ls(i, r, e, s)];
        break;
    }
    l = m, i = f[f.length - 2], r = f[f.length - 1], f.length > 4 ? (h = f[f.length - 4], c = f[f.length - 3]) : (h = i, c = r), t.push(f);
  }
  return t;
}
class jn {
  video;
  constructor(t) {
    this.video = t;
  }
  setSrcObject(t) {
    this.video.addEventListener("loadedmetadata", (e) => {
      e.target;
    }), this.video.srcObject = t;
  }
  captureWebCamera() {
    navigator.mediaDevices.getUserMedia({
      video: !0
    }).then((t) => {
      this.setSrcObject(t);
    });
  }
  // feature test for native video media switching media
  static async videoMediaChangeSupport() {
    return new Promise((t) => {
      const e = document.createElement("iframe"), s = document.createElement("video"), i = document.createElement("source"), r = new MediaSource();
      r.addEventListener("sourceopen", () => t(!0)), i.src = URL.createObjectURL(r), i.media = "(min-width:10px)", s.append(i), e.width = "5", e.style.cssText = "position: absolute; visibility: hidden;", document.documentElement.append(e), e.contentDocument?.body.append(s), setTimeout(() => {
        e.width = "15";
      }), setTimeout(() => {
        e.remove(), t(!1);
      }, 1e3);
    });
  }
  static tryAutoPlayOrAutoPlayAfterClick(t) {
    return new Promise((e) => {
      t.play().then(() => {
        t.autoplay = !0, e(!0);
      }).catch(() => {
        jn.setAutoPlayWhenClick(t), e(!1);
      });
    });
  }
  // 监听页面的点击事件，一旦点过了就能autoplay了
  static setAutoPlayWhenClick(t) {
    function e() {
      t.autoplay = !0, t.play(), document.removeEventListener("click", e), document.removeEventListener("touchend", e);
    }
    document.addEventListener("click", e), document.addEventListener("touchend", e);
  }
}
class cl extends Qn {
  source;
  raw = "";
  mode = "text";
  tagname = "";
  nodename = "";
  textchunk = "";
  entity = "";
  quote = "";
  attrs = {};
  constructor(t) {
    super(), this.source = t;
  }
  parse() {
    const t = yu(this.source);
    if (t === 0) {
      this.emit("finish");
      return;
    }
    let e, s, i = Lo(this.source, 0);
    for (let r = 1; r < t; r++)
      e = s, s = i, i = Lo(this.source, r), this.raw += s, s && this.step(s, i, e);
    i && this.step(i, void 0, s), this.emit("finish");
  }
  step(t, e, s) {
    t == `
` && this.emit("newline"), this.act(t, e, s);
  }
  act(t, e, s) {
    switch (this.mode) {
      case "text":
        switch (t) {
          case "<":
          case "eof":
            this.nodename = "", this.attrs = {}, this.mode = "tag name start", this.raw = this.raw.slice(0, -1), this.textchunk && this.emit("text", this.textchunk), this.raw += t, this.textchunk = "";
            break;
          case "&":
            this.mode = "entity", this.entity = "";
            break;
          default:
            this.textchunk += t;
            break;
        }
        break;
      case "entity":
        fe("whitespace", t) ? (this.textchunk += Na(this.entity), this.mode = "text") : t == ";" ? (this.textchunk += Na(this.entity + t), this.mode = "text") : this.entity += t;
        break;
      case "special":
        if (s == "!" && t == "-" && e == "-") {
          this.mode = "comment start";
          break;
        }
        if (this.textchunk == "[CDATA" && t == "[") {
          this.mode = "cdata", this.textchunk = "";
          break;
        }
        if (t == ">" || t == "eof") {
          this.emit("special", this.textchunk), this.mode = "text", this.textchunk = "";
          break;
        }
        this.textchunk += t;
        break;
      case "cdata":
        if (s == "]" && t == "]" && e == ">") {
          this.mode = "cdata end", this.textchunk = this.textchunk.slice(0, -1);
          break;
        }
        t == "eof" && (this.mode = "cdata end", this.act(t, e, s)), this.textchunk += t;
        break;
      case "cdata end":
        this.emit("cdata", this.textchunk), this.textchunk = "", this.mode = "text";
        break;
      case "comment start":
        e == ">" || t == "eof" ? (this.emit("comment", ""), this.mode = "skip") : this.mode = "comment";
        break;
      case "skip":
        this.mode = "text";
        break;
      case "comment":
        t == "-" && s == "-" && e == ">" ? (this.mode = "comment end", this.textchunk = this.textchunk.slice(0, -1)) : t == "eof" ? this.emit("comment", this.textchunk) : this.textchunk += t;
        break;
      case "comment end":
        this.emit("comment", this.textchunk), this.textchunk = "", this.mode = "text";
        break;
      case "declaration":
        if (t == "?" && e == ">") {
          this.mode = "declaration end";
          break;
        }
        t == "eof" && this.emit("comment", this.textchunk), this.textchunk += t;
        break;
      case "declaration end":
        this.emit("comment", this.textchunk), this.textchunk = "", this.mode = "text";
        break;
      case "tag name start":
        if (t == "eof") {
          this.emit("text", "<");
          break;
        }
        if (!fe("whitespace", t)) {
          if (this.mode = "tag name", t == "/") {
            this.mode = "close tag name start";
            break;
          } else if (t == "!") {
            this.mode = "special", this.textchunk = "";
            break;
          } else if (t == "?") {
            this.mode = "declaration";
            break;
          }
          this.act(t, e, s);
        }
        break;
      case "close tag name start":
        fe("whitespace", t) || (this.mode = "close tag name", this.tagname = "", this.nodename = "", this.act(t, e, s));
        break;
      case "close tag name":
        if (fe("whitespace", t))
          this.tagname = this.nodename;
        else
          switch (t) {
            case ">":
              this.emit("/tag", this.tagname || this.nodename, this.attrs), this.mode = "text";
              break;
            default:
              !this.tagname && (this.nodename += t);
              break;
          }
        break;
      case "tag name":
        if (fe("whitespace", t))
          this.tagname = this.nodename, this.nodename = "", this.mode = "attr start";
        else
          switch (t) {
            case ">":
              this.emit("tag", this.nodename, this.attrs), this.mode = "text";
              break;
            case "/":
              this.raw += e, this.emit("tag", this.nodename, this.attrs), this.emit("/tag", this.nodename, this.attrs), this.mode = "skip";
              break;
            default:
              this.nodename += t;
              break;
          }
        break;
      case "attr start":
        fe("whitespace", t) || (this.mode = "attr", this.nodename = "", this.act(t, e, s));
        break;
      case "attr":
        if (fe("whitespace", t) || t == "=")
          this.attrs[this.nodename] = "", this.mode = "attr value start";
        else
          switch (t) {
            case ">":
              this.nodename == "/" ? (delete this.attrs["/"], this.emit("tag", this.tagname, this.attrs), this.emit("/tag", this.tagname, this.attrs)) : (this.nodename && (this.attrs[this.nodename] = ""), this.emit("tag", this.tagname, this.attrs)), this.mode = "text";
              break;
            default:
              this.nodename += t;
              break;
          }
        break;
      case "attr value start":
        if (!fe("whitespace", t)) {
          if (this.mode = "attr value", this.quote = "", t == "'" || t == '"') {
            this.quote = t;
            return;
          }
          this.act(t, e, s);
        }
        break;
      case "attr value":
        if (fe("whitespace", t) && !this.quote)
          this.mode = "attr start";
        else if (t == ">" && !this.quote)
          this.emit("tag", this.tagname, this.attrs), this.mode = "text";
        else
          switch (t) {
            case '"':
            case "'":
              this.quote == t && s != "\\" && (this.mode = "attr start");
              break;
            default:
              this.attrs[this.nodename] += t;
              break;
          }
        break;
    }
  }
}
function Na(n) {
  const t = {
    lt: 60,
    "lt;": 60,
    "AMP;": 38,
    AMP: 38,
    "GT;": 62,
    GT: 62,
    "QUOT;": 34,
    QUOT: 34,
    "apos;": 39,
    "bull;": 8226,
    "bullet;": 8226,
    "copy;": 169,
    copy: 169,
    "deg;": 176,
    deg: 176
  };
  let e;
  return n.charAt(0) == "#" ? n.charAt(1).toLowerCase() == "x" ? e = parseInt(n.substring(2), 16) : e = parseInt(n.substring(1), 10) : e = t[n], e ? String.fromCharCode(e) : "&" + n;
}
var Ya = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
function ll(n, t = {}) {
  var e = 1, s = 1;
  function i(L) {
    var k = L.match(/\n/g);
    k && (e += k.length);
    var F = L.lastIndexOf(`
`);
    s = ~F ? L.length - F : s + L.length;
  }
  function r() {
    var L = { line: e, column: s };
    return function(k) {
      return k.position = new o(L), m(), k;
    };
  }
  function o(L) {
    this.start = L, this.end = { line: e, column: s }, this.source = t.source;
  }
  o.prototype.content = n;
  var a = [];
  function h(L) {
    var k = new Error(
      t.source + ":" + e + ":" + s + ": " + L
    );
    if (k.reason = L, k.filename = t.source, k.line = e, k.column = s, k.source = n, t.silent)
      a.push(k);
    else
      throw k;
  }
  function c() {
    var L = d();
    return {
      type: "stylesheet",
      stylesheet: {
        source: t.source,
        rules: L,
        parsingErrors: a
      }
    };
  }
  function l() {
    return f(/^{\s*/);
  }
  function u() {
    return f(/^}/);
  }
  function d() {
    var L, k = [];
    for (m(), p(k); n.length && n.charAt(0) != "}" && (L = Yt() || Wt()); )
      L !== !1 && (k.push(L), p(k));
    return k;
  }
  function f(L) {
    var k = L.exec(n);
    if (k) {
      var F = k[0];
      return i(F), n = n.slice(F.length), k;
    }
  }
  function m() {
    f(/^\s*/);
  }
  function p(L) {
    var k;
    for (L = L || []; k = S(); )
      k !== !1 && L.push(k);
    return L;
  }
  function S() {
    var L = r();
    if (!(n.charAt(0) != "/" || n.charAt(1) != "*")) {
      for (var k = 2; n.charAt(k) != "" && (n.charAt(k) != "*" || n.charAt(k + 1) != "/"); )
        ++k;
      if (k += 2, n.charAt(k - 1) === "")
        return h("End of comment missing");
      var F = n.slice(2, k - 2);
      return s += 2, i(F), n = n.slice(k), s += 2, L({
        type: "comment",
        comment: F
      });
    }
  }
  function g() {
    var L = f(/^([^{]+)/);
    if (L)
      return de(L[0]).replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*\/+/g, "").replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function(k) {
        return k.replace(/,/g, "‌");
      }).split(/\s*(?![^(]*\)),\s*/).map(function(k) {
        return k.replace(/\u200C/g, ",");
      });
  }
  function b() {
    var L = r(), k = f(/^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/);
    if (k) {
      if (k = de(k[0]), !f(/^:\s*/))
        return h("property missing ':'");
      var F = f(/^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/), H = L({
        type: "declaration",
        property: k.replace(Ya, ""),
        value: F ? de(F[0]).replace(Ya, "") : ""
      });
      return f(/^[;\s]*/), H;
    }
  }
  function x() {
    var L = [];
    if (!l())
      return h("missing '{'");
    p(L);
    for (var k; k = b(); )
      k !== !1 && (L.push(k), p(L));
    return u() ? L : h("missing '}'");
  }
  function w() {
    for (var L, k = [], F = r(); L = f(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/); )
      k.push(L[1]), f(/^,\s*/);
    if (k.length)
      return F({
        type: "keyframe",
        values: k,
        declarations: x()
      });
  }
  function C() {
    var L = r(), k = f(/^@([-\w]+)?keyframes\s*/);
    if (k) {
      var F = k[1];
      if (k = f(/^([-\w]+)\s*/), !k)
        return h("@keyframes missing name");
      var H = k[1];
      if (!l())
        return h("@keyframes missing '{'");
      for (var Ct, Zt = p(); Ct = w(); )
        Zt.push(Ct), Zt = Zt.concat(p());
      return u() ? L({
        type: "keyframes",
        name: H,
        vendor: F,
        keyframes: Zt
      }) : h("@keyframes missing '}'");
    }
  }
  function _() {
    var L = r(), k = f(/^@supports *([^{]+)/);
    if (k) {
      var F = de(k[1]);
      if (!l())
        return h("@supports missing '{'");
      var H = p().concat(d());
      return u() ? L({
        type: "supports",
        supports: F,
        rules: H
      }) : h("@supports missing '}'");
    }
  }
  function D() {
    var L = r(), k = f(/^@host\s*/);
    if (k) {
      if (!l())
        return h("@host missing '{'");
      var F = p().concat(d());
      return u() ? L({
        type: "host",
        rules: F
      }) : h("@host missing '}'");
    }
  }
  function z() {
    var L = r(), k = f(/^@media *([^{]+)/);
    if (k) {
      var F = de(k[1]);
      if (!l())
        return h("@media missing '{'");
      var H = p().concat(d());
      return u() ? L({
        type: "media",
        media: F,
        rules: H
      }) : h("@media missing '}'");
    }
  }
  function B() {
    var L = r(), k = f(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
    if (k)
      return L({
        type: "custom-media",
        name: de(k[1]),
        media: de(k[2])
      });
  }
  function G() {
    var L = r(), k = f(/^@page */);
    if (k) {
      var F = g() || [];
      if (!l())
        return h("@page missing '{'");
      for (var H = p(), Ct; Ct = b(); )
        H.push(Ct), H = H.concat(p());
      return u() ? L({
        type: "page",
        selectors: F,
        declarations: H
      }) : h("@page missing '}'");
    }
  }
  function V() {
    var L = r(), k = f(/^@([-\w]+)?document *([^{]+)/);
    if (k) {
      var F = de(k[1]), H = de(k[2]);
      if (!l())
        return h("@document missing '{'");
      var Ct = p().concat(d());
      return u() ? L({
        type: "document",
        document: H,
        vendor: F,
        rules: Ct
      }) : h("@document missing '}'");
    }
  }
  function j() {
    var L = r(), k = f(/^@font-face\s*/);
    if (k) {
      if (!l())
        return h("@font-face missing '{'");
      for (var F = p(), H; H = b(); )
        F.push(H), F = F.concat(p());
      return u() ? L({
        type: "font-face",
        declarations: F
      }) : h("@font-face missing '}'");
    }
  }
  var et = Dt("import"), J = Dt("charset"), Ht = Dt("namespace");
  function Dt(L) {
    var k = new RegExp("^@" + L + "\\s*([^;]+);");
    return function() {
      var F = r(), H = f(k);
      if (H) {
        var Ct = { type: L };
        return Ct[L] = H[1].trim(), F(Ct);
      }
    };
  }
  function Yt() {
    if (n[0] == "@")
      return C() || z() || B() || _() || et() || J() || Ht() || V() || G() || D() || j();
  }
  function Wt() {
    var L = r(), k = g();
    return k ? (p(), L({
      type: "rule",
      selectors: k,
      declarations: x()
    })) : h("selector missing");
  }
  return wr(c());
}
function de(n) {
  return n ? n.replace(/^\s+|\s+$/g, "") : "";
}
function wr(n, t) {
  var e = n && typeof n.type == "string", s = e ? n : t;
  for (var i in n) {
    var r = n[i];
    Array.isArray(r) ? r.forEach(function(o) {
      wr(o, s);
    }) : r && typeof r == "object" && wr(r, s);
  }
  return e && Object.defineProperty(n, "parent", {
    configurable: !0,
    writable: !0,
    enumerable: !1,
    value: t || null
  }), n;
}
let vg = class extends cl {
  currentItem = {};
  items = [];
  groups = [];
  globalStyles = {};
  grad = {};
  idtops = {};
  text = "";
  constructor(t) {
    super(t), this.on("tag", (e, s) => {
      switch (this.text = "", this.currentItem = { type: e }, e) {
        case "g":
          this.groups.push(this.currentItem);
          break;
      }
      this.processAttrs(e, s);
    }), this.on("text", (e) => {
      if (this.currentItem.type == "style") {
        try {
          const s = ll(e);
          for (const i of s.stylesheet.rules)
            for (const r of i.declarations)
              for (const o of i.selectors)
                this.globalStyles[o] = this.globalStyles[o] || [], this.globalStyles[o].push(
                  `${r.property}:${r.value}`
                );
        } catch {
          console.error("CAN'T parse css text: " + e);
        }
        return;
      }
      this.text += e;
    }), this.on("/tag", (e, s) => {
      let i = this.groups.length;
      for (; i--; )
        if (this.groups[i] != this.currentItem) {
          let r = "", o = "";
          for (const a in this.groups[i])
            a == "transform" ? r = this.groups[i].transform : a == "class" && this.globalStyles["." + this.groups[i][a]] ? o = this.globalStyles["." + this.groups[i][a]].join(";") + ";" + o : a == "id" && this.globalStyles["#" + this.groups[i][a]] ? o = this.globalStyles["#" + this.groups[i][a]].join(";") + ";" + o : typeof this.currentItem[a] > "u" && (this.currentItem[a] = this.groups[i][a]);
          typeof this.currentItem.transform > "u" ? this.currentItem.transform = r : this.currentItem.transform += " " + r, typeof this.currentItem.style > "u" ? this.currentItem.style = o : this.currentItem.style = o + this.currentItem.style, this.currentItem.class && this.globalStyles["." + this.currentItem.class] ? this.currentItem.style = this.globalStyles["." + this.currentItem.class].join(";") + ";" + this.currentItem.style : this.currentItem.id && this.globalStyles["#" + this.currentItem.id] && (this.currentItem.style = this.globalStyles["#" + this.currentItem.id].join(";") + ";" + this.currentItem.style), Yi(
            this.currentItem.style,
            this.currentItem,
            Bi
          );
        }
      switch (this.processAttrs(e, s), e) {
        case "g":
          this.groups.pop();
          break;
        case "cirlce":
          this.addToItems();
          break;
        case "ellipse":
          this.addToItems();
          break;
        case "polygon":
          this.addToItems();
          break;
        case "path":
          this.addToItems();
          break;
        case "line":
          this.addToItems();
          break;
        case "rect":
          this.addToItems();
          break;
        case "image":
          this.addToItems();
          break;
        case "text":
          this.currentItem.text = this.text, this.currentItem["text-anchor"] = this.currentItem["text-anchor"] || "start", this.addToItems();
          break;
      }
    }), this.on("finish", () => {
      this.emit("result", this.items);
    });
  }
  parse() {
    return super.parse(), this.items;
  }
  processAttrs(t, e) {
    let s = [], i;
    switch (t) {
      case "svg":
        let r = "", o = "";
        if (e.width && e.height)
          r = e.width, o = e.height;
        else if (e.viewBox) {
          const a = e.viewBox.split(/\s+/gi);
          a.length == 4 && (r = String(parseFloat(a[2]) - parseFloat(a[0])), o = String(parseFloat(a[3]) - parseFloat(a[1])));
        }
        r && o && this.items.push({
          type: "viewbox",
          width: r,
          height: o
        });
        break;
      case "line":
        typeof e.x1 == "number" && typeof e.y1 == "number" && typeof e.x2 == "number" && typeof e.y2 == "number" && (this.currentItem.path = "M" + [e.x1, e.y1, e.x2, e.y2]);
        break;
      case "stop":
        i = {}, e.style && Yi(e.style, i), i.offset = i.offset || e.offset, i.color = i["stop-color"] || e["stop-color"], i.opacity = i["stop-opacity"] || e["stop-opacity"], ~(i.offset + "").indexOf("%") ? i.offset = parseFloat(i.offset) : i.offset = parseFloat(i.offset) * 100, i.offset = +i.offset.toFixed(2), this.grad.stops.push(i);
        break;
      case "linearGradient":
        this.grad.angle = (360 + br(
          parseFloat(e.x1),
          parseFloat(e.y1),
          parseFloat(e.x2),
          parseFloat(e.y2),
          parseFloat(e.x1) + 100,
          parseFloat(e.y1)
        )).toFixed(2), s = [this.grad.angle];
        for (let a = 0, h = this.grad.stops.length; a < h; a++)
          i = this.grad.stops[a], a && a != h - 1 ? s.push(i.color + ":" + i.offset) : s.push(i.color);
        this.idtops[this.grad.id] = s.join("-"), this.items.forEach((a) => {
          a.fillid == this.grad.id && (a.fill = this.idtops[this.grad.id]);
        });
        break;
      case "radialGradient":
        s = [];
        for (let a = 0, h = this.grad.stops.length; a < h; a++)
          i = this.grad.stops[a], a && a != h - 1 ? s.push(i.color + ":" + i.offset) : s.push(i.color);
        this.idtops[this.grad.id] = s.join("-"), this.items.forEach((a) => {
          a.fillid == this.grad.id && (a.fill = this.idtops[this.grad.id]);
        });
        break;
    }
    for (const r in e) {
      const o = e[r];
      if (Bi.includes(r) && (this.currentItem[r] = o), r === "id" && (this.currentItem.type === "linearGradient" && (this.grad = {
        id: r,
        stops: []
      }), this.currentItem.type === "radialGradient" && (this.grad = {
        id: r,
        stops: []
      })), r === "style" && Yi(o, this.currentItem, Bi), r === "transform" && (this.currentItem.transform = o + (this.currentItem.transform || " ")), r === "fill") {
        const a = o.match(/url\(#([^)]+)\)/);
        if (a) {
          const h = a[1];
          this.currentItem.fillid = h, this.idtops[h] && (this.currentItem.fill = this.idtops[h]);
        }
      }
      r === "points" && this.currentItem.type == "polygon" && (this.currentItem.path = "M" + o + "z"), r === "d" && this.currentItem.type == "path" && (this.currentItem.path = o), r === "xlink:href" && this.currentItem.type == "image" && (this.currentItem.src = o);
    }
  }
  addToItems() {
    this.items.push(this.currentItem);
  }
};
function br(n, t, e, s, i, r) {
  if (typeof i > "u" || typeof r > "u") {
    const o = n - e, a = t - s;
    return !o && !a ? 0 : (180 + Math.atan2(-a, -o) * 180 / Math.PI + 360) % 360;
  } else
    return br(n, t, i, r) - br(e, s, i, r);
}
function Yi(n, t, e) {
  const s = (n + "").split(";"), i = /^\s+|\s+$/g;
  for (let r = 0, o = s.length; r < o; r++) {
    const a = s[r].split(":"), h = a[0].replace(i, "").replace(/[A-Z]/g, function(c) {
      return "-" + c.toLowerCase();
    });
    (!e || e.includes(h)) && (t[h] = a[1].replace(i, ""));
  }
}
const Bi = [
  "id",
  "class",
  "viewBox",
  "width",
  "height",
  "x",
  "y",
  "cx",
  "cy",
  "r",
  "rx",
  "ry",
  "cursor",
  "opacity",
  "src",
  "fill",
  "fill-opacity",
  "stroke",
  "stroke-dasharray",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "text-anchor",
  "font",
  "font-family",
  "font-size",
  "font-style",
  "font-weight",
  "letter-spacing"
];
class At {
  // 在坐标系的绝对值
  prevPathX = 0;
  prevPathY = 0;
  // 提高性能, 没更新时使用缓存值
  isUpdatedSVGPathData = !0;
  isUpdatedSVGPathD = !0;
  isUpdatedBoundingClientRect = !0;
  isUpdatedPolymorphPoints = !0;
  isUpdatedTotalLength = !0;
  normalizedLines = [];
  // d = "M0,0"
  // d = [['C',1,2,3,4,5,6]]
  constructor(t) {
    const e = typeof t == "string" ? al(t) : t || [], s = bg(hl(e));
    for (let i = 0, r = s.length; i < r; i++) {
      const o = s[i];
      o[0] == "M" ? (this.prevPathX = o[1], this.prevPathY = o[2]) : this._appendLine(
        new xt({
          x: this.prevPathX,
          y: this.prevPathY,
          c1x: o[1],
          c1y: o[2],
          c2x: o[3],
          c2y: o[4],
          toX: o[5],
          toY: o[6]
        })
      );
    }
  }
  _appendLine(t) {
    if (this.isUpdatedSVGPathData = !0, this.isUpdatedSVGPathD = !0, this.isUpdatedBoundingClientRect = !0, this.isUpdatedPolymorphPoints = !0, this.isUpdatedTotalLength = !0, t instanceof yr) {
      il(
        this.prevPathX,
        this.prevPathY,
        t.toX,
        t.toY,
        t.largeArcFlag,
        t.sweepFlag,
        t.rx,
        t.ry,
        t.xAxisRotate
      ).forEach((c) => {
        const [l, u, d, f, m, p, S, g] = c;
        this.normalizedLines.push(
          new xt({
            x: this.prevPathX,
            y: this.prevPathY,
            c1x: d,
            c1y: f,
            c2x: m,
            c2y: p,
            toX: S,
            toY: g
          })
        ), this.prevPathX = S, this.prevPathY = g;
      });
      return;
    }
    if (t instanceof xt) {
      this.normalizedLines.push(t.clone()), this.prevPathX = t.toX, this.prevPathY = t.toY;
      return;
    }
    let e, s, i, r, o, a;
    t instanceof mg ? [e, s, i, r, o, a] = xr(
      this.prevPathX,
      this.prevPathY,
      t.cx,
      t.cy,
      t.toX,
      t.toY
    ) : [e, s, i, r, o, a] = Ls(
      this.prevPathX,
      this.prevPathY,
      t.toX,
      t.toY
    ), this.normalizedLines.push(
      new xt({
        x: this.prevPathX,
        y: this.prevPathY,
        c1x: e,
        c1y: s,
        c2x: i,
        c2y: r,
        toX: o,
        toY: a
      })
    ), this.prevPathX = o, this.prevPathY = a;
  }
  static fromPolymorphPoints(t) {
    const e = new At(), s = t.length;
    if (s) {
      e.prevPathX = t[0], e.prevPathY = t[1];
      for (let i = 2; i + 5 < s; i += 6)
        e._appendLine(
          new xt({
            x: e.prevPathX,
            y: e.prevPathY,
            c1x: t[i],
            c1y: t[i + 1],
            c2x: t[i + 2],
            c2y: t[i + 3],
            toX: t[i + 4],
            toY: t[i + 5]
          })
        );
    }
    return e;
  }
  static fromLines(t) {
    const e = new At(), s = t.length;
    if (s) {
      e.prevPathX = t[0].x, e.prevPathY = t[0].y;
      for (let i = 0; i < s; i++)
        e._appendLine(t[i]);
    }
    return e;
  }
  clone() {
    return At.fromLines(this.normalizedLines);
  }
  // 在坐标系的绝对值
  cachedSVGPathData = [];
  toSVGPathData() {
    if (this.isUpdatedSVGPathData) {
      const t = [];
      for (let e = 0, s = this.normalizedLines.length; e < s; e++) {
        const i = this.normalizedLines[e];
        e == 0 && t.push(["M", i.x, i.y]), t.push(...i.toSVGPathData());
      }
      this.cachedSVGPathData = t, this.isUpdatedSVGPathData = !1;
    }
    return this.cachedSVGPathData;
  }
  // 外部使用
  cachedSVGPathD = "";
  toSVGPathD() {
    return this.isUpdatedSVGPathD && (this.cachedSVGPathD = wg(this.toSVGPathData()), this.isUpdatedSVGPathD = !1), this.cachedSVGPathD;
  }
  // 外部使用
  toCanvasContext(t) {
    t.beginPath();
    for (let e = 0, s = this.normalizedLines.length; e < s; e++) {
      const i = this.normalizedLines[e];
      e == 0 && t.moveTo(i.x, i.y), i.toCanvasContext(t);
    }
  }
  // 外部使用
  // 相对坐标系原点 - 坐标系没有考虑 transform : translate rotate scale
  cachedBoundingClientRect = {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  };
  getBoundingClientRect(t = 2) {
    if (this.isUpdatedBoundingClientRect) {
      const e = [], s = [];
      if (this.normalizedLines.forEach((i) => {
        const r = i.getBoundingClientRect(t);
        e.push(r.x, r.x + r.width), s.push(r.y, r.y + r.height);
      }), e.length == 0 || s.length == 0)
        this.cachedBoundingClientRect = { x: 0, y: 0, width: 0, height: 0 };
      else {
        const i = Math.min(...e), r = Math.min(...s), o = Math.max(...e), a = Math.max(...s);
        this.cachedBoundingClientRect = {
          x: Y(i, t),
          y: Y(r, t),
          width: Y(o - i, t),
          height: Y(a - r, t)
        };
      }
      this.isUpdatedBoundingClientRect = !1;
    }
    return this.cachedBoundingClientRect;
  }
  // 相对坐标系原点 - 坐标系没有考虑 transform : translate rotate scale
  getBoundingClientRectCenter(t = 2) {
    const e = this.getBoundingClientRect(t);
    return {
      x: Y(e.x + e.width * 0.5, t),
      y: Y(e.y + e.height * 0.5, t)
    };
  }
  // 通过 DrawContext shape.m 获得 新的 PathD
  transform(t) {
    let e;
    return t.m ? e = t.m : (e = new _t(), e.translate(t.x || 0, t.y || 0), e.rotate(t.degree || 0, t.centerX, t.centerY), e.scale(
      t.scaleX || 1,
      t.scaleY || 1,
      t.centerX,
      t.centerY
    )), e.isIdentity ? this.clone() : At.fromLines(
      this.normalizedLines.map((s) => {
        let i = s.x, r = s.y, o = s.c1x, a = s.c1y, h = s.c2x, c = s.c2y, l = s.toX, u = s.toY;
        return { x: i, y: r } = e.transformPoint({ x: i, y: r }), { x: o, y: a } = e.transformPoint({ x: o, y: a }), { x: h, y: c } = e.transformPoint({ x: h, y: c }), { x: l, y: u } = e.transformPoint({ x: l, y: u }), new xt({ x: i, y: r, c1x: o, c1y: a, c2x: h, c2y: c, toX: l, toY: u });
      })
    );
  }
  // returns length in pixels
  cachedTotalLength;
  getTotalLength() {
    return (typeof this.cachedTotalLength != "number" || this.isUpdatedTotalLength) && (this.cachedTotalLength = Math.round(
      this.normalizedLines.reduce((t, e) => t += e.length(), 0)
    ), this.isUpdatedTotalLength = !1), this.cachedTotalLength;
  }
  // 获取插值方法1
  getPointAtLength(t) {
    let e = 0, s = 0;
    const i = this.normalizedLines.length;
    for (let r = 0; r < i; r++) {
      const o = this.normalizedLines[r];
      if (s = o.length(), e + s >= t)
        return o.getPointAtSegmentLength(t - e);
      e += s;
    }
    return this.normalizedLines[i - 1].getPointAtSegmentLength(s);
  }
  // 获取插值方法2 t (0.0 to 1.0) : The fraction of the overall duration of the path
  interpolate(t) {
    const e = this.normalizedLines.length;
    if (e === 0)
      return { x: 0, y: 0 };
    if (e === 1)
      return this.normalizedLines[0].interpolate(t);
    {
      let s = t * e, i = this.normalizedLines[0];
      if (s--, s > 1)
        for (let r = 1; r < e && (i = this.normalizedLines[r], s > 1); r++)
          s -= 1;
      return i.interpolate(s);
    }
  }
  getSubPathD(t, e, s = 1e-6) {
    const i = this.getSubPathDAtLength(e, !0);
    return ji(s)(t, 0) ? i : i.getSubPathDAtLength(t, !1);
  }
  getSubPathDAtLength(t, e = !1) {
    const s = new At();
    let i = 0, r = !1;
    for (let o = 0, a = this.normalizedLines.length; o < a; o++) {
      const h = this.normalizedLines[o];
      o == 0 && (s.prevPathX = h.x, s.prevPathY = h.y);
      const c = h.length();
      if (i + c > t && !r) {
        r = !0;
        const l = h.getPointAtSegmentLength(t - i);
        if (s._appendLine(
          new xt({
            x: s.prevPathX,
            y: s.prevPathY,
            c1x: l.start.x,
            c1y: l.start.y,
            c2x: l.m.x,
            c2y: l.m.y,
            toX: l.x,
            toY: l.y
          })
        ), e)
          return s;
        s.normalizedLines = [], s._appendLine(
          new xt({
            x: s.prevPathX,
            y: s.prevPathY,
            c1x: l.n.x,
            c1y: l.n.y,
            c2x: l.end.x,
            c2y: l.end.y,
            toX: h.toX,
            toY: h.toY
          })
        ), i += c;
        continue;
      }
      s._appendLine(h), i += c;
    }
    return s;
  }
  closestPoint(t, e) {
    const s = this.getTotalLength();
    let i = { x: t, y: e }, r = 0, o = 1 / 0, a = 8;
    for (let c = 0; c <= s; c += a) {
      const l = this.getPointAtLength(c), u = (t - l.x) * (t - l.x) + (e - l.y) * (e - l.y);
      u < o && (i = l, r = c, o = u);
    }
    for (a /= 2; a > 0.5; ) {
      const c = r - a, l = this.getPointAtLength(c), u = (t - l.x) * (t - l.x) + (e - l.y) * (e - l.y), d = r + a, f = this.getPointAtLength(d), m = (t - f.x) * (t - f.x) + (e - f.y) * (e - f.y);
      c >= 0 && u < o ? (i = l, r = c, o = u) : d <= s && m < o ? (i = f, r = d, o = m) : a /= 2;
    }
    const h = this.getPointAtLength(
      r + (r === s ? -0.1 : 0.1)
    );
    return {
      point: i,
      rotation: r >= s ? qt(h.x, h.y, i.x, i.y) : qt(i.x, i.y, h.x, h.y),
      distance: Math.sqrt(o)
    };
  }
  // 获得 Polymorph 要用的所有的点
  cachedPolymorphPoints = [];
  getPolymorphPoints() {
    if (this.isUpdatedPolymorphPoints) {
      if (this.normalizedLines.length) {
        const t = this.normalizedLines[0];
        this.cachedPolymorphPoints = [t.x, t.y].concat(
          this.normalizedLines.reduce(
            (e, s) => e.concat([s.c1x, s.c1y, s.c2x, s.c2y, s.toX, s.toY]),
            []
          )
        );
      }
      this.isUpdatedPolymorphPoints = !1;
    }
    return [...this.cachedPolymorphPoints];
  }
  getPolymorphPointsPerimeter() {
    let t = 0;
    const e = this.getPolymorphPoints(), s = e.length;
    if (s) {
      let i = e[s - 2], r = e[s - 1];
      for (let o = 0; o < s; o += 6)
        t += Ge(e[o], e[o + 1], i, r), i = e[o], r = e[o + 1];
    }
    return Math.floor(t);
  }
  // 扩充 PolymorphPoints 到对应数量的点，返回新 PathD
  expendToPolymorphPoints(t) {
    const e = t.length, s = this.getPolymorphPoints(), i = s.length;
    if (i) {
      const r = [];
      let o = e - i;
      const a = Math.ceil(e / i);
      r.push(["M", s[0], s[1]]);
      let h = 2;
      for (; h + 5 <= i - 1; ) {
        const c = s[h++], l = s[h++], u = s[h++], d = s[h++], f = s[h++], m = s[h++];
        r.push(["C", c, l, u, d, f, m]);
        let p = 0;
        for (; p < a && o > 0; )
          r.push(["C", f, m, f, m, f, m]), o -= 6, p++;
      }
      return new At(r);
    } else
      return At.fromPolymorphPoints(t);
  }
  // 返回 从 leftPathD 到 rightPathD 的 插值函数
  static getInterpolator(t, e) {
    return (s) => {
      const i = ji(Number.EPSILON);
      return i(s, 0) ? t.clone() : i(s, 1) ? e.clone() : At.fromPolymorphPoints(
        Bu(t.getPolymorphPoints(), e.getPolymorphPoints(), s).map(
          (r) => Y(r, 2)
        )
      );
    };
  }
}
const Ba = _g(
  "50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,t9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro",
  32
);
function _g(n, t = 10) {
  const e = {}, s = n.split(",");
  for (let i = 0; i < s.length; i += 2) {
    const r = "&" + s[i + 1] + ";", o = parseInt(s[i], t);
    e[r] = "&#" + o + ";";
  }
  return e["\\xa0"] = "&#160;", e;
}
function Tt(n, t) {
  const e = Object.keys(t);
  for (let s = 0; s < e.length; s++)
    n = n.replace(
      new RegExp("{" + e[s] + "}", "gi"),
      "" + t[e[s]]
    );
  return n;
}
function Pn(n) {
  let t, e;
  if (!n)
    throw new Error(
      "cannot create a random attribute name for an undefined object"
    );
  const s = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
  t = "";
  do
    for (t = "", e = 0; e < 12; e++)
      t += s[Math.floor(Math.random() * s.length)];
  while (n[t]);
  return t;
}
function Sg(n) {
  const t = {
    left: "start",
    right: "end",
    center: "middle",
    start: "start",
    end: "end"
  };
  return t[n] || t.start;
}
function Cg(n) {
  const t = {
    alphabetic: "alphabetic",
    hanging: "hanging",
    top: "text-before-edge",
    bottom: "text-after-edge",
    middle: "central"
  };
  return t[n] || t.alphabetic;
}
const Cs = {
  strokeStyle: {
    svgAttr: "stroke",
    canvas: "#000000",
    svg: "none",
    apply: "stroke"
  },
  fillStyle: {
    svgAttr: "fill",
    canvas: "#000000",
    svg: null,
    // svg default is black, but we need to special case this to handle canvas stroke without fill
    apply: "fill"
  },
  lineCap: {
    svgAttr: "stroke-linecap",
    canvas: "butt",
    svg: "butt",
    apply: "stroke"
  },
  lineJoin: {
    svgAttr: "stroke-linejoin",
    canvas: "miter",
    svg: "miter",
    apply: "stroke"
  },
  miterLimit: {
    svgAttr: "stroke-miterlimit",
    canvas: 10,
    svg: 4,
    apply: "stroke"
  },
  lineWidth: {
    svgAttr: "stroke-width",
    canvas: 1,
    svg: 1,
    apply: "stroke"
  },
  globalAlpha: {
    svgAttr: "opacity",
    canvas: 1,
    svg: 1,
    apply: "fill stroke"
  },
  font: {
    // font converts to multiple svg attributes, there is custom logic for this
    canvas: "10px sans-serif"
  },
  shadowColor: {
    canvas: "#000000"
  },
  shadowOffsetX: {
    canvas: 0
  },
  shadowOffsetY: {
    canvas: 0
  },
  shadowBlur: {
    canvas: 0
  },
  textAlign: {
    canvas: "start"
  },
  textBaseline: {
    canvas: "alphabetic"
  },
  lineDash: {
    svgAttr: "stroke-dasharray",
    canvas: [],
    svg: null,
    apply: "stroke"
  },
  lineDashOffset: {
    svgAttr: "stroke-dashoffset",
    canvas: 0,
    svg: 0,
    apply: "stroke"
  }
};
class Xi {
  __root;
  __ctx;
  constructor(t, e) {
    this.__root = t, this.__ctx = e;
  }
  /**
   * Adds a color stop to the gradient root
   */
  addColorStop(t, e) {
    const s = this.__ctx.__createElement("stop");
    if (s.setAttribute("offset", "" + t), e.indexOf("rgba") !== -1) {
      const r = /rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d?\.?\d*)\s*\)/gi.exec(e);
      r && (s.setAttribute(
        "stop-color",
        Tt("rgb({r},{g},{b})", {
          r: r[1],
          g: r[2],
          b: r[3]
        })
      ), s.setAttribute("stop-opacity", r[4]));
    } else
      s.setAttribute("stop-color", e);
    this.__root.appendChild(s);
  }
}
class Xa {
  __root;
  __ctx;
  constructor(t, e) {
    this.__root = t, this.__ctx = e;
  }
}
class Hn {
  __document = document;
  __canvas;
  __ctx;
  width;
  height;
  __styleStack;
  __groupStack;
  __rootSVG;
  __ids;
  __SVGdefs;
  __currentElement;
  __currentElementsToStyle = null;
  constructor({
    canvas: t,
    width: e = 500,
    height: s = 500
  }) {
    t ? (this.__canvas = t, this.__ctx = t.getContext("2d")) : (this.__canvas = this.__document.createElement("canvas"), this.__ctx = this.__canvas.getContext("2d")), this.width = e || t?.width || 0, this.height = s || t?.height || 0, this.__setDefaultStyles(), this.__styleStack = [this.__getStyleState()], this.__groupStack = [], this.__rootSVG = this.__document.createElementNS(
      "http://www.w3.org/2000/svg",
      "svg"
    ), this.__rootSVG.setAttribute("version", "1.1"), this.__rootSVG.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.__rootSVG.setAttributeNS(
      "http://www.w3.org/2000/xmlns/",
      "xmlns:xlink",
      "http://www.w3.org/1999/xlink"
    ), this.__rootSVG.setAttribute("width", "" + this.width), this.__rootSVG.setAttribute("height", "" + this.height), this.__ids = {}, this.__SVGdefs = this.__document.createElementNS(
      "http://www.w3.org/2000/svg",
      "defs"
    ), this.__rootSVG.appendChild(this.__SVGdefs), this.__currentElement = this.__document.createElementNS(
      "http://www.w3.org/2000/svg",
      "g"
    ), this.__rootSVG.appendChild(this.__currentElement);
  }
  /**
   * Applies default canvas styles to the context
   */
  __setDefaultStyles() {
    const t = Object.keys(Cs);
    for (let e = 0, s = t.length; e < s; e++) {
      const i = t[e];
      this[i] = Cs[i].canvas;
    }
  }
  /**
   * Gets the current style state
   */
  __getStyleState() {
    const t = {}, e = Object.keys(Cs);
    for (let s = 0, i = e.length; s < i; s++) {
      const r = e[s];
      t[r] = this[r];
    }
    return t;
  }
  /**
   * Applies styles on restore
   */
  __applyStyleState(t) {
    const e = Object.keys(t);
    for (let s = 0, i = e.length; s < i; s++) {
      const r = e[s];
      this[r] = t[r];
    }
  }
  /**
   * Creates the specified svg element
   */
  __createElement(t, e = {}, s = !1) {
    const i = this.__document.createElementNS(
      "http://www.w3.org/2000/svg",
      t
    ), r = Object.keys(e);
    s && (i.setAttribute("fill", "none"), i.setAttribute("stroke", "none"));
    for (let o = 0; o < r.length; o++) {
      const a = r[o];
      i.setAttribute(a, e[a]);
    }
    return i;
  }
  /**
   * Apples the current styles to the current SVG element. On "CustomCanvasContext.fill" or "CustomCanvasContext.stroke"
   */
  __applyStyleToCurrentElement(t) {
    let e = this.__currentElement;
    const s = this.__currentElementsToStyle;
    s && (e.setAttribute(t, ""), e = s.element, s.children.forEach((r) => {
      r.setAttribute(t, "");
    }));
    const i = Object.keys(Cs);
    for (let r = 0; r < i.length; r++) {
      const o = Cs[i[r]], a = this[i[r]];
      if (o.apply) {
        if (a instanceof Xa) {
          if (a.__ctx)
            for (; a.__ctx.__SVGdefs.childNodes.length; ) {
              const h = a.__ctx.__SVGdefs.childNodes[0].getAttribute("id");
              this.__ids[h] = h, this.__SVGdefs.appendChild(a.__ctx.__SVGdefs.childNodes[0]);
            }
          e.setAttribute(
            o.apply,
            Tt("url(#{id})", {
              id: a.__root.getAttribute("id")
            })
          );
        } else if (a instanceof Xi)
          e.setAttribute(
            o.apply,
            Tt("url(#{id})", {
              id: a.__root.getAttribute("id")
            })
          );
        else if (o.apply.indexOf(t) !== -1 && o.svg !== a)
          if ((o.svgAttr === "stroke" || o.svgAttr === "fill") && a.indexOf("rgba") !== -1) {
            const c = /rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d?\.?\d*)\s*\)/gi.exec(a);
            if (c) {
              e.setAttribute(
                o.svgAttr,
                Tt("rgb({r},{g},{b})", {
                  r: c[1],
                  g: c[2],
                  b: c[3]
                })
              );
              let l = parseFloat(c[4]);
              const u = this.globalAlpha;
              u != null && (l *= u), e.setAttribute(
                o.svgAttr + "-opacity",
                "" + l
              );
            }
          } else {
            let h = o.svgAttr;
            if (i[r] === "globalAlpha" && (h = t + "-" + o.svgAttr, e.getAttribute(h)))
              continue;
            h && e.setAttribute(h, a);
          }
      }
    }
  }
  /**
   * Will return the closest group or svg node. May return the current element.
   */
  __closestGroupOrSvg(t) {
    return t = t || this.__currentElement, t.nodeName === "g" || t.nodeName === "svg" ? t : this.__closestGroupOrSvg(t.parentNode);
  }
  /**
   * Returns the serialized value of the svg so far
   * @param fixNamedEntities - Standalone SVG doesn't support named entities, which document.createTextNode encodes.
   *                           If true, we attempt to find all named entities and encode it as a numeric entity.
   * @return serialized svg
   */
  getSerializedSvg(t) {
    let e = new XMLSerializer().serializeToString(this.__rootSVG);
    if (/xmlns="http:\/\/www\.w3\.org\/2000\/svg".+xmlns="http:\/\/www\.w3\.org\/2000\/svg/gi.test(e) && (e = e.replace(
      'xmlns="http://www.w3.org/2000/svg',
      'xmlns:xlink="http://www.w3.org/1999/xlink'
    )), t) {
      const i = Object.keys(Ba);
      for (let r = 0, o = i.length; r < o; r++) {
        const a = i[r], h = Ba[a], c = new RegExp(a, "gi");
        c.test(e) && (e = e.replace(c, h));
      }
    }
    return e;
  }
  /**
   * Returns the root svg
   */
  getSvg() {
    return this.__rootSVG;
  }
  /**
   * Will generate a group tag
   */
  save() {
    const t = this.__createElement("g"), e = this.__closestGroupOrSvg();
    this.__groupStack.push(e), e.appendChild(t), this.__currentElement = t, this.__styleStack.push(this.__getStyleState());
  }
  /**
   * Sets current element to parent, or just root if already root
   */
  restore() {
    this.__currentElementsToStyle = null;
    const t = this.__groupStack.pop();
    t ? this.__currentElement = t : this.__currentElement = this.__rootSVG.childNodes[1];
    const e = this.__styleStack.pop();
    e && this.__applyStyleState(e);
  }
  /**
   * Helper method to add transform
   */
  __addTransform(t) {
    const e = this.__closestGroupOrSvg();
    if (e.childNodes.length > 0) {
      this.__currentElement.nodeName === "path" && (this.__currentElementsToStyle || (this.__currentElementsToStyle = { element: e, children: [] }), this.__currentElementsToStyle.children.push(this.__currentElement), this.__applyCurrentDefaultPath());
      const i = this.__createElement("g");
      e.appendChild(i), this.__currentElement = i;
    }
    let s = this.__currentElement.getAttribute("transform");
    s ? s += " " : s = "", s += t, this.__currentElement.setAttribute("transform", s);
  }
  /**
   *  scales the current element
   */
  scale(t, e) {
    e === void 0 && (e = t), this.__addTransform(Tt("scale({x},{y})", { x: t, y: e }));
  }
  /**
   * rotates the current element
   */
  rotate(t) {
    const e = t * 180 / Math.PI;
    this.__addTransform(
      Tt("rotate({angle},{cx},{cy})", {
        angle: e,
        cx: 0,
        cy: 0
      })
    );
  }
  /**
   * translates the current element
   */
  translate(t, e) {
    this.__addTransform(Tt("translate({x},{y})", { x: t, y: e }));
  }
  /**
   * applies a transform to the current element
   */
  transform(t, e, s, i, r, o) {
    this.__addTransform(
      Tt("matrix({a},{b},{c},{d},{e},{f})", {
        a: t,
        b: e,
        c: s,
        d: i,
        e: r,
        f: o
      })
    );
  }
  /**
   * Create a new Path Element
   */
  beginPath() {
    this.__currentDefaultPath = "", this.__currentPosition = {};
    const t = this.__createElement("path", {}, !0);
    this.__closestGroupOrSvg().appendChild(t), this.__currentElement = t;
  }
  /**
   * Helper function to apply currentDefaultPath to current path element
   */
  __applyCurrentDefaultPath() {
    const t = this.__currentElement;
    t.nodeName === "path" && t.setAttribute("d", this.__currentDefaultPath);
  }
  /**
   * Helper function to add path command
   */
  __addPathCommand(t) {
    this.__currentDefaultPath += " ", this.__currentDefaultPath += t;
  }
  /**
   * Adds the move command to the current path element,
   * if the currentPathElement is not empty create a new path element
   */
  moveTo(t, e) {
    this.__currentElement.nodeName !== "path" && this.beginPath(), this.__currentPosition = { x: t, y: e }, this.__addPathCommand(Tt("M {x} {y}", this.__currentPosition));
  }
  /**
   * Closes the current path
   */
  closePath() {
    this.__currentDefaultPath && this.__addPathCommand("Z");
  }
  /**
   * Adds a line to command
   */
  lineTo(t, e) {
    this.__currentPosition = { x: t, y: e }, this.__currentDefaultPath.indexOf("M") > -1 ? this.__addPathCommand(Tt("L {x} {y}", this.__currentPosition)) : this.__addPathCommand(Tt("M {x} {y}", this.__currentPosition));
  }
  /**
   * Add a bezier command
   */
  bezierCurveTo(t, e, s, i, r, o) {
    this.__currentPosition = { x: r, y: o }, this.__addPathCommand(
      Tt("C {cp1x} {cp1y} {cp2x} {cp2y} {x} {y}", {
        cp1x: t,
        cp1y: e,
        cp2x: s,
        cp2y: i,
        x: r,
        y: o
      })
    );
  }
  /**
   * Adds a quadratic curve to command
   */
  quadraticCurveTo(t, e, s, i) {
    this.__currentPosition = { x: s, y: i }, this.__addPathCommand(
      Tt("Q {cpx} {cpy} {x} {y}", { cpx: t, cpy: e, x: s, y: i })
    );
  }
  /**
   * Return a new normalized vector of given vector
   */
  normalize(t) {
    const e = Math.sqrt(t[0] * t[0] + t[1] * t[1]);
    return [t[0] / e, t[1] / e];
  }
  /**
   * Adds the arcTo to the current path
   *
   * @see http://www.w3.org/TR/2015/WD-2dcontext-20150514/#dom-context-2d-arcto
   */
  arcTo(t, e, s, i, r) {
    const o = this.__currentPosition && this.__currentPosition.x, a = this.__currentPosition && this.__currentPosition.y;
    if (typeof o > "u" || typeof a > "u")
      return;
    if (r < 0)
      throw new Error(
        "IndexSizeError: The radius provided (" + r + ") is negative."
      );
    if (o === t && a === e || t === s && e === i || r === 0) {
      this.lineTo(t, e);
      return;
    }
    const h = this.normalize([o - t, a - e]), c = this.normalize([s - t, i - e]);
    if (h[0] * c[1] === h[1] * c[0]) {
      this.lineTo(t, e);
      return;
    }
    const l = h[0] * c[0] + h[1] * c[1], u = Math.acos(Math.abs(l)), d = this.normalize([
      h[0] + c[0],
      h[1] + c[1]
    ]), f = r / Math.sin(u / 2), m = t + f * d[0], p = e + f * d[1], S = [
      -h[1],
      h[0]
    ], g = [c[1], -c[0]], b = function(C) {
      const _ = C[0];
      return C[1] >= 0 ? Math.acos(_) : -Math.acos(_);
    }, x = b(S), w = b(g);
    this.lineTo(
      m + S[0] * r,
      p + S[1] * r
    ), this.arc(m, p, r, x, w);
  }
  /**
   * Sets the stroke property on the current element
   */
  stroke() {
    this.__currentElement.nodeName === "path" && this.__currentElement.setAttribute("paint-order", "fill stroke markers"), this.__applyCurrentDefaultPath(), this.__applyStyleToCurrentElement("stroke");
  }
  /**
   * Sets fill properties on the current element
   */
  fill() {
    this.__currentElement.nodeName === "path" && this.__currentElement.setAttribute("paint-order", "stroke fill markers"), this.__applyCurrentDefaultPath(), this.__applyStyleToCurrentElement("fill");
  }
  /**
   *  Adds a rectangle to the path.
   */
  rect(t, e, s, i) {
    this.__currentElement.nodeName !== "path" && this.beginPath(), this.moveTo(t, e), this.lineTo(t + s, e), this.lineTo(t + s, e + i), this.lineTo(t, e + i), this.lineTo(t, e), this.closePath();
  }
  /**
   * adds a rectangle element
   */
  fillRect(t, e, s, i) {
    const r = this.__createElement(
      "rect",
      {
        x: t,
        y: e,
        width: s,
        height: i
      },
      !0
    );
    this.__closestGroupOrSvg().appendChild(r), this.__currentElement = r, this.__applyStyleToCurrentElement("fill");
  }
  /**
   * Draws a rectangle with no fill
   */
  strokeRect(t, e, s, i) {
    const r = this.__createElement(
      "rect",
      {
        x: t,
        y: e,
        width: s,
        height: i
      },
      !0
    );
    this.__closestGroupOrSvg().appendChild(r), this.__currentElement = r, this.__applyStyleToCurrentElement("stroke");
  }
  /**
   * Clear entire canvas:
   * 1. save current transforms
   * 2. remove all the childNodes of the root g element
   */
  __clearCanvas() {
    const e = this.__closestGroupOrSvg().getAttribute("transform"), s = this.__rootSVG.childNodes[1], i = s.childNodes;
    for (let r = i.length - 1; r >= 0; r--)
      i[r] && s.removeChild(i[r]);
    this.__currentElement = s, this.__groupStack = [], e && this.__addTransform(e);
  }
  /**
   * "Clears" a canvas by just drawing a white rectangle in the current group.
   */
  clearRect(t, e, s, i) {
    if (t === 0 && e === 0 && s === this.width && i === this.height) {
      this.__clearCanvas();
      return;
    }
    const r = this.__closestGroupOrSvg(), o = this.__createElement(
      "rect",
      {
        x: t,
        y: e,
        width: s,
        height: i,
        fill: "#FFFFFF"
      },
      !0
    );
    r.appendChild(o);
  }
  /**
   * Adds a linear gradient to a defs tag.
   * Returns a canvas gradient object that has a reference to it's parent def
   */
  createLinearGradient(t, e, s, i) {
    const r = this.__createElement(
      "linearGradient",
      {
        id: Pn(this.__ids),
        x1: t + "px",
        x2: s + "px",
        y1: e + "px",
        y2: i + "px",
        gradientUnits: "userSpaceOnUse"
      },
      !1
    );
    return this.__SVGdefs.appendChild(r), new Xi(r, this);
  }
  /**
   * Adds a radial gradient to a defs tag.
   * Returns a canvas gradient object that has a reference to it's parent def
   */
  createRadialGradient(t, e, s, i, r, o) {
    const a = this.__createElement(
      "radialGradient",
      {
        id: Pn(this.__ids),
        cx: i + "px",
        cy: r + "px",
        r: o + "px",
        fx: t + "px",
        fy: e + "px",
        gradientUnits: "userSpaceOnUse"
      },
      !1
    );
    return this.__SVGdefs.appendChild(a), new Xi(a, this);
  }
  /**
   * Parses the font string and returns svg mapping
   */
  __parseFont() {
    const e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:%|in|[cem]m|ex|p[CustomCanvasContext]))(?:\s*\/\s*(normal|[.\d]+(?:%|in|[cem]m|ex|p[CustomCanvasContext])))?\s*([-,'"\sa-z0-9]+?)\s*$/i.exec(this.font), s = {
      style: e[1] || "normal",
      size: e[4] || "10px",
      family: e[6] || "sans-serif",
      weight: e[3] || "normal",
      decoration: e[2] || "normal",
      href: null
    };
    return this.__fontUnderline === "underline" && (s.decoration = "underline"), this.__fontHref && (s.href = this.__fontHref), s;
  }
  /**
   * Helper to link text fragments
   */
  __wrapTextLink(t, e) {
    if (t.href) {
      const s = this.__createElement("a");
      return s.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", t.href), s.appendChild(e), s;
    }
    return e;
  }
  /**
   * Fills or strokes text
   * @param text
   * @param x
   * @param y
   * @param action - stroke or fill
   */
  __applyText(t, e, s, i) {
    const r = this.__parseFont(), o = this.__closestGroupOrSvg(), a = this.__createElement(
      "text",
      {
        "font-family": r.family,
        "font-size": r.size,
        "font-style": r.style,
        "font-weight": r.weight,
        "text-decoration": r.decoration,
        x: e,
        y: s,
        "text-anchor": Sg(this.textAlign),
        "dominant-baseline": Cg(this.textBaseline)
      },
      !0
    );
    a.appendChild(this.__document.createTextNode(t)), this.__currentElement = a, this.__applyStyleToCurrentElement(i), o.appendChild(
      this.__wrapTextLink(r, a)
    );
  }
  /**
   * Creates a text element
   * @param text
   * @param x
   * @param y
   */
  fillText(t, e, s) {
    this.__applyText(t, e, s, "fill");
  }
  /**
   * Strokes text
   * @param text
   * @param x
   * @param y
   */
  strokeText(t, e, s) {
    this.__applyText(t, e, s, "stroke");
  }
  /**
   * No need to implement this for svg.
   * @param text
   * @return {TextMetrics}
   */
  measureText(t) {
    return this.__ctx.font = this.font, this.__ctx.measureText(t);
  }
  /**
   *  Arc command!
   */
  arc(t, e, s, i, r, o) {
    if (i === r)
      return;
    i = i % (2 * Math.PI), r = r % (2 * Math.PI), i === r && (r = (r + 2 * Math.PI - 1e-3 * (o ? -1 : 1)) % (2 * Math.PI));
    const a = t + s * Math.cos(r), h = e + s * Math.sin(r), c = t + s * Math.cos(i), l = e + s * Math.sin(i), u = o ? 0 : 1;
    let d = 0, f = r - i;
    f < 0 && (f += 2 * Math.PI), o ? d = f > Math.PI ? 0 : 1 : d = f > Math.PI ? 1 : 0, this.lineTo(c, l), this.__addPathCommand(
      Tt(
        "A {rx} {ry} {xAxisRotation} {largeArcFlag} {sweepFlag} {endX} {endY}",
        {
          rx: s,
          ry: s,
          xAxisRotation: 0,
          largeArcFlag: d,
          sweepFlag: u,
          endX: a,
          endY: h
        }
      )
    ), this.__currentPosition = { x: a, y: h };
  }
  /**
   * Generates a ClipPath from the clip command.
   */
  clip() {
    const t = this.__closestGroupOrSvg(), e = this.__createElement("clipPath"), s = Pn(this.__ids), i = this.__createElement("g");
    this.__applyCurrentDefaultPath(), t.removeChild(this.__currentElement), e.setAttribute("id", s), e.appendChild(this.__currentElement), this.__SVGdefs.appendChild(e), t.setAttribute("clip-path", Tt("url(#{id})", { id: s })), t.appendChild(i), this.__currentElement = i;
  }
  /**
   * Draws a canvas, image or mock context to this canvas.
   * Note that all svg dom manipulation uses node.childNodes rather than node.children for IE support.
   * http://www.whatwg.org/specs/web-apps/current-work/multipage/the-canvas-element.html#dom-context-2d-drawimage
   */
  drawImage(...t) {
    let e = t[0], s, i, r, o, a = 0, h = 0, c, l, u, d, f, m, p, S;
    if (t.length === 3)
      s = t[1], i = t[2], c = e.width, l = e.height, r = c, o = l;
    else if (t.length === 5)
      s = t[1], i = t[2], r = t[3], o = t[4], c = e.width, l = e.height;
    else if (t.length === 9)
      a = t[1], h = t[2], c = t[3], l = t[4], s = t[5], i = t[6], r = t[7], o = t[8];
    else
      throw new Error(
        "Invalid number of arguments passed to drawImage: " + arguments.length
      );
    const g = this.__closestGroupOrSvg();
    this.__currentElement;
    const b = "translate(" + s + ", " + i + ")";
    if (e instanceof Hn) {
      if (u = e.getSvg().cloneNode(!0), u.childNodes && u.childNodes.length > 1) {
        for (d = u.childNodes[0]; d.childNodes.length; )
          S = d.childNodes[0].getAttribute("id"), this.__ids[S] = S, this.__SVGdefs.appendChild(d.childNodes[0]);
        if (f = u.childNodes[1], f) {
          const x = f.getAttribute("transform");
          let w;
          x ? w = x + " " + b : w = b, f.setAttribute("transform", w), g.appendChild(f);
        }
      }
    } else
      (e.nodeName === "CANVAS" || e.nodeName === "IMG") && (m = this.__createElement("image"), m.setAttribute("width", r), m.setAttribute("height", o), m.setAttribute("preserveAspectRatio", "none"), (a || h || c !== e.width || l !== e.height) && (p = this.__document.createElement("canvas"), p.width = r, p.height = o, p.getContext("2d")?.drawImage(e, a, h, c, l, 0, 0, r, o), e = p), m.setAttribute("transform", b), m.setAttributeNS(
        "http://www.w3.org/1999/xlink",
        "xlink:href",
        e.nodeName === "CANVAS" ? e.toDataURL() : e.getAttribute("src")
      ), g.appendChild(m));
  }
  /**
   * Generates a pattern tag
   */
  createPattern(t, e) {
    const s = this.__document.createElementNS(
      "http://www.w3.org/2000/svg",
      "pattern"
    ), i = Pn(this.__ids);
    let r;
    return s.setAttribute("id", i), t.nodeName === "CANVAS" || t.nodeName === "IMG" ? (r = this.__document.createElementNS(
      "http://www.w3.org/2000/svg",
      "image"
    ), r.setAttribute(
      "width",
      "" + t.width
    ), r.setAttribute(
      "height",
      "" + t.height
    ), r.setAttributeNS(
      "http://www.w3.org/1999/xlink",
      "xlink:href",
      t.nodeName === "CANVAS" ? t.toDataURL() : t.getAttribute("src")
    ), s.appendChild(r), this.__SVGdefs.appendChild(s)) : t instanceof Hn && (s.setAttribute("width", "" + t.width), s.setAttribute(
      "height",
      "" + t.height
    ), s.appendChild(t.__rootSVG.childNodes[1]), this.__SVGdefs.appendChild(s)), new Xa(s, this);
  }
  setLineDash(t) {
    t && t.length > 0 ? this.lineDash = t.join(",") : this.lineDash = null;
  }
  drawFocusRing() {
  }
  createImageData() {
  }
  getImageData() {
  }
  putImageData() {
  }
  globalCompositeOperation() {
  }
  setTransform() {
  }
}
class vr {
  canvas;
  context;
  // context: CanvasRenderingContext2D
  // | WebGLRenderingContext
  // | WebGL2RenderingContext
  // | GPUCanvasContext
  // | ImageBitmapRenderingContext
  customContext;
  // https://developer.mozilla.org/en-US/docs/Web/API/Path2D
  enablePath2D = !1;
  currentPath2D = new Path2D();
  path2Ds = [];
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix
  currentMatrix = new DOMMatrix();
  // currentMatrix = document
  //   .createElementNS("http://www.w3.org/2000/svg", "svg")
  //   .createSVGMatrix();
  hasSetCustomStrokeStyle = !1;
  hasSetCustomFillStyle = !1;
  constructor(t, e, s, i = !1, r = !1) {
    this.canvas = t, this.context = t.getContext("2d", {
      willReadFrequently: !0
    }), i && (this.customContext = new Hn({
      canvas: this.canvas,
      width: e || this.canvas.width,
      height: s || this.canvas.height
    })), this.enablePath2D = typeof r == "boolean" ? r : !1;
  }
  set lineWidth(t) {
    this.hasSetCustomStrokeStyle = !0, this.context.lineWidth = t, this.customContext && (this.customContext.lineWidth = t);
  }
  get lineWidth() {
    return this.context.lineWidth;
  }
  set lineCap(t) {
    this.hasSetCustomStrokeStyle = !0, this.context.lineCap = t, this.customContext && (this.customContext.lineCap = t);
  }
  get lineCap() {
    return this.context.lineCap;
  }
  set lineJoin(t) {
    this.hasSetCustomStrokeStyle = !0, this.context.lineJoin = t, this.customContext && (this.customContext.lineCap = t);
  }
  get lineJoin() {
    return this.context.lineJoin;
  }
  set lineDashOffset(t) {
    this.hasSetCustomStrokeStyle = !0, this.context.lineDashOffset = t, this.customContext && (this.customContext.lineDashOffset = t);
  }
  get lineDashOffset() {
    return this.context.lineDashOffset;
  }
  set miterLimit(t) {
    this.hasSetCustomStrokeStyle = !0, this.context.miterLimit = t, this.customContext && (this.customContext.miterLimit = t);
  }
  get miterLimit() {
    return this.context.miterLimit;
  }
  set globalAlpha(t) {
    this.context.globalAlpha = t, this.customContext && (this.customContext.globalAlpha = t);
  }
  get globalAlpha() {
    return this.context.globalAlpha;
  }
  // rgb(255,221,0)
  // rgba(255,221,0,1)
  // #000000
  set fillStyle(t) {
    this.hasSetCustomFillStyle = !0, typeof t == "string" || t instanceof CanvasGradient || t instanceof CanvasPattern ? (this.context.fillStyle = t, this.customContext && (this.customContext.fillStyle = t)) : (this.context.fillStyle = t.gradient, this.customContext && (this.customContext.fillStyle = t.gradientCustom));
  }
  get fillStyle() {
    return this.context.fillStyle;
  }
  set strokeStyle(t) {
    this.hasSetCustomStrokeStyle = !0, typeof t == "string" || t instanceof CanvasGradient || t instanceof CanvasPattern ? (this.context.strokeStyle = t, this.customContext && (this.customContext.strokeStyle = t)) : (this.context.strokeStyle = t.gradient, this.customContext && (this.customContext.strokeStyle = t.gradientCustom));
  }
  get strokeStyle() {
    return this.context.strokeStyle;
  }
  // font:"10px sans-serif"
  set font(t) {
    this.context.font = t, this.customContext && (this.customContext.font = t);
  }
  get font() {
    return this.context.font;
  }
  set textBaseline(t) {
    this.context.textBaseline = t, this.customContext && (this.customContext.textBaseline = t);
  }
  get textBaseline() {
    return this.context.textBaseline;
  }
  set textAlign(t) {
    this.context.textAlign = t, this.customContext && (this.customContext.textAlign = t);
  }
  get textAlign() {
    return this.context.textAlign;
  }
  fill(t) {
    return t ? this.context.fill(t) : (this.context.fill(), this.customContext && this.customContext.fill()), this;
  }
  fillRect(t, e, s, i) {
    return this.context.fillRect(t, e, s, i), this.customContext && this.customContext.fillRect(t, e, s, i), this;
  }
  fillText(t, e, s, i) {
    return this.hasSetCustomFillStyle = !1, this.context.fillText(t, e, s, i), this.customContext && this.customContext.fillText(t, e, s), this;
  }
  setLineDash(t) {
    return this.context.setLineDash(t), this.customContext && this.customContext.setLineDash(t), this;
  }
  stroke(t) {
    return t ? this.context.stroke(t) : (this.context.stroke(), this.customContext && this.customContext.stroke()), this;
  }
  strokeText(t, e, s, i) {
    return this.context.strokeText(t, e, s, i), this.customContext && this.customContext.strokeText(t, e, s), this;
  }
  strokeRect(t, e, s, i) {
    return this.context.strokeRect(t, e, s, i), this.customContext && this.customContext.strokeRect(t, e, s, i), this;
  }
  measureText(t) {
    return this.context.measureText(t);
  }
  clearRect(t = 0, e = 0, s = this.canvas.width, i = this.canvas.height) {
    return this.context.clearRect(t, e, s, i), this.customContext && this.customContext.clearRect(t, e, s, i), this;
  }
  save() {
    return this.context.save(), this.customContext && this.customContext.save(), this.currentMatrix = new DOMMatrix(), this.enablePath2D && (this.path2Ds.push(this.currentPath2D), this.currentPath2D = new Path2D()), this;
  }
  restore() {
    return this.context.restore(), this.customContext && this.customContext.restore(), this.hasSetCustomStrokeStyle = !1, this.hasSetCustomFillStyle = !1, this.currentMatrix = new DOMMatrix(), this.enablePath2D && (this.currentPath2D = this.path2Ds.pop() || new Path2D()), this;
  }
  beginPath() {
    return this.context.beginPath(), this.customContext && this.customContext.beginPath(), this;
  }
  closePath() {
    return this.context.closePath(), this.customContext && this.customContext.closePath(), this.enablePath2D && this.currentPath2D.closePath(), this;
  }
  changePath2D(t = this.currentPath2D, e = this.currentMatrix) {
    if (this.enablePath2D) {
      const s = new Path2D();
      s.addPath(t, e), this.currentPath2D = s;
    }
  }
  isPointInStroke(...t) {
    return t[0] instanceof Path2D ? this.context.isPointInStroke(t[0], t[1], t[2]) : this.context.isPointInStroke(t[0], t[1]);
  }
  isPointInPath(...t) {
    return t[0] instanceof Path2D ? this.context.isPointInPath(t[0], t[1], t[2]) : this.context.isPointInPath(t[0], t[1]);
  }
  // transform(a: number, b: number, c: number, d: number, e: number, f: number) {
  //   this.context.transform(a, b, c, d, e, f);
  //   if (this.customContext) this.customContext.transform(a, b, c, d, e, f);
  //   return this;
  // }
  translate(t, e) {
    return this.context.translate(t, e), this.customContext && this.customContext.translate(t, e), this.currentMatrix = this.currentMatrix.translate(t, e), this.changePath2D(), this;
  }
  rotate(t, e = 0, s = 0) {
    return this.translate(e, s), this.context.rotate(t), this.customContext && this.customContext.rotate(t), this.currentMatrix = this.currentMatrix.rotate(t), this.translate(-e, -s), this.changePath2D(), this;
  }
  scale(t, e = t, s = 0, i = 0) {
    return this.translate(s, i), this.context.scale(t, e), this.customContext && this.customContext.scale(t, e), this.currentMatrix = this.currentMatrix.scale(t, e), this.translate(-s, -i), this.changePath2D(), this;
  }
  moveTo(t, e) {
    return this.context.moveTo(t, e), this.customContext && this.customContext.moveTo(t, e), this.enablePath2D && this.currentPath2D.moveTo(t, e), this;
  }
  lineTo(t, e) {
    return this.context.lineTo(t, e), this.customContext && this.customContext.lineTo(t, e), this.enablePath2D && this.currentPath2D.lineTo(t, e), this;
  }
  arc(t, e, s, i, r, o) {
    return this.context.arc(t, e, s, i, r, o), this.customContext && this.customContext.arc(
      t,
      e,
      s,
      i,
      r,
      o ? -1 : 1
    ), this.enablePath2D && this.currentPath2D.arc(
      t,
      e,
      s,
      i,
      r,
      o
    ), this;
  }
  arcTo(t, e, s, i, r) {
    return this.context.arcTo(t, e, s, i, r), this.customContext && this.customContext.arcTo(t, e, s, i, r), this.enablePath2D && this.currentPath2D.arcTo(t, e, s, i, r), this;
  }
  ellipse(t, e, s, i, r, o, a, h) {
    return this.context.ellipse(
      t,
      e,
      s,
      i,
      r,
      o,
      a,
      h
    ), this.enablePath2D && this.currentPath2D.ellipse(
      t,
      e,
      s,
      i,
      r,
      o,
      a,
      h
    ), this;
  }
  quadraticCurveTo(t, e, s, i) {
    return this.context.quadraticCurveTo(t, e, s, i), this.customContext && this.customContext.quadraticCurveTo(t, e, s, i), this.enablePath2D && this.currentPath2D.quadraticCurveTo(t, e, s, i), this;
  }
  bezierCurveTo(t, e, s, i, r, o) {
    return this.context.bezierCurveTo(t, e, s, i, r, o), this.customContext && this.customContext.bezierCurveTo(t, e, s, i, r, o), this.enablePath2D && this.currentPath2D.bezierCurveTo(t, e, s, i, r, o), this;
  }
  rect(t, e, s, i) {
    return this.context.rect(t, e, s, i), this.customContext && this.customContext.rect(t, e, s, i), this.enablePath2D && this.currentPath2D.rect(t, e, s, i), this;
  }
  // { 0: "#ffffff", 1: "#ff0000" }
  createLinearGradient(t, e, s, i, r) {
    const o = this.context.createLinearGradient(
      t,
      e,
      s,
      i
    );
    return r && Object.entries(r).forEach(([a, h]) => {
      o.addColorStop(parseFloat(a), h);
    }), o;
  }
  createRadialGradient(t, e, s, i, r, o, a) {
    const h = this.context.createRadialGradient(
      t,
      e,
      s,
      i,
      r,
      o
    );
    return a && Object.entries(a).forEach(([c, l]) => {
      h.addColorStop(parseFloat(c), l);
    }), h;
  }
  //  const image = new Image();
  //  image.src = "../assets/images/picture.jpg";
  //  image.onload = function () {
  //    co.drawImage(image);
  //  };
  drawImage(t, ...e) {
    if (e.length === 0)
      this.context.drawImage(t, 0, 0);
    else if (e.length === 2) {
      const s = e[0], i = e[1];
      this.context.drawImage(t, s, i);
    } else if (e.length === 4) {
      const s = e[0], i = e[1], r = e[2], o = e[3];
      this.context.drawImage(t, s, i, r, o);
    } else if (e.length === 8) {
      const s = e[0], i = e[1], r = e[2], o = e[3], a = e[4], h = e[5], c = e[6], l = e[7];
      this.context.drawImage(t, s, i, r, o, a, h, c, l);
    } else
      throw new Error(
        "Invalid number of arguments passed to drawImage: " + e.length
      );
    return this.customContext && this.customContext.drawImage(t, ...e), this;
  }
  getImageData(t = 0, e = 0, s = this.canvas.width, i = this.canvas.height, r) {
    return this.context.getImageData(t, e, s, i, r);
  }
  putImageData(t, e = 0, s = 0) {
    return this.context.putImageData(t, e, s);
  }
  createPattern(t, e) {
    return this.context.createPattern(t, e);
  }
  toRawSVG() {
    if (this.customContext) {
      const t = this.customContext.getSerializedSvg(!0), e = this.customContext.getSvg();
      return { raw: t, element: e };
    } else
      return { raw: "", element: null };
  }
}
class Q {
  // this.shouldUpdatePathD 交给子类变更
  shouldUpdatePathD = !1;
  shouldUpdateTransformPathD = !1;
  shouldUpdateSVGElInDraw = !1;
  shouldUpdateMInDraw = !0;
  shouldUpdateAttrsInDraw = !0;
  shouldUpdateStyleInDraw = !0;
  id;
  initD;
  d;
  parent;
  attrs = {};
  style = {};
  initCenterX;
  initCenterY;
  _x;
  _y;
  _degree;
  _scaleX;
  _scaleY;
  vx;
  vy;
  ax;
  ay;
  mass;
  interactive;
  drag;
  transform$ = new ke();
  transformSubscription;
  // DrawContext 动态注入参数
  isMouseIn = !1;
  isDragging = !1;
  m;
  el;
  constructor(t) {
    this.id = Xs(4), this.initD = t?.initD, this.setAttr({
      // "paint-order": "markers stroke fill", // 先 stroke 再 fill
      // "paint-order": "fill stroke markers", // default
      stroke: "none",
      fill: "none"
      // "pointerEvents": "none",
    }), t?.attrs && this.setAttr(t.attrs), t?.style && this.setStyle(t.style), this.initCenterX = t?.centerX, this.initCenterY = t?.centerY, this._x = t?.x || 0, this._y = t?.y || 0, this._degree = t?.degree || 0, this._scaleX = 1, this._scaleY = 1, t?.scale !== void 0 && (this._scaleX = t.scale, this._scaleY = t.scale), t?.scaleX !== void 0 && (this._scaleX = t.scaleX), t?.scaleY !== void 0 && (this._scaleY = t.scaleY), this.vx = t?.vx || 0, this.vy = t?.vy || 0, this.ax = t?.ax || 0, this.ay = t?.ay || 0, this.mass = t?.mass || 1, this.interactive = typeof t?.interactive == "boolean" ? t?.interactive : !0, this.drag = t?.drag, this.transformSubscription = this.transform$.subscribe(() => {
      this.shouldUpdateTransformPathD = !0, this.shouldUpdateMInDraw = !0;
    });
  }
  destroy() {
    this.transformSubscription.unsubscribe();
  }
  // 基操
  moveTo(t, e) {
    const s = this._x, i = this._y;
    (s !== t || i !== e) && (this._x = t, this._y = e, this.transform$.next({ dX: t - s, dY: e - i }));
  }
  move(t, e = 0) {
    this.moveTo(this._x + t, this._y + e);
  }
  moveXTo(t) {
    this.moveTo(t, this._y);
  }
  moveX(t) {
    this.moveTo(this._x + t, this._y);
  }
  moveYTo(t) {
    this.moveTo(this._x, t);
  }
  moveY(t) {
    this.moveTo(this._x, this._y + t);
  }
  get x() {
    return this._x;
  }
  // 基操
  set x(t) {
    this._x !== t && (this.transform$.next({ dX: t - this._x }), this._x = t);
  }
  get y() {
    return this._y;
  }
  // 基操
  set y(t) {
    this._y !== t && (this.transform$.next({ dY: t - this._y }), this._y = t);
  }
  // 基操
  rotateTo(t) {
    this._degree !== t && (this.transform$.next({ dDegree: t - this._degree }), this._degree = t);
  }
  rotate(t) {
    this.rotateTo(this._degree + t);
  }
  get degree() {
    return this._degree;
  }
  // 基操
  set degree(t) {
    this._degree !== t && (this.transform$.next({ dDegree: t - this._degree }), this._degree = t);
  }
  // 基操
  scaleTo(t, e) {
    const s = this._scaleX, i = this._scaleY;
    (this._scaleX !== t || this._scaleY !== (e || t)) && (this._scaleX = t, this._scaleY = e || t, this.transform$.next({
      dScaleX: this._scaleX / s,
      dScaleY: this._scaleY / i
    }));
  }
  scale(t, e) {
    this.scaleTo(this._scaleX * t, this._scaleY * (e || t));
  }
  get scaleX() {
    return this._scaleX;
  }
  // 基操
  set scaleX(t) {
    this._scaleX !== t && (this.transform$.next({
      dScaleX: t / this._scaleX
    }), this._scaleX = t);
  }
  get scaleY() {
    return this._scaleY;
  }
  // 基操
  set scaleY(t) {
    this._scaleY !== t && (this.transform$.next({
      dScaleY: t / this._scaleY
    }), this._scaleY = t);
  }
  // 无法在 constructor 中获得 子类.toSVGPathData()
  pathD(t) {
    return t ? (this.d = t, this.shouldUpdateTransformPathD = !0, this.shouldUpdateSVGElInDraw = !0) : this.initD ? this.d || (this.d = this.initD instanceof At ? this.initD : new At(this.initD)) : (!this.d || this.shouldUpdatePathD) && (this.d = new At(this.toSVGPathData()), this.shouldUpdatePathD = !1, this.shouldUpdateTransformPathD = !0, this.shouldUpdateSVGElInDraw = !0), this.d;
  }
  cachedTransformedPathD;
  transformPathD() {
    if (!this.m) {
      const { x: t, y: e } = this.transformOrigin();
      let s = 0, i = 0;
      if (this.parent?.dDegree || this.parent?.dScaleX !== 1 || this.parent?.dScaleY !== 1) {
        const o = this.transformOrigin(!0);
        s = o.x, i = o.y;
      }
      const r = new _t();
      r.translate(
        this.x + (this.parent?.dX || 0),
        this.y + (this.parent?.dY || 0)
      ), r.rotate(this.degree, t, e), r.scale(this.scaleX, this.scaleY, t, e), this.parent?.dDegree && r.rotate(this.parent.dDegree, s, i), (this.parent?.dScaleX !== 1 || this.parent?.dScaleY !== 1) && r.scale(
        this.parent?.dScaleX || 1,
        this.parent?.dScaleY || 1,
        s,
        i
      ), this.m = r;
    }
    return (this.shouldUpdateTransformPathD || !this.cachedTransformedPathD) && (this.cachedTransformedPathD = this.pathD().transform({ m: this.m }), this.shouldUpdateTransformPathD = !1), this.cachedTransformedPathD;
  }
  getBaseOptions() {
    return {
      initD: this.initD,
      attrs: { ...this.attrs },
      style: { ...this.style },
      centerX: this.initCenterX,
      centerY: this.initCenterY,
      x: this._x,
      y: this._y,
      degree: this._degree,
      scaleX: this._scaleX,
      scaleY: this._scaleY,
      vx: this.vx,
      vy: this.vy,
      ax: this.ax,
      ay: this.ay,
      mass: this.mass,
      interactive: this.interactive,
      drag: { ...this.drag }
    };
  }
  clone() {
    return this.cloneShape();
  }
  // 子类需覆盖！
  cloneShape() {
    return new Q(this.getBaseOptions());
  }
  // 供外部使用：基本属性变更
  update(t) {
    this.shouldUpdatePathD = !0;
  }
  // 优先级比 toSVGPathData() 高
  // 使用相对值! transform 交给 DrawContext
  toSVGEl() {
    return null;
  }
  // shape 内部定义
  // 使用相对值! transform 交给 DrawContext
  toSVGPathData() {
    return [];
  }
  // 外部使用
  // 使用相对值!
  toSVGPathD() {
    return this.pathD().toSVGPathD();
  }
  // 使用相对值! transform 交给 DrawContext
  // ctx.createLinearGradient 使用相对值
  // 如果子类没有覆盖 toCanvasContext , 默认使用 PathD 的 toCanvasContext
  // 如果子类覆盖 toCanvasContext , 则使用 原生canvas系统
  toCanvasContext(t) {
    this.pathD().toCanvasContext(t);
  }
  // 子类可覆盖
  // 相对坐标系原点 - 坐标系没有考虑 transform : translate rotate scale
  getBoundingClientRect(t = 2) {
    return this.pathD().getBoundingClientRect(t);
  }
  // 相对坐标系原点 - 坐标系加入考虑 transform : translate rotate scale
  getRealBoundingClientRect(t = 2) {
    return this.transformPathD().getBoundingClientRect(t);
  }
  // 相对坐标系原点 - 坐标系没有考虑 transform : translate rotate scale
  getBoundingClientRectCenter(t = 2) {
    return this.pathD().getBoundingClientRectCenter(t);
  }
  // 相对坐标系原点 - 坐标系加入考虑 transform : translate rotate scale
  getRealBoundingClientRectCenter(t = 2) {
    return this.transformPathD().getBoundingClientRectCenter(t);
  }
  // transform origin - 不缓存, 直接使用 getBoundingClientRectCenter， 间接使用 getBoundingClientRect
  // 相对坐标系原点 - 坐标系没有考虑 transform : translate rotate scale
  transformOrigin(t = !1, e = 2) {
    let s = 0, i = 0;
    if (this.parent && !t) {
      const r = this.parent.combo.getBoundingClientRectCenter(e);
      s = r.x - this.parent.dX, i = r.y - this.parent.dY;
    } else if (typeof this.initCenterX > "u" && typeof this.initCenterY > "u") {
      const r = this.getBoundingClientRectCenter(e);
      s = r.x, i = r.y;
    } else
      s = this.initCenterX || 0, i = this.initCenterY || 0;
    return { x: s, y: i };
  }
  isPointInPath(t, e, s) {
    if (t instanceof vr)
      return t.isPointInPath(new Path2D(this.toSVGPathD()), e, s);
    if (this.el instanceof SVGGeometryElement) {
      const i = this.el.getCTM();
      if (i) {
        const r = i.inverse();
        return this.el.isPointInFill({
          x: r.a * e + r.c * s + r.e,
          y: r.b * e + r.d * s + r.f
        });
      }
    }
    return !1;
  }
  isPointInStroke(t, e, s) {
    if (t instanceof vr)
      return t.isPointInStroke(new Path2D(this.toSVGPathD()), e, s);
    if (this.el instanceof SVGGeometryElement) {
      const i = this.el.getCTM();
      if (i) {
        const r = i.inverse();
        return this.el.isPointInStroke({
          x: r.a * e + r.c * s + r.e,
          y: r.b * e + r.d * s + r.f
        });
      }
    }
    return !1;
  }
  setStyle(t) {
    Object.assign(this.style, t), this.shouldUpdateStyleInDraw = !0;
  }
  setAttr(t, e) {
    if (typeof t != "string")
      for (const s in t) {
        const i = t[s];
        i && i != this.getAttr(s) && (this.attrs[pt(s)] = i, this.shouldUpdateAttrsInDraw = !0);
      }
    else
      e && e != this.getAttr(t) && (this.attrs[pt(t)] = e, this.shouldUpdateAttrsInDraw = !0);
  }
  getAttr(t, e) {
    return this.attrs[t] || this.attrs[pt(t)] || e;
  }
  hasAttr(t) {
    return !!this.getAttr(t);
  }
  animate(t) {
    this.vx += this.ax, this.vy += this.ay;
    const e = t?.gravity || 0;
    this.vy += e;
    const s = t?.friction || 1;
    this.vx *= s, this.vy *= s, this.move(this.vx, this.vy);
  }
  animateEaseTo(t, e) {
    const s = e?.easing || 0.05, i = t.x - this.x, r = t.y - this.y;
    this.vx = i * s, this.vy = r * s, this.animate(e);
  }
  animateSpringTo(t, e) {
    const s = e?.spring || 0.03;
    (Array.isArray(t) ? t : [t]).forEach((i) => {
      const r = i.x - this.x, o = i.y - this.y, a = r * s, h = o * s;
      this.vx += a, this.vy += h;
    }), this.animate({ friction: 0.9, ...e });
  }
  getSpringMassAlphaTo(t, e) {
    const s = e?.springLength || 100, i = e?.spring || 5e-4, r = t.x - this.x, o = t.y - this.y, a = Math.sqrt(r * r + o * o);
    if (a < s) {
      const h = r * i, c = o * i;
      return this.vx += h / this.mass, this.vy += c / this.mass, t.vx -= h / t.mass, t.vy -= c / t.mass, 1 - a / s;
    }
    return 0;
  }
  followTo(t, e = 3) {
    this.rotateTo(wt(qt(this.x, this.y, t.x, t.y)));
    const { dx: s, dy: i } = He(q(this.degree), e);
    this.vx = s, this.vy = i, this.animate();
  }
  followAccelerationTo(t, e = 0.05) {
    this.rotateTo(wt(qt(this.x, this.y, t.x, t.y)));
    const { dx: s, dy: i } = He(q(this.degree), e);
    this.ax = s, this.ay = i, this.animate();
  }
  // 物体之间引力
  gravitateTo(t) {
    const e = t.x - this.x, s = t.y - this.y, i = e * e + s * s, r = Math.sqrt(i), o = this.mass * t.mass / i, a = o * e / r, h = o * s / r;
    this.vx += a / this.mass, this.vy += h / this.mass, t.vx -= a / t.mass, t.vy -= h / t.mass;
  }
  // 碰撞检测
  checkCollision(t) {
    const e = t.x - this.x, s = t.y - this.y, i = Math.sqrt(e * e + s * s), {
      x: r,
      y: o,
      width: a,
      height: h
    } = t.getBoundingClientRect(), { x: c, y: l } = t.getBoundingClientRectCenter(), { x: u, y: d, width: f, height: m } = this.getBoundingClientRect(), { x: p, y: S } = this.getBoundingClientRectCenter();
    if (i < Math.abs(c - r) + Math.abs(p - u) || i < Math.abs(l - o) + Math.abs(S - d)) {
      const g = Math.atan2(s, e), b = { x: 0, y: 0 }, x = oe(-g, e, s), w = oe(-g, this.vx, this.vy), C = oe(-g, t.vx, t.vy), _ = w.x - C.x;
      w.x = ((this.mass - t.mass) * w.x + 2 * t.mass * C.x) / (this.mass + t.mass), C.x = _ + w.x;
      const D = Math.abs(w.x) + Math.abs(C.x), z = this.ballRadius + t.ballRadius - Math.abs(b.x - x.x);
      b.x += w.x / D * z, x.x += C.x / D * z;
      const B = oe(g, b.x, b.y), G = oe(g, x.x, x.y);
      t.moveTo(this.x + G.x, this.y + G.y), this.moveTo(this.x + B.x, this.y + B.y);
      const V = oe(g, w.x, w.y), j = oe(g, C.x, C.y);
      this.vx = V.x, this.vy = V.y, t.vx = j.x, t.vy = j.y;
    }
  }
  // 回弹检测 或 重回检测
  checkWall(t) {
    if (!t?.wall)
      return;
    const e = typeof t.wall.bounce == "number" ? t.wall.bounce : -1, s = t.wall.x, i = t.wall.y, r = t.wall.x + t.wall.width, o = t.wall.y + t.wall.height, { x: a, y: h, width: c, height: l } = this.getBoundingClientRect();
    t.wall.cycle || !1 ? (this.x + a > r ? this.moveXTo(s - (a + c)) : this.x + a + c < s && this.moveXTo(r - a), this.y + h > o ? this.moveYTo(i - (h + l)) : this.y + h + l < i && this.moveYTo(o - h)) : (this.x + a + c > r ? (this.moveXTo(r - (a + c)), this.vx *= e) : this.x + a < s && (this.moveXTo(s + (a + c)), this.vx *= e), this.y + h + l > o ? (this.moveYTo(o - (h + l)), this.vy *= e) : this.y + h < i && (this.moveYTo(i + (h + l)), this.vy *= e));
  }
  // 相对坐标系原点 - 坐标系没有考虑 transform : translate rotate scale
  getTotalLength() {
    return this.transformPathD().getTotalLength();
  }
  // 相对坐标系原点 - 坐标系没有考虑 transform : translate rotate scale
  // 获取插值方法1
  getPointAtLength(t) {
    return this.transformPathD().getPointAtLength(t);
  }
  // 相对坐标系原点 - 坐标系没有考虑 transform : translate rotate scale
  // 获取插值方法2 t (0.0 to 1.0)
  interpolate(t) {
    return this.transformPathD().interpolate(t);
  }
  // t (0.0 to 1.0)
  trailPath(t = 0, e = 1) {
    const s = this.getTotalLength(), i = t * s, r = e * s;
    return {
      subPathD: this.transformPathD().getSubPathD(i, r),
      point: this.getPointAtLength(r)
    };
  }
  // frameDuration 1帧运行时间
  strokeDashTween(t = 1e3, e) {
    const s = this.pathD().getTotalLength();
    this.setAttr({
      strokeDasharray: `${s} ${s}`,
      strokeDashoffset: `${s}`
    });
    const i = e?.onUpdate, r = new li({ frameDuration: t });
    r.addTween(
      { offset: s },
      { offset: 0 },
      Object.assign(e || {}, {
        onUpdate: (o, a) => {
          this.setAttr("strokeDashoffset", "" + Y(o.offset, 2)), i?.(o, a);
        }
      })
    ), r.play();
  }
  // const rosetta = Shape.generateRosetta(120, 120, 55, 35, 6);
  static generateRosetta(t, e, s, i, r) {
    if (r == 0)
      throw new Error("no dividing by zero, please");
    const o = [], a = 360 / r;
    for (let h = 0; h < r; h += 1) {
      const c = a * h * Math.PI / 180, l = t + 2 * s * Math.cos(c), u = e + 2 * s * Math.sin(c);
      o.push(
        new yr({
          x: t,
          y: e,
          rx: s,
          ry: i,
          xAxisRotate: a * h,
          largeArcFlag: 1,
          sweepFlag: 1,
          toX: l,
          toY: u
        })
      ), o.push(
        new yr({
          x: l,
          y: u,
          rx: s,
          ry: i,
          xAxisRotate: a * h,
          largeArcFlag: 1,
          sweepFlag: 1,
          toX: t,
          toY: e
        })
      );
    }
    return new Q({ initD: At.fromLines(o) });
  }
}
class Nt {
  shapes = [];
  svg;
  forceWidth;
  attrs = {};
  style = {};
  initCenterX;
  initCenterY;
  x;
  y;
  degree;
  scaleX;
  scaleY;
  interactive;
  drag;
  constructor(t) {
    if (this.initCenterX = t?.centerX, this.initCenterY = t?.centerY, this.x = t?.x || 0, this.y = t?.y || 0, this.degree = t?.degree || 0, this.scaleX = 1, this.scaleY = 1, t?.scale !== void 0 && (this.scaleX = t.scale, this.scaleY = t.scale), t?.scaleX !== void 0 && (this.scaleX = t.scaleX), t?.scaleY !== void 0 && (this.scaleY = t.scaleY), t?.attrs && this.setAttr(t.attrs), t?.style && this.setStyle(t.style), this.interactive = typeof t?.interactive == "boolean" ? t?.interactive : !0, this.drag = t?.drag, this.svg = t?.svg, this.forceWidth = t?.forceWidth, t?.svg) {
      this.initCenterX = 0, this.initCenterY = 0;
      let e = 0, s = 0, i = 0, r = 0;
      const o = new vg(t.svg).parse();
      for (let a = 0, h = o.length; a < h; a++) {
        const c = o[a];
        if (c.type == "viewbox" && c.width && c.height) {
          if (e = parseFloat(c.width), s = parseFloat(c.height), t.forceWidth) {
            const m = e / s;
            i = t.forceWidth, r = i / m;
          } else
            i = e, r = s;
          continue;
        }
        if (c.type != "path" || !ol(c.path))
          continue;
        const l = {};
        for (const m in c)
          m === "type" || m === "path" || m === "transform" || (l[m] = c[m]);
        const u = hl(al(c.path)), d = [];
        let f = [];
        for (let m = 0, p = u.length; m < p; m++) {
          const S = u[m];
          f.push(S), S[0].toLowerCase() == "z" && (d.push(f), f = []);
        }
        f.length && d.push(f), d.forEach((m) => {
          const p = new Q({
            attrs: l,
            initD: m
          });
          if (c.transform) {
            const g = v0(c.transform).split();
            p.moveTo(g.x, g.y), p.rotateTo(g.degree), p.scaleTo(g.scaleX, g.scaleY);
          }
          this.addShape(p);
        });
      }
      i && e && r && s && this.comboScale(i / e, r / s, !0);
    }
  }
  destroy() {
    this.shapes.forEach((t) => t.destroy());
  }
  getBaseOptions() {
    return {
      svg: this.svg,
      forceWidth: this.forceWidth,
      attrs: { ...this.attrs },
      style: { ...this.style },
      centerX: this.initCenterX,
      centerY: this.initCenterY,
      x: this.x,
      y: this.y,
      degree: this.degree,
      scaleX: this.scaleX,
      scaleY: this.scaleY,
      interactive: this.interactive,
      drag: { ...this.drag }
    };
  }
  clone() {
    const t = this.cloneShapeCombo();
    return t.shapes = this.shapes.map((e) => {
      const s = e.clone();
      return e.parent && (s.parent = { ...e.parent, combo: t }), s;
    }), t;
  }
  // 子类需覆盖！
  cloneShapeCombo() {
    return new Nt(this.getBaseOptions());
  }
  // 供外部使用：基本属性变更
  update(t) {
    this.shapes.forEach((e) => e.update(t));
  }
  addShape(t, e) {
    e?.notCopyFromCombo !== !0 && (t.setAttr(this.attrs), t.setStyle(this.style), t.interactive = t.interactive || this.interactive, t.drag = { ...this.drag, ...t.drag }), t.parent = {
      combo: this,
      dX: e?.dX || 0,
      dY: e?.dY || 0,
      dDegree: e?.dDegree || 0,
      dScaleX: e?.dScaleX || 1,
      dScaleY: e?.dScaleY || 1
    }, this.shapes.push(t);
  }
  comboMove(t, e, s = !1) {
    s || (this.x += t, this.y += e), this.shapes.forEach((i) => {
      i.move(t, e);
    });
  }
  comboRotate(t, e = !1) {
    e || (this.degree += t), this.shapes.forEach((s) => {
      s.rotate(t);
    });
  }
  comboScale(t, e, s = !1) {
    s || (this.scaleX *= t, this.scaleY *= e || t), this.shapes.forEach((i) => {
      i.scale(t, e);
    });
  }
  comboTransform(t, e = !1) {
    (typeof t?.x == "number" || typeof t?.y == "number") && this.comboMove(t?.x || 0, t?.y || 0, e), typeof t?.degree == "number" && this.comboRotate(t?.degree || 0, e), (typeof t?.scale == "number" || typeof t?.scaleX == "number" || typeof t?.scaleY == "number") && this.comboScale(
      t?.scaleX || t?.scale || 1,
      t?.scaleY || t?.scale || 1,
      e
    );
  }
  // 子类可覆盖
  // 相对坐标系原点 - 坐标系没有考虑 transform : translate rotate scale
  getBoundingClientRect(t = 2) {
    const e = [], s = [];
    if (this.shapes.forEach((h) => {
      const c = h.getBoundingClientRect(t);
      e.push(c.x, c.x + c.width), s.push(c.y, c.y + c.height);
    }), e.length == 0 || s.length == 0)
      return { x: 0, y: 0, width: 0, height: 0 };
    const i = Math.min(...e), r = Math.min(...s), o = Math.max(...e), a = Math.max(...s);
    return {
      x: Y(i, t),
      y: Y(r, t),
      width: Y(o - i, t),
      height: Y(a - r, t)
    };
  }
  // 相对坐标系原点 - 坐标系没有考虑 transform : translate rotate scale
  getBoundingClientRectCenter(t = 2) {
    if (typeof this.initCenterX == "number" && typeof this.initCenterY == "number")
      return { x: this.initCenterX, y: this.initCenterY };
    const e = this.getBoundingClientRect(t);
    return {
      x: Y(e.x + e.width * 0.5, t),
      y: Y(e.y + e.height * 0.5, t)
    };
  }
  setStyle(t) {
    Object.assign(this.style, t), this.shapes.forEach((e) => {
      e.setStyle(t);
    });
  }
  setAttr(t, e) {
    if (typeof t != "string") {
      for (const s in t) {
        const i = t[s];
        i && i != this.getAttr(s) && (this.attrs[pt(s)] = i);
      }
      this.shapes.forEach((s) => {
        s.setAttr(t);
      });
    } else
      e && e != this.getAttr(t) && (this.attrs[pt(t)] = e, this.shapes.forEach((s) => {
        s.setAttr(t, e);
      }));
  }
  getAttr(t, e) {
    return this.attrs[t] || this.attrs[pt(t)] || e;
  }
  hasAttr(t) {
    return !!this.getAttr(t);
  }
  // 从小到大排序
  sort() {
    this.shapes.map((t) => ({
      shape: t,
      perimeter: t.transformPathD().getPolymorphPointsPerimeter()
    })).sort((t, e) => e.perimeter - t.perimeter).map((t) => t.shape);
  }
  expendTo(t) {
    const e = t.shapes.length, s = this.shapes.length;
    if (e < s)
      return t.expendTo(this);
    for (let i = s; i < e; i++) {
      const r = t.shapes[i];
      this.addShape(
        new Q({
          initD: r.pathD().clone()
        }),
        {
          dX: r.x - this.x,
          dY: r.y - this.y,
          dDegree: r.degree - this.degree,
          dScaleX: r.scaleX / this.scaleX,
          dScaleY: r.scaleY / this.scaleY,
          notCopyFromCombo: !0
        }
      );
    }
  }
  strokeDashTween(t, e) {
    switch (e?.type) {
      case "sequence":
        this.shapes.forEach((o, a) => {
          o.strokeDashTween(t, {
            ...e,
            // 注意 options 浅拷贝
            delay: a,
            onStart: () => {
              a == 0 && e?.onGroupStart?.();
            },
            onUpdate: () => {
              e?.onGroupUpdate?.();
            },
            onComplete: () => {
              a == this.shapes.length - 1 && e?.onGroupComplete?.();
            }
          });
        });
        break;
      case "parallel":
      default:
        const s = new li({ frameDuration: t }), i = {}, r = {};
        this.shapes.forEach((o, a) => {
          const h = o.pathD().getTotalLength();
          i[`offset_${a}`] = h, r[`offset_${a}`] = 0, o.setAttr({
            strokeDasharray: `${h} ${h}`,
            strokeDashoffset: `${h}`
          });
        }), s.addTween(
          i,
          r,
          Object.assign(e || {}, {
            onStart: () => {
              e?.onGroupStart?.();
            },
            onUpdate: (o, a) => {
              for (const h in o) {
                const c = Hi(h).number;
                this.shapes[c].setAttr(
                  "strokeDashoffset",
                  "" + Y(o[h], 2)
                );
              }
              e?.onGroupUpdate?.();
            },
            onComplete: () => {
              e?.onGroupComplete?.();
            }
          })
        ), s.play();
        break;
    }
  }
}
function Sw(n, t, e = 5) {
  const s = ji(e);
  (!s(n.x, t.current.x) || !s(n.y, t.current.y)) && n.followTo(t.current);
}
function Cw(n, t, e) {
  n.drag && n.drag.enable && !n.isDragging && n.animateEaseTo(t, e);
}
function Ew(n, t) {
  const e = [], s = n.length;
  for (let i = 0; i < s; i++) {
    const r = n[i];
    if (t?.springLength) {
      const o = t?.springLength || 100;
      r.isDragging || n.filter((a) => a.id !== r.id).forEach((a) => {
        const h = qt(r.x, r.y, a.x, a.y);
        r.animateSpringTo(
          {
            x: a.x - Math.cos(h) * o,
            y: a.y - Math.sin(h) * o
          },
          t
        );
      });
    } else
      t?.spring ? i > 0 && r.animateSpringTo(n[i - 1], t) : r.animate(t);
    if (t?.wall && r.checkWall(t), t?.enableCollision || t?.enableGravityBetweenObjects || t?.enableSpringMassAlpha)
      for (let o = i + 1; o < s; o++)
        t?.enableCollision && r.checkCollision(n[o]), t?.enableGravityBetweenObjects && r.gravitateTo(n[o]), t?.enableSpringMassAlpha && e.push([
          r.x,
          r.y,
          n[o].x,
          n[o].y,
          r.getSpringMassAlphaTo(n[o], t)
        ]);
  }
  return e;
}
function ul(n) {
  if (n.length < 2)
    throw new Error("shapes个数必须大于等于2");
  const t = n.length - 1, e = new Array(t);
  for (let i = 0; i < t; i++) {
    const r = n[i].transformPathD(), o = n[i + 1].transformPathD(), a = r.getPolymorphPoints(), h = o.getPolymorphPoints(), c = a.length >= h.length ? a : h;
    e[i] = At.getInterpolator(
      r.expendToPolymorphPoints(c),
      o.expendToPolymorphPoints(c)
    );
  }
  const s = new Q({ initD: "" });
  return (i) => {
    const r = Y(t * i, 6), o = Math.min(Math.floor(r), t - 1), a = Y(r - o, 6);
    return s.pathD(e[o](a)), s.setAttr(n[o + 1].attrs), s;
  };
}
function Eg(n) {
  if (n.length < 2)
    throw new Error("shapeCombos个数必须大于等于2");
  let t;
  const e = [];
  n.forEach((o) => {
    let a;
    o instanceof Nt ? (a = o, a.sort()) : (a = new Nt(), a.addShape(o)), e.push(a), (!t || t.shapes.length < a.shapes.length) && (t = a);
  });
  const s = [];
  e.forEach((o, a) => {
    o !== t && o.expendTo(t), o.shapes.forEach((h, c) => {
      s[c] = s[c] || [], s[c][a] = h;
    });
  });
  const i = [];
  s.forEach((o) => {
    i.push(ul(o));
  });
  const r = new Nt();
  return i.forEach((o) => {
    r.addShape(o(0));
  }), (o) => (i.forEach((a) => {
    a(o);
  }), r);
}
function Pw(n, t = 6e3, e) {
  const s = n.findIndex((a) => a instanceof Nt) >= 0 ? Eg(n) : ul(n), i = s(0), r = e?.onUpdate, o = new li({ frameDuration: t });
  return o.addTween(
    { t: 0 },
    { t: 1 },
    Object.assign(e || {}, {
      onUpdate: (a, h) => {
        r?.(a, h), s(a.t), e?.shapeOrCombo?.(i, a.t);
      }
    })
  ), o.play(), i;
}
const Tn = {
  1: 705234,
  // rgb(10,194,210)
  2: 8108026,
  // rgb(123,183,250)
  3: 6346665,
  // rgb(96,215,169)
  4: 16630114,
  // rgb(253,193,98)
  5: 16607842,
  // rgb(253,106,98)
  6: 16158139,
  // rgb(246,141,187)
  7: 2542847,
  8: 10640125,
  9: 16735870,
  10: 8978266,
  11: 16580418,
  12: 16754221,
  13: 16725759,
  14: 14436630,
  15: 6844849,
  16: 13744437,
  17: 1817755,
  18: 16744272,
  19: 4964291,
  20: 16750848,
  d: 14540253,
  // rgb(221,221,221)
  aliceblue: 15792383,
  // rgb(240,248,255)
  antiquewhite: 16444375,
  // rgb(250,235,215)
  aqua: 65535,
  // rgb(0,255,255)
  aquamarine: 8388564,
  // rgb(127,255,212)
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  // rgb(0,0,0)
  blanchedalmond: 16772045,
  blue: 255,
  // rgb(0,0,255)
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  // rgb(255,0,0)
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  // rgb(255,255,255)
  whitesmoke: 16119285,
  yellow: 16776960,
  // rgb(255,255,0)
  yellowgreen: 10145074
  // rgb(154,205,50)
};
class Ft {
  _color = {
    r: 0,
    // 0 ~ 255
    g: 0,
    // 0 ~ 255
    b: 0,
    // 0 ~ 255
    a: 1
    // 0 ~ 1
  };
  constructor(t, e) {
    t && this.setColor(t), this.setAlpha(e);
  }
  get color() {
    return this._color;
  }
  set color(t) {
    const e = `Color: Unknown color(${t}) type(${typeof t})`;
    if (typeof t == "number")
      this.setHEX(t);
    else if (typeof t == "string") {
      let s;
      if (s = /^(\w+)\(([^)]*)\)/.exec(t)) {
        const i = s[2];
        let r;
        switch (s[1]) {
          case "rgb":
          case "rgba":
            (r = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
              i
            )) ? (this.r = parseInt(r[1], 10), this.g = parseInt(r[2], 10), this.b = parseInt(r[3], 10), this.a = r[4] ? parseFloat(r[4]) : 1) : (r = /^\s*(\d+)%\s*,\s*(\d+)%\s*,\s*(\d+)%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
              i
            )) ? (this.r = N(parseFloat(r[1]), 0, 100) * 255 / 100, this.g = N(parseFloat(r[2]), 0, 100) * 255 / 100, this.b = N(parseFloat(r[3]), 0, 100) * 255 / 100, this.a = r[4] ? parseFloat(r[4]) : 1) : console.warn(e);
            break;
          case "hsl":
          case "hsla":
            (r = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)%\s*,\s*(\d*\.?\d+)%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
              i
            )) ? this.setHSL(
              parseFloat(r[1]) / 360,
              parseFloat(r[2]) / 100,
              parseFloat(r[3]) / 100,
              r[4] ? parseFloat(r[4]) : 1
            ) : console.warn(e);
            break;
          case "hsv":
          case "hsva":
          case "hsb":
          case "hsba":
            (r = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)%\s*,\s*(\d*\.?\d+)%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
              i
            )) ? this.setHSV(
              parseFloat(r[1]) / 360,
              parseFloat(r[2]) / 100,
              parseFloat(r[3]) / 100,
              r[4] ? parseFloat(r[4]) : 1
            ) : console.warn(e);
            break;
          default:
            console.warn(e);
        }
      } else if (s = /#([A-Fa-f0-9]+)/.exec(t)) {
        const i = s[1], r = i.length;
        r === 3 ? this.setRGB(
          parseInt(i.charAt(0), 16),
          parseInt(i.charAt(1), 16),
          parseInt(i.charAt(2), 16),
          1
        ) : r === 6 || r === 8 ? this.setHEX(parseInt(i, 16)) : console.warn(e);
      } else if (t && t.length > 0)
        try {
          this.setColorName(t);
        } catch {
          console.warn(e);
        }
      else
        console.warn(e);
    } else
      t instanceof Ft ? this.setRGB(t.r, t.g, t.b, t.a) : Object.prototype.hasOwnProperty.call(t, "r") && Object.prototype.hasOwnProperty.call(t, "g") && Object.prototype.hasOwnProperty.call(t, "b") ? this.setRGB(
        t.r,
        t.g,
        t.b,
        Object.prototype.hasOwnProperty.call(t, "a") ? t.a : 1
      ) : Object.prototype.hasOwnProperty.call(t, "h") && Object.prototype.hasOwnProperty.call(t, "s") && Object.prototype.hasOwnProperty.call(t, "l") ? this.setHSL(
        t.h,
        t.s,
        t.l,
        Object.prototype.hasOwnProperty.call(t, "a") ? t.a : 1
      ) : Object.prototype.hasOwnProperty.call(t, "h") && Object.prototype.hasOwnProperty.call(t, "s") && Object.prototype.hasOwnProperty.call(t, "v") ? this.setHSV(
        t.h,
        t.s,
        t.v,
        Object.prototype.hasOwnProperty.call(t, "a") ? t.a : 1
      ) : Object.prototype.hasOwnProperty.call(t, "h") && Object.prototype.hasOwnProperty.call(t, "s") && Object.prototype.hasOwnProperty.call(t, "b") ? this.setHSV(
        t.h,
        t.s,
        t.b,
        Object.prototype.hasOwnProperty.call(t, "a") ? t.a : 1
      ) : console.warn(e);
  }
  setColor(t) {
    return this.color = t, this;
  }
  set(t) {
    return this.setColor(t);
  }
  get r() {
    return this._color.r;
  }
  set r(t) {
    this._color.r = N(Math.round(Qt(t, this.r)), 0, 255);
  }
  get g() {
    return this._color.g;
  }
  set g(t) {
    this._color.g = N(Math.round(Qt(t, this.g)), 0, 255);
  }
  get b() {
    return this._color.b;
  }
  set b(t) {
    this._color.b = N(Math.round(Qt(t, this.b)), 0, 255);
  }
  get a() {
    return this._color.a;
  }
  set a(t) {
    this._color.a = N(Qt(t, this.a), 0, 1);
  }
  setAlpha(t) {
    return this.a = t, this;
  }
  setFromVector3(t) {
    return this.r = t.x, this.g = t.y, this.b = t.z, this;
  }
  applyMatrix3(t) {
    const e = this.r, s = this.g, i = this.b, r = t.value;
    return this.r = r[0] * e + r[3] * s + r[6] * i, this.g = r[1] * e + r[4] * s + r[7] * i, this.b = r[2] * e + r[5] * s + r[8] * i, this;
  }
  fromBufferAttribute(t, e) {
    return this.r = t.getX(e), this.g = t.getY(e), this.b = t.getZ(e), this;
  }
  fromArray(t, e = 0) {
    return this.r = t[e], this.g = t[e + 1], this.b = t[e + 2], this.a = t[e + 3], this;
  }
  toArray(t = [], e = 0) {
    return t[e] = this.r, t[e + 1] = this.g, t[e + 2] = this.b, t[e + 3] = this.a, t;
  }
  toRGBString() {
    return this.a === 1 ? `rgb(${this.r},${this.g},${this.b})` : `rgba(${this.r},${this.g},${this.b},${Y(this.a, 6)})`;
  }
  toHexString() {
    return this.a === 1 ? ("000000" + this.hex.toString(16)).slice(-6) : ("00000000" + this.hex.toString(16)).slice(-8);
  }
  toString() {
    return this.a === 1 ? "#" + this.toHexString() : this.toRGBString();
  }
  toColorSpaceString(t = os) {
    ml.fromWorkingColorSpace(Pe.copy(this), t);
    const e = Pe.r, s = Pe.g, i = Pe.b;
    return t !== os ? `color(${t} ${e.toFixed(3)} ${s.toFixed(3)} ${i.toFixed(
      3
    )})` : this.toRGBString();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b, yield this.a;
  }
  clone() {
    return new Ft(this.color);
  }
  copy(t) {
    return this.setColor(t.color), this;
  }
  copySRGBToLinear(t) {
    return this.r = hs(t.r), this.g = hs(t.g), this.b = hs(t.b), this;
  }
  copyLinearToSRGB(t) {
    return this.r = cs(t.r), this.g = cs(t.g), this.b = cs(t.b), this;
  }
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this;
  }
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this;
  }
  equals(t) {
    return t.r === this.r && t.g === this.g && t.b === this.b && t.a === this.a;
  }
  add(t) {
    return this.r = this.r + t.r, this.g = this.g + t.g, this.b = this.b + t.b, this;
  }
  addColors(t, e) {
    return this.r = t.r + e.r, this.g = t.g + e.g, this.b = t.b + e.b, this;
  }
  addScalar(t) {
    return this.r = this.r + t, this.g = this.g + t, this.b = this.b + t, this;
  }
  setScalar(t) {
    return this.r = t, this.g = t, this.b = t, this;
  }
  sub(t) {
    return this.r = this.r - t.r, this.g = this.g - t.g, this.b = this.b - t.b, this;
  }
  multiply(t) {
    return this.r = this.r * t.r, this.g = this.g * t.g, this.b = this.b * t.b, this;
  }
  multiplyScalar(t) {
    return this.r = this.r * t, this.g = this.g * t, this.b = this.b * t, this;
  }
  opposite(t = !0, e = "#000000", s = "#ffffff") {
    if (t)
      return this.setColor(
        this.r * 0.299 + this.g * 0.587 + this.b * 0.114 > 186 ? e : s
      );
    {
      const { r: i, g: r, b: o } = this.color;
      return this.r = 255 - i, this.g = 255 - r, this.b = 255 - o, this;
    }
  }
  closet(t = "#000000", e = "#ffffff") {
    return this.opposite(!0, t, e).opposite(
      !0,
      t,
      e
    );
  }
  // t: 0 ~ 1
  lighten(t) {
    t = N(t, 0, 1);
    const { r: e, g: s, b: i, a: r } = this.color;
    return r == 0 ? this.a = t : (this.r = e + (255 - e) * t, this.g = s + (255 - s) * t, this.b = i + (255 - i) * t), this;
  }
  // t: 0 ~ 1
  darken(t) {
    t = N(t, 0, 1);
    const { r: e, g: s, b: i, a: r } = this.color;
    return r == 0 ? this.a = t : (this.r = e * (1 - t), this.g = s * (1 - t), this.b = i * (1 - t)), this;
  }
  // 渐变色
  // t: 0 ~ 1
  lerp(t, e) {
    e = N(e, 0, 1);
    const { r: s, g: i, b: r } = this.color;
    return this.r = s + (t.r - s) * e, this.g = i + (t.g - i) * e, this.b = r + (t.b - r) * e, this;
  }
  // 渐变色
  // t: 0 ~ 1
  lerpColors(t, e, s) {
    return s = N(s, 0, 1), this.r = t.r + (e.r - t.r) * s, this.g = t.g + (e.g - t.g) * s, this.b = t.b + (e.b - t.b) * s, this;
  }
  // 渐变色
  // t: 0 ~ 1
  static gradient(t, e, s) {
    try {
      return Pe.lerpColors(new Ft(t), new Ft(e), s).toString();
    } catch {
      return e;
    }
  }
  static random() {
    return Pe.setHEX(Math.random() * 16777215).toString();
  }
  static nextIndex = 0;
  static next(t = Ft.nextIndex) {
    Ft.nextIndex = t;
    const e = Object.keys(Tn), s = e.length;
    return Pe.setHEX(Tn[e[Ft.nextIndex++ % s]]).toString();
  }
  setColorName(t) {
    const e = Tn[t.toLowerCase()];
    return e !== void 0 ? this.setHEX(e) : t === "none" ? this.a = 0 : (this.a = 1, console.warn("Color.setColorName: Unknown color " + t)), this;
  }
  static getColors() {
    return Object.values(Tn).map((t) => Pe.setHEX(t).toString());
  }
  setRGB(t, e, s, i = 1) {
    return this.r = t, this.g = e, this.b = s, this.a = i, this;
  }
  get rgb() {
    return {
      r: this.r,
      g: this.g,
      b: this.b,
      a: this.a
    };
  }
  // RRGGBB(AA)
  setHEX(t) {
    return t = Math.floor(t), t < 16777216 ? (this.r = t >> 16 & 255, this.g = t >> 8 & 255, this.b = t & 255, this.a = 1) : (this.r = t >> 24 & 255, this.g = t >> 16 & 255, this.b = t >> 8 & 255, this.a = (t & 255) / 255), this;
  }
  get hex() {
    let t = (this.r << 16) + (this.g << 8) + this.b;
    return this.a !== 1 && (t = t << 8, t += Math.round(this.a * 255)), t;
  }
  /// hsl(a) : hue 色相 + saturation 饱和度 + lightness luminosity 亮度
  /// h,s,l ranges are in 0.0 ~ 1.0
  setHSL(t, e, s, i = 1) {
    const r = Yu(t, 1), o = N(e, 0, 1), a = N(s, 0, 1);
    if (o === 0)
      this.r = a * 255, this.g = a * 255, this.b = a * 255;
    else {
      const h = a <= 0.5 ? a * (1 + o) : a + o - a * o, c = 2 * a - h;
      this.r = Fi(c, h, r + 1 / 3) * 255, this.g = Fi(c, h, r) * 255, this.b = Fi(c, h, r - 1 / 3) * 255;
    }
    return this.a = i, this;
  }
  getHSL(t) {
    const e = this.r, s = this.g, i = this.b, r = Math.max(e, s, i) / 255, o = Math.min(e, s, i) / 255;
    let a, h;
    const c = (o + r) / 2;
    if (o === r)
      a = 0, h = 0;
    else {
      const l = r - o;
      switch (h = c <= 0.5 ? l / (r + o) : l / (2 - r - o), r) {
        case e:
          a = (s - i) / l + (s < i ? 6 : 0);
          break;
        case s:
          a = (i - e) / l + 2;
          break;
        case i:
        default:
          a = (e - s) / l + 4;
          break;
      }
      a /= 6;
    }
    return t && t.setHSL(a, h, c, this.a), {
      h: a,
      s: h,
      l: c,
      a: this.a
    };
  }
  offsetHSL(t, e, s) {
    const i = this.getHSL();
    return this.setHSL(i.h + t, i.s + e, i.l + s);
  }
  lerpHSL(t, e) {
    const s = this.getHSL(), i = t.getHSL(), r = In(s.h, i.h, e), o = In(s.s, i.s, e), a = In(s.l, i.l, e);
    return this.setHSL(r, o, a), this;
  }
  /// hsv(a) / hsb(a) : hue 色相 + saturation 饱和度 + value or brightness 明度
  /// h,s,v ranges are in 0.0 ~ 1.0
  setHSV(t, e, s, i = 1) {
    const r = N(t, 0, 1) * 360, o = N(e, 0, 1), a = N(s, 0, 1), h = Math.floor(r / 60) % 6, c = r / 60 - Math.floor(r / 60), l = a * (1 - o), u = a * (1 - c * o), d = a * (1 - (1 - c) * o), f = [
      [a, d, l],
      [u, a, l],
      [l, a, d],
      [l, u, a],
      [d, l, a],
      [a, l, u]
    ][h];
    return this.r = f[0] * 255, this.g = f[1] * 255, this.b = f[2] * 255, this.a = i, this;
  }
  setHSB(t, e, s, i = 1) {
    this.setHSV(t, e, s, i);
  }
  getHSV(t) {
    const { r: e, g: s, b: i, a: r } = this.color, o = Math.max(e, s, i), a = Math.min(e, s, i), h = o - a;
    let c;
    e === o ? c = (s - i) / h : s === o ? c = 2 + (i - e) / h : c = 4 + (e - s) / h, c /= 6, c < 0 && (c += 1);
    const l = h == 0 ? 0 : c, u = o === 0 ? 0 : h / o, d = o / 255;
    return t && t.setHSV(l, u, d, r), {
      h: l,
      s: u,
      v: d,
      a: r
    };
  }
  getHSB(t) {
    const { h: e, s, v: i, a: r } = this.getHSV(t);
    return {
      h: e,
      s,
      b: i,
      a: r
    };
  }
}
const Pe = new Ft(), Pg = "", os = "srgb", fl = "srgb-linear", dl = "linear", _r = "srgb";
function hs(n) {
  return n < 0.04045 ? n * 0.0773993808 : Math.pow(n * 0.9478672986 + 0.0521327014, 2.4);
}
function cs(n) {
  return n < 31308e-7 ? n * 12.92 : 1.055 * Math.pow(n, 0.41666) - 0.055;
}
const Fa = new en().set(
  0.4123908,
  0.3575843,
  0.1804808,
  0.212639,
  0.7151687,
  0.0721923,
  0.0193308,
  0.1191948,
  0.9505322
), Ua = new en().set(
  3.2409699,
  -1.5373832,
  -0.4986108,
  -0.9692436,
  1.8759675,
  0.0415551,
  0.0556301,
  -0.203977,
  1.0569715
), Ga = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06], Va = [0.2126, 0.7152, 0.0722], $a = [0.3127, 0.329], ml = {
  enabled: !0,
  workingColorSpace: fl,
  /**
   * Implementations of supported color spaces.
   *
   * Required:
   *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
   *	- whitePoint: reference white [ x y ]
   *	- transfer: transfer function (pre-defined)
   *	- toXYZ: Matrix3 RGB to XYZ transform
   *	- fromXYZ: Matrix3 XYZ to RGB transform
   *	- luminanceCoefficients: RGB luminance coefficients
   *
   * Optional:
   *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
   *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
   *
   * Reference:
   * - https://www.russellcottrell.com/photo/matrixCalculator.htm
   */
  spaces: {},
  convert: function(n, t, e) {
    return this.enabled === !1 || t === e || !t || !e || (this.spaces[t].transfer === _r && (n.r = hs(n.r), n.g = hs(n.g), n.b = hs(n.b)), this.spaces[t].primaries !== this.spaces[e].primaries && (n.applyMatrix3(this.spaces[t].toXYZ), n.applyMatrix3(this.spaces[e].fromXYZ)), this.spaces[e].transfer === _r && (n.r = cs(n.r), n.g = cs(n.g), n.b = cs(n.b))), n;
  },
  fromWorkingColorSpace: function(n, t) {
    return this.convert(n, this.workingColorSpace, t);
  },
  toWorkingColorSpace: function(n, t) {
    return this.convert(n, t, this.workingColorSpace);
  },
  getPrimaries: function(n) {
    return this.spaces[n].primaries;
  },
  getTransfer: function(n) {
    return n === Pg ? dl : this.spaces[n].transfer;
  },
  getLuminanceCoefficients: function(n, t = this.workingColorSpace) {
    return n.fromArray(this.spaces[t].luminanceCoefficients);
  },
  define: function(n) {
    Object.assign(this.spaces, n);
  },
  // Internal APIs
  _getMatrix: function(n, t, e) {
    return n.copy(this.spaces[t].toXYZ).multiply(this.spaces[e].fromXYZ);
  },
  _getDrawingBufferColorSpace: function(n) {
    return this.spaces[n].outputColorSpaceConfig.drawingBufferColorSpace;
  },
  _getUnpackColorSpace: function(n = this.workingColorSpace) {
    return this.spaces[n].workingColorSpaceConfig.unpackColorSpace;
  }
};
ml.define({
  [fl]: {
    primaries: Ga,
    whitePoint: $a,
    transfer: dl,
    toXYZ: Fa,
    fromXYZ: Ua,
    luminanceCoefficients: Va,
    workingColorSpaceConfig: { unpackColorSpace: os },
    outputColorSpaceConfig: { drawingBufferColorSpace: os }
  },
  [os]: {
    primaries: Ga,
    whitePoint: $a,
    transfer: _r,
    toXYZ: Fa,
    fromXYZ: Ua,
    luminanceCoefficients: Va,
    outputColorSpaceConfig: { drawingBufferColorSpace: os }
  }
});
function Fi(n, t, e) {
  return e < 0 && (e += 1), e > 1 && (e -= 1), e < 1 / 6 ? n + (t - n) * 6 * e : e < 1 / 2 ? t : e < 2 / 3 ? n + (t - n) * 6 * (2 / 3 - e) : n;
}
class Tw {
  PARENT_EL;
  SVG_EL = null;
  CANVAS_EL = null;
  ctx = null;
  rect = {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  };
  size$ = new aa(null);
  resizeSubscription;
  mpg = ys();
  mouseSubscription;
  shapes = [];
  shapeTap$ = new aa(null);
  tapSubscription;
  lastMouseInShapeId = "";
  // 一旦拖拽开始，不释放时，可以一直触发
  draggingShapeId = "";
  prevCursor = "default";
  constructor(t = document.documentElement, e = "canvas", s = !1) {
    this.PARENT_EL = t, (e == "svg" || e == "canvas") && M0(this.PARENT_EL), e == "svg" && (this.SVG_EL = We("svg"), Ds(this.PARENT_EL, this.SVG_EL)), e == "canvas" && (this.CANVAS_EL = D0("canvas"), Ds(this.PARENT_EL, this.CANVAS_EL)), this.resizeSubscription = nl(this.PARENT_EL).subscribe(
      (i) => {
        this.rect.x = i.x, this.rect.y = i.y, this.rect.width = i.width, this.rect.height = i.height, this.SVG_EL && Me(this.SVG_EL, {
          viewBox: `0 0 ${this.rect.width} ${this.rect.height}`,
          width: `${this.rect.width}`,
          height: `${this.rect.height}`
        }), this.CANVAS_EL && (Me(this.CANVAS_EL, {
          width: `${this.rect.width}`,
          height: `${this.rect.height}`
        }), this.ctx = new vr(
          this.CANVAS_EL,
          this.rect.width,
          this.rect.height,
          s
        )), this.size$.next(i);
      }
    ), this.mouseSubscription = rg(
      this.SVG_EL || this.CANVAS_EL || this.PARENT_EL,
      {
        useMousePoint: this.mpg
      }
    ).subscribe(() => {
    }), this.tapSubscription = j0(this.PARENT_EL).subscribe((i) => {
      for (const r of this.shapes)
        if (r.isMouseIn) {
          this.shapeTap$.next(r);
          break;
        }
    });
  }
  destroy() {
    this.resizeSubscription.unsubscribe(), this.mouseSubscription.unsubscribe(), this.tapSubscription.unsubscribe();
  }
  setCursor(t = "default") {
    t != this.prevCursor && (this.PARENT_EL.style.cursor = t, this.prevCursor = t);
  }
  // requestAnimationFrameCycle()
  draw(...t) {
    if (t.length) {
      const e = [];
      t.forEach((s) => {
        s instanceof Nt ? e.push(...s.shapes) : e.push(s);
      }), this.SVG_EL && this.shapes.filter(
        (s) => e.findIndex((i) => i.id == s.id) == -1
      ).forEach((s) => {
        s.el && (s.el.remove(), delete s.el);
      }), Uu(this.shapes, e);
    }
    this.ctx && this.ctx.clearRect(), this.lastMouseInShapeId = "", this.mpg.current.isDown || (this.draggingShapeId = "");
    for (const e of this.shapes) {
      const { x: s, y: i } = e.transformOrigin();
      let r = 0, o = 0;
      if (e.parent?.dDegree || e.parent?.dScaleX !== 1 || e.parent?.dScaleY !== 1) {
        const a = e.transformOrigin(!0);
        r = a.x, o = a.y;
      }
      if (e.shouldUpdatePathD && e.pathD(), this.SVG_EL) {
        if (!e.el || e.shouldUpdateSVGElInDraw) {
          const a = e.toSVGEl();
          e.el ? a && (e.el.remove(), e.el = a, Ds(this.SVG_EL, e.el), Me(e.el, { id: e.id })) : (e.el = a || rl(), Ds(this.SVG_EL, e.el), Me(e.el, { id: e.id })), yg(e.el) && Me(e.el, { d: e.toSVGPathD() }), e.shouldUpdateSVGElInDraw = !1, e.shouldUpdateAttrsInDraw = !0, e.shouldUpdateStyleInDraw = !0, e.shouldUpdateMInDraw = !0;
        }
        if (e.shouldUpdateAttrsInDraw && (Ro(e.attrs) || Me(e.el, e.attrs), e.shouldUpdateAttrsInDraw = !1), e.shouldUpdateStyleInDraw && (Ro(e.style) || qs(e.el, e.style), e.shouldUpdateStyleInDraw = !1), e.shouldUpdateMInDraw || !e.m) {
          const a = new _t();
          a.translate(
            e.x + (e.parent?.dX || 0),
            e.y + (e.parent?.dY || 0)
          ), a.rotate(e.degree, s, i), a.scale(e.scaleX, e.scaleY, s, i), e.parent?.dDegree && a.rotate(e.parent.dDegree, r, o), (e.parent?.dScaleX !== 1 || e.parent?.dScaleY !== 1) && a.scale(
            e.parent?.dScaleX || 1,
            e.parent?.dScaleY || 1,
            r,
            o
          ), Me(e.el, { transform: a.toString() }), e.m = a, e.shouldUpdateMInDraw = !1;
        }
      }
      if (this.ctx && (this.ctx.save(), this.ctx.translate(
        e.x + (e.parent?.dX || 0),
        e.y + (e.parent?.dY || 0)
      ), this.ctx.rotate(q(e.degree), s, i), this.ctx.scale(e.scaleX, e.scaleY, s, i), e.parent?.dDegree && this.ctx.rotate(
        q(e.parent.dDegree),
        r,
        o
      ), (e.parent?.dScaleX !== 1 || e.parent?.dScaleY !== 1) && this.ctx.scale(
        e.parent?.dScaleX || 1,
        e.parent?.dScaleY || 1,
        r,
        o
      ), e.m = this.ctx.currentMatrix, X0(this.ctx, e.attrs), e.toCanvasContext(this.ctx), this.ctx.hasSetCustomStrokeStyle && this.ctx.stroke(), this.ctx.hasSetCustomFillStyle && this.ctx.fill()), e.interactive ? this.SVG_EL ? e.isMouseIn = e.isPointInPath(
        this.SVG_EL,
        this.mpg.current.x,
        this.mpg.current.y
      ) || e.isPointInStroke(
        this.SVG_EL,
        this.mpg.current.x,
        this.mpg.current.y
      ) : this.ctx ? e.isMouseIn = e.isPointInPath(
        this.ctx,
        this.mpg.current.x,
        this.mpg.current.y
      ) || e.isPointInStroke(
        this.ctx,
        this.mpg.current.x,
        this.mpg.current.y
      ) : e.isMouseIn = !1 : e.isMouseIn = !1, e.isMouseIn && (this.setCursor("pointer"), this.lastMouseInShapeId = e.id), e.isDragging = e.id == this.draggingShapeId, this.mpg.current.isDown && (e.isDragging || !this.draggingShapeId && e.isMouseIn && e.drag && e.drag.enable)) {
        this.setCursor("grabbing"), e.isDragging = !0, this.draggingShapeId = e.id;
        let a = this.mpg.current.x - this.mpg.start.x, h = this.mpg.current.y - this.mpg.start.y;
        if (a || h) {
          if (e.drag && e.drag.enable && e.drag.alongPath) {
            const c = e.drag.alongPath.transform({ m: e.m }).closestPoint(this.mpg.current.x, this.mpg.current.y);
            a = c.point.x - e.x, h = c.point.y - e.y;
          }
          (a || h) && (e.move(a, h), e.parent?.combo.shapes.forEach((c) => {
            c.drag?.followSibling && c !== e && c.move(a, h);
          }));
        }
        this.mpg.setStart(this.mpg.current);
      } else
        e.isMouseIn && e.drag && e.drag.enable && this.setCursor("grab");
      this.ctx && this.ctx.restore();
    }
    !this.lastMouseInShapeId && !this.draggingShapeId && this.setCursor("default");
  }
  clear() {
    this.shapes.forEach((t) => {
      t.el && (t.el.remove(), delete t.el);
    }), this.ctx && this.ctx.clearRect(), this.shapes = [];
  }
  drawMouseMoveLine(t) {
    const e = t?.brushSize || 4, s = t?.brushColor || "#000000";
    let i = !1;
    const r = gr(
      this.SVG_EL || this.CANVAS_EL || this.PARENT_EL,
      {
        start: () => {
          i = !1, this.ctx && (this.ctx.save(), this.ctx.lineWidth = e, this.ctx.strokeStyle = s, this.ctx.beginPath());
        },
        end: () => {
          this.ctx && this.ctx.restore();
        }
      }
    ).subscribe((o) => {
      this.ctx && (i ? this.ctx.lineTo(o.current.x, o.current.y) : (i = !0, this.ctx.moveTo(o.current.x, o.current.y)), this.ctx.stroke());
    });
    return () => {
      r.unsubscribe();
    };
  }
  drawMouseMoveBrush(t) {
    const e = t?.brushSize || 10, s = t?.brushDensity || 50, i = t?.brushColor || "#000000", r = new Ft(i), o = r.r, a = r.g, h = r.b, c = gr(
      this.SVG_EL || this.CANVAS_EL || this.PARENT_EL
    ).subscribe((l) => {
      if (this.ctx) {
        const u = this.ctx.getImageData(
          0,
          0,
          this.ctx.canvas.width,
          this.ctx.canvas.height
        ), d = u.data;
        for (let f = 0; f < s; f++) {
          const m = Math.random() * Math.PI * 2, p = Math.random() * e, S = l.current.x + Math.cos(m) * p | 0, g = l.current.y + Math.sin(m) * p | 0, b = (S + g * u.width) * 4;
          d[b] = o, d[b + 1] = a, d[b + 2] = h, d[b + 3] = 255;
        }
        this.ctx.putImageData(u);
      }
    });
    return () => {
      c.unsubscribe();
    };
  }
  downloadSVG = () => {
    this.SVG_EL && xg(this.SVG_EL);
  };
}
class ls extends Q {
  lineLength;
  startColor;
  endColor;
  constructor(t) {
    super({ ...t, centerX: 0, centerY: 0 }), this.lineLength = t?.lineLength || 0, this.startColor = t?.startColor, this.endColor = t?.endColor, this.setAttr({
      strokeWidth: this.getAttr("strokeWidth") || "1",
      stroke: this.startColor || this.getAttr("stroke") || "#000000"
    });
  }
  cloneShape() {
    return new ls({
      ...super.getBaseOptions(),
      lineLength: this.lineLength,
      startColor: this.startColor,
      endColor: this.endColor
    });
  }
  // 供外部变更
  lineToAbsolutePoint(t) {
    const e = wt(qt(this.x, this.y, t.x, t.y)), s = Ge(this.x, this.y, t.x, t.y);
    (e != this.degree || s != this.lineLength) && (e != this.degree && this.rotateTo(e), s != this.lineLength && (this.lineLength = s), this.shouldUpdatePathD = !0);
  }
  enableGradient(t, e) {
    this.startColor = t, this.endColor = e, this.setAttr({
      stroke: this.startColor
    });
  }
  disableGradient(t) {
    this.startColor = t, this.endColor = void 0, this.setAttr({
      stroke: this.startColor
    });
  }
  getBoundingClientRect() {
    return {
      x: 0,
      y: 0,
      width: this.lineLength,
      height: parseFloat(this.getAttr("strokeWidth"))
    };
  }
  toSVGPathData() {
    return [
      ["m", 0, 0],
      ["l", this.lineLength, 0]
    ];
  }
  toCanvasContext(t) {
    this.startColor && this.endColor && this.setAttr({
      stroke: t.createLinearGradient(0, 0, this.lineLength, 0, {
        0: this.startColor,
        1: this.endColor
      })
    }), t.beginPath(), t.moveTo(0, 0), t.lineTo(this.lineLength, 0);
  }
  // 绝对值 - 考虑 transform : translate rotate scale
  intersection(t) {
    const e = this.transformPathD().normalizedLines[0], s = t.transformPathD().normalizedLines[0];
    return e.intersection(s);
  }
}
class pl extends Q {
  cx;
  cy;
  toX;
  toY;
  isLineThrough;
  constructor(t) {
    super(t), this.cx = t?.cx || 0, this.cy = t?.cy || 0, this.toX = t?.toX || 0, this.toY = t?.toY || 0, this.isLineThrough = typeof t?.isLineThrough == "boolean" ? t.isLineThrough : !1, this.setAttr({
      strokeWidth: this.getAttr("strokeWidth") || "1",
      stroke: this.getAttr("stroke") || "#000000"
    });
  }
  cloneShape() {
    return new pl({
      ...super.getBaseOptions(),
      cx: this.cx,
      cy: this.cy,
      toX: this.toX,
      toY: this.toY,
      isLineThrough: this.isLineThrough
    });
  }
  // 供外部变更
  update(t) {
    typeof t.cx == "number" && (this.cx = t.cx, this.shouldUpdatePathD = !0), typeof t.cy == "number" && (this.cy = t.cy, this.shouldUpdatePathD = !0), typeof t.toX == "number" && (this.toX = t.toX, this.shouldUpdatePathD = !0), typeof t.toY == "number" && (this.toY = t.toY, this.shouldUpdatePathD = !0), typeof t.isLineThrough == "boolean" && (this.isLineThrough = t.isLineThrough, this.shouldUpdatePathD = !0);
  }
  toSVGPathData() {
    if (this.isLineThrough) {
      const t = this.cx * 2 - (0 + this.toX) / 2, e = this.cy * 2 - (0 + this.toY) / 2;
      return [
        ["m", 0, 0],
        ["q", t, e, this.toX, this.toY]
      ];
    } else
      return [
        ["m", 0, 0],
        ["q", this.cx, this.cy, this.toX, this.toY]
      ];
  }
  toCanvasContext(t) {
    if (t.beginPath(), t.moveTo(0, 0), this.isLineThrough) {
      const e = this.cx * 2 - (0 + this.toX) / 2, s = this.cy * 2 - (0 + this.toY) / 2;
      t.quadraticCurveTo(e, s, this.toX, this.toY);
    } else
      t.quadraticCurveTo(this.cx, this.cy, this.toX, this.toY);
  }
}
class Sr extends Q {
  points;
  isStraight;
  constructor(t) {
    super(t), this.points = t?.points || [], this.isStraight = typeof t?.isStraight == "boolean" ? t.isStraight : !0, this.setAttr({
      strokeWidth: this.getAttr("strokeWidth") || "1",
      stroke: this.getAttr("stroke") || "#000000"
    });
  }
  cloneShape() {
    return new Sr({
      ...super.getBaseOptions(),
      points: [...this.points],
      isStraight: this.isStraight
    });
  }
  // 供外部变更
  update(t) {
    "points" in t && (this.points = [...t.points || this.points], this.shouldUpdatePathD = !0), typeof t.isStraight == "boolean" && (this.isStraight = t.isStraight, this.shouldUpdatePathD = !0);
  }
  toSVGPathData() {
    const t = [];
    if (this.points.length < 3)
      return t;
    const e = this.points.length;
    if (this.isStraight) {
      t.push(["m", this.points[0].x, this.points[0].y]);
      for (let s = 1; s <= e - 1; s++)
        t.push([
          "l",
          this.points[s].x - this.points[s - 1].x,
          this.points[s].y - this.points[s - 1].y
        ]);
      t.push(["z"]);
    } else {
      const s = (this.points[0].x + this.points[e - 1].x) / 2, i = (this.points[0].y + this.points[e - 1].y) / 2;
      let r = s, o = i;
      t.push(["m", r, o]);
      for (let a = 0; a < e - 1; a++) {
        const h = (this.points[a].x + this.points[a + 1].x) / 2, c = (this.points[a].y + this.points[a + 1].y) / 2;
        t.push([
          "q",
          this.points[a].x - r,
          this.points[a].y - o,
          h - r,
          c - o
        ]), r = h, o = c;
      }
      t.push([
        "q",
        this.points[e - 1].x - r,
        this.points[e - 1].y - o,
        s - r,
        i - o
      ]);
    }
    return t;
  }
  toCanvasContext(t) {
    if (this.points.length < 3)
      return;
    t.beginPath();
    const e = this.points.length;
    if (this.isStraight) {
      t.moveTo(this.points[0].x, this.points[0].y);
      for (let s = 1; s <= e - 1; s++)
        t.lineTo(this.points[s].x, this.points[s].y);
      t.closePath();
    } else {
      const s = (this.points[0].x + this.points[e - 1].x) / 2, i = (this.points[0].y + this.points[e - 1].y) / 2;
      t.moveTo(s, i);
      for (let r = 0; r < e - 1; r++) {
        const o = (this.points[r].x + this.points[r + 1].x) / 2, a = (this.points[r].y + this.points[r + 1].y) / 2;
        t.quadraticCurveTo(
          this.points[r].x,
          this.points[r].y,
          o,
          a
        );
      }
      t.quadraticCurveTo(
        this.points[e - 1].x,
        this.points[e - 1].y,
        s,
        i
      );
    }
  }
  isPointInShape(t) {
    const e = this.points.length;
    let s = !1;
    const i = 2e-10;
    for (let r = 0, o = e - 1; r < e; o = r, r++) {
      const a = this.points[r].x, h = this.points[r].y, c = this.points[o].x, l = this.points[o].y;
      if (a === t.x && h === t.y || c === t.x && l === t.y || t.y === h && t.y === l)
        return !0;
      if (t.y >= h && t.y < l || t.y < h && t.y >= l) {
        const u = (c - a) / (l - h), d = a + u * (t.y - h);
        if (d === t.x || Math.abs(d - t.x) < i)
          return !0;
        d > t.x && (s = !s);
      }
    }
    return s;
  }
  [Symbol.iterator]() {
    let t = -1;
    return {
      next: () => ({
        value: t <= this.points.length - 1 ? this.points[++t] : void 0,
        done: t >= this.points.length
      })
    };
  }
  static generate(t, e, s, i) {
    const r = [];
    for (let o = 0; o < i; o++) {
      const a = o / i * 2 * Math.PI, { dx: h, dy: c } = He(a, s);
      r.push({ x: t + h, y: e + c });
    }
    return new Sr({ points: r });
  }
}
class gl extends Nt {
  length = 100;
  constructor(t) {
    super(t);
    const e = new ls({
      drag: {
        followSibling: !0
      },
      lineLength: this.length
    });
    this.addShape(e);
    const s = new ls({
      drag: {
        followSibling: !0
      },
      lineLength: 20 + Math.random() * 20
    });
    this.addShape(s, {
      dX: 90 - Math.random() * 40,
      dDegree: Math.random() * 70
    });
    const i = new ls({
      drag: {
        followSibling: !0
      },
      lineLength: 20 + Math.random() * 20
    });
    this.addShape(i, {
      dX: 90 - Math.random() * 40,
      dDegree: -Math.random() * 70
    }), this.comboRotate(-90, !0);
  }
  cloneShapeCombo() {
    return new gl(super.getBaseOptions());
  }
}
class js extends Q {
  ballRadius;
  constructor(t) {
    super(t), this.ballRadius = t?.ballRadius || 0;
  }
  cloneShape() {
    return new js({
      ...super.getBaseOptions(),
      ballRadius: this.ballRadius
    });
  }
  // 供外部使用：基本属性变更
  update(t) {
    typeof t.ballRadius == "number" && (this.ballRadius = t.ballRadius, this.shouldUpdatePathD = !0);
  }
  getBoundingClientRect() {
    return {
      x: -this.ballRadius,
      y: -this.ballRadius,
      width: this.ballRadius * 2,
      height: this.ballRadius * 2
    };
  }
  toSVGEl() {
    const t = We("circle");
    return this.setAttr({
      cx: "0",
      cy: "0",
      r: String(this.ballRadius)
    }), t;
  }
  toSVGPathData() {
    return this.ballRadius ? [
      ["m", 0, -this.ballRadius],
      [
        "a",
        this.ballRadius,
        this.ballRadius,
        0,
        1,
        1,
        0,
        2 * this.ballRadius
      ],
      [
        "a",
        this.ballRadius,
        this.ballRadius,
        0,
        1,
        1,
        0,
        -2 * this.ballRadius
      ],
      ["z"]
    ] : [["m", 0, 0]];
  }
  toCanvasContext(t) {
    t.beginPath(), t.arc(0, 0, this.ballRadius, 0, Math.PI * 2, !0), t.closePath();
  }
  eq(t) {
    return this.x === t.x && this.y === t.y && this.ballRadius === t.ballRadius && this.mass === t.mass;
  }
  midPointBtw(t) {
    return {
      x: this.x + (t.x - this.x) / 2,
      y: this.y + (t.y - this.y) / 2
    };
  }
  length() {
    return $s(this.x, this.y);
  }
  scalar(t) {
    return this.moveTo(this.x * t, this.y * t), this;
  }
  normalize(t = 1) {
    const e = this.length();
    if (e) {
      const s = t / e;
      this.scalar(s);
    }
    return this;
  }
  clamp(t) {
    const e = this.length();
    return e && e > t && this.scalar(t / e), this;
  }
  cross(t) {
    const e = this.x, s = this.y;
    return {
      x: s * t.x - e * t.y,
      y: e * t.y - s * t.x
    };
  }
  multiply(t) {
    return {
      x: this.x * t.x,
      y: this.y * t.y
    };
  }
  div(t) {
    return {
      x: this.x / t.x,
      y: this.y / t.y
    };
  }
  add(t) {
    return {
      x: this.x + t.x,
      y: this.y + t.y
    };
  }
  sub(t) {
    return {
      x: this.x - t.x,
      y: this.y - t.y
    };
  }
  dot(t) {
    return this.x * t.x + this.y * t.y;
  }
  reflect(t) {
    const e = this.dot(t);
    return {
      x: this.x - 2 * e * t.x,
      y: this.y - 2 * e * t.y
    };
  }
}
class yl extends Q {
  constructor(t) {
    super(t);
  }
  cloneShape() {
    return new yl({
      ...super.getBaseOptions()
    });
  }
  toSVGPathData() {
    return [
      ["m", -50, -25],
      ["l", 50, 0],
      ["l", 0, -25],
      ["l", 50, 50],
      ["l", -50, 50],
      ["l", 0, -25],
      ["l", -50, 0],
      ["l", 0, -50],
      ["z"]
    ];
  }
  toCanvasContext(t) {
    t.beginPath(), t.moveTo(-50, -25), t.lineTo(0, -25), t.lineTo(0, -50), t.lineTo(50, 0), t.lineTo(0, 50), t.lineTo(0, 25), t.lineTo(-50, 25), t.lineTo(-50, -25), t.closePath();
  }
}
class Ze extends Q {
  rectWidth;
  rectHeight;
  rectBorderRadius;
  constructor(t) {
    super(t), this.rectWidth = t.rectWidth || 0, this.rectHeight = t.rectHeight || 0, this.rectBorderRadius = t.rectBorderRadius || 0;
  }
  cloneShape() {
    return new Ze({
      ...super.getBaseOptions(),
      rectWidth: this.rectWidth,
      rectHeight: this.rectHeight,
      rectBorderRadius: this.rectBorderRadius
    });
  }
  // 供外部使用：基本属性变更
  update(t) {
    typeof t.rectWidth == "number" && (this.rectWidth = t.rectWidth, this.shouldUpdatePathD = !0), typeof t.rectHeight == "number" && (this.rectHeight = t.rectHeight, this.shouldUpdatePathD = !0), typeof t.rectBorderRadius == "number" && (this.rectBorderRadius = t.rectBorderRadius, this.shouldUpdatePathD = !0);
  }
  getBoundingClientRect() {
    return {
      x: 0,
      y: 0,
      width: this.rectWidth,
      height: this.rectHeight
    };
  }
  toSVGEl() {
    const t = We("rect");
    return this.setAttr({
      x: "0",
      y: "0",
      width: String(this.rectWidth),
      height: String(this.rectHeight),
      rx: String(this.rectBorderRadius),
      ry: String(this.rectBorderRadius)
    }), t;
  }
  toSVGPathData() {
    return this.rectBorderRadius ? [
      ["m", this.rectBorderRadius, 0],
      ["l", this.rectWidth - this.rectBorderRadius * 2, 0],
      [
        "a",
        this.rectBorderRadius,
        this.rectBorderRadius,
        0,
        0,
        1,
        this.rectBorderRadius,
        this.rectBorderRadius
      ],
      ["l", 0, this.rectHeight - this.rectBorderRadius * 2],
      [
        "a",
        this.rectBorderRadius,
        this.rectBorderRadius,
        0,
        0,
        1,
        -this.rectBorderRadius,
        this.rectBorderRadius
      ],
      ["l", this.rectBorderRadius * 2 - this.rectWidth, 0],
      [
        "a",
        this.rectBorderRadius,
        this.rectBorderRadius,
        0,
        0,
        1,
        -this.rectBorderRadius,
        -this.rectBorderRadius
      ],
      ["l", 0, this.rectBorderRadius * 2 - this.rectHeight],
      [
        "a",
        this.rectBorderRadius,
        this.rectBorderRadius,
        0,
        0,
        1,
        this.rectBorderRadius,
        -this.rectBorderRadius
      ],
      ["z"]
    ] : [
      ["m", 0, 0],
      ["l", this.rectWidth, 0],
      ["l", 0, this.rectHeight],
      ["l", -this.rectWidth, 0],
      ["z"]
    ];
  }
  toCanvasContext(t) {
    t.beginPath(), this.rectBorderRadius <= 0 ? t.rect(0, 0, this.rectWidth, this.rectHeight) : (t.moveTo(0, this.rectBorderRadius), t.lineTo(0, this.rectHeight - this.rectBorderRadius), t.quadraticCurveTo(
      0,
      this.rectHeight,
      this.rectBorderRadius,
      this.rectHeight
    ), t.lineTo(this.rectWidth - this.rectBorderRadius, this.rectHeight), t.quadraticCurveTo(
      this.rectWidth,
      this.rectHeight,
      this.rectWidth,
      this.rectHeight - this.rectBorderRadius
    ), t.lineTo(this.rectWidth, this.rectBorderRadius), t.quadraticCurveTo(
      this.rectWidth,
      0,
      this.rectWidth - this.rectBorderRadius,
      0
    ), t.lineTo(this.rectBorderRadius, 0), t.quadraticCurveTo(0, 0, 0, this.rectBorderRadius)), t.closePath();
  }
  static fromCubicBezier(t, e, s, i, r, o, a, h) {
    const l = new xt({
      x: t,
      y: e,
      c1x: s,
      c1y: i,
      c2x: r,
      c2y: o,
      toX: a,
      toY: h
    }).getBoundingClientRect();
    return new Ze({
      x: l.x,
      y: l.y,
      rectWidth: l.width,
      rectHeight: l.height
    });
  }
  eq(t) {
    return this.x === t.x && this.y === t.y && this.rectWidth === t.rectWidth && this.rectHeight === t.rectHeight && this.rectBorderRadius === t.rectBorderRadius;
  }
  intersection(t) {
    return !(this.x + this.rectWidth < t.x || t.x + t.rectWidth < this.x || this.y + this.rectHeight < t.y || t.y + t.rectHeight < this.y);
  }
  isPointInShape(t) {
    return t.x >= this.x && t.x <= this.x + this.rectWidth && t.y >= this.y && t.y <= this.y + this.rectHeight;
  }
}
class xl extends Q {
  rx;
  ry;
  constructor(t) {
    super(t), this.rx = t?.heartRx || 10, this.ry = t?.heartRy || 10;
  }
  cloneShape() {
    return new xl({
      ...super.getBaseOptions(),
      heartRx: this.rx,
      heartRy: this.ry
    });
  }
  toSVGPathData() {
    return [
      ["m", 0, 0],
      // bottom right curve
      ["l", this.rx * 2.4, -this.ry * 3.14],
      // top right curve
      ["a", this.rx / 2, this.ry / 2, 0, 0, 0, -this.rx * 2.4, -this.ry * 1.5],
      // top left curve
      ["a", this.rx / 2, this.ry / 2, 0, 0, 0, -this.rx * 2.4, this.ry * 1.5],
      // bottom left curve
      ["l", this.rx * 2.4, this.ry * 3.14],
      ["z"]
    ];
  }
}
class wl extends Q {
  rx;
  ry;
  constructor(t) {
    super(t), this.rx = t?.heartRx || 50, this.ry = t?.heartRy || 50;
  }
  cloneShape() {
    return new wl({
      ...super.getBaseOptions(),
      heartRx: this.rx,
      heartRy: this.ry
    });
  }
  toSVGPathData() {
    return [
      ["m", 0, 0 + this.ry * 0.3],
      // top left curve
      ["C", 0, 0, 0 - this.rx / 2, 0, 0 - this.rx / 2, 0 + this.ry * 0.3],
      // bottom left curve
      [
        "C",
        0 - this.rx / 2,
        0 + (this.ry + this.ry * 0.3) / 2,
        0,
        0 + (this.ry + this.ry * 0.3) / 1.4,
        0,
        0 + this.ry
      ],
      // bottom right curve
      [
        "C",
        0,
        0 + (this.ry + this.ry * 0.3) / 1.8,
        0 + this.rx / 2,
        0 + (this.ry + this.ry * 0.3) / 2,
        0 + this.rx / 2,
        0 + this.ry * 0.3
      ],
      // top right curve
      ["C", 0 + this.rx / 2, 0, 0, 0, 0, 0 + this.ry * 0.3],
      ["z"]
    ];
  }
}
class bl extends Q {
  r;
  constructor(t) {
    super(t), this.r = t?.starR || 20;
  }
  cloneShape() {
    return new bl({
      ...super.getBaseOptions(),
      starR: this.r
    });
  }
  toSVGPathData() {
    const t = [["m", 0, -this.r]];
    for (let e = 0; e < 6; e += 1) {
      const s = 288 + e * 144, i = this.r * Math.cos(q(s)), r = this.r * Math.sin(q(s));
      t.push(["l", i, r]);
    }
    return t;
  }
}
class vl extends Q {
  constructor(t) {
    super(t);
  }
  cloneShape() {
    return new vl({
      ...super.getBaseOptions()
    });
  }
  toSVGPathData() {
    return [
      ["m", 4, 24],
      ["l", 4, -8],
      ["l", 6, -6],
      ["l", 1, -10],
      ["l", -6, -10],
      ["l", -7, 10],
      ["l", -4, 0],
      ["l", -7, -10],
      ["l", -6, 10],
      ["l", 1, 10],
      ["l", 6, 6],
      ["l", 4, 8],
      ["z"]
    ];
  }
  toCanvasContext(t) {
    t.beginPath(), t.moveTo(4, 24), t.lineTo(8, 16), t.lineTo(14, 10), t.lineTo(15, 0), t.lineTo(9, -10), t.lineTo(2, 0), t.lineTo(-2, 0), t.lineTo(-9, -10), t.lineTo(-15, 0), t.lineTo(-14, 10), t.lineTo(-8, 16), t.lineTo(-4, 24), t.closePath();
  }
}
class _l extends Q {
  constructor(t) {
    super(t);
  }
  cloneShape() {
    return new _l({
      ...super.getBaseOptions()
    });
  }
  toSVGPathData() {
    return [
      ["M", 0, 0],
      ["C", 15, 0, 15, -40, 5, -30],
      ["L", 0, 0],
      ["C", -15, 0, -15, -40, -5, -30],
      ["L", 0, 0],
      ["a", 15, 15, 0, 1, 1, 0, 2 * 15],
      ["a", 15, 15, 0, 1, 1, 0, -2 * 15]
    ];
  }
}
class Sl extends Q {
  constructor(t) {
    super({
      ...t,
      initD: "m5.068 9.267-3.08-.77a.512.512 0 0 1 0-.994l3.08-.77a2.289 2.289 0 0 0 1.665-1.665l.77-3.08a.512.512 0 0 1 .994 0l.77 3.08c.205.82.845 1.46 1.665 1.665l3.08.77a.512.512 0 0 1 0 .994l-3.08.77a2.29 2.29 0 0 0-1.665 1.665l-.77 3.08a.512.512 0 0 1-.994 0l-.77-3.08a2.289 2.289 0 0 0-1.665-1.665Z"
    });
  }
  cloneShape() {
    return new Sl({
      ...super.getBaseOptions()
    });
  }
}
class Cl extends Q {
  rx;
  ry;
  constructor(t) {
    super(t), this.rx = t?.rx || 0, this.ry = t?.ry || 0;
  }
  cloneShape() {
    return new Cl({
      ...super.getBaseOptions(),
      rx: this.rx,
      ry: this.ry
    });
  }
  getBoundingClientRect() {
    return {
      x: this.x - this.rx,
      y: this.y - this.ry,
      width: this.rx * 2,
      height: this.ry * 2
    };
  }
  toSVGEl() {
    const t = We("ellipse");
    return this.setAttr({
      cx: "0",
      cy: "0",
      rx: String(this.rx),
      ry: String(this.ry)
    }), t;
  }
  toSVGPathData() {
    return [
      ["m", 0, -this.ry],
      ["a", this.rx, this.ry, 0, 1, 1, 0, 2 * this.ry],
      ["a", this.rx, this.ry, 0, 1, 1, 0, -2 * this.ry],
      ["z"]
    ];
  }
  toCanvasContext(t) {
    t.beginPath(), t.ellipse(0, 0, this.rx, this.ry, 0, 0, 2 * Math.PI, !0), t.closePath();
  }
}
class El extends Nt {
  showFlame;
  flame;
  ship;
  constructor(t) {
    super(t), this.showFlame = typeof t?.showFlame == "boolean" ? t?.showFlame : !0, this.flame = new Q({
      initD: [["M", -15, 0], ["L", -2.5, -5], ["L", -2.5, 5], ["Z"]],
      drag: {
        followSibling: !0
      }
    }), this.showFlame && this.addShape(this.flame), this.ship = new Q({
      initD: [
        ["M", 10, 0],
        ["L", -10, 10],
        ["L", -5, 0],
        ["L", -10, -10],
        ["L", 10, 0],
        ["Z"]
      ],
      drag: {
        followSibling: !0
      }
    }), this.addShape(this.ship);
  }
  cloneShapeCombo() {
    return new El({
      ...super.getBaseOptions(),
      showFlame: this.showFlame
    });
  }
  // 供外部使用：基本属性变更
  update(t) {
    typeof t?.showFlame == "boolean" && (this.shapes = [], this.showFlame = t?.showFlame, this.showFlame && this.addShape(this.flame), this.addShape(this.ship));
  }
}
class Pl extends Nt {
  width;
  height;
  cornerRadius;
  constructor(t) {
    super(t), this.width = t.segmentWidth, this.height = t.segmentHeight, this.cornerRadius = typeof t.segmentCornerRadius == "number" ? t.segmentCornerRadius : this.height * 0.5;
    const e = new Ze({
      drag: {
        followSibling: !0
      },
      rectWidth: this.width + this.cornerRadius * 2,
      rectHeight: this.height,
      rectBorderRadius: this.cornerRadius
    });
    this.addShape(e, {
      dX: 0 - this.cornerRadius,
      dY: 0 - this.height * 0.5
    });
    const s = new js({
      drag: {
        followSibling: !0
      },
      ballRadius: 2
    });
    this.addShape(s);
    const i = new js({
      drag: {
        followSibling: !0
      },
      ballRadius: 2
    });
    this.addShape(i, { dX: 0 + this.width });
  }
  cloneShapeCombo() {
    return new Pl({
      ...super.getBaseOptions(),
      segmentWidth: this.width,
      segmentHeight: this.height,
      segmentCornerRadius: this.cornerRadius
    });
  }
  // 重写覆盖
  getBoundingClientRectCenter() {
    return {
      x: 0,
      y: 0
    };
  }
  // 绝对值
  getPin() {
    const t = this.shapes[1];
    return {
      x: t.x + Math.cos(q(t.degree)) * this.width,
      y: t.y + Math.sin(q(t.degree)) * this.width
    };
  }
}
class Tl extends Nt {
  options;
  value$ = new ke();
  subscription;
  constructor(t) {
    super(t), this.options = t;
    const e = t?.sliderMin || 0, s = t?.sliderMax || 100, i = t?.sliderStep || 1, r = Xu(e, s, i), o = r(
      typeof t?.sliderDefaultValue == "number" ? N(t.sliderDefaultValue, e, s) : e
    );
    this.value$.next(o);
    const a = o / (s - e), h = t?.sliderWidth || 100, c = t?.sliderHeight || 4, l = c * 0.5, u = c * 2.5, d = t?.sliderBackgroundColor || "#f5f5f5", f = t?.sliderForegroundColor || "#5a82f0", m = new Ze({
      rectWidth: h,
      rectHeight: c,
      rectBorderRadius: l,
      attrs: {
        fill: d
      },
      drag: {
        enable: !1
      }
    });
    this.addShape(m);
    const p = new Ze({
      rectWidth: h * a,
      rectHeight: c,
      rectBorderRadius: l,
      attrs: {
        fill: f
      },
      drag: {
        enable: !1
      }
    });
    this.addShape(p);
    const S = new js({
      x: h * a,
      y: l,
      ballRadius: u,
      attrs: {
        fill: f
      },
      drag: {
        enable: !0,
        alongPath: new At([
          ["m", 0, 0],
          ["l", h, 0]
        ])
      }
    });
    this.addShape(S), this.subscription = S.transform$.subscribe(({ dX: g }) => {
      console.log(g);
      const b = (S.x - m.x) / h;
      p.update({
        rectWidth: h * b
      }), this.value$.next(r(b * (s - e) + e));
    });
  }
  destroy() {
    super.destroy(), this.subscription.unsubscribe();
  }
  cloneShapeCombo() {
    return new Tl({
      ...super.getBaseOptions(),
      ...this.options
    });
  }
}
class Wn extends Q {
  half;
  lineWidth;
  radius;
  startDegree;
  endDegree;
  percent = 0;
  percentDegree = 0;
  // public bgColor?: CanvasGradient | string;
  startColor;
  endColor;
  constructor(t) {
    super(t), this.half = typeof t?.half == "boolean" ? t?.half : !1, this.lineWidth = t.lineWidth;
    const e = t.width || 0, s = t.height || 0, i = (t.endDegree - t.startDegree - 180) / 2;
    if (t.radius)
      this.radius = t.radius;
    else if (this.half) {
      const r = Math.min(e / 2, s) - this.lineWidth;
      this.radius = Math.max(0, r - r * Math.sin(q(i)));
    } else
      this.radius = Math.max(
        0,
        Math.min(e / 2, s / 2) - this.lineWidth
      );
    t.x || (this.x = e / 2), t.y || (this.half ? this.y = s - this.lineWidth - this.radius * Math.sin(q(i)) : this.y = s / 2), t.forceCoordinate ? (this.startDegree = t.startDegree, this.endDegree = t.endDegree) : (this.startDegree = -90 + t.startDegree, this.endDegree = -90 + t.endDegree), this.startColor = t?.startColor, this.endColor = t?.endColor, this.setAttr({
      "stroke-linecap": "round",
      "stroke-width": String(this.lineWidth),
      stroke: this.startColor || "#000000"
    }), this.setPercent(t.percent || 1);
  }
  cloneShape() {
    return new Wn({
      ...super.getBaseOptions(),
      half: this.half,
      lineWidth: this.lineWidth,
      radius: this.radius,
      forceCoordinate: !0,
      startDegree: this.startDegree,
      endDegree: this.endDegree,
      startColor: this.startColor,
      endColor: this.endColor,
      percent: this.percent
    });
  }
  // 提供外部变更
  setPercent(t) {
    this.percent = Math.max(0, t), this.percentDegree = this.startDegree + (this.endDegree - this.startDegree) * t;
  }
  enableGradient(t, e) {
    this.startColor = t, this.endColor = e, this.setAttr({
      stroke: this.startColor
    });
  }
  disableGradient(t) {
    this.startColor = t, this.endColor = void 0, this.setAttr({
      stroke: this.startColor
    });
  }
  toSVGPathData() {
    const { dx: t, dy: e } = He(
      q(this.startDegree),
      this.radius
    ), { dx: s, dy: i } = He(
      q(this.percentDegree),
      this.radius
    );
    return [
      ["m", t, e],
      [
        "a",
        this.radius,
        this.radius,
        0,
        Math.abs(this.percentDegree - this.startDegree) >= 180 ? 1 : 0,
        1,
        s - t,
        i - e
      ]
    ];
  }
  toCanvasContext(t) {
    if (this.startColor && this.endColor) {
      let e;
      if (this.half) {
        const s = this.radius - this.radius * Math.cos(Math.PI * this.percent), i = this.radius * Math.sin(Math.PI * this.percent);
        e = t.createLinearGradient(
          -this.radius,
          0,
          -this.radius + s,
          -i,
          {
            0: this.startColor,
            1: this.endColor
          }
        );
      } else {
        const s = this.radius * Math.sin(2 * Math.PI * this.percent), i = this.radius * Math.cos(2 * Math.PI * this.percent);
        e = t.createLinearGradient(0, -this.radius, s, -i, {
          0: this.startColor,
          1: this.endColor
        });
      }
      this.setAttr({
        stroke: e
      });
    }
    t.beginPath(), t.arc(
      0,
      0,
      this.radius,
      q(this.startDegree),
      q(this.percentDegree),
      !1
    );
  }
}
class Ml extends Nt {
  half;
  lineWidth;
  width;
  height;
  bgColor;
  startColor;
  endColor;
  startDegree;
  endDegree;
  percent = 0;
  ringBg;
  ring;
  lines = [];
  indicatorLineCount;
  constructor(t) {
    if (super(t), this.half = typeof t?.half == "boolean" ? t?.half : !1, this.lineWidth = t?.lineWidth || 12, this.width = t.width, this.height = t.height, this.bgColor = t?.bgColor, this.startColor = t?.startColor, this.endColor = t?.endColor, this.half ? (this.startDegree = t?.startDegree || -90 - 15, this.endDegree = t?.endDegree || 90 + 15) : (this.startDegree = t?.startDegree || 0, this.endDegree = t?.endDegree || 360), this.percent = t?.percent || 0, this.ringBg = new Wn({
      half: this.half,
      lineWidth: this.lineWidth,
      width: t.width,
      height: t.height,
      startDegree: this.startDegree,
      endDegree: this.endDegree,
      startColor: this.bgColor,
      percent: 1
    }), this.addShape(this.ringBg), this.ring = new Wn({
      half: this.half,
      lineWidth: this.lineWidth,
      width: t.width,
      height: t.height,
      startDegree: this.startDegree,
      endDegree: this.endDegree,
      startColor: this.startColor,
      endColor: this.endColor,
      percent: 0
    }), this.addShape(this.ring), this.indicatorLineCount = 22 + 1, this.half) {
      const r = this.ringBg.radius - 20 - 17;
      for (let o = 0; o < this.indicatorLineCount; o++) {
        const a = new ls({
          lineLength: 17,
          startColor: this.startColor,
          endColor: this.endColor,
          attrs: {
            "stroke-linecap": "round",
            "stroke-width": String(2),
            stroke: this.bgColor
          }
        });
        this.lines.push(a);
        const h = -90 + this.startDegree + (this.endDegree - this.startDegree) / (this.indicatorLineCount - 1) * o;
        this.addShape(a, {
          dX: this.ringBg.x + Math.cos(q(h)) * r,
          dY: this.ringBg.y + Math.sin(q(h)) * r,
          dDegree: h
        });
      }
    }
    this.setPercent(t.percent || 0);
  }
  cloneShapeCombo() {
    return new Ml({
      ...super.getBaseOptions(),
      half: this.half,
      lineWidth: this.lineWidth,
      width: this.width,
      height: this.height,
      bgColor: this.bgColor,
      startColor: this.startColor,
      endColor: this.endColor,
      startDegree: this.startDegree,
      endDegree: this.endDegree,
      percent: this.percent
    });
  }
  // 提供外部变更
  setPercent(t) {
    if (this.percent = Math.max(0, t), this.ring.setPercent(t), this.half)
      for (let e = 0; e < this.indicatorLineCount; e++)
        e / (this.indicatorLineCount - 1) <= this.percent ? this.lines[e].enableGradient(this.startColor, this.endColor) : this.lines[e].disableGradient(this.bgColor);
  }
}
class Rs extends Q {
  text;
  width = 0;
  height = 0;
  constructor(t) {
    super(t), this.text = t.text, this.setAttr({
      // default attributes
      fontSize: "10px",
      fontFamily: 'system-ui, Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
      // see https://nolanlawson.com/2022/04/08/the-struggle-of-using-native-emoji-on-the-web/
      emojiFontFamily: '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif',
      fill: "#666666",
      stroke: "none",
      "alignment-baseline": "middle",
      textAnchor: "start",
      // start | end
      // custom attributes
      ...this.attrs
    });
    const e = Hi(this.getAttr("fontSize"), 10).number, s = Hi(this.getAttr("fontWeight"), 400).number, i = Rs.measureText(this.text, e, s);
    this.width = i.width, this.height = i.height;
  }
  cloneShape() {
    return new Rs({
      ...super.getBaseOptions(),
      text: this.text
    });
  }
  toSVGEl() {
    const t = We("text");
    t.setAttribute("x", "0"), t.setAttribute("y", "0"), t.style.alignmentBaseline = "middle";
    const e = this.text.split(`
`);
    if (e.length <= 1)
      t.innerHTML = this.text;
    else {
      const s = this.getAttr("line-height", "1.2em");
      e.forEach((i, r) => {
        if (i.trim()) {
          const o = We("tspan");
          o.setAttribute("x", "0"), o.setAttribute("dy", r > 0 ? s : "0"), o.innerHTML = i.trim(), o.style.alignmentBaseline = "middle", t.append(o);
        }
      });
    }
    return t;
  }
  toSVGPathData() {
    return [];
  }
  toCanvasContext(t) {
    const e = this.text.split(`
`);
    if (e.length <= 1)
      t.fillText(this.text, 0, 0);
    else {
      const s = t.measureText(this.text), r = (s.actualBoundingBoxAscent + s.actualBoundingBoxDescent) * parseFloat(this.getAttr("line-height", "1.2em"));
      let o = 0;
      e.forEach((a, h) => {
        a.trim() && (o += h > 0 ? r : 0, t.fillText(a.trim(), 0, o));
      });
    }
  }
  static measureText(t, e = 12, s = 400) {
    const i = document.createElement("span");
    i.style.visibility = "hidden", i.style.margin = "0", i.style.padding = "0", i.style.inset = "0", i.style.whiteSpace = "nowrap", i.style.overflow = "visible", i.style.fontSize = e + "px", i.style.fontWeight = s.toString(), i.innerText = t, document.body.appendChild(i);
    const r = i.offsetWidth, o = i.offsetHeight;
    return document.body.removeChild(i), { width: r, height: o };
  }
  /**
   * 获取固定宽度的字符串，如果传入的text的宽度不够width,则返回原字符串
   * @text   将要被提取的原字符串
   * @width  想要提取的字符串长度
   * @fontSize  字符串显示时的字符大小，支持>=12
   * @fontWeight  字符串显示时的字符粗细
   * @isNeedEllipsis   当text的宽度大于width时是否需要省略号
   */
  static getFixedWidthText(t, e, s = 12, i = 400, r = "...") {
    let o = "";
    if (!t || e < s)
      return o;
    const a = t.split("");
    let h = r ? Rs.measureText(r, s, i).width : 0;
    for (let c = 0, l = a.length; c < l; c++)
      if (h += Rs.measureText(a[c], s, i).width, h > e) {
        r && (o += r);
        break;
      } else
        o += a[c];
    return o;
  }
}
class Al extends Nt {
  options;
  constructor(t) {
    super(t), this.options = t;
    const {
      shapeCreator: e,
      width: s,
      height: i,
      x: r,
      y: o,
      particleCount: a,
      angle: h,
      spread: c,
      startVelocity: l,
      decay: u,
      gravity: d,
      drift: f,
      ticks: m,
      colors: p,
      scalar: S,
      flat: g
    } = Object.assign(
      {
        shapeCreator: () => new Ze({ rectWidth: 10, rectHeight: 10 }),
        width: 100,
        height: 100,
        x: 0.5,
        y: 0.6,
        particleCount: 100,
        angle: 90,
        spread: 70,
        startVelocity: 45,
        decay: 0.9,
        gravity: 1,
        drift: 0,
        ticks: 200,
        colors: Ft.getColors(),
        scalar: 1,
        flat: !1
      },
      t || {}
    ), b = (_, D) => {
      _.x = s * r, _.y = i * o, _.scaleX = S, _.scaleY = S;
      const z = p[D % p.length];
      _.setAttr({
        fill: z
      }), _.interactive = !1, _.wobble = Math.random() * 10, _.wobbleSpeed = Math.min(0.11, Math.random() * 0.1 + 0.05), _.velocity = l * 0.5 + Math.random() * l, _.angle2D = -x + (0.5 * w - Math.random() * w), _.tiltAngle = (Math.random() * (0.75 - 0.25) + 0.25) * Math.PI, _.tick = 0, _.totalTicks = m, _.decay = u, _.drift = f, _.random = Math.random() + 2, _.tiltSin = 0, _.tiltCos = 0, _.wobbleX = 0, _.wobbleY = 0, _.gravity = d * 3, _.scalar = S, _.flat = g, _.color = new Ft(z);
    }, x = q(h), w = q(c);
    let C = a;
    for (; C; ) {
      const _ = e();
      b(_, C), _.clone = ((D) => () => {
        const z = e();
        return b(z, D), z;
      })(C), this.addShape(_), C--;
    }
  }
  cloneShapeCombo() {
    return new Al(this.options);
  }
  // 提供外部变更
  update() {
    return this.shapes = this.shapes.filter((t) => {
      t.x += Math.cos(t.angle2D) * t.velocity + t.drift, t.y += Math.sin(t.angle2D) * t.velocity + t.gravity, t.velocity *= t.decay, t.flat ? (t.wobble = 0, t.wobbleX = t.x + 10 * t.scalar, t.wobbleY = t.y + 10 * t.scalar, t.tiltSin = 0, t.tiltCos = 0, t.random = 1) : (t.wobble += t.wobbleSpeed, t.wobbleX = t.x + 10 * t.scalar * Math.cos(t.wobble), t.wobbleY = t.y + 10 * t.scalar * Math.sin(t.wobble), t.tiltAngle += 0.1, t.tiltSin = Math.sin(t.tiltAngle), t.tiltCos = Math.cos(t.tiltAngle), t.random = Math.random() + 2);
      const e = t.tick++ / t.totalTicks, s = t.x + t.random * t.tiltCos, i = t.y + t.random * t.tiltSin, r = t.wobbleX + t.random * t.tiltCos, o = t.wobbleY + t.random * t.tiltSin;
      return t.setAttr("fill", t.color.setAlpha(1 - e).toString()), t.degree = wt(Math.PI / 10 * t.wobble), t.scaleX = Math.abs(r - s) * 0.1, t.scaleY = Math.abs(o - i) * 0.1, t.tick < t.totalTicks;
    }), this.shapes.length > 0;
  }
}
function Tg(n, t = {
  attributes: !0,
  childList: !0,
  subtree: !0
}) {
  return new nt((e) => {
    const s = new MutationObserver(
      (i, r) => {
        e.next(i);
      }
    );
    return s.observe(n, t), () => {
      s.disconnect();
    };
  });
}
function Mw(n, t) {
  return new Promise((e) => {
    new MutationObserver((i, r) => {
      for (const o of i)
        o.type === "childList" && o.addedNodes.forEach((a) => {
          a.isEqualNode(t) && (r.disconnect(), e(!0));
        });
    }).observe(n, { childList: !0 });
  });
}
function Mg(n, t = {
  root: null
  // default browser viewport 必须是目标元素的父级元素
  // threshold: 0.5, // 表示重叠面积占被观察者的比例，从 0 - 1 取值，1 表示完全被包含
}) {
  return new nt((e) => {
    const s = new IntersectionObserver(
      (i, r) => {
        if (i.length) {
          const o = i[i.length - 1];
          o && e.next(o);
        }
      },
      t
    );
    return s.observe(n), () => {
      s.unobserve(n), s.disconnect();
    };
  });
}
function Aw(n, t) {
  return og().pipe(
    Ke(null),
    it(() => {
      const { width: e, height: s } = t?.root?.getBoundingClientRect() || tl(), { top: i, left: r, right: o, bottom: a } = n.getBoundingClientRect();
      return (i >= 0 && i <= s || a >= 0 && a <= s) && (r >= 0 && r <= e || o >= 0 && o <= e);
    }),
    De()
  );
}
function Iw(n, t) {
  const e = typeof t?.threshold == "number" ? t.threshold : 0.5;
  return Mg(n, {
    threshold: e,
    root: t?.root
  }).pipe(
    it((s) => s.isIntersecting && s.intersectionRatio >= e),
    De()
  );
}
let qa = !1;
function Ag() {
  qa || (qa = !0, O0(`
    :root {
      --sat:env(safe-area-inset-top, 0px);
      --sar:env(safe-area-inset-right, 0px);
      --sab:env(safe-area-inset-bottom, 0px);
      --sal:env(safe-area-inset-left, 0px);
    }
    :host {
      --sat:env(safe-area-inset-top, 0px);
      --sar:env(safe-area-inset-right, 0px);
      --sab:env(safe-area-inset-bottom, 0px);
      --sal:env(safe-area-inset-left, 0px);
    }
  `));
}
Ag();
function kw() {
  return nl(document.documentElement).pipe(
    Kr(Wr),
    // next tick
    it(() => {
      const n = getComputedStyle(document.documentElement);
      return {
        bottom: n.getPropertyValue("--sab"),
        top: n.getPropertyValue("--sat"),
        right: n.getPropertyValue("--sar"),
        left: n.getPropertyValue("--sal")
      };
    })
  );
}
function Dw(n = {
  enableHighAccuracy: !0,
  // 使用高精度模式
  timeout: 5e3,
  // 设置最大超时时间
  maximumAge: 0
  // 每次都获取新的位置
}) {
  return new nt((t) => {
    if (!("geolocation" in navigator))
      return t.error("navigator.geolocation is not available.");
    let e;
    return new Promise((s, i) => {
      navigator.geolocation.getCurrentPosition(
        (r) => {
          t.next({
            longitude: r.coords.longitude,
            latitude: r.coords.latitude
          }), s();
        },
        (r) => {
          i(r);
        }
      );
    }).then(() => {
      e = navigator.geolocation.watchPosition(
        (s) => {
          t.next({
            longitude: s.coords.longitude,
            latitude: s.coords.latitude
          });
        },
        (s) => {
          t.error(s);
        },
        n
      );
    }).catch((s) => {
      t.error(s);
    }), () => {
      typeof e == "number" && navigator.geolocation.clearWatch(e);
    };
  });
}
function Ig(n = "(prefers-color-scheme: dark)") {
  const t = window.matchMedia(n);
  return X(t, "change").pipe(
    it((e) => e.matches),
    Ke(t.matches),
    De()
  );
}
function ja(n, t) {
  const e = typeof n == "string" ? n : n.toString(), s = () => {
    try {
      const a = window.sessionStorage.getItem(e);
      if (a)
        return Wa(a);
    } catch {
    }
  }, i = (a) => {
    try {
      typeof a.v < "u" ? window.sessionStorage.setItem(e, Mr(a)) : window.sessionStorage.removeItem(e);
    } catch {
    }
  };
  return {
    get: () => {
      const { get: a } = Fn(s(), t);
      return a().v;
    },
    set: (a) => {
      const { set: h } = Fn(s(), t), c = h(a);
      i(c);
    }
  };
}
function Lw() {
  window.sessionStorage.clear();
}
function kg() {
  return Tg(document).pipe(
    it(() => location),
    // const { pathname, search } = location;
    Ke(location)
  );
}
function Rw() {
  return kg().pipe(
    it((n) => n.href),
    Ke(location.href),
    De()
  );
}
function Ow() {
  return X(window, "hashchange").pipe(
    it(
      (n) => n.target.location.hash.replace("#", "")
    ),
    Ke(window.location.hash.replace("#", "")),
    De()
  );
}
function Dg(n = "current") {
  return X(window, "popstate").pipe(
    // 注意：当页面刷新时，history.state（最近一次 pushState/replaceState 的 state对象） 可能为 null
    // 即：浏览器可能不会自动恢复 state 对象
    // startWith(null),
    it((t) => t.state || {}),
    it((t) => ({
      ...t,
      // pop-state 转换为 标准输出-state
      [n]: t[n] || window.location.pathname + window.location.search + window.location.hash
    })),
    De((t, e) => t[n] === e[n])
  );
}
function zw(n = {
  nameInState: "current",
  alreadyPushState: !0
}) {
  const t = n.nameInState, e = typeof n.alreadyPushState == "boolean" ? n.alreadyPushState : !0, { get: s, set: i } = ja("fe-route-history"), r = s() || [], { get: o, set: a } = ja("fe-route-history-index"), h = o();
  let c = typeof h == "number" ? h : r.length - 1;
  function l(g) {
    return r.findIndex(
      (x) => x[t] === g[t]
    );
  }
  const u = { currentIndex: c };
  function d(g) {
    g = N(g, -1, r.length - 1), c < 0 ? (u.direction = "keep", u.delta = 0) : (g < c ? u.direction = "backward" : g > c ? u.direction = "forward" : u.direction = "keep", u.delta = g - c), u.from = u.to, u.to = r[g]?.[t], c = g, u.currentIndex = c, a(c);
  }
  d(c);
  function f(g) {
    r.push(g), i(r), d(r.length - 1);
  }
  function m(g, b) {
    const x = { ...b, [t]: g };
    window.history.pushState(x, "", g), f(x);
  }
  function p(g, b = e) {
    const x = l(g);
    if (x < 0) {
      c >= 0 && (r.splice(c + 1), i(r)), b ? f(g) : m(g[t], g);
      return;
    }
    x != c && d(x);
  }
  const S = Dg().subscribe((g) => {
    p(g, !0);
  });
  return {
    history: r,
    route: u,
    // 统一对外接口：前进或后退
    // 注意与 popstate$ 的前后调用顺序
    navigate: (g, b) => {
      p({ ...b, [t]: g }, e);
    },
    go(g) {
      window.history.go(g);
    },
    back() {
      window.history.back();
    },
    forward() {
      window.history.forward();
    },
    destroy: () => {
      S.unsubscribe();
    }
  };
}
function Nw(n, t, e) {
  if (typeof t == "string" && (t = Ka(t)), (typeof t == "string" || t === void 0) && e === void 0) {
    const s = Object.assign({}, n.dataset);
    return Object.keys(s).forEach((i) => {
      if (s[i]?.startsWith("[") || s[i]?.startsWith("{"))
        try {
          s[i] = JSON.parse(s[i] || "");
        } catch {
        }
    }), typeof t == "string" ? s[t] : s;
  } else {
    let s = {};
    typeof t == "object" ? s = t : typeof t == "string" && (s[t] = e), Object.entries(s).forEach(([i, r]) => {
      r ? n.dataset[i] = r instanceof Object ? JSON.stringify(r) : r : delete n.dataset[i];
    });
  }
}
function Yw(n, t) {
  t.split(/[,\s]+/).forEach((e) => {
    e.trim() != "" && delete n.dataset[e.trim()];
  });
}
function Lg(n, t) {
  const e = typeof n == "string" ? n : n.toString(), s = () => {
    try {
      const a = window.localStorage.getItem(e);
      if (a)
        return Wa(a);
    } catch {
    }
  }, i = (a) => {
    try {
      typeof a.v < "u" ? window.localStorage.setItem(e, Mr(a)) : window.localStorage.removeItem(e);
    } catch {
    }
  };
  return {
    get: () => {
      const { get: a } = Fn(s(), t);
      return a().v;
    },
    set: (a) => {
      const { set: h } = Fn(s(), t), c = h(a);
      i(c);
    }
  };
}
function Bw() {
  window.localStorage.clear();
}
const { get: Il, set: kl } = Lg(
  Zn("theme")
), Dl = new ke(), Rg = Dl.pipe(Ke(void 0));
function Ll(n) {
  switch (n) {
    case "dark":
      document.documentElement.classList.add("dark"), ds(document.documentElement, "data-theme", "dark");
      break;
    case "light":
    default:
      document.documentElement.classList.remove("dark"), ds(document.documentElement, "data-theme", "light");
      break;
  }
}
function Og(n) {
  return kl(n), Ll(n), Dl.next(n), n;
}
function Xw() {
  return Og(Il() == "dark" ? "light" : "dark");
}
function Fw() {
  return op([
    Rg,
    Ig("(prefers-color-scheme: dark)")
  ]).pipe(
    it(([n, t]) => n || (n = Il(), n || (n = t ? "dark" : "light"), kl(n), Ll(n), n))
  );
}
function Uw(n, t = "") {
  return getComputedStyle(document.documentElement).getPropertyValue(n) || t;
}
function Gw(n, t) {
  document.documentElement.style.setProperty(n, t);
}
function Vw(n, t) {
  let e = t?.value || "";
  if (!e) {
    const r = `; ${document.cookie}`.split(`; ${n}=`).pop()?.split(";").shift();
    r && (e = decodeURIComponent(r));
  }
  const s = () => e, i = (r) => {
    if (e = r, e) {
      const o = t?.domain ? "; domain=" + t.domain : "", a = t?.path ? "; path=" + t.path : "", h = t?.secure == !0 ? "; secure" : "";
      let c = n + "=" + encodeURIComponent(e) + o + a + h;
      if (t?.days) {
        const l = "; expires=" + new Date(Date.now() + t.days * 864e5).toUTCString();
        c += l;
      }
      document.cookie = c;
    }
  };
  return i(e), {
    get: s,
    set: i
  };
}
function $w() {
  const n = document.cookie.split("; ");
  for (let t = 0; t < n.length; t++) {
    const e = window.location.hostname.split(".");
    for (; e.length > 0; ) {
      const s = encodeURIComponent(n[t].split(";")[0].split("=")[0]) + "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" + e.join(".") + " ;path=", i = location.pathname.split("/");
      for (document.cookie = s + "/"; i.length > 0; )
        document.cookie = s + i.join("/"), i.pop();
      e.shift();
    }
  }
}
function zg(n, t) {
  let e;
  return n.objectStoreNames.contains(t) || (e = n.createObjectStore(t, { keyPath: "id" })), e;
}
function qw(n, t = 1, e) {
  return new Promise((s, i) => {
    let r;
    const o = window.indexedDB.open(n, t);
    o.onerror = () => {
      i("无法使用IndexDB!");
    }, o.onsuccess = (a) => {
      r = a.target.result, zg(r, e), s(r);
    };
  });
}
function jw(n, t, e = { id: 1, name: "xxx" }) {
  return new Promise((s, i) => {
    const r = n.transaction(
      [t],
      "readwrite"
    );
    r.objectStore(t).add(e), r.oncomplete = (a) => {
      s(a);
    }, r.onerror = (a) => {
      i(a);
    };
  });
}
const Cr = new Ws();
function Rl(n, t) {
  return Ar({ url: n, ...t });
}
async function ao(n, t) {
  if (typeof fetch > "u")
    throw new Error("fetch() not supported!");
  if (typeof AbortController > "u")
    throw new Error("AbortController not supported!");
  try {
    const e = Rl(n, t), s = new AbortController();
    Cr.set(e, s);
    const { responseType: i, onProgress: r, timeout: o } = {
      responseType: "json",
      timeout: 6e4,
      ...t
    }, a = setTimeout(() => {
      s.abort();
    }, o);
    let h = await fetch(
      new Request(n, {
        ...t,
        signal: s.signal
        // signal: AbortSignal.timeout(timeout) // TimeoutError
        // headers: new Headers(headers),
        // credentials: "include" || "same-origin"
      })
    );
    if (Cr.delete(e), clearTimeout(a), h.status === 200 || h.status === 0) {
      if (h.status === 0 && kn("useFetch: HTTP Status 0 received."), typeof ReadableStream < "u" && h.body && h.body.getReader && r) {
        const c = h.body.getReader(), l = h.headers.get("X-File-Size") || h.headers.get("Content-Length"), u = l ? parseInt(l) : 0, d = u !== 0;
        let f = 0;
        const m = new ReadableStream({
          start(p) {
            function S() {
              c.read().then(({ done: g, value: b }) => {
                g ? p.close() : (f += b.byteLength, r?.(
                  new ProgressEvent("progress", {
                    lengthComputable: d,
                    loaded: f,
                    total: u
                  })
                ), p.enqueue(b), S());
              }).catch((g) => {
                p.error(g);
              });
            }
            S();
          }
        });
        h = new Response(m);
      }
      switch (i) {
        case "arraybuffer":
          return await h.arrayBuffer();
        case "blob":
          return await h.blob();
        case "json":
          return await h.json();
        case "text":
        default:
          return await h.text();
      }
    } else
      throw new xf(
        `useFetch for "${h.url}" responded with ${h.status}: ${h.statusText}`,
        h
      );
  } catch (e) {
    throw e.name === "AbortError" ? new Error("Request timed out") : e.name === "TimeoutError" ? new Error("Request timed out") : e;
  }
}
function Hw(n, t) {
  const e = Cr.get(Rl(n, t));
  e && e.abort();
}
function Ww(n = 3, t) {
  return Lr(ao, n, t);
}
function Zw(n = 6e4) {
  return Rr(ao, n);
}
function Jw(n = 6e4, t = 3, e) {
  return Rr(Lr(ao, t, e), n);
}
const Ng = {
  name: "zh-cn",
  weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
  weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
  weekdaysMin: "日_一_二_三_四_五_六".split("_"),
  months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split(
    "_"
  ),
  monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
  ordinal: (n, t) => {
    switch (t) {
      case "W":
        return `${n}周`;
      default:
        return `${n}日`;
    }
  },
  weekStart: 1,
  yearStart: 4,
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "YYYY/MM/DD",
    LL: "YYYY年M月D日",
    LLL: "YYYY年M月D日Ah点mm分",
    LLLL: "YYYY年M月D日ddddAh点mm分",
    l: "YYYY/M/D",
    ll: "YYYY年M月D日",
    lll: "YYYY年M月D日 HH:mm",
    llll: "YYYY年M月D日dddd HH:mm"
  },
  relativeTime: {
    future: "%s内",
    past: "%s前",
    s: "几秒",
    m: "1 分钟",
    mm: "%d 分钟",
    h: "1 小时",
    hh: "%d 小时",
    d: "1 天",
    dd: "%d 天",
    M: "1 个月",
    MM: "%d 个月",
    y: "1 年",
    yy: "%d 年"
  },
  meridiem: (n, t) => {
    const e = n * 100 + t;
    return e < 600 ? "凌晨" : e < 900 ? "早上" : e < 1100 ? "上午" : e < 1300 ? "中午" : e < 1800 ? "下午" : "晚上";
  }
}, Yg = {
  name: "en",
  weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
    "_"
  ),
  months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
    "_"
  ),
  ordinal: (n) => {
    const t = ["th", "st", "nd", "rd"], e = n % 100;
    return `[${n}${t[(e - 20) % 10] || t[e] || t[0]}]`;
  }
}, Be = new Ws();
let Mn = "zh-cn";
Ol(Yg);
Ol(Ng);
function Ol(n, t) {
  if (!n)
    return Be.get(Mn);
  let e;
  if (typeof n == "string") {
    const s = n.toLowerCase();
    if (Be.get(s))
      e = s;
    else if (t)
      Be.set(s, t), e = s;
    else
      return Be.get(Mn);
  } else {
    const { name: s } = n;
    Be.set(s, n), e = s;
  }
  return e && (Mn = e), Be.get(e) || Be.get(Mn);
}
let Bg = 0;
function ns(n, t = {}, e = [], s) {
  return {
    name: String(++Bg),
    tag: n,
    props: t,
    children: e,
    el: s
  };
}
function ho(n) {
  return ns(
    n.tagName,
    Wc(n),
    Array.from(n.children).map((t) => ho(t)),
    n
  );
}
function Bs(n, t = document.documentElement) {
  if (n.el)
    return n.el;
  if (n.el = n.tag == "path" ? rl() : document.createElement(n.tag), n.props)
    for (const e in n.props) {
      const s = n.props[e];
      e.startsWith("on") ? n.el.addEventListener(e.slice(2).toLowerCase(), s) : e === "style" ? di(n.el, n.props[e]) : ds(n.el, e, s);
    }
  return n.children && (typeof n.children == "string" ? n.el.appendChild(document.createTextNode(n.children)) : n.children.forEach((e) => {
    Bs(e, n.el);
  })), t.appendChild(n.el), n.el;
}
function co(n, t) {
  if (!n.el)
    return;
  if (n.tag !== t.tag) {
    (n.el.parentElement || document.body).replaceChild(
      Bs(t),
      n.el
    );
    return;
  }
  const e = t.el = n.el, s = n.props, i = t.props;
  for (const a in s)
    a in i || (a.startsWith("on") ? e.removeEventListener(a.slice(2).toLowerCase(), s[a]) : e.removeAttribute(a));
  for (const a in i) {
    const h = s[a], c = i[a];
    if (c != h)
      if (a.startsWith("on")) {
        const l = a.slice(2).toLowerCase();
        e.removeEventListener(l, h), e.addEventListener(l, c);
      } else if (a === "style") {
        for (const l in h)
          l in c || Hc(e, l);
        di(e, c);
      } else
        ds(e, a, c);
  }
  const r = n.children || [], o = t.children || [];
  if (typeof o == "string")
    e.innerHTML = o;
  else if (typeof r == "string")
    e.innerHTML = "", o.forEach((a) => {
      Bs(a, e);
    });
  else {
    const a = Math.min(r.length, o.length);
    for (let h = 0; h < a; h++)
      co(r[h], o[h]);
    o.length > r.length && o.slice(r.length).forEach((h) => {
      Bs(h, e);
    }), o.length < r.length && r.slice(o.length).forEach((h) => {
      h.el && e.removeChild(h.el);
    });
  }
}
class Kw {
  state;
  el;
  constructor(t, e) {
    this.state = Yr(t, { deep: !0 }), this.el = e, this.compile(this.el);
  }
  // 解析器
  compile(t) {
    t.childNodes.forEach((e) => {
      switch (e.nodeType) {
        case 1:
          const s = e;
          [...s.attributes].forEach((a) => {
            const h = a.name, c = a.value;
            if (h === "v-model")
              if (Gc(s)) {
                const l = s;
                Te(() => {
                  l.checked = this.getStateValue(c) == l.value;
                }), l.addEventListener("change", (u) => {
                  this.setStateValue(
                    c,
                    u.target.value
                  );
                });
              } else if (Uc(s)) {
                const l = s;
                Te(() => {
                  l.checked = oh(
                    this.getStateValue(c),
                    l.value
                  );
                }), l.addEventListener("change", (u) => {
                  const d = u.target, f = d.value;
                  d.checked ? Gu(this.getStateValue(c), f) : rh(this.getStateValue(c), f);
                });
              } else if (Fc(s)) {
                const l = s;
                Te(() => {
                  l.value = this.getStateValue(c);
                }), l.addEventListener("change", (u) => {
                  this.setStateValue(
                    c,
                    u.target.value
                  );
                });
              } else {
                const l = s;
                Te(() => {
                  l.value = this.getStateValue(c);
                });
                const u = (d) => {
                  this.setStateValue(
                    c,
                    d.target.value
                  );
                };
                l.addEventListener("input", u);
              }
            else
              h === "v-text" ? Te(() => {
                s.innerText = this.getStateValue(c);
              }) : h === "v-html" && Te(() => {
                s.innerHTML = this.getStateValue(c);
              });
          }), s.childNodes.length > 0 && this.compile(s);
          break;
        case 3:
          const i = e.textContent || "", r = /\{\{\s*([^{}\s]+)\s*\}\}/g, o = r.exec(i);
          o && o[1] && Te(() => {
            e.textContent = i.replace(
              r,
              this.getStateValue(o[1])
            );
          });
          break;
      }
    });
  }
  // UNDO : 暂未考虑 嵌套的 数组
  getStateValue(t) {
    let e = this.state;
    return t.split(".").forEach((s) => {
      e = e[s];
    }), e;
  }
  // UNDO : 暂未考虑 嵌套的 数组
  setStateValue(t, e) {
    let s = this.state;
    const i = t.split("."), r = i.length;
    for (let o = 0; o < r - 1; o++)
      s = s[i[o]];
    s[i[r - 1]] = e;
  }
  // setState(data: State) {
  //   for (const k in data) {
  //     const v = data[k];
  //     if (Array.isArray(v)) {
  //       flushArray(this.state[k], v);
  //     } else if (isJustObject(v)) {
  //       for (const vk in v) {
  //         this.state[k][vk] = v[vk];
  //       }
  //     } else {
  //       this.state[k] = v;
  //     }
  //   }
  // }
  /**
   * @description 编译模板字符串
   * @example
   * const template = `
   * <ul>
   *   <% for(let i=0; i < data.supplies.length; i++) { %>
   *     <li><%= data.supplies[i] %></li>
   *   <% } %>
   * </ul>
   * `;
   * const parse = eval(compileTemplate(template));
   * console.log(parse({ supplies: ["broom", "mop", "cleaner"] }));
   */
  static compileTemplate(t) {
    return t = t.replace(/<%=(.+?)%>/g, "`); \n  echo( $1 ); \n  echo(`").replace(/<%([\s\S]+?)%>/g, "`); \n $1 \n  echo(`"), t = "echo(`" + t + "`);", `(function parse(data){
      let output = "";
      function echo(html){
        output += html;
      }
      ${t}
      return output;
    })`;
  }
}
function Xg(n, t, e) {
  return new WebSocket(n);
}
function Qw(n) {
  return `${n}eventbus/${Xs(3, "number")}/${Xs(
    8
  )}/websocket`;
}
class pe {
  static CONNECTING = WebSocket.CONNECTING;
  // 0
  static OPEN = WebSocket.OPEN;
  // 1
  static CLOSING = WebSocket.CLOSING;
  // 2
  static CLOSED = WebSocket.CLOSED;
  // 3
  url;
  socketCreatorProtocols;
  socketCreatorOptions;
  socketCreator;
  socket;
  state = pe.CONNECTING;
  messageQueue = [];
  pingInterval;
  pingTimerID;
  reconnect;
  reconnectAttempts = 0;
  maxReconnectAttempts;
  reconnectTimerID;
  onopen;
  onclose;
  onerror;
  requestid = 0;
  waitings = {};
  listeners = {};
  // wss://echo.websocket.org/
  // wss://xinge.ruolin-link.com/
  // wss://test.xinge.me/
  constructor(t = "", e) {
    this.url = t, this.socketCreatorProtocols = e?.socketCreatorProtocols, this.socketCreatorOptions = e?.socketCreatorOptions || {}, this.socketCreator = e?.socketCreator || Xg, this.pingInterval = e?.pingInterval || 5e3, this.onopen = e?.onopen, this.onclose = e?.onclose, this.onerror = e?.onerror, this.reconnect = typeof e?.reconnect == "boolean" ? e.reconnect : !0, this.maxReconnectAttempts = typeof e?.maxReconnectAttempts == "number" ? e.maxReconnectAttempts : 1 / 0, this._connect();
  }
  open() {
    this.reconnectAttempts = 0, this._connect();
  }
  close() {
    this.state = pe.CLOSING, this.socket?.close();
  }
  _connect() {
    this.socket?.readyState === pe.CONNECTING || this.socket?.readyState === pe.OPEN || (this.state = pe.CONNECTING, this.socket = this.socketCreator(
      this.url,
      this.socketCreatorProtocols,
      this.socketCreatorOptions
    ), this.socket.onopen = () => {
      ae(`(${this.url}) onopen`), this.state = pe.OPEN, this.reconnectTimerID && (clearTimeout(this.reconnectTimerID), this.reconnectTimerID = void 0);
      const t = this.messageQueue.slice();
      this.messageQueue = [], t.forEach(this._send.bind(this)), this.ping(), this.pingTimerID = setInterval(this.ping.bind(this), this.pingInterval), this.onopen?.();
    }, this.socket.onclose = (t) => {
      const { code: e, reason: s, wasClean: i } = t;
      ae(
        `(${this.url}) onclose: code(${e}) reason(${s}) wasClean(${i})`
      ), this.state = pe.CLOSED, this.socket = void 0, this.pingTimerID && (clearInterval(this.pingTimerID), this.pingTimerID = void 0), this.onclose?.(t), this.reconnect && this.reconnectAttempts < this.maxReconnectAttempts && (this.reconnectTimerID = setTimeout(
        this._connect.bind(this),
        lh(this.reconnectAttempts++)
      ));
    }, this.socket.onerror = (t) => {
      ae(`(${this.url}) onerror: ${t}`), this.onerror?.(t);
    }, this.socket.onmessage = (t) => {
      if (ae(`(${this.url}) onmessage: { type: ${t.type}, data: ${t.data} }`), typeof t.data == "string") {
        let e;
        const s = t.data.substring(1);
        try {
          e = JSON.parse(s);
        } catch (i) {
          e = [
            JSON.stringify({
              type: "err",
              failureCode: "fe-json-parse-error",
              failureType: i.toString(),
              message: s
            })
          ];
        }
        e.forEach((i) => {
          const r = JSON.parse(i);
          if (r.body && Object.prototype.hasOwnProperty.call(r.body, "requestid")) {
            const o = this.waitings[r.body.requestid];
            o ? o.resolve?.(r.body) : kn(
              `(${this.url}) onmessage: found no associated request, already timed out`
            );
          } else if (this.listeners[r.address]) {
            const o = this.listeners[r.address];
            for (let a = 0; a < o.length; a++)
              r.type === "err" ? o[a]({
                failureCode: r.failureCode,
                failureType: r.failureType,
                message: r.message
              }) : o[a](null, r.body);
          } else
            this.onunhandled(r);
        });
      } else
        t.data instanceof ArrayBuffer ? kn(`(${this.url}) onmessage: unhandle ArrayBuffer`) : t.data instanceof Blob && kn(`(${this.url}) onmessage: unhandle Blob`);
    });
  }
  onunhandled(t) {
    try {
      t.type === "err" ? this.onerror?.(t) : t.event ? console.warn(
        "No handler found for event: %o. Message: %O",
        t.event,
        t
      ) : console.warn("No handler found for message: ", t);
    } catch {
    }
  }
  // 可能需要根据协议变更传输格式
  _send(t) {
    this.socket?.readyState === pe.OPEN ? this.socket.send(JSON.stringify([JSON.stringify(t)])) : (this.messageQueue.push(t), this._connect());
  }
  ping() {
    this._send({ type: "ping" });
  }
  // 注册监听
  register(t, e, s = {}) {
    this.listeners[t] || (this.listeners[t] = [], this._send({
      type: "register",
      address: t,
      headers: is(
        s,
        this.socketCreatorOptions.headers,
        !1
      )
    })), this.listeners[t].push(e);
  }
  // 取消注册监听
  unregister(t, e, s = {}) {
    const i = this.listeners[t];
    if (i) {
      const r = i.indexOf(e);
      r != -1 && (i.splice(r, 1), i.length === 0 && (this._send({
        type: "unregister",
        address: t,
        headers: is(
          s,
          this.socketCreatorOptions.headers,
          !1
        )
      }), delete this.listeners[t]));
    }
  }
  // 广播
  publish(t, e, s = {}) {
    this._send({
      type: "publish",
      address: t,
      headers: is(
        s,
        this.socketCreatorOptions.headers,
        !1
      ),
      body: e
    });
  }
  // 普通发送，等待回应
  async send(t, e, s = {}, i = 3e4) {
    this.requestid++;
    const r = this.waitings[this.requestid] = {
      requestid: this.requestid
    }, o = await new Promise((a, h) => {
      r.resolve = a, this._send({
        type: "send",
        address: t,
        headers: is(
          s,
          this.socketCreatorOptions.headers,
          !1
        ),
        body: {
          requestid: r.requestid,
          ...e
        }
      }), setTimeout(() => {
        h(
          `(${this.url}) send(${r.requestid}: ${Ve(
            e
          )}) Timeout!`
        );
      }, i);
    });
    return delete this.waitings[r.requestid], o;
  }
}
function lo() {
  const n = navigator.userAgent.toLowerCase();
  let t = "Unknown";
  return /iphone|ipad|ipod/i.test(n) ? t = "iOS" : /android/i.test(n) ? t = "Android" : /BlackBerry/i.test(n) ? t = "BlackBerry" : /mac/i.test(n) ? t = "macOS" : /win/i.test(n) ? t = "Windows" : /linux/i.test(n) ? t = "Linux" : /bsd/i.test(n) && (t = "BSD"), t.toLowerCase();
}
function t2(n = navigator.userAgent) {
  let t = "Unknown";
  if (/iPhone|iPad|iPod/i.test(n)) {
    const e = n.match(/OS (\d+_\d+)/i);
    e && (t = e[1].replace("_", "."));
  } else if (/Android/i.test(n)) {
    const e = n.match(/Android (\d+\.\d+)/i);
    e && (t = e[1]);
  } else if (/Mac OS X/i.test(n)) {
    const e = n.match(/Mac OS X (\d+_\d+)/i);
    e && (t = e[1].replace("_", "."));
  } else if (/Windows NT/i.test(n)) {
    const e = n.match(/Windows NT (\d+\.\d+)/i);
    e && (t = e[1]);
  }
  return t.toLowerCase();
}
function uo() {
  const n = navigator.userAgent.toLowerCase();
  let t = "Unknown";
  return /opr/i.test(n) || /opera/i.test(n) ? t = "Opera" : /chrome/i.test(n) ? t = "Chrome" : /firefox/i.test(n) ? t = "Firefox" : /safari/i.test(n) ? t = "Safari" : /edge/i.test(n) ? t = "Edge" : /msie|trident/i.test(n) ? t = "IE" : /MicroMessenger/i.test(n) ? t = "Wechat" : /alipay/i.test(n) && (t = "Ali"), t.toLowerCase();
}
function e2() {
  const n = navigator.userAgent;
  let t = "Unknown";
  if (/Chrome/.test(n)) {
    const e = n.match(/Chrome\/(\d+\.\d+)/);
    e && (t = e[1]);
  } else if (/Firefox/.test(n)) {
    const e = n.match(/Firefox\/(\d+\.\d+)/);
    e && (t = e[1]);
  } else if (/Safari/.test(n)) {
    const e = n.match(/Version\/(\d+\.\d+)/);
    e && (t = e[1]);
  } else if (/Edge/.test(n)) {
    const e = n.match(/Edge\/(\d+\.\d+)/);
    e && (t = e[1]);
  } else if (/MSIE|Trident/.test(n)) {
    const e = n.match(/(?:MSIE|rv:)(\d+\.\d+)/);
    e && (t = e[1]);
  }
  return t;
}
function s2() {
  return (navigator.browserLanguage || navigator.language).toLowerCase();
}
function n2() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone.toLowerCase();
}
function i2() {
  return uo() == "safari";
}
function zl() {
  return lo() === "ios";
}
function Fg() {
  return lo() === "macos";
}
function r2() {
  return zl() | Fg();
}
function Ug() {
  return lo() === "android";
}
function o2() {
  const n = window.navigator.appVersion;
  if (/Android/.test(n) && !/Chrome\/\d/.test(n)) {
    const t = n.match(/Safari\/(\d+.\d)/);
    return t && typeof t == "object" && t.length >= 2 ? parseFloat(t[1]) < 535.19 : !0;
  } else
    return !1;
}
function a2() {
  return zl() || Ug();
}
function Gg() {
  const n = window.navigator.userAgent, t = n.indexOf("MSIE ");
  if (t > 0)
    return parseInt(n.substring(t + 5, n.indexOf(".", t)), 10);
  if (n.indexOf("Trident/") > 0) {
    const i = n.indexOf("rv:");
    return parseInt(n.substring(i + 3, n.indexOf(".", i)), 10);
  }
  const s = n.indexOf("Edge/");
  return s > 0 ? parseInt(n.substring(s + 5, n.indexOf(".", s)), 10) : -1;
}
const h2 = Gg() !== -1, c2 = document.documentMode ? document.documentMode === 9 : !1, l2 = document.documentMode ? document.documentMode === 10 : !1, u2 = document.documentMode ? document.documentMode === 11 : !1;
function Vg() {
  return uo() === "wechat";
}
function $g() {
  return uo() === "ali";
}
function f2() {
  return Vg() && navigator.userAgent.match(/miniprogram/i) || window.__wxjs_environment === "miniprogram";
}
function d2() {
  return $g() && navigator.userAgent.match(/miniprogram/i);
}
function m2(n = 750) {
  const t = document.documentElement, e = window.top === window.self ? window.devicePixelRatio : 1;
  t.dataset.dpr = e;
  let s = 100;
  const i = function() {
    t.style.height = window.innerHeight + "px";
    const r = t.clientWidth;
    t.dataset.width = r, t.dataset.layout = r > n ? "pc" : "mobile", t.dataset.rem = s = Math.min(
      100,
      Math.round(100 * (r / n))
    ), t.style.fontSize = s + "px";
  };
  i(), window.rem2px = function(r) {
    return parseFloat(r) * s;
  }, window.px2rem = function(r) {
    return parseFloat(r) / s;
  }, window.addEventListener && window.addEventListener(
    "orientationchange" in window ? "orientationchange" : "resize",
    i,
    !1
  );
}
class p2 extends cl {
  currentItem = {};
  items = [];
  groups = [];
  globalStyles = {};
  grad = {};
  idtops = {};
  text = "";
  constructor(t) {
    super(t), this.on("tag", (e, s) => {
      switch (this.text = "", this.currentItem = { type: e }, e) {
        case "g":
          this.groups.push(this.currentItem);
          break;
      }
      this.processAttrs(e, s);
    }), this.on("text", (e) => {
      if (this.currentItem.type == "style") {
        try {
          const s = ll(e);
          for (const i of s.stylesheet.rules)
            for (const r of i.declarations)
              for (const o of i.selectors)
                this.globalStyles[o] = this.globalStyles[o] || [], this.globalStyles[o].push(
                  `${r.property}:${r.value}`
                );
        } catch {
          console.error("CAN'T parse css text: " + e);
        }
        return;
      }
      this.text += e;
    }), this.on("/tag", (e, s) => {
      let i = this.groups.length;
      for (; i--; )
        if (this.groups[i] != this.currentItem) {
          let r = "", o = "";
          for (const a in this.groups[i])
            a == "transform" ? r = this.groups[i].transform : a == "class" && this.globalStyles["." + this.groups[i][a]] ? o = this.globalStyles["." + this.groups[i][a]].join(";") + ";" + o : a == "id" && this.globalStyles["#" + this.groups[i][a]] ? o = this.globalStyles["#" + this.groups[i][a]].join(";") + ";" + o : typeof this.currentItem[a] > "u" && (this.currentItem[a] = this.groups[i][a]);
          typeof this.currentItem.transform > "u" ? this.currentItem.transform = r : this.currentItem.transform += " " + r, typeof this.currentItem.style > "u" ? this.currentItem.style = o : this.currentItem.style = o + this.currentItem.style, this.currentItem.class && this.globalStyles["." + this.currentItem.class] ? this.currentItem.style = this.globalStyles["." + this.currentItem.class].join(";") + ";" + this.currentItem.style : this.currentItem.id && this.globalStyles["#" + this.currentItem.id] && (this.currentItem.style = this.globalStyles["#" + this.currentItem.id].join(";") + ";" + this.currentItem.style), Ui(
            this.currentItem.style,
            this.currentItem,
            Gi
          );
        }
      switch (this.processAttrs(e, s), e) {
        case "g":
          this.groups.pop();
          break;
        case "cirlce":
          this.addToItems();
          break;
        case "ellipse":
          this.addToItems();
          break;
        case "polygon":
          this.addToItems();
          break;
        case "path":
          this.addToItems();
          break;
        case "line":
          this.addToItems();
          break;
        case "rect":
          this.addToItems();
          break;
        case "image":
          this.addToItems();
          break;
        case "text":
          this.currentItem.text = this.text, this.currentItem["text-anchor"] = this.currentItem["text-anchor"] || "start", this.addToItems();
          break;
      }
    }), this.on("finish", () => {
      this.emit("result", this.items);
    });
  }
  parse() {
    return super.parse(), this.items;
  }
  processAttrs(t, e) {
    let s = [], i;
    switch (t) {
      case "svg":
        let r = "", o = "";
        if (e.width && e.height)
          r = e.width, o = e.height;
        else if (e.viewBox) {
          const a = e.viewBox.split(/\s+/gi);
          a.length == 4 && (r = String(parseFloat(a[2]) - parseFloat(a[0])), o = String(parseFloat(a[3]) - parseFloat(a[1])));
        }
        r && o && this.items.push({
          type: "viewbox",
          width: r,
          height: o
        });
        break;
      case "line":
        typeof e.x1 == "number" && typeof e.y1 == "number" && typeof e.x2 == "number" && typeof e.y2 == "number" && (this.currentItem.path = "M" + [e.x1, e.y1, e.x2, e.y2]);
        break;
      case "stop":
        i = {}, e.style && Ui(e.style, i), i.offset = i.offset || e.offset, i.color = i["stop-color"] || e["stop-color"], i.opacity = i["stop-opacity"] || e["stop-opacity"], ~(i.offset + "").indexOf("%") ? i.offset = parseFloat(i.offset) : i.offset = parseFloat(i.offset) * 100, i.offset = +i.offset.toFixed(2), this.grad.stops.push(i);
        break;
      case "linearGradient":
        this.grad.angle = (360 + Er(
          parseFloat(e.x1),
          parseFloat(e.y1),
          parseFloat(e.x2),
          parseFloat(e.y2),
          parseFloat(e.x1) + 100,
          parseFloat(e.y1)
        )).toFixed(2), s = [this.grad.angle];
        for (let a = 0, h = this.grad.stops.length; a < h; a++)
          i = this.grad.stops[a], a && a != h - 1 ? s.push(i.color + ":" + i.offset) : s.push(i.color);
        this.idtops[this.grad.id] = s.join("-"), this.items.forEach((a) => {
          a.fillid == this.grad.id && (a.fill = this.idtops[this.grad.id]);
        });
        break;
      case "radialGradient":
        s = [];
        for (let a = 0, h = this.grad.stops.length; a < h; a++)
          i = this.grad.stops[a], a && a != h - 1 ? s.push(i.color + ":" + i.offset) : s.push(i.color);
        this.idtops[this.grad.id] = s.join("-"), this.items.forEach((a) => {
          a.fillid == this.grad.id && (a.fill = this.idtops[this.grad.id]);
        });
        break;
    }
    for (const r in e) {
      const o = e[r];
      if (Gi.includes(r) && (this.currentItem[r] = o), r === "id" && (this.currentItem.type === "linearGradient" && (this.grad = {
        id: r,
        stops: []
      }), this.currentItem.type === "radialGradient" && (this.grad = {
        id: r,
        stops: []
      })), r === "style" && Ui(o, this.currentItem, Gi), r === "transform" && (this.currentItem.transform = o + (this.currentItem.transform || " ")), r === "fill") {
        const a = o.match(/url\(#([^)]+)\)/);
        if (a) {
          const h = a[1];
          this.currentItem.fillid = h, this.idtops[h] && (this.currentItem.fill = this.idtops[h]);
        }
      }
      r === "points" && this.currentItem.type == "polygon" && (this.currentItem.path = "M" + o + "z"), r === "d" && this.currentItem.type == "path" && (this.currentItem.path = o), r === "xlink:href" && this.currentItem.type == "image" && (this.currentItem.src = o);
    }
  }
  addToItems() {
    this.items.push(this.currentItem);
  }
}
function Er(n, t, e, s, i, r) {
  if (typeof i > "u" || typeof r > "u") {
    const o = n - e, a = t - s;
    return !o && !a ? 0 : (180 + Math.atan2(-a, -o) * 180 / Math.PI + 360) % 360;
  } else
    return Er(n, t, i, r) - Er(e, s, i, r);
}
function Ui(n, t, e) {
  const s = (n + "").split(";"), i = /^\s+|\s+$/g;
  for (let r = 0, o = s.length; r < o; r++) {
    const a = s[r].split(":"), h = a[0].replace(i, "").replace(/[A-Z]/g, function(c) {
      return "-" + c.toLowerCase();
    });
    (!e || e.includes(h)) && (t[h] = a[1].replace(i, ""));
  }
}
const Gi = [
  "id",
  "class",
  "viewBox",
  "width",
  "height",
  "x",
  "y",
  "cx",
  "cy",
  "r",
  "rx",
  "ry",
  "cursor",
  "opacity",
  "src",
  "fill",
  "fill-opacity",
  "stroke",
  "stroke-dasharray",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "text-anchor",
  "font",
  "font-family",
  "font-size",
  "font-style",
  "font-weight",
  "letter-spacing"
];
class g2 {
  localVideoUtil;
  remoteVideoUtil;
  localPeerConnection = null;
  remotePeerConnection = null;
  constructor(t, e) {
    this.localVideoUtil = new jn(t), this.remoteVideoUtil = new jn(e);
  }
  start() {
    this.getLocalMediaStream().then((t) => {
      this.call(t);
    });
  }
  end() {
    this.localPeerConnection?.close(), this.remotePeerConnection?.close(), this.localPeerConnection = null, this.remotePeerConnection = null, this.trace("Ending call.");
  }
  getLocalMediaStream() {
    return new Promise((t, e) => {
      navigator.mediaDevices.getUserMedia({
        audio: !0,
        video: !0
      }).then((s) => {
        this.localVideoUtil.setSrcObject(s), t(s);
      }).catch((s) => {
        this.trace(`navigator.getUserMedia error: ${s}.`), e(s);
      });
    });
  }
  gotRemoteMediaStream(t) {
    const e = t.streams[0];
    this.remoteVideoUtil.setSrcObject(e), this.trace("Remote peer connection received remote stream.");
  }
  call(t) {
    const e = t.getVideoTracks(), s = t.getAudioTracks();
    e.length > 0 && this.trace(`Using video device: ${e[0].label}.`), s.length > 0 && this.trace(`Using audio device: ${s[0].label}.`);
    const i = void 0, r = new RTCPeerConnection(i);
    this.localPeerConnection = r, this.trace("Created local peer connection object localPeerConnection."), r.addEventListener("icecandidate", this.handleConnection), r.addEventListener(
      "iceconnectionstatechange",
      this.handleConnectionChange
    );
    const o = new RTCPeerConnection(i);
    this.remotePeerConnection = o, this.trace("Created remote peer connection object remotePeerConnection."), o.addEventListener(
      "icecandidate",
      this.handleConnection
    ), o.addEventListener(
      "iceconnectionstatechange",
      this.handleConnectionChange
    ), o.addEventListener("track", this.gotRemoteMediaStream), this.trace("Add local localStream to localPeerConnection."), r.addTrack(e[0], t), r.addTrack(s[0], t), this.trace("localPeerConnection createOffer start."), r.createOffer({
      offerToReceiveVideo: !0
    }).then((a) => this.createdOffer(a)).catch((a) => this.setSessionDescriptionError(a));
  }
  handleConnection(t) {
    const e = t.target, s = t.candidate;
    if (e && s) {
      const i = new RTCIceCandidate(s), r = this.getOtherPeer(e);
      r && (r.addIceCandidate(i).then(() => {
        this.handleConnectionSuccess(e);
      }).catch((o) => {
        this.handleConnectionFailure(e, o);
      }), this.trace(
        `${this.getPeerName(e)} ICE candidate:
${t.candidate.candidate}.`
      ));
    }
  }
  handleConnectionSuccess(t) {
    this.trace(`${this.getPeerName(t)} addIceCandidate success.`);
  }
  handleConnectionFailure(t, e) {
    this.trace(
      `${this.getPeerName(t)} failed to add ICE Candidate:
${e.toString()}.`
    );
  }
  handleConnectionChange(t) {
    const e = t.target;
    console.log("ICE state change event: ", t), e && this.trace(
      `${this.getPeerName(e)} ICE state: ${e.iceConnectionState}.`
    );
  }
  createdOffer(t) {
    this.trace(`Offer from localPeerConnection:
${t.sdp}`), this.localPeerConnection && (this.trace("localPeerConnection setLocalDescription start."), this.localPeerConnection.setLocalDescription(t).then(() => {
      this.setLocalDescriptionSuccess(this.localPeerConnection);
    }).catch((e) => this.setSessionDescriptionError(e))), this.remotePeerConnection && (this.trace("remotePeerConnection setRemoteDescription start."), this.remotePeerConnection.setRemoteDescription(t).then(() => {
      this.setRemoteDescriptionSuccess(this.remotePeerConnection);
    }).catch((e) => this.setSessionDescriptionError(e)), this.trace("remotePeerConnection createAnswer start."), this.remotePeerConnection.createAnswer().then((e) => this.createdAnswer(e)).catch((e) => this.setSessionDescriptionError(e)));
  }
  createdAnswer(t) {
    this.trace(`Answer from remotePeerConnection:
${t.sdp}.`), this.remotePeerConnection && (this.trace("remotePeerConnection setLocalDescription start."), this.remotePeerConnection.setLocalDescription(t).then(() => {
      this.setLocalDescriptionSuccess(this.remotePeerConnection);
    }).catch((e) => this.setSessionDescriptionError(e))), this.localPeerConnection && (this.trace("localPeerConnection setRemoteDescription start."), this.localPeerConnection.setRemoteDescription(t).then(() => {
      this.setRemoteDescriptionSuccess(this.localPeerConnection);
    }).catch((e) => this.setSessionDescriptionError(e)));
  }
  setSessionDescriptionError(t) {
    this.trace(`Failed to create session description: ${t.toString()}.`);
  }
  setDescriptionSuccess(t, e) {
    const s = this.getPeerName(t);
    this.trace(`${s} ${e} complete.`);
  }
  setLocalDescriptionSuccess(t) {
    this.setDescriptionSuccess(t, "setLocalDescription");
  }
  setRemoteDescriptionSuccess(t) {
    this.setDescriptionSuccess(t, "setRemoteDescription");
  }
  trace(t) {
    t = t.trim();
    const e = (window.performance.now() / 1e3).toFixed(3);
    console.log(e, t);
    const s = document.createElement("div");
    s.innerHTML = `<div>${e}, ${t}</div>`, document.getElementById("trace")?.appendChild(s);
  }
  getOtherPeer(t) {
    return t === this.localPeerConnection ? this.remotePeerConnection : this.localPeerConnection;
  }
  getPeerName(t) {
    return t === this.localPeerConnection ? "localPeerConnection" : "remotePeerConnection";
  }
}
class y2 {
  canvas;
  gl;
  constructor(t) {
    this.canvas = t;
    const e = { alpha: !0, premultipliedAlpha: !1 };
    if (this.gl = this.canvas.getContext("webgl", e), !this.gl)
      throw new Error("WebGL failed to initialize.");
  }
}
const Nl = [], Ha = {};
function Yl(n) {
  Nl.push(n);
}
function x2(n, t = !1) {
  const e = Pf();
  if (Ha[e])
    return;
  wx.error((r) => {
    console.log(r.errMsg || JSON.stringify(r));
  }), wx.ready(() => {
    Nl.forEach((r) => r());
  });
  const s = [
    "updateAppMessageShareData",
    "updateTimelineShareData",
    "onMenuShareWeibo",
    "onMenuShareQZone",
    "startRecord",
    "stopRecord",
    "onVoiceRecordEnd",
    "playVoice",
    "pauseVoice",
    "stopVoice",
    "onVoicePlayEnd",
    "uploadVoice",
    "downloadVoice",
    "chooseImage",
    "previewImage",
    "uploadImage",
    "downloadImage",
    "getLocalImgData",
    "translateVoice",
    "getNetworkType",
    "openLocation",
    "getLocation",
    "hideOptionMenu",
    "showOptionMenu",
    "hideMenuItems",
    "showMenuItems",
    "hideAllNonBaseMenuItem",
    "showAllNonBaseMenuItem",
    "closeWindow",
    "scanQRCode",
    "openProductSpecificView",
    "addCard",
    "chooseCard",
    "openCard"
  ], i = [
    "wx-open-launch-app",
    "wx-open-launch-app",
    "wx-open-subscribe",
    "wx-open-audio"
  ];
  wx.config(
    Object.assign(n, {
      debug: t,
      jsApiList: s,
      openTagList: i
    })
  ), Ha[e] = !0;
}
function w2(n) {
  return new Promise((t, e) => {
    wx.checkJsApi({
      jsApiList: [n],
      success: function(s) {
        s.checkResult[n] ? t(!0) : e(!1);
      },
      fail: function() {
        e(!1);
      }
    });
  });
}
function b2(n) {
  Yl(function() {
    wx.updateAppMessageShareData(n);
  });
}
function v2(n) {
  Yl(function() {
    wx.updateTimelineShareData(n);
  });
}
function _2(n) {
  wx.chooseImage(n);
}
function S2(n) {
  wx.previewImage(n);
}
function C2(n) {
  wx.uploadImage(n);
}
function E2(n) {
  wx.downloadImage(n);
}
function P2(n) {
  wx.getLocalImgData(n);
}
function T2() {
  wx.startRecord();
}
function M2(n) {
  wx.stopRecord(n);
}
function A2(n) {
  wx.onVoiceRecordEnd(n);
}
function I2(n) {
  wx.playVoice(n);
}
function k2(n) {
  wx.pauseVoice(n);
}
function D2(n) {
  wx.stopVoice(n);
}
function L2(n) {
  wx.onVoicePlayEnd(n);
}
function R2(n) {
  wx.uploadVoice(n);
}
function O2(n) {
  wx.downloadVoice(n);
}
function z2(n) {
  wx.translateVoice(n);
}
function N2(n) {
  wx.getNetworkType(n);
}
function Y2(n) {
  wx.openLocation(n);
}
function B2(n) {
  wx.getLocation(n);
}
function X2(n) {
  wx.scanQRCode(n);
}
function F2(n, t, e) {
  function s() {
    WeixinJSBridge.invoke("getBrandWCPayRequest", n, function(i) {
      i.err_msg == "get_brand_wcpay_request:ok" ? t() : e(i.err_msg);
    });
  }
  typeof WeixinJSBridge > "u" ? document.addEventListener ? document.addEventListener("WeixinJSBridgeReady", s, !1) : document.attachEvent && (document.attachEvent("WeixinJSBridgeReady", s), document.attachEvent("onWeixinJSBridgeReady", s)) : s();
}
function U2(n, t, e = "snsapi_userinfo", s = "") {
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${n}&redirect_uri=${encodeURIComponent(
    t
  )}&response_type=code&scope=${e}&state=${s}#wechat_redirect`;
}
function G2(n) {
  window.AlipayJSBridge ? n && n() : document.addEventListener("AlipayJSBridgeReady", n, !1);
}
function nn(n, t) {
  let e = "未知错误";
  switch (n.error) {
    case 1:
      e = "接口不存在";
      break;
    case 2:
      e = "参数无效";
      break;
    case 3:
      e = "发生未知错误";
      break;
    case 4:
      e = "接口无权限";
      break;
    case 10:
      e = "用户取消";
      break;
    case 11:
      e = "操作失败", t === "chooseImage" && (e = "操作失败（权限不够）");
      break;
    case 12:
      e = "GPS打开，但定位失败";
      break;
    case 13:
      e = "获取地理位置信息失败";
      break;
    case 14:
      e = "定位超时";
      break;
    case 15:
      e = "网络错误";
      break;
    case 16:
      e = "GPS未打开或用户未授权";
      break;
  }
  return `${n.error}(${e}): ${n.errorMessage}`;
}
function V2(n, t, e) {
  ap.tradePay(
    Object.assign(n, {
      // fail: (res: commonFailOption) => {
      //   errorCb?.(aliJsFormatCommonFailMessage(res));
      // }
    }),
    function(s) {
      let i = "未知错误";
      switch (s.resultCode) {
        case 9e3:
          return i = "订单支付成功", t?.(i);
        case 8e3:
          i = "正在处理中";
          break;
        case 4e3:
          i = "订单支付失败";
          break;
        case 6001:
          i = "用户中途取消";
          break;
        case 6002:
          i = "网络连接出错";
          break;
        case 99:
          i = "用户点击忘记密码导致快捷界面退出(only iOS)";
          break;
      }
      e?.(i);
    }
  );
}
function $2(n, t, e) {
  ap.scan(
    Object.assign(n, {
      fail: (s) => {
        e?.(nn(s));
      }
    }),
    function(s) {
      t?.(s.code);
    }
  );
}
function q2(n, t, e) {
  ap.getLocation(
    Object.assign(n, {
      fail: (s) => {
        e?.(nn(s));
      }
    }),
    function(s) {
      t?.(s);
    }
  );
}
function j2(n, t, e) {
  ap.openLocation(
    Object.assign(n, {
      fail: (s) => {
        e?.(nn(s));
      }
    }),
    function() {
      t?.();
    }
  );
}
function H2(n, t, e) {
  ap.chooseImage(
    Object.assign(n, {
      fail: (s) => {
        e?.(nn(s, "chooseImage"));
      }
    }),
    function(s) {
      t?.(s);
    }
  );
}
function W2(n, t, e) {
  ap.previewImage(
    Object.assign(n, {
      fail: (s) => {
        e?.(nn(s));
      }
    }),
    function() {
      t?.();
    }
  );
}
class Z2 {
  map;
  constructor(t, e = 120.619585, s = 31.299379, i = 18) {
    this.map = new T.Map(t), this.map.centerAndZoom(new T.LngLat(e, s), i);
  }
}
const Vt = window.crypto.subtle;
async function qg(n, t = Hs.SHA256) {
  if (!Vt)
    throw new Error("Crypto API not supported");
  const e = await Vt.digest(
    t,
    kr(n)
  );
  return ah(e);
}
async function J2(n, t = Hs.SHA256) {
  return qg(JSON.stringify(Ru(n)), t);
}
async function K2(n, t = Hs.AESGCM) {
  if (!Vt)
    throw new Error("Crypto API not supported");
  const e = crypto.getRandomValues(new Uint8Array(12)), s = await Vt.generateKey(
    { name: t, length: 256 },
    !1,
    // defines key as extractable, use false b/c we do not need to store it
    ["encrypt", "decrypt"]
  ), i = await Vt.encrypt(
    { name: t, iv: e },
    s,
    kr(n)
  );
  return { algorithm: t, iv: e, key: s, encryptedData: i };
}
async function Q2(n) {
  if (!Vt)
    throw new Error("Crypto API not supported");
  const t = await Vt.decrypt(
    {
      name: n.algorithm,
      iv: n.iv
    },
    n.key,
    n.encryptedData
  );
  return ah(t);
}
async function tb(n, t = Hs.ECDSA, e = "SHA-384") {
  if (!Vt)
    throw new Error("Crypto API not supported");
  const { privateKey: s, publicKey: i } = await Vt.generateKey(
    {
      name: t,
      namedCurve: "P-384"
    },
    !1,
    // defines key as extractable, use false b/c we do not need to store it
    ["sign", "verify"]
  ), r = kr(
    JSON.stringify(n)
  ), o = await Vt.sign(
    {
      name: t,
      hash: { name: e }
    },
    s,
    r
  );
  return {
    algorithm: t,
    hash: e,
    publicKey: i,
    signature: o,
    encodedData: r
  };
}
async function eb(n) {
  if (!Vt)
    throw new Error("Crypto API not supported");
  return await Vt.verify(
    {
      name: n.algorithm,
      hash: { name: n.hash }
    },
    n.publicKey,
    n.signature,
    n.encodedData
  );
}
class sb {
  /// 当前页数，从0开始
  currentPage;
  /// 每页item数量
  itemsPerPage;
  /// page中间连续的个数
  entriesInterval;
  /// page边缘个数
  entriesEdge;
  linkTo;
  prevText;
  nextText;
  ellipseText;
  prevShowAlways;
  nextShowAlways;
  callback;
  totalPages;
  parentVNode;
  constructor(t, e, s) {
    this.currentPage = s?.currentPage || 0, this.itemsPerPage = s?.itemsPerPage || 10, this.entriesInterval = s?.entriesInterval || 5, this.entriesEdge = s?.entriesEdge || 1, this.linkTo = s?.linkTo || "javascript:;", this.prevText = s?.prevText || "上一页", this.nextText = s?.nextText || "下一页", this.ellipseText = s?.ellipseText || "...", this.prevShowAlways = typeof s?.prevShowAlways == "boolean" ? s?.prevShowAlways : !0, this.nextShowAlways = typeof s?.nextShowAlways == "boolean" ? s?.nextShowAlways : !0, this.callback = s?.callback || ((i) => !1), this.totalPages = Math.ceil(e / this.itemsPerPage), this.parentVNode = this.createParentVNode(), Bs(this.parentVNode, t), this.selectPage(this.currentPage);
  }
  createParentVNode() {
    return ns("div", { class: "pagination" }, []);
  }
  appendVNode(t, e, s) {
    e = e < 0 ? 0 : e < this.totalPages ? e : this.totalPages - 1;
    const i = s?.text || String(e + 1), r = s?.classes || "";
    t.children.push(
      e == this.currentPage && r.indexOf("prev") == -1 && r.indexOf("next") == -1 ? ns("span", { class: `current ${r}` }, i) : ns(
        "a",
        {
          class: r,
          href: this.linkTo.replace(/__id__/, String(e)),
          onClick: (o) => this.selectPage(e, o)
        },
        i
      )
    );
  }
  drawLinks() {
    const t = this.createParentVNode(), e = Math.ceil(this.entriesInterval / 2), s = this.currentPage > e ? Math.max(
      Math.min(
        this.currentPage - e,
        this.totalPages - this.entriesInterval
      ),
      0
    ) : 0, i = this.currentPage > e ? Math.min(this.currentPage + e, this.totalPages) : Math.min(this.entriesInterval, this.totalPages);
    if (this.prevText && (this.currentPage > 0 || this.prevShowAlways) && this.appendVNode(t, this.currentPage - 1, {
      text: this.prevText,
      classes: "prev"
    }), s > 0 && this.entriesEdge > 0) {
      const r = Math.min(this.entriesEdge, s);
      for (let o = 0; o < r; o++)
        this.appendVNode(t, o);
      this.entriesEdge < s && this.ellipseText && t.children.push(
        ns("span", {}, this.ellipseText)
      );
    }
    for (let r = s; r < i; r++)
      this.appendVNode(t, r);
    if (i < this.totalPages && this.entriesEdge > 0) {
      this.totalPages - this.entriesEdge > i && this.ellipseText && t.children.push(
        ns("span", {}, this.ellipseText)
      );
      const r = Math.max(this.totalPages - this.entriesEdge, i);
      for (let o = r; o < this.totalPages; o++)
        this.appendVNode(t, o);
    }
    this.nextText && (this.currentPage < this.totalPages - 1 || this.nextShowAlways) && this.appendVNode(t, this.currentPage + 1, {
      text: this.nextText,
      classes: "next"
    }), co(this.parentVNode, t), this.parentVNode = t;
  }
  selectPage(t, e) {
    this.currentPage = t = t < 0 ? 0 : t < this.totalPages ? t : this.totalPages - 1, this.drawLinks();
    const s = this.callback(t);
    return e && (s || gc(e)), s;
  }
  prevPage() {
    return this.selectPage(this.currentPage - 1);
  }
  nextPage() {
    return this.selectPage(this.currentPage + 1);
  }
}
class nb {
  static;
  store;
  eb;
  // 多对多
  axios;
  ds;
  constructor(t = {}) {
    this.static = t.static || {};
    const e = t.store?.state || {};
    this.store = gh({
      reducer: t.store?.reducer || (() => e),
      initState: e,
      enhancer: t.store?.enhancer,
      immutable: typeof t.store?.immutable == "boolean" ? t.store?.immutable : !0
    }), this.eb = new Qn(), this.axios = new Xh({
      baseURL: t.axios?.baseURL,
      timeout: t.axios?.timeout,
      headers: t.axios?.headers,
      responseType: t.axios?.responseType,
      responseEncoding: t.axios?.responseEncoding,
      interceptor: t.axios?.interceptor,
      retry: t.axios?.retry,
      cache: t.axios?.cache
    }), this.ds = new Cf({ concurrency: 1 });
  }
}
class ib {
  appId;
  reportUrl;
  constructor(t) {
    this.appId = t.appId, this.reportUrl = t.reportUrl, this.listenJSError(), this.listenAssetsError(), this.listenPromiseError(), t.checkWhiteScreen && this.listenWhiteScreenError();
  }
  // 捕获绝大多数运行时错误
  listenJSError() {
    window.onerror = (t, e, s, i, r) => {
      const o = {
        type: "js_error",
        msg: t,
        file: e,
        row: s,
        col: i,
        stack: r?.stack
      };
      this.report(o);
    };
  }
  // 资源加载错误
  listenAssetsError() {
    window.addEventListener(
      "error",
      (t) => {
        const e = t.target;
        if (e instanceof HTMLScriptElement || e instanceof HTMLStyleElement || e instanceof HTMLImageElement) {
          const s = {
            type: "resource_error",
            filename: e.src || e.href,
            tagName: e.tagName
          };
          this.report(s);
        }
      },
      !0
      // 资源错误不会冒泡
    );
  }
  // Promise 报错
  listenPromiseError() {
    window.addEventListener(
      "unhandledrejection",
      (t) => {
        const e = {
          type: "promise_error",
          reason: t.reason
        };
        this.report(e);
      }
    );
  }
  // 白屏检测
  listenWhiteScreenError() {
    Yc(() => {
      setTimeout(() => {
        const t = [
          [window.innerWidth / 2, window.innerHeight / 2],
          // 中心点
          [window.innerWidth / 2, window.innerHeight * 0.2],
          // 上
          [window.innerWidth / 2, window.innerHeight * 0.8],
          // 下
          [window.innerWidth * 0.2, window.innerHeight / 2],
          // 左
          [window.innerWidth * 0.8, window.innerHeight / 2]
          // 右
          // ... 可以多取几个点
        ];
        let e = 0;
        if (t.forEach((s) => {
          const [i, r] = s, a = document.elementsFromPoint(i, r)[0];
          (a?.tagName === "BODY" || a?.tagName === "HTML") && e++;
        }), e >= t.length * 0.8) {
          const s = {
            type: "whitescreen_error",
            reason: "检测到白屏！"
          };
          this.report(s);
        }
      }, 3e3);
    });
  }
  // 数据上报：别用 AJAX
  // 如果页面正在关闭或卸载（用户看到白屏气得关网页），AJAX 请求很可能会被浏览器切断（Canceled），导致上报失败
  // 标准方案：navigator.sendBeacon
  // 不占用主线程：它把数据放入浏览器的传输队列，浏览器会在空闲时发送。
  // 页面关闭也能发：即使用户强制关闭 Tab，浏览器也会保证把这条请求发出去。
  report(t) {
    const e = JSON.stringify({
      ...t,
      appId: this.appId,
      time: Vu()
    });
    console.error(e), this.reportUrl && navigator.sendBeacon(this.reportUrl, e);
  }
}
export {
  yl as ArrowShape,
  js as BallShape,
  Cc as BezierEasing,
  Le as BufferAttribute,
  Tn as COLOR_NAMES,
  fy as CSSToJSEasing,
  ma as Clock,
  Ft as Color,
  ml as ColorManagement,
  fw as CommonKeyCode,
  Al as ConfettiShapeCombo,
  nb as Context,
  Sl as CrossShape,
  pl as CurveShape,
  h0 as CustomCanvasContext,
  zi as CustomCanvasGradient,
  va as CustomCanvasPattern,
  cl as DOMParse,
  rs as DOMSVGUtil,
  Vh as DOMToBlob,
  Gh as DOMToString,
  jn as DOMVideo,
  Tw as DrawContext,
  O as Easing,
  Cl as EllipseShape,
  sy as FileUpload,
  g1 as Float32BufferAttribute,
  vl as FoxShape,
  xl as HeartShape,
  wl as HeartVariantShape,
  f1 as Int16BufferAttribute,
  m1 as Int32BufferAttribute,
  c1 as Int8BufferAttribute,
  Ae as Interpolation,
  dw as Key,
  ls as LineShape,
  fl as LinearSRGBColorSpace,
  cs as LinearToSRGB,
  dl as LinearTransfer,
  Be as Ls,
  Kw as MVVM,
  _t as Matrix,
  zc as Matrix2,
  en as Matrix3,
  Ot as Matrix4,
  Pg as NoColorSpace,
  sb as Pagination,
  Sr as PointsShape,
  Ue as QRCode,
  _l as RabbitShape,
  Ze as RectShape,
  Ml as RingIndicatorShapeCombo,
  Wn as RingShape,
  os as SRGBColorSpace,
  hs as SRGBToLinear,
  _r as SRGBTransfer,
  p2 as SVGParse,
  bn as SVGParsedPathArgsLength,
  Pl as SegmentShapeCombo,
  Q as Shape,
  Nt as ShapeCombo,
  El as ShipShapeCombo,
  Tl as SliderShapeCombo,
  bl as StarShape,
  my as TWEEN,
  Rs as TextShape,
  li as Timeline,
  gl as TreeShapeCombo,
  Tc as Tween,
  d1 as Uint16BufferAttribute,
  p1 as Uint32BufferAttribute,
  l1 as Uint8BufferAttribute,
  u1 as Uint8ClampedBufferAttribute,
  ui as Vector2,
  jt as Vector3,
  Rc as Vector4,
  _n as WebGLCoordinateSystem,
  y2 as WebGLRenderer,
  Ca as WebGPUCoordinateSystem,
  ib as WebMonitor,
  g2 as WebRTCClient,
  pe as WebSocketClient,
  _a as YZCanvasContext,
  Pe as __color,
  ex as addClass,
  Hy as addWatermark,
  Yl as addWxJsReadyFnBeforeConfig,
  R0 as ajax,
  H2 as aliJsChooseImage,
  q2 as aliJsGetLocation,
  j2 as aliJsOpenLocation,
  W2 as aliJsPreviewImage,
  G2 as aliJsReady,
  $2 as aliJsScan,
  V2 as aliJsTradePay,
  qt as angle,
  w1 as animate,
  Ew as animateShapes,
  Hx as animationEnd$,
  jx as animationStart$,
  B0 as atomReadAttribute,
  Wc as atomReadAttributes,
  lx as atomReadStyle,
  jc as atomReadStyles,
  fx as atomRemoveAttribute,
  Yw as atomRemoveDataset,
  Hc as atomRemoveStyle,
  ds as atomWriteAttribute,
  di as atomWriteStyle,
  e0 as base64EncodeOutputStream,
  _0 as bitmapMapper,
  by as blobToImageData,
  Lc as byteArrayOutputStream,
  hr as cAF,
  Hw as cancelFetch,
  qy as changeBrightness,
  Z1 as changeCheckboxChecked,
  jy as changeDiaphaneity,
  W1 as changeRadioChecked,
  H1 as changeSelected,
  $y as changeSize,
  w2 as checkWxJsApi,
  $w as clearCookies,
  Bw as clearLocalStorage,
  Lw as clearSessionStorage,
  Hg as closeLog,
  G1 as closest,
  gy as computeImageDisplayRect,
  B1 as containsChild,
  La as createDefaultMousePoint,
  D0 as createElement,
  ix as createElementNS,
  so as createEvent,
  k0 as createFragment,
  oy as createFromEventPattern,
  qw as createIndexDB,
  S0 as createObjectURL,
  uy as createRunCycleInMaxRate,
  rx as createTextNode,
  Xg as createWebSocket,
  L0 as createXMLHttpRequest,
  X0 as cssAttrsToCanvasAttrs,
  Q2 as decrypt,
  hy as dispatchClickFromEvent,
  yc as dispatchEvent,
  ay as dispatchEventFromEvent,
  Ge as distance,
  Aa as domPrefixes,
  H0 as drag$,
  Z0 as dragEnd$,
  K0 as dragEnter$,
  Q0 as dragLeave$,
  tg as dragOver$,
  W0 as dragStart$,
  x1 as drawBitmapInCanvas,
  Ky as drawQRCodeToCanvas,
  J0 as drop$,
  Ec as easeNameToCubicBezier,
  M0 as empty,
  K2 as encrypt,
  _y as flipSideToSide,
  Sy as flipUpsideDown,
  Sw as followMouseShape,
  y1 as getBitmapFromCanvas,
  uo as getBrowserClient,
  e2 as getBrowserClientVersion,
  s2 as getBrowserLanguage,
  Uw as getCSSVar,
  Nc as getDOMMatrix,
  t1 as getDirection,
  sn as getDocumentElement,
  Ra as getElementPositionInPage,
  ow as getElementPositionInPage2,
  el as getElementPositionInViewport,
  O1 as getEmSize,
  ny as getEventCurrentTarget,
  Rl as getFetchId,
  ty as getFileExtension,
  fm as getFileMD5Hash,
  Qg as getFileTypeFromFile,
  hx as getFormSubmitData,
  t0 as getImageData,
  Zy as getImageDataByAIData,
  vy as getImageMainColor,
  K1 as getInnerText,
  Gg as getInternetExplorerVersion,
  mw as getKeyCode,
  ey as getMIME,
  uw as getMouseButton,
  mt as getMousePositionInElement,
  Oa as getMousePositionInPage,
  cw as getMousePositionInViewport,
  lo as getOperatingSystem,
  t2 as getOperatingSystemVersion,
  iw as getPage,
  rw as getRelativeBoundingClientRect,
  Bc as getRemSize,
  ux as getRules,
  lw as getScrollWheelDelta,
  P1 as getSelectedText,
  Yn as getStyle,
  Y0 as getStyleSheets,
  Fw as getTheme$,
  n2 as getTimeZone,
  aw as getVerticalScrollTopPercentInPage,
  Qw as getVertxRegisterBaseUrl,
  tl as getViewport,
  Mc as getVnode,
  nw as getWindow,
  s0 as gifImage,
  ns as h,
  ho as hFromEl,
  nx as hasClass,
  I0 as hideEl,
  T0 as html,
  ox as iframePostMessage,
  yy as imageDataToBitmap,
  wy as imageDataToBlob,
  xy as imageDataToDataURL,
  O0 as injectStyle,
  x2 as injectWxJsConfig,
  Ds as insert,
  L1 as isActiveEl,
  $g as isAliBrowser,
  d2 as isAliMiniProgram,
  Ug as isAndroid,
  r2 as isAppleDevice,
  o2 as isBadAndroid,
  Zg as isBrowserSupportFileAPI,
  b1 as isElement,
  h2 as isIE,
  l2 as isIE10,
  u2 as isIE11,
  c2 as isIE9,
  zl as isIOS,
  hw as isInViewport,
  fi as isInput,
  Uc as isInputCheckbox,
  j1 as isInputNumber,
  Gc as isInputRadio,
  q1 as isInputText,
  Fg as isMacOS,
  a2 as isMobile,
  D1 as isRootEl,
  i2 as isSafari,
  Fc as isSelect,
  px as isSupportEvent,
  mx as isSupportPointer,
  dx as isSupportTouch,
  $1 as isTextArea,
  Vg as isWxBrowser,
  f2 as isWxMiniProgram,
  Fy as jpgToPng,
  eg as keyDown$,
  Wx as keyPress$,
  sg as keyUp$,
  Cy as leftRotate,
  $s as length,
  Z2 as mapTDTJSSDK,
  Xy as marginSharpen,
  Wy as mosaic,
  Bs as mount,
  vx as mouseClick$,
  Cx as mouseContextMenu$,
  _x as mouseDoubleClick$,
  F0 as mouseDown$,
  xx as mouseEnter$,
  bx as mouseLeave$,
  ro as mouseMove$,
  yx as mouseOut$,
  gx as mouseOver$,
  U0 as mouseUp$,
  Sx as mouseWheel$,
  z1 as nearestElement,
  F1 as nextElementSibling,
  Qy as normalizePoint,
  J2 as objectSignature,
  C0 as onBeforeUnload,
  Yc as onDocumentReady,
  jg as openLog,
  n0 as outputGifBase64,
  Jy as outputQRCodeBase64,
  Ex as pan$,
  Ax as panCancel$,
  Lx as panDown$,
  Mx as panEnd$,
  Ix as panLeft$,
  Px as panMove$,
  kx as panRight$,
  Tx as panStart$,
  Dx as panUp$,
  N1 as parent,
  Xc as parents,
  ll as parseCSS,
  v0 as parseTransformToMatrix,
  co as patch,
  Rx as pinch$,
  Ox as pinchIn$,
  zx as pinchOut$,
  Uy as pngToJpg,
  Qc as pointerCancel$,
  Jc as pointerDown$,
  Zc as pointerMove$,
  Kc as pointerUp$,
  He as polar,
  Pw as polymorphTween,
  Nx as press$,
  Fe as preventDefault,
  U1 as previousElementSibling,
  Jg as querySelectorAllToStringArray,
  Vs as rAF,
  Vy as radiusClip,
  ai as readFileInBrowser,
  cx as readStyleFromStyles,
  Gy as rectClip,
  R1 as rem2px,
  Q1 as remove,
  ry as removeAllEventListeners,
  sx as removeClass,
  xc as requestAnimationFrameCycle,
  dy as reverseCSSToJSEasing,
  jp as reverseEaseNameToCubicBezier,
  Yp as reverseEasing,
  v1 as revokeObjectURL,
  Ey as rightRotate,
  Yx as rotate$,
  oe as rotatePoint,
  ax as runInSandbox,
  Rp as scheduleIdle,
  Np as scheduleIdleAsap,
  Ic as scheduleVnodeAsap,
  py as scheduleVnodeImmediately,
  Y1 as scrollParent,
  I1 as scrollTo,
  $h as selectFileInBrowser,
  Gw as setCSSVar,
  ly as setIntervalAccurate,
  Wg as setLogUploadFn,
  k1 as setManualScroll,
  m2 as setRem,
  qs as setStyle,
  Og as setTheme,
  fa as setTimeoutAccurate,
  T1 as setWindowTitle,
  V1 as shadowRoot,
  By as sharpen,
  A0 as showEl,
  X1 as siblings,
  tb as signEncrypt,
  qg as signature,
  cy as simulateEventFromTouch,
  gc as stopPropagation,
  sw as storage$,
  Kg as stringToDOM,
  Bx as swipe$,
  Gx as swipeDown$,
  Xx as swipeLeft$,
  Fx as swipeRight$,
  Ux as swipeUp$,
  j0 as tap$,
  Vx as tapOutSide$,
  Cw as targetToAfterDropShape,
  J1 as text,
  My as toBlackAndWhite,
  Dy as toBlue,
  Oy as toBlueAndGreen,
  Yy as toBlueAndGrey,
  wt as toDegree,
  ky as toGreen,
  Ny as toGreenAndGrey,
  Py as toGrey,
  Ty as toGrey2,
  Ay as toOpposite,
  q as toRadian,
  Iy as toRed,
  Ry as toRedAndBlue,
  Ly as toRedAndGreen,
  zy as toRedAndGrey,
  Vc as toggleClass,
  tx as toggleElDisplay,
  Xw as toggleTheme,
  q0 as touchCancel$,
  $0 as touchEnd$,
  G0 as touchMove$,
  V0 as touchStart$,
  Ia as transform,
  h1 as transformPath2D,
  qx as transitionEnd$,
  $x as transitionStart$,
  fr as updateVnode,
  Me as useAttribute,
  pr as useClickA,
  A1 as useClipboard,
  Jx as useCompatableDownMovePoint$,
  Vw as useCookie,
  Dw as useCoords$,
  Nw as useDataset,
  ew as useDocumentVisible$,
  Qx as useDraggable,
  tw as useDrop,
  xw as useElementEventBus,
  X as useEvent$,
  Z as useEventListener,
  zw as useFeRoute,
  ao as useFetch,
  Zw as useFetchCache,
  Ww as useFetchRetry,
  Jw as useFetchRetryCache,
  Ow as useHashChange$,
  ag as useHotKeyDown$,
  gw as useHotKeyFile,
  hg as useHotKeyFile$,
  pw as useHotKeyUp$,
  Mg as useIntersection$,
  E0 as useLoadImage,
  S1 as useLoadLink,
  _1 as useLoadScript,
  Lg as useLocalStorage,
  Ol as useLocale,
  kg as useLocation$,
  Ig as useMatchMedia$,
  rg as useMouseAndPointerDownMovePoint$,
  ng as useMouseDownMovePoint$,
  Zx as useMouseMovePoint$,
  ys as useMousePoint,
  Tg as useMutation$,
  iy as useParentEventListener,
  gr as usePointerDownMovePoint$,
  Dg as usePopStateChange$,
  ug as usePressDownMove,
  ww as usePressDownMoveWithMouse,
  fg as usePressDownMoveWithPointer,
  bw as usePressDownMoveWithTouch,
  Kx as usePull$,
  cg as useResize,
  nl as useResize$,
  kw as useSafeArea$,
  og as useScroll$,
  P0 as useSelectFile,
  E1 as useSelectFileImage,
  ja as useSessionStorage,
  ig as useTouchDownMovePoint$,
  Rw as useUrlChange$,
  Iw as useVisible$,
  Aw as useVisibleSimple$,
  yw as useWindowResize$,
  eb as verifyDecrypt,
  M1 as vibrate,
  Mw as waitElementAddedInDOM,
  C1 as waitForStyleSheetsLoaded,
  jw as writeToIndexDB,
  _2 as wxJsChooseImage,
  E2 as wxJsDownloadImage,
  O2 as wxJsDownloadVoice,
  P2 as wxJsGetLocalImgData,
  B2 as wxJsGetLocation,
  N2 as wxJsGetNetworkType,
  U2 as wxJsLogin,
  L2 as wxJsOnVoicePlayEnd,
  A2 as wxJsOnVoiceRecordEnd,
  Y2 as wxJsOpenLocation,
  k2 as wxJsPauseVoice,
  F2 as wxJsPay,
  I2 as wxJsPlayVoice,
  S2 as wxJsPreviewImage,
  X2 as wxJsScanQRCode,
  T2 as wxJsStartRecord,
  M2 as wxJsStopRecord,
  D2 as wxJsStopVoice,
  z2 as wxJsTranslateVoice,
  b2 as wxJsUpdateAppMessageShareData,
  v2 as wxJsUpdateTimelineShareData,
  C2 as wxJsUploadImage,
  R2 as wxJsUploadVoice
};
//# sourceMappingURL=zyzgroup_core_web.js.map
